(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.cvchart.level2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-hospital-cvchart-level2', {
                url    : '/qc-report-hospital-cvchart-level2',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/hospital/cvchart/level2/level2.html',
                        controller : 'HospitalCVChartLevel2Controller as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin'],
                    module: 'qc-report-hospital'
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/hospital/cvchart/level2');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.hospital.cvchart', ['/reports/hospital/cvchart']);

        msNavigationServiceProvider.saveItem('qc-report-hospital.cvchart-level2', {
            title : 'Precision for Level 2 (CV Graph)',
            state: 'app.qc-report-hospital-cvchart-level2',
            weight: 25,
            translate: "QC_REPORT_HOSPITAL_CVCHART_LEVEL2.NAV"
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.cvchart.level2')
        .component('hospitalCvChartLevel2HospitalAdmin', {
            templateUrl: 'app/main/qc-report/hospital/cvchart/level2/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, $mdSelect, localStorageService, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 2';
        vm.startDate = moment().subtract(2, 'months').startOf('month').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.meterColumns = [];
        vm.meters = [];
        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.metersLoaded = false;
        vm.message = null;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'MMM-YYYY',
                                        second: 'MMM-YYYY',
                                        minute: 'MMM-YYYY',
                                        hour: 'MMM-YYYY',
                                        day: 'MMM-YYYY',
                                        week: 'MMM-YYYY',
                                        month: 'MMM-YYYY',
                                        quarter: 'MMM-YYYY',
                                        year: 'MMM-YYYY'
                                    },
                                    tooltipFormat: 'MMM-YYYY',
                                    unit: 'month'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    }
                }
            };

            getMeters()
                .then(getLJChart);
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart();
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.user.hospitals[0].id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    level: vm.level,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                return msApi.request('reports.hospital.cvchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        vm.data = response.data;

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function points(data) {
            var meters = _.uniq(_.flatten( _.map(data, function(date) {
                return _.keys(date);
            })));

            var series = [];

            for(var i = 0; i < meters.length; i++) {
                var meter = meters[i];
                var points = [];
                _.map(_.keys(data), function(date) {
                    if (_.has(data[date], meter)) {
                        var cv = data[date][meter];
                        points.push({x: date, y: cv !== null ? cv.toFixed(2) : null});
                    }
                });

                series.push({meter: meter, points: points});
            }

            series = _.sortBy(series, ['meter']);

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter
                });

                datas.push(series[i].points);
            }

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            var dates = _.keys(data);
            var minDate = _.min(dates);
            var maxDate = _.max(dates);

            var min = (vm.zoomToFit && minDate != null) ? moment(minDate).startOf('month') : moment(vm.startDate).startOf('month');
            var max = (vm.zoomToFit && maxDate != null ) ? moment(maxDate).startOf('month') : moment(vm.endDate).startOf('month');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(date) {
                return _.values(date);
            }));

            var minData = _.min(flatten);
            var maxData = _.max(flatten);

            var min = (vm.zoomToFit && minData != null) ? ((minData - 2 > 0) ? minData - 2 : 0.0)  : 0.0;
            var max = (vm.zoomToFit && maxData != null) ? maxData + 2 : 15.0;
            var stepSize = (min + max) / 2;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return parseFloat(value).toFixed(2);
            };
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                }
            };
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('CVGraph–Level2-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function translate() {
            return $translate([
                'QC_REPORT_HOSPITAL.TITLE',
                'QC_REPORT_HOSPITAL.START_DATE',
                'QC_REPORT_HOSPITAL.END_DATE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.TITLE',
                'QC_REPORT_HOSPITAL.METERS',
                'QC_REPORT_HOSPITAL.ALL_METERS',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.TITLE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.X_AXIS',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.Y_AXIS',

                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_HOSPITAL.TITLE'],
                    title: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL2.TITLE'],
                    startDate: translations['QC_REPORT_HOSPITAL.START_DATE'],
                    endDate: translations['QC_REPORT_HOSPITAL.END_DATE'],
                    meters: translations['QC_REPORT_HOSPITAL.METERS']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    allMeters: translations['QC_REPORT_HOSPITAL.ALL_METERS']
                };

                vm.chart = {
                    title: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.Y_AXIS']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'],
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.cvchart.level2')
        .component('hospitalCvChartLevel2GlobalAdmin', {
            templateUrl: 'app/main/qc-report/hospital/cvchart/level2/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, $mdSelect, localStorageService, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.level = 'Level 2';
        vm.startDate = moment().subtract(2, 'months').startOf('month').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.metersLoaded = false;
        vm.message = null;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);

        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'MMM-YYYY',
                                        second: 'MMM-YYYY',
                                        minute: 'MMM-YYYY',
                                        hour: 'MMM-YYYY',
                                        day: 'MMM-YYYY',
                                        week: 'MMM-YYYY',
                                        month: 'MMM-YYYY',
                                        quarter: 'MMM-YYYY',
                                        year: 'MMM-YYYY'
                                    },
                                    tooltipFormat: 'MMM-YYYY',
                                    unit: 'month'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    }
                }
            };

            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getLJChart);
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart();
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    level: vm.level,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                return msApi.request('reports.hospital.cvchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        vm.data = response.data;

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function points(data) {
            var meters = _.uniq(_.flatten( _.map(data, function(date) {
                return _.keys(date);
            })));

            var series = [];

            for(var i = 0; i < meters.length; i++) {
                var meter = meters[i];
                var points = [];
                _.map(_.keys(data), function(date) {
                    if (_.has(data[date], meter)) {
                        var cv = data[date][meter];
                        points.push({x: date, y: cv !== null ? cv.toFixed(2) : null});
                    }
                })

                series.push({meter: meter, points: points});
            }

            series = _.sortBy(series, ['meter']);

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter
                });

                datas.push(series[i].points);
            }

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            var dates = _.keys(data);
            var minDate = _.min(dates);
            var maxDate = _.max(dates);

            var min = (vm.zoomToFit && minDate != null) ? moment(minDate).startOf('month') : moment(vm.startDate).startOf('month');
            var max = (vm.zoomToFit && maxDate != null ) ? moment(maxDate).startOf('month') : moment(vm.endDate).startOf('month');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(date) {
                return _.values(date);
            }));

            var minData = _.min(flatten);
            var maxData = _.max(flatten);

            var min = (vm.zoomToFit && minData != null) ? ((minData - 2 > 0) ? minData - 2 : 0.0)  : 0.0;
            var max = (vm.zoomToFit && maxData != null) ? maxData + 2 : 15.0;
            var stepSize = (min + max) / 2;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return parseFloat(value).toFixed(2);
            };
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                }
            };
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.country,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedCountry.name
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.state,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedState.name
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 640
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('CVGraph–Level2-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function translate() {
            return $translate([
                'QC_REPORT_HOSPITAL.TITLE',
                'QC_REPORT_HOSPITAL.START_DATE',
                'QC_REPORT_HOSPITAL.END_DATE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.TITLE',
                'QC_REPORT_HOSPITAL.COUNTRY',
                'QC_REPORT_HOSPITAL.STATE',
                'QC_REPORT_HOSPITAL.HOSPITAL',
                'QC_REPORT_HOSPITAL.METERS',
                'QC_REPORT_HOSPITAL.ALL_METERS',

                'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.TITLE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.X_AXIS',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.Y_AXIS',

                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_METER',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_STATE_IN',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_HOSPITAL.TITLE'],
                    title: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL2.TITLE'],
                    startDate: translations['QC_REPORT_HOSPITAL.START_DATE'],
                    endDate: translations['QC_REPORT_HOSPITAL.END_DATE'],
                    country: translations['QC_REPORT_HOSPITAL.COUNTRY'],
                    state: translations['QC_REPORT_HOSPITAL.STATE'],
                    hospital: translations['QC_REPORT_HOSPITAL.HOSPITAL'],
                    meters: translations['QC_REPORT_HOSPITAL.METERS']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    allMeters: translations['QC_REPORT_HOSPITAL.ALL_METERS']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN']
                };

                vm.chart = {
                    title: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.Y_AXIS']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.cvchart.level2')
        .component('hospitalCvChartLevel2CountryAdmin', {
            templateUrl: 'app/main/qc-report/hospital/cvchart/level2/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, $mdSelect, localStorageService, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.level = 'Level 2';
        vm.startDate = moment().subtract(2, 'months').startOf('month').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.metersLoaded = false;
        vm.message = null;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);

        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'MMM-YYYY',
                                        second: 'MMM-YYYY',
                                        minute: 'MMM-YYYY',
                                        hour: 'MMM-YYYY',
                                        day: 'MMM-YYYY',
                                        week: 'MMM-YYYY',
                                        month: 'MMM-YYYY',
                                        quarter: 'MMM-YYYY',
                                        year: 'MMM-YYYY'
                                    },
                                    tooltipFormat: 'MMM-YYYY',
                                    unit: 'month'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    }
                }
            };

            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getLJChart);
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart();
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    level: vm.level,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                return msApi.request('reports.hospital.cvchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        vm.data = response.data;

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function points(data) {
            var meters = _.uniq(_.flatten( _.map(data, function(date) {
                return _.keys(date);
            })));

            var series = [];

            for(var i = 0; i < meters.length; i++) {
                var meter = meters[i];
                var points = [];
                _.map(_.keys(data), function(date) {
                    if (_.has(data[date], meter)) {
                        var cv = data[date][meter];
                        points.push({x: date, y: cv !== null ? cv.toFixed(2) : null});
                    }
                })

                series.push({meter: meter, points: points});
            }

            series = _.sortBy(series, ['meter']);

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter
                });

                datas.push(series[i].points);
            }

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            var dates = _.keys(data);
            var minDate = _.min(dates);
            var maxDate = _.max(dates);

            var min = (vm.zoomToFit && minDate != null) ? moment(minDate).startOf('month') : moment(vm.startDate).startOf('month');
            var max = (vm.zoomToFit && maxDate != null ) ? moment(maxDate).startOf('month') : moment(vm.endDate).startOf('month');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(date) {
                return _.values(date);
            }));

            var minData = _.min(flatten);
            var maxData = _.max(flatten);

            var min = (vm.zoomToFit && minData != null) ? ((minData - 2 > 0) ? minData - 2 : 0.0)  : 0.0;
            var max = (vm.zoomToFit && maxData != null) ? maxData + 2 : 15.0;
            var stepSize = (min + max) / 2;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return parseFloat(value).toFixed(2);
            };
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                }
            };
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.state,
                                    style: 'small'
                                },
                                {
                                    text:  vm.selectedState.name,
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name,
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 640
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('CVGraph–Level2-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function translate() {
            return $translate([
                'QC_REPORT_HOSPITAL.TITLE',
                'QC_REPORT_HOSPITAL.START_DATE',
                'QC_REPORT_HOSPITAL.END_DATE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.TITLE',
                'QC_REPORT_HOSPITAL.STATE',
                'QC_REPORT_HOSPITAL.HOSPITAL',
                'QC_REPORT_HOSPITAL.METERS',
                'QC_REPORT_HOSPITAL.ALL_METERS',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.TITLE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.X_AXIS',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.Y_AXIS'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_HOSPITAL.TITLE'],
                    title: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL2.TITLE'],
                    startDate: translations['QC_REPORT_HOSPITAL.START_DATE'],
                    endDate: translations['QC_REPORT_HOSPITAL.END_DATE'],
                    state: translations['QC_REPORT_HOSPITAL.STATE'],
                    hospital: translations['QC_REPORT_HOSPITAL.HOSPITAL'],
                    meters: translations['QC_REPORT_HOSPITAL.METERS']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    allMeters: translations['QC_REPORT_HOSPITAL.ALL_METERS']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE'],
                    selectState: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL'],
                    noRegisteredHospitalIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN']
                };

                vm.chart = {
                    title: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL2.CHART.Y_AXIS']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.cvchart.level1', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-hospital-cvchart-level1', {
                url    : '/qc-report-hospital-cvchart-level1',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/hospital/cvchart/level1/level1.html',
                        controller : 'HospitalCVChartLevel1Controller as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin'],
                    module: 'qc-report-hospital'
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/hospital/cvchart/level1');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.hospital.cvchart', ['/reports/hospital/cvchart']);

        msNavigationServiceProvider.saveItem('qc-report-hospital.cvchart-level1', {
            title : 'Precision for Level 1 (CV Graph)',
            state: 'app.qc-report-hospital-cvchart-level1',
            weight: 24,
            translate: 'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.NAV'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.cvchart.level1')
        .component('hospitalCvChartLevel1HospitalAdmin', {
            templateUrl: 'app/main/qc-report/hospital/cvchart/level1/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, $mdSelect, localStorageService, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 1';
        vm.startDate = moment().subtract(2, 'months').startOf('month').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.meterColumns = [];
        vm.meters = [];
        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.metersLoaded = false;
        vm.message = null;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'MMM-YYYY',
                                        second: 'MMM-YYYY',
                                        minute: 'MMM-YYYY',
                                        hour: 'MMM-YYYY',
                                        day: 'MMM-YYYY',
                                        week: 'MMM-YYYY',
                                        month: 'MMM-YYYY',
                                        quarter: 'MMM-YYYY',
                                        year: 'MMM-YYYY'
                                    },
                                    tooltipFormat: 'MMM-YYYY',
                                    unit: 'month'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    }
                }
            };

            getMeters()
                .then(getLJChart);
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart();
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.user.hospitals[0].id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    level: vm.level,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                return msApi.request('reports.hospital.cvchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        vm.data = response.data;

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function points(data) {
            var meters = _.uniq(_.flatten( _.map(data, function(date) {
                return _.keys(date);
            })));

            var series = [];

            for(var i = 0; i < meters.length; i++) {
                var meter = meters[i];
                var points = [];
                _.map(_.keys(data), function(date) {
                    if (_.has(data[date], meter)) {
                        var cv = data[date][meter];
                        points.push({x: date, y: cv !== null ? cv.toFixed(2) : null});
                    }
                })

                series.push({meter: meter, points: points});
            }

            series = _.sortBy(series, ['meter']);

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            var dates = _.keys(data);
            var minDate = _.min(dates);
            var maxDate = _.max(dates);

            var min = (vm.zoomToFit && minDate != null) ? moment(minDate).startOf('month') : moment(vm.startDate).startOf('month');
            var max = (vm.zoomToFit && maxDate != null ) ? moment(maxDate).startOf('month') : moment(vm.endDate).startOf('month');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(date) {
                return _.values(date);
            }));

            var minData = _.min(flatten);
            var maxData = _.max(flatten);

            var min = (vm.zoomToFit && minData != null) ? ((minData - 2 > 0) ? minData - 2 : 0.0)  : 0.0;
            var max = (vm.zoomToFit && maxData != null) ? maxData + 2 : 15.0;
            var stepSize = (min + max) / 2;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return parseFloat(value).toFixed(2);
            };
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                }
            };
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 680,
                        margin: [0, 0, 0, 10]
                    },
                    {
                        text: vm.pdf.ps,
                        style: 'remark'
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    },
                    remark: {
                        bold: true,
                        italics: true,
                        fontSize: 10
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('CVGraph–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function translate() {
            return $translate([
                'QC_REPORT_HOSPITAL.TITLE',
                'QC_REPORT_HOSPITAL.START_DATE',
                'QC_REPORT_HOSPITAL.END_DATE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.TITLE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.PS',
                'QC_REPORT_HOSPITAL.METERS',
                'QC_REPORT_HOSPITAL.ALL_METERS',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.TITLE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.X_AXIS',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.Y_AXIS',

                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_HOSPITAL.TITLE'],
                    title: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.TITLE'],
                    startDate: translations['QC_REPORT_HOSPITAL.START_DATE'],
                    endDate: translations['QC_REPORT_HOSPITAL.END_DATE'],
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    ps: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.PS']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    allMeters: translations['QC_REPORT_HOSPITAL.ALL_METERS']
                };

                vm.chart = {
                    title: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.Y_AXIS']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'],
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.cvchart.level1')
        .component('hospitalCvChartLevel1GlobalAdmin', {
            templateUrl: 'app/main/qc-report/hospital/cvchart/level1/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, $mdSelect, localStorageService, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.level = 'Level 1';
        vm.startDate = moment().subtract(2, 'months').startOf('month').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.metersLoaded = false;
        vm.message = null;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'MMM-YYYY',
                                        second: 'MMM-YYYY',
                                        minute: 'MMM-YYYY',
                                        hour: 'MMM-YYYY',
                                        day: 'MMM-YYYY',
                                        week: 'MMM-YYYY',
                                        month: 'MMM-YYYY',
                                        quarter: 'MMM-YYYY',
                                        year: 'MMM-YYYY'
                                    },
                                    tooltipFormat: 'MMM-YYYY',
                                    unit: 'month'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    }
                }
            };

            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getLJChart);
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart();
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    level: vm.level,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                return msApi.request('reports.hospital.cvchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        vm.data = response.data;

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function points(data) {
            var meters = _.uniq(_.flatten( _.map(data, function(date) {
                return _.keys(date);
            })));

            var series = [];

            for(var i = 0; i < meters.length; i++) {
                var meter = meters[i];
                var points = [];
                _.map(_.keys(data), function(date) {
                    if (_.has(data[date], meter)) {
                        var cv = data[date][meter];
                        points.push({x: date, y: cv !== null ? cv.toFixed(2) : null});
                    }
                })

                series.push({meter: meter, points: points});
            }

            series = _.sortBy(series, ['meter']);

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            var dates = _.keys(data);
            var minDate = _.min(dates);
            var maxDate = _.max(dates);

            var min = (vm.zoomToFit && minDate != null) ? moment(minDate).startOf('month') : moment(vm.startDate).startOf('month');
            var max = (vm.zoomToFit && maxDate != null ) ? moment(maxDate).startOf('month') : moment(vm.endDate).startOf('month');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(date) {
                return _.values(date);
            }));

            var minData = _.min(flatten);
            var maxData = _.max(flatten);

            var min = (vm.zoomToFit && minData != null) ? ((minData - 2 > 0) ? minData - 2 : 0.0)  : 0.0;
            var max = (vm.zoomToFit && maxData != null) ? maxData + 2 : 15.0;
            var stepSize = (min + max) / 2;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return parseFloat(value).toFixed(2);
            };
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                }
            };
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.country,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedCountry.name
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.state,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedState.name
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 640,
                        margin: [0, 0, 0, 10]
                    },
                    {
                        text: vm.pdf.ps,
                        style: 'remark'
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    },
                    remark: {
                        bold: true,
                        italics: true,
                        fontSize: 10
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('CVGraph–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function translate() {
            return $translate([
                'QC_REPORT_HOSPITAL.TITLE',
                'QC_REPORT_HOSPITAL.START_DATE',
                'QC_REPORT_HOSPITAL.END_DATE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.TITLE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.PS',
                'QC_REPORT_HOSPITAL.COUNTRY',
                'QC_REPORT_HOSPITAL.STATE',
                'QC_REPORT_HOSPITAL.HOSPITAL',
                'QC_REPORT_HOSPITAL.METERS',
                'QC_REPORT_HOSPITAL.ALL_METERS',

                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.TITLE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.X_AXIS',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.Y_AXIS',

                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_METER',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_STATE_IN',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_HOSPITAL.TITLE'],
                    title: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.TITLE'],
                    startDate: translations['QC_REPORT_HOSPITAL.START_DATE'],
                    endDate: translations['QC_REPORT_HOSPITAL.END_DATE'],
                    country: translations['QC_REPORT_HOSPITAL.COUNTRY'],
                    state: translations['QC_REPORT_HOSPITAL.STATE'],
                    hospital: translations['QC_REPORT_HOSPITAL.HOSPITAL'],
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    ps: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.PS']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    allMeters: translations['QC_REPORT_HOSPITAL.ALL_METERS']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN']
                };

                vm.chart = {
                    title: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.Y_AXIS']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.cvchart.level1')
        .component('hospitalCvChartLevel1CountryAdmin', {
            templateUrl: 'app/main/qc-report/hospital/cvchart/level1/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, $mdSelect, localStorageService, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.level = 'Level 1';
        vm.startDate = moment().subtract(2, 'months').startOf('month').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.metersLoaded = false;
        vm.message = null;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'MMM-YYYY',
                                        second: 'MMM-YYYY',
                                        minute: 'MMM-YYYY',
                                        hour: 'MMM-YYYY',
                                        day: 'MMM-YYYY',
                                        week: 'MMM-YYYY',
                                        month: 'MMM-YYYY',
                                        quarter: 'MMM-YYYY',
                                        year: 'MMM-YYYY'
                                    },
                                    tooltipFormat: 'MMM-YYYY',
                                    unit: 'month'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    }
                }
            };

            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getLJChart);
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart();
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    level: vm.level,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                return msApi.request('reports.hospital.cvchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        vm.data = response.data;

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function points(data) {
            var meters = _.uniq(_.flatten( _.map(data, function(date) {
                return _.keys(date);
            })));

            var series = [];

            for(var i = 0; i < meters.length; i++) {
                var meter = meters[i];
                var points = [];
                _.map(_.keys(data), function(date) {
                    if (_.has(data[date], meter)) {
                        var cv = data[date][meter];
                        points.push({x: date, y: cv !== null ? cv.toFixed(2) : null});
                    }
                })

                series.push({meter: meter, points: points});
            }

            series = _.sortBy(series, ['meter']);

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            var dates = _.keys(data);
            var minDate = _.min(dates);
            var maxDate = _.max(dates);

            var min = (vm.zoomToFit && minDate != null) ? moment(minDate).startOf('month') : moment(vm.startDate).startOf('month');
            var max = (vm.zoomToFit && maxDate != null ) ? moment(maxDate).startOf('month') : moment(vm.endDate).startOf('month');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(date) {
                return _.values(date);
            }));

            var minData = _.min(flatten);
            var maxData = _.max(flatten);

            var min = (vm.zoomToFit && minData != null) ? ((minData - 2 > 0) ? minData - 2 : 0.0)  : 0.0;
            var max = (vm.zoomToFit && maxData != null) ? maxData + 2 : 15.0;
            var stepSize = (min + max) / 2;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return parseFloat(value).toFixed(2);
            };
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                }
            };
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.state,
                                    style: 'small'
                                },
                                {
                                    text:  vm.selectedState.name,
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name,
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 640,
                        margin: [0, 0, 0, 10]
                    },
                    {
                        text: vm.pdf.ps,
                        style: 'remark'
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    },
                    remark: {
                        bold: true,
                        italics: true,
                        fontSize: 10
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('CVGraph–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function translate() {
            return $translate([
                'QC_REPORT_HOSPITAL.TITLE',
                'QC_REPORT_HOSPITAL.START_DATE',
                'QC_REPORT_HOSPITAL.END_DATE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.TITLE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.PS',
                'QC_REPORT_HOSPITAL.STATE',
                'QC_REPORT_HOSPITAL.HOSPITAL',
                'QC_REPORT_HOSPITAL.METERS',
                'QC_REPORT_HOSPITAL.ALL_METERS',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.TITLE',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.X_AXIS',
                'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.Y_AXIS'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_HOSPITAL.TITLE'],
                    title: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.TITLE'],
                    startDate: translations['QC_REPORT_HOSPITAL.START_DATE'],
                    endDate: translations['QC_REPORT_HOSPITAL.END_DATE'],
                    state: translations['QC_REPORT_HOSPITAL.STATE'],
                    hospital: translations['QC_REPORT_HOSPITAL.HOSPITAL'],
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    ps: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.PS']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    allMeters: translations['QC_REPORT_HOSPITAL.ALL_METERS']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE'],
                    selectState: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL'],
                    noRegisteredHospitalIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN']
                };

                vm.chart = {
                    title: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_HOSPITAL_CVCHART_LEVEL1.CHART.Y_AXIS']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.multiple.logbook', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-multiple-logbook', {
                url    : '/qc-report-multiple-logbook',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/multiple/logbook/logbook.html',
                        controller : 'MultipleLogbookController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin', 'hospital_operator']
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/multiple/logbook');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('users', ['/users']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.multiple.qclogbook', ['/reports/multiple/qclogbook']);
        msApiProvider.register('quality_control_tests.tag_operator', ['/quality_control_tests/tag_operator']);
        msApiProvider.register('quality_control_tests.untag_operator', ['/quality_control_tests/untag_operator']);
        msApiProvider.register('quality_control_tests.edit', ['/quality_control_tests/:id', {id: '@id'}, {
            update: { method:'PUT'}
        }]);
        msApiProvider.register('quality_control_tests.remove', ['/quality_control_tests/:id', {id: '@id'}, {
            delete: { method:'DELETE'}
        }]);

        msNavigationServiceProvider.saveItem('qc-report-multiple.logbook', {
            title : 'QC Logbook',
            state: 'app.qc-report-multiple-logbook',
            weight: 21,
            translate: 'QC_REPORT_MULTIPLE_LOGBOOK.NAV'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.multiple.logbook')
        .component('multipleLogbookHospitalAdmin', {
            templateUrl: 'app/main/qc-report/multiple/logbook/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, $mdDialog, $document, localStorageService, $mdSelect, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.pagination = {
            total:0,
            per_page: 10,
            current_page: 1
        };
        vm.sort = "tested_on";

        vm.meterColumns = [];
        vm.meters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.overall = null;
        vm.qclogbook = [];

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions1 = [];
        vm.controlLot1 = [];

        vm.controlSolutions2 = [];
        vm.controlLot2 = [];

        vm.isReadOnly = false;
        vm.hasManualQcData = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.stripLotChanged = stripLotChanged;
        vm.controlLot1Changed = controlLot1Changed;
        vm.controlLot2Changed = controlLot2Changed;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.getStripLotText = getStripLotText;
        vm.getControlLot1Text = getControlLot1Text;
        vm.getControlLot2Text = getControlLot2Text;
        vm.getQCLogbook = getQCLogbook;
        vm.editQcData = editQcData;
        vm.changeOperator = changeOperator;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.scanQcLogForManualData = scanQcLogForManualData;
        vm.evalMeterReading = evalMeterReading;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.isReadOnly = vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            getMeters()
                .then(getQCLogbook.bind(null, true));
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getQCLogbook(true);
            }

            close();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getQCLogbook(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getQCLogbook(true);
            }
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function stripLotChanged() {
            if(vm.subFilterForm.$valid) {
                getQCLogbook(false);
            }

            close();
        }

        function controlLot1Changed() {
            if(vm.subFilterForm.$valid) {
                getQCLogbook(false);
            }

            close();
        }

        function controlLot2Changed() {
            if(vm.subFilterForm.$valid) {
                getQCLogbook(false);
            }

            close();
        }

        function getStripLotText() {
            var limit = 30;
            if (vm.stripLot && vm.stripLot.length) {
                if (vm.stripLot.length === vm.testStrips.length) {
                    return vm.filters.allStripLot;
                }

                var joined =  _.join(_.map(vm.stripLot, 'lot_no'), ', ');
                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');

            } else {
                return vm.filters.stripLot;
            }
        }

        function getControlLot1Text() {
            var limit = 30;
            if (vm.controlLot1 && vm.controlLot1.length) {
                if (vm.controlLot1.length === vm.controlSolutions1.length) {
                    return vm.filters.allControlLotLevel1;
                }

                var joined = _.join(_.map(vm.controlLot1, 'lot_no'), ',');
                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');

            } else {
                return vm.filters.controlLotLevel1;
            }
        }

        function getControlLot2Text() {
            var limit = 30;
            if (vm.controlLot2 && vm.controlLot2.length) {
                if (vm.controlLot2.length === vm.controlSolutions2.length) {
                    return vm.filters.allControlLotLevel2;
                }

                var joined = _.join(_.map(vm.controlLot2, 'lot_no'), ',');
                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');

            } else {
                return vm.filters.controlLotLevel2;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToCSV() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');
                var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
                var sort = _.trimStart(vm.sort, '-');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    sort: sort + ':' + order,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                var stripLotIds = _.map(vm.stripLot, 'id');
                params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);

                var controlLot = vm.controlLot1.concat(vm.controlLot2);

                var controlLotIds = _.map(controlLot, 'id');
                params = angular.merge({'control_lot_ids[]': controlLotIds}, params);

                msApi.request('reports.multiple.qclogbook@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var data = [];

                        data.push({
                            a: vm.columns.testDateTime,
                            b: vm.columns.meterSerial,
                            c: vm.columns.location,
                            d: vm.columns.stripLot,
                            e: vm.columns.controlType,
                            f: vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                            g: vm.columns.qcValue + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                            h: vm.columns.status,
                            i: vm.columns.operatorInitials
                        });

                        var qclogbook = response.qclogbook;

                        _.map(qclogbook, function (log) {
                            data.push({
                                a: moment(log.tested_on).format(),
                                b: log.meter.serial_no,
                                c: log.meter.location.code,
                                d: log.test_strip.lot_no,
                                e: log.control_level,
                                f: parseFloat(log.from).toFixed(1) + ' ' + vm.misc.to + ' ' + parseFloat(log.to).toFixed(1),
                                g: log.source == 'manual' ? vm.evalMeterReading(log) + ' **' : vm.evalMeterReading(log),
                                h: log.within_range ? vm.misc.withinRange : vm.misc.outsideRange,
                                i: log.hospital_operator ? log.hospital_operator.initials : ''
                            });
                        });

                        if (vm.hasManualQcData) {
                            data.push({a: '**' + vm.columns.ps, b: '', c: '', d: '', e: '', f: '', g: '', h: ''});
                        }

                        var timestamp = moment();
                        var filename = 'QCLogbook-' + timestamp.format('YMMDDHm');

                        alasql('SELECT * INTO CSV(?, {headers:false, separator:","}) FROM ?',[filename, data]);
                    });
            }
        }

        function exportToExcel() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');
                var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
                var sort = _.trimStart(vm.sort, '-');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    sort: sort + ':' + order,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                var stripLotIds = _.map(vm.stripLot, 'id');
                params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);

                var controlLot = vm.controlLot1.concat(vm.controlLot2);

                var controlLotIds = _.map(controlLot, 'id');
                params = angular.merge({'control_lot_ids[]': controlLotIds}, params);

                msApi.request('reports.multiple.qclogbook@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var data = [];

                        data.push({
                            a: vm.columns.testDateTime,
                            b: vm.columns.meterSerial,
                            c: vm.columns.location,
                            d: vm.columns.stripLot,
                            e: vm.columns.controlType,
                            f: vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                            g: vm.columns.qcValue + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                            h: vm.columns.status,
                            i: vm.columns.operatorInitials
                        });

                        var qclogbook = response.qclogbook;

                        _.map(qclogbook, function (log) {
                            data.push({
                                a: moment(log.tested_on).format(),
                                b: log.meter.serial_no,
                                c: log.meter.location.code,
                                d: log.test_strip.lot_no,
                                e: log.control_level,
                                f: parseFloat(log.from).toFixed(1) + ' ' + vm.misc.to + ' ' + parseFloat(log.to).toFixed(1),
                                g: log.source == 'manual' ? vm.evalMeterReading(log) + ' **' : vm.evalMeterReading(log),
                                h: log.within_range ? vm.misc.withinRange : vm.misc.outsideRange,
                                i: log.hospital_operator ? log.hospital_operator.initials : ''
                            });
                        });

                        if (vm.hasManualQcData) {
                            data.push({a: '**' + vm.columns.ps, b: '', c: '', d: '', e: '', f: '', g: '', h: ''});
                        }

                        var timestamp = moment();
                        var filename = 'QCLogbook-' + timestamp.format('YMMDDHm');

                        alasql('SELECT * INTO XLSX(?, {headers:false}) FROM ?',[filename, data]);
                    });
            }
        }

        function getMeters() {
            var params = {
                hospital_id: vm.user.hospitals[0].id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';
            vm.filtered = [];

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getQCLogbook(updateSubFilterForm) {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');
                var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
                var sort = _.trimStart(vm.sort, '-');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    sort: sort + ':' + order,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                if (!updateSubFilterForm) {
                    if (vm.stripLot.length) {
                        var stripLotIds = _.map(vm.stripLot, 'id');
                        params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                    }

                    var controlLot = vm.controlLot1.concat(vm.controlLot2);

                    if (controlLot.length) {
                        var controlLotIds = _.map(controlLot, 'id');
                        params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                    }
                }

                vm.promise = msApi.request('reports.multiple.qclogbook@get',
                    angular.extend(vm.pagination, params),
                    // SUCCESS
                    function (response) {
                        vm.pagination.total = response.qclogbook.total;
                        vm.qclogbook = response.qclogbook.data;
                        vm.scanQcLogForManualData(vm.qclogbook);

                        if (updateSubFilterForm) {
                            subFilterForm(response.test_strips, response.control_solutions1, response.control_solutions2);
                        }

                        vm.loaded = true;
                    });
            }
        }

        function editQcData(log, e) {
            var dialogData = {
                qcValue: Math.round(log.meter_reading * 10) / 10    // Round to one decimal place.
            };

            $mdDialog.show({
                controller: 'EditQcDataDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/edit-qc-data-dialog/edit-qc-data-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    dialogData: dialogData,
                    isReadOnly: log.source == 'upload'
                }
            }).then(function (dialogResponse) {
                if (dialogResponse.result == 'save') {
                    saveQcValue(log, dialogResponse.qcValue);
                }
                else if (dialogResponse.result == 'delete') {
                    deleteQcData(log, e);
                }
            });
        }

        function saveQcValue(log, qcValue) {
            return msApi.request('quality_control_tests.edit@update', {
                    id: log.id,
                    meter_reading: qcValue,
                    measurement_unit: vm.user.preferred_measurement_unit
                },
                // SUCCESS
                function (response) {
                    log.meter_reading = response.quality_control_test.meter_reading;
                    log.within_range = response.quality_control_test.within_range;
                    log.is_low = response.quality_control_test.is_low;
                    log.is_high = response.quality_control_test.is_high;
                });
        }

        function deleteQcData(log, e) {
            var dialogData = {
                reason: ''
            };

            $mdDialog.show({
                controller: 'EnterReasonDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/enter-reason-dialog/enter-reason-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    dialogData: dialogData
                }
            }).then(function (dialogResponse) {
                return msApi.request('quality_control_tests.remove@delete', {
                        id: log.id,
                        reason: dialogResponse.reason
                    },
                    // SUCCESS
                    function (response) {
                        log.is_deleted = true;
                    });
            });
        }

        function changeOperator(log, e) {
            var dialogData = {
                operator: log.hospital_operator
            };

            $mdDialog.show({
                controller: 'ChangeOperatorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/change-operator-dialog/change-operator-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        return msApi.request('users@get', {
                            role: 'hospital_operator',
                            hospital_id: vm.user.hospitals[0].id
                        });
                    }
                }
            }).then(function (dialogResponse) {
                if (dialogResponse.operator) {
                    tagOperator(log, dialogResponse.operator);
                } else {
                    unTagOperator(log);
                }
            });
        }

        function tagOperator(log, operator) {
            return msApi.request('quality_control_tests.tag_operator@save',{
                    quality_control_test_id: log.id,
                    hospital_operator_id: operator.id
                },
                // SUCCESS
                function (response) {
                    log.hospital_operator = response.quality_control_test.hospital_operator;
                });
        }

        function unTagOperator(log) {
            return msApi.request('quality_control_tests.untag_operator@save',{
                    quality_control_test_id: log.id
                },
                // SUCCESS
                function (response) {
                    log.hospital_operator = response.quality_control_test.hospital_operator;
                });
        }

        function subFilterForm(testStrips, controlSolutions1, controlSolutions2) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions1 = controlSolutions1;
            vm.controlLot1 = controlSolutions1;

            vm.controlSolutions2 = controlSolutions2;
            vm.controlLot2 = controlSolutions2;
        }

        function scanQcLogForManualData(qcLogs) {
            vm.hasManualQcData = false;
            _.forEach(qcLogs, function(qcLog) {
                if (qcLog.source == 'manual') {
                    vm.hasManualQcData = true;
                    return;
                }
            });
        }

        function evalMeterReading(log) {
          if (log.is_high) {
            return "HIGH";
          }
          else if (log.is_high) {
            return "LOW";
          }

          return parseFloat(log.meter_reading).toFixed(1);
        }

        function translate() {
            return $translate([
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.TEST_DATE_TIME',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.METER_SERIAL',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.LOCATION',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.CONTROL_TYPE',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_VALUE',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STATUS',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.PS',

                'QC_REPORT_MULTIPLE_LOGBOOK.TO',
                'QC_REPORT_MULTIPLE_LOGBOOK.WITHIN_RANGE',
                'QC_REPORT_MULTIPLE_LOGBOOK.OUTSIDE_RANGE',

                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.METERS',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_METERS',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL1',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL2',

                'QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.OF',
                'QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.PAGE',
                'QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.ROWS_PER_PAGE',

                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.columns = {
                    testDateTime: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.TEST_DATE_TIME'],
                    meterSerial: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.METER_SERIAL'],
                    location: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.LOCATION'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STRIP_LOT'],
                    controlType: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.CONTROL_TYPE'],
                    qcTargetRange: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE'],
                    qcValue: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_VALUE'],
                    status: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STATUS'],
                    operatorInitials: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS'],
                    ps: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.PS']
                };

                vm.misc = {
                    to: translations['QC_REPORT_MULTIPLE_LOGBOOK.TO'],
                    withinRange: translations['QC_REPORT_MULTIPLE_LOGBOOK.WITHIN_RANGE'],
                    outsideRange: translations['QC_REPORT_MULTIPLE_LOGBOOK.OUTSIDE_RANGE']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.METERS'],
                    allMeters: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1'],
                    allControlLotLevel1: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2'],
                    allControlLotLevel2: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL2']
                };

                vm.paginationLabel = {
                    of: translations['QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.OF'],
                    page: translations['QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.PAGE'],
                    rowsPerPage: translations['QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.ROWS_PER_PAGE']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'],
                    selectMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        $scope.$watch('vm.subFilterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        var exportToCSVEvent = $scope.$on('report::exportToCSV', function () {
            exportToCSV();
        });

        var exportToExcelEvent = $scope.$on('report::exportToExcel', function () {
            exportToExcel();
        });

        vm.$onDestroy = function() {
            exportToCSVEvent();
            exportToExcelEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.multiple.logbook')
        .component('multipleLogbookGlobalAdmin', {
            templateUrl: 'app/main/qc-report/multiple/logbook/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, localStorageService, $mdSelect, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.pagination = {
            total:0,
            per_page: 10,
            current_page: 1
        };
        vm.sort = "tested_on";

        vm.loaded = false;
        vm.message = null;
        vm.hasManualQcData = false;

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.getQCLogbook = getQCLogbook;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.scanQcLogForManualData = scanQcLogForManualData;
        vm.evalMeterReading = evalMeterReading;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getQCLogbook);
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getQCLogbook();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getQCLogbook();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getQCLogbook();
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getQCLogbook() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');
                var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
                var sort = _.trimStart(vm.sort, '-');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    sort: sort + ':' + order,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                vm.promise = msApi.request('reports.multiple.qclogbook@get',
                    angular.extend(vm.pagination, params),
                    // SUCCESS
                    function (response) {
                        vm.pagination.total = response.qclogbook.total;
                        vm.qclogbook = response.qclogbook.data;
                        vm.scanQcLogForManualData(vm.qclogbook);
                        vm.loaded = true;
                    });
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToCSV() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');
                var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
                var sort = _.trimStart(vm.sort, '-');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    sort: sort + ':' + order,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                msApi.request('reports.multiple.qclogbook@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var data = [];

                        data.push({
                            a: vm.columns.testDateTime,
                            b: vm.columns.meterSerial,
                            c: vm.columns.location,
                            d: vm.columns.stripLot,
                            e: vm.columns.controlType,
                            f: vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                            g: vm.columns.qcValue + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                            h: vm.columns.status
                        });

                        var qclogbook = response.qclogbook;

                        _.map(qclogbook, function (log) {
                            data.push({
                                a: moment(log.tested_on).format(),
                                b: log.meter.serial_no,
                                c: log.meter.location.code,
                                d: log.test_strip.lot_no,
                                e: log.control_level,
                                f: parseFloat(log.from).toFixed(1) + ' ' + vm.misc.to + ' ' + parseFloat(log.to).toFixed(1),
                                g: log.source == 'manual' ? vm.evalMeterReading(log) + ' **' : vm.evalMeterReading(log),
                                h: log.within_range ? vm.misc.withinRange : vm.misc.outsideRange
                            });
                        });

                        if (vm.hasManualQcData) {
                            data.push({a: '**' + vm.columns.ps, b: '', c: '', d: '', e: '', f: '', g: ''});
                        }

                        var timestamp = moment();
                        var filename = 'QCLogbook-' + timestamp.format('YMMDDHm');

                        alasql('SELECT * INTO CSV(?, {headers:false, separator:","}) FROM ?',[filename, data]);
                    });
            }
        }

        function exportToExcel() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');
                var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
                var sort = _.trimStart(vm.sort, '-');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    sort: sort + ':' + order,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                msApi.request('reports.multiple.qclogbook@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var data = [];

                        data.push({
                            a: vm.columns.testDateTime,
                            b: vm.columns.meterSerial,
                            c: vm.columns.location,
                            d: vm.columns.stripLot,
                            e: vm.columns.controlType,
                            f: vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                            g: vm.columns.qcValue + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                            h: vm.columns.status
                        });

                        var qclogbook = response.qclogbook;

                        _.map(qclogbook, function (log) {
                            data.push({
                                a: moment(log.tested_on).format(),
                                b: log.meter.serial_no,
                                c: log.meter.location.code,
                                d: log.test_strip.lot_no,
                                e: log.control_level,
                                f: parseFloat(log.from).toFixed(1) + ' ' + vm.misc.to + ' ' + parseFloat(log.to).toFixed(1),
                                g: log.source == 'manual' ? vm.evalMeterReading(log) + ' **' : vm.evalMeterReading(log),
                                h: log.within_range ? vm.misc.withinRange : vm.misc.outsideRange
                            });
                        });

                        if (vm.hasManualQcData) {
                            data.push({a: '**' + vm.columns.ps, b: '', c: '', d: '', e: '', f: '', g: ''});
                        }

                        var timestamp = moment();
                        var filename = 'QCLogbook-' + timestamp.format('YMMDDHm');

                        alasql('SELECT * INTO XLSX(?, {headers:false}) FROM ?',[filename, data]);
                    });
            }
        }

        function scanQcLogForManualData(qcLogs) {
            vm.hasManualQcData = false;
            _.forEach(qcLogs, function(qcLog) {
                if (qcLog.source == 'manual') {
                    vm.hasManualQcData = true;
                    return;
                }
            });
        }

        function evalMeterReading(log) {
          if (log.is_high) {
            return "HIGH";
          }
          else if (log.is_high) {
            return "LOW";
          }

          return parseFloat(log.meter_reading).toFixed(1);
        }

        function translate() {
            return $translate([
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.TEST_DATE_TIME',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.METER_SERIAL',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.LOCATION',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.CONTROL_TYPE',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_VALUE',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STATUS',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.PS',

                'QC_REPORT_MULTIPLE_LOGBOOK.TO',
                'QC_REPORT_MULTIPLE_LOGBOOK.WITHIN_RANGE',
                'QC_REPORT_MULTIPLE_LOGBOOK.OUTSIDE_RANGE',

                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.METERS',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_METERS',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL1',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL2',

                'QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.OF',
                'QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.PAGE',
                'QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.ROWS_PER_PAGE',

                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN'

            ]).then(function(translations) {
                vm.columns = {
                    testDateTime: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.TEST_DATE_TIME'],
                    meterSerial: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.METER_SERIAL'],
                    location: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.LOCATION'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STRIP_LOT'],
                    controlType: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.CONTROL_TYPE'],
                    qcTargetRange: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE'],
                    qcValue: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_VALUE'],
                    status: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STATUS'],
                    operatorInitials: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS'],
                    ps: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.PS']
                };

                vm.misc = {
                    to: translations['QC_REPORT_MULTIPLE_LOGBOOK.TO'],
                    withinRange: translations['QC_REPORT_MULTIPLE_LOGBOOK.WITHIN_RANGE'],
                    outsideRange: translations['QC_REPORT_MULTIPLE_LOGBOOK.OUTSIDE_RANGE']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.METERS'],
                    allMeters: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1'],
                    allControlLotLevel1: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2'],
                    allControlLotLevel2: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL2']
                };

                vm.paginationLabel = {
                    of: translations['QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.OF'],
                    page: translations['QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.PAGE'],
                    rowsPerPage: translations['QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.ROWS_PER_PAGE']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN']
                };

            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToCSVEvent = $scope.$on('report::exportToCSV', function () {
            exportToCSV();
        });

        var exportToExcelEvent = $scope.$on('report::exportToExcel', function () {
            exportToExcel();
        });

        vm.$onDestroy = function() {
            exportToCSVEvent();
            exportToExcelEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.multiple.logbook')
        .component('multipleLogbookCountryAdmin', {
            templateUrl: 'app/main/qc-report/multiple/logbook/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, localStorageService, $mdSelect, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.pagination = {
            total:0,
            per_page: 10,
            current_page: 1
        };
        vm.sort = "tested_on";

        vm.loaded = false;
        vm.message = null;
        vm.hasManualQcData = false;

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.getQCLogbook = getQCLogbook;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.scanQcLogForManualData = scanQcLogForManualData;
        vm.evalMeterReading = evalMeterReading;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getQCLogbook);
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getQCLogbook();
            }

            close();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getQCLogbook();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getQCLogbook();
            }
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getQCLogbook() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');
                var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
                var sort = _.trimStart(vm.sort, '-');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    sort: sort + ':' + order,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                vm.promise = msApi.request('reports.multiple.qclogbook@get',
                    angular.extend(vm.pagination, params),
                    // SUCCESS
                    function (response) {
                        vm.pagination.total = response.qclogbook.total;
                        vm.qclogbook = response.qclogbook.data;
                        vm.scanQcLogForManualData(vm.qclogbook);
                        vm.loaded = true;
                    });
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToCSV() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');
                var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
                var sort = _.trimStart(vm.sort, '-');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    sort: sort + ':' + order,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                msApi.request('reports.multiple.qclogbook@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var data = [];

                        data.push({
                            a: vm.columns.testDateTime,
                            b: vm.columns.meterSerial,
                            c: vm.columns.location,
                            d: vm.columns.stripLot,
                            e: vm.columns.controlType,
                            f: vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                            g: vm.columns.qcValue + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                            h: vm.columns.status
                        });

                        var qclogbook = response.qclogbook;

                        _.map(qclogbook, function (log) {
                            data.push({
                                a: moment(log.tested_on).format(),
                                b: log.meter.serial_no,
                                c: log.meter.location.code,
                                d: log.test_strip.lot_no,
                                e: log.control_level,
                                f: parseFloat(log.from).toFixed(1) + ' ' + vm.misc.to + ' ' + parseFloat(log.to).toFixed(1),
                                g: log.source == 'manual' ? vm.evalMeterReading(log) + ' **' : vm.evalMeterReading(log),
                                h: log.within_range ? vm.misc.withinRange : vm.misc.outsideRange
                            });
                        });

                        if (vm.hasManualQcData) {
                            data.push({a: '**' + vm.columns.ps, b: '', c: '', d: '', e: '', f: '', g: ''});
                        }

                        var timestamp = moment();
                        var filename = 'QCLogbook-' + timestamp.format('YMMDDHm');

                        alasql('SELECT * INTO CSV(?, {headers:false, separator:","}) FROM ?',[filename, data]);
                    });
            }
        }

        function exportToExcel() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');
                var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
                var sort = _.trimStart(vm.sort, '-');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    sort: sort + ':' + order,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                msApi.request('reports.multiple.qclogbook@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var data = [];

                        data.push({
                            a: vm.columns.testDateTime,
                            b: vm.columns.meterSerial,
                            c: vm.columns.location,
                            d: vm.columns.stripLot,
                            e: vm.columns.controlType,
                            f: vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                            g: vm.columns.qcValue + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                            h: vm.columns.status
                        });

                        var qclogbook = response.qclogbook;

                        _.map(qclogbook, function (log) {
                            data.push({
                                a: moment(log.tested_on).format(),
                                b: log.meter.serial_no,
                                c: log.meter.location.code,
                                d: log.test_strip.lot_no,
                                e: log.control_level,
                                f: parseFloat(log.from).toFixed(1) + ' ' + vm.misc.to + ' ' + parseFloat(log.to).toFixed(1),
                                g: log.source == 'manual' ? vm.evalMeterReading(log) + ' **' : vm.evalMeterReading(log),
                                h: log.within_range ? vm.misc.withinRange : vm.misc.outsideRange
                            });
                        });

                        if (vm.hasManualQcData) {
                            data.push({a: '**' + vm.columns.ps, b: '', c: '', d: '', e: '', f: '', g: ''});
                        }

                        var timestamp = moment();
                        var filename = 'QCLogbook-' + timestamp.format('YMMDDHm');

                        alasql('SELECT * INTO XLSX(?, {headers:false}) FROM ?',[filename, data]);
                    });
            }
        }

        function scanQcLogForManualData(qcLogs) {
            vm.hasManualQcData = false;
            _.forEach(qcLogs, function(qcLog) {
                if (qcLog.source == 'manual') {
                    vm.hasManualQcData = true;
                    return;
                }
            });
        }

        function evalMeterReading(log) {
          if (log.is_high) {
            return "HIGH";
          }
          else if (log.is_high) {
            return "LOW";
          }

          return parseFloat(log.meter_reading).toFixed(1);
        }

        function translate() {
            return $translate([
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.TEST_DATE_TIME',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.METER_SERIAL',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.LOCATION',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.CONTROL_TYPE',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_VALUE',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STATUS',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS',
                'QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.PS',

                'QC_REPORT_MULTIPLE_LOGBOOK.TO',
                'QC_REPORT_MULTIPLE_LOGBOOK.WITHIN_RANGE',
                'QC_REPORT_MULTIPLE_LOGBOOK.OUTSIDE_RANGE',

                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.METERS',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_METERS',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL1',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2',
                'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL2',

                'QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.OF',
                'QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.PAGE',
                'QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.ROWS_PER_PAGE',

                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN'

            ]).then(function(translations) {
                vm.columns = {
                    testDateTime: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.TEST_DATE_TIME'],
                    meterSerial: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.METER_SERIAL'],
                    location: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.LOCATION'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STRIP_LOT'],
                    controlType: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.CONTROL_TYPE'],
                    qcTargetRange: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE'],
                    qcValue: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_VALUE'],
                    status: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STATUS'],
                    operatorInitials: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS'],
                    ps: translations['QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.PS']
                };

                vm.misc = {
                    to: translations['QC_REPORT_MULTIPLE_LOGBOOK.TO'],
                    withinRange: translations['QC_REPORT_MULTIPLE_LOGBOOK.WITHIN_RANGE'],
                    outsideRange: translations['QC_REPORT_MULTIPLE_LOGBOOK.OUTSIDE_RANGE']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.METERS'],
                    allMeters: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1'],
                    allControlLotLevel1: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2'],
                    allControlLotLevel2: translations['QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL2']
                };

                vm.paginationLabel = {
                    of: translations['QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.OF'],
                    page: translations['QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.PAGE'],
                    rowsPerPage: translations['QC_REPORT_MULTIPLE_LOGBOOK.PAGINATION.ROWS_PER_PAGE']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN']
                };

            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToCSVEvent = $scope.$on('report::exportToCSV', function () {
            exportToCSV();
        });

        var exportToExcelEvent = $scope.$on('report::exportToExcel', function () {
            exportToExcel();
        });

        vm.$onDestroy = function() {
            exportToCSVEvent();
            exportToExcelEvent();
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.multiple.level1', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-multiple-level1', {
                url    : '/qc-report-multiple-level1',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/multiple/level1/level1.html',
                        controller : 'MultipleLevel1Controller as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin'],
                    module: 'qc-report-multiple'
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/multiple/level1');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.multiple.ljchart', ['/reports/multiple/ljchart']);

        msNavigationServiceProvider.saveItem('qc-report-multiple.level1', {
            title : 'Comparison Chart – Level 1',
            state: 'app.qc-report-multiple-level1',
            weight: 19,
            translate: 'QC_REPORT_MULTIPLE_LEVEL1.NAV'
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.qc-report.multiple.level1')
        .component('multipleLevel1HospitalAdmin', {
            templateUrl: 'app/main/qc-report/multiple/level1/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 1';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.stripLotChanged = stripLotChanged;
        vm.controlLotChanged = controlLotChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.getStripLotText = getStripLotText;
        vm.getControlLotText = getControlLotText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true,
                                    zeroLineColor: 'rgba(0, 0, 0, 0)'
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'linear',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            getMeters()
                .then(getLJChart.bind(null, true));
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }

            close();
        }

        function stripLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function controlLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function getStripLotText() {
            var limit = 50;
            if (vm.stripLot && vm.stripLot.length) {
                if (vm.stripLot.length === vm.testStrips.length) {
                    return vm.filters.allStripLot;
                }
                var joined =  _.join(_.map(vm.stripLot, 'lot_no'), ', ');

                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
            } else {
                return vm.filters.stripLot;
            }
        }

        function getControlLotText() {
            var limit = 50;
            if (vm.controlLot && vm.controlLot.length) {
                if (vm.controlLot.length === vm.controlSolutions.length) {
                    return vm.filters.allControlLot;
                }
                var joined = _.join(_.map(vm.controlLot, 'lot_no'), ', ');

                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
            } else {
                return vm.filters.controlLot;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            yAxes(vm.data);
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.stripLot,
                                    style: 'small'
                                },
                                {
                                    text:  getStripLotText(),
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.controlLot,
                                    style: 'small'
                                },
                                {
                                    text: getControlLotText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('ComparisonChart–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function getMeters() {
            var params = {
                hospital_id: vm.user.hospitals[0].id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart(updateSubFilterForm) {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    level: vm.level,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                if (!updateSubFilterForm) {
                    if (vm.stripLot.length) {
                        var stripLotIds = _.map(vm.stripLot, 'id');
                        params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                    }

                    if (vm.controlLot.length) {
                        var controlLotIds = _.map(vm.controlLot, 'id');
                        params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                    }
                }

                return msApi.request('reports.multiple.ljchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var testStrips = response.test_strips;
                        var controlSolutions = response.control_solutions;
                        vm.data = response.data;

                        if (updateSubFilterForm) {
                            subFilterForm(testStrips, controlSolutions);
                        }

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        annotations();
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var series = [];

            for (var i = 0; i < vm.locations.length; i++) {
                var location = vm.locations[i];
                var meters = _.keys(data[location]);
                _.map(meters, function(meter) {
                    var zscore = data[location][meter];
                    series.push({meter: meter, points: [{x: i, y: zscore !== null ? zscore.toFixed(2) : null}]});
                });
            }

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    showLine: false,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter,
                    pointStyle: 'rect',
                    pointBorderWidth: 2
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            vm.locations = _.keys(data);

            // x axes for empty data
            if (vm.locations.length === 0) {
                vm.locations = _.keys(_.keyBy(vm.selectedMeters, function(meter) {
                    return meter.location.code;
                }));
            }

            vm.chartjs.options.scales.xAxes[0].ticks.min = -1;
            vm.chartjs.options.scales.xAxes[0].ticks.max = vm.locations.length;
            vm.chartjs.options.scales.xAxes[0].ticks.fixedStepSize = 1;

            vm.chartjs.options.scales.xAxes[0].ticks.callback = function (value) {
                if (value >= 0 && value < vm.locations.length) {
                    return vm.locations[value];
                }

                return null;
            };
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(location) {
                return _.values(location);
            }));

            var minZscore = _.min(flatten);
            var maxZscore = _.max(flatten);

            var min = (vm.zoomToFit && minZscore != null) ? _.floor(minZscore - 0.5) : -3;
            var max = (vm.zoomToFit && maxZscore != null) ?_.ceil(maxZscore + 0.5) : 3;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = 1;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            // Secondary Axes
            vm.chartjs.options.scales.yAxes[1].ticks.min = min;
            vm.chartjs.options.scales.yAxes[1].ticks.max = max;
            vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1;
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                },
                title: function (tooltipItem, data) {
                    return vm.locations[tooltipItem[0].xLabel];
                }
            };
        }

        function annotations() {
            var annotations = [];

            // mean
            annotations.push(annotation(0, 8, {borderWidth: 2}, vm.chart.mfrMean));

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(value === 0) return vm.chart.mfrMean;
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function translate() {
            return $translate([
                'QC_REPORT_MULTIPLE.TITLE',
                'QC_REPORT_MULTIPLE.START_DATE',
                'QC_REPORT_MULTIPLE.END_DATE',
                'QC_REPORT_MULTIPLE_LEVEL1.TITLE',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.METERS',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_METERS',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.CONTROL_LOT',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_MULTIPLE_LEVEL1.CHART.TITLE',
                'QC_REPORT_MULTIPLE_LEVEL1.CHART.X_AXIS',
                'QC_REPORT_MULTIPLE_LEVEL1.CHART.Y_AXIS',
                'QC_REPORT_MULTIPLE_LEVEL1.CHART.MFR_MEAN',

                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MULTIPLE.TITLE'],
                    title: translations['QC_REPORT_MULTIPLE_LEVEL1.TITLE'],
                    startDate: translations['QC_REPORT_MULTIPLE.START_DATE'],
                    endDate: translations['QC_REPORT_MULTIPLE.END_DATE'],
                    meters: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.METERS'],
                    allMeters: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_CONTROL_LOT']
                };

                vm.chart = {
                    title: translations['QC_REPORT_MULTIPLE_LEVEL1.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MULTIPLE_LEVEL1.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MULTIPLE_LEVEL1.CHART.Y_AXIS'],
                    mfrMean: translations['QC_REPORT_MULTIPLE_LEVEL1.CHART.MFR_MEAN']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'],
                    selectMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        $scope.$watch('vm.subFilterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.multiple.level1')
        .component('multipleLevel1GlobalAdmin', {
            templateUrl: 'app/main/qc-report/multiple/level1/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 1';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true,
                                    zeroLineColor: 'rgba(0, 0, 0, 0)'
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'linear',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getLJChart.bind(null, true));
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            yAxes(vm.data);
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.country,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedCountry.name
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.state,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedState.name
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('ComparisonChart–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart(updateSubFilterForm) {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    level: vm.level,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                if (!updateSubFilterForm) {
                    if (vm.stripLot.length) {
                        var stripLotIds = _.map(vm.stripLot, 'id');
                        params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                    }

                    if (vm.controlLot.length) {
                        var controlLotIds = _.map(vm.controlLot, 'id');
                        params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                    }
                }

                return msApi.request('reports.multiple.ljchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var testStrips = response.test_strips;
                        var controlSolutions = response.control_solutions;
                        vm.data = response.data;

                        if (updateSubFilterForm) {
                            subFilterForm(testStrips, controlSolutions);
                        }

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        annotations();
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var series = [];

            for (var i = 0; i < vm.locations.length; i++) {
                var location = vm.locations[i];
                var meters = _.keys(data[location]);
                _.map(meters, function(meter) {
                    var zscore = data[location][meter];
                    series.push({meter: meter, points: [{x: i, y: zscore !== null ? zscore.toFixed(2) : null}]});
                });
            }

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    showLine: false,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter,
                    pointStyle: 'rect',
                    pointBorderWidth: 2
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            vm.locations = _.keys(data);

            // x axes for empty data
            if (vm.locations.length === 0) {
                vm.locations = _.keys(_.keyBy(vm.selectedMeters, function(meter) {
                    return meter.location.code;
                }));
            }

            vm.chartjs.options.scales.xAxes[0].ticks.min = -1;
            vm.chartjs.options.scales.xAxes[0].ticks.max = vm.locations.length;
            vm.chartjs.options.scales.xAxes[0].ticks.fixedStepSize = 1;

            vm.chartjs.options.scales.xAxes[0].ticks.callback = function (value) {
                if (value >= 0 && value < vm.locations.length) {
                    return vm.locations[value];
                }

                return null;
            };
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(location) {
                return _.values(location);
            }));

            var minZscore = _.min(flatten);
            var maxZscore = _.max(flatten);

            var min = (vm.zoomToFit && minZscore != null) ? _.floor(minZscore - 0.5) : -3;
            var max = (vm.zoomToFit && maxZscore != null) ?_.ceil(maxZscore + 0.5) : 3;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = 1;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            // Secondary Axes
            vm.chartjs.options.scales.yAxes[1].ticks.min = min;
            vm.chartjs.options.scales.yAxes[1].ticks.max = max;
            vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1;
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                },
                title: function (tooltipItem, data) {
                    return vm.locations[tooltipItem[0].xLabel];
                }
            };
        }

        function annotations() {
            var annotations = [];

            // mean
            annotations.push(annotation(0, 8, {borderWidth: 2}, vm.chart.mfrMean));

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(value === 0) return vm.chart.mfrMean;
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function translate() {
            return $translate([
                'QC_REPORT_MULTIPLE.TITLE',
                'QC_REPORT_MULTIPLE.COUNTRY',
                'QC_REPORT_MULTIPLE.STATE',
                'QC_REPORT_MULTIPLE.HOSPITAL',
                'QC_REPORT_MULTIPLE.START_DATE',
                'QC_REPORT_MULTIPLE.END_DATE',
                'QC_REPORT_MULTIPLE_LEVEL1.TITLE',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.METERS',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_METERS',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.CONTROL_LOT',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_MULTIPLE_LEVEL1.CHART.TITLE',
                'QC_REPORT_MULTIPLE_LEVEL1.CHART.X_AXIS',
                'QC_REPORT_MULTIPLE_LEVEL1.CHART.Y_AXIS',
                'QC_REPORT_MULTIPLE_LEVEL1.CHART.MFR_MEAN',

                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MULTIPLE.TITLE'],
                    title: translations['QC_REPORT_MULTIPLE_LEVEL1.TITLE'],
                    country: translations['QC_REPORT_MULTIPLE.COUNTRY'],
                    state: translations['QC_REPORT_MULTIPLE.STATE'],
                    hospital: translations['QC_REPORT_MULTIPLE.HOSPITAL'],
                    startDate: translations['QC_REPORT_MULTIPLE.START_DATE'],
                    endDate: translations['QC_REPORT_MULTIPLE.END_DATE'],
                    meters: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.METERS'],
                    allMeters: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_CONTROL_LOT']
                };

                vm.chart = {
                    title: translations['QC_REPORT_MULTIPLE_LEVEL1.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MULTIPLE_LEVEL1.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MULTIPLE_LEVEL1.CHART.Y_AXIS'],
                    mfrMean: translations['QC_REPORT_MULTIPLE_LEVEL1.CHART.MFR_MEAN']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.multiple.level1')
        .component('multipleLevel1CountryAdmin', {
            templateUrl: 'app/main/qc-report/multiple/level1/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 1';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true,
                                    zeroLineColor: 'rgba(0, 0, 0, 0)'
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'linear',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getLJChart.bind(null, true));
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            yAxes(vm.data);
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.state,
                                    style: 'small'
                                },
                                {
                                    text:  vm.selectedState.name,
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name,
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('ComparisonChart–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart(updateSubFilterForm) {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    level: vm.level,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                if (!updateSubFilterForm) {
                    if (vm.stripLot.length) {
                        var stripLotIds = _.map(vm.stripLot, 'id');
                        params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                    }

                    if (vm.controlLot.length) {
                        var controlLotIds = _.map(vm.controlLot, 'id');
                        params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                    }
                }

                return msApi.request('reports.multiple.ljchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var testStrips = response.test_strips;
                        var controlSolutions = response.control_solutions;
                        vm.data = response.data;

                        if (updateSubFilterForm) {
                            subFilterForm(testStrips, controlSolutions);
                        }

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        annotations();
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var series = [];

            for (var i = 0; i < vm.locations.length; i++) {
                var location = vm.locations[i];
                var meters = _.keys(data[location]);
                _.map(meters, function(meter) {
                    var zscore = data[location][meter];
                    series.push({meter: meter, points: [{x: i, y: zscore !== null ? zscore.toFixed(2) : null}]});
                });
            }

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    showLine: false,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter,
                    pointStyle: 'rect',
                    pointBorderWidth: 2
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            vm.locations = _.keys(data);

            // x axes for empty data
            if (vm.locations.length === 0) {
                vm.locations = _.keys(_.keyBy(vm.selectedMeters, function(meter) {
                    return meter.location.code;
                }));
            }

            vm.chartjs.options.scales.xAxes[0].ticks.min = -1;
            vm.chartjs.options.scales.xAxes[0].ticks.max = vm.locations.length;
            vm.chartjs.options.scales.xAxes[0].ticks.fixedStepSize = 1;

            vm.chartjs.options.scales.xAxes[0].ticks.callback = function (value) {
                if (value >= 0 && value < vm.locations.length) {
                    return vm.locations[value];
                }

                return null;
            };
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(location) {
                return _.values(location);
            }));

            var minZscore = _.min(flatten);
            var maxZscore = _.max(flatten);

            var min = (vm.zoomToFit && minZscore != null) ? _.floor(minZscore - 0.5) : -3;
            var max = (vm.zoomToFit && maxZscore != null) ?_.ceil(maxZscore + 0.5) : 3;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = 1;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            // Secondary Axes
            vm.chartjs.options.scales.yAxes[1].ticks.min = min;
            vm.chartjs.options.scales.yAxes[1].ticks.max = max;
            vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1;
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                },
                title: function (tooltipItem, data) {
                    return vm.locations[tooltipItem[0].xLabel];
                }
            };
        }

        function annotations() {
            var annotations = [];

            // mean
            annotations.push(annotation(0, 8, {borderWidth: 2}, vm.chart.mfrMean));

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(value === 0) return vm.chart.mfrMean;
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function translate() {
            return $translate([
                'QC_REPORT_MULTIPLE.TITLE',
                'QC_REPORT_MULTIPLE.COUNTRY',
                'QC_REPORT_MULTIPLE.STATE',
                'QC_REPORT_MULTIPLE.HOSPITAL',
                'QC_REPORT_MULTIPLE.START_DATE',
                'QC_REPORT_MULTIPLE.END_DATE',
                'QC_REPORT_MULTIPLE_LEVEL1.TITLE',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.METERS',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_METERS',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.CONTROL_LOT',
                'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_MULTIPLE_LEVEL1.CHART.TITLE',
                'QC_REPORT_MULTIPLE_LEVEL1.CHART.X_AXIS',
                'QC_REPORT_MULTIPLE_LEVEL1.CHART.Y_AXIS',
                'QC_REPORT_MULTIPLE_LEVEL1.CHART.MFR_MEAN',

                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MULTIPLE.TITLE'],
                    title: translations['QC_REPORT_MULTIPLE_LEVEL1.TITLE'],
                    country: translations['QC_REPORT_MULTIPLE.COUNTRY'],
                    state: translations['QC_REPORT_MULTIPLE.STATE'],
                    hospital: translations['QC_REPORT_MULTIPLE.HOSPITAL'],
                    startDate: translations['QC_REPORT_MULTIPLE.START_DATE'],
                    endDate: translations['QC_REPORT_MULTIPLE.END_DATE'],
                    meters: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.METERS'],
                    allMeters: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_MULTIPLE_LEVEL1.FILTERS.ALL_CONTROL_LOT']
                };

                vm.chart = {
                    title: translations['QC_REPORT_MULTIPLE_LEVEL1.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MULTIPLE_LEVEL1.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MULTIPLE_LEVEL1.CHART.Y_AXIS'],
                    mfrMean: translations['QC_REPORT_MULTIPLE_LEVEL1.CHART.MFR_MEAN']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.multiple.level2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-multiple-level2', {
                url    : '/qc-report-multiple-level2',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/multiple/level2/level2.html',
                        controller : 'MultipleLevel2Controller as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin'],
                    module: 'qc-report-multiple'
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/multiple/level2');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.multiple.ljchart', ['/reports/multiple/ljchart']);

        msNavigationServiceProvider.saveItem('qc-report-multiple.level2', {
            title : 'Comparison Chart – Level 2',
            state: 'app.qc-report-multiple-level2',
            weight: 20,
            translate: 'QC_REPORT_MULTIPLE_LEVEL2.NAV'
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.qc-report.multiple.level2')
        .component('multipleLevel2HospitalAdmin', {
            templateUrl: 'app/main/qc-report/multiple/level2/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 2';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.stripLotChanged = stripLotChanged;
        vm.controlLotChanged = controlLotChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.getStripLotText = getStripLotText;
        vm.getControlLotText = getControlLotText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true,
                                    zeroLineColor: 'rgba(0, 0, 0, 0)'
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'linear',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            getMeters()
                .then(getLJChart.bind(null, true));
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }

            close();
        }

        function stripLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function controlLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function getStripLotText() {
            var limit = 50;
            if (vm.stripLot && vm.stripLot.length) {
                if (vm.stripLot.length === vm.testStrips.length) {
                    return vm.filters.allStripLot;
                }
                var joined =  _.join(_.map(vm.stripLot, 'lot_no'), ', ');

                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
            } else {
                return vm.filters.stripLot;
            }
        }

        function getControlLotText() {
            var limit = 50;
            if (vm.controlLot && vm.controlLot.length) {
                if (vm.controlLot.length === vm.controlSolutions.length) {
                    return vm.filters.allControlLot;
                }
                var joined = _.join(_.map(vm.controlLot, 'lot_no'), ', ');

                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
            } else {
                return vm.filters.controlLot;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            yAxes(vm.data);
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.stripLot,
                                    style: 'small'
                                },
                                {
                                    text:  getStripLotText(),
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.controlLot,
                                    style: 'small'
                                },
                                {
                                    text: getControlLotText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('ComparisonChart–Level2-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function getMeters() {
            var params = {
                hospital_id: vm.user.hospitals[0].id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart(updateSubFilterForm) {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    level: vm.level,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                if (!updateSubFilterForm) {
                    if (vm.stripLot.length) {
                        var stripLotIds = _.map(vm.stripLot, 'id');
                        params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                    }

                    if (vm.controlLot.length) {
                        var controlLotIds = _.map(vm.controlLot, 'id');
                        params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                    }
                }

                return msApi.request('reports.multiple.ljchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var testStrips = response.test_strips;
                        var controlSolutions = response.control_solutions;
                        vm.data = response.data;

                        if (updateSubFilterForm) {
                            subFilterForm(testStrips, controlSolutions);
                        }

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        annotations();
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var series = [];

            for (var i = 0; i < vm.locations.length; i++) {
                var location = vm.locations[i];
                var meters = _.keys(data[location]);
                _.map(meters, function(meter) {
                    var zscore = data[location][meter];
                    series.push({meter: meter, points: [{x: i, y: zscore !== null ? zscore.toFixed(2) : null}]});
                });
            }

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    showLine: false,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter,
                    pointStyle: 'rectRot',
                    pointBorderWidth: 2
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            vm.locations = _.keys(data);

            // x axes for empty data
            if (vm.locations.length === 0) {
                vm.locations = _.keys(_.keyBy(vm.selectedMeters, function(meter) {
                    return meter.location.code;
                }));
            }

            vm.chartjs.options.scales.xAxes[0].ticks.min = -1;
            vm.chartjs.options.scales.xAxes[0].ticks.max = vm.locations.length;
            vm.chartjs.options.scales.xAxes[0].ticks.fixedStepSize = 1;

            vm.chartjs.options.scales.xAxes[0].ticks.callback = function (value) {
                if (value >= 0 && value < vm.locations.length) {
                    return vm.locations[value];
                }

                return null;
            };
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(location) {
                return _.values(location);
            }));

            var minZscore = _.min(flatten);
            var maxZscore = _.max(flatten);

            var min = (vm.zoomToFit && minZscore != null) ? _.floor(minZscore - 0.5) : -3;
            var max = (vm.zoomToFit && maxZscore != null) ?_.ceil(maxZscore + 0.5) : 3;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = 1;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            // Secondary Axes
            vm.chartjs.options.scales.yAxes[1].ticks.min = min;
            vm.chartjs.options.scales.yAxes[1].ticks.max = max;
            vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1;
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                },
                title: function (tooltipItem, data) {
                    return vm.locations[tooltipItem[0].xLabel];
                }
            };
        }

        function annotations() {
            var annotations = [];

            // mean
            annotations.push(annotation(0, 8, {borderWidth: 2}, vm.chart.mfrMean));

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(value === 0) return vm.chart.mfrMean;
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function translate() {
            return $translate([
                'QC_REPORT_MULTIPLE.TITLE',
                'QC_REPORT_MULTIPLE.START_DATE',
                'QC_REPORT_MULTIPLE.END_DATE',
                'QC_REPORT_MULTIPLE_LEVEL2.TITLE',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.METERS',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_METERS',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.CONTROL_LOT',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_MULTIPLE_LEVEL2.CHART.TITLE',
                'QC_REPORT_MULTIPLE_LEVEL2.CHART.X_AXIS',
                'QC_REPORT_MULTIPLE_LEVEL2.CHART.Y_AXIS',
                'QC_REPORT_MULTIPLE_LEVEL2.CHART.MFR_MEAN',

                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MULTIPLE.TITLE'],
                    title: translations['QC_REPORT_MULTIPLE_LEVEL2.TITLE'],
                    startDate: translations['QC_REPORT_MULTIPLE.START_DATE'],
                    endDate: translations['QC_REPORT_MULTIPLE.END_DATE'],
                    meters: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.METERS'],
                    allMeters: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_CONTROL_LOT']
                };

                vm.chart = {
                    title: translations['QC_REPORT_MULTIPLE_LEVEL2.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MULTIPLE_LEVEL2.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MULTIPLE_LEVEL2.CHART.Y_AXIS'],
                    mfrMean: translations['QC_REPORT_MULTIPLE_LEVEL2.CHART.MFR_MEAN']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'],
                    selectMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        $scope.$watch('vm.subFilterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.multiple.level1')
        .component('multipleLevel2GlobalAdmin', {
            templateUrl: 'app/main/qc-report/multiple/level1/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 2';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true,
                                    zeroLineColor: 'rgba(0, 0, 0, 0)'
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'linear',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getLJChart.bind(null, true));
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            yAxes(vm.data);
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.country,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedCountry.name
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.state,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedState.name
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('ComparisonChart–Level2-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart(updateSubFilterForm) {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    level: vm.level,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                if (!updateSubFilterForm) {
                    if (vm.stripLot.length) {
                        var stripLotIds = _.map(vm.stripLot, 'id');
                        params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                    }

                    if (vm.controlLot.length) {
                        var controlLotIds = _.map(vm.controlLot, 'id');
                        params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                    }
                }

                return msApi.request('reports.multiple.ljchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var testStrips = response.test_strips;
                        var controlSolutions = response.control_solutions;
                        vm.data = response.data;

                        if (updateSubFilterForm) {
                            subFilterForm(testStrips, controlSolutions);
                        }

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        annotations();
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var series = [];

            for (var i = 0; i < vm.locations.length; i++) {
                var location = vm.locations[i];
                var meters = _.keys(data[location]);
                _.map(meters, function(meter) {
                    var zscore = data[location][meter];
                    series.push({meter: meter, points: [{x: i, y: zscore !== null ? zscore.toFixed(2) : null}]});
                });
            }

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    showLine: false,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter,
                    pointStyle: 'rectRot',
                    pointBorderWidth: 2
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            vm.locations = _.keys(data);

            // x axes for empty data
            if (vm.locations.length === 0) {
                vm.locations = _.keys(_.keyBy(vm.selectedMeters, function(meter) {
                    return meter.location.code;
                }));
            }

            vm.chartjs.options.scales.xAxes[0].ticks.min = -1;
            vm.chartjs.options.scales.xAxes[0].ticks.max = vm.locations.length;
            vm.chartjs.options.scales.xAxes[0].ticks.fixedStepSize = 1;

            vm.chartjs.options.scales.xAxes[0].ticks.callback = function (value) {
                if (value >= 0 && value < vm.locations.length) {
                    return vm.locations[value];
                }

                return null;
            };
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(location) {
                return _.values(location);
            }));

            var minZscore = _.min(flatten);
            var maxZscore = _.max(flatten);

            var min = (vm.zoomToFit && minZscore != null) ? _.floor(minZscore - 0.5) : -3;
            var max = (vm.zoomToFit && maxZscore != null) ?_.ceil(maxZscore + 0.5) : 3;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = 1;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            // Secondary Axes
            vm.chartjs.options.scales.yAxes[1].ticks.min = min;
            vm.chartjs.options.scales.yAxes[1].ticks.max = max;
            vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1;
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                },
                title: function (tooltipItem, data) {
                    return vm.locations[tooltipItem[0].xLabel];
                }
            };
        }

        function annotations() {
            var annotations = [];

            // mean
            annotations.push(annotation(0, 8, {borderWidth: 2}, vm.chart.mfrMean));

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(value === 0) return vm.chart.mfrMean;
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function translate() {
            return $translate([
                'QC_REPORT_MULTIPLE.TITLE',
                'QC_REPORT_MULTIPLE.COUNTRY',
                'QC_REPORT_MULTIPLE.STATE',
                'QC_REPORT_MULTIPLE.HOSPITAL',
                'QC_REPORT_MULTIPLE.START_DATE',
                'QC_REPORT_MULTIPLE.END_DATE',
                'QC_REPORT_MULTIPLE_LEVEL2.TITLE',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.METERS',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_METERS',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.CONTROL_LOT',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_MULTIPLE_LEVEL2.CHART.TITLE',
                'QC_REPORT_MULTIPLE_LEVEL2.CHART.X_AXIS',
                'QC_REPORT_MULTIPLE_LEVEL2.CHART.Y_AXIS',
                'QC_REPORT_MULTIPLE_LEVEL2.CHART.MFR_MEAN',

                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MULTIPLE.TITLE'],
                    title: translations['QC_REPORT_MULTIPLE_LEVEL2.TITLE'],
                    country: translations['QC_REPORT_MULTIPLE.COUNTRY'],
                    state: translations['QC_REPORT_MULTIPLE.STATE'],
                    hospital: translations['QC_REPORT_MULTIPLE.HOSPITAL'],
                    startDate: translations['QC_REPORT_MULTIPLE.START_DATE'],
                    endDate: translations['QC_REPORT_MULTIPLE.END_DATE'],
                    meters: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.METERS'],
                    allMeters: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_CONTROL_LOT']
                };

                vm.chart = {
                    title: translations['QC_REPORT_MULTIPLE_LEVEL2.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MULTIPLE_LEVEL2.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MULTIPLE_LEVEL2.CHART.Y_AXIS'],
                    mfrMean: translations['QC_REPORT_MULTIPLE_LEVEL2.CHART.MFR_MEAN']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.multiple.level1')
        .component('multipleLevel2CountryAdmin', {
            templateUrl: 'app/main/qc-report/multiple/level1/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 2';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true,
                                    zeroLineColor: 'rgba(0, 0, 0, 0)'
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'linear',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getLJChart.bind(null, true));
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            yAxes(vm.data);
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.state,
                                    style: 'small'
                                },
                                {
                                    text:  vm.selectedState.name,
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name,
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('ComparisonChart–Level2-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart(updateSubFilterForm) {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    level: vm.level,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                if (!updateSubFilterForm) {
                    if (vm.stripLot.length) {
                        var stripLotIds = _.map(vm.stripLot, 'id');
                        params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                    }

                    if (vm.controlLot.length) {
                        var controlLotIds = _.map(vm.controlLot, 'id');
                        params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                    }
                }

                return msApi.request('reports.multiple.ljchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var testStrips = response.test_strips;
                        var controlSolutions = response.control_solutions;
                        vm.data = response.data;

                        if (updateSubFilterForm) {
                            subFilterForm(testStrips, controlSolutions);
                        }

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        annotations();
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var series = [];

            for (var i = 0; i < vm.locations.length; i++) {
                var location = vm.locations[i];
                var meters = _.keys(data[location]);
                _.map(meters, function(meter) {
                    var zscore = data[location][meter];
                    series.push({meter: meter, points: [{x: i, y: zscore !== null ? zscore.toFixed(2) : null}]});
                });
            }

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    showLine: false,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter,
                    pointStyle: 'rectRot',
                    pointBorderWidth: 2
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            vm.locations = _.keys(data);

            // x axes for empty data
            if (vm.locations.length === 0) {
                vm.locations = _.keys(_.keyBy(vm.selectedMeters, function(meter) {
                    return meter.location.code;
                }));
            }

            vm.chartjs.options.scales.xAxes[0].ticks.min = -1;
            vm.chartjs.options.scales.xAxes[0].ticks.max = vm.locations.length;
            vm.chartjs.options.scales.xAxes[0].ticks.fixedStepSize = 1;

            vm.chartjs.options.scales.xAxes[0].ticks.callback = function (value) {
                if (value >= 0 && value < vm.locations.length) {
                    return vm.locations[value];
                }

                return null;
            };
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(location) {
                return _.values(location);
            }));

            var minZscore = _.min(flatten);
            var maxZscore = _.max(flatten);

            var min = (vm.zoomToFit && minZscore != null) ? _.floor(minZscore - 0.5) : -3;
            var max = (vm.zoomToFit && maxZscore != null) ?_.ceil(maxZscore + 0.5) : 3;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = 1;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            // Secondary Axes
            vm.chartjs.options.scales.yAxes[1].ticks.min = min;
            vm.chartjs.options.scales.yAxes[1].ticks.max = max;
            vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1;
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                },
                title: function (tooltipItem, data) {
                    return vm.locations[tooltipItem[0].xLabel];
                }
            };
        }

        function annotations() {
            var annotations = [];

            // mean
            annotations.push(annotation(0, 8, {borderWidth: 2}, vm.chart.mfrMean));

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(value === 0) return vm.chart.mfrMean;
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function translate() {
            return $translate([
                'QC_REPORT_MULTIPLE.TITLE',
                'QC_REPORT_MULTIPLE.COUNTRY',
                'QC_REPORT_MULTIPLE.STATE',
                'QC_REPORT_MULTIPLE.HOSPITAL',
                'QC_REPORT_MULTIPLE.START_DATE',
                'QC_REPORT_MULTIPLE.END_DATE',
                'QC_REPORT_MULTIPLE_LEVEL2.TITLE',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.METERS',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_METERS',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.CONTROL_LOT',
                'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_MULTIPLE_LEVEL2.CHART.TITLE',
                'QC_REPORT_MULTIPLE_LEVEL2.CHART.X_AXIS',
                'QC_REPORT_MULTIPLE_LEVEL2.CHART.Y_AXIS',
                'QC_REPORT_MULTIPLE_LEVEL2.CHART.MFR_MEAN',

                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MULTIPLE.TITLE'],
                    title: translations['QC_REPORT_MULTIPLE_LEVEL2.TITLE'],
                    country: translations['QC_REPORT_MULTIPLE.COUNTRY'],
                    state: translations['QC_REPORT_MULTIPLE.STATE'],
                    hospital: translations['QC_REPORT_MULTIPLE.HOSPITAL'],
                    startDate: translations['QC_REPORT_MULTIPLE.START_DATE'],
                    endDate: translations['QC_REPORT_MULTIPLE.END_DATE'],
                    meters: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.METERS'],
                    allMeters: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_MULTIPLE_LEVEL2.FILTERS.ALL_CONTROL_LOT']
                };

                vm.chart = {
                    title: translations['QC_REPORT_MULTIPLE_LEVEL2.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MULTIPLE_LEVEL2.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MULTIPLE_LEVEL2.CHART.Y_AXIS'],
                    mfrMean: translations['QC_REPORT_MULTIPLE_LEVEL2.CHART.MFR_MEAN']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.multiple.combined', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-multiple-combined', {
                url    : '/qc-report-multiple-combined',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/multiple/combined/combined.html',
                        controller : 'MultipleCombinedController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin'],
                    module: 'qc-report-multiple'
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/multiple/combined');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.multiple.ljchart', ['/reports/multiple/ljchart']);

        msNavigationServiceProvider.saveItem('qc-report-multiple.combined', {
            title : 'Comparison Chart – Combined',
            state: 'app.qc-report-multiple-combined',
            weight: 21,
            translate: 'QC_REPORT_MULTIPLE_COMBINED.NAV'
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.qc-report.multiple.combined')
        .component('multipleCombinedHospitalAdmin', {
            templateUrl: 'app/main/qc-report/multiple/combined/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.message = null;

        vm.controlSolutions1 = [];
        vm.controlLot1 = [];

        vm.controlSolutions2 = [];
        vm.controlLot2 = [];

        vm.zoomToFit = false;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.stripLotChanged = stripLotChanged;
        vm.controlLot1Changed = controlLot1Changed;
        vm.controlLot2Changed = controlLot2Changed;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.getStripLotText = getStripLotText;
        vm.getControlLot1Text = getControlLot1Text;
        vm.getControlLot2Text = getControlLot2Text;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true,
                                    zeroLineColor: 'rgba(0, 0, 0, 0)'
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'linear',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            getMeters()
                .then(getLJChart.bind(null, true));
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }

            close();
        }

        function stripLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function controlLot1Changed() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function controlLot2Changed() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function getStripLotText() {
            var limit = 50;
            if (vm.stripLot && vm.stripLot.length) {
                if (vm.stripLot.length === vm.testStrips.length) {
                    return vm.filters.allStripLot;
                }
                var joined =  _.join(_.map(vm.stripLot, 'lot_no'), ', ');

                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
            } else {
                return vm.filters.stripLot;
            }
        }

        function getControlLot1Text() {
            var limit = 30;
            if (vm.controlLot1 && vm.controlLot1.length) {
                if (vm.controlLot1.length === vm.controlSolutions1.length) {
                    return vm.filters.allControlLotLevel1;
                }

                var joined = _.join(_.map(vm.controlLot1, 'lot_no'), ',');
                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');

            } else {
                return vm.filters.controlLotLevel1;
            }
        }

        function getControlLot2Text() {
            var limit = 30;
            if (vm.controlLot2 && vm.controlLot2.length) {
                if (vm.controlLot2.length === vm.controlSolutions2.length) {
                    return vm.filters.allControlLotLevel2;
                }

                var joined = _.join(_.map(vm.controlLot2, 'lot_no'), ',');
                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');

            } else {
                return vm.filters.controlLotLevel2;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            yAxes(vm.data);
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.startDate,
                                    style: 'small'
                                },
                                {
                                    text: moment(vm.startDate).format('YYYY-MM-DD')
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.endDate,
                                    style: 'small'
                                },
                                {
                                    text: moment(vm.endDate).format('YYYY-MM-DD')
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: vm.getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.stripLot,
                                    style: 'small'
                                },
                                {
                                    text: getStripLotText(),
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.controlLotLevel1,
                                    style: 'small'
                                },
                                {
                                    text: getControlLot1Text(),
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.controlLotLevel2,
                                    style: 'small'
                                },
                                {
                                    text: getControlLot2Text(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 20]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('ComparisonChart–Combined-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function getMeters() {
            var params = {
                hospital_id: vm.user.hospitals[0].id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart(updateSubFilterForm) {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                if (!updateSubFilterForm) {
                    if (vm.stripLot.length) {
                        var stripLotIds = _.map(vm.stripLot, 'id');
                        params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                    }

                    var controlLot = vm.controlLot1.concat(vm.controlLot2);

                    if (controlLot.length) {
                        var controlLotIds = _.map(controlLot, 'id');
                        params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                    }
                }

                return msApi.request('reports.multiple.ljchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var testStrips = response.test_strips;
                        var controlSolutions1 = response.control_solutions1;
                        var controlSolutions2 = response.control_solutions2;
                        vm.data = response.data;

                        if (updateSubFilterForm) {
                            subFilterForm(testStrips, controlSolutions1, controlSolutions2);
                        }

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        annotations();
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function subFilterForm(testStrips, controlSolutions1, controlSolutions2) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions1 = controlSolutions1;
            vm.controlLot1 = controlSolutions1;

            vm.controlSolutions2 = controlSolutions2;
            vm.controlLot2 = controlSolutions2;
        }

        function points(data) {
            var series = [];
            var colors = [];

            for (var i = 0; i < vm.meters.length; i++) {
                colors.push({meter: vm.meters[i].serial_no, color: vm.colors[i % vm.colors.length]});
            }

            if (_.has(data, 'Level 1')) {
                for (var i = 0; i < vm.locations.length; i++) {
                    var location = vm.locations[i];
                    var meters = _.keys(data['Level 1'][location]);
                    _.map(meters, function (meter) {
                        var zscore = data['Level 1'][location][meter];
                        series.push({meter: meter, level: 1, points: [{x: i, y: zscore !== null ? zscore.toFixed(2) : null}]});
                    });
                }
            }

            if (_.has(data, 'Level 2')) {
                for (var i = 0; i < vm.locations.length; i++) {
                    var location = vm.locations[i];
                    var meters = _.keys(data['Level 2'][location]);
                    _.map(meters, function (meter) {
                        var zscore = data['Level 2'][location][meter];
                        series.push({meter: meter, level: 2, points: [{x: i, y: zscore !== null ? zscore.toFixed(2) : null}]});
                    });
                }
            }

            series = _.sortBy(series, ['meter']);

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                var pointStyle = series[i].level === 1 ? 'rect' : 'rectRot';
                var label = series[i].level === 1 ? series[i].meter + '-C1' : series[i].meter + '-C2';
                var color = _.find(colors, ['meter', series[i].meter]);
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    showLine: false,
                    backgroundColor: color.color,
                    borderColor: color.color,
                    pointBorderColor: color.color,
                    pointBackgroundColor: color.color,
                    pointHoverBackgroundColor: color.color,
                    pointHoverBorderColor: color.color,
                    label: label,
                    pointStyle: pointStyle,
                    pointBorderWidth: 2
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            var location1 = _.keys(data['Level 1']);
            var location2 = _.keys(data['Level 2']);
            vm.locations = _.merge(location1, location2);
            vm.locations = _.sortBy(vm.locations);

            // x axes for empty data
            if (vm.locations.length === 0) {
                vm.locations = _.keys(_.keyBy(vm.selectedMeters, function(meter) {
                    return meter.location.code;
                }));
            }

            vm.chartjs.options.scales.xAxes[0].ticks.min = -1;
            vm.chartjs.options.scales.xAxes[0].ticks.max = vm.locations.length;
            vm.chartjs.options.scales.xAxes[0].ticks.fixedStepSize = 1;

            vm.chartjs.options.scales.xAxes[0].ticks.callback = function (value) {
                if (value >= 0 && value < vm.locations.length) {
                    return vm.locations[value];
                }

                return null;
            };
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(level) {
                return _.flatten(_.map(level, function(location) {
                    return _.values(location);
                }));
            }));

            var minZscore = _.min(flatten);
            var maxZscore = _.max(flatten);

            var min = (vm.zoomToFit && minZscore != null) ? _.floor(minZscore - 0.5) : -3;
            var max = (vm.zoomToFit && maxZscore != null) ? _.ceil(maxZscore + 0.5) : 3;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = 1;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            // Secondary Axes
            vm.chartjs.options.scales.yAxes[1].ticks.min = min;
            vm.chartjs.options.scales.yAxes[1].ticks.max = max;
            vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1;
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                },
                title: function (tooltipItem, data) {
                    return vm.locations[tooltipItem[0].xLabel];
                }
            };
        }

        function annotations() {
            var annotations = [];

            // mean
            annotations.push(annotation(0, 8, {borderWidth: 2}, vm.chart.mfrMean));

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(value === 0) return vm.chart.mfrMean;
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function translate() {
            return $translate([
                'QC_REPORT_MULTIPLE.TITLE',
                'QC_REPORT_MULTIPLE.START_DATE',
                'QC_REPORT_MULTIPLE.END_DATE',
                'QC_REPORT_MULTIPLE_COMBINED.TITLE',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.METERS',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_METERS',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL1',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL2',
                'QC_REPORT_MULTIPLE_COMBINED.CHART.TITLE',
                'QC_REPORT_MULTIPLE_COMBINED.CHART.X_AXIS',
                'QC_REPORT_MULTIPLE_COMBINED.CHART.Y_AXIS',
                'QC_REPORT_MULTIPLE_COMBINED.CHART.MFR_MEAN',

                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MULTIPLE.TITLE'],
                    title: translations['QC_REPORT_MULTIPLE_COMBINED.TITLE'],
                    startDate: translations['QC_REPORT_MULTIPLE.START_DATE'],
                    endDate: translations['QC_REPORT_MULTIPLE.END_DATE'],
                    meters: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.METERS'],
                    allMeters: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1'],
                    allControlLotLevel1: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2'],
                    allControlLotLevel2: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL2']
                };

                vm.chart = {
                    title: translations['QC_REPORT_MULTIPLE_COMBINED.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MULTIPLE_COMBINED.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MULTIPLE_COMBINED.CHART.Y_AXIS'],
                    mfrMean: translations['QC_REPORT_MULTIPLE_COMBINED.CHART.MFR_MEAN']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'],
                    selectMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        $scope.$watch('vm.subFilterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.multiple.combined')
        .component('multipleCombinedGlobalAdmin', {
            templateUrl: 'app/main/qc-report/multiple/combined/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions1 = [];
        vm.controlLot1 = [];

        vm.controlSolutions2 = [];
        vm.controlLot2 = [];

        vm.zoomToFit = false;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true,
                                    zeroLineColor: 'rgba(0, 0, 0, 0)'
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'linear',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getLJChart.bind(null, true));
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            yAxes(vm.data);
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.country,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedCountry.name
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.state,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedState.name
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('ComparisonChart–Combined-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart(updateSubFilterForm) {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                if (!updateSubFilterForm) {
                    if (vm.stripLot.length) {
                        var stripLotIds = _.map(vm.stripLot, 'id');
                        params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                    }

                    var controlLot = vm.controlLot1.concat(vm.controlLot2);

                    if (controlLot.length) {
                        var controlLotIds = _.map(controlLot, 'id');
                        params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                    }
                }

                return msApi.request('reports.multiple.ljchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var testStrips = response.test_strips;
                        var controlSolutions1 = response.control_solutions1;
                        var controlSolutions2 = response.control_solutions2;
                        vm.data = response.data;

                        if (updateSubFilterForm) {
                            subFilterForm(testStrips, controlSolutions1, controlSolutions2);
                        }

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        annotations();
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function subFilterForm(testStrips, controlSolutions1, controlSolutions2) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions1 = controlSolutions1;
            vm.controlLot1 = controlSolutions1;

            vm.controlSolutions2 = controlSolutions2;
            vm.controlLot2 = controlSolutions2;
        }

        function points(data) {
            var series = [];
            var colors = [];

            for (var i = 0; i < vm.meters.length; i++) {
                colors.push({meter: vm.meters[i].serial_no, color: vm.colors[i % vm.colors.length]});
            }

            if (_.has(data, 'Level 1')) {
                for (var i = 0; i < vm.locations.length; i++) {
                    var location = vm.locations[i];
                    var meters = _.keys(data['Level 1'][location]);
                    _.map(meters, function (meter) {
                        var zscore = data['Level 1'][location][meter];
                        series.push({meter: meter, level: 1, points: [{x: i, y: zscore !== null ? zscore.toFixed(2) : null}]});
                    });
                }
            }

            if (_.has(data, 'Level 2')) {
                for (var i = 0; i < vm.locations.length; i++) {
                    var location = vm.locations[i];
                    var meters = _.keys(data['Level 2'][location]);
                    _.map(meters, function (meter) {
                        var zscore = data['Level 2'][location][meter];
                        series.push({meter: meter, level: 2, points: [{x: i, y: zscore !== null ? zscore.toFixed(2) : null}]});
                    });
                }
            }

            series = _.sortBy(series, ['meter']);

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                var pointStyle = series[i].level === 1 ? 'rect' : 'rectRot';
                var label = series[i].level === 1 ? series[i].meter + '-C1' : series[i].meter + '-C2';
                var color = _.find(colors, ['meter', series[i].meter]);
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    showLine: false,
                    backgroundColor: color.color,
                    borderColor: color.color,
                    pointBorderColor: color.color,
                    pointBackgroundColor: color.color,
                    pointHoverBackgroundColor: color.color,
                    pointHoverBorderColor: color.color,
                    label: label,
                    pointStyle: pointStyle,
                    pointBorderWidth: 2
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            var location1 = _.keys(data['Level 1']);
            var location2 = _.keys(data['Level 2']);
            vm.locations = _.merge(location1, location2);
            vm.locations = _.sortBy(vm.locations);

            // x axes for empty data
            if (vm.locations.length === 0) {
                vm.locations = _.keys(_.keyBy(vm.selectedMeters, function(meter) {
                    return meter.location.code;
                }));
            }

            vm.chartjs.options.scales.xAxes[0].ticks.min = -1;
            vm.chartjs.options.scales.xAxes[0].ticks.max = vm.locations.length;
            vm.chartjs.options.scales.xAxes[0].ticks.fixedStepSize = 1;

            vm.chartjs.options.scales.xAxes[0].ticks.callback = function (value) {
                if (value >= 0 && value < vm.locations.length) {
                    return vm.locations[value];
                }

                return null;
            };
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(level) {
                return _.flatten(_.map(level, function(location) {
                    return _.values(location);
                }));
            }));

            var minZscore = _.min(flatten);
            var maxZscore = _.max(flatten);

            var min = (vm.zoomToFit && minZscore != null) ? _.floor(minZscore - 0.5) : -3;
            var max = (vm.zoomToFit && maxZscore != null) ? _.ceil(maxZscore + 0.5) : 3;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = 1;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            // Secondary Axes
            vm.chartjs.options.scales.yAxes[1].ticks.min = min;
            vm.chartjs.options.scales.yAxes[1].ticks.max = max;
            vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1;
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                },
                title: function (tooltipItem, data) {
                    return vm.locations[tooltipItem[0].xLabel];
                }
            };
        }

        function annotations() {
            var annotations = [];

            // mean
            annotations.push(annotation(0, 8, {borderWidth: 2}, vm.chart.mfrMean));

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(value === 0) return vm.chart.mfrMean;
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function translate() {
            return $translate([
                'QC_REPORT_MULTIPLE.TITLE',
                'QC_REPORT_MULTIPLE.COUNTRY',
                'QC_REPORT_MULTIPLE.STATE',
                'QC_REPORT_MULTIPLE.HOSPITAL',
                'QC_REPORT_MULTIPLE.START_DATE',
                'QC_REPORT_MULTIPLE.END_DATE',
                'QC_REPORT_MULTIPLE_COMBINED.TITLE',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.METERS',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_METERS',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL1',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL2',
                'QC_REPORT_MULTIPLE_COMBINED.CHART.TITLE',
                'QC_REPORT_MULTIPLE_COMBINED.CHART.X_AXIS',
                'QC_REPORT_MULTIPLE_COMBINED.CHART.Y_AXIS',
                'QC_REPORT_MULTIPLE_COMBINED.CHART.MFR_MEAN',

                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MULTIPLE.TITLE'],
                    title: translations['QC_REPORT_MULTIPLE_COMBINED.TITLE'],
                    country: translations['QC_REPORT_MULTIPLE.COUNTRY'],
                    state: translations['QC_REPORT_MULTIPLE.STATE'],
                    hospital: translations['QC_REPORT_MULTIPLE.HOSPITAL'],
                    startDate: translations['QC_REPORT_MULTIPLE.START_DATE'],
                    endDate: translations['QC_REPORT_MULTIPLE.END_DATE'],
                    meters: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.METERS'],
                    allMeters: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1'],
                    allControlLotLevel1: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2'],
                    allControlLotLevel2: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL2']
                };

                vm.chart = {
                    title: translations['QC_REPORT_MULTIPLE_COMBINED.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MULTIPLE_COMBINED.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MULTIPLE_COMBINED.CHART.Y_AXIS'],
                    mfrMean: translations['QC_REPORT_MULTIPLE_COMBINED.CHART.MFR_MEAN']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.multiple.combined')
        .component('multipleCombinedCountryAdmin', {
            templateUrl: 'app/main/qc-report/multiple/combined/country-admin/country-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions1 = [];
        vm.controlLot1 = [];

        vm.controlSolutions2 = [];
        vm.controlLot2 = [];

        vm.zoomToFit = false;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true,
                                    zeroLineColor: 'rgba(0, 0, 0, 0)'
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'linear',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getLJChart.bind(null, true));
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            yAxes(vm.data);
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.state,
                                    style: 'small'
                                },
                                {
                                    text:  vm.selectedState.name,
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name,
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('ComparisonChart–Combined-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart(updateSubFilterForm) {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                if (!updateSubFilterForm) {
                    if (vm.stripLot.length) {
                        var stripLotIds = _.map(vm.stripLot, 'id');
                        params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                    }

                    var controlLot = vm.controlLot1.concat(vm.controlLot2);

                    if (controlLot.length) {
                        var controlLotIds = _.map(controlLot, 'id');
                        params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                    }
                }

                return msApi.request('reports.multiple.ljchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        var testStrips = response.test_strips;
                        var controlSolutions1 = response.control_solutions1;
                        var controlSolutions2 = response.control_solutions2;
                        vm.data = response.data;

                        if (updateSubFilterForm) {
                            subFilterForm(testStrips, controlSolutions1, controlSolutions2);
                        }

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        annotations();
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function subFilterForm(testStrips, controlSolutions1, controlSolutions2) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions1 = controlSolutions1;
            vm.controlLot1 = controlSolutions1;

            vm.controlSolutions2 = controlSolutions2;
            vm.controlLot2 = controlSolutions2;
        }

        function points(data) {
            var series = [];
            var colors = [];

            for (var i = 0; i < vm.meters.length; i++) {
                colors.push({meter: vm.meters[i].serial_no, color: vm.colors[i % vm.colors.length]});
            }

            if (_.has(data, 'Level 1')) {
                for (var i = 0; i < vm.locations.length; i++) {
                    var location = vm.locations[i];
                    var meters = _.keys(data['Level 1'][location]);
                    _.map(meters, function (meter) {
                        var zscore = data['Level 1'][location][meter];
                        series.push({meter: meter, level: 1, points: [{x: i, y: zscore !== null ? zscore.toFixed(2) : null}]});
                    });
                }
            }

            if (_.has(data, 'Level 2')) {
                for (var i = 0; i < vm.locations.length; i++) {
                    var location = vm.locations[i];
                    var meters = _.keys(data['Level 2'][location]);
                    _.map(meters, function (meter) {
                        var zscore = data['Level 2'][location][meter];
                        series.push({meter: meter, level: 2, points: [{x: i, y: zscore !== null ? zscore.toFixed(2) : null}]});
                    });
                }
            }

            series = _.sortBy(series, ['meter']);

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                var pointStyle = series[i].level === 1 ? 'rect' : 'rectRot';
                var label = series[i].level === 1 ? series[i].meter + '-C1' : series[i].meter + '-C2';
                var color = _.find(colors, ['meter', series[i].meter]);
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    showLine: false,
                    backgroundColor: color.color,
                    borderColor: color.color,
                    pointBorderColor: color.color,
                    pointBackgroundColor: color.color,
                    pointHoverBackgroundColor: color.color,
                    pointHoverBorderColor: color.color,
                    label: label,
                    pointStyle: pointStyle,
                    pointBorderWidth: 2
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            var location1 = _.keys(data['Level 1']);
            var location2 = _.keys(data['Level 2']);
            vm.locations = _.merge(location1, location2);
            vm.locations = _.sortBy(vm.locations);

            // x axes for empty data
            if (vm.locations.length === 0) {
                vm.locations = _.keys(_.keyBy(vm.selectedMeters, function(meter) {
                    return meter.location.code;
                }));
            }

            vm.chartjs.options.scales.xAxes[0].ticks.min = -1;
            vm.chartjs.options.scales.xAxes[0].ticks.max = vm.locations.length;
            vm.chartjs.options.scales.xAxes[0].ticks.fixedStepSize = 1;

            vm.chartjs.options.scales.xAxes[0].ticks.callback = function (value) {
                if (value >= 0 && value < vm.locations.length) {
                    return vm.locations[value];
                }

                return null;
            };
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(level) {
                return _.flatten(_.map(level, function(location) {
                    return _.values(location);
                }));
            }));

            var minZscore = _.min(flatten);
            var maxZscore = _.max(flatten);

            var min = (vm.zoomToFit && minZscore != null) ? _.floor(minZscore - 0.5) : -3;
            var max = (vm.zoomToFit && maxZscore != null) ? _.ceil(maxZscore + 0.5) : 3;

            vm.chartjs.options.scales.yAxes[0].ticks.min = min;
            vm.chartjs.options.scales.yAxes[0].ticks.max = max;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = 1;
            vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis;

            // Secondary Axes
            vm.chartjs.options.scales.yAxes[1].ticks.min = min;
            vm.chartjs.options.scales.yAxes[1].ticks.max = max;
            vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1;
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                },
                title: function (tooltipItem, data) {
                    return vm.locations[tooltipItem[0].xLabel];
                }
            };
        }

        function annotations() {
            var annotations = [];

            // mean
            annotations.push(annotation(0, 8, {borderWidth: 2}, vm.chart.mfrMean));

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(value === 0) return vm.chart.mfrMean;
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function translate() {
            return $translate([
                'QC_REPORT_MULTIPLE.TITLE',
                'QC_REPORT_MULTIPLE.COUNTRY',
                'QC_REPORT_MULTIPLE.STATE',
                'QC_REPORT_MULTIPLE.HOSPITAL',
                'QC_REPORT_MULTIPLE.START_DATE',
                'QC_REPORT_MULTIPLE.END_DATE',
                'QC_REPORT_MULTIPLE_COMBINED.TITLE',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.METERS',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_METERS',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.STRIP_LOT',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL1',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2',
                'QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL2',
                'QC_REPORT_MULTIPLE_COMBINED.CHART.TITLE',
                'QC_REPORT_MULTIPLE_COMBINED.CHART.X_AXIS',
                'QC_REPORT_MULTIPLE_COMBINED.CHART.Y_AXIS',
                'QC_REPORT_MULTIPLE_COMBINED.CHART.MFR_MEAN',

                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MULTIPLE.TITLE'],
                    title: translations['QC_REPORT_MULTIPLE_COMBINED.TITLE'],
                    country: translations['QC_REPORT_MULTIPLE.COUNTRY'],
                    state: translations['QC_REPORT_MULTIPLE.STATE'],
                    hospital: translations['QC_REPORT_MULTIPLE.HOSPITAL'],
                    startDate: translations['QC_REPORT_MULTIPLE.START_DATE'],
                    endDate: translations['QC_REPORT_MULTIPLE.END_DATE'],
                    meters: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.METERS'],
                    allMeters: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_METERS'],
                    stripLot: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1'],
                    allControlLotLevel1: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2'],
                    allControlLotLevel2: translations['QC_REPORT_MULTIPLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL2']
                };

                vm.chart = {
                    title: translations['QC_REPORT_MULTIPLE_COMBINED.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MULTIPLE_COMBINED.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MULTIPLE_COMBINED.CHART.Y_AXIS'],
                    mfrMean: translations['QC_REPORT_MULTIPLE_COMBINED.CHART.MFR_MEAN']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_MULTIPLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_MULTIPLE.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.single.level2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-single-level2', {
                url    : '/qc-report-single-level2',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/single/level2/level2.html',
                        controller : 'SingleLevel2Controller as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin', 'hospital_operator']
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/single/level2');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.single.ljchart', ['/reports/single/ljchart']);

        msNavigationServiceProvider.saveItem('qc-report-single.level2', {
            title : 'L-J Chart – Level 2',
            state: 'app.qc-report-single-level2',
            weight: 15,
            translate: "QC_REPORT_SINGLE_LEVEL2.NAV"
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.qc-report.single.level2')
        .component('singleLevel2GlobalAdmin', {
            templateUrl: 'app/main/qc-report/single/level2/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 2';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#66bb6a",
                        borderColor: "#66bb6a",
                        pointBorderColor: "#66bb6a",
                        pointBackgroundColor: "#66bb6a",
                        pointHoverBackgroundColor: "#66bb6a",
                        pointHoverBorderColor: "#66bb6a",
                        showLine: true
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left:16
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: false,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        bodySpacing: 4,
                        displayColors: false
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.meter = null;
            meterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.meter && vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.country,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedCountry.name
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.state,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedState.name
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Level2-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data, vm.user.preferred_measurement_unit);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                level: vm.level,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                if (vm.controlLot.length) {
                    var controlLotIds = _.map(vm.controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions = response.control_solutions;
                    vm.mean = response.mean;
                    vm.stdev = response.stdev;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data, vm.user.preferred_measurement_unit);
                    points(vm.data);
                    tooltips(vm.data, vm.user.preferred_measurement_unit);
                    annotations(vm.mean, vm.stdev, vm.user.preferred_measurement_unit);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var points = _.map(data, function(test) {
                if (test.meter_reading !== null) {
                    return {x: moment(test.tested_on), y: formatMeasurement(parseFloat(test.meter_reading), test.measurement_unit)};
                }
            });

            vm.chartjs.datasetOverride[0].label = vm.level;
            vm.chartjs.data = [points];
        }

        function xAxes(tests) {
            var minTest = _.minBy(tests, 'tested_on');
            var maxTest = _.maxBy(tests, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests, measurementUnit) {
            var minTest = _.minBy(tests, 'meter_reading');
            var maxTest = _.maxBy(tests, 'meter_reading');

            if (measurementUnit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 0.5 : 14.0;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 0.5 : 19.0;
                var stepSize = (min + max) / 2;
                // Primary axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.01;
            } else {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 9 : 252;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 9 : 342;
                var stepSize = (min + max) / 2;

                // Primary Axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.01;
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatMeasurement(parseFloat(value), measurementUnit);
            };
        }

        function tooltips(tests, measurementUnit) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return [
                        vm.tooltips.reading + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[measurementUnit],
                        vm.tooltips.stripLot + ' ' + tests[tooltipItem.index].test_strip.lot_no,
                        vm.tooltips.controlLot + ' ' + tests[tooltipItem.index].control_solution.lot_no
                    ];
                }
            };
        }

        function annotations(mean, stdev, measurementUnit) {
            var annotations = [];
            var m = null;
            var sd1 = null;
            var _sd1 = null;
            var sd2 = null;
            var _sd2 = null;
            var sd3 = null;
            var _sd3 = null;

            // mean
            if (mean) {
                m = formatMeasurement(mean, measurementUnit);
                annotations.push(annotation(m, 8, {borderWidth: 2}, vm.annotations.mean + ' (' + m + ')'));
            }

            if (stdev) {
                sd1 = formatMeasurement(mean + stdev, measurementUnit);
                _sd1 = formatMeasurement(mean - stdev, measurementUnit);
                sd2 = formatMeasurement(mean + stdev * 2, measurementUnit);
                _sd2 = formatMeasurement (mean - stdev * 2, measurementUnit);
                sd3 = formatMeasurement(mean + stdev * 3, measurementUnit);
                _sd3 = formatMeasurement(mean - stdev * 3, measurementUnit);
                annotations.push(annotation(sd1, 8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, '+1' + vm.annotations.sd + ' (' + sd1 + ')'));
                annotations.push(annotation(_sd1, -8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, '-1' + vm.annotations.sd + ' (' + _sd1 + ')'));
                annotations.push(annotation(sd2, 8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, '+2' + vm.annotations.sd + ' (' + sd2 + ')'));
                annotations.push(annotation(_sd2, -8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, '-2' + vm.annotations.sd + ' (' + _sd2 + ')'));
                annotations.push(annotation(sd3, 8, {borderWidth: 1}, '+3' + vm.annotations.sd + ' (' + sd3 + ')'));
                annotations.push(annotation(_sd3, -8, {borderWidth: 1}, '-3' + vm.annotations.sd + ' (' + _sd3 + ')'));
            }

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(m && value == m) return vm.annotations.mean + ' (' + m + ')';
                if(sd1 && value == sd1) return '+1' + vm.annotations.sd + ' (' + sd1 + ')';
                if(_sd1 && value == _sd1) return '-1' + vm.annotations.sd + ' (' + _sd1 + ')';
                if(sd2 && value == sd2) return '+2' + vm.annotations.sd + ' (' + sd2 + ')';
                if(_sd2 && value == _sd2) return '-2' + vm.annotations.sd + ' (' + _sd2 + ')';
                if(sd2 && value == sd3) return '+3' + vm.annotations.sd + ' (' + sd3 + ')';
                if(_sd2 && value == _sd3) return '-3' + vm.annotations.sd + ' (' + _sd3 + ')';
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function formatMeasurement(value, measurementUnit) {
          if (measurementUnit == 'MMOL_PER_L') {
            return value.toFixed(1);
          }
          else if (measurementUnit == 'MG_PER_DL') {
            return value.toFixed(0);
          }

          return value;
        }

        function translate() {
            return $translate([
                'QC_REPORT_SINGLE.TITLE',
                'QC_REPORT_SINGLE.COUNTRY',
                'QC_REPORT_SINGLE.STATE',
                'QC_REPORT_SINGLE.HOSPITAL',
                'QC_REPORT_SINGLE.START_DATE',
                'QC_REPORT_SINGLE.END_DATE',
                'QC_REPORT_SINGLE.METER_SERIAL_NO',
                'QC_REPORT_SINGLE_LEVEL2.TITLE',
                'QC_REPORT_SINGLE_LEVEL2.FILTERS.STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL2.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL2.FILTERS.CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL2.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL2.CHART.TITLE',
                'QC_REPORT_SINGLE_LEVEL2.CHART.X_AXIS',
                'QC_REPORT_SINGLE_LEVEL2.CHART.Y_AXIS',
                'QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.READING',
                'QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL2.CHART.ANNOTATION.MEAN',
                'QC_REPORT_SINGLE_LEVEL2.CHART.ANNOTATION.SD',

                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN',
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_SINGLE.TITLE'],
                    title: translations['QC_REPORT_SINGLE_LEVEL2.TITLE'],
                    country: translations['QC_REPORT_SINGLE.COUNTRY'],
                    state: translations['QC_REPORT_SINGLE.STATE'],
                    hospital: translations['QC_REPORT_SINGLE.HOSPITAL'],
                    startDate: translations['QC_REPORT_SINGLE.START_DATE'],
                    endDate: translations['QC_REPORT_SINGLE.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_SINGLE.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.ALL_CONTROL_LOT'],
                };

                vm.chart = {
                    title: translations['QC_REPORT_SINGLE_LEVEL2.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_SINGLE_LEVEL2.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_SINGLE_LEVEL2.CHART.Y_AXIS']
                };

                vm.tooltips = {
                    reading: translations['QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.READING'],
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.annotations = {
                    mean: translations['QC_REPORT_SINGLE_LEVEL2.CHART.ANNOTATION.MEAN'],
                    sd: translations['QC_REPORT_SINGLE_LEVEL2.CHART.ANNOTATION.SD']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.single.level2')
        .component('singleLevel2HospitalAdmin', {
            templateUrl: 'app/main/qc-report/single/level2/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, localStorageService, $mdSelect, $filter, CONFIG, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 2';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.meterColumns = [];
        vm.meters = [];
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.stripLotChanged = stripLotChanged;
        vm.controlLotChanged = controlLotChanged;
        vm.getStripLotText = getStripLotText;
        vm.getControlLotText = getControlLotText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#66bb6a",
                        borderColor: "#66bb6a",
                        pointBorderColor: "#66bb6a",
                        pointBackgroundColor: "#66bb6a",
                        pointHoverBackgroundColor: "#66bb6a",
                        pointHoverBorderColor: "#66bb6a",
                        showLine: true
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left:16
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: false,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        bodySpacing: 4,
                        displayColors: false
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            getMeters();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function stripLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function controlLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function getStripLotText() {
            var limit = 50;
            if (vm.stripLot && vm.stripLot.length) {
                if (vm.stripLot.length === vm.testStrips.length) {
                    return vm.filters.allStripLot;
                }
                var joined =  _.join(_.map(vm.stripLot, 'lot_no'), ', ');

                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
            } else {
                return vm.filters.stripLot;
            }
        }

        function getControlLotText() {
            var limit = 50;
            if (vm.controlLot && vm.controlLot.length) {
                if (vm.controlLot.length === vm.controlSolutions.length) {
                    return vm.filters.allControlLot;
                }
                var joined = _.join(_.map(vm.controlLot, 'lot_no'), ', ');

                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
            } else {
                return vm.filters.controlLot;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.stripLot,
                                    style: 'small'
                                },
                                {
                                    text: getStripLotText(),
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.controlLot,
                                    style: 'small'
                                },
                                {
                                    text: getControlLotText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 20]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Level2-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data, vm.user.preferred_measurement_unit);
        }

        function getMeters() {
            var locationIds = _.map(vm.user.locations, 'id');
            var params = {
                hospital_id: vm.user.hospitals[0].id,
                'location_ids[]': locationIds
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                level: vm.level,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                if (vm.controlLot.length) {
                    var controlLotIds = _.map(vm.controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions = response.control_solutions;
                    vm.mean = response.mean;
                    vm.stdev = response.stdev;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data, vm.user.preferred_measurement_unit);
                    points(vm.data);
                    tooltips(vm.data, vm.user.preferred_measurement_unit);
                    annotations(vm.mean, vm.stdev, vm.user.preferred_measurement_unit);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var points = _.map(data, function(test) {
                if (test.meter_reading !== null) {
                    return {x: moment(test.tested_on), y: formatMeasurement(parseFloat(test.meter_reading), test.measurement_unit)};
                }
            });

            vm.chartjs.datasetOverride[0].label = vm.level;
            vm.chartjs.data = [points];
        }

        function xAxes(tests) {
            var minTest = _.minBy(tests, 'tested_on');
            var maxTest = _.maxBy(tests, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests, measurementUnit) {
            var minTest = _.minBy(tests, 'meter_reading');
            var maxTest = _.maxBy(tests, 'meter_reading');

            if (measurementUnit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 0.5 : 14.0;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 0.5 : 19.0;
                var stepSize = (min + max) / 2;
                // Primary axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.01;
            } else {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 9 : 252;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 9 : 342;
                var stepSize = (min + max) / 2;

                // Primary Axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.01;
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatMeasurement(parseFloat(value), measurementUnit);
            };
        }

        function tooltips(tests, measurementUnit) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return [
                        vm.tooltips.reading + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[measurementUnit],
                        vm.tooltips.stripLot + ' ' + tests[tooltipItem.index].test_strip.lot_no,
                        vm.tooltips.controlLot + ' ' + tests[tooltipItem.index].control_solution.lot_no
                    ];
                }
            };
        }

        function annotations(mean, stdev, measurementUnit) {
            var annotations = [];
            var m = null;
            var sd1 = null;
            var _sd1 = null;
            var sd2 = null;
            var _sd2 = null;
            var sd3 = null;
            var _sd3 = null;

            // mean
            if (mean) {
                m = formatMeasurement(mean, measurementUnit);
                annotations.push(annotation(m, 8, {borderWidth: 2}, vm.annotations.mean + ' (' + m + ')'));
            }

            if (stdev) {
                sd1 = formatMeasurement(mean + stdev, measurementUnit);
                _sd1 = formatMeasurement(mean - stdev, measurementUnit);
                sd2 = formatMeasurement(mean + stdev * 2, measurementUnit);
                _sd2 = formatMeasurement (mean - stdev * 2, measurementUnit);
                sd3 = formatMeasurement(mean + stdev * 3, measurementUnit);
                _sd3 = formatMeasurement(mean - stdev * 3, measurementUnit);
                annotations.push(annotation(sd1, 8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, '+1' + vm.annotations.sd + ' (' + sd1 + ')'));
                annotations.push(annotation(_sd1, -8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, '-1' + vm.annotations.sd + ' (' + _sd1 + ')'));
                annotations.push(annotation(sd2, 8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, '+2' + vm.annotations.sd + ' (' + sd2 + ')'));
                annotations.push(annotation(_sd2, -8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, '-2' + vm.annotations.sd + ' (' + _sd2 + ')'));
                annotations.push(annotation(sd3, 8, {borderWidth: 1}, '+3' + vm.annotations.sd + ' (' + sd3 + ')'));
                annotations.push(annotation(_sd3, -8, {borderWidth: 1}, '-3' + vm.annotations.sd + ' (' + _sd3 + ')'));
            }

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(m && value == m) return vm.annotations.mean + ' (' + m + ')';
                if(sd1 && value == sd1) return '+1' + vm.annotations.sd + ' (' + sd1 + ')';
                if(_sd1 && value == _sd1) return '-1' + vm.annotations.sd + ' (' + _sd1 + ')';
                if(sd2 && value == sd2) return '+2' + vm.annotations.sd + ' (' + sd2 + ')';
                if(_sd2 && value == _sd2) return '-2' + vm.annotations.sd + ' (' + _sd2 + ')';
                if(sd2 && value == sd3) return '+3' + vm.annotations.sd + ' (' + sd3 + ')';
                if(_sd2 && value == _sd3) return '-3' + vm.annotations.sd + ' (' + _sd3 + ')';
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function formatMeasurement(value, measurementUnit) {
          if (measurementUnit == 'MMOL_PER_L') {
            return value.toFixed(1);
          }
          else if (measurementUnit == 'MG_PER_DL') {
            return value.toFixed(0);
          }

          return value;
        }

        function translate() {
            return $translate([
                'QC_REPORT_SINGLE.TITLE',
                'QC_REPORT_SINGLE.START_DATE',
                'QC_REPORT_SINGLE.END_DATE',
                'QC_REPORT_SINGLE.METER_SERIAL_NO',
                'QC_REPORT_SINGLE_LEVEL2.TITLE',
                'QC_REPORT_SINGLE_LEVEL2.FILTERS.STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL2.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL2.FILTERS.CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL2.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL2.CHART.TITLE',
                'QC_REPORT_SINGLE_LEVEL2.CHART.X_AXIS',
                'QC_REPORT_SINGLE_LEVEL2.CHART.Y_AXIS',
                'QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.READING',
                'QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL2.CHART.ANNOTATION.MEAN',
                'QC_REPORT_SINGLE_LEVEL2.CHART.ANNOTATION.SD',

                'QC_REPORT_SINGLE.MESSAGES.SELECT_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_SINGLE.TITLE'],
                    title: translations['QC_REPORT_SINGLE_LEVEL2.TITLE'],
                    startDate: translations['QC_REPORT_SINGLE.START_DATE'],
                    endDate: translations['QC_REPORT_SINGLE.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_SINGLE.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.ALL_CONTROL_LOT'],
                };

                vm.chart = {
                    title: translations['QC_REPORT_SINGLE_LEVEL2.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_SINGLE_LEVEL2.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_SINGLE_LEVEL2.CHART.Y_AXIS']
                };

                vm.tooltips = {
                    reading: translations['QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.READING'],
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.annotations = {
                    mean: translations['QC_REPORT_SINGLE_LEVEL2.CHART.ANNOTATION.MEAN'],
                    sd: translations['QC_REPORT_SINGLE_LEVEL2.CHART.ANNOTATION.SD']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'],
                    selectMeter: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_METER']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        $scope.$watch('vm.subFilterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.single.level2')
        .component('singleLevel2CountryAdmin', {
            templateUrl: 'app/main/qc-report/single/level2/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 2';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#66bb6a",
                        borderColor: "#66bb6a",
                        pointBorderColor: "#66bb6a",
                        pointBackgroundColor: "#66bb6a",
                        pointHoverBackgroundColor: "#66bb6a",
                        pointHoverBorderColor: "#66bb6a",
                        showLine: true
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left:16
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: false,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        bodySpacing: 4,
                        displayColors: false
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.meter = null;
            meterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.meter && vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.state,
                                    style: 'small'
                                },
                                {
                                    text:  vm.selectedState.name,
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name,
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Level2-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data, vm.user.preferred_measurement_unit);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                level: vm.level,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                if (vm.controlLot.length) {
                    var controlLotIds = _.map(vm.controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions = response.control_solutions;
                    vm.mean = response.mean;
                    vm.stdev = response.stdev;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data, vm.user.preferred_measurement_unit);
                    points(vm.data);
                    tooltips(vm.data, vm.user.preferred_measurement_unit);
                    annotations(vm.mean, vm.stdev, vm.user.preferred_measurement_unit);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var points = _.map(data, function(test) {
                if (test.meter_reading !== null) {
                    return {x: moment(test.tested_on), y: formatMeasurement(parseFloat(test.meter_reading), test.measurement_unit)};
                }
            });

            vm.chartjs.datasetOverride[0].label = vm.level;
            vm.chartjs.data = [points];
        }

        function xAxes(tests) {
            var minTest = _.minBy(tests, 'tested_on');
            var maxTest = _.maxBy(tests, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests, measurementUnit) {
            var minTest = _.minBy(tests, 'meter_reading');
            var maxTest = _.maxBy(tests, 'meter_reading');

            if (measurementUnit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 0.5 : 14.0;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 0.5 : 19.0;
                var stepSize = (min + max) / 2;
                // Primary axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.01;
            } else {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 9 : 252;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 9 : 342;
                var stepSize = (min + max) / 2;

                // Primary Axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.01;
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatMeasurement(parseFloat(value), measurementUnit);
            };
        }

        function tooltips(tests, measurementUnit) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return [
                        vm.tooltips.reading + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[measurementUnit],
                        vm.tooltips.stripLot + ' ' + tests[tooltipItem.index].test_strip.lot_no,
                        vm.tooltips.controlLot + ' ' + tests[tooltipItem.index].control_solution.lot_no
                    ];
                }
            };
        }

        function annotations(mean, stdev, measurementUnit) {
            var annotations = [];
            var m = null;
            var sd1 = null;
            var _sd1 = null;
            var sd2 = null;
            var _sd2 = null;
            var sd3 = null;
            var _sd3 = null;

            // mean
            if (mean) {
                m = formatMeasurement(mean, measurementUnit);
                annotations.push(annotation(m, 8, {borderWidth: 2}, vm.annotations.mean + ' (' + m + ')'));
            }

            if (stdev) {
                sd1 = formatMeasurement(mean + stdev, measurementUnit);
                _sd1 = formatMeasurement(mean - stdev, measurementUnit);
                sd2 = formatMeasurement(mean + stdev * 2, measurementUnit);
                _sd2 = formatMeasurement (mean - stdev * 2, measurementUnit);
                sd3 = formatMeasurement(mean + stdev * 3, measurementUnit);
                _sd3 = formatMeasurement(mean - stdev * 3, measurementUnit);
                annotations.push(annotation(sd1, 8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, '+1' + vm.annotations.sd + ' (' + sd1 + ')'));
                annotations.push(annotation(_sd1, -8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, '-1' + vm.annotations.sd + ' (' + _sd1 + ')'));
                annotations.push(annotation(sd2, 8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, '+2' + vm.annotations.sd + ' (' + sd2 + ')'));
                annotations.push(annotation(_sd2, -8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, '-2' + vm.annotations.sd + ' (' + _sd2 + ')'));
                annotations.push(annotation(sd3, 8, {borderWidth: 1}, '+3' + vm.annotations.sd + ' (' + sd3 + ')'));
                annotations.push(annotation(_sd3, -8, {borderWidth: 1}, '-3' + vm.annotations.sd + ' (' + _sd3 + ')'));
            }

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(m && value == m) return vm.annotations.mean + ' (' + m + ')';
                if(sd1 && value == sd1) return '+1' + vm.annotations.sd + ' (' + sd1 + ')';
                if(_sd1 && value == _sd1) return '-1' + vm.annotations.sd + ' (' + _sd1 + ')';
                if(sd2 && value == sd2) return '+2' + vm.annotations.sd + ' (' + sd2 + ')';
                if(_sd2 && value == _sd2) return '-2' + vm.annotations.sd + ' (' + _sd2 + ')';
                if(sd2 && value == sd3) return '+3' + vm.annotations.sd + ' (' + sd3 + ')';
                if(_sd2 && value == _sd3) return '-3' + vm.annotations.sd + ' (' + _sd3 + ')';
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function formatMeasurement(value, measurementUnit) {
          if (measurementUnit == 'MMOL_PER_L') {
            return value.toFixed(1);
          }
          else if (measurementUnit == 'MG_PER_DL') {
            return value.toFixed(0);
          }

          return value;
        }

        function translate() {
            return $translate([
                'QC_REPORT_SINGLE.TITLE',
                'QC_REPORT_SINGLE.COUNTRY',
                'QC_REPORT_SINGLE.STATE',
                'QC_REPORT_SINGLE.HOSPITAL',
                'QC_REPORT_SINGLE.START_DATE',
                'QC_REPORT_SINGLE.END_DATE',
                'QC_REPORT_SINGLE.METER_SERIAL_NO',
                'QC_REPORT_SINGLE_LEVEL2.TITLE',
                'QC_REPORT_SINGLE_LEVEL2.FILTERS.STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL2.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL2.FILTERS.CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL2.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL2.CHART.TITLE',
                'QC_REPORT_SINGLE_LEVEL2.CHART.X_AXIS',
                'QC_REPORT_SINGLE_LEVEL2.CHART.Y_AXIS',
                'QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.READING',
                'QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL2.CHART.ANNOTATION.MEAN',
                'QC_REPORT_SINGLE_LEVEL2.CHART.ANNOTATION.SD',

                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN',
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_SINGLE.TITLE'],
                    title: translations['QC_REPORT_SINGLE_LEVEL2.TITLE'],
                    country: translations['QC_REPORT_SINGLE.COUNTRY'],
                    state: translations['QC_REPORT_SINGLE.STATE'],
                    hospital: translations['QC_REPORT_SINGLE.HOSPITAL'],
                    startDate: translations['QC_REPORT_SINGLE.START_DATE'],
                    endDate: translations['QC_REPORT_SINGLE.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_SINGLE.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_SINGLE_LEVEL2.FILTERS.ALL_CONTROL_LOT'],
                };

                vm.chart = {
                    title: translations['QC_REPORT_SINGLE_LEVEL2.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_SINGLE_LEVEL2.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_SINGLE_LEVEL2.CHART.Y_AXIS']
                };

                vm.tooltips = {
                    reading: translations['QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.READING'],
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL2.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.annotations = {
                    mean: translations['QC_REPORT_SINGLE_LEVEL2.CHART.ANNOTATION.MEAN'],
                    sd: translations['QC_REPORT_SINGLE_LEVEL2.CHART.ANNOTATION.SD']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.single.logbook', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-single-logbook', {
                url    : '/qc-report-single-logbook',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/single/logbook/logbook.html',
                        controller : 'SingleLogbookController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin', 'hospital_operator']
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/single/logbook');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('users', ['/users']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.single.qclogbook', ['/reports/single/qclogbook']);
        msApiProvider.register('reports.single.overall', ['/reports/single/overall']);
        msApiProvider.register('quality_control_tests.tag_operator', ['/quality_control_tests/tag_operator']);
        msApiProvider.register('quality_control_tests.untag_operator', ['/quality_control_tests/untag_operator']);
        msApiProvider.register('quality_control_tests.edit', ['/quality_control_tests/:id', {id: '@id'}, {
            update: { method:'PUT'}
        }]);
        msApiProvider.register('quality_control_tests.remove', ['/quality_control_tests/:id', {id: '@id'}, {
            delete: { method:'DELETE'}
        }]);
        msApiProvider.register('reports.single.qclogbook.export', ['/reports/single/qclogbook/export', {}, {
            download: {method: 'GET', responseType: 'arraybuffer', transformResponse: function(data, headersGetter) {
                // Stores the ArrayBuffer object in a property called "data"
                return { data : data };
            }}
        }]);

        msNavigationServiceProvider.saveItem('qc-report-single.logbook', {
            title : 'QC Logbook',
            state: 'app.qc-report-single-logbook',
            weight: 17,
            translate: 'QC_REPORT_SINGLE_LOGBOOK.NAV'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.single.logbook')
        .component('singleLogbookHospitalAdmin', {
            templateUrl: 'app/main/qc-report/single/logbook/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, $mdDialog, $document, localStorageService, $mdSelect, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.pagination = {
            total:0,
            per_page: 10,
            current_page: 1
        };
        vm.sort = "tested_on";

        vm.meterColumns = [];
        vm.meters = [];
        vm.meter = null;
        vm.searchTerm = '';

        vm.overall = null;
        vm.qclogbook = [];

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions1 = [];
        vm.controlLot1 = [];

        vm.controlSolutions2 = [];
        vm.controlLot2 = [];

        vm.isReadOnly = false;
        vm.hasManualQcData = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.stripLotChanged = stripLotChanged;
        vm.controlLot1Changed = controlLot1Changed;
        vm.controlLot2Changed = controlLot2Changed;
        vm.close = close;
        vm.getStripLotText = getStripLotText;
        vm.getControlLot1Text = getControlLot1Text;
        vm.getControlLot2Text = getControlLot2Text;
        vm.getQCLogbook = getQCLogbook;
        vm.editQcData = editQcData;
        vm.changeOperator = changeOperator;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.scanQcLogForManualData = scanQcLogForManualData;
        vm.evalMeterReading = evalMeterReading;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.isReadOnly = vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            getMeters();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getOverall(false, true)
                    .then(getQCLogbook);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getOverall(false, true)
                    .then(getQCLogbook);
            }
        }

        function meterChanged() {
            if(vm.filterForm.$valid) {
                getOverall(false, true)
                    .then(getQCLogbook);
            }
        }

        function stripLotChanged() {
            if(vm.subFilterForm.$valid) {
                getOverall(true, false)
                    .then(getQCLogbook);
            }

            close();
        }

        function controlLot1Changed() {
            if(vm.subFilterForm.$valid) {
                getOverall(true, false)
                    .then(getQCLogbook);
            }

            close();
        }

        function controlLot2Changed() {
            if(vm.subFilterForm.$valid) {
                getOverall(true, false)
                    .then(getQCLogbook);
            }

            close();
        }

        function getStripLotText() {
            var limit = 30;
            if (vm.stripLot && vm.stripLot.length) {
                if (vm.stripLot.length === vm.testStrips.length) {
                    return vm.filters.allStripLot;
                }

                var joined =  _.join(_.map(vm.stripLot, 'lot_no'), ', ');
                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');

            } else {
                return vm.filters.stripLot;
            }
        }

        function getControlLot1Text() {
            var limit = 30;
            if (vm.controlLot1 && vm.controlLot1.length) {
                if (vm.controlLot1.length === vm.controlSolutions1.length) {
                    return vm.filters.allControlLotLevel1;
                }

                var joined = _.join(_.map(vm.controlLot1, 'lot_no'), ',');
                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');

            } else {
                return vm.filters.controlLotLevel1;
            }
        }

        function getControlLot2Text() {
            var limit = 30;
            if (vm.controlLot2 && vm.controlLot2.length) {
                if (vm.controlLot2.length === vm.controlSolutions2.length) {
                    return vm.filters.allControlLotLevel2;
                }

                var joined = _.join(_.map(vm.controlLot2, 'lot_no'), ',');
                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');

            } else {
                return vm.filters.controlLotLevel2;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToCSV() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            var stripLotIds = _.map(vm.stripLot, 'id');
            params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);

            var controlLot = vm.controlLot1.concat(vm.controlLot2);

            var controlLotIds = _.map(controlLot, 'id');
            params = angular.merge({'control_lot_ids[]': controlLotIds}, params);

            msApi.request('reports.single.qclogbook@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge,
                        f: '',
                        g: ''
                    });

                    data.push({
                        a: vm.meter.serial_no,
                        b: vm.meter.model_no,
                        c: vm.meter.location.hospital.name,
                        d: vm.meter.location.code,
                        e: vm.meter.location.person_in_charge,
                        f: '',
                        g: ''
                    });

                    data.push({a: '', b: '', c: '', d: '', e: '', f: '', g: ''});

                    data.push({a: vm.overallSection.title, b: 'Level 1', c: 'Level 2', d: '', e: '', f: '', g: ''});
                    data.push({a: vm.overallSection.noOfTests, b:  _.has(vm.overall, 'Level 1') ? vm.overall['Level 1'].number_of_tests : 0, c:  _.has(vm.overall, 'Level 2') ? vm.overall['Level 2'].number_of_tests : 0, d: '', e: '', f: '', g: ''});
                    data.push({a: vm.overallSection.mean + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')', b: _.has(vm.overall, 'Level 1') ? parseFloat(vm.overall['Level 1'].mean).toFixed(2) : '', c: _.has(vm.overall, 'Level 2') ? parseFloat(vm.overall['Level 2'].mean).toFixed(2) : '', d: '', e: '', f: '', g: ''});
                    data.push({a: vm.overallSection.sd  + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')', b: (_.has(vm.overall, 'Level 1') && vm.overall['Level 1'].stdev != null) ? parseFloat(vm.overall['Level 1'].stdev).toFixed(2) : '', c: (_.has(vm.overall, 'Level 2') && vm.overall['Level 2'].stdev != null) ? parseFloat(vm.overall['Level 2'].stdev).toFixed(2) : '', d: '', e: '', f: '', g: ''});
                    data.push({a: vm.overallSection.cv, b: (_.has(vm.overall, 'Level 1') && vm.overall['Level 1'].cv != null) ? parseFloat(vm.overall['Level 1'].cv).toFixed(2) + '*' : '', c: (_.has(vm.overall, 'Level 2') && vm.overall['Level 2'].cv != null) ? parseFloat(vm.overall['Level 2'].cv).toFixed(2) : '', d: '', e: '', f: '', g: ''});
                    data.push({a: vm.overallSection.ps, b:'', c: '', d: '', e: '', f: '', g: ''});

                    data.push({a: '', b: '', c: '', d: '', e: '', f: '', g: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.stripLot,
                        c: vm.columns.controlType,
                        d: vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        e: vm.columns.qcValue + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        f: vm.columns.status,
                        g: vm.columns.operatorInitials
                    });

                    var qclogbook = response.qclogbook;

                    _.map(qclogbook, function (log) {
                        data.push({
                            a: moment(log.tested_on).format(),
                            b: log.test_strip.lot_no,
                            c: log.control_level,
                            d: parseFloat(log.from).toFixed(1) + ' ' + vm.misc.to + ' ' + parseFloat(log.to).toFixed(1),
                            e: log.source == 'manual' ? vm.evalMeterReading(log) + ' **' : vm.evalMeterReading(log),
                            f: log.within_range ? vm.misc.withinRange : vm.misc.outsideRange,
                            g: log.hospital_operator ? log.hospital_operator.initials : ''
                        });
                    });

                    if (vm.hasManualQcData) {
                        data.push({a: '**' + vm.columns.ps, b:'', c: '', d: '', e: '', f: '', g: ''});
                    }

                    var timestamp = moment();
                    var filename = 'QCLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO CSV(?, {headers:false, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            var stripLotIds = _.map(vm.stripLot, 'id');
            params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);

            var controlLot = vm.controlLot1.concat(vm.controlLot2);

            var controlLotIds = _.map(controlLot, 'id');
            params = angular.merge({'control_lot_ids[]': controlLotIds}, params);

            msApi.request('reports.single.qclogbook@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge,
                        f: '',
                        g: ''
                    });

                    data.push({
                        a: vm.meter.serial_no,
                        b: vm.meter.model_no,
                        c: vm.meter.location.hospital.name,
                        d: vm.meter.location.code,
                        e: vm.meter.location.person_in_charge,
                        f: '',
                        g: ''
                    });

                    data.push({a: '', b: '', c: '', d: '', e: '', f: '', g: ''});

                    data.push({a: vm.overallSection.title, b: 'Level 1', c: 'Level 2', d: '', e: '', f: '', g: ''});
                    data.push({a: vm.overallSection.noOfTests, b:  _.has(vm.overall, 'Level 1') ? vm.overall['Level 1'].number_of_tests : 0, c:  _.has(vm.overall, 'Level 2') ? vm.overall['Level 2'].number_of_tests : 0, d: '', e: '', f: '', g: ''});
                    data.push({a: vm.overallSection.mean + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')', b: _.has(vm.overall, 'Level 1') ? parseFloat(vm.overall['Level 1'].mean).toFixed(2) : '', c: _.has(vm.overall, 'Level 2') ? parseFloat(vm.overall['Level 2'].mean).toFixed(2) : '', d: '', e: '', f: '', g: ''});
                    data.push({a: vm.overallSection.sd  + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')', b: (_.has(vm.overall, 'Level 1') && vm.overall['Level 1'].stdev != null) ? parseFloat(vm.overall['Level 1'].stdev).toFixed(2) : '', c: (_.has(vm.overall, 'Level 2') && vm.overall['Level 2'].stdev != null) ? parseFloat(vm.overall['Level 2'].stdev).toFixed(2) : '', d: '', e: '', f: '', g: ''});
                    data.push({a: vm.overallSection.cv, b: (_.has(vm.overall, 'Level 1') && vm.overall['Level 1'].cv != null) ? parseFloat(vm.overall['Level 1'].cv).toFixed(2) + '*' : '', c: (_.has(vm.overall, 'Level 2') && vm.overall['Level 2'].cv != null) ? parseFloat(vm.overall['Level 2'].cv).toFixed(2) : '', d: '', e: '', f: '', g: ''});
                    data.push({a: vm.overallSection.ps, b:'', c: '', d: '', e: '', f: '', g: ''});

                    data.push({a: '', b: '', c: '', d: '', e: '', f: '', g: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.stripLot,
                        c: vm.columns.controlType,
                        d: vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        e: vm.columns.qcValue + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        f: vm.columns.status,
                        g: vm.columns.operatorInitials
                    });

                    var qclogbook = response.qclogbook;

                    _.map(qclogbook, function (log) {
                        data.push({
                            a: moment(log.tested_on).format(),
                            b: log.test_strip.lot_no,
                            c: log.control_level,
                            d: parseFloat(log.from).toFixed(1) + ' ' + vm.misc.to + ' ' + parseFloat(log.to).toFixed(1),
                            e: log.source == 'manual' ? vm.evalMeterReading(log) + ' **' : vm.evalMeterReading(log),
                            f: log.within_range ? vm.misc.withinRange : vm.misc.outsideRange,
                            g: log.hospital_operator ? log.hospital_operator.initials : ''
                        });
                    });

                    if (vm.hasManualQcData) {
                        data.push({a: '**' + vm.columns.ps, b:'', c: '', d: '', e: '', f: '', g: ''});
                    }

                    var timestamp = moment();
                    var filename = 'QCLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO XLSX(?, {headers:false}) FROM ?',[filename, data]);
                });
        }

        function getMeters() {
            var locationIds = _.map(vm.user.locations, 'id');
            var params = {
                hospital_id: vm.user.hospitals[0].id,
                'location_ids[]': locationIds
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getOverall(withSubFilter, updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (withSubFilter) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                var controlLot = vm.controlLot1.concat(vm.controlLot2);

                if (controlLot.length) {
                    var controlLotIds = _.map(controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.overall@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions1 = response.control_solutions1;
                    var controlSolutions2 = response.control_solutions2;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions1, controlSolutions2);
                    }

                    vm.overall = response.overall;
                });
        }

        function getQCLogbook() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            var stripLotIds = _.map(vm.stripLot, 'id');
            params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);

            var controlLot = vm.controlLot1.concat(vm.controlLot2);

            var controlLotIds = _.map(controlLot, 'id');
            params = angular.merge({'control_lot_ids[]': controlLotIds}, params);

            vm.promise = msApi.request('reports.single.qclogbook@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.pagination.total = response.qclogbook.total;
                    vm.qclogbook = response.qclogbook.data;
                    vm.scanQcLogForManualData(vm.qclogbook);
                    vm.loaded = true;
                });
        }

        function editQcData(log, e) {
            var dialogData = {
                qcValue: Math.round(log.meter_reading * 10) / 10    // Round to one decimal place.
            };

            $mdDialog.show({
                controller: 'EditQcDataDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/edit-qc-data-dialog/edit-qc-data-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    dialogData: dialogData,
                    isReadOnly: log.source == 'upload'
                }
            }).then(function (dialogResponse) {
                if (dialogResponse.result == 'save') {
                    saveQcValue(log, dialogResponse.qcValue);
                }
                else if (dialogResponse.result == 'delete') {
                    deleteQcData(log, e);
                }
            });
        }

        function saveQcValue(log, qcValue) {
            return msApi.request('quality_control_tests.edit@update', {
                    id: log.id,
                    meter_reading: qcValue,
                    measurement_unit: vm.user.preferred_measurement_unit
                },
                // SUCCESS
                function (response) {
                    log.meter_reading = response.quality_control_test.meter_reading;
                    log.within_range = response.quality_control_test.within_range;
                    log.is_low = response.quality_control_test.is_low;
                    log.is_high = response.quality_control_test.is_high;
                });
        }

        function deleteQcData(log, e) {
            var dialogData = {
                reason: ''
            };

            $mdDialog.show({
                controller: 'EnterReasonDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/enter-reason-dialog/enter-reason-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    dialogData: dialogData
                }
            }).then(function (dialogResponse) {
                return msApi.request('quality_control_tests.remove@delete', {
                        id: log.id,
                        reason: dialogResponse.reason
                    },
                    // SUCCESS
                    function (response) {
                        log.is_deleted = true;
                    });
            });
        }

        function changeOperator(log, e) {
            var dialogData = {
                operator: log.hospital_operator
            };

            $mdDialog.show({
                controller: 'ChangeOperatorDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/change-operator-dialog/change-operator-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        return msApi.request('users@get', {
                            role: 'hospital_operator',
                            hospital_id: vm.user.hospitals[0].id
                        });
                    }
                }
            }).then(function (dialogResponse) {
                if (dialogResponse.operator) {
                    tagOperator(log, dialogResponse.operator);
                } else {
                    unTagOperator(log);
                }
            });
        }

        function tagOperator(log, operator) {
            return msApi.request('quality_control_tests.tag_operator@save',{
                    quality_control_test_id: log.id,
                    hospital_operator_id: operator.id
                },
                // SUCCESS
                function (response) {
                    log.hospital_operator = response.quality_control_test.hospital_operator;
                });
        }

        function unTagOperator(log) {
            return msApi.request('quality_control_tests.untag_operator@save',{
                    quality_control_test_id: log.id
                },
                // SUCCESS
                function (response) {
                    log.hospital_operator = response.quality_control_test.hospital_operator;
                });
        }

        function subFilterForm(testStrips, controlSolutions1, controlSolutions2) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions1 = controlSolutions1;
            vm.controlLot1 = controlSolutions1;

            vm.controlSolutions2 = controlSolutions2;
            vm.controlLot2 = controlSolutions2;
        }

        function scanQcLogForManualData(qcLogs) {
            vm.hasManualQcData = false;
            _.forEach(qcLogs, function(qcLog) {
                if (qcLog.source == 'manual') {
                    vm.hasManualQcData = true;
                    return;
                }
            });
        }

        function evalMeterReading(log) {
          if (log.is_high) {
            return "HIGH";
          }
          else if (log.is_high) {
            return "LOW";
          }

          return parseFloat(log.meter_reading).toFixed(1);
        }

        function translate() {
            return $translate([
                'QC_REPORT_SINGLE.METER_SERIAL_NO',
                'QC_REPORT_SINGLE_LOGBOOK.METER.METER_MODEL',
                'QC_REPORT_SINGLE_LOGBOOK.METER.HOSPITAL',
                'QC_REPORT_SINGLE_LOGBOOK.METER.LOCATION_CODE',
                'QC_REPORT_SINGLE_LOGBOOK.METER.PERSON_IN_CHARGE',

                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.TITLE',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.NO_OF_TESTS',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.MEAN',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.SD',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.CV',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.PS',

                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.TEST_DATE_TIME',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STRIP_LOT',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.CONTROL_TYPE',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_VALUE',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STATUS',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.PS',

                'QC_REPORT_SINGLE_LOGBOOK.TO',
                'QC_REPORT_SINGLE_LOGBOOK.WITHIN_RANGE',
                'QC_REPORT_SINGLE_LOGBOOK.OUTSIDE_RANGE',

                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.STRIP_LOT',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL1',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL2',

                'QC_REPORT_SINGLE_LOGBOOK.PAGINATION.OF',
                'QC_REPORT_SINGLE_LOGBOOK.PAGINATION.PAGE',
                'QC_REPORT_SINGLE_LOGBOOK.PAGINATION.ROWS_PER_PAGE',

                'QC_REPORT_SINGLE.MESSAGES.SELECT_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.meterSection = {
                    serialNo: translations['QC_REPORT_SINGLE.METER_SERIAL_NO'],
                    model: translations['QC_REPORT_SINGLE_LOGBOOK.METER.METER_MODEL'],
                    hospital: translations['QC_REPORT_SINGLE_LOGBOOK.METER.HOSPITAL'],
                    locationCode: translations['QC_REPORT_SINGLE_LOGBOOK.METER.LOCATION_CODE'],
                    personInCharge: translations['QC_REPORT_SINGLE_LOGBOOK.METER.PERSON_IN_CHARGE']
                };

                vm.overallSection = {
                    title: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.TITLE'],
                    noOfTests: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.NO_OF_TESTS'],
                    mean: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.MEAN'],
                    sd: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.SD'],
                    cv: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.CV'],
                    ps: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.PS'],
                };

                vm.columns = {
                    testDateTime: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.TEST_DATE_TIME'],
                    stripLot: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STRIP_LOT'],
                    controlType: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.CONTROL_TYPE'],
                    qcTargetRange: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE'],
                    qcValue: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_VALUE'],
                    status: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STATUS'],
                    operatorInitials: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS'],
                    ps: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.PS']
                };

                vm.misc = {
                    to: translations['QC_REPORT_SINGLE_LOGBOOK.TO'],
                    withinRange: translations['QC_REPORT_SINGLE_LOGBOOK.WITHIN_RANGE'],
                    outsideRange: translations['QC_REPORT_SINGLE_LOGBOOK.OUTSIDE_RANGE']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1'],
                    allControlLotLevel1: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2'],
                    allControlLotLevel2: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL2']
                };

                vm.paginationLabel = {
                    of: translations['QC_REPORT_SINGLE_LOGBOOK.PAGINATION.OF'],
                    page: translations['QC_REPORT_SINGLE_LOGBOOK.PAGINATION.PAGE'],
                    rowsPerPage: translations['QC_REPORT_SINGLE_LOGBOOK.PAGINATION.ROWS_PER_PAGE']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'],
                    selectMeter: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_METER']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        $scope.$watch('vm.subFilterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        var exportToCSVEvent = $scope.$on('report::exportToCSV', function () {
            exportToCSV();
        });

        var exportToExcelEvent = $scope.$on('report::exportToExcel', function () {
            exportToExcel();
        });

        vm.$onDestroy = function() {
            exportToCSVEvent();
            exportToExcelEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.single.logbook')
        .component('singleLogbookGlobalAdmin', {
            templateUrl: 'app/main/qc-report/single/logbook/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, localStorageService, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.meter = null;
        vm.searchTerm = '';

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.pagination = {
            total:0,
            per_page: 10,
            current_page: 1
        };
        vm.sort = "tested_on";

        vm.loaded = false;
        vm.message = null;
        vm.hasManualQcData = false;

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.getQCLogbook = getQCLogbook;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.scanQcLogForManualData = scanQcLogForManualData;
        vm.evalMeterReading = evalMeterReading;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.meter = null;
            meterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function meterChanged() {
            if (vm.meter && vm.filterForm.$valid) {
                getOverall()
                    .then(getQCLogbook);
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getOverall()
                    .then(getQCLogbook);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getOverall()
                    .then(getQCLogbook);
            }
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getOverall() {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            return msApi.request('reports.single.overall@get',
                params,
                // SUCCESS
                function (response) {
                    vm.overall = response.overall;
                });
        }

        function getQCLogbook() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            vm.promise = msApi.request('reports.single.qclogbook@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.pagination.total = response.qclogbook.total;
                    vm.qclogbook = response.qclogbook.data;
                    vm.scanQcLogForManualData(vm.qclogbook);
                    vm.loaded = true;
                });
        }

        function exportToCSV() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('reports.single.qclogbook@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge,
                        f: ''
                    });

                    data.push({
                        a: vm.meter.serial_no,
                        b: vm.meter.model_no,
                        c: vm.meter.location.hospital.name,
                        d: vm.meter.location.code,
                        e: vm.meter.location.person_in_charge,
                        f: ''
                    });

                    data.push({a: '', b: '', c: '', d: '', e: '', f: ''});

                    data.push({a: vm.overallSection.title, b: 'Level 1', c: 'Level 2', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.noOfTests, b:  _.has(vm.overall, 'Level 1') ? vm.overall['Level 1'].number_of_tests : 0, c:  _.has(vm.overall, 'Level 2') ? vm.overall['Level 2'].number_of_tests : 0, d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.mean + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')', b: _.has(vm.overall, 'Level 1') ? parseFloat(vm.overall['Level 1'].mean).toFixed(2) : '', c: _.has(vm.overall, 'Level 2') ? parseFloat(vm.overall['Level 2'].mean).toFixed(2) : '', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.sd  + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')', b: (_.has(vm.overall, 'Level 1') && vm.overall['Level 1'].stdev != null) ? parseFloat(vm.overall['Level 1'].stdev).toFixed(2) : '', c: (_.has(vm.overall, 'Level 2') && vm.overall['Level 2'].stdev != null) ? parseFloat(vm.overall['Level 2'].stdev).toFixed(2) : '', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.cv, b: (_.has(vm.overall, 'Level 1') && vm.overall['Level 1'].cv != null) ? parseFloat(vm.overall['Level 1'].cv).toFixed(2) + '*' : '', c: (_.has(vm.overall, 'Level 2') && vm.overall['Level 2'].cv != null) ? parseFloat(vm.overall['Level 2'].cv).toFixed(2) : '', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.ps, b:'', c: '', d: '', e: '', f: ''});

                    data.push({a: '', b: '', c: '', d: '', e: '', f: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.stripLot,
                        c: vm.columns.controlType,
                        d: vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        e: vm.columns.qcValue + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        f: vm.columns.status
                    });

                    var qclogbook = response.qclogbook;

                    _.map(qclogbook, function (log) {
                        data.push({
                            a: moment(log.tested_on).format(),
                            b: log.test_strip.lot_no,
                            c: log.control_level,
                            d: parseFloat(log.from).toFixed(1) + ' ' + vm.misc.to + ' ' + parseFloat(log.to).toFixed(1),
                            e: log.source == 'manual' ? vm.evalMeterReading(log) + ' **' : vm.evalMeterReading(log),
                            f: log.within_range ? vm.misc.withinRange : vm.misc.outsideRange
                        });
                    });

                    if (vm.hasManualQcData) {
                        data.push({a: '**' + vm.columns.ps, b:'', c: '', d: '', e: '', f: ''});
                    }

                    var timestamp = moment();
                    var filename = 'QCLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO CSV(?, {headers:false, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('reports.single.qclogbook@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge,
                        f: ''
                    });

                    data.push({
                        a: vm.meter.serial_no,
                        b: vm.meter.model_no,
                        c: vm.meter.location.hospital.name,
                        d: vm.meter.location.code,
                        e: vm.meter.location.person_in_charge,
                        f: ''
                    });

                    data.push({a: '', b: '', c: '', d: '', e: '', f: ''});

                    data.push({a: vm.overallSection.title, b: 'Level 1', c: 'Level 2', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.noOfTests, b:  _.has(vm.overall, 'Level 1') ? vm.overall['Level 1'].number_of_tests : 0, c:  _.has(vm.overall, 'Level 2') ? vm.overall['Level 2'].number_of_tests : 0, d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.mean + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')', b: _.has(vm.overall, 'Level 1') ? parseFloat(vm.overall['Level 1'].mean).toFixed(2) : '', c: _.has(vm.overall, 'Level 2') ? parseFloat(vm.overall['Level 2'].mean).toFixed(2) : '', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.sd  + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')', b: (_.has(vm.overall, 'Level 1') && vm.overall['Level 1'].stdev != null) ? parseFloat(vm.overall['Level 1'].stdev).toFixed(2) : '', c: (_.has(vm.overall, 'Level 2') && vm.overall['Level 2'].stdev != null) ? parseFloat(vm.overall['Level 2'].stdev).toFixed(2) : '', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.cv, b: (_.has(vm.overall, 'Level 1') && vm.overall['Level 1'].cv != null) ? parseFloat(vm.overall['Level 1'].cv).toFixed(2) + '*' : '', c: (_.has(vm.overall, 'Level 2') && vm.overall['Level 2'].cv != null) ? parseFloat(vm.overall['Level 2'].cv).toFixed(2) : '', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.ps, b:'', c: '', d: '', e: '', f: ''});

                    data.push({a: '', b: '', c: '', d: '', e: '', f: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.stripLot,
                        c: vm.columns.controlType,
                        d: vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        e: vm.columns.qcValue + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        f: vm.columns.status
                    });

                    var qclogbook = response.qclogbook;

                    _.map(qclogbook, function (log) {
                        data.push({
                            a: moment(log.tested_on).format(),
                            b: log.test_strip.lot_no,
                            c: log.control_level,
                            d: parseFloat(log.from).toFixed(1) + ' ' + vm.misc.to + ' ' + parseFloat(log.to).toFixed(1),
                            e: log.source == 'manual' ? vm.evalMeterReading(log) + ' **' : vm.evalMeterReading(log),
                            f: log.within_range ? vm.misc.withinRange : vm.misc.outsideRange
                        });
                    });

                    if (vm.hasManualQcData) {
                        data.push({a: '**' + vm.columns.ps, b:'', c: '', d: '', e: '', f: ''});
                    }

                    var timestamp = moment();
                    var filename = 'QCLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO XLSX(?, {headers:false}) FROM ?',[filename, data]);
                });
        }

        function scanQcLogForManualData(qcLogs) {
            vm.hasManualQcData = false;
            _.forEach(qcLogs, function(qcLog) {
                if (qcLog.source == 'manual') {
                    vm.hasManualQcData = true;
                    return;
                }
            });
        }

        function evalMeterReading(log) {
          if (log.is_high) {
            return "HIGH";
          }
          else if (log.is_high) {
            return "LOW";
          }

          return parseFloat(log.meter_reading).toFixed(1);
        }

        function translate() {
            return $translate([
                'QC_REPORT_SINGLE.METER_SERIAL_NO',
                'QC_REPORT_SINGLE_LOGBOOK.METER.METER_MODEL',
                'QC_REPORT_SINGLE_LOGBOOK.METER.HOSPITAL',
                'QC_REPORT_SINGLE_LOGBOOK.METER.LOCATION_CODE',
                'QC_REPORT_SINGLE_LOGBOOK.METER.PERSON_IN_CHARGE',

                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.TITLE',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.NO_OF_TESTS',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.MEAN',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.SD',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.CV',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.PS',

                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.TEST_DATE_TIME',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STRIP_LOT',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.CONTROL_TYPE',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_VALUE',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STATUS',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.PS',

                'QC_REPORT_SINGLE_LOGBOOK.TO',
                'QC_REPORT_SINGLE_LOGBOOK.WITHIN_RANGE',
                'QC_REPORT_SINGLE_LOGBOOK.OUTSIDE_RANGE',

                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.STRIP_LOT',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL1',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL2',

                'QC_REPORT_SINGLE_LOGBOOK.PAGINATION.OF',
                'QC_REPORT_SINGLE_LOGBOOK.PAGINATION.PAGE',
                'QC_REPORT_SINGLE_LOGBOOK.PAGINATION.ROWS_PER_PAGE',

                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN'

            ]).then(function(translations) {
                vm.meterSection = {
                    serialNo: translations['QC_REPORT_SINGLE.METER_SERIAL_NO'],
                    model: translations['QC_REPORT_SINGLE_LOGBOOK.METER.METER_MODEL'],
                    hospital: translations['QC_REPORT_SINGLE_LOGBOOK.METER.HOSPITAL'],
                    locationCode: translations['QC_REPORT_SINGLE_LOGBOOK.METER.LOCATION_CODE'],
                    personInCharge: translations['QC_REPORT_SINGLE_LOGBOOK.METER.PERSON_IN_CHARGE']
                };

                vm.overallSection = {
                    title: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.TITLE'],
                    noOfTests: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.NO_OF_TESTS'],
                    mean: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.MEAN'],
                    sd: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.SD'],
                    cv: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.CV'],
                    ps: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.PS'],
                };

                vm.columns = {
                    testDateTime: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.TEST_DATE_TIME'],
                    stripLot: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STRIP_LOT'],
                    controlType: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.CONTROL_TYPE'],
                    qcTargetRange: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE'],
                    qcValue: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_VALUE'],
                    status: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STATUS'],
                    operatorInitials: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS'],
                    ps: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.PS']
                };

                vm.misc = {
                    to: translations['QC_REPORT_SINGLE_LOGBOOK.TO'],
                    withinRange: translations['QC_REPORT_SINGLE_LOGBOOK.WITHIN_RANGE'],
                    outsideRange: translations['QC_REPORT_SINGLE_LOGBOOK.OUTSIDE_RANGE']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1'],
                    allControlLotLevel1: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2'],
                    allControlLotLevel2: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL2']
                };

                vm.paginationLabel = {
                    of: translations['QC_REPORT_SINGLE_LOGBOOK.PAGINATION.OF'],
                    page: translations['QC_REPORT_SINGLE_LOGBOOK.PAGINATION.PAGE'],
                    rowsPerPage: translations['QC_REPORT_SINGLE_LOGBOOK.PAGINATION.ROWS_PER_PAGE']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN']
                };

            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToCSVEvent = $scope.$on('report::exportToCSV', function () {
            exportToCSV();
        });

        var exportToExcelEvent = $scope.$on('report::exportToExcel', function () {
            exportToExcel();
        });

        vm.$onDestroy = function() {
            exportToCSVEvent();
            exportToExcelEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.single.logbook')
        .component('singleLogbookCountryAdmin', {
            templateUrl: 'app/main/qc-report/single/logbook/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, localStorageService, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.meter = null;
        vm.searchTerm = '';

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.pagination = {
            total:0,
            per_page: 10,
            current_page: 1
        };
        vm.sort = "tested_on";

        vm.loaded = false;
        vm.message = null;
        vm.hasManualQcData = false;

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.getQCLogbook = getQCLogbook;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.scanQcLogForManualData = scanQcLogForManualData;
        vm.evalMeterReading = evalMeterReading;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.meter = null;
            meterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function meterChanged() {
            if (vm.meter && vm.filterForm.$valid) {
                getOverall()
                    .then(getQCLogbook);
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getOverall()
                    .then(getQCLogbook);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getOverall()
                    .then(getQCLogbook);
            }
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getOverall() {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            return msApi.request('reports.single.overall@get',
                params,
                // SUCCESS
                function (response) {
                    vm.overall = response.overall;
                });
        }

        function getQCLogbook() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            vm.promise = msApi.request('reports.single.qclogbook@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.pagination.total = response.qclogbook.total;
                    vm.qclogbook = response.qclogbook.data;
                    vm.scanQcLogForManualData(vm.qclogbook);
                    vm.loaded = true;
                });
        }

        function exportToCSV() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('reports.single.qclogbook@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge,
                        f: ''
                    });

                    data.push({
                        a: vm.meter.serial_no,
                        b: vm.meter.model_no,
                        c: vm.meter.location.hospital.name,
                        d: vm.meter.location.code,
                        e: vm.meter.location.person_in_charge,
                        f: ''
                    });

                    data.push({a: '', b: '', c: '', d: '', e: '', f: ''});

                    data.push({a: vm.overallSection.title, b: 'Level 1', c: 'Level 2', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.noOfTests, b:  _.has(vm.overall, 'Level 1') ? vm.overall['Level 1'].number_of_tests : 0, c:  _.has(vm.overall, 'Level 2') ? vm.overall['Level 2'].number_of_tests : 0, d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.mean + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')', b: _.has(vm.overall, 'Level 1') ? parseFloat(vm.overall['Level 1'].mean).toFixed(2) : '', c: _.has(vm.overall, 'Level 2') ? parseFloat(vm.overall['Level 2'].mean).toFixed(2) : '', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.sd  + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')', b: (_.has(vm.overall, 'Level 1') && vm.overall['Level 1'].stdev != null) ? parseFloat(vm.overall['Level 1'].stdev).toFixed(2) : '', c: (_.has(vm.overall, 'Level 2') && vm.overall['Level 2'].stdev != null) ? parseFloat(vm.overall['Level 2'].stdev).toFixed(2) : '', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.cv, b: (_.has(vm.overall, 'Level 1') && vm.overall['Level 1'].cv != null) ? parseFloat(vm.overall['Level 1'].cv).toFixed(2) + '*' : '', c: (_.has(vm.overall, 'Level 2') && vm.overall['Level 2'].cv != null) ? parseFloat(vm.overall['Level 2'].cv).toFixed(2) : '', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.ps, b:'', c: '', d: '', e: '', f: ''});

                    data.push({a: '', b: '', c: '', d: '', e: '', f: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.stripLot,
                        c: vm.columns.controlType,
                        d: vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        e: vm.columns.qcValue + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        f: vm.columns.status
                    });

                    var qclogbook = response.qclogbook;

                    _.map(qclogbook, function (log) {
                        data.push({
                            a: moment(log.tested_on).format(),
                            b: log.test_strip.lot_no,
                            c: log.control_level,
                            d: parseFloat(log.from).toFixed(1) + ' ' + vm.misc.to + ' ' + parseFloat(log.to).toFixed(1),
                            e: log.source == 'manual' ? vm.evalMeterReading(log) + ' **' : vm.evalMeterReading(log),
                            f: log.within_range ? vm.misc.withinRange : vm.misc.outsideRange
                        });
                    });

                    if (vm.hasManualQcData) {
                        data.push({a: '**' + vm.columns.ps, b:'', c: '', d: '', e: '', f: ''});
                    }

                    var timestamp = moment();
                    var filename = 'QCLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO CSV(?, {headers:false, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('reports.single.qclogbook@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge,
                        f: ''
                    });

                    data.push({
                        a: vm.meter.serial_no,
                        b: vm.meter.model_no,
                        c: vm.meter.location.hospital.name,
                        d: vm.meter.location.code,
                        e: vm.meter.location.person_in_charge,
                        f: ''
                    });

                    data.push({a: '', b: '', c: '', d: '', e: '', f: ''});

                    data.push({a: vm.overallSection.title, b: 'Level 1', c: 'Level 2', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.noOfTests, b:  _.has(vm.overall, 'Level 1') ? vm.overall['Level 1'].number_of_tests : 0, c:  _.has(vm.overall, 'Level 2') ? vm.overall['Level 2'].number_of_tests : 0, d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.mean + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')', b: _.has(vm.overall, 'Level 1') ? parseFloat(vm.overall['Level 1'].mean).toFixed(2) : '', c: _.has(vm.overall, 'Level 2') ? parseFloat(vm.overall['Level 2'].mean).toFixed(2) : '', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.sd  + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')', b: (_.has(vm.overall, 'Level 1') && vm.overall['Level 1'].stdev != null) ? parseFloat(vm.overall['Level 1'].stdev).toFixed(2) : '', c: (_.has(vm.overall, 'Level 2') && vm.overall['Level 2'].stdev != null) ? parseFloat(vm.overall['Level 2'].stdev).toFixed(2) : '', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.cv, b: (_.has(vm.overall, 'Level 1') && vm.overall['Level 1'].cv != null) ? parseFloat(vm.overall['Level 1'].cv).toFixed(2) + '*' : '', c: (_.has(vm.overall, 'Level 2') && vm.overall['Level 2'].cv != null) ? parseFloat(vm.overall['Level 2'].cv).toFixed(2) : '', d: '', e: '', f: ''});
                    data.push({a: vm.overallSection.ps, b:'', c: '', d: '', e: '', f: ''});

                    data.push({a: '', b: '', c: '', d: '', e: '', f: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.stripLot,
                        c: vm.columns.controlType,
                        d: vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        e: vm.columns.qcValue + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        f: vm.columns.status
                    });

                    var qclogbook = response.qclogbook;

                    _.map(qclogbook, function (log) {
                        data.push({
                            a: moment(log.tested_on).format(),
                            b: log.test_strip.lot_no,
                            c: log.control_level,
                            d: parseFloat(log.from).toFixed(1) + ' ' + vm.misc.to + ' ' + parseFloat(log.to).toFixed(1),
                            e: log.source == 'manual' ? vm.evalMeterReading(log) + ' **' : vm.evalMeterReading(log),
                            f: log.within_range ? vm.misc.withinRange : vm.misc.outsideRange
                        });
                    });

                    if (vm.hasManualQcData) {
                        data.push({a: '**' + vm.columns.ps, b:'', c: '', d: '', e: '', f: ''});
                    }

                    var timestamp = moment();
                    var filename = 'QCLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO XLSX(?, {headers:false}) FROM ?',[filename, data]);
                });
        }

        function scanQcLogForManualData(qcLogs) {
            vm.hasManualQcData = false;
            _.forEach(qcLogs, function(qcLog) {
                if (qcLog.source == 'manual') {
                    vm.hasManualQcData = true;
                    return;
                }
            });
        }

        function evalMeterReading(log) {
          if (log.is_high) {
            return "HIGH";
          }
          else if (log.is_high) {
            return "LOW";
          }

          return parseFloat(log.meter_reading).toFixed(1);
        }

        function translate() {
            return $translate([
                'QC_REPORT_SINGLE.METER_SERIAL_NO',
                'QC_REPORT_SINGLE_LOGBOOK.METER.METER_MODEL',
                'QC_REPORT_SINGLE_LOGBOOK.METER.HOSPITAL',
                'QC_REPORT_SINGLE_LOGBOOK.METER.LOCATION_CODE',
                'QC_REPORT_SINGLE_LOGBOOK.METER.PERSON_IN_CHARGE',

                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.TITLE',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.NO_OF_TESTS',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.MEAN',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.SD',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.CV',
                'QC_REPORT_SINGLE_LOGBOOK.OVERALL.PS',

                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.TEST_DATE_TIME',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STRIP_LOT',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.CONTROL_TYPE',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_VALUE',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STATUS',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS',
                'QC_REPORT_SINGLE_LOGBOOK.COLUMNS.PS',

                'QC_REPORT_SINGLE_LOGBOOK.TO',
                'QC_REPORT_SINGLE_LOGBOOK.WITHIN_RANGE',
                'QC_REPORT_SINGLE_LOGBOOK.OUTSIDE_RANGE',

                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.STRIP_LOT',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL1',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2',
                'QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL2',

                'QC_REPORT_SINGLE_LOGBOOK.PAGINATION.OF',
                'QC_REPORT_SINGLE_LOGBOOK.PAGINATION.PAGE',
                'QC_REPORT_SINGLE_LOGBOOK.PAGINATION.ROWS_PER_PAGE',

                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN'

            ]).then(function(translations) {
                vm.meterSection = {
                    serialNo: translations['QC_REPORT_SINGLE.METER_SERIAL_NO'],
                    model: translations['QC_REPORT_SINGLE_LOGBOOK.METER.METER_MODEL'],
                    hospital: translations['QC_REPORT_SINGLE_LOGBOOK.METER.HOSPITAL'],
                    locationCode: translations['QC_REPORT_SINGLE_LOGBOOK.METER.LOCATION_CODE'],
                    personInCharge: translations['QC_REPORT_SINGLE_LOGBOOK.METER.PERSON_IN_CHARGE']
                };

                vm.overallSection = {
                    title: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.TITLE'],
                    noOfTests: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.NO_OF_TESTS'],
                    mean: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.MEAN'],
                    sd: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.SD'],
                    cv: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.CV'],
                    ps: translations['QC_REPORT_SINGLE_LOGBOOK.OVERALL.PS'],
                };

                vm.columns = {
                    testDateTime: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.TEST_DATE_TIME'],
                    stripLot: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STRIP_LOT'],
                    controlType: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.CONTROL_TYPE'],
                    qcTargetRange: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE'],
                    qcValue: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_VALUE'],
                    status: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STATUS'],
                    operatorInitials: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS'],
                    ps: translations['QC_REPORT_SINGLE_LOGBOOK.COLUMNS.PS']
                };

                vm.misc = {
                    to: translations['QC_REPORT_SINGLE_LOGBOOK.TO'],
                    withinRange: translations['QC_REPORT_SINGLE_LOGBOOK.WITHIN_RANGE'],
                    outsideRange: translations['QC_REPORT_SINGLE_LOGBOOK.OUTSIDE_RANGE']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1'],
                    allControlLotLevel1: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2'],
                    allControlLotLevel2: translations['QC_REPORT_SINGLE_LOGBOOK.FILTERS.ALL_CONTROL_LOT_LEVEL2']
                };

                vm.paginationLabel = {
                    of: translations['QC_REPORT_SINGLE_LOGBOOK.PAGINATION.OF'],
                    page: translations['QC_REPORT_SINGLE_LOGBOOK.PAGINATION.PAGE'],
                    rowsPerPage: translations['QC_REPORT_SINGLE_LOGBOOK.PAGINATION.ROWS_PER_PAGE']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN']
                };

            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToCSVEvent = $scope.$on('report::exportToCSV', function () {
            exportToCSV();
        });

        var exportToExcelEvent = $scope.$on('report::exportToExcel', function () {
            exportToExcel();
        });

        vm.$onDestroy = function() {
            exportToCSVEvent();
            exportToExcelEvent();
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.single.level1', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-single-level1', {
                url    : '/qc-report-single-level1',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/single/level1/level1.html',
                        controller : 'SingleLevel1Controller as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin', 'hospital_operator']
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/single/level1');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.single.ljchart', ['/reports/single/ljchart']);

        msNavigationServiceProvider.saveItem('qc-report-single.level1', {
            title : 'L-J Chart – Level 1',
            state: 'app.qc-report-single-level1',
            weight: 14,
            translate: 'QC_REPORT_SINGLE_LEVEL1.NAV'
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.qc-report.single.level1')
        .component('singleLevel1HospitalAdmin', {
            templateUrl: 'app/main/qc-report/single/level1/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, localStorageService, $mdSelect, $filter, CONFIG, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 1';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.meterColumns = [];
        vm.meters = [];
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.stripLotChanged = stripLotChanged;
        vm.controlLotChanged = controlLotChanged;
        vm.getStripLotText = getStripLotText;
        vm.getControlLotText = getControlLotText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#29b6f6",
                        borderColor: "#29b6f6",
                        pointBorderColor: "#29b6f6",
                        pointBackgroundColor: "#29b6f6",
                        pointHoverBackgroundColor: "#29b6f6",
                        pointHoverBorderColor: "#29b6f6",
                        showLine: true
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left:16
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: false,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        bodySpacing: 4,
                        displayColors: false
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            getMeters();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function stripLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function controlLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function getStripLotText() {
            var limit = 50;
            if (vm.stripLot && vm.stripLot.length) {
                if (vm.stripLot.length === vm.testStrips.length) {
                    return vm.filters.allStripLot;
                }
                var joined =  _.join(_.map(vm.stripLot, 'lot_no'), ', ');

                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
            } else {
                return vm.filters.stripLot;
            }
        }

        function getControlLotText() {
            var limit = 50;
            if (vm.controlLot && vm.controlLot.length) {
                if (vm.controlLot.length === vm.controlSolutions.length) {
                    return vm.filters.allControlLot;
                }
                var joined = _.join(_.map(vm.controlLot, 'lot_no'), ', ');

                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
            } else {
                return vm.filters.controlLot;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.stripLot,
                                    style: 'small'
                                },
                                {
                                    text: getStripLotText(),
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.controlLot,
                                    style: 'small'
                                },
                                {
                                    text: getControlLotText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 20]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data, vm.user.preferred_measurement_unit);
        }

        function getMeters() {
            var locationIds = _.map(vm.user.locations, 'id');
            var params = {
                hospital_id: vm.user.hospitals[0].id,
                'location_ids[]': locationIds
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                level: vm.level,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                if (vm.controlLot.length) {
                    var controlLotIds = _.map(vm.controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions = response.control_solutions;
                    vm.mean = response.mean;
                    vm.stdev = response.stdev;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data, vm.user.preferred_measurement_unit);
                    points(vm.data);
                    tooltips(vm.data, vm.user.preferred_measurement_unit);
                    annotations(vm.mean, vm.stdev, vm.user.preferred_measurement_unit);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var points = _.map(data, function(test) {
                if (test.meter_reading !== null) {
                    return {x: moment(test.tested_on), y: formatMeasurement(parseFloat(test.meter_reading), test.measurement_unit)};
                }
            });

            vm.chartjs.datasetOverride[0].label = vm.level;
            vm.chartjs.data = [points];
        }

        function xAxes(tests) {
            var minTest = _.minBy(tests, 'tested_on');
            var maxTest = _.maxBy(tests, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests, measurementUnit) {
            var minTest = _.minBy(tests, 'meter_reading');
            var maxTest = _.maxBy(tests, 'meter_reading');

            if (measurementUnit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 0.5 : 1.7;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 0.5 : 3.3;
                var stepSize = (min + max) / 2;
                // Primary axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.01;
            } else {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 9 : 30;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 9 : 60;
                var stepSize = (min + max) / 2;

                // Primary Axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.01;
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatMeasurement(parseFloat(value), measurementUnit);
            };
        }

        function tooltips(tests, measurementUnit) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return [
                        vm.tooltips.reading + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[measurementUnit],
                        vm.tooltips.stripLot + ' ' + tests[tooltipItem.index].test_strip.lot_no,
                        vm.tooltips.controlLot + ' ' + tests[tooltipItem.index].control_solution.lot_no
                    ];
                }
            };
        }

        function annotations(mean, stdev, measurementUnit) {
            var annotations = [];
            var m = null;
            var sd1 = null;
            var _sd1 = null;
            var sd2 = null;
            var _sd2 = null;
            var sd3 = null;
            var _sd3 = null;

            // mean
            if (mean) {
                m = formatMeasurement(mean, measurementUnit);
                annotations.push(annotation(m, 8, {borderWidth: 2}, vm.annotations.mean + ' (' + m + ')'));
            }

            if (stdev) {
                sd1 = formatMeasurement(mean + stdev, measurementUnit);
                _sd1 = formatMeasurement(mean - stdev, measurementUnit);
                sd2 = formatMeasurement(mean + stdev * 2, measurementUnit);
                _sd2 = formatMeasurement (mean - stdev * 2, measurementUnit);
                sd3 = formatMeasurement(mean + stdev * 3, measurementUnit);
                _sd3 = formatMeasurement(mean - stdev * 3, measurementUnit);
                annotations.push(annotation(sd1, 8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, '+1' + vm.annotations.sd + ' (' + sd1 + ')'));
                annotations.push(annotation(_sd1, -8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, '-1' + vm.annotations.sd + ' (' + _sd1 + ')'));
                annotations.push(annotation(sd2, 8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, '+2' + vm.annotations.sd + ' (' + sd2 + ')'));
                annotations.push(annotation(_sd2, -8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, '-2' + vm.annotations.sd + ' (' + _sd2 + ')'));
                annotations.push(annotation(sd3, 8, {borderWidth: 1}, '+3' + vm.annotations.sd + ' (' + sd3 + ')'));
                annotations.push(annotation(_sd3, -8, {borderWidth: 1}, '-3' + vm.annotations.sd + ' (' + _sd3 + ')'));
            }

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(m && value == m) return vm.annotations.mean + ' (' + m + ')';
                if(sd1 && value == sd1) return '+1' + vm.annotations.sd + ' (' + sd1 + ')';
                if(_sd1 && value == _sd1) return '-1' + vm.annotations.sd + ' (' + _sd1 + ')';
                if(sd2 && value == sd2) return '+2' + vm.annotations.sd + ' (' + sd2 + ')';
                if(_sd2 && value == _sd2) return '-2' + vm.annotations.sd + ' (' + _sd2 + ')';
                if(sd2 && value == sd3) return '+3' + vm.annotations.sd + ' (' + sd3 + ')';
                if(_sd2 && value == _sd3) return '-3' + vm.annotations.sd + ' (' + _sd3 + ')';
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function formatMeasurement(value, measurementUnit) {
          if (measurementUnit == 'MMOL_PER_L') {
            return value.toFixed(1);
          }
          else if (measurementUnit == 'MG_PER_DL') {
            return value.toFixed(0);
          }

          return value;
        }

        function translate() {
            return $translate([
                'QC_REPORT_SINGLE.TITLE',
                'QC_REPORT_SINGLE.START_DATE',
                'QC_REPORT_SINGLE.END_DATE',
                'QC_REPORT_SINGLE.METER_SERIAL_NO',
                'QC_REPORT_SINGLE_LEVEL1.TITLE',
                'QC_REPORT_SINGLE_LEVEL1.FILTERS.STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL1.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL1.FILTERS.CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL1.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL1.CHART.TITLE',
                'QC_REPORT_SINGLE_LEVEL1.CHART.X_AXIS',
                'QC_REPORT_SINGLE_LEVEL1.CHART.Y_AXIS',
                'QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.READING',
                'QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL1.CHART.ANNOTATION.MEAN',
                'QC_REPORT_SINGLE_LEVEL1.CHART.ANNOTATION.SD',

                'QC_REPORT_SINGLE.MESSAGES.SELECT_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_SINGLE.TITLE'],
                    title: translations['QC_REPORT_SINGLE_LEVEL1.TITLE'],
                    startDate: translations['QC_REPORT_SINGLE.START_DATE'],
                    endDate: translations['QC_REPORT_SINGLE.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_SINGLE.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.ALL_CONTROL_LOT'],
                };

                vm.chart = {
                    title: translations['QC_REPORT_SINGLE_LEVEL1.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_SINGLE_LEVEL1.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_SINGLE_LEVEL1.CHART.Y_AXIS']
                };

                vm.tooltips = {
                    reading: translations['QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.READING'],
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.annotations = {
                    mean: translations['QC_REPORT_SINGLE_LEVEL1.CHART.ANNOTATION.MEAN'],
                    sd: translations['QC_REPORT_SINGLE_LEVEL1.CHART.ANNOTATION.SD']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'],
                    selectMeter: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_METER']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        $scope.$watch('vm.subFilterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.single.level1')
        .component('singleLevel1GlobalAdmin', {
            templateUrl: 'app/main/qc-report/single/level1/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 1';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#29b6f6",
                        borderColor: "#29b6f6",
                        pointBorderColor: "#29b6f6",
                        pointBackgroundColor: "#29b6f6",
                        pointHoverBackgroundColor: "#29b6f6",
                        pointHoverBorderColor: "#29b6f6",
                        showLine: true
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left:16
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: false,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        bodySpacing: 4,
                        displayColors: false
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.meter = null;
            meterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.meter && vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.country,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedCountry.name
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.state,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedState.name
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data, vm.user.preferred_measurement_unit);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                level: vm.level,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                if (vm.controlLot.length) {
                    var controlLotIds = _.map(vm.controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions = response.control_solutions;
                    vm.mean = response.mean;
                    vm.stdev = response.stdev;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data, vm.user.preferred_measurement_unit);
                    points(vm.data);
                    tooltips(vm.data, vm.user.preferred_measurement_unit);
                    annotations(vm.mean, vm.stdev, vm.user.preferred_measurement_unit);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var points = _.map(data, function(test) {
                if (test.meter_reading !== null) {
                    return {x: moment(test.tested_on), y: formatMeasurement(parseFloat(test.meter_reading), test.measurement_unit)};
                }
            });

            vm.chartjs.datasetOverride[0].label = vm.level;
            vm.chartjs.data = [points];
        }

        function xAxes(tests) {
            var minTest = _.minBy(tests, 'tested_on');
            var maxTest = _.maxBy(tests, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests, measurementUnit) {
            var minTest = _.minBy(tests, 'meter_reading');
            var maxTest = _.maxBy(tests, 'meter_reading');

            if (measurementUnit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 0.5 : 1.7;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 0.5 : 3.3;
                var stepSize = (min + max) / 2;
                // Primary axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.01;
            } else {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 9 : 30;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 9 : 60;
                var stepSize = (min + max) / 2;

                // Primary Axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.01;
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatMeasurement(parseFloat(value), measurementUnit);
            };
        }

        function tooltips(tests, measurementUnit) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return [
                        vm.tooltips.reading + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[measurementUnit],
                        vm.tooltips.stripLot + ' ' + tests[tooltipItem.index].test_strip.lot_no,
                        vm.tooltips.controlLot + ' ' + tests[tooltipItem.index].control_solution.lot_no
                    ];
                }
            };
        }

        function annotations(mean, stdev, measurementUnit) {
            var annotations = [];
            var m = null;
            var sd1 = null;
            var _sd1 = null;
            var sd2 = null;
            var _sd2 = null;
            var sd3 = null;
            var _sd3 = null;

            // mean
            if (mean) {
                m = formatMeasurement(mean, measurementUnit);
                annotations.push(annotation(m, 8, {borderWidth: 2}, vm.annotations.mean + ' (' + m + ')'));
            }

            if (stdev) {
                sd1 = formatMeasurement(mean + stdev, measurementUnit);
                _sd1 = formatMeasurement(mean - stdev, measurementUnit);
                sd2 = formatMeasurement(mean + stdev * 2, measurementUnit);
                _sd2 = formatMeasurement (mean - stdev * 2, measurementUnit);
                sd3 = formatMeasurement(mean + stdev * 3, measurementUnit);
                _sd3 = formatMeasurement(mean - stdev * 3, measurementUnit);
                annotations.push(annotation(sd1, 8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, '+1' + vm.annotations.sd + ' (' + sd1 + ')'));
                annotations.push(annotation(_sd1, -8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, '-1' + vm.annotations.sd + ' (' + _sd1 + ')'));
                annotations.push(annotation(sd2, 8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, '+2' + vm.annotations.sd + ' (' + sd2 + ')'));
                annotations.push(annotation(_sd2, -8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, '-2' + vm.annotations.sd + ' (' + _sd2 + ')'));
                annotations.push(annotation(sd3, 8, {borderWidth: 1}, '+3' + vm.annotations.sd + ' (' + sd3 + ')'));
                annotations.push(annotation(_sd3, -8, {borderWidth: 1}, '-3' + vm.annotations.sd + ' (' + _sd3 + ')'));
            }

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(m && value == m) return vm.annotations.mean + ' (' + m + ')';
                if(sd1 && value == sd1) return '+1' + vm.annotations.sd + ' (' + sd1 + ')';
                if(_sd1 && value == _sd1) return '-1' + vm.annotations.sd + ' (' + _sd1 + ')';
                if(sd2 && value == sd2) return '+2' + vm.annotations.sd + ' (' + sd2 + ')';
                if(_sd2 && value == _sd2) return '-2' + vm.annotations.sd + ' (' + _sd2 + ')';
                if(sd2 && value == sd3) return '+3' + vm.annotations.sd + ' (' + sd3 + ')';
                if(_sd2 && value == _sd3) return '-3' + vm.annotations.sd + ' (' + _sd3 + ')';
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function formatMeasurement(value, measurementUnit) {
          if (measurementUnit == 'MMOL_PER_L') {
            return value.toFixed(1);
          }
          else if (measurementUnit == 'MG_PER_DL') {
            return value.toFixed(0);
          }

          return value;
        }

        function translate() {
            return $translate([
                'QC_REPORT_SINGLE.TITLE',
                'QC_REPORT_SINGLE.COUNTRY',
                'QC_REPORT_SINGLE.STATE',
                'QC_REPORT_SINGLE.HOSPITAL',
                'QC_REPORT_SINGLE.START_DATE',
                'QC_REPORT_SINGLE.END_DATE',
                'QC_REPORT_SINGLE.METER_SERIAL_NO',

                'QC_REPORT_SINGLE_LEVEL1.TITLE',
                'QC_REPORT_SINGLE_LEVEL1.FILTERS.STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL1.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL1.FILTERS.CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL1.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL1.CHART.TITLE',
                'QC_REPORT_SINGLE_LEVEL1.CHART.X_AXIS',
                'QC_REPORT_SINGLE_LEVEL1.CHART.Y_AXIS',
                'QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.READING',
                'QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL1.CHART.ANNOTATION.MEAN',
                'QC_REPORT_SINGLE_LEVEL1.CHART.ANNOTATION.SD',

                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_SINGLE.TITLE'],
                    title: translations['QC_REPORT_SINGLE_LEVEL1.TITLE'],
                    country: translations['QC_REPORT_SINGLE.COUNTRY'],
                    state: translations['QC_REPORT_SINGLE.STATE'],
                    hospital: translations['QC_REPORT_SINGLE.HOSPITAL'],
                    startDate: translations['QC_REPORT_SINGLE.START_DATE'],
                    endDate: translations['QC_REPORT_SINGLE.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_SINGLE.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.ALL_CONTROL_LOT'],
                };

                vm.chart = {
                    title: translations['QC_REPORT_SINGLE_LEVEL1.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_SINGLE_LEVEL1.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_SINGLE_LEVEL1.CHART.Y_AXIS']
                };

                vm.tooltips = {
                    reading: translations['QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.READING'],
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.annotations = {
                    mean: translations['QC_REPORT_SINGLE_LEVEL1.CHART.ANNOTATION.MEAN'],
                    sd: translations['QC_REPORT_SINGLE_LEVEL1.CHART.ANNOTATION.SD']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.single.level1')
        .component('singleLevel1CountryAdmin', {
            templateUrl: 'app/main/qc-report/single/level1/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 1';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#29b6f6",
                        borderColor: "#29b6f6",
                        pointBorderColor: "#29b6f6",
                        pointBackgroundColor: "#29b6f6",
                        pointHoverBackgroundColor: "#29b6f6",
                        pointHoverBorderColor: "#29b6f6",
                        showLine: true
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left:16
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: false,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        bodySpacing: 4,
                        displayColors: false
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.meter = null;
            meterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.meter && vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.state,
                                    style: 'small'
                                },
                                {
                                    text:  vm.selectedState.name,
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name,
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data, vm.user.preferred_measurement_unit);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                level: vm.level,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                if (vm.controlLot.length) {
                    var controlLotIds = _.map(vm.controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions = response.control_solutions;
                    vm.mean = response.mean;
                    vm.stdev = response.stdev;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data, vm.user.preferred_measurement_unit);
                    points(vm.data);
                    tooltips(vm.data, vm.user.preferred_measurement_unit);
                    annotations(vm.mean, vm.stdev, vm.user.preferred_measurement_unit);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var points = _.map(data, function(test) {
                if (test.meter_reading !== null) {
                    return {x: moment(test.tested_on), y: formatMeasurement(parseFloat(test.meter_reading), test.measurement_unit)};
                }
            });

            vm.chartjs.datasetOverride[0].label = vm.level;
            vm.chartjs.data = [points];
        }

        function xAxes(tests) {
            var minTest = _.minBy(tests, 'tested_on');
            var maxTest = _.maxBy(tests, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests, measurementUnit) {
            var minTest = _.minBy(tests, 'meter_reading');
            var maxTest = _.maxBy(tests, 'meter_reading');

            if (measurementUnit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 0.5 : 1.7;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 0.5 : 3.3;
                var stepSize = (min + max) / 2;
                // Primary axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.01;
            } else {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 9 : 30;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 9 : 60;
                var stepSize = (min + max) / 2;

                // Primary Axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.01;
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatMeasurement(parseFloat(value), measurementUnit);
            };
        }

        function tooltips(tests, measurementUnit) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return [
                        vm.tooltips.reading + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[measurementUnit],
                        vm.tooltips.stripLot + ' ' + tests[tooltipItem.index].test_strip.lot_no,
                        vm.tooltips.controlLot + ' ' + tests[tooltipItem.index].control_solution.lot_no
                    ];
                }
            };
        }

        function annotations(mean, stdev, measurementUnit) {
            var annotations = [];
            var m = null;
            var sd1 = null;
            var _sd1 = null;
            var sd2 = null;
            var _sd2 = null;
            var sd3 = null;
            var _sd3 = null;

            // mean
            if (mean) {
                m = formatMeasurement(mean, measurementUnit);
                annotations.push(annotation(m, 8, {borderWidth: 2}, vm.annotations.mean + ' (' + m + ')'));
            }

            if (stdev) {
                sd1 = formatMeasurement(mean + stdev, measurementUnit);
                _sd1 = formatMeasurement(mean - stdev, measurementUnit);
                sd2 = formatMeasurement(mean + stdev * 2, measurementUnit);
                _sd2 = formatMeasurement (mean - stdev * 2, measurementUnit);
                sd3 = formatMeasurement(mean + stdev * 3, measurementUnit);
                _sd3 = formatMeasurement(mean - stdev * 3, measurementUnit);
                annotations.push(annotation(sd1, 8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, '+1' + vm.annotations.sd + ' (' + sd1 + ')'));
                annotations.push(annotation(_sd1, -8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, '-1' + vm.annotations.sd + ' (' + _sd1 + ')'));
                annotations.push(annotation(sd2, 8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, '+2' + vm.annotations.sd + ' (' + sd2 + ')'));
                annotations.push(annotation(_sd2, -8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, '-2' + vm.annotations.sd + ' (' + _sd2 + ')'));
                annotations.push(annotation(sd3, 8, {borderWidth: 1}, '+3' + vm.annotations.sd + ' (' + sd3 + ')'));
                annotations.push(annotation(_sd3, -8, {borderWidth: 1}, '-3' + vm.annotations.sd + ' (' + _sd3 + ')'));
            }

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(m && value == m) return vm.annotations.mean + ' (' + m + ')';
                if(sd1 && value == sd1) return '+1' + vm.annotations.sd + ' (' + sd1 + ')';
                if(_sd1 && value == _sd1) return '-1' + vm.annotations.sd + ' (' + _sd1 + ')';
                if(sd2 && value == sd2) return '+2' + vm.annotations.sd + ' (' + sd2 + ')';
                if(_sd2 && value == _sd2) return '-2' + vm.annotations.sd + ' (' + _sd2 + ')';
                if(sd2 && value == sd3) return '+3' + vm.annotations.sd + ' (' + sd3 + ')';
                if(_sd2 && value == _sd3) return '-3' + vm.annotations.sd + ' (' + _sd3 + ')';
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function formatMeasurement(value, measurementUnit) {
          if (measurementUnit == 'MMOL_PER_L') {
            return value.toFixed(1);
          }
          else if (measurementUnit == 'MG_PER_DL') {
            return value.toFixed(0);
          }

          return value;
        }

        function translate() {
            return $translate([
                'QC_REPORT_SINGLE.TITLE',
                'QC_REPORT_SINGLE.COUNTRY',
                'QC_REPORT_SINGLE.STATE',
                'QC_REPORT_SINGLE.HOSPITAL',
                'QC_REPORT_SINGLE.START_DATE',
                'QC_REPORT_SINGLE.END_DATE',
                'QC_REPORT_SINGLE.METER_SERIAL_NO',
                'QC_REPORT_SINGLE_LEVEL1.TITLE',
                'QC_REPORT_SINGLE_LEVEL1.FILTERS.STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL1.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL1.FILTERS.CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL1.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL1.CHART.TITLE',
                'QC_REPORT_SINGLE_LEVEL1.CHART.X_AXIS',
                'QC_REPORT_SINGLE_LEVEL1.CHART.Y_AXIS',
                'QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.READING',
                'QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.CONTROL_LOT',
                'QC_REPORT_SINGLE_LEVEL1.CHART.ANNOTATION.MEAN',
                'QC_REPORT_SINGLE_LEVEL1.CHART.ANNOTATION.SD',

                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_SINGLE.TITLE'],
                    title: translations['QC_REPORT_SINGLE_LEVEL1.TITLE'],
                    country: translations['QC_REPORT_SINGLE.COUNTRY'],
                    state: translations['QC_REPORT_SINGLE.STATE'],
                    hospital: translations['QC_REPORT_SINGLE.HOSPITAL'],
                    startDate: translations['QC_REPORT_SINGLE.START_DATE'],
                    endDate: translations['QC_REPORT_SINGLE.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_SINGLE.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_SINGLE_LEVEL1.FILTERS.ALL_CONTROL_LOT'],
                };

                vm.chart = {
                    title: translations['QC_REPORT_SINGLE_LEVEL1.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_SINGLE_LEVEL1.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_SINGLE_LEVEL1.CHART.Y_AXIS']
                };

                vm.tooltips = {
                    reading: translations['QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.READING'],
                    stripLot: translations['QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_LEVEL1.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.annotations = {
                    mean: translations['QC_REPORT_SINGLE_LEVEL1.CHART.ANNOTATION.MEAN'],
                    sd: translations['QC_REPORT_SINGLE_LEVEL1.CHART.ANNOTATION.SD']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.single.combined', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-single-combined', {
                url    : '/qc-report-single-combined',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/single/combined/combined.html',
                        controller : 'SingleCombinedController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin', 'hospital_operator']
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/single/combined');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.single.ljchart', ['/reports/single/ljchart']);

        msNavigationServiceProvider.saveItem('qc-report-single.combined', {
            title : 'L-J Chart – Combined',
            state: 'app.qc-report-single-combined',
            weight: 16,
            translate: 'QC_REPORT_SINGLE_COMBINED.NAV'
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.qc-report.single.combined')
        .component('singleCombinedHospitalAdmin', {
            templateUrl: 'app/main/qc-report/single/combined/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, localStorageService, $mdSelect, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.meterColumns = [];
        vm.meters = [];
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions1 = [];
        vm.controlLot1 = [];

        vm.controlSolutions2 = [];
        vm.controlLot2 = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.stripLotChanged = stripLotChanged;
        vm.controlLot1Changed = controlLot1Changed;
        vm.controlLot2Changed = controlLot2Changed;
        vm.getStripLotText = getStripLotText;
        vm.getControlLot1Text = getControlLot1Text;
        vm.getControlLot2Text = getControlLot2Text;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#29b6f6",
                        borderColor: "#29b6f6",
                        pointBorderColor: "#29b6f6",
                        pointBackgroundColor: "#29b6f6",
                        pointHoverBackgroundColor: "#29b6f6",
                        pointHoverBorderColor: "#29b6f6"
                    },
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#66bb6a",
                        borderColor: "#66bb6a",
                        pointBorderColor: "#66bb6a",
                        pointBackgroundColor: "#66bb6a",
                        pointHoverBackgroundColor: "#66bb6a",
                        pointHoverBorderColor: "#66bb6a"
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left: 24
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: false
                                },
                                gridLines: {
                                    display: true
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing: 4
                    }
                }
            };

            getMeters();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function stripLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function controlLot1Changed() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function controlLot2Changed() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function getStripLotText() {
            var limit = 30;
            if (vm.stripLot && vm.stripLot.length) {
                if (vm.stripLot.length === vm.testStrips.length) {
                    return vm.filters.allStripLot;
                }

                var joined =  _.join(_.map(vm.stripLot, 'lot_no'), ', ');
                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');

            } else {
                return vm.filters.stripLot;
            }
        }

        function getControlLot1Text() {
            var limit = 30;
            if (vm.controlLot1 && vm.controlLot1.length) {
                if (vm.controlLot1.length === vm.controlSolutions1.length) {
                    return vm.filters.allControlLotLevel1;
                }

                var joined = _.join(_.map(vm.controlLot1, 'lot_no'), ',');
                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');

            } else {
                return vm.filters.controlLotLevel1;
            }
        }

        function getControlLot2Text() {
            var limit = 30;
            if (vm.controlLot2 && vm.controlLot2.length) {
                if (vm.controlLot2.length === vm.controlSolutions2.length) {
                    return vm.filters.allControlLotLevel2;
                }

                var joined = _.join(_.map(vm.controlLot2, 'lot_no'), ',');
                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');

            } else {
                return vm.filters.controlLotLevel2;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data);
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.startDate,
                                    style: 'small'
                                },
                                {
                                    text: moment(vm.startDate).format('YYYY-MM-DD')
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.endDate,
                                    style: 'small'
                                },
                                {
                                    text: moment(vm.endDate).format('YYYY-MM-DD')
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.stripLot,
                                    style: 'small'
                                },
                                {
                                    text: getStripLotText(),
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.controlLotLevel1,
                                    style: 'small'
                                },
                                {
                                    text: getControlLot1Text(),
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.controlLotLevel2,
                                    style: 'small'
                                },
                                {
                                    text: getControlLot2Text(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 20]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Combined-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function getMeters() {
            var locationIds = _.map(vm.user.locations, 'id');
            var params = {
                hospital_id: vm.user.hospitals[0].id,
                'location_ids[]': locationIds
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                var controlLot = vm.controlLot1.concat(vm.controlLot2);

                if (controlLot.length) {
                    var controlLotIds = _.map(controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions1 = response.control_solutions1;
                    var controlSolutions2 = response.control_solutions2;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions1, controlSolutions2);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data);
                    points(vm.data);
                    tooltips(vm.data);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions1, controlSolutions2) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions1 = controlSolutions1;
            vm.controlLot1 = controlSolutions1;

            vm.controlSolutions2 = controlSolutions2;
            vm.controlLot2 = controlSolutions2;
        }

        function points(data) {
            var level1 = [null];
            var level2 = [null];

            if( _.has(data, 'Level 1')) {
                level1 = _.map(data['Level 1'], function(test) {
                    return {x: moment(test.tested_on), y: test.zscore !== null ? test.zscore.toFixed(2) : null};
                });
            }

            if( _.has(data, 'Level 2')) {
                level2 = _.map(data['Level 2'], function(test) {
                    return {x: moment(test.tested_on), y: test.zscore !== null ? test.zscore.toFixed(2) :null};
                });
            }

            vm.chartjs.datasetOverride[0].label = 'Level 1';
            vm.chartjs.datasetOverride[1].label = 'Level 2';
            vm.chartjs.data = [level1, level2];
        }

        function xAxes(tests) {
            var flatten = _.flatten(_.map(tests, function(level) {
                return _.values(level);
            }));

            var minTest = _.minBy(flatten, 'tested_on');
            var maxTest = _.maxBy(flatten, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests) {
            var flatten = _.flatten(_.map(tests, function(level) {
                return _.values(level);
            }));

            vm.chartjs.options.scales.yAxes[0].ticks.min = (flatten.length && vm.zoomToFit) ? undefined : -3;
            vm.chartjs.options.scales.yAxes[0].ticks.max = (flatten.length && vm.zoomToFit) ? undefined : 3;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = 1;

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function(value) {
                if(value === 0) return vm.chart.mean;

                return (value > 0 ? '+' : '') + value + vm.chart.sd;
            };
        }

        function tooltips(tests) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + vm.tooltips.zScore + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                },
                afterLabel: function (tooltipItem, data) {
                    var level = tooltipItem.datasetIndex === 0 ? tests['Level 1'] : tests['Level 2'];
                    return [
                        ' ' + vm.tooltips.stripLot + ' ' + level[tooltipItem.index].test_strip.lot_no,
                        ' ' + vm.tooltips.controlLot + ' ' + level[tooltipItem.index].control_solution.lot_no];
                }
            };
        }

        function translate() {
            return $translate([
                'QC_REPORT_SINGLE.TITLE',
                'QC_REPORT_SINGLE.START_DATE',
                'QC_REPORT_SINGLE.END_DATE',
                'QC_REPORT_SINGLE.METER_SERIAL_NO',
                'QC_REPORT_SINGLE_COMBINED.TITLE',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.STRIP_LOT',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL1',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL2',
                'QC_REPORT_SINGLE_COMBINED.CHART.TITLE',
                'QC_REPORT_SINGLE_COMBINED.CHART.X_AXIS',
                'QC_REPORT_SINGLE_COMBINED.CHART.MEAN',
                'QC_REPORT_SINGLE_COMBINED.CHART.SD',
                'QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.Z_SCORE',
                'QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.CONTROL_LOT',

                'QC_REPORT_SINGLE.MESSAGES.SELECT_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_SINGLE.TITLE'],
                    title: translations['QC_REPORT_SINGLE_COMBINED.TITLE'],
                    startDate: translations['QC_REPORT_SINGLE.START_DATE'],
                    endDate: translations['QC_REPORT_SINGLE.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_SINGLE.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1'],
                    allControlLotLevel1: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2'],
                    allControlLotLevel2: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL2']
                };

                vm.chart = {
                    title: translations['QC_REPORT_SINGLE_COMBINED.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_SINGLE_COMBINED.CHART.X_AXIS'],
                    mean: translations['QC_REPORT_SINGLE_COMBINED.CHART.MEAN'],
                    sd: translations['QC_REPORT_SINGLE_COMBINED.CHART.SD']
                };

                vm.tooltips = {
                    zScore: translations['QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.Z_SCORE'],
                    stripLot: translations['QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'],
                    selectMeter: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_METER']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        $scope.$watch('vm.subFilterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.single.combined')
        .component('singleCombinedGlobalAdmin', {
            templateUrl: 'app/main/qc-report/single/combined/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, localStorageService, $mdSelect, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 1';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#29b6f6",
                        borderColor: "#29b6f6",
                        pointBorderColor: "#29b6f6",
                        pointBackgroundColor: "#29b6f6",
                        pointHoverBackgroundColor: "#29b6f6",
                        pointHoverBorderColor: "#29b6f6"
                    },
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#66bb6a",
                        borderColor: "#66bb6a",
                        pointBorderColor: "#66bb6a",
                        pointBackgroundColor: "#66bb6a",
                        pointHoverBackgroundColor: "#66bb6a",
                        pointHoverBorderColor: "#66bb6a"
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left: 24
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: false
                                },
                                gridLines: {
                                    display: true
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing: 4
                    }
                }
            };

            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.meter = null;
            meterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.meter && vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.country,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedCountry.name
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.state,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedState.name
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Combined-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                var controlLot = vm.controlLot1.concat(vm.controlLot2);

                if (controlLot.length) {
                    var controlLotIds = _.map(controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions1 = response.control_solutions1;
                    var controlSolutions2 = response.control_solutions2;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions1, controlSolutions2);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data);
                    points(vm.data);
                    tooltips(vm.data);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions1, controlSolutions2) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions1 = controlSolutions1;
            vm.controlLot1 = controlSolutions1;

            vm.controlSolutions2 = controlSolutions2;
            vm.controlLot2 = controlSolutions2;
        }

        function points(data) {
            var level1 = [null];
            var level2 = [null];

            if( _.has(data, 'Level 1')) {
                level1 = _.map(data['Level 1'], function(test) {
                    return {x: moment(test.tested_on), y: test.zscore !== null ? test.zscore.toFixed(2) : null};
                });
            }

            if( _.has(data, 'Level 2')) {
                level2 = _.map(data['Level 2'], function(test) {
                    return {x: moment(test.tested_on), y: test.zscore !== null ? test.zscore.toFixed(2) :null};
                });
            }

            vm.chartjs.datasetOverride[0].label = 'Level 1';
            vm.chartjs.datasetOverride[1].label = 'Level 2';
            vm.chartjs.data = [level1, level2];
        }

        function xAxes(tests) {
            var flatten = _.flatten(_.map(tests, function(level) {
                return _.values(level);
            }));

            var minTest = _.minBy(flatten, 'tested_on');
            var maxTest = _.maxBy(flatten, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests) {
            var flatten = _.flatten(_.map(tests, function(level) {
                return _.values(level);
            }));

            vm.chartjs.options.scales.yAxes[0].ticks.min = (flatten.length && vm.zoomToFit) ? undefined : -3;
            vm.chartjs.options.scales.yAxes[0].ticks.max = (flatten.length && vm.zoomToFit) ? undefined : 3;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = 1;

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function(value) {
                if(value === 0) return vm.chart.mean;

                return (value > 0 ? '+' : '') + value + vm.chart.sd;
            };
        }

        function tooltips(tests) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + vm.tooltips.zScore + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                },
                afterLabel: function (tooltipItem, data) {
                    var level = tooltipItem.datasetIndex === 0 ? tests['Level 1'] : tests['Level 2'];
                    return [
                        ' ' + vm.tooltips.stripLot + ' ' + level[tooltipItem.index].test_strip.lot_no,
                        ' ' + vm.tooltips.controlLot + ' ' + level[tooltipItem.index].control_solution.lot_no];
                }
            };
        }

        function translate() {
            return $translate([
                'QC_REPORT_SINGLE.TITLE',
                'QC_REPORT_SINGLE.COUNTRY',
                'QC_REPORT_SINGLE.STATE',
                'QC_REPORT_SINGLE.HOSPITAL',
                'QC_REPORT_SINGLE.START_DATE',
                'QC_REPORT_SINGLE.END_DATE',
                'QC_REPORT_SINGLE.METER_SERIAL_NO',

                'QC_REPORT_SINGLE_COMBINED.TITLE',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.STRIP_LOT',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL1',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL2',
                'QC_REPORT_SINGLE_COMBINED.CHART.TITLE',
                'QC_REPORT_SINGLE_COMBINED.CHART.X_AXIS',
                'QC_REPORT_SINGLE_COMBINED.CHART.MEAN',
                'QC_REPORT_SINGLE_COMBINED.CHART.SD',
                'QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.Z_SCORE',
                'QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.CONTROL_LOT',

                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_SINGLE.TITLE'],
                    title: translations['QC_REPORT_SINGLE_COMBINED.TITLE'],
                    country: translations['QC_REPORT_SINGLE.COUNTRY'],
                    state: translations['QC_REPORT_SINGLE.STATE'],
                    hospital: translations['QC_REPORT_SINGLE.HOSPITAL'],
                    startDate: translations['QC_REPORT_SINGLE.START_DATE'],
                    endDate: translations['QC_REPORT_SINGLE.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_SINGLE.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1'],
                    allControlLotLevel1: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2'],
                    allControlLotLevel2: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL2']
                };

                vm.chart = {
                    title: translations['QC_REPORT_SINGLE_COMBINED.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_SINGLE_COMBINED.CHART.X_AXIS'],
                    mean: translations['QC_REPORT_SINGLE_COMBINED.CHART.MEAN'],
                    sd: translations['QC_REPORT_SINGLE_COMBINED.CHART.SD']
                };

                vm.tooltips = {
                    zScore: translations['QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.Z_SCORE'],
                    stripLot: translations['QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.single.combined')
        .component('singleCombinedCountryAdmin', {
            templateUrl: 'app/main/qc-report/single/combined/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, localStorageService, $mdSelect, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 1';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#29b6f6",
                        borderColor: "#29b6f6",
                        pointBorderColor: "#29b6f6",
                        pointBackgroundColor: "#29b6f6",
                        pointHoverBackgroundColor: "#29b6f6",
                        pointHoverBorderColor: "#29b6f6"
                    },
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#66bb6a",
                        borderColor: "#66bb6a",
                        pointBorderColor: "#66bb6a",
                        pointBackgroundColor: "#66bb6a",
                        pointHoverBackgroundColor: "#66bb6a",
                        pointHoverBorderColor: "#66bb6a"
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left: 24
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: false
                                },
                                gridLines: {
                                    display: true
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing: 4
                    }
                }
            };

            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.meter = null;
            meterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.meter && vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.state,
                                    style: 'small'
                                },
                                {
                                    text:  vm.selectedState.name,
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name,
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Combined-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                var controlLot = vm.controlLot1.concat(vm.controlLot2);

                if (controlLot.length) {
                    var controlLotIds = _.map(controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions1 = response.control_solutions1;
                    var controlSolutions2 = response.control_solutions2;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions1, controlSolutions2);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data);
                    points(vm.data);
                    tooltips(vm.data);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions1, controlSolutions2) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions1 = controlSolutions1;
            vm.controlLot1 = controlSolutions1;

            vm.controlSolutions2 = controlSolutions2;
            vm.controlLot2 = controlSolutions2;
        }

        function points(data) {
            var level1 = [null];
            var level2 = [null];

            if( _.has(data, 'Level 1')) {
                level1 = _.map(data['Level 1'], function(test) {
                    return {x: moment(test.tested_on), y: test.zscore !== null ? test.zscore.toFixed(2) : null};
                });
            }

            if( _.has(data, 'Level 2')) {
                level2 = _.map(data['Level 2'], function(test) {
                    return {x: moment(test.tested_on), y: test.zscore !== null ? test.zscore.toFixed(2) :null};
                });
            }

            vm.chartjs.datasetOverride[0].label = 'Level 1';
            vm.chartjs.datasetOverride[1].label = 'Level 2';
            vm.chartjs.data = [level1, level2];
        }

        function xAxes(tests) {
            var flatten = _.flatten(_.map(tests, function(level) {
                return _.values(level);
            }));

            var minTest = _.minBy(flatten, 'tested_on');
            var maxTest = _.maxBy(flatten, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests) {
            var flatten = _.flatten(_.map(tests, function(level) {
                return _.values(level);
            }));

            vm.chartjs.options.scales.yAxes[0].ticks.min = (flatten.length && vm.zoomToFit) ? undefined : -3;
            vm.chartjs.options.scales.yAxes[0].ticks.max = (flatten.length && vm.zoomToFit) ? undefined : 3;
            vm.chartjs.options.scales.yAxes[0].ticks.stepSize = 1;

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function(value) {
                if(value === 0) return vm.chart.mean;

                return (value > 0 ? '+' : '') + value + vm.chart.sd;
            };
        }

        function tooltips(tests) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + vm.tooltips.zScore + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y;
                },
                afterLabel: function (tooltipItem, data) {
                    var level = tooltipItem.datasetIndex === 0 ? tests['Level 1'] : tests['Level 2'];
                    return [
                        ' ' + vm.tooltips.stripLot + ' ' + level[tooltipItem.index].test_strip.lot_no,
                        ' ' + vm.tooltips.controlLot + ' ' + level[tooltipItem.index].control_solution.lot_no];
                }
            };
        }

        function translate() {
            return $translate([
                'QC_REPORT_SINGLE.TITLE',
                'QC_REPORT_SINGLE.COUNTRY',
                'QC_REPORT_SINGLE.STATE',
                'QC_REPORT_SINGLE.HOSPITAL',
                'QC_REPORT_SINGLE.START_DATE',
                'QC_REPORT_SINGLE.END_DATE',
                'QC_REPORT_SINGLE.METER_SERIAL_NO',

                'QC_REPORT_SINGLE_COMBINED.TITLE',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.STRIP_LOT',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL1',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2',
                'QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL2',
                'QC_REPORT_SINGLE_COMBINED.CHART.TITLE',
                'QC_REPORT_SINGLE_COMBINED.CHART.X_AXIS',
                'QC_REPORT_SINGLE_COMBINED.CHART.MEAN',
                'QC_REPORT_SINGLE_COMBINED.CHART.SD',
                'QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.Z_SCORE',
                'QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.CONTROL_LOT',

                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_STATE',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_SINGLE.MESSAGES.SELECT_METER',
                'QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_SINGLE.TITLE'],
                    title: translations['QC_REPORT_SINGLE_COMBINED.TITLE'],
                    country: translations['QC_REPORT_SINGLE.COUNTRY'],
                    state: translations['QC_REPORT_SINGLE.STATE'],
                    hospital: translations['QC_REPORT_SINGLE.HOSPITAL'],
                    startDate: translations['QC_REPORT_SINGLE.START_DATE'],
                    endDate: translations['QC_REPORT_SINGLE.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_SINGLE.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_STRIP_LOT'],
                    controlLotLevel1: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1'],
                    allControlLotLevel1: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL1'],
                    controlLotLevel2: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2'],
                    allControlLotLevel2: translations['QC_REPORT_SINGLE_COMBINED.FILTERS.ALL_CONTROL_LOT_LEVEL2']
                };

                vm.chart = {
                    title: translations['QC_REPORT_SINGLE_COMBINED.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_SINGLE_COMBINED.CHART.X_AXIS'],
                    mean: translations['QC_REPORT_SINGLE_COMBINED.CHART.MEAN'],
                    sd: translations['QC_REPORT_SINGLE_COMBINED.CHART.SD']
                };

                vm.tooltips = {
                    zScore: translations['QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.Z_SCORE'],
                    stripLot: translations['QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_SINGLE_COMBINED.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_SINGLE.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_SINGLE.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.mfr-control-limits.level1', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-mfr-control-limits-level1', {
                url    : '/qc-report-mfr-control-limits-level1',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/mfr-control-limits/level1/level1.html',
                        controller : 'MfrControlLimitsLevel1Controller as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin', 'hospital_operator']
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/mfr-control-limits/level1');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.single.ljchart', ['/reports/single/ljchart']);

        msNavigationServiceProvider.saveItem('qc-report-mfr-control-limits.level1', {
            title : 'L-J Chart – Level 1',
            state: 'app.qc-report-mfr-control-limits-level1',
            weight: 14,
            translate: 'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.NAV'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.mfr-control-limits.level1')
        .component('mfrControlLimitsLevel1HospitalAdmin', {
            templateUrl: 'app/main/qc-report/mfr-control-limits/level1/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, localStorageService, $mdSelect, $filter, CONFIG, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 1';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.meterColumns = [];
        vm.meters = [];
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.stripLotChanged = stripLotChanged;
        vm.controlLotChanged = controlLotChanged;
        vm.getStripLotText = getStripLotText;
        vm.getControlLotText = getControlLotText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#29b6f6",
                        borderColor: "#29b6f6",
                        pointBorderColor: "#29b6f6",
                        pointBackgroundColor: "#29b6f6",
                        pointHoverBackgroundColor: "#29b6f6",
                        pointHoverBorderColor: "#29b6f6",
                        showLine: true
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left:16
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: false,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        bodySpacing: 4,
                        displayColors: false
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            getMeters();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function stripLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function controlLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function getStripLotText() {
            var limit = 50;
            if (vm.stripLot && vm.stripLot.length) {
                if (vm.stripLot.length === vm.testStrips.length) {
                    return vm.filters.allStripLot;
                }
                var joined =  _.join(_.map(vm.stripLot, 'lot_no'), ', ');

                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
            } else {
                return vm.filters.stripLot;
            }
        }

        function getControlLotText() {
            var limit = 50;
            if (vm.controlLot && vm.controlLot.length) {
                if (vm.controlLot.length === vm.controlSolutions.length) {
                    return vm.filters.allControlLot;
                }
                var joined = _.join(_.map(vm.controlLot, 'lot_no'), ', ');

                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
            } else {
                return vm.filters.controlLot;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.stripLot,
                                    style: 'small'
                                },
                                {
                                    text: getStripLotText(),
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.controlLot,
                                    style: 'small'
                                },
                                {
                                    text: getControlLotText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 20]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data, vm.user.preferred_measurement_unit);
        }

        function getMeters() {
            var locationIds = _.map(vm.user.locations, 'id');
            var params = {
                hospital_id: vm.user.hospitals[0].id,
                'location_ids[]': locationIds
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                level: vm.level,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                if (vm.controlLot.length) {
                    var controlLotIds = _.map(vm.controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions = response.control_solutions;
                    vm.mean = response.meanMfr;
                    vm.stdev = response.stdevMfr;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data, vm.user.preferred_measurement_unit);
                    points(vm.data);
                    tooltips(vm.data, vm.user.preferred_measurement_unit);
                    annotations(vm.mean, vm.stdev, vm.user.preferred_measurement_unit);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var points = _.map(data, function(test) {
                if (test.meter_reading !== null) {
                    return {x: moment(test.tested_on), y: formatMeasurement(parseFloat(test.meter_reading), test.measurement_unit)};
                }
            });

            vm.chartjs.datasetOverride[0].label = vm.level;
            vm.chartjs.data = [points];
        }

        function xAxes(tests) {
            var minTest = _.minBy(tests, 'tested_on');
            var maxTest = _.maxBy(tests, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests, measurementUnit) {
            var minTest = _.minBy(tests, 'meter_reading');
            var maxTest = _.maxBy(tests, 'meter_reading');

            if (measurementUnit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 0.5 : 1.7;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 0.5 : 3.3;
                var stepSize = (min + max) / 2;
                // Primary axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.1;
            } else {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 9 : 30;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 9 : 60;
                var stepSize = (min + max) / 2;

                // Primary Axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1.0;
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatMeasurement(parseFloat(value), measurementUnit);
            };
        }

        function tooltips(tests, measurementUnit) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return [
                        vm.tooltips.reading + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[measurementUnit],
                        vm.tooltips.stripLot + ' ' + tests[tooltipItem.index].test_strip.lot_no,
                        vm.tooltips.controlLot + ' ' + tests[tooltipItem.index].control_solution.lot_no
                    ];
                }
            };
        }

        function annotations(mean, stdev, measurementUnit) {
            var annotations = [];
            var m = null;
            var sd1 = null;
            var _sd1 = null;
            var sd2 = null;
            var _sd2 = null;
            var sd3 = null;
            var _sd3 = null;

            // mean
            if (mean) {
                m = formatMeasurement(mean, measurementUnit);
                annotations.push(annotation(m, 8, {borderWidth: 2}, m + ' (' + vm.annotations.mean + ')'));
            }

            if (stdev) {
                sd1 = formatMeasurement(mean + stdev, measurementUnit);
                _sd1 = formatMeasurement(mean - stdev, measurementUnit);
                sd2 = formatMeasurement(mean + stdev * 2, measurementUnit);
                _sd2 = formatMeasurement (mean - stdev * 2, measurementUnit);
                sd3 = formatMeasurement(mean + stdev * 3, measurementUnit);
                _sd3 = formatMeasurement(mean - stdev * 3, measurementUnit);
                //annotations.push(annotation(sd1, 8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, sd1));
                //annotations.push(annotation(_sd1, -8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, _sd1));
                //annotations.push(annotation(sd2, 8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, sd2));
                //annotations.push(annotation(_sd2, -8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, _sd2));
                annotations.push(annotation(sd3, 8, {borderWidth: 1}, sd3 + ' (' + vm.annotations.upperLimit + ')'));
                annotations.push(annotation(_sd3, -8, {borderWidth: 1}, _sd3 + ' (' + vm.annotations.lowerLimit + ')'));
            }

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(m && value == m) return m + ' (' + vm.annotations.mean + ')';
                //if(sd1 && value.toFixed(2) === sd1) return sd1;
                //if(_sd1 && value.toFixed(2) === _sd1) return  _sd1;
                //if(sd2 && value.toFixed(2) === sd2) return sd2;
                //if(_sd2 && value.toFixed(2) === _sd2) return _sd2;
                if(sd3 && value == sd3) return  sd3 + ' (' + vm.annotations.upperLimit + ')';
                if(_sd3 && value == _sd3) return  _sd3 + ' (' + vm.annotations.lowerLimit + ')';
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function formatMeasurement(value, measurementUnit) {
          if (measurementUnit == 'MMOL_PER_L') {
            return value.toFixed(1);
          }
          else if (measurementUnit == 'MG_PER_DL') {
            return value.toFixed(0);
          }

          return value;
        }

        function translate() {
            return $translate([
                'QC_REPORT_MFR_CONTROL_LIMITS.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS.START_DATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.END_DATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.X_AXIS',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.Y_AXIS',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.READING',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.MEAN',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.UPPER_LIMIT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.LOWER_LIMIT',

                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_METER',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MFR_CONTROL_LIMITS.TITLE'],
                    title: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.TITLE'],
                    startDate: translations['QC_REPORT_MFR_CONTROL_LIMITS.START_DATE'],
                    endDate: translations['QC_REPORT_MFR_CONTROL_LIMITS.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.ALL_CONTROL_LOT'],
                };

                vm.chart = {
                    title: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.Y_AXIS']
                };

                vm.tooltips = {
                    reading: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.READING'],
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.annotations = {
                    mean: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.MEAN'],
                    upperLimit: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.UPPER_LIMIT'],
                    lowerLimit: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.LOWER_LIMIT']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER'],
                    selectMeter: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_METER']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        $scope.$watch('vm.subFilterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();


(function() {
    'use strict';

    angular
        .module('app.qc-report.mfr-control-limits.level1')
        .component('mfrControlLimitsLevel1GlobalAdmin', {
            templateUrl: 'app/main/qc-report/mfr-control-limits/level1/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 1';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#29b6f6",
                        borderColor: "#29b6f6",
                        pointBorderColor: "#29b6f6",
                        pointBackgroundColor: "#29b6f6",
                        pointHoverBackgroundColor: "#29b6f6",
                        pointHoverBorderColor: "#29b6f6",
                        showLine: true
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left:16
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: false,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        bodySpacing: 4,
                        displayColors: false
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.meter = null;
            meterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.meter && vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.country,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedCountry.name
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.state,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedState.name
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data, vm.user.preferred_measurement_unit);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                level: vm.level,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                if (vm.controlLot.length) {
                    var controlLotIds = _.map(vm.controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions = response.control_solutions;
                    vm.mean = response.meanMfr;
                    vm.stdev = response.stdevMfr;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data, vm.user.preferred_measurement_unit);
                    points(vm.data);
                    tooltips(vm.data, vm.user.preferred_measurement_unit);
                    annotations(vm.mean, vm.stdev, vm.user.preferred_measurement_unit);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var points = _.map(data, function(test) {
                if (test.meter_reading !== null) {
                    return {x: moment(test.tested_on), y: formatMeasurement(parseFloat(test.meter_reading), test.measurement_unit)};
                }
            });

            vm.chartjs.datasetOverride[0].label = vm.level;
            vm.chartjs.data = [points];
        }

        function xAxes(tests) {
            var minTest = _.minBy(tests, 'tested_on');
            var maxTest = _.maxBy(tests, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests, measurementUnit) {
            var minTest = _.minBy(tests, 'meter_reading');
            var maxTest = _.maxBy(tests, 'meter_reading');

            if (measurementUnit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 0.5 : 1.7;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 0.5 : 3.3;
                var stepSize = (min + max) / 2;
                // Primary axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.1;
            } else {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 9 : 30;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 9 : 60;
                var stepSize = (min + max) / 2;

                // Primary Axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1.0;
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatMeasurement(parseFloat(value), measurementUnit);
            };
        }

        function tooltips(tests, measurementUnit) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return [
                        vm.tooltips.reading + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[measurementUnit],
                        vm.tooltips.stripLot + ' ' + tests[tooltipItem.index].test_strip.lot_no,
                        vm.tooltips.controlLot + ' ' + tests[tooltipItem.index].control_solution.lot_no
                    ];
                }
            };
        }

        function annotations(mean, stdev, measurementUnit) {
            var annotations = [];
            var m = null;
            var sd1 = null;
            var _sd1 = null;
            var sd2 = null;
            var _sd2 = null;
            var sd3 = null;
            var _sd3 = null;

            // mean
            if (mean) {
                m = formatMeasurement(mean, measurementUnit);
                annotations.push(annotation(m, 8, {borderWidth: 2}, m + ' (' + vm.annotations.mean + ')'));
            }

            if (stdev) {
                sd1 = formatMeasurement(mean + stdev, measurementUnit);
                _sd1 = formatMeasurement(mean - stdev, measurementUnit);
                sd2 = formatMeasurement(mean + stdev * 2, measurementUnit);
                _sd2 = formatMeasurement (mean - stdev * 2, measurementUnit);
                sd3 = formatMeasurement(mean + stdev * 3, measurementUnit);
                _sd3 = formatMeasurement(mean - stdev * 3, measurementUnit);
                //annotations.push(annotation(sd1, 8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, sd1));
                //annotations.push(annotation(_sd1, -8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, _sd1));
                //annotations.push(annotation(sd2, 8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, sd2));
                //annotations.push(annotation(_sd2, -8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, _sd2));
                annotations.push(annotation(sd3, 8, {borderWidth: 1}, sd3 + ' (' + vm.annotations.upperLimit + ')'));
                annotations.push(annotation(_sd3, -8, {borderWidth: 1}, _sd3 + ' (' + vm.annotations.lowerLimit + ')'));
            }

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(m && value == m) return m + ' (' + vm.annotations.mean + ')';
                //if(sd1 && value.toFixed(2) === sd1) return sd1;
                //if(_sd1 && value.toFixed(2) === _sd1) return  _sd1;
                //if(sd2 && value.toFixed(2) === sd2) return sd2;
                //if(_sd2 && value.toFixed(2) === _sd2) return _sd2;
                if(sd3 && value == sd3) return  sd3 + ' (' + vm.annotations.upperLimit + ')';
                if(_sd3 && value == _sd3) return  _sd3 + ' (' + vm.annotations.lowerLimit + ')';
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function formatMeasurement(value, measurementUnit) {
          if (measurementUnit == 'MMOL_PER_L') {
            return value.toFixed(1);
          }
          else if (measurementUnit == 'MG_PER_DL') {
            return value.toFixed(0);
          }

          return value;
        }

        function translate() {
            return $translate([
                'QC_REPORT_MFR_CONTROL_LIMITS.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS.COUNTRY',
                'QC_REPORT_MFR_CONTROL_LIMITS.STATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.HOSPITAL',
                'QC_REPORT_MFR_CONTROL_LIMITS.START_DATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.END_DATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO',

                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.X_AXIS',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.Y_AXIS',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.READING',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.MEAN',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.UPPER_LIMIT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.LOWER_LIMIT',

                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_STATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_METER',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_STATE_IN',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MFR_CONTROL_LIMITS.TITLE'],
                    title: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.TITLE'],
                    country: translations['QC_REPORT_MFR_CONTROL_LIMITS.COUNTRY'],
                    state: translations['QC_REPORT_MFR_CONTROL_LIMITS.STATE'],
                    hospital: translations['QC_REPORT_MFR_CONTROL_LIMITS.HOSPITAL'],
                    startDate: translations['QC_REPORT_MFR_CONTROL_LIMITS.START_DATE'],
                    endDate: translations['QC_REPORT_MFR_CONTROL_LIMITS.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.ALL_CONTROL_LOT'],
                };

                vm.chart = {
                    title: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.Y_AXIS']
                };

                vm.tooltips = {
                    reading: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.READING'],
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.annotations = {
                    mean: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.MEAN'],
                    upperLimit: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.UPPER_LIMIT'],
                    lowerLimit: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.LOWER_LIMIT']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.mfr-control-limits.level1')
        .component('mfrControlLimitsLevel1CountryAdmin', {
            templateUrl: 'app/main/qc-report/mfr-control-limits/level1/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 1';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#29b6f6",
                        borderColor: "#29b6f6",
                        pointBorderColor: "#29b6f6",
                        pointBackgroundColor: "#29b6f6",
                        pointHoverBackgroundColor: "#29b6f6",
                        pointHoverBorderColor: "#29b6f6",
                        showLine: true
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left:16
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: false,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        bodySpacing: 4,
                        displayColors: false
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.meter = null;
            meterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.meter && vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.state,
                                    style: 'small'
                                },
                                {
                                    text:  vm.selectedState.name,
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name,
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data, vm.user.preferred_measurement_unit);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                level: vm.level,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                if (vm.controlLot.length) {
                    var controlLotIds = _.map(vm.controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions = response.control_solutions;
                    vm.mean = response.meanMfr;
                    vm.stdev = response.stdevMfr;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data, vm.user.preferred_measurement_unit);
                    points(vm.data);
                    tooltips(vm.data, vm.user.preferred_measurement_unit);
                    annotations(vm.mean, vm.stdev, vm.user.preferred_measurement_unit);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var points = _.map(data, function(test) {
                if (test.meter_reading !== null) {
                    return {x: moment(test.tested_on), y: formatMeasurement(parseFloat(test.meter_reading), test.measurement_unit)};
                }
            });

            vm.chartjs.datasetOverride[0].label = vm.level;
            vm.chartjs.data = [points];
        }

        function xAxes(tests) {
            var minTest = _.minBy(tests, 'tested_on');
            var maxTest = _.maxBy(tests, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests, measurementUnit) {
            var minTest = _.minBy(tests, 'meter_reading');
            var maxTest = _.maxBy(tests, 'meter_reading');

            if (measurementUnit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 0.5 : 1.7;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 0.5 : 3.3;
                var stepSize = (min + max) / 2;
                // Primary axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.1;
            } else {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 9 : 30;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 9 : 60;
                var stepSize = (min + max) / 2;

                // Primary Axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1.0;
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatMeasurement(parseFloat(value), measurementUnit);
            };
        }

        function tooltips(tests, measurementUnit) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return [
                        vm.tooltips.reading + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[measurementUnit],
                        vm.tooltips.stripLot + ' ' + tests[tooltipItem.index].test_strip.lot_no,
                        vm.tooltips.controlLot + ' ' + tests[tooltipItem.index].control_solution.lot_no
                    ];
                }
            };
        }

        function annotations(mean, stdev, measurementUnit) {
            var annotations = [];
            var m = null;
            var sd1 = null;
            var _sd1 = null;
            var sd2 = null;
            var _sd2 = null;
            var sd3 = null;
            var _sd3 = null;

            // mean
            if (mean) {
                m = formatMeasurement(mean, measurementUnit);
                annotations.push(annotation(m, 8, {borderWidth: 2}, m + ' (' + vm.annotations.mean + ')'));
            }

            if (stdev) {
                sd1 = formatMeasurement(mean + stdev, measurementUnit);
                _sd1 = formatMeasurement(mean - stdev, measurementUnit);
                sd2 = formatMeasurement(mean + stdev * 2, measurementUnit);
                _sd2 = formatMeasurement (mean - stdev * 2, measurementUnit);
                sd3 = formatMeasurement(mean + stdev * 3, measurementUnit);
                _sd3 = formatMeasurement(mean - stdev * 3, measurementUnit);
                //annotations.push(annotation(sd1, 8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, sd1));
                //annotations.push(annotation(_sd1, -8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, _sd1));
                //annotations.push(annotation(sd2, 8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, sd2));
                //annotations.push(annotation(_sd2, -8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, _sd2));
                annotations.push(annotation(sd3, 8, {borderWidth: 1}, sd3 + ' (' + vm.annotations.upperLimit + ')'));
                annotations.push(annotation(_sd3, -8, {borderWidth: 1}, _sd3 + ' (' + vm.annotations.lowerLimit + ')'));
            }

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(m && value == m) return m + ' (' + vm.annotations.mean + ')';
                //if(sd1 && value.toFixed(2) === sd1) return sd1;
                //if(_sd1 && value.toFixed(2) === _sd1) return  _sd1;
                //if(sd2 && value.toFixed(2) === sd2) return sd2;
                //if(_sd2 && value.toFixed(2) === _sd2) return _sd2;
                if(sd3 && value == sd3) return  sd3 + ' (' + vm.annotations.upperLimit + ')';
                if(_sd3 && value == _sd3) return  _sd3 + ' (' + vm.annotations.lowerLimit + ')';
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function formatMeasurement(value, measurementUnit) {
          if (measurementUnit == 'MMOL_PER_L') {
            return value.toFixed(1);
          }
          else if (measurementUnit == 'MG_PER_DL') {
            return value.toFixed(0);
          }

          return value;
        }

        function translate() {
            return $translate([
                'QC_REPORT_MFR_CONTROL_LIMITS.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS.COUNTRY',
                'QC_REPORT_MFR_CONTROL_LIMITS.STATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.HOSPITAL',
                'QC_REPORT_MFR_CONTROL_LIMITS.START_DATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.END_DATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.X_AXIS',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.Y_AXIS',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.READING',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.MEAN',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.UPPER_LIMIT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.LOWER_LIMIT',

                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_STATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_METER',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_STATE_IN',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MFR_CONTROL_LIMITS.TITLE'],
                    title: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.TITLE'],
                    country: translations['QC_REPORT_MFR_CONTROL_LIMITS.COUNTRY'],
                    state: translations['QC_REPORT_MFR_CONTROL_LIMITS.STATE'],
                    hospital: translations['QC_REPORT_MFR_CONTROL_LIMITS.HOSPITAL'],
                    startDate: translations['QC_REPORT_MFR_CONTROL_LIMITS.START_DATE'],
                    endDate: translations['QC_REPORT_MFR_CONTROL_LIMITS.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.ALL_CONTROL_LOT'],
                };

                vm.chart = {
                    title: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.Y_AXIS']
                };

                vm.tooltips = {
                    reading: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.READING'],
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.annotations = {
                    mean: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.MEAN'],
                    upperLimit: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.UPPER_LIMIT'],
                    lowerLimit: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.LOWER_LIMIT']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.mfr-control-limits.level2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-mfr-control-limits-level2', {
                url    : '/qc-report-mfr-control-limits-level2',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/mfr-control-limits/level2/level2.html',
                        controller : 'MfrControlLimitsLevel2Controller as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin', 'hospital_operator']
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/mfr-control-limits/level2');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.single.ljchart', ['/reports/single/ljchart']);

        msNavigationServiceProvider.saveItem('qc-report-mfr-control-limits.level2', {
            title : 'L-J Chart – Level 2',
            state: 'app.qc-report-mfr-control-limits-level2',
            weight: 15,
            translate: "QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.NAV"
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.mfr-control-limits.level2')
        .component('mfrControlLimitsLevel2HospitalAdmin', {
            templateUrl: 'app/main/qc-report/mfr-control-limits/level2/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, localStorageService, $mdSelect, $filter, CONFIG, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 2';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.meterColumns = [];
        vm.meters = [];
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.stripLotChanged = stripLotChanged;
        vm.controlLotChanged = controlLotChanged;
        vm.getStripLotText = getStripLotText;
        vm.getControlLotText = getControlLotText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#66bb6a",
                        borderColor: "#66bb6a",
                        pointBorderColor: "#66bb6a",
                        pointBackgroundColor: "#66bb6a",
                        pointHoverBackgroundColor: "#66bb6a",
                        pointHoverBorderColor: "#66bb6a",
                        showLine: true
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left:16
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: false,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        bodySpacing: 4,
                        displayColors: false
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            getMeters();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function stripLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function controlLotChanged() {
            if(vm.subFilterForm.$valid) {
                getLJChart(false);
            }

            close();
        }

        function getStripLotText() {
            var limit = 50;
            if (vm.stripLot && vm.stripLot.length) {
                if (vm.stripLot.length === vm.testStrips.length) {
                    return vm.filters.allStripLot;
                }
                var joined =  _.join(_.map(vm.stripLot, 'lot_no'), ', ');

                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
            } else {
                return vm.filters.stripLot;
            }
        }

        function getControlLotText() {
            var limit = 50;
            if (vm.controlLot && vm.controlLot.length) {
                if (vm.controlLot.length === vm.controlSolutions.length) {
                    return vm.filters.allControlLot;
                }
                var joined = _.join(_.map(vm.controlLot, 'lot_no'), ', ');

                return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
            } else {
                return vm.filters.controlLot;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.stripLot,
                                    style: 'small'
                                },
                                {
                                    text: getStripLotText(),
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.controlLot,
                                    style: 'small'
                                },
                                {
                                    text: getControlLotText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 20]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Level2-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data, vm.user.preferred_measurement_unit);
        }

        function getMeters() {
            var locationIds = _.map(vm.user.locations, 'id');
            var params = {
                hospital_id: vm.user.hospitals[0].id,
                'location_ids[]': locationIds
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                level: vm.level,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                if (vm.controlLot.length) {
                    var controlLotIds = _.map(vm.controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions = response.control_solutions;
                    vm.mean = response.meanMfr;
                    vm.stdev = response.stdevMfr;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data, vm.user.preferred_measurement_unit);
                    points(vm.data);
                    tooltips(vm.data, vm.user.preferred_measurement_unit);
                    annotations(vm.mean, vm.stdev, vm.user.preferred_measurement_unit);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var points = _.map(data, function(test) {
                if (test.meter_reading !== null) {
                    return {x: moment(test.tested_on), y: formatMeasurement(parseFloat(test.meter_reading), test.measurement_unit)};
                }
            });

            vm.chartjs.datasetOverride[0].label = vm.level;
            vm.chartjs.data = [points];
        }

        function xAxes(tests) {
            var minTest = _.minBy(tests, 'tested_on');
            var maxTest = _.maxBy(tests, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests, measurementUnit) {
            var minTest = _.minBy(tests, 'meter_reading');
            var maxTest = _.maxBy(tests, 'meter_reading');

            if (measurementUnit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 0.5 : 14.0;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 0.5 : 19.0;
                var stepSize = (min + max) / 2;
                // Primary axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.1;
            } else {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 9 : 252;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 9 : 342;
                var stepSize = (min + max) / 2;

                // Primary Axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1.0;
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatMeasurement(parseFloat(value), measurementUnit);
            };
        }

        function tooltips(tests, measurementUnit) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return [
                        vm.tooltips.reading + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[measurementUnit],
                        vm.tooltips.stripLot + ' ' + tests[tooltipItem.index].test_strip.lot_no,
                        vm.tooltips.controlLot + ' ' + tests[tooltipItem.index].control_solution.lot_no
                    ];
                }
            };
        }

        function annotations(mean, stdev, measurementUnit) {
            var annotations = [];
            var m = null;
            var sd1 = null;
            var _sd1 = null;
            var sd2 = null;
            var _sd2 = null;
            var sd3 = null;
            var _sd3 = null;

            // mean
            if (mean) {
                m = formatMeasurement(mean, measurementUnit);
                annotations.push(annotation(m, 8, {borderWidth: 2}, m + ' (' + vm.annotations.mean + ')'));
            }

            if (stdev) {
                sd1 = formatMeasurement(mean + stdev, measurementUnit);
                _sd1 = formatMeasurement(mean - stdev, measurementUnit);
                sd2 = formatMeasurement(mean + stdev * 2, measurementUnit);
                _sd2 = formatMeasurement (mean - stdev * 2, measurementUnit);
                sd3 = formatMeasurement(mean + stdev * 3, measurementUnit);
                _sd3 = formatMeasurement(mean - stdev * 3, measurementUnit);
                //annotations.push(annotation(sd1, 8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, sd1));
                //annotations.push(annotation(_sd1, -8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, _sd1));
                //annotations.push(annotation(sd2, 8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, sd2));
                //annotations.push(annotation(_sd2, -8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, _sd2));
                annotations.push(annotation(sd3, 8, {borderWidth: 1}, sd3 + ' (' + vm.annotations.upperLimit + ')'));
                annotations.push(annotation(_sd3, -8, {borderWidth: 1}, _sd3 + ' (' + vm.annotations.lowerLimit + ')'));
            }

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(m && value == m) return m + ' (' + vm.annotations.mean + ')';
                //if(sd1 && value.toFixed(2) === sd1) return sd1;
                //if(_sd1 && value.toFixed(2) === _sd1) return  _sd1;
                //if(sd2 && value.toFixed(2) === sd2) return sd2;
                //if(_sd2 && value.toFixed(2) === _sd2) return _sd2;
                if(sd3 && value == sd3) return  sd3 + ' (' + vm.annotations.upperLimit + ')';
                if(_sd3 && value == _sd3) return  _sd3 + ' (' + vm.annotations.lowerLimit + ')';
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function formatMeasurement(value, measurementUnit) {
          if (measurementUnit == 'MMOL_PER_L') {
            return value.toFixed(1);
          }
          else if (measurementUnit == 'MG_PER_DL') {
            return value.toFixed(0);
          }

          return value;
        }

        function translate() {
            return $translate([
                'QC_REPORT_MFR_CONTROL_LIMITS.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS.START_DATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.END_DATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.X_AXIS',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.Y_AXIS',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.READING',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.ANNOTATION.MEAN',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.UPPER_LIMIT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.LOWER_LIMIT',

                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_METER',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MFR_CONTROL_LIMITS.TITLE'],
                    title: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.TITLE'],
                    startDate: translations['QC_REPORT_MFR_CONTROL_LIMITS.START_DATE'],
                    endDate: translations['QC_REPORT_MFR_CONTROL_LIMITS.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.ALL_CONTROL_LOT'],
                };

                vm.chart = {
                    title: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.Y_AXIS']
                };

                vm.tooltips = {
                    reading: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.READING'],
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.annotations = {
                    mean: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.ANNOTATION.MEAN'],
                    upperLimit: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.UPPER_LIMIT'],
                    lowerLimit: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.LOWER_LIMIT']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER'],
                    selectMeter: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_METER']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        $scope.$watch('vm.subFilterForm.$valid', function(validity) {
            vm.valid = vm.filterForm.$valid && vm.subFilterForm.$valid;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.mfr-control-limits.level2')
        .component('mfrControlLimitsLevel2GlobalAdmin', {
            templateUrl: 'app/main/qc-report/mfr-control-limits/level2/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 2';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#66bb6a",
                        borderColor: "#66bb6a",
                        pointBorderColor: "#66bb6a",
                        pointBackgroundColor: "#66bb6a",
                        pointHoverBackgroundColor: "#66bb6a",
                        pointHoverBorderColor: "#66bb6a",
                        showLine: true
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left:16
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: false,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        bodySpacing: 4,
                        displayColors: false
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.meter = null;
            meterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.meter && vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.country,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedCountry.name
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.state,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedState.name
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Level2-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data, vm.user.preferred_measurement_unit);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                level: vm.level,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                if (vm.controlLot.length) {
                    var controlLotIds = _.map(vm.controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions = response.control_solutions;
                    vm.mean = response.meanMfr;
                    vm.stdev = response.stdevMfr;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data, vm.user.preferred_measurement_unit);
                    points(vm.data);
                    tooltips(vm.data, vm.user.preferred_measurement_unit);
                    annotations(vm.mean, vm.stdev, vm.user.preferred_measurement_unit);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var points = _.map(data, function(test) {
                if (test.meter_reading !== null) {
                    return {x: moment(test.tested_on), y: formatMeasurement(parseFloat(test.meter_reading), test.measurement_unit)};
                }
            });

            vm.chartjs.datasetOverride[0].label = vm.level;
            vm.chartjs.data = [points];
        }

        function xAxes(tests) {
            var minTest = _.minBy(tests, 'tested_on');
            var maxTest = _.maxBy(tests, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests, measurementUnit) {
            var minTest = _.minBy(tests, 'meter_reading');
            var maxTest = _.maxBy(tests, 'meter_reading');

            if (measurementUnit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 0.5 : 14.0;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 0.5 : 19.0;
                var stepSize = (min + max) / 2;
                // Primary axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.1;
            } else {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 9 : 252;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 9 : 342;
                var stepSize = (min + max) / 2;

                // Primary Axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1.0;
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatMeasurement(parseFloat(value), measurementUnit);
            };
        }

        function tooltips(tests, measurementUnit) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return [
                        vm.tooltips.reading + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[measurementUnit],
                        vm.tooltips.stripLot + ' ' + tests[tooltipItem.index].test_strip.lot_no,
                        vm.tooltips.controlLot + ' ' + tests[tooltipItem.index].control_solution.lot_no
                    ];
                }
            };
        }

        function annotations(mean, stdev, measurementUnit) {
            var annotations = [];
            var m = null;
            var sd1 = null;
            var _sd1 = null;
            var sd2 = null;
            var _sd2 = null;
            var sd3 = null;
            var _sd3 = null;

            // mean
            if (mean) {
                m = formatMeasurement(mean, measurementUnit);
                annotations.push(annotation(m, 8, {borderWidth: 2}, m + ' (' + vm.annotations.mean + ')'));
            }

            if (stdev) {
                sd1 = formatMeasurement(mean + stdev, measurementUnit);
                _sd1 = formatMeasurement(mean - stdev, measurementUnit);
                sd2 = formatMeasurement(mean + stdev * 2, measurementUnit);
                _sd2 = formatMeasurement (mean - stdev * 2, measurementUnit);
                sd3 = formatMeasurement(mean + stdev * 3, measurementUnit);
                _sd3 = formatMeasurement(mean - stdev * 3, measurementUnit);
                //annotations.push(annotation(sd1, 8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, sd1));
                //annotations.push(annotation(_sd1, -8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, _sd1));
                //annotations.push(annotation(sd2, 8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, sd2));
                //annotations.push(annotation(_sd2, -8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, _sd2));
                annotations.push(annotation(sd3, 8, {borderWidth: 1}, sd3 + ' (' + vm.annotations.upperLimit + ')'));
                annotations.push(annotation(_sd3, -8, {borderWidth: 1}, _sd3 + ' (' + vm.annotations.lowerLimit + ')'));
            }

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(m && value == m) return m + ' (' + vm.annotations.mean + ')';
                //if(sd1 && value.toFixed(2) === sd1) return sd1;
                //if(_sd1 && value.toFixed(2) === _sd1) return  _sd1;
                //if(sd2 && value.toFixed(2) === sd2) return sd2;
                //if(_sd2 && value.toFixed(2) === _sd2) return _sd2;
                if(sd3 && value == sd3) return  sd3 + ' (' + vm.annotations.upperLimit + ')';
                if(_sd3 && value == _sd3) return  _sd3 + ' (' + vm.annotations.lowerLimit + ')';
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function formatMeasurement(value, measurementUnit) {
          if (measurementUnit == 'MMOL_PER_L') {
            return value.toFixed(1);
          }
          else if (measurementUnit == 'MG_PER_DL') {
            return value.toFixed(0);
          }

          return value;
        }

        function translate() {
            return $translate([
                'QC_REPORT_MFR_CONTROL_LIMITS.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS.COUNTRY',
                'QC_REPORT_MFR_CONTROL_LIMITS.STATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.HOSPITAL',
                'QC_REPORT_MFR_CONTROL_LIMITS.START_DATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.END_DATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.X_AXIS',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.Y_AXIS',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.READING',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.ANNOTATION.MEAN',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.UPPER_LIMIT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.LOWER_LIMIT',

                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_STATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_METER',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_STATE_IN',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER_IN',
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MFR_CONTROL_LIMITS.TITLE'],
                    title: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.TITLE'],
                    country: translations['QC_REPORT_MFR_CONTROL_LIMITS.COUNTRY'],
                    state: translations['QC_REPORT_MFR_CONTROL_LIMITS.STATE'],
                    hospital: translations['QC_REPORT_MFR_CONTROL_LIMITS.HOSPITAL'],
                    startDate: translations['QC_REPORT_MFR_CONTROL_LIMITS.START_DATE'],
                    endDate: translations['QC_REPORT_MFR_CONTROL_LIMITS.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.ALL_CONTROL_LOT'],
                };

                vm.chart = {
                    title: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.Y_AXIS']
                };

                vm.tooltips = {
                    reading: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.READING'],
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.annotations = {
                    mean: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.ANNOTATION.MEAN'],
                    upperLimit: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.UPPER_LIMIT'],
                    lowerLimit: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.LOWER_LIMIT']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.mfr-control-limits.level2')
        .component('mfrControlLimitsLevel2CountryAdmin', {
            templateUrl: 'app/main/qc-report/mfr-control-limits/level2/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, localStorageService, $mdSelect, CONFIG, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.level = 'Level 2';
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.meter = null;
        vm.searchTerm = '';

        vm.loaded = false;
        vm.message = null;

        vm.testStrips = [];
        vm.stripLot = [];

        vm.controlSolutions = [];
        vm.controlLot = [];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.meterChanged = meterChanged;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [
                    {
                        yAxisID: 'y-axis-1' ,
                        fill: false,
                        lineTension: 0.1,
                        spanGaps: true,
                        backgroundColor: "#66bb6a",
                        borderColor: "#66bb6a",
                        pointBorderColor: "#66bb6a",
                        pointBackgroundColor: "#66bb6a",
                        pointHoverBackgroundColor: "#66bb6a",
                        pointHoverBorderColor: "#66bb6a",
                        showLine: true
                    }
                ],
                options: {
                    layout: {
                        padding: {
                            left:16
                        }
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: false,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            },
                            {
                                id: 'y-axis-2',
                                type: 'linear',
                                display: true,
                                position: 'right',
                                ticks: {
                                    fontColor: CONFIG.annotation_color
                                },
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: false
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'D-MMM-YYYY',
                                        second: 'D-MMM-YYYY',
                                        minute: 'D-MMM-YYYY',
                                        hour: 'D-MMM-YYYY',
                                        day: 'D-MMM-YYYY',
                                        week: 'D-MMM-YYYY',
                                        month: 'D-MMM-YYYY',
                                        quarter: 'D-MMM-YYYY',
                                        year: 'D-MMM-YYYY'
                                    },
                                    tooltipFormat: 'D-MMM-YYYY hh:mmA',
                                    minUnit: 'day'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        bodySpacing: 4,
                        displayColors: false
                    },
                    annotation: {
                        annotations:[],
                        drawTime: 'afterDatasetsDraw'
                    }
                }
            };

            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.meter = null;
            meterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function meterChanged() {
            if(vm.meter && vm.filterForm.$valid) {
                getLJChart(true);
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.state,
                                    style: 'small'
                                },
                                {
                                    text:  vm.selectedState.name,
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name,
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.meterSerialNo,
                                    style: 'small'
                                },
                                {
                                    text: vm.meter.serial_no
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('LJChart–Level2-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data, vm.user.preferred_measurement_unit);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getLJChart(updateSubFilterForm) {
            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.meter.id,
                level: vm.level,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            if (!updateSubFilterForm) {
                if (vm.stripLot.length) {
                    var stripLotIds = _.map(vm.stripLot, 'id');
                    params = angular.merge({'strip_lot_ids[]': stripLotIds}, params);
                }

                if (vm.controlLot.length) {
                    var controlLotIds = _.map(vm.controlLot, 'id');
                    params = angular.merge({'control_lot_ids[]': controlLotIds}, params);
                }
            }

            return msApi.request('reports.single.ljchart@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var controlSolutions = response.control_solutions;
                    vm.mean = response.meanMfr;
                    vm.stdev = response.stdevMfr;
                    vm.data = response.data;

                    if (updateSubFilterForm) {
                        subFilterForm(testStrips, controlSolutions);
                    }

                    xAxes(vm.data);
                    yAxes(vm.data, vm.user.preferred_measurement_unit);
                    points(vm.data);
                    tooltips(vm.data, vm.user.preferred_measurement_unit);
                    annotations(vm.mean, vm.stdev, vm.user.preferred_measurement_unit);
                    vm.loaded = true;
                });
        }

        function subFilterForm(testStrips, controlSolutions) {
            vm.testStrips = testStrips;
            vm.stripLot = testStrips;

            vm.controlSolutions = controlSolutions;
            vm.controlLot = controlSolutions;
        }

        function points(data) {
            var points = _.map(data, function(test) {
                if (test.meter_reading !== null) {
                    return {x: moment(test.tested_on), y: formatMeasurement(parseFloat(test.meter_reading), test.measurement_unit)};
                }
            });

            vm.chartjs.datasetOverride[0].label = vm.level;
            vm.chartjs.data = [points];
        }

        function xAxes(tests) {
            var minTest = _.minBy(tests, 'tested_on');
            var maxTest = _.maxBy(tests, 'tested_on');

            var min = (vm.zoomToFit && minTest != null) ? moment(minTest.tested_on).startOf('day') : moment(vm.startDate).startOf('day');
            var max = (vm.zoomToFit && maxTest != null) ? moment(maxTest.tested_on).add(1, 'days').startOf('day') : moment(vm.endDate).add(1, 'days').startOf('day');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(tests, measurementUnit) {
            var minTest = _.minBy(tests, 'meter_reading');
            var maxTest = _.maxBy(tests, 'meter_reading');

            if (measurementUnit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 0.5 : 14.0;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 0.5 : 19.0;
                var stepSize = (min + max) / 2;
                // Primary axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 0.1;
            } else {
                var min = (vm.zoomToFit && minTest != null) ? minTest.meter_reading - 9 : 252;
                var max = (vm.zoomToFit && maxTest != null) ? maxTest.meter_reading + 9 : 342;
                var stepSize = (min + max) / 2;

                // Primary Axes
                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[measurementUnit] + ')';

                // Secondary Axes
                vm.chartjs.options.scales.yAxes[1].ticks.min = min;
                vm.chartjs.options.scales.yAxes[1].ticks.max = max;
                vm.chartjs.options.scales.yAxes[1].ticks.stepSize = 1.0;
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return formatMeasurement(parseFloat(value), measurementUnit);
            };
        }

        function tooltips(tests, measurementUnit) {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return [
                        vm.tooltips.reading + ' ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[measurementUnit],
                        vm.tooltips.stripLot + ' ' + tests[tooltipItem.index].test_strip.lot_no,
                        vm.tooltips.controlLot + ' ' + tests[tooltipItem.index].control_solution.lot_no
                    ];
                }
            };
        }

        function annotations(mean, stdev, measurementUnit) {
            var annotations = [];
            var m = null;
            var sd1 = null;
            var _sd1 = null;
            var sd2 = null;
            var _sd2 = null;
            var sd3 = null;
            var _sd3 = null;

            // mean
            if (mean) {
                m = formatMeasurement(mean, measurementUnit);
                annotations.push(annotation(m, 8, {borderWidth: 2}, m + ' (' + vm.annotations.mean + ')'));
            }

            if (stdev) {
                sd1 = formatMeasurement(mean + stdev, measurementUnit);
                _sd1 = formatMeasurement(mean - stdev, measurementUnit);
                sd2 = formatMeasurement(mean + stdev * 2, measurementUnit);
                _sd2 = formatMeasurement (mean - stdev * 2, measurementUnit);
                sd3 = formatMeasurement(mean + stdev * 3, measurementUnit);
                _sd3 = formatMeasurement(mean - stdev * 3, measurementUnit);
                //annotations.push(annotation(sd1, 8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, sd1));
                //annotations.push(annotation(_sd1, -8, {borderWidth: 1, borderDash: [1,2], borderDashOffset: 5}, _sd1));
                //annotations.push(annotation(sd2, 8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, sd2));
                //annotations.push(annotation(_sd2, -8, {borderWidth: 1, borderDash: [3,2], borderDashOffset: 5}, _sd2));
                annotations.push(annotation(sd3, 8, {borderWidth: 1}, sd3 + ' (' + vm.annotations.upperLimit + ')'));
                annotations.push(annotation(_sd3, -8, {borderWidth: 1}, _sd3 + ' (' + vm.annotations.lowerLimit + ')'));
            }

            vm.chartjs.options.annotation.annotations = annotations;

            // Use secondary yAxes to show the control line labels instead
            vm.chartjs.options.scales.yAxes[1].ticks.callback = function(value) {
                if(m && value == m) return m + ' (' + vm.annotations.mean + ')';
                //if(sd1 && value.toFixed(2) === sd1) return sd1;
                //if(_sd1 && value.toFixed(2) === _sd1) return  _sd1;
                //if(sd2 && value.toFixed(2) === sd2) return sd2;
                //if(_sd2 && value.toFixed(2) === _sd2) return _sd2;
                if(sd3 && value == sd3) return  sd3 + ' (' + vm.annotations.upperLimit + ')';
                if(_sd3 && value == _sd3) return  _sd3 + ' (' + vm.annotations.lowerLimit + ')';
                return null;
            };
        }

        function annotation(value, yAdjust, border, content) {
            var annotation = {
                type: 'line',
                mode: 'horizontal',
                scaleID: 'y-axis-1',
                value: value,
                borderColor: CONFIG.annotation_color,
                label: {
                    backgroundColor: 'rgba(0,0,0,0)',
                    fontSize: 10,
                    fontStyle: "normal",
                    fontColor: CONFIG.annotation_color,
                    yAdjust: yAdjust,
                    position: "right",
                    enabled: false, // disable cause it cannot show on outside chart area
                    content: content
                }
            };

            return angular.extend(annotation, border);
        }

        function formatMeasurement(value, measurementUnit) {
          if (measurementUnit == 'MMOL_PER_L') {
            return value.toFixed(1);
          }
          else if (measurementUnit == 'MG_PER_DL') {
            return value.toFixed(0);
          }

          return value;
        }

        function translate() {
            return $translate([
                'QC_REPORT_MFR_CONTROL_LIMITS.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS.COUNTRY',
                'QC_REPORT_MFR_CONTROL_LIMITS.STATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.HOSPITAL',
                'QC_REPORT_MFR_CONTROL_LIMITS.START_DATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.END_DATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.ALL_STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.ALL_CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TITLE',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.X_AXIS',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.Y_AXIS',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.READING',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.STRIP_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.CONTROL_LOT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.ANNOTATION.MEAN',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.UPPER_LIMIT',
                'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.LOWER_LIMIT',

                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_STATE',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_METER',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_STATE_IN',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER_IN',
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_MFR_CONTROL_LIMITS.TITLE'],
                    title: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.TITLE'],
                    country: translations['QC_REPORT_MFR_CONTROL_LIMITS.COUNTRY'],
                    state: translations['QC_REPORT_MFR_CONTROL_LIMITS.STATE'],
                    hospital: translations['QC_REPORT_MFR_CONTROL_LIMITS.HOSPITAL'],
                    startDate: translations['QC_REPORT_MFR_CONTROL_LIMITS.START_DATE'],
                    endDate: translations['QC_REPORT_MFR_CONTROL_LIMITS.END_DATE'],
                    meterSerialNo: translations['QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO'],
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.CONTROL_LOT']
                };

                vm.filters = {
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.STRIP_LOT'],
                    allStripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.ALL_STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.CONTROL_LOT'],
                    allControlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.ALL_CONTROL_LOT'],
                };

                vm.chart = {
                    title: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.Y_AXIS']
                };

                vm.tooltips = {
                    reading: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.READING'],
                    stripLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.STRIP_LOT'],
                    controlLot: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.TOOLTIPS.CONTROL_LOT']
                };

                vm.annotations = {
                    mean: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.CHART.ANNOTATION.MEAN'],
                    upperLimit: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.UPPER_LIMIT'],
                    lowerLimit: translations['QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.CHART.ANNOTATION.LOWER_LIMIT']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_REGISTERED_METER_IN']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.qcperformance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-hospital-qcperformance', {
                url    : '/qc-report-hospital-qcperformance',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/hospital/qcperformance/qcperformance.html',
                        controller : 'HospitalQCPerformanceController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin'],
                    module: 'qc-report-hospital'
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/hospital/qcperformance');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.hospital.qcperformance', ['/reports/hospital/qcperformance']);

        msNavigationServiceProvider.saveItem('qc-report-hospital.qcperformance', {
            title : 'QC Test Performance (Pie Chart)',
            state: 'app.qc-report-hospital-qcperformance',
            weight: 26,
            translate: 'QC_REPORT_HOSPITAL_QCPERFORMANCE.NAV'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.qcperformance')
        .component('hospitalQcPerformanceHospitalAdmin', {
            templateUrl: 'app/main/qc-report/hospital/qcperformance/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '=',
                hasData: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, $mdSelect, localStorageService, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.meterColumns = [];
        vm.meters = [];
        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.metersLoaded = false;
        vm.loaded = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.pieChart = {
                labels: [vm.chart.good, vm.chart.acceptable, vm.chart.poor, vm.chart.failed],
                data  : [],
                datasetOverride: {
                    backgroundColor: [
                        '#29b6f6',
                        '#66bb6a',
                        '#ffca28',
                        '#f44336'
                    ],
                    hoverBackgroundColor: [
                        '#29b6f6',
                        '#66bb6a',
                        '#ffca28',
                        '#f44336'
                    ]
                },
                options: {
                    legend: {
                        display: true
                    },
                    // Workaround to fix chartjs-plugin-annotation on pie chart
                    scales:{
                        yAxes: [],
                        xAxes: []
                    },
                    tooltips: {
                        bodySpacing:4,
                        callbacks: {
                            label: function (tooltipItem, data) {
                                return ' ' + data.labels[tooltipItem.index] + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + vm.tooltips.tests;
                            }
                        }
                    },
                    pieceLabel: {
                        mode: 'percentage',
                        position: 'border'

                    }
                }
            };

            getMeters()
                .then(getReport);
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getReport();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getReport();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getReport();
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function getMeters() {
            var params = {
                hospital_id: vm.user.hospitals[0].id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getReport() {
            getQCPerformance();
        }

        function getQCPerformance() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                return msApi.request('reports.hospital.qcperformance@get',
                    {
                        start_date: moment(vm.startDate).startOf('day').format(),
                        end_date: moment(vm.endDate).endOf('day').format(),
                        'meter_ids[]': meterIds
                    },
                    // SUCCESS
                    function (response) {
                        if (response.total === 0) {
                            vm.pieChart.data = [];
                            vm.hasData = false;
                        } else {
                            vm.pieChart.data = [response.good, response.acceptable, response.poor, response.failed];
                            vm.hasData = true;
                        }

                        vm.loaded = true;
                    });
            }
        }

        function exportToPDF() {
            var canvas = document.getElementById('pie');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 320,
                        alignment: 'center'
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('QCTestPerformance-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function translate() {
            return $translate([
                'QC_REPORT_HOSPITAL.TITLE',
                'QC_REPORT_HOSPITAL.START_DATE',
                'QC_REPORT_HOSPITAL.END_DATE',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.TITLE',
                'QC_REPORT_HOSPITAL.METERS',
                'QC_REPORT_HOSPITAL.ALL_METERS',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.GOOD',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.ACCEPTABLE',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.POOR',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.FAILED',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.TOOLTIPS.TESTS',

                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_HOSPITAL.TITLE'],
                    title: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.TITLE'],
                    startDate: translations['QC_REPORT_HOSPITAL.START_DATE'],
                    endDate: translations['QC_REPORT_HOSPITAL.END_DATE'],
                    meters: translations['QC_REPORT_HOSPITAL.METERS']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    allMeters: translations['QC_REPORT_HOSPITAL.ALL_METERS']
                };

                vm.chart = {
                    good: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.GOOD'],
                    acceptable: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.ACCEPTABLE'],
                    poor: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.POOR'],
                    failed: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.FAILED']
                };

                vm.tooltips = {
                    tests: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.TOOLTIPS.TESTS']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'],
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.qcperformance')
        .component('hospitalQcPerformanceGlobalAdmin', {
            templateUrl: 'app/main/qc-report/hospital/qcperformance/global-admin/global-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '=',
                hasData: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, $mdSelect, localStorageService, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.startDate = moment().subtract(2, 'months').startOf('month').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.message = null;

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.pieChart = {
                labels: [vm.chart.good, vm.chart.acceptable, vm.chart.poor, vm.chart.failed],
                data  : [],
                datasetOverride: {
                    backgroundColor: [
                        '#29b6f6',
                        '#66bb6a',
                        '#ffca28',
                        '#f44336'
                    ],
                    hoverBackgroundColor: [
                        '#29b6f6',
                        '#66bb6a',
                        '#ffca28',
                        '#f44336'
                    ]
                },
                options: {
                    legend: {
                        display: true
                    },
                    // Workaround to fix chartjs-plugin-annotation on pie chart
                    scales:{
                        yAxes: [],
                        xAxes: []
                    },
                    tooltips: {
                        bodySpacing:4,
                        callbacks: {
                            label: function (tooltipItem, data) {
                                return ' ' + data.labels[tooltipItem.index] + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + vm.tooltips.tests;
                            }
                        }
                    },
                    pieceLabel: {
                        mode: 'percentage',
                        position: 'border'

                    }
                }
            };

            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getReport);
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getReport();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getReport();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getReport();
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getReport() {
            getQCPerformance();
        }

        function getQCPerformance() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                return msApi.request('reports.hospital.qcperformance@get',
                    {
                        start_date: moment(vm.startDate).startOf('day').format(),
                        end_date: moment(vm.endDate).endOf('day').format(),
                        'meter_ids[]': meterIds
                    },
                    // SUCCESS
                    function (response) {
                        if (response.total === 0) {
                            vm.pieChart.data = [];
                            vm.hasData = false;
                        } else {
                            vm.pieChart.data = [response.good, response.acceptable, response.poor, response.failed];
                            vm.hasData = true;
                        }

                        vm.loaded = true;
                    });
            }
        }

        function exportToPDF() {
            var canvas = document.getElementById('pie');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.country,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedCountry.name
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.state,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedState.name
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 320,
                        alignment: 'center'
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('QCTestPerformance-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function translate() {
            return $translate([
                'QC_REPORT_HOSPITAL.TITLE',
                'QC_REPORT_HOSPITAL.START_DATE',
                'QC_REPORT_HOSPITAL.END_DATE',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.TITLE',
                'QC_REPORT_HOSPITAL.COUNTRY',
                'QC_REPORT_HOSPITAL.STATE',
                'QC_REPORT_HOSPITAL.HOSPITAL',
                'QC_REPORT_HOSPITAL.METERS',
                'QC_REPORT_HOSPITAL.ALL_METERS',

                'QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.GOOD',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.ACCEPTABLE',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.POOR',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.FAILED',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.TOOLTIPS.TESTS',

                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_METER',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_STATE_IN',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_HOSPITAL.TITLE'],
                    title: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.TITLE'],
                    country: translations['QC_REPORT_HOSPITAL.COUNTRY'],
                    startDate: translations['QC_REPORT_HOSPITAL.START_DATE'],
                    endDate: translations['QC_REPORT_HOSPITAL.END_DATE'],
                    state: translations['QC_REPORT_HOSPITAL.STATE'],
                    hospital: translations['QC_REPORT_HOSPITAL.HOSPITAL'],
                    meters: translations['QC_REPORT_HOSPITAL.METERS']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    allMeters: translations['QC_REPORT_HOSPITAL.ALL_METERS']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN']
                };

                vm.chart = {
                    good: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.GOOD'],
                    acceptable: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.ACCEPTABLE'],
                    poor: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.POOR'],
                    failed: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.FAILED']
                };

                vm.tooltips = {
                    tests: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.TOOLTIPS.TESTS']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.qcperformance')
        .component('hospitalQcPerformanceCountryAdmin', {
            templateUrl: 'app/main/qc-report/hospital/qcperformance/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '=',
                hasData: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, $mdSelect, localStorageService, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.startDate = moment().subtract(2, 'months').startOf('month').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.message = null;

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.pieChart = {
                labels: [vm.chart.good, vm.chart.acceptable, vm.chart.poor, vm.chart.failed],
                data  : [],
                datasetOverride: {
                    backgroundColor: [
                        '#29b6f6',
                        '#66bb6a',
                        '#ffca28',
                        '#f44336'
                    ],
                    hoverBackgroundColor: [
                        '#29b6f6',
                        '#66bb6a',
                        '#ffca28',
                        '#f44336'
                    ]
                },
                options: {
                    legend: {
                        display: true
                    },
                    // Workaround to fix chartjs-plugin-annotation on pie chart
                    scales:{
                        yAxes: [],
                        xAxes: []
                    },
                    tooltips: {
                        bodySpacing:4,
                        callbacks: {
                            label: function (tooltipItem, data) {
                                return ' ' + data.labels[tooltipItem.index] + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + vm.tooltips.tests;
                            }
                        }
                    },
                    pieceLabel: {
                        mode: 'percentage',
                        position: 'border'

                    }
                }
            };

            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                return hospital.state === vm.selectedState.code;
            }), 'name');

            if (vm.hospitals.length) {
                vm.message = vm.messages.selectHospital;
            } else {
                $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getReport);
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getReport();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getReport();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getReport();
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getReport() {
            getQCPerformance();
        }

        function getQCPerformance() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                return msApi.request('reports.hospital.qcperformance@get',
                    {
                        start_date: moment(vm.startDate).startOf('day').format(),
                        end_date: moment(vm.endDate).endOf('day').format(),
                        'meter_ids[]': meterIds
                    },
                    // SUCCESS
                    function (response) {
                        if (response.total === 0) {
                            vm.pieChart.data = [];
                            vm.hasData = false;
                        } else {
                            vm.pieChart.data = [response.good, response.acceptable, response.poor, response.failed];
                            vm.hasData = true;
                        }

                        vm.loaded = true;
                    });
            }
        }

        function exportToPDF() {
            var canvas = document.getElementById('pie');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.state,
                                    style: 'small'
                                },
                                {
                                    text:  vm.selectedState.name,
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name,
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 320,
                        alignment: 'center'
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('QCTestPerformance-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function translate() {
            return $translate([
                'QC_REPORT_HOSPITAL.TITLE',
                'QC_REPORT_HOSPITAL.START_DATE',
                'QC_REPORT_HOSPITAL.END_DATE',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.TITLE',
                'QC_REPORT_HOSPITAL.STATE',
                'QC_REPORT_HOSPITAL.HOSPITAL',
                'QC_REPORT_HOSPITAL.METERS',
                'QC_REPORT_HOSPITAL.ALL_METERS',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.GOOD',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.ACCEPTABLE',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.POOR',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.FAILED',
                'QC_REPORT_HOSPITAL_QCPERFORMANCE.TOOLTIPS.TESTS'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_HOSPITAL.TITLE'],
                    title: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.TITLE'],
                    startDate: translations['QC_REPORT_HOSPITAL.START_DATE'],
                    endDate: translations['QC_REPORT_HOSPITAL.END_DATE'],
                    state: translations['QC_REPORT_HOSPITAL.STATE'],
                    hospital: translations['QC_REPORT_HOSPITAL.HOSPITAL'],
                    meters: translations['QC_REPORT_HOSPITAL.METERS']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    allMeters: translations['QC_REPORT_HOSPITAL.ALL_METERS']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE'],
                    selectState: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL'],
                    noRegisteredHospitalIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN']
                };

                vm.chart = {
                    good: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.GOOD'],
                    acceptable: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.ACCEPTABLE'],
                    poor: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.POOR'],
                    failed: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.CHART.FAILED']
                };

                vm.tooltips = {
                    tests: translations['QC_REPORT_HOSPITAL_QCPERFORMANCE.TOOLTIPS.TESTS']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.sdchart', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-report-hospital-sdchart', {
                url    : '/qc-report-hospital-sdchart',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/qc-report/hospital/sdchart/sdchart.html',
                        controller : 'HospitalSDChartController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin'],
                    module: 'qc-report-hospital'
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/hospital/sdchart');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('reports.hospital.sdchart', ['/reports/hospital/sdchart']);

        msNavigationServiceProvider.saveItem('qc-report-hospital.sdchart', {
            title : 'Precision for Level 1 (SD Graph)',
            state: 'app.qc-report-hospital-sdchart',
            weight: 23,
            translate: "QC_REPORT_HOSPITAL_SDCHART.NAV"
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.sdchart')
        .component('hospitalSdChartGlobalAdmin', {
            templateUrl: 'app/main/qc-report/hospital/sdchart/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, $mdSelect, localStorageService, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.startDate = moment().subtract(2, 'months').startOf('month').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.metersLoaded = false;
        vm.message = null;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'MMM-YYYY',
                                        second: 'MMM-YYYY',
                                        minute: 'MMM-YYYY',
                                        hour: 'MMM-YYYY',
                                        day: 'MMM-YYYY',
                                        week: 'MMM-YYYY',
                                        month: 'MMM-YYYY',
                                        quarter: 'MMM-YYYY',
                                        year: 'MMM-YYYY'
                                    },
                                    tooltipFormat: 'MMM-YYYY',
                                    unit: 'month'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    }
                }
            };

            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getLJChart);
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart();
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                return msApi.request('reports.hospital.sdchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        vm.data = response.data;

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function points(data) {
            var meters = _.uniq(_.flatten( _.map(data, function(date) {
                return _.keys(date);
            })));

            var series = [];

            for(var i = 0; i < meters.length; i++) {
                var meter = meters[i];
                var points = [];
                _.map(_.keys(data), function(date) {
                    if (_.has(data[date], meter)) {
                        var cv = data[date][meter];
                        points.push({x: date, y: cv !== null ? cv.toFixed(2) : null});
                    }
                })

                series.push({meter: meter, points: points});
            }

            series = _.sortBy(series, ['meter']);

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            var dates = _.keys(data);
            var minDate = _.min(dates);
            var maxDate = _.max(dates);

            var min = (vm.zoomToFit && minDate != null) ? moment(minDate).startOf('month') : moment(vm.startDate).startOf('month');
            var max = (vm.zoomToFit && maxDate != null ) ? moment(maxDate).startOf('month') : moment(vm.endDate).startOf('month');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(date) {
                return _.values(date);
            }));

            var minData = _.min(flatten);
            var maxData = _.max(flatten);

            if (vm.user.preferred_measurement_unit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minData != null) ? ((minData - 0.1 > 0) ? minData - 0.1 : 0.0)  : 0.0;
                var max = (vm.zoomToFit && maxData != null) ? maxData + 0.1 : 0.9;
                var stepSize = (min + max) / 2;

                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')';
            } else {
                var min = (vm.zoomToFit && minData != null) ? ((minData - 2 > 0) ? minData - 2 : 0.0)  : 0.0;
                var max = (vm.zoomToFit && maxData != null) ? maxData + 2 : 15.0;
                var stepSize = (min + max) / 2;

                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')';
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return parseFloat(value).toFixed(2);
            };
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[vm.user.preferred_measurement_unit];
                }
            };
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.country,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedCountry.name
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.state,
                                            style: 'small'
                                        },
                                        {
                                            text: vm.selectedState.name
                                        }
                                    ]
                                ]

                            },
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 640
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('SDGraph–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function translate() {
            return $translate([
                'QC_REPORT_HOSPITAL.TITLE',
                'QC_REPORT_HOSPITAL.START_DATE',
                'QC_REPORT_HOSPITAL.END_DATE',
                'QC_REPORT_HOSPITAL_SDCHART.TITLE',
                'QC_REPORT_HOSPITAL.COUNTRY',
                'QC_REPORT_HOSPITAL.STATE',
                'QC_REPORT_HOSPITAL.HOSPITAL',
                'QC_REPORT_HOSPITAL.METERS',
                'QC_REPORT_HOSPITAL.ALL_METERS',

                'QC_REPORT_HOSPITAL_SDCHART.CHART.TITLE',
                'QC_REPORT_HOSPITAL_SDCHART.CHART.X_AXIS',
                'QC_REPORT_HOSPITAL_SDCHART.CHART.Y_AXIS',

                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_COUNTRY',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_METER',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_STATE_IN',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_HOSPITAL.TITLE'],
                    title: translations['QC_REPORT_HOSPITAL_SDCHART.TITLE'],
                    startDate: translations['QC_REPORT_HOSPITAL.START_DATE'],
                    endDate: translations['QC_REPORT_HOSPITAL.END_DATE'],
                    country: translations['QC_REPORT_HOSPITAL.COUNTRY'],
                    state: translations['QC_REPORT_HOSPITAL.STATE'],
                    hospital: translations['QC_REPORT_HOSPITAL.HOSPITAL'],
                    meters: translations['QC_REPORT_HOSPITAL.METERS']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    allMeters: translations['QC_REPORT_HOSPITAL.ALL_METERS']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_METER'],
                    noStateIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN']
                };

                vm.chart = {
                    title: translations['QC_REPORT_HOSPITAL_SDCHART.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_HOSPITAL_SDCHART.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_HOSPITAL_SDCHART.CHART.Y_AXIS']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.sdchart')
        .component('hospitalSdChartHospitalAdmin', {
            templateUrl: 'app/main/qc-report/hospital/sdchart/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, $mdSelect, localStorageService, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.startDate = moment().subtract(2, 'months').startOf('month').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.metersLoaded = false;
        vm.message = null;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'MMM-YYYY',
                                        second: 'MMM-YYYY',
                                        minute: 'MMM-YYYY',
                                        hour: 'MMM-YYYY',
                                        day: 'MMM-YYYY',
                                        week: 'MMM-YYYY',
                                        month: 'MMM-YYYY',
                                        quarter: 'MMM-YYYY',
                                        year: 'MMM-YYYY'
                                    },
                                    tooltipFormat: 'MMM-YYYY',
                                    unit: 'month'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    }
                }
            };

            getMeters()
                .then(getLJChart);
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart();
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.user.hospitals[0].id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                return msApi.request('reports.hospital.sdchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        vm.data = response.data;

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function points(data) {
            var meters = _.uniq(_.flatten( _.map(data, function(date) {
                return _.keys(date);
            })));

            var series = [];

            for(var i = 0; i < meters.length; i++) {
                var meter = meters[i];
                var points = [];
                _.map(_.keys(data), function(date) {
                    if (_.has(data[date], meter)) {
                        var cv = data[date][meter];
                        points.push({x: date, y: cv !== null ? cv.toFixed(2) : null});
                    }
                });

                series.push({meter: meter, points: points});
            }

            series = _.sortBy(series, ['meter']);

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            var dates = _.keys(data);
            var minDate = _.min(dates);
            var maxDate = _.max(dates);

            var min = (vm.zoomToFit && minDate != null) ? moment(minDate).startOf('month') : moment(vm.startDate).startOf('month');
            var max = (vm.zoomToFit && maxDate != null ) ? moment(maxDate).startOf('month') : moment(vm.endDate).startOf('month');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(date) {
                return _.values(date);
            }));

            var minData = _.min(flatten);
            var maxData = _.max(flatten);

            if (vm.user.preferred_measurement_unit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minData != null) ? ((minData - 0.1 > 0) ? minData - 0.1 : 0.0)  : 0.0;
                var max = (vm.zoomToFit && maxData != null ) ? maxData + 0.1 : 0.9;
                var stepSize = (min + max) / 2;

                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')';
            } else {
                var min = (vm.zoomToFit && minData != null) ? ((minData - 2 > 0) ? minData - 2 : 0.0)  : 0.0;
                var max = (vm.zoomToFit && maxData != null) ? maxData + 2 : 15.0;
                var stepSize = (min + max) / 2;

                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')';
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return parseFloat(value).toFixed(2);
            };
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[vm.user.preferred_measurement_unit];
                }
            };
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 680
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('SDGraph–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function translate() {
            return $translate([
                'QC_REPORT_HOSPITAL.TITLE',
                'QC_REPORT_HOSPITAL.START_DATE',
                'QC_REPORT_HOSPITAL.END_DATE',
                'QC_REPORT_HOSPITAL_SDCHART.TITLE',
                'QC_REPORT_HOSPITAL.METERS',
                'QC_REPORT_HOSPITAL.ALL_METERS',
                'QC_REPORT_HOSPITAL_SDCHART.CHART.TITLE',
                'QC_REPORT_HOSPITAL_SDCHART.CHART.X_AXIS',
                'QC_REPORT_HOSPITAL_SDCHART.CHART.Y_AXIS',

                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_HOSPITAL.TITLE'],
                    title: translations['QC_REPORT_HOSPITAL_SDCHART.TITLE'],
                    startDate: translations['QC_REPORT_HOSPITAL.START_DATE'],
                    endDate: translations['QC_REPORT_HOSPITAL.END_DATE'],
                    meters: translations['QC_REPORT_HOSPITAL.METERS']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    allMeters: translations['QC_REPORT_HOSPITAL.ALL_METERS']
                };

                vm.chart = {
                    title: translations['QC_REPORT_HOSPITAL_SDCHART.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_HOSPITAL_SDCHART.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_HOSPITAL_SDCHART.CHART.Y_AXIS']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'],
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.sdchart')
        .component('hospitalSdChartCountryAdmin', {
            templateUrl: 'app/main/qc-report/hospital/sdchart/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, $mdSelect, localStorageService, $filter, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.startDate = moment().subtract(2, 'months').startOf('month').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = [];
        vm.searchTerm = '';
        vm.filtered = [];

        vm.loaded = false;
        vm.metersLoaded = false;
        vm.message = null;

        vm.colors = [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2',

            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ];

        vm.zoomToFit = false;

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.changeZoom = changeZoom;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.chartjs = {
                data  : [],
                datasetOverride: [],
                options: {
                    layout: {
                        padding: {}
                    },
                    title: {
                        display: true,
                        text: vm.chart.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            usePointStyle: true
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                id: 'y-axis-1',
                                type: 'linear',
                                display: true,
                                position: 'left',
                                ticks: {},
                                scaleLabel: {
                                    display: true
                                },
                                gridLines: {
                                    display: true
                                }
                            }
                        ],
                        xAxes: [
                            {
                                id: 'x-axis-1',
                                type: 'time',
                                position: 'bottom',
                                ticks:{},
                                scaleLabel:{
                                    display: true,
                                    labelString: vm.chart.xAxis
                                },
                                gridLines: {
                                    display: false
                                },
                                time: {
                                    displayFormats: {
                                        millisecond: 'MMM-YYYY',
                                        second: 'MMM-YYYY',
                                        minute: 'MMM-YYYY',
                                        hour: 'MMM-YYYY',
                                        day: 'MMM-YYYY',
                                        week: 'MMM-YYYY',
                                        month: 'MMM-YYYY',
                                        quarter: 'MMM-YYYY',
                                        year: 'MMM-YYYY'
                                    },
                                    tooltipFormat: 'MMM-YYYY',
                                    unit: 'month'
                                }
                            }
                        ]
                    },
                    tooltips: {
                        mode: 'point',
                        bodySpacing:4
                    }
                }
            };

            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters()
                    .then(getLJChart);
            } else {

                vm.loaded = false;
                vm.meters = [];
                vm.selectedMeters = [];

                vm.filterForm.$setPristine();
                vm.filterForm.$setUntouched();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getLJChart();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getLJChart();
            }

            close();
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function changeZoom() {
            xAxes(vm.data);
            yAxes(vm.data);
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;
                    vm.selectedMeters = meters;

                    if (!vm.meters.length) {
                        vm.loaded = false;
                        $translate('QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    vm.metersLoaded = true;

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getLJChart() {
            if (vm.selectedMeters.length) {
                var meterIds = _.map(vm.selectedMeters, 'id');

                var params = {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    'meter_ids[]': meterIds,
                    measurement_unit: vm.user.preferred_measurement_unit
                };

                return msApi.request('reports.hospital.sdchart@get',
                    params,
                    // SUCCESS
                    function (response) {
                        vm.data = response.data;

                        xAxes(vm.data);
                        yAxes(vm.data);
                        points(vm.data);
                        tooltips();
                        vm.loaded = true;
                    });
            }
        }

        function points(data) {
            var meters = _.uniq(_.flatten( _.map(data, function(date) {
                return _.keys(date);
            })));

            var series = [];

            for(var i = 0; i < meters.length; i++) {
                var meter = meters[i];
                var points = [];
                _.map(_.keys(data), function(date) {
                    if (_.has(data[date], meter)) {
                        var cv = data[date][meter];
                        points.push({x: date, y: cv !== null ? cv.toFixed(2) : null});
                    }
                })

                series.push({meter: meter, points: points});
            }

            series = _.sortBy(series, ['meter']);

            var datasets = [];
            var datas = [];
            for(var i = 0; i < series.length; i++) {
                datasets.push({
                    yAxisID: 'y-axis-1' ,
                    fill: false,
                    lineTension: 0.1,
                    spanGaps: true,
                    backgroundColor: vm.colors[i % vm.colors.length],
                    borderColor: vm.colors[i % vm.colors.length],
                    pointBorderColor: vm.colors[i % vm.colors.length],
                    pointBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBackgroundColor: vm.colors[i % vm.colors.length],
                    pointHoverBorderColor: vm.colors[i % vm.colors.length],
                    label: series[i].meter
                });

                datas.push(series[i].points);
            };

            vm.chartjs.options.legend.display = true;

            // dummy data empty data to show complete chart
            if (datas.length === 0) {
                vm.chartjs.options.legend.display = false;
                datas.push([{}]);
            }

            vm.chartjs.datasetOverride = datasets;
            vm.chartjs.data = datas;
        }

        function xAxes(data) {
            var dates = _.keys(data);
            var minDate = _.min(dates);
            var maxDate = _.max(dates);

            var min = (vm.zoomToFit && minDate != null) ? moment(minDate).startOf('month') : moment(vm.startDate).startOf('month');
            var max = (vm.zoomToFit && maxDate != null ) ? moment(maxDate).startOf('month') : moment(vm.endDate).startOf('month');

            vm.chartjs.options.scales.xAxes[0].time.min = min;
            vm.chartjs.options.scales.xAxes[0].time.max = max;
        }

        function yAxes(data) {
            var flatten = _.flatten(_.map(data, function(date) {
                return _.values(date);
            }));

            var minData = _.min(flatten);
            var maxData = _.max(flatten);

            if (vm.user.preferred_measurement_unit === 'MMOL_PER_L') {
                var min = (vm.zoomToFit && minData != null) ? ((minData - 0.1 > 0) ? minData - 0.1 : 0.0)  : 0.0;
                var max = (vm.zoomToFit && maxData != null) ? maxData + 0.1 : 0.9;
                var stepSize = (min + max) / 2;

                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')';
            } else {
                var min = (vm.zoomToFit && minData != null) ? ((minData - 2 > 0) ? minData - 2 : 0.0)  : 0.0;
                var max = (vm.zoomToFit && maxData != null) ? maxData + 2 : 15.0;
                var stepSize = (min + max) / 2;

                vm.chartjs.options.scales.yAxes[0].ticks.min = min;
                vm.chartjs.options.scales.yAxes[0].ticks.max = max;
                vm.chartjs.options.scales.yAxes[0].ticks.stepSize = stepSize;
                vm.chartjs.options.scales.yAxes[0].scaleLabel.labelString = vm.chart.yAxis + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')';
            }

            vm.chartjs.options.scales.yAxes[0].ticks.callback = function (value, index, values) {
                return parseFloat(value).toFixed(2);
            };
        }

        function tooltips() {
            vm.chartjs.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return ' ' + data.datasets[tooltipItem.datasetIndex].label + ' : ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y + ' ' + vm.measurementUnits[vm.user.preferred_measurement_unit];
                }
            };
        }

        function exportToPDF() {
            var canvas = document.getElementById('chart');
            var imageData = canvas.toDataURL();

            var docDefinition = {
                content: [
                    {
                        text: vm.pdf.parent,
                        style: 'subheader'
                    },
                    {
                        text: vm.pdf.title,
                        style: 'header',
                        margin: [0, 0, 0, 20]
                    },
                    {
                        columns: [
                            [
                                {
                                    text: vm.pdf.state,
                                    style: 'small'
                                },
                                {
                                    text:  vm.selectedState.name,
                                    maxHeight: 40
                                }
                            ],
                            [
                                {
                                    text: vm.pdf.hospital,
                                    style: 'small'
                                },
                                {
                                    text: vm.selectedHospital.name,
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                columns: [
                                    [
                                        {
                                            text: vm.pdf.startDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.startDate).format('YYYY-MM-DD')
                                        }
                                    ],
                                    [
                                        {
                                            text: vm.pdf.endDate,
                                            style: 'small'
                                        },
                                        {
                                            text: moment(vm.endDate).format('YYYY-MM-DD')
                                        }
                                    ]
                                ]
                            },
                            [
                                {
                                    text: vm.pdf.meters,
                                    style: 'small'
                                },
                                {
                                    text: getSelectedMetersText(),
                                    maxHeight: 40
                                }
                            ]
                        ],
                        margin: [0, 0, 0, 30]
                    },
                    {
                        image: imageData,
                        width: 640
                    }
                ],
                styles: {
                    header: {
                        fontSize: 20,
                        bold: true
                    },
                    subheader: {
                        fontSize: 10,
                        bold: true,
                        color: 'gray'
                    },
                    small: {
                        fontSize: 8,
                        color: 'gray'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'pdfFont'
                },
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [60, 40, 60, 40]
            };

            var timestamp = moment();
            pdfMake.createPdf(docDefinition).download('SDGraph–Level1-' + timestamp.format('YMMDDHm') + '.pdf');
        }

        function translate() {
            return $translate([
                'QC_REPORT_HOSPITAL.TITLE',
                'QC_REPORT_HOSPITAL.START_DATE',
                'QC_REPORT_HOSPITAL.END_DATE',
                'QC_REPORT_HOSPITAL_SDCHART.TITLE',
                'QC_REPORT_HOSPITAL.STATE',
                'QC_REPORT_HOSPITAL.HOSPITAL',
                'QC_REPORT_HOSPITAL.METERS',
                'QC_REPORT_HOSPITAL.ALL_METERS',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE',
                'QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN',
                'QC_REPORT_HOSPITAL_SDCHART.CHART.TITLE',
                'QC_REPORT_HOSPITAL_SDCHART.CHART.X_AXIS',
                'QC_REPORT_HOSPITAL_SDCHART.CHART.Y_AXIS'
            ]).then(function(translations) {
                vm.pdf = {
                    parent: translations['QC_REPORT_HOSPITAL.TITLE'],
                    title: translations['QC_REPORT_HOSPITAL_SDCHART.TITLE'],
                    startDate: translations['QC_REPORT_HOSPITAL.START_DATE'],
                    endDate: translations['QC_REPORT_HOSPITAL.END_DATE'],
                    state: translations['QC_REPORT_HOSPITAL.STATE'],
                    hospital: translations['QC_REPORT_HOSPITAL.HOSPITAL'],
                    meters: translations['QC_REPORT_HOSPITAL.METERS']
                };

                vm.filters = {
                    meters: translations['QC_REPORT_HOSPITAL.METERS'],
                    allMeters: translations['QC_REPORT_HOSPITAL.ALL_METERS']
                };

                vm.messages = {
                    noRegisteredMeter: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE'],
                    selectState: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['QC_REPORT_HOSPITAL.MESSAGES.SELECT_HOSPITAL'],
                    noRegisteredHospitalIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['QC_REPORT_HOSPITAL.MESSAGES.NO_REGISTERED_METER_IN']
                };

                vm.chart = {
                    title: translations['QC_REPORT_HOSPITAL_SDCHART.CHART.TITLE'],
                    xAxis: translations['QC_REPORT_HOSPITAL_SDCHART.CHART.X_AXIS'],
                    yAxis: translations['QC_REPORT_HOSPITAL_SDCHART.CHART.Y_AXIS']
                };
            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToPDFEvent = $scope.$on('report::exportToPDF', function () {
            exportToPDF();
        });

        vm.$onDestroy = function() {
            exportToPDFEvent();
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.cvchart.level2')
        .controller('HospitalCVChartLevel2Controller', HospitalCVChartLevel2Controller);

    /** @ngInject */
    function HospitalCVChartLevel2Controller(countriesData, statesData, hospitalsData, $scope, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();

        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;

        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        // Methods
        vm.exportToPDF = exportToPDF;

        init();

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToPDF() {
            $scope.$broadcast('report::exportToPDF');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.cvchart.level1')
        .controller('HospitalCVChartLevel1Controller', HospitalCVChartLevel1Controller);

    /** @ngInject */
    function HospitalCVChartLevel1Controller(countriesData, statesData, hospitalsData, $scope, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();

        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;

        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        // Methods
        vm.exportToPDF = exportToPDF;

        init();

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToPDF() {
            $scope.$broadcast('report::exportToPDF');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.user.hospital-operator', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.hospital-operator', {
                url    : '/hospital-operator',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/user/hospital-operator/hospital-operator.html',
                        controller : 'HospitalOperatorController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['hospital_admin']
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/user/hospital-operator');
        $translatePartialLoaderProvider.addPart('app/main/user/hospital-operator/hospital-operator-form');

        // Api
        msApiProvider.register('locations', ['/locations']);
        msApiProvider.register('users', ['/users']);
        msApiProvider.register('users.edit', ['/users/:id', {id: '@id'}, {
            update: { method:'PUT'}
        }]);
        msApiProvider.register('users.reset-password', ['/users/reset_password']);

        msApiProvider.register('users.export', ['/users/export', {}, {
            download: {method: 'GET', responseType: 'arraybuffer', transformResponse: function(data, headersGetter) {
                // Stores the ArrayBuffer object in a property called "data"
                return { data : data };
            }}
        }]);

        msNavigationServiceProvider.saveItem('hospital-operator', {
            title    : 'Operator Register',
            icon     : 'icon-account-box',
            state    : 'app.hospital-operator',
            weight   : 12,
            translate: 'HOSPITAL_OPERATOR.NAV'
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.user.hospital-operator')
        .controller('HospitalOperatorFormController', HospitalOperatorFormController);

    /** @ngInject */
    function HospitalOperatorFormController($mdDialog, dialogData, locationData, $translate, $log) {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.hospital = vm.dialogData.hospital;
        vm.locations = locationData.locations;
        vm.selectedLocation = null;
        vm.trainingCompletion = null;
        vm.certExpiry = null;
        vm.canRemove = false;
        vm.canResetPassword = false;

        // Methods
        vm.save = save;
        vm.remove = remove;
        vm.close = close;
        vm.resetPassword = resetPassword;
        vm.nameOnBlur = nameOnBlur;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            // Figure out the title
            switch (vm.dialogData.type) {
                case 'create' :
                    vm.dialogTitle = vm.dialogTitles.create;
                    break;

                case 'edit' :
                    vm.dialogTitle = vm.dialogTitles.edit;
                    //vm.canRemove = true;
                    vm.canResetPassword = true;
                    break;

                default:
                    break;
            }

            if (vm.dialogData.user) {
                vm.user = vm.dialogData.user;
                vm.user.role = 'hospital_operator';
                vm.selectedLocation = _.find(vm.locations, ['id', vm.user.locations[0].id]);
                vm.trainingCompletion = moment(vm.user.training_completion).toDate();
                vm.certExpiry = moment(vm.user.cert_expiry).toDate();
            } else {
                vm.user = {
                    name: '',
                    email: '',
                    role: 'hospital_operator',
                    country: vm.hospital.country,
                    location_id: null,
                    operator_id: null,
                    initials: null,
                    training_completion: null,
                    cert_expiry: null,
                    preferred_measurement_unit: vm.hospital.default_measurement_unit,
                    status: 'active'
                };
            }
        }

        function save() {
            vm.user.location_id = vm.selectedLocation.id;
            vm.user.training_completion = moment(vm.trainingCompletion).startOf('day').format();
            vm.user.cert_expiry = moment(vm.certExpiry).startOf('day').format();

            var response = {
                type: vm.dialogData.type,
                user: vm.user
            };

            $mdDialog.hide(response);
        }

        function remove() {
            var response = {
                type: 'remove',
                user: vm.user
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function resetPassword() {
            var response = {
                type: 'resetPassword',
                user: vm.user
            };

            $mdDialog.hide(response);
        }

        function nameOnBlur() {
            if (!vm.user.initials) {
                vm.user.initials = _.flatMap(_.words(vm.user.name), function(word) {
                    return word.substring(0, 1).toUpperCase();
                }).join('');
            }
        }

        function translate() {
            return $translate([
                'HOSPITAL_OPERATOR_FORM.CREATE',
                'HOSPITAL_OPERATOR_FORM.EDIT'
            ]).then(function(translations) {
                vm.dialogTitles = {
                    create: translations['HOSPITAL_OPERATOR_FORM.CREATE'],
                    edit: translations['HOSPITAL_OPERATOR_FORM.EDIT']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.user.hospital-admin', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.hospital-admin', {
                url    : '/hospital-admin',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/user/hospital-admin/hospital-admin.html',
                        controller : 'HospitalAdminController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_country_admin'],
                    module: 'hospital-admin'
                },
                resolve: {
                    hospitalsData: function(msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        if (user.role.name === 'roche_country_admin') {
                            return msApi.request('hospitals@get', {
                                country: user.country
                            });
                        }
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/user/hospital-admin');
        $translatePartialLoaderProvider.addPart('app/main/user/hospital-admin/hospital-admin-form');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('users', ['/users']);
        msApiProvider.register('users.edit', ['/users/:id', {id: '@id'}, {
            update: { method:'PUT'}
        }]);
        msApiProvider.register('users.reset-password', ['/users/reset_password']);

        msApiProvider.register('users.export', ['/users/export', {}, {
            download: {method: 'GET', responseType: 'arraybuffer', transformResponse: function(data, headersGetter) {
                // Stores the ArrayBuffer object in a property called "data"
                return { data : data };
            }}
        }]);

        msNavigationServiceProvider.saveItem('hospital-admin', {
            title    : 'Hospital Admin Register',
            icon     : 'icon-clipboard-account',
            state    : 'app.hospital-admin',
            weight   : 6,
            translate: 'HOSPITAL_ADMIN.NAV'
        });
    }
})();

(function ()
{
    'use strict';

    angular.module('app.user.hospital-admin')
        .controller('HospitalAdminFormController', HospitalAdminFormController);

    /** @ngInject */
    function HospitalAdminFormController($mdDialog, dialogData, resolveData, $translate, $log)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.countries = vm.dialogData.countries;
        vm.country = vm.dialogData.country;
        vm.hospitals = resolveData.hospitals;
        vm.selectedHospital = null;

        // Methods
        vm.save = save;
        vm.remove = remove;
        vm.close = close;
        vm.resetPassword = resetPassword;
        vm.canRemove = false;
        vm.canResetPassword = false;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            // Figure out the title
            switch (vm.dialogData.type)
            {
                case 'create' :
                    vm.dialogTitle = vm.dialogTitles.create;
                    break;

                case 'edit' :
                    vm.dialogTitle = vm.dialogTitles.edit;
                    //vm.canRemove = true;
                    vm.canResetPassword = true;
                    break;

                default:
                    break;
            }

            if (vm.dialogData.user) {
                vm.user = vm.dialogData.user;
                vm.user.role = 'hospital_admin';
                vm.selectedHospital = _.find(vm.hospitals, ['id', vm.user.hospitals[0].id]);
            } else {
                vm.user = {
                    name: '',
                    email: '',
                    role: 'hospital_admin',
                    country: vm.country,
                    hospital_id: null,
                    department: null,
                    phone: null,
                    status: 'active'
                };
            }
        }

        function save(){
            vm.user.hospital_id = vm.selectedHospital.id;
            vm.user.preferred_measurement_unit = vm.selectedHospital.default_measurement_unit;
            vm.user.available_modules = vm.selectedHospital.default_modules;

            var response = {
                type: vm.dialogData.type,
                user: vm.user
            };

            $mdDialog.hide(response);
        }

        function remove() {
            var response = {
                type: 'remove',
                user: vm.user
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function resetPassword() {
            var response = {
                type: 'resetPassword',
                user: vm.user
            };

            $mdDialog.hide(response);
        }

        function translate() {
            return $translate([
                'HOSPITAL_ADMIN_FORM.CREATE',
                'HOSPITAL_ADMIN_FORM.EDIT'
            ]).then(function(translations) {
                vm.dialogTitles = {
                    create: translations['HOSPITAL_ADMIN_FORM.CREATE'],
                    edit: translations['HOSPITAL_ADMIN_FORM.EDIT']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.user.country-admin', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.country-admin', {
                url    : '/country-admin',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/user/country-admin/country-admin.html',
                        controller : 'CountryAdminController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin'],
                    module: 'country-admin'
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/user/country-admin');
        $translatePartialLoaderProvider.addPart('app/main/user/country-admin/country-admin-form');

        // Api
        msApiProvider.register('users', ['/users']);
        msApiProvider.register('users.edit', ['/users/:id', {id: '@id'}, {
            update: { method:'PUT'}
        }]);
        msApiProvider.register('users.reset-password', ['/users/reset_password']);
        msApiProvider.register('users.export', ['/users/export', {}, {
            download: {method: 'GET', responseType: 'arraybuffer', transformResponse: function(data, headersGetter) {
                // Stores the ArrayBuffer object in a property called "data"
                return { data : data };
            }}
        }]);

        msNavigationServiceProvider.saveItem('country-admin', {
            title    : 'Country Admin Register',
            icon     : 'icon-account-location',
            state    : 'app.country-admin',
            weight   : 3,
            translate: 'COUNTRY_ADMIN.NAV'
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.user.country-admin')
        .controller('CountryAdminFormController', CountryAdminFormController);

    /** @ngInject */
    function CountryAdminFormController($mdDialog, dialogData, $translate, $log)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.countries = _.sortBy(_.transform(vm.dialogData.countries, function(result, value, key) {
            result.push({ code: key, name: value });
        }, []), 'name');

        vm.selectedCountry = vm.countries[0];

        // Methods
        vm.save = save;
        vm.remove = remove;
        vm.close = close;
        vm.resetPassword = resetPassword;
        vm.canRemove = false;
        vm.canResetPassword = false;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            // Figure out the title
            switch (vm.dialogData.type)
            {
                case 'create' :
                    vm.dialogTitle = vm.dialogTitles.create;
                    break;

                case 'edit' :
                    vm.dialogTitle = vm.dialogTitles.edit;
                    //vm.canRemove = true;
                    vm.canResetPassword = true;
                    break;

                default:
                    break;
            }

            if (vm.dialogData.user) {
                vm.user = vm.dialogData.user;
                vm.user.role = 'roche_country_admin';
                vm.selectedCountry = _.find(vm.countries, ['code', vm.user.country]);
            } else {
                vm.user = {
                    name: '',
                    email: '',
                    role: 'roche_country_admin',
                    country: vm.selectedCountry.code,
                    preferred_measurement_unit: 'MMOL_PER_L',
                    status: 'active'
                };
            }
        }

        function save(){
            vm.user.country = vm.selectedCountry.code;

            var response = {
                type: vm.dialogData.type,
                user: vm.user
            };

            $mdDialog.hide(response);
        }

        function remove() {
            var response = {
                type: 'remove',
                user: vm.user
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function resetPassword() {
            var response = {
                type: 'resetPassword',
                user: vm.user
            };

            $mdDialog.hide(response);
        }

        function translate() {
            return $translate([
                'COUNTRY_ADMIN_FORM.CREATE',
                'COUNTRY_ADMIN_FORM.EDIT'
            ]).then(function(translations) {
                vm.dialogTitles = {
                    create: translations['COUNTRY_ADMIN_FORM.CREATE'],
                    edit: translations['COUNTRY_ADMIN_FORM.EDIT']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.multiple.logbook')
        .controller('MultipleLogbookController', MultipleLogbookController);

    /** @ngInject */
    function MultipleLogbookController($scope, countriesData, statesData, hospitalsData, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;
        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        init();

        // Methods
        vm.exportToCSV = exportToCSV;
        vm.exportToExcel = exportToExcel;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToCSV() {
            $scope.$broadcast('report::exportToCSV');
        }

        function exportToExcel() {
            $scope.$broadcast('report::exportToExcel');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.multiple.level1')
        .controller('MultipleLevel1Controller', MultipleLevel1Controller);

    /** @ngInject */
    function MultipleLevel1Controller($scope, countriesData, statesData, hospitalsData, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;
        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        init();

        // Methods
        vm.exportToPDF = exportToPDF;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToPDF() {
            $scope.$broadcast('report::exportToPDF');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.multiple.level2')
        .controller('MultipleLevel2Controller', MultipleLevel2Controller);

    /** @ngInject */
    function MultipleLevel2Controller($scope, countriesData, statesData, hospitalsData, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;
        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        init();

        // Methods
        vm.exportToPDF = exportToPDF;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToPDF() {
            $scope.$broadcast('report::exportToPDF');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.multiple.combined')
        .controller('MultipleCombinedController', MultipleCombinedController);

    /** @ngInject */
    function MultipleCombinedController($scope, countriesData, statesData, hospitalsData, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;
        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        init();

        // Methods
        vm.exportToPDF = exportToPDF;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToPDF() {
            $scope.$broadcast('report::exportToPDF');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.single.level2')
        .controller('SingleLevel2Controller', SingleLevel1Controller);

    /** @ngInject */
    function SingleLevel1Controller($scope, countriesData, statesData, hospitalsData, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;
        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        init();

        // Methods
        vm.exportToPDF = exportToPDF;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToPDF() {
            $scope.$broadcast('report::exportToPDF');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.single.logbook')
        .controller('SingleLogbookController', SingleLogbookController);

    /** @ngInject */
    function SingleLogbookController($scope, countriesData, statesData, hospitalsData, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;
        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        init();

        // Methods
        vm.exportToCSV = exportToCSV;
        vm.exportToExcel = exportToExcel;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToCSV() {
            $scope.$broadcast('report::exportToCSV');
        }

        function exportToExcel() {
            $scope.$broadcast('report::exportToExcel');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.single.level1')
        .controller('SingleLevel1Controller', SingleLevel1Controller);

    /** @ngInject */
    function SingleLevel1Controller($scope, countriesData, statesData, hospitalsData, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;
        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        init();

        // Methods
        vm.exportToPDF = exportToPDF;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToPDF() {
            $scope.$broadcast('report::exportToPDF');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.single.combined')
        .controller('SingleCombinedController', SingleCombinedController);

    /** @ngInject */
    function SingleCombinedController($scope, countriesData, statesData, hospitalsData, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;
        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        init();

        // Methods
        vm.exportToPDF = exportToPDF;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToPDF() {
            $scope.$broadcast('report::exportToPDF');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.mfr-control-limits.level1')
        .controller('MfrControlLimitsLevel1Controller', MfrControlLimitsLevel1Controller);

    /** @ngInject */
    function MfrControlLimitsLevel1Controller($scope, countriesData, statesData, hospitalsData, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;
        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        init();

        // Methods
        vm.exportToPDF = exportToPDF;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToPDF() {
            $scope.$broadcast('report::exportToPDF');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.mfr-control-limits.level2')
        .controller('MfrControlLimitsLevel2Controller', MfrControlLimitsLevel1Controller);

    /** @ngInject */
    function MfrControlLimitsLevel1Controller($scope, countriesData, statesData, hospitalsData, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;
        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        init();

        // Methods
        vm.exportToPDF = exportToPDF;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToPDF() {
            $scope.$broadcast('report::exportToPDF');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qc-report.hospital.qcperformance')
        .controller('HospitalQCPerformanceController', HospitalQCPerformanceController);

    /** @ngInject */
    function HospitalQCPerformanceController(countriesData, statesData, hospitalsData, $scope, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;

        vm.loaded = false;
        vm.valid = false;
        vm.hasData = false;

        vm.isReadOnly = false;

        // Methods
        vm.exportToPDF = exportToPDF;

        init();

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToPDF() {
            $scope.$broadcast('report::exportToPDF');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.sdchart')
        .controller('HospitalSDChartController', HospitalSDChartController);

    /** @ngInject */
    function HospitalSDChartController(countriesData, statesData, hospitalsData, $scope, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();

        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;

        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        // Methods
        vm.exportToPDF = exportToPDF;

        init();

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToPDF() {
            $scope.$broadcast('report::exportToPDF');
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard.component', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dashboard/component/qc-failed');
        $translatePartialLoaderProvider.addPart('app/main/dashboard/component/qc-history');

        // Api
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('meters.last-qcdate', ['/meters/last_qcdate']);
        msApiProvider.register('logs', ['/logs']);
        msApiProvider.register('quality_control_tests', ['/quality_control_tests']);
        msApiProvider.register('quality_control_tests.edit', ['/quality_control_tests/:id', {id: '@id'}, {
            update: { method:'PUT'}
        }]);
    }
})();
(function() {
    'use strict';

    angular
        .module('app.dashboard.component')
        .component('qcHistory', {
            templateUrl: 'app/main/dashboard/component/qc-history/qc-history.html',
            controller: QCHistoryController,
            controllerAs: 'vm',
            bindings: {
                hospital: '<',
                loaded: '='
            }
        });

    /** @ngInject */
    function QCHistoryController(msApi, $timeout, $mdDialog, $document, $translate, $log) {
        var vm = this;

        // Data
        vm.meters = [];
        vm.show = false;
        vm.pagination = {
            total:0,
            per_page: 5,
            current_page: 1
        };

        vm.sort = 'last_qcdate';
        vm.emptyMessage = null;


        // Methods
        vm.$onInit = init;
        vm.showActionLog = showActionLog;
        vm.getLastQCDate = getLastQCDate;
        vm.getDuration = getDuration;

        ////////////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            vm.isReadOnly = (vm.hospital.cloud_link && vm.hospital.cloud_link.is_cloud_link_enabled);

            vm.ranges = [
                {
                    text: vm.options.moreThan1Day,
                    value: 1
                },
                {
                    text: vm.options.moreThen7Days,
                    value: 7
                },
                {
                    text: vm.options.moreThen14Days,
                    value: 14
                },
                {
                    text: vm.options.moreThen30Days,
                    value: 30
                },
                {
                    text: vm.options.moreThen60Days,
                    value: 60
                },
                {
                    text: vm.options.moreThen90Days,
                    value: 90
                },
                {
                    text: vm.options.all,
                    value: null
                }
            ];

            vm.range = vm.ranges[0];

            getLastQCDate().then(function() {
                $timeout( function(){
                    vm.loaded = true;
                    vm.show = true;
                }, 300);
            });
        }

        function showActionLog(meter, e) {
            var dialogData = {
                meter: meter,
                isReadOnly: vm.isReadOnly
            };

            $mdDialog.show({
                controller: 'ActionLogDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/action-log-dialog/action-log-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        var pagination = {
                            total:0,
                            per_page: 5,
                            current_page: 1
                        };

                        var params = {
                            meter_id: meter.id,
                            sort: 'created_at:desc'
                        };

                        return msApi.request('logs@get',  angular.extend(pagination, params));
                    }
                }
            });
        }

        function getLastQCDate() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: vm.range.value ? moment().subtract(vm.range.value, 'days').startOf('day').format() : null,
                hospital_id: vm.hospital.id,
                sort: sort + ':' + order
            };

            vm.promise = msApi.request('meters.last-qcdate@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.pagination.total = response.meters.total;
                    if (vm.pagination.total === 0) {
                        showEmptyMessage();
                        vm.meters = [];
                    } else {
                        vm.meters = response.meters.data;
                    }
                    return response;
                });

            return vm.promise;
        }

        function getDuration(dateTime) {
            var now = moment(new Date());
            var timestamp = moment(dateTime);
            return (now.diff(timestamp, 'days') + ' days');
        }

        function showEmptyMessage() {
            if (vm.range.value) {
                $translate('QC_HISTORY.MESSAGES.NO_QC_NOT_DONE', { selectedRange: vm.range.text })
                    .then(function (translation) {
                        vm.emptyMessage = translation;
                    });
            } else {
                vm.emptyMessage = vm.messages.noQCData;
            }
        }

        function translate() {
            return $translate([
                'QC_HISTORY.MESSAGES.NO_QC_NOT_DONE',
                'QC_HISTORY.MESSAGES.NO_QC_DATA',
                'QC_HISTORY.OPTIONS.MORE_THAN_1_DAY',
                'QC_HISTORY.OPTIONS.MORE_THAN_7_DAYS',
                'QC_HISTORY.OPTIONS.MORE_THAN_14_DAYS',
                'QC_HISTORY.OPTIONS.MORE_THAN_30_DAYS',
                'QC_HISTORY.OPTIONS.MORE_THAN_60_DAYS',
                'QC_HISTORY.OPTIONS.MORE_THAN_90_DAYS',
                'QC_HISTORY.OPTIONS.ALL',
                'QC_HISTORY.PAGINATION.OF',
                'QC_HISTORY.PAGINATION.PAGE',
                'QC_HISTORY.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.messages = {
                    noQCNotDone: translations['QC_HISTORY.MESSAGES.NO_QC_NOT_DONE'],
                    noQCData: translations['QC_HISTORY.MESSAGES.NO_QC_DATA']
                };

                vm.options = {
                    moreThan1Day: translations['QC_HISTORY.OPTIONS.MORE_THAN_1_DAY'],
                    moreThen7Days: translations['QC_HISTORY.OPTIONS.MORE_THAN_7_DAYS'],
                    moreThen14Days: translations['QC_HISTORY.OPTIONS.MORE_THAN_14_DAYS'],
                    moreThen30Days: translations['QC_HISTORY.OPTIONS.MORE_THAN_30_DAYS'],
                    moreThen60Days: translations['QC_HISTORY.OPTIONS.MORE_THAN_60_DAYS'],
                    moreThen90Days: translations['QC_HISTORY.OPTIONS.MORE_THAN_90_DAYS'],
                    all: translations['QC_HISTORY.OPTIONS.ALL']
                };

                vm.paginationLabel = {
                    of: translations['QC_HISTORY.PAGINATION.OF'],
                    page: translations['QC_HISTORY.PAGINATION.PAGE'],
                    rowsPerPage: translations['QC_HISTORY.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.dashboard.component')
        .component('qcFailed', {
            templateUrl: 'app/main/dashboard/component/qc-failed/qc-failed.html',
            controller: QCFailedController,
            controllerAs: 'vm',
            bindings: {
                hospital: '<',
                measurementUnit: '<',
                loaded: '='
            }
        });

    /** @ngInject */
    function QCFailedController(msApi, $timeout, toastService, $mdDialog, $document, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.pagination = {
            total:0,
            per_page: 5,
            current_page: 1
        };

        vm.qualityControlTests = [];
        vm.show = false;
        vm.emptyMessage = null;

        // Methods
        vm.$onInit = init;
        vm.editNotes = editNotes;
        vm.actionCompleted = actionCompleted;
        vm.getQualityControlTests = getQualityControlTests;

        ////////////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            vm.isReadOnly = (vm.hospital.cloud_link && vm.hospital.cloud_link.is_cloud_link_enabled);

            vm.ranges = [
                {
                    text: vm.options.last7Days,
                    value: 7
                },
                {
                    text: vm.options.last14Days,
                    value: 14
                },
                {
                    text: vm.options.last30Days,
                    value: 30
                },
                {
                    text: vm.options.last60Days,
                    value: 60
                },
                {
                    text: vm.options.last90Days,
                    value: 90
                },
                {
                    text: vm.options.all,
                    value: null
                }
            ];

            vm.range = vm.ranges[0];

            getQualityControlTests().then(function () {
                $timeout( function(){
                    vm.loaded = true;
                    vm.show = true;
                }, 300);
            });
        }

        function getQualityControlTests() {
            var params = {
                start_date: vm.range.value ? moment().subtract(vm.range.value, 'days').startOf('day').format() : null,
                end_date: vm.range.value ? moment().endOf('day').format() : null,
                hospital_id: vm.hospital.id,
                within_range: 0,
                actions_taken: 0,
                measurement_unit: vm.measurementUnit
            };

            vm.promise =  msApi.request('quality_control_tests@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.pagination.total = response.quality_control_tests.total;
                    if (vm.pagination.total === 0) {
                        showEmptyMessage();
                        vm.qualityControlTests = [];
                    } else {
                        vm.qualityControlTests = response.quality_control_tests.data;
                    }
                });

            return vm.promise;
        }

        function editNotes(test, e) {
            var testToUpdate = angular.copy(test);

            var dialogData = {
                notes: testToUpdate.notes,
                readonly: vm.isReadOnly
            };

            $mdDialog.show({
                controller: 'EditNotesDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/edit-notes-dialog/edit-notes-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    dialogData: dialogData
                }
            }).then(function (dialogResponse) {
                testToUpdate.notes = dialogResponse.notes;
                updateQualityControlTest(testToUpdate);
            });
        }

        function actionCompleted(test) {
            if (test.actions_taken) {
                var testToUpdate = angular.copy(test);
                testToUpdate.actions_taken_at = moment().format();
                updateQualityControlTest(testToUpdate);
            }
        }

        function updateQualityControlTest(testToUpdate) {
            return msApi.request('quality_control_tests.edit@update', {
                    id:  testToUpdate.id,
                    actions_taken_at: testToUpdate.actions_taken_at,
                    notes: testToUpdate.notes
                },
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.qcTestUpdated);
                    var test = _.find(vm.qualityControlTests, ['id', response.quality_control_test.id]);
                    test.notes = response.quality_control_test.notes;

                    if (response.quality_control_test.actions_taken) {
                        test.disabled = true;
                    }
                });
        }

        function showEmptyMessage() {
            if (vm.range.value) {
                $translate('QC_FAILED.MESSAGES.NO_QC_FAILED_FOR', { selectedRange: vm.range.text })
                    .then(function (translation) {
                        vm.emptyMessage = translation;
                    });
            } else {
                vm.emptyMessage = vm.messages.noQCFailed;
            }
        }

        function translate() {
            return $translate([
                'QC_FAILED.MESSAGES.NO_QC_FAILED_FOR',
                'QC_FAILED.MESSAGES.NO_QC_FAILED',
                'QC_FAILED.MESSAGES.QC_TEST_UPDATED',
                'QC_FAILED.OPTIONS.LAST_7_DAYS',
                'QC_FAILED.OPTIONS.LAST_14_DAYS',
                'QC_FAILED.OPTIONS.LAST_30_DAYS',
                'QC_FAILED.OPTIONS.LAST_60_DAYS',
                'QC_FAILED.OPTIONS.LAST_90_DAYS',
                'QC_FAILED.OPTIONS.ALL',
                'QC_FAILED.PAGINATION.OF',
                'QC_FAILED.PAGINATION.PAGE',
                'QC_FAILED.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.messages = {
                    noQCFailedFor: translations['QC_FAILED.MESSAGES.NO_QC_FAILED_FOR'],
                    noQCFailed: translations['QC_FAILED.MESSAGES.NO_QC_FAILED'],
                    qcTestUpdated: translations['QC_FAILED.MESSAGES.QC_TEST_UPDATED']
                };

                vm.options = {
                    last7Days: translations['QC_FAILED.OPTIONS.LAST_7_DAYS'],
                    last14Days: translations['QC_FAILED.OPTIONS.LAST_14_DAYS'],
                    last30Days: translations['QC_FAILED.OPTIONS.LAST_30_DAYS'],
                    last60Days: translations['QC_FAILED.OPTIONS.LAST_60_DAYS'],
                    last90Days: translations['QC_FAILED.OPTIONS.LAST_90_DAYS'],
                    all: translations['QC_FAILED.OPTIONS.ALL']
                };

                vm.paginationLabel = {
                    of: translations['QC_FAILED.PAGINATION.OF'],
                    page: translations['QC_FAILED.PAGINATION.PAGE'],
                    rowsPerPage: translations['QC_FAILED.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.user.hospital-operator')
        .controller('HospitalOperatorController', HospitalOperatorController);

    /** @ngInject */
    function HospitalOperatorController(msApi, $timeout, toastService, $mdDialog, $document, localStorageService, $translate, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.pagination = {
            total:0,
            per_page: 5,
            current_page: 1
        };
        vm.searchTerm = '';
        vm.sort = "-created_at";
        vm.users = [];

        vm.show = false;
        vm.isReadOnly = false;

        init();

        // Methods
        vm.create = create;
        vm.edit = edit;
        vm.getUsers = getUsers;
        vm.exportToCSV = exportToCSV;
        vm.exportToExcel = exportToExcel;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.isReadOnly = vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;

            translate()
                .then(load);

        }

        function load() {
            getUsers().then(function() {
                $timeout( function(){
                    vm.show = true;
                }, 300);
            });
        }

        function create(e) {
            showHospitalOperatorFormDialog('create', null, e);
        }

        function edit(user, e) {
            showHospitalOperatorFormDialog('edit', angular.copy(user), e);
        }

        function exportToCSV() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                role: 'hospital_operator',
                hospital_id: vm.user.hospitals[0].id,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('users@get',
                params,
                // SUCCESS
                function (response) {
                    var users = response.users;
                    var data =  _.map(users, function (user) {
                        return {
                            name: user.name,
                            operatorId: user.operator_id,
                            initials: user.initials,
                            locationCode: user.locations[0]['code'],
                            trainingCompletion: moment(user.training_completion).format('YYYY-MM-DD'),
                            certExpiry: moment(user.cert_expiry).format('YYYY-MM-DD'),
                            created: moment(user.created_at).format(),
                            status: vm.status[user.status]
                        };
                    });

                    var timestamp = moment();
                    var filename = 'HospitalOperators-' + timestamp.format('YMMDDHm');

                    alasql('SELECT name AS [' + vm.columns.operator + '], ' +
                        'operatorId AS [' + vm.columns.opId + '],' +
                        'initials AS [' + vm.columns.opInitials + '],' +
                        'locationCode AS [' + vm.columns.locationCode + '],' +
                        'trainingCompletion AS [' + vm.columns.trainingCompletion + '],' +
                        'certExpiry AS [' + vm.columns.trainingCertExpiry + '], ' +
                        'created AS [' + vm.columns.created + '], ' +
                        'status AS [' + vm.columns.status + '] ' +
                        'INTO CSV(?, {headers:true, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                role: 'hospital_operator',
                hospital_id: vm.user.hospitals[0].id,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('users@get',
                params,
                // SUCCESS
                function (response) {
                    var users = response.users;
                    var data =  _.map(users, function (user) {
                        return {
                            name: user.name,
                            operatorId: user.operator_id,
                            initials: user.initials,
                            locationCode: user.locations[0]['code'],
                            trainingCompletion: moment(user.training_completion).format('YYYY-MM-DD'),
                            certExpiry: moment(user.cert_expiry).format('YYYY-MM-DD'),
                            created: moment(user.created_at).format(),
                            status: vm.status[user.status]
                        };
                    });

                    var timestamp = moment();
                    var filename = 'HospitalOperators-' + timestamp.format('YMMDDHm');

                    alasql('SELECT name AS [' + vm.columns.operator + '], ' +
                        'operatorId AS [' + vm.columns.opId + '],' +
                        'initials AS [' + vm.columns.opInitials + '],' +
                        'locationCode AS [' + vm.columns.locationCode + '],' +
                        'trainingCompletion AS [' + vm.columns.trainingCompletion + '],' +
                        'certExpiry AS [' + vm.columns.trainingCertExpiry + '], ' +
                        'created AS [' + vm.columns.created + '], ' +
                        'status AS [' + vm.columns.status + '] ' +
                        'INTO XLSX(?, {headers:true}) FROM ?',[filename, data]);
                });
        }

        function showHospitalOperatorFormDialog(type, user, e) {
            var dialogData = {
                type: type,
                hospital: vm.user.hospitals[0],
                user: user
            };

            $mdDialog.show({
                controller: 'HospitalOperatorFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/user/hospital-operator/hospital-operator-form/hospital-operator-form.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    locationData: function() {
                        return msApi.request('locations@get', {'hospital_id' : vm.user.hospitals[0].id});
                    }
                }
            }).then(function (dialogResponse) {
                switch (dialogResponse.type) {
                    case 'create':
                        createUser(dialogResponse.user);
                        break;

                    case 'edit':
                        editUser(dialogResponse.user);
                        break;

                    case 'remove':
                        break;

                    case 'resetPassword':
                        resetPassword(dialogResponse.user);
                        break;
                }
            });
        }

        function showCopyPasswordDialog(user, password) {
            var dialogData = {
                user: user,
                password: password
            };

            $mdDialog.show({
                controller: 'CopyPasswordDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/copy-password-dialog/copy-password-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    dialogData: dialogData
                }
            }).then(function () {
                getUsers();
            });
        }

        function getUsers() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                role: 'hospital_operator',
                hospital_id: vm.user.hospitals[0].id,
                search: searchTerm,
                sort: sort + ':' + order
            };

            vm.promise = msApi.request('users@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.users = response.users.data;
                    vm.pagination.total = response.users.total;
                });

            return vm.promise;
        }

        function createUser(user) {
            return msApi.request('users@save',
                user,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.created);
                    showCopyPasswordDialog(response.user, response.password);
                });
        }

        function editUser(user) {console.log(user);
            return msApi.request('users.edit@update',
                user,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.updated);
                    getUsers();
                });
        }

        function resetPassword(user) {
            return msApi.request('users.reset-password@save',
                user,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.passwordReset);
                    showCopyPasswordDialog(response.user, response.password);
                });
        }

        function translate() {
            return $translate([
                'HOSPITAL_OPERATOR.COLUMNS.OPERATOR',
                'HOSPITAL_OPERATOR.COLUMNS.OP_ID',
                'HOSPITAL_OPERATOR.COLUMNS.OP_INITIALS',
                'HOSPITAL_OPERATOR.COLUMNS.LOCATION_CODE',
                'HOSPITAL_OPERATOR.COLUMNS.TRAINING_COMPLETION',
                'HOSPITAL_OPERATOR.COLUMNS.TRAINING_CERT_EXPIRY',
                'HOSPITAL_OPERATOR.COLUMNS.CREATED',
                'HOSPITAL_OPERATOR.COLUMNS.STATUS',
                'HOSPITAL_OPERATOR.ACTIVE',
                'HOSPITAL_OPERATOR.INACTIVE',
                'HOSPITAL_OPERATOR.MESSAGES.CREATED',
                'HOSPITAL_OPERATOR.MESSAGES.UPDATED',
                'HOSPITAL_OPERATOR.MESSAGES.PASSWORD_RESET',
                'HOSPITAL_OPERATOR.MESSAGES.NO_PERMISSION_CREATE_USER',
                'HOSPITAL_OPERATOR.MESSAGES.NO_PERMISSION_UPDATE_USER',
                'HOSPITAL_OPERATOR.MESSAGES.NO_PERMISSION_RESET_PASSWORD',
                'HOSPITAL_OPERATOR.PAGINATION.OF',
                'HOSPITAL_OPERATOR.PAGINATION.PAGE',
                'HOSPITAL_OPERATOR.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.columns = {
                    operator: translations['HOSPITAL_OPERATOR.COLUMNS.OPERATOR'],
                    opId: translations['HOSPITAL_OPERATOR.COLUMNS.OP_ID'],
                    opInitials: translations['HOSPITAL_OPERATOR.COLUMNS.OP_INITIALS'],
                    locationCode: translations['HOSPITAL_OPERATOR.COLUMNS.LOCATION_CODE'],
                    trainingCompletion: translations['HOSPITAL_OPERATOR.COLUMNS.TRAINING_COMPLETION'],
                    trainingCertExpiry: translations['HOSPITAL_OPERATOR.COLUMNS.TRAINING_CERT_EXPIRY'],
                    created: translations['HOSPITAL_OPERATOR.COLUMNS.CREATED'],
                    status: translations['HOSPITAL_OPERATOR.COLUMNS.STATUS']
                };

                vm.status = {
                    active: translations['HOSPITAL_OPERATOR.ACTIVE'],
                    inactive: translations['HOSPITAL_OPERATOR.INACTIVE']
                };

                vm.messages = {
                    created: translations['HOSPITAL_OPERATOR.MESSAGES.CREATED'],
                    updated: translations['HOSPITAL_OPERATOR.MESSAGES.UPDATED'],
                    passwordReset: translations['HOSPITAL_OPERATOR.MESSAGES.PASSWORD_RESET'],
                    noPermissionCreateUser: translations['HOSPITAL_OPERATOR.MESSAGES.NO_PERMISSION_CREATE_USER'],
                    noPermissionUpdateUser: translations['HOSPITAL_OPERATOR.MESSAGES.NO_PERMISSION_UPDATE_USER'],
                    noPermissionResetPasswordUser: translations['HOSPITAL_OPERATOR.MESSAGES.NO_PERMISSION_RESET_PASSWORD']
                };

                vm.paginationLabel = {
                    of: translations['HOSPITAL_OPERATOR.PAGINATION.OF'],
                    page: translations['HOSPITAL_OPERATOR.PAGINATION.PAGE'],
                    rowsPerPage: translations['HOSPITAL_OPERATOR.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.user.hospital-admin')
        .controller('HospitalAdminController', HospitalAdminController);

    /** @ngInject */
    function HospitalAdminController(countriesData, hospitalsData, msApi, $timeout, toastService, $mdDialog, $document, localStorageService, $translate, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.pagination = {
            total:0,
            per_page: 5,
            current_page: 1
        };
        vm.searchTerm = '';
        vm.sort = "-created_at";
        vm.countries = countriesData.countries;
        vm.hospitals = hospitalsData ? _.sortBy(hospitalsData.hospitals, 'name') : null;
        vm.selectedHospital = null;
        vm.users = [];

        vm.show = false;

        init();

        // Methods
        vm.create = create;
        vm.edit = edit;
        vm.getUsers = getUsers;
        vm.exportToCSV = exportToCSV;
        vm.exportToExcel = exportToExcel;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            translate()
                .then(load);

        }

        function load() {
            getUsers()
                .then(function() {
                    $timeout( function(){
                        vm.show = true;
                    }, 300);
                });
        }

        function create(e) {
            showHospitalAdminFormDialog('create', null, e);
        }

        function edit(user, e) {
            showHospitalAdminFormDialog('edit', angular.copy(user), e);
        }

        function exportToCSV() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                role: 'hospital_admin',
                country: vm.user.country,
                hospital_id: vm.selectedHospital ? vm.selectedHospital.id : null,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('users@get',
                params,
                // SUCCESS
                function (response) {
                    var users = response.users;
                    var data =  _.map(users, function (user) {
                        return {
                            name: user.name,
                            email: user.email,
                            hospital: user.hospitals[0].name,
                            department: user.department ?  user.department : '',
                            phone: user.phone ? user.phone : '',
                            created: moment(user.created_at).format(),
                            status: vm.status[user.status]
                        };
                    });

                    var timestamp = moment();
                    var filename = 'HospitalAdmins-' + timestamp.format('YMMDDHm');

                    alasql('SELECT name AS [' + vm.columns.name + '], ' +
                        'email AS [' + vm.columns.email + '],' +
                        'hospital AS [' + vm.columns.hospital + '],' +
                        'department AS [' + vm.columns.department + '],' +
                        'phone AS [' + vm.columns.phone + '],' +
                        'created AS [' + vm.columns.created + '], ' +
                        'status AS [' + vm.columns.status + '] ' +
                        'INTO CSV(?, {headers:true, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                role: 'hospital_admin',
                country: vm.user.country,
                hospital_id: vm.selectedHospital ? vm.selectedHospital.id : null,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('users@get',
                params,
                // SUCCESS
                function (response) {
                    var users = response.users;
                    var data =  _.map(users, function (user) {
                        return {
                            name: user.name,
                            email: user.email,
                            hospital: user.hospitals[0].name,
                            department: user.department ?  user.department : '',
                            phone: user.phone ? user.phone : '',
                            created: moment(user.created_at).format(),
                            status: vm.status[user.status]
                        };
                    });

                    var timestamp = moment();
                    var filename = 'HospitalAdmins-' + timestamp.format('YMMDDHm');

                    alasql('SELECT name AS [' + vm.columns.name + '], ' +
                        'email AS [' + vm.columns.email + '],' +
                        'hospital AS [' + vm.columns.hospital + '],' +
                        'department AS [' + vm.columns.department + '],' +
                        'phone AS [' + vm.columns.phone + '],' +
                        'created AS [' + vm.columns.created + '], ' +
                        'status AS [' + vm.columns.status + '] ' +
                        'INTO XLSX(?, {headers:true}) FROM ?',[filename, data]);
                });
        }

        function showHospitalAdminFormDialog(type, user, e) {
            var dialogData = {
                type: type,
                country: vm.user.country,
                countries: vm.countries,
                user: user
            };

            $mdDialog.show({
                controller: 'HospitalAdminFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/user/hospital-admin/hospital-admin-form/hospital-admin-form.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        return msApi.request('hospitals@get', {'country' : vm.user.country});
                    }
                }
            }).then(function (dialogResponse) {
                switch (dialogResponse.type) {
                    case 'create':
                        createUser(dialogResponse.user);
                        break;

                    case 'edit':
                        editUser(dialogResponse.user);
                        break;

                    case 'remove':
                        break;

                    case 'resetPassword':
                        resetPassword(dialogResponse.user);
                        break;
                }
            });
        }

        function showCopyPasswordDialog(user, password) {
            var dialogData = {
                user: user,
                password: password
            };

            $mdDialog.show({
                controller: 'CopyPasswordDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/copy-password-dialog/copy-password-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    dialogData: dialogData
                }
            }).then(function () {
                getUsers();
            });
        }

        function getCountries() {
            return msApi.request('countries@get',
                {},
                // SUCCESS
                function (response) {
                    vm.countries = response.countries;
                });
        }

        function getUsers() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                role: 'hospital_admin',
                country: vm.user.country,
                hospital_id: vm.selectedHospital ? vm.selectedHospital.id : null,
                search: searchTerm,
                sort: sort + ':' + order
            };

            vm.promise = msApi.request('users@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.users = response.users.data;
                    vm.pagination.total = response.users.total;
                });

            return vm.promise;
        }

        function createUser(user) {
            return msApi.request('users@save',
                user,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.created);
                    showCopyPasswordDialog(response.user, response.password);
                });
        }

        function editUser(user) {
            return msApi.request('users.edit@update',
                user,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.updated);
                    getUsers();
                });
        }

        function resetPassword(user) {
            return msApi.request('users.reset-password@save',
                user,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.passwordReset);
                    showCopyPasswordDialog(response.user, response.password);
                });
        }

        function translate() {
            return $translate([
                'HOSPITAL_ADMIN.COLUMNS.NAME',
                'HOSPITAL_ADMIN.COLUMNS.EMAIL',
                'HOSPITAL_ADMIN.COLUMNS.HOSPITAL',
                'HOSPITAL_ADMIN.COLUMNS.DEPARTMENT',
                'HOSPITAL_ADMIN.COLUMNS.PHONE',
                'HOSPITAL_ADMIN.COLUMNS.CREATED',
                'HOSPITAL_ADMIN.COLUMNS.STATUS',
                'HOSPITAL_ADMIN.ACTIVE',
                'HOSPITAL_ADMIN.INACTIVE',
                'HOSPITAL_ADMIN.MESSAGES.CREATED',
                'HOSPITAL_ADMIN.MESSAGES.UPDATED',
                'HOSPITAL_ADMIN.MESSAGES.PASSWORD_RESET',
                'HOSPITAL_ADMIN.MESSAGES.NO_PERMISSION_CREATE_USER',
                'HOSPITAL_ADMIN.MESSAGES.NO_PERMISSION_UPDATE_USER',
                'HOSPITAL_ADMIN.MESSAGES.NO_PERMISSION_RESET_PASSWORD',
                'HOSPITAL_ADMIN.PAGINATION.OF',
                'HOSPITAL_ADMIN.PAGINATION.PAGE',
                'HOSPITAL_ADMIN.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.columns = {
                    name: translations['HOSPITAL_ADMIN.COLUMNS.NAME'],
                    email: translations['HOSPITAL_ADMIN.COLUMNS.EMAIL'],
                    hospital: translations['HOSPITAL_ADMIN.COLUMNS.HOSPITAL'],
                    department: translations['HOSPITAL_ADMIN.COLUMNS.DEPARTMENT'],
                    phone: translations['HOSPITAL_ADMIN.COLUMNS.PHONE'],
                    created: translations['HOSPITAL_ADMIN.COLUMNS.CREATED'],
                    status: translations['HOSPITAL_ADMIN.COLUMNS.STATUS']
                };

                vm.status = {
                    active: translations['HOSPITAL_ADMIN.ACTIVE'],
                    inactive: translations['HOSPITAL_ADMIN.INACTIVE']
                };

                vm.messages = {
                    created: translations['HOSPITAL_ADMIN.MESSAGES.CREATED'],
                    updated: translations['HOSPITAL_ADMIN.MESSAGES.UPDATED'],
                    passwordReset: translations['HOSPITAL_ADMIN.MESSAGES.PASSWORD_RESET'],
                    noPermissionCreateUser: translations['HOSPITAL_ADMIN.MESSAGES.NO_PERMISSION_CREATE_USER'],
                    noPermissionUpdateUser: translations['HOSPITAL_ADMIN.MESSAGES.NO_PERMISSION_UPDATE_USER'],
                    noPermissionResetPasswordUser: translations['HOSPITAL_ADMIN.MESSAGES.NO_PERMISSION_RESET_PASSWORD']
                };

                vm.paginationLabel = {
                    of: translations['HOSPITAL_ADMIN.PAGINATION.OF'],
                    page: translations['HOSPITAL_ADMIN.PAGINATION.PAGE'],
                    rowsPerPage: translations['HOSPITAL_ADMIN.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.user.country-admin')
        .controller('CountryAdminController', CountryAdminController);

    /** @ngInject */
    function CountryAdminController(msApi, $timeout, toastService, $mdDialog, $document, $translate, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.pagination = {
            total:0,
            per_page: 5,
            current_page: 1
        };

        vm.searchTerm = '';
        vm.sort = "-created_at";
        vm.countries = {};
        vm.countryList = [];
        vm.users = [];
        vm.selectedCountry = null;

        vm.show = false;

        init();

        // Methods
        vm.create = create;
        vm.edit = edit;
        vm.getUsers = getUsers;
        vm.exportToCSV = exportToCSV;
        vm.exportToExcel = exportToExcel;

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            getCountries()
                .then(getUsers)
                .then(function() {
                    $timeout( function(){
                        vm.show = true;
                    }, 300);
                });
        }

        function create(e) {
            showCountryAdminFormDialog('create', null, e);
        }

        function edit(user, e) {
            showCountryAdminFormDialog('edit', angular.copy(user), e);
        }

        function exportToCSV() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                role: 'roche_country_admin',
                country: vm.selectedCountry ? vm.selectedCountry.code : null,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('users@get',
                params,
                // SUCCESS
                function (response) {
                    var users = response.users;
                    var data =  _.map(users, function (user) {
                        return {
                            name: user.name,
                            email: user.email,
                            country: vm.countries[user.country],
                            last_login: user.last_login_at ? moment(user.last_login_at).format() : vm.status.never,
                            created: moment(user.created_at).format(),
                            status: vm.status[user.status]
                        };
                    });

                    var timestamp = moment();
                    var filename = 'CountryAdmins-' + timestamp.format('YMMDDHm');

                    alasql('SELECT name AS [' + vm.columns.name + '], ' +
                        'email AS [' + vm.columns.email + '],' +
                        'country AS [' + vm.columns.country + '],' +
                        'last_login AS [' + vm.columns.last_login + '], ' +
                        'created AS [' + vm.columns.created + '], ' +
                        'status AS [' + vm.columns.status + '] ' +
                        'INTO CSV(?, {headers:true, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                role: 'roche_country_admin',
                country: vm.selectedCountry ? vm.selectedCountry.code : null,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('users@get',
                params,
                // SUCCESS
                function (response) {
                    var users = response.users;
                    var data =  _.map(users, function (user) {
                        return {
                            name: user.name,
                            email: user.email,
                            country: vm.countries[user.country],
                            last_login: user.last_login_at ? moment(user.last_login_at).format() : vm.status.never,
                            created: moment(user.created_at).format(),
                            status: vm.status[user.status]
                        };
                    });

                    var timestamp = moment();
                    var filename = 'CountryAdmins-' + timestamp.format('YMMDDHm');

                    alasql('SELECT name AS [' + vm.columns.name + '], ' +
                        'email AS [' + vm.columns.email + '],' +
                        'country AS [' + vm.columns.country + '],' +
                        'last_login AS [' + vm.columns.last_login + '], ' +
                        'created AS [' + vm.columns.created + '], ' +
                        'status AS [' + vm.columns.status + '] ' +
                        'INTO XLSX(?, {headers:true}) FROM ?',[filename, data]);
                });
        }

        function showCountryAdminFormDialog(type, user, e) {
            var dialogData = {
                type: type,
                user: user,
                countries: vm.countries
            };

            $mdDialog.show({
                controller: 'CountryAdminFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/user/country-admin/country-admin-form/country-admin-form.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                }
            }).then(function (dialogResponse) {
                switch (dialogResponse.type)    {
                    case 'create':
                        createUser(dialogResponse.user);
                        break;

                    case 'edit':
                        editUser(dialogResponse.user);
                        break;

                    case 'remove':
                        break;

                    case 'resetPassword':
                        resetPassword(dialogResponse.user);
                        break;
                }
            });
        }

        function showCopyPasswordDialog(user, password) {
            var dialogData = {
                user: user,
                password: password
            };

            $mdDialog.show({
                controller: 'CopyPasswordDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/copy-password-dialog/copy-password-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    dialogData: dialogData
                }
            }).then(function () {
                getUsers();
            });
        }

        function getCountries() {
            return msApi.request('countries@get',
                {},
                // SUCCESS
                function (response) {
                    vm.countries = response.countries;
                    vm.countryList = Object.keys(vm.countries).map(function(key) {
                        return { code: key, name: vm.countries[key] };
                    });
                });
        }

        function getUsers() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                role: 'roche_country_admin',
                country: vm.selectedCountry ? vm.selectedCountry.code : null,
                search: searchTerm,
                sort: sort + ':' + order
            };

            vm.promise = msApi.request('users@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.users = response.users.data;
                    vm.pagination.total = response.users.total;
                });

            return vm.promise;
        }

        function createUser(user) {
            return msApi.request('users@save',
                user,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.created);
                    showCopyPasswordDialog(response.user, response.password);
                });
        }

        function editUser(user) {
            return msApi.request('users.edit@update',
                user,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.updated);
                    getUsers();
                });
        }

        function resetPassword(user) {
            return msApi.request('users.reset-password@save',
                user,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.passwordReset);
                    showCopyPasswordDialog(response.user, response.password);
                });
        }

        function translate() {

            return $translate([
                'COUNTRY_ADMIN.COLUMNS.NAME',
                'COUNTRY_ADMIN.COLUMNS.EMAIL',
                'COUNTRY_ADMIN.COLUMNS.COUNTRY',
                'COUNTRY_ADMIN.COLUMNS.LAST_LOGIN',
                'COUNTRY_ADMIN.COLUMNS.CREATED',
                'COUNTRY_ADMIN.COLUMNS.STATUS',
                'COUNTRY_ADMIN.NEVER',
                'COUNTRY_ADMIN.ACTIVE',
                'COUNTRY_ADMIN.INACTIVE',
                'COUNTRY_ADMIN.MESSAGES.CREATED',
                'COUNTRY_ADMIN.MESSAGES.UPDATED',
                'COUNTRY_ADMIN.MESSAGES.PASSWORD_RESET',
                'COUNTRY_ADMIN.MESSAGES.NO_PERMISSION_CREATE_USER',
                'COUNTRY_ADMIN.MESSAGES.NO_PERMISSION_UPDATE_USER',
                'COUNTRY_ADMIN.MESSAGES.NO_PERMISSION_RESET_PASSWORD',
                'COUNTRY_ADMIN.PAGINATION.OF',
                'COUNTRY_ADMIN.PAGINATION.PAGE',
                'COUNTRY_ADMIN.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.columns = {
                    name: translations['COUNTRY_ADMIN.COLUMNS.NAME'],
                    email: translations['COUNTRY_ADMIN.COLUMNS.EMAIL'],
                    country: translations['COUNTRY_ADMIN.COLUMNS.COUNTRY'],
                    last_login: translations['COUNTRY_ADMIN.COLUMNS.LAST_LOGIN'],
                    created: translations['COUNTRY_ADMIN.COLUMNS.CREATED'],
                    status: translations['COUNTRY_ADMIN.COLUMNS.STATUS']
                };

                vm.status = {
                    never: translations['COUNTRY_ADMIN.NEVER'],
                    active: translations['COUNTRY_ADMIN.ACTIVE'],
                    inactive: translations['COUNTRY_ADMIN.INACTIVE']
                };

                vm.messages = {
                    created: translations['COUNTRY_ADMIN.MESSAGES.CREATED'],
                    updated: translations['COUNTRY_ADMIN.MESSAGES.UPDATED'],
                    passwordReset: translations['COUNTRY_ADMIN.MESSAGES.PASSWORD_RESET'],
                    noPermissionCreateUser: translations['COUNTRY_ADMIN.MESSAGES.NO_PERMISSION_CREATE_USER'],
                    noPermissionUpdateUser: translations['COUNTRY_ADMIN.MESSAGES.NO_PERMISSION_UPDATE_USER'],
                    noPermissionResetPasswordUser: translations['COUNTRY_ADMIN.MESSAGES.NO_PERMISSION_RESET_PASSWORD']
                };

                vm.paginationLabel = {
                    of: translations['COUNTRY_ADMIN.PAGINATION.OF'],
                    page: translations['COUNTRY_ADMIN.PAGINATION.PAGE'],
                    rowsPerPage: translations['COUNTRY_ADMIN.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.test-strip-model', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.test-strip-model', {
                url    : '/test-strip-model',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/test-strip-model/test-strip-model.html',
                        controller : 'TestStripModelController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin']
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/test-strip-model');
        $translatePartialLoaderProvider.addPart('app/main/test-strip-model/test-strip-model-form');

        // Api
        msApiProvider.register('test-strip-models', ['/test_strip_models']);
        msApiProvider.register('test-strip-models.edit', ['/test_strip_models/:id', {id: '@id'}, {
            update: { method:'PUT'}
        }]);

        msNavigationServiceProvider.saveItem('test-strip-model', {
            title    : 'Test Strip Model Register',
            icon     : 'icon-archive',
            state    : 'app.test-strip-model',
            weight   : 4,
            translate: 'TEST_STRIP_MODEL.NAV'
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.test-strip-model')
        .controller('TestStripModelFormController', TestStripModelFormController);

    /** @ngInject */
    function TestStripModelFormController($mdDialog, dialogData, $translate, $log)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.userDefinedMeasurementUnit = vm.dialogData.userDefinedMeasurementUnit;
        vm.measurementUnits = vm.dialogData.measurementUnits;

        // Methods
        vm.save = save;
        vm.remove = remove;
        vm.close = close;
        vm.canRemove = false;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            // Figure out the title
            switch (vm.dialogData.type)
            {
                case 'create' :
                    vm.dialogTitle = vm.dialogTitles.create;
                    break;

                case 'edit' :
                    vm.dialogTitle = vm.dialogTitles.edit;
                    //vm.canRemove = true;
                    break;

                default:
                    break;
            }

            if (vm.dialogData.testStripModel) {
                vm.testStripModel = vm.dialogData.testStripModel;
                vm.testStripModel.l1_mfr_mean = _.round(vm.testStripModel.l1_mfr_mean, 2);
                vm.testStripModel.l1_mfr_sd =  _.round(vm.testStripModel.l1_mfr_sd, 2);
                vm.testStripModel.l2_mfr_mean =  _.round(vm.testStripModel.l2_mfr_mean, 2);
                vm.testStripModel.l2_mfr_sd =  _.round(vm.testStripModel.l2_mfr_sd, 2);
            } else {
                if (vm.userDefinedMeasurementUnit === _.keys(vm.measurementUnits)[0]) {
                    vm.testStripModel = {
                        model_name: '',
                        l1_mfr_mean: 2.50,
                        l1_mfr_sd: 0.27,
                        l2_mfr_mean: 16.50,
                        l2_mfr_sd: 0.83,
                        measurement_unit: vm.userDefinedMeasurementUnit
                    };
                } else {
                    vm.testStripModel = {
                        model_name: '',
                        l1_mfr_mean: 45.00,
                        l1_mfr_sd: 4.86,
                        l2_mfr_mean: 297.00,
                        l2_mfr_sd: 14.94,
                        measurement_unit: vm.userDefinedMeasurementUnit
                    };
                }
            }
        }

        function save(){
            var response = {
                type: vm.dialogData.type,
                testStripModel: vm.testStripModel
            };

            $mdDialog.hide(response);
        }

        function remove() {
            var response = {
                type: 'remove',
                testStripModel: vm.testStripModel
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function translate() {
            return $translate([
                'TEST_STRIP_MODEL_FORM.CREATE',
                'TEST_STRIP_MODEL_FORM.EDIT'
            ]).then(function(translations) {
                vm.dialogTitles = {
                    create: translations['TEST_STRIP_MODEL_FORM.CREATE'],
                    edit: translations['TEST_STRIP_MODEL_FORM.EDIT']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.test-strip-consumption', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.test-strip-consumption', {
                url    : '/test-strip-consumption',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/test-strip-consumption/test-strip-consumption.html',
                        controller : 'TestStripConsumptionController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin', 'hospital_operator']
                },
                resolve: {
                    statesData: function(msApi) {
                        return msApi.request('states@get');
                    },
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/test-strip-consumption');

        // Api
        msApiProvider.register('states', ['/states']);
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('test-strips.consumption', ['/test_strips/consumption']);


        msNavigationServiceProvider.saveItem('test-strip-consumption', {
            title    : 'Test Strip Consumption',
            icon     : 'icon-glass-stange',
            state    : 'app.test-strip-consumption',
            weight   : 28,
            translate: 'TEST_STRIP_CONSUMPTION.NAV'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.test-strip-consumption')
        .component('testStripConsumptionHospitalOperator', {
            templateUrl: 'app/main/test-strip-consumption/hospital-operator/hospital-operator.html',
            controller: HospitalOperatorController,
            controllerAs: 'vm',
            bindings: {
                hospital: '<',
                locations: '<'
            }
        });

    /** @ngInject */
    function HospitalOperatorController(msApi, $mdSelect, $filter, $translate, localStorageService, $log) {
        var vm = this;

        // Data
        vm.meterColumns = [];
        vm.meters = [];

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.selectedMeters = null;
        vm.searchTerm = '';
        vm.filtered = [];

        vm.quality_control_tests = 0;
        vm.blood_glucose_tests = 0;
        vm.all = 0;

        vm.loaded = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        ////////////////

        function init() {
            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            getMeters()
                .then(getTestStripConsumption);
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getTestStripConsumption();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getTestStripConsumption();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getTestStripConsumption();
            }

            close();
        }

        function close() {
            $mdSelect.hide();
        }

        function getMeters() {
            var params = {
                hospital_id: vm.hospital.id,
                'location_ids[]': _.map(vm.locations, 'id')
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    if (meters.length) {
                        vm.meters = meters;
                        vm.selectedMeters = meters;
                        groupMeters(vm.meters);

                    } else {
                        vm.meters = [];
                        vm.selectedMeters = null;
                    }

                    selectedMetersChanged();
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function getTestStripConsumption() {
            var meterIds = _.map(vm.selectedMeters, 'id');

            return msApi.request('test-strips.consumption@get',
                {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    hospital_id: vm.hospital.id,
                    'meter_ids[]': meterIds,
                    'location_ids[]': _.map(vm.locations, 'id')
                },
                // SUCCESS
                function (response) {
                    vm.quality_control_tests = response.summary.quality_control_tests;
                    vm.blood_glucose_tests = response.summary.blood_glucose_tests;
                    vm.all = response.summary.all;
                    vm.loaded = true;
                });
        }

        function translate() {
            return $translate([
                'TEST_STRIP_CONSUMPTION.FILTERS.METERS',
                'TEST_STRIP_CONSUMPTION.FILTERS.ALL_METERS'
            ]).then(function(translations) {
                vm.filters = {
                    meters: translations['TEST_STRIP_CONSUMPTION.FILTERS.METERS'],
                    allMeters: translations['TEST_STRIP_CONSUMPTION.FILTERS.ALL_METERS']
                };
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.test-strip-consumption')
        .component('testStripConsumptionHospitalAdmin', {
            templateUrl: 'app/main/test-strip-consumption/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                hospital: '<'
            }
        });

    /** @ngInject */
    function HospitalAdminController(msApi, $mdSelect, $filter, $translate, localStorageService, $log) {
        var vm = this;

        // Data
        vm.meterColumns = [];
        vm.meters = [];

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.selectedMeters = null;
        vm.searchTerm = '';
        vm.filtered = [];

        vm.quality_control_tests = 0;
        vm.blood_glucose_tests = 0;
        vm.all = 0;

        vm.loaded = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        ////////////////

        function init() {
            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            getMeters()
                .then(getTestStripConsumption);
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getTestStripConsumption();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getTestStripConsumption();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getTestStripConsumption();
            }

            close();
        }

        function close() {
            $mdSelect.hide();
        }

        function getMeters() {
            var params = {
                hospital_id: vm.hospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    if (meters.length) {
                        vm.meters = meters;
                        vm.selectedMeters = meters;
                        groupMeters(vm.meters);

                    } else {
                        vm.meters = [];
                        vm.selectedMeters = null;
                    }

                    selectedMetersChanged();
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function getTestStripConsumption() {
            var meterIds = _.map(vm.selectedMeters, 'id');

            return msApi.request('test-strips.consumption@get',
                {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    hospital_id: vm.hospital.id,
                    'meter_ids[]': meterIds
                },
                // SUCCESS
                function (response) {
                    vm.quality_control_tests = response.summary.quality_control_tests;
                    vm.blood_glucose_tests = response.summary.blood_glucose_tests;
                    vm.all = response.summary.all;
                    vm.loaded = true;
                });
        }

        function translate() {
            return $translate([
                'TEST_STRIP_CONSUMPTION.FILTERS.METERS',
                'TEST_STRIP_CONSUMPTION.FILTERS.ALL_METERS'
            ]).then(function(translations) {
                vm.filters = {
                    meters: translations['TEST_STRIP_CONSUMPTION.FILTERS.METERS'],
                    allMeters: translations['TEST_STRIP_CONSUMPTION.FILTERS.ALL_METERS']
                };
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.test-strip-consumption')
        .component('testStripConsumptionGlobalAdmin', {
            templateUrl: 'app/main/test-strip-consumption/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<'
            }
        });

    /** @ngInject */
    function GlobalAdminController(msApi, $mdSelect, $filter, $translate, localStorageService, $log) {
        var vm = this;

        // Data
        vm.meterColumns = [];
        vm.meters = [];

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = null;
        vm.searchTerm = '';
        vm.filtered = [];
        vm.sort = "-total";

        vm.quality_control_tests = 0;
        vm.blood_glucose_tests = 0;
        vm.all = 0;
        vm.hospital_tests = [];

        vm.loaded = false;

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        ////////////////

        function init() {
            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            getTestStripConsumption();
        }

        function selectedCountryChanged() {
            if (vm.selectedCountry) {
                vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                    result.push({ code: key, name: value });
                }, []), 'name');
            } else {
                vm.states = [];
            }

            vm.selectedState = null;
            selectedStateChanged();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');
            } else {
                vm.hospitals = [];
            }

            vm.selectedHospital = null;
            selectedHospitalChanged();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
                vm.selectedMeters = null;
                selectedMetersChanged();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getTestStripConsumption();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getTestStripConsumption();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getTestStripConsumption();
            }

            close();
        }

        function close() {
            $mdSelect.hide();
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    if (meters.length) {
                        vm.meters = meters;
                        vm.selectedMeters = meters;
                        groupMeters(vm.meters);

                    } else {
                        vm.meters = [];
                        vm.selectedMeters = null;
                    }

                    selectedMetersChanged();
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function getTestStripConsumption() {
            var country = vm.selectedCountry ? vm.selectedCountry.code : null;
            var state = vm.selectedState ? vm.selectedState.code : null;
            var hospital_id = vm.selectedHospital ? vm.selectedHospital.id : null;
            var meterIds = _.map(vm.selectedMeters, 'id');

            return msApi.request('test-strips.consumption@get',
                {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    country: country,
                    state: state,
                    hospital_id: hospital_id,
                    'meter_ids[]': meterIds
                },
                // SUCCESS
                function (response) {
                    vm.quality_control_tests = response.summary.quality_control_tests;
                    vm.blood_glucose_tests = response.summary.blood_glucose_tests;
                    vm.all = response.summary.all;
                    vm.hospital_tests = response.summary.hospitals;
                    vm.loaded = true;
                });
        }

        function translate() {
            return $translate([
                'TEST_STRIP_CONSUMPTION.FILTERS.METERS',
                'TEST_STRIP_CONSUMPTION.FILTERS.ALL_METERS'
            ]).then(function(translations) {
                vm.filters = {
                    meters: translations['TEST_STRIP_CONSUMPTION.FILTERS.METERS'],
                    allMeters: translations['TEST_STRIP_CONSUMPTION.FILTERS.ALL_METERS']
                };
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.test-strip-consumption')
        .component('testStripConsumptionCountryAdmin', {
            templateUrl: 'app/main/test-strip-consumption/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                allStates: '<',
                allHospitals: '<',
                country: '<'
            }
        });

    /** @ngInject */
    function CountryAdminController(msApi, $mdSelect, $filter, $translate, localStorageService, $log) {
        var vm = this;

        // Data
        vm.meterColumns = [];
        vm.meters = [];

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.selectedState = null;
        vm.selectedHospital = null;

        vm.selectedMeters = null;
        vm.searchTerm = '';
        vm.filtered = [];
        vm.sort = "-total";

        vm.quality_control_tests = 0;
        vm.blood_glucose_tests = 0;
        vm.all = 0;
        vm.hospital_tests = [];

        vm.loaded = false;

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMetersChanged = selectedMetersChanged;
        vm.getSelectedMetersText = getSelectedMetersText;
        vm.close = close;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.selectMeters = selectMeters;
        vm.getSelectMetersIcon = getSelectMetersIcon;

        ////////////////

        function init() {
            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            getTestStripConsumption();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');
            } else {
                vm.hospitals = [];
            }

            vm.selectedHospital = null;
            selectedHospitalChanged();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
                vm.selectedMeters = null;
                selectedMetersChanged();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getTestStripConsumption();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getTestStripConsumption();
            }
        }

        function selectedMetersChanged() {
            if(vm.filterForm.$valid) {
                getTestStripConsumption();
            }

            close();
        }

        function close() {
            $mdSelect.hide();
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    if (meters.length) {
                        vm.meters = meters;
                        vm.selectedMeters = meters;
                        groupMeters(vm.meters);

                    } else {
                        vm.meters = [];
                        vm.selectedMeters = null;
                    }

                    selectedMetersChanged();
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            vm.filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(vm.filtered);
        }

        function meterSelectionOnClose() {
            vm.filtered = [];
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function selectMeters() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    vm.selectedMeters = [];
                } else {
                    vm.selectedMeters = vm.meters;
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);
                if(!dif.length) {
                    vm.selectedMeters = _.difference(vm.selectedMeters, vm.filtered);
                } else {
                    vm.selectedMeters = _.concat(vm.selectedMeters, vm.filtered);
                }
            }
        }

        function getSelectMetersIcon() {
            if (!vm.searchTerm && !vm.filtered.length) {
                if(vm.selectedMeters && vm.selectedMeters.length === vm.meters.length) {
                    return 'icon-checkbox-marked';
                } else if(!vm.selectedMeters || !vm.selectedMeters.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            } else {
                var dif = _.difference(vm.filtered, vm.selectedMeters);

                if(!dif.length) {
                    return 'icon-checkbox-marked';
                } else if(dif.length === vm.filtered.length) {
                    return 'icon-checkbox-blank-outline';
                } else {
                    return 'icon-minus-box';
                }
            }
        }

        function getSelectedMetersText() {
            var limit = 50;

            if(!vm.searchTerm && !vm.filtered.length) {
                if (vm.selectedMeters && vm.selectedMeters.length) {
                    if (vm.selectedMeters.length === vm.meters.length) {
                        return vm.filters.allMeters;
                    }
                    var joined = _.join(_.map(vm.selectedMeters, 'serial_no'), ', ');

                    return $filter('limitTo')(joined, limit) + (joined.length > limit ? '...' : '');
                } else {
                    return vm.filters.meters;
                }
            } else {
                return vm.filters.meters;
            }
        }

        function getTestStripConsumption() {
            var country = vm.country;
            var state = vm.selectedState ? vm.selectedState.code : null;
            var hospital_id = vm.selectedHospital ? vm.selectedHospital.id : null;
            var meterIds = _.map(vm.selectedMeters, 'id');

            return msApi.request('test-strips.consumption@get',
                {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    country: country,
                    state: state,
                    hospital_id: hospital_id,
                    'meter_ids[]': meterIds
                },
                // SUCCESS
                function (response) {
                    vm.quality_control_tests = response.summary.quality_control_tests;
                    vm.blood_glucose_tests = response.summary.blood_glucose_tests;
                    vm.all = response.summary.all;
                    vm.hospital_tests = response.summary.hospitals;
                    vm.loaded = true;
                });
        }

        function translate() {
            return $translate([
                'TEST_STRIP_CONSUMPTION.FILTERS.METERS',
                'TEST_STRIP_CONSUMPTION.FILTERS.ALL_METERS'
            ]).then(function(translations) {
                vm.filters = {
                    meters: translations['TEST_STRIP_CONSUMPTION.FILTERS.METERS'],
                    allMeters: translations['TEST_STRIP_CONSUMPTION.FILTERS.ALL_METERS']
                };
            });
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.test-strip', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.test-strip', {
                url    : '/test-strip',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/test-strip/test-strip.html',
                        controller : 'TestStripController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_country_admin', 'hospital_admin']
                },
                resolve: {
                    hospitalsData: function(msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        if (user.role.name === 'roche_country_admin') {
                            return msApi.request('hospitals@get', {
                                country: user.country
                            });
                        }
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/test-strip');
        $translatePartialLoaderProvider.addPart('app/main/test-strip/test-strip-form');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('test-strip-models', ['/test_strip_models']);
        msApiProvider.register('test-strips', ['/test_strips']);
        msApiProvider.register('test-strips.edit', ['/test_strips/:id', {id: '@id'}, {
            update: { method:'PUT'}
        }]);
        msApiProvider.register('test-strips.export', ['/test_strips/export', {}, {
            download: {method: 'GET', responseType: 'arraybuffer', transformResponse: function(data, headersGetter) {
                // Stores the ArrayBuffer object in a property called "data"
                return { data : data };
            }}
        }]);

        msNavigationServiceProvider.saveItem('test-strip', {
            title    : 'Test Strip Register',
            icon     : 'icon-glass-stange',
            state    : 'app.test-strip',
            weight   : 9,
            translate: 'TEST_STRIP.NAV'
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.test-strip')
        .controller('TestStripFormController', TestStripFormController);

    /** @ngInject */
    function TestStripFormController($mdDialog, dialogData, resolveData, $translate, $log)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.isCountryAdmin = dialogData.isCountryAdmin;
        vm.hospitals = dialogData.hospitals;
        vm.testStripModels =  _.sortBy(resolveData.test_strip_models, 'model_name');
        vm.selectedHospital = null;
        vm.selectedTestStripModel = null;
        vm.userDefinedMeasurementUnit = vm.dialogData.userDefinedMeasurementUnit;
        vm.measurementUnits = vm.dialogData.measurementUnits;
        vm.expiry = null;

        vm.isReadOnly = dialogData.isReadOnly;
        vm.canRemove = false;

        // Methods
        vm.save = save;
        vm.remove = remove;
        vm.close = close;
        vm.validateLotNo = validateLotNo;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            // Figure out the title
            switch (vm.dialogData.type)
            {
                case 'create' :
                    vm.dialogTitle = vm.dialogTitles.create;
                    break;

                case 'edit' :
                    vm.dialogTitle = vm.dialogTitles.edit;
                    //vm.canRemove = true;
                    break;

                case 'view' :
                    vm.dialogTitle = vm.dialogTitles.view;
                    break;

                default:
                    vm.dialogTitle = vm.dialogTitles.view;
                    break;
            }

            if (vm.dialogData.testStrip) {
                vm.testStrip = vm.dialogData.testStrip;
                vm.testStrip.l1_min = _.round(vm.testStrip.l1_min, 1);
                vm.testStrip.l1_max =  _.round(vm.testStrip.l1_max, 1);
                vm.testStrip.l2_min =  _.round(vm.testStrip.l2_min, 1);
                vm.testStrip.l2_max =  _.round(vm.testStrip.l2_max, 1);
                vm.expiry = moment(vm.testStrip.expiry).toDate();
                vm.selectedHospital = _.find(vm.hospitals, ['id', vm.testStrip.hospital.id]);
                if (vm.testStrip.test_strip_model) {
                    vm.selectedTestStripModel = _.find(vm.testStripModels, ['id', vm.testStrip.test_strip_model.id]);
                }
            } else {

                if (!vm.isCountryAdmin) {
                    vm.selectedHospital = vm.hospitals[0];
                }

                if (vm.userDefinedMeasurementUnit === _.keys(vm.measurementUnits)[0]) {
                    vm.testStrip = {
                        lot_no: '',
                        l1_min: 1.7,
                        l1_max: 3.3,
                        l2_min: 14.0,
                        l2_max: 19.0,
                        expiry: null,
                        hospital_id: null,
                        test_strip_model_id: null,
                        measurement_unit: vm.userDefinedMeasurementUnit
                    };
                } else {
                    vm.testStrip = {
                        lot_no: '',
                        l1_min: 30,
                        l1_max: 60,
                        l2_min: 252,
                        l2_max: 342,
                        expiry: null,
                        hospital_id: null,
                        test_strip_model_id: null,
                        measurement_unit: vm.userDefinedMeasurementUnit
                    };
                }
            }
        }

        function save(){
            vm.testStrip.hospital_id = vm.selectedHospital.id;
            vm.testStrip.test_strip_model_id = vm.selectedTestStripModel.id;
            vm.testStrip.expiry =  moment(vm.expiry).startOf('day').format();

            var response = {
                type: vm.dialogData.type,
                testStrip: vm.testStrip
            };

            $mdDialog.hide(response);
        }

        function remove() {
            var response = {
                type: 'remove',
                testStrip: vm.testStrip
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function validateLotNo() {
            if (vm.dialogData.type === 'edit') {
                vm.testStripForm.lot_no.$setTouched();
            }

            vm.testStripForm.lot_no.$validate();
        }

        function translate() {
            return $translate([
                'TEST_STRIP_FORM.VIEW',
                'TEST_STRIP_FORM.CREATE',
                'TEST_STRIP_FORM.EDIT'
            ]).then(function(translations) {
                vm.dialogTitles = {
                    view: translations['TEST_STRIP_FORM.VIEW'],
                    create: translations['TEST_STRIP_FORM.CREATE'],
                    edit: translations['TEST_STRIP_FORM.EDIT']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.test-strip')
        .controller('BatchCreateTestStripsFormController', BatchCreateTestStripsFormController);

    /** @ngInject */
    function BatchCreateTestStripsFormController($mdDialog, dialogData, resolveData, $translate, $log)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.hospitals = dialogData.hospitals;
        vm.testStripModels =  _.sortBy(resolveData.test_strip_models, 'model_name');
        vm.selectedHospitals = [];
        vm.selectedTestStripModel = null;
        vm.userDefinedMeasurementUnit = vm.dialogData.userDefinedMeasurementUnit;
        vm.measurementUnits = vm.dialogData.measurementUnits;
        vm.expiry = null;

        // Methods
        vm.save = save;
        vm.close = close;
        vm.getSelectedHospitalsText = getSelectedHospitalsText;
        vm.getSelectedHospitalIds = getSelectedHospitalIds;
        vm.validateLotNo = validateLotNo;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            if (vm.userDefinedMeasurementUnit === 'MMOL_PER_L') {
                vm.testStrip = {
                    lot_no: '',
                    l1_min: 1.7,
                    l1_max: 3.3,
                    l2_min: 14.0,
                    l2_max: 19.0,
                    expiry: null,
                    hospital_id: null,
                    test_strip_model_id: null,
                    measurement_unit: vm.userDefinedMeasurementUnit
                };
            } else {
                vm.testStrip = {
                    lot_no: '',
                    l1_min: 30,
                    l1_max: 60,
                    l2_min: 252,
                    l2_max: 342,
                    expiry: null,
                    hospital_id: null,
                    test_strip_model_id: null,
                    measurement_unit: vm.userDefinedMeasurementUnit
                };
            }
        }

        function save(){

            vm.testStrip.test_strip_model_id = vm.selectedTestStripModel.id;
            vm.testStrip.expiry =  moment(vm.expiry).startOf('day').format();

            var testStrips = [];

            _.forEach(vm.selectedHospitals, function(hospital) {
                var testStrip = _.clone(vm.testStrip);
                testStrip.hospital_id = hospital.id;

                testStrips.push(testStrip);
            });



            var response = {
                testStrips: testStrips
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function getSelectedHospitalsText() {
            if (vm.selectedHospitals && vm.selectedHospitals.length) {
                if (vm.selectedHospitals.length === vm.hospitals.length) {
                    return vm.selectedHospitalTexts.allHospitals;
                }
                return _.join(_.map(vm.selectedHospitals, 'name'), ',');
            } else {
                return vm.selectedHospitalTexts.hospitals;
            }
        }

        function getSelectedHospitalIds() {
            return _.map(vm.selectedHospitals, 'id');
        }

        function validateLotNo() {
            if (vm.dialogData.type === 'edit') {
                vm.testStripForm.lot_no.$setTouched();
            }

            vm.testStripForm.lot_no.$validate();
        }

        function translate() {
            return $translate([
                'TEST_STRIP_FORM.ALL_HOSPITALS',
                'TEST_STRIP_FORM.HOSPITALS'
            ]).then(function(translations) {
                vm.selectedHospitalTexts = {
                    allHospitals: translations['TEST_STRIP_FORM.ALL_HOSPITALS'],
                    hospitals: translations['TEST_STRIP_FORM.HOSPITALS']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.profile', [
            'app.profile.update-password'
        ])
})();
(function ()
{
    'use strict';

    angular
        .module('app.profile')
        .controller('UpdatePasswordController', UpdatePasswordController);

    /** @ngInject */
    function UpdatePasswordController($rootScope, $timeout, msApi, localStorageService, $state, toastService, CONFIG, $translate, $log)
    {
        // Data
        var vm = this;
        vm.year = new Date().getFullYear();

        // Methods
        vm.update = update;

        init();

        //////////

        function init() {
            translate();
        }

        function update() {
            return msApi.request('profile.password@save',
                vm.form,
                // SUCCESS
                function (response) {
                    var token = response.token;
                    var user = response.user;

                    localStorageService.set('token', token);
                    localStorageService.set('user', user);

                    toastService.show(vm.messages.updated);

                    if (user.role.name === 'roche_global_admin') {
                        $state.go('app.country-admin');
                    } else if (user.role.name === 'roche_country_admin') {
                        $state.go('app.hospital');
                    } else if(user.role.name === 'hospital_admin'){
                        _.forEach(CONFIG.hospital_modules, function (module) {
                            if (_.indexOf(user.available_modules, module.name) > -1 && _.indexOf(module.forRoles, 'hospital_admin') > -1) {
                                $state.go(module.state);
                                return false;
                            }
                        });
                    } else if(user.role.name === 'hospital_operator'){
                        _.forEach(CONFIG.hospital_modules, function (module) {
                            if (_.indexOf(user.available_modules, module.name) > -1 && _.indexOf(module.forRoles, 'hospital_operator') > -1) {
                                $state.go(module.state);
                                return false;
                            }
                        });
                    }
                },
                function(response) {
                    $timeout(function ()
                    {
                        $rootScope.loadingProgress = false;
                    }, 500);

                    if (response.status === 422) {
                        if( _.has(response.data, 'old_password')) {
                            return toastService.error($rootScope.messages.oldPasswordMismatch);
                        } else {
                            var data = _.values(response.data);
                            _.forEach(data, function (error) {
                                toastService.error(error[0]);
                            });
                        }
                    }else if (response.status === 401 || response.status === 403 || response.status === 404) {
                        return toastService.error(vm.messages.invalidCredential);
                    } else{
                        return toastService.error(response.statusText);
                    }
                });
        }

        function translate() {
            $translate([
                'UPDATE_PASSWORD.MESSAGES.UPDATED',
                'UPDATE_PASSWORD.MESSAGES.OLD_PASSWORD_DID_NOT_MATCH'
            ]).then(function(translations) {
                vm.messages = {
                    updated: translations['UPDATE_PASSWORD.MESSAGES.UPDATED'],
                    oldPasswordDidNotMatch: translations['UPDATE_PASSWORD.MESSAGES.OLD_PASSWORD_DID_NOT_MATCH']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.meter', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.meter', {
                url    : '/meter',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/meter/meter.html',
                        controller : 'MeterController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_country_admin', 'hospital_admin']
                },
                resolve: {
                    hospitalsData: function(msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        if (user.role.name === 'roche_country_admin') {
                            return msApi.request('hospitals@get', {
                                country: user.country
                            });
                        }
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/meter');
        $translatePartialLoaderProvider.addPart('app/main/meter/meter-form');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('locations', ['/locations']);
        msApiProvider.register('meters.edit', ['/meters/:id', {id: '@id'}, {
            update: { method:'PUT'}
        }]);
        msApiProvider.register('meters.archive', ['/meters/:id', {id: '@id'}, {
            delete: { method:'DELETE'}
        }]);
        msApiProvider.register('meters.export', ['/meters/export', {}, {
            download: {method: 'GET', responseType: 'arraybuffer', transformResponse: function(data, headersGetter) {
                // Stores the ArrayBuffer object in a property called "data"
                return { data : data };
            }}
        }]);

        msNavigationServiceProvider.saveItem('meter', {
            title    : 'Meter Register',
            icon     : 'icon-custom-reading-device',
            state    : 'app.meter',
            weight   : 8,
            translate: 'METER.NAV'
        });
    }
})();

(function ()
{
    'use strict';

    angular.module('app.meter')
        .controller('MeterFormController', MeterFormController);

    /** @ngInject */
    function MeterFormController($mdDialog, dialogData, resolveData, $translate)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.isCountryAdmin = dialogData.isCountryAdmin;
        vm.hospitals = dialogData.hospitals;
        vm.locations = resolveData.locations;
        vm.selectedHospital = null;
        vm.selectedLocation = null;
        vm.models = [
            'Accu-Chek Active',
            'Accu-Chek Guide',
            'Accu-Chek Guide Me',
            'Accu-Chek Guide One',
            'Accu-Chek Instant',
            'Accu-Chek Instant S',
            'Accu-Chek Performa'
        ];

        vm.isReadOnly = dialogData.isReadOnly;
        vm.canRemove = false;

        // Methods
        vm.save = save;
        vm.remove = remove;
        vm.close = close;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            // Figure out the title
            switch (vm.dialogData.type)
            {
                case 'create' :
                    vm.dialogTitle = vm.dialogTitles.create;
                    break;

                case 'edit' :
                    vm.dialogTitle = vm.dialogTitles.edit;
                    //vm.canRemove = true;
                    break;

                case 'view' :
                    vm.dialogTitle = vm.dialogTitles.view;
                    break;

                default:
                    vm.dialogTitle = vm.dialogTitles.view;
                    break;
            }

            if (vm.dialogData.meter) {
                vm.meter = vm.dialogData.meter;
                vm.selectedLocation = _.find(vm.locations, ['id', vm.meter.location_id]);
                vm.selectedHospital = _.find(vm.hospitals, ['id', vm.meter.location.hospital.id]);
            } else {

                if (!vm.isCountryAdmin) {
                    vm.selectedHospital = vm.hospitals[0];
                    vm.selectedLocation = vm.locations.length ? vm.locations[0] : null;
                }

                vm.meter = {
                    model_no: vm.models[0],
                    serial_no: null,
                    location_id: null,
                    status: 'active'
                };
            }
        }

        function save(){
            vm.meter.location_id = vm.selectedLocation.id;

            var response = {
                type: vm.dialogData.type,
                meter: vm.meter
            };

            $mdDialog.hide(response);
        }

        function remove() {
            var response = {
                type: 'remove',
                meter: vm.meter
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function translate() {
            return $translate([
                'METER_FORM.VIEW',
                'METER_FORM.CREATE',
                'METER_FORM.EDIT'
            ]).then(function(translations) {
                vm.dialogTitles = {
                    view: translations['METER_FORM.VIEW'],
                    create: translations['METER_FORM.CREATE'],
                    edit: translations['METER_FORM.EDIT']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.manual-qc-data', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.manual-qc-data', {
                url    : '/manual-qc-data',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/manual-qc-data/manual-qc-data.html',
                        controller : 'ManualQcDataController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['hospital_admin', 'hospital_operator']
                }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/manual-qc-data');
        $translatePartialLoaderProvider.addPart('app/main/manual-qc-data/manual-qc-data-form');

        // Api
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('quality_control_tests.manual_qc_data', ['/quality_control_tests/manual_qc_data']);

        // Navigation
        msNavigationServiceProvider.saveItem('manual-qc-data', {
            title : 'Manual QC Data',
            icon  : 'icon-pencil-box-outline',
            state : 'app.manual-qc-data',
            weight: 33,
            translate: 'MANUAL_QC_DATA.NAV'
        });
    }
})();

(function ()
{
    'use strict';

    angular
      .module('app.manual-qc-data')
      .controller('ManualQcDataFormController', ManualQcDataFormController);

    /** @ngInject */
    function ManualQcDataFormController($mdDialog, dialogData, resolveData, $translate)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.meters = resolveData.meters;
        vm.defaultMeasurementUnit = vm.dialogData.defaultMeasurementUnit;

        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.types = ['Level 1', 'Level 2'];
        vm.meterColumns = [];
        vm.searchTerm = '';

        vm.meter = null;
        vm.testDatetime = null;
        vm.controlType = null;
        vm.qcValue = null;
        vm.qcDatas = [];

        // Methods
        vm.close = close;
        vm.add = add;
        vm.remove = remove;
        vm.save = save;
        vm.resetForm = resetForm;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            groupMeters(vm.meters);
        }

        function add(e) {
            vm.qcDatas.unshift({meter: vm.meter, test_datetime: vm.testDatetime, control_type: vm.controlType, qc_value: vm.qcValue});
            vm.meter = null;
            vm.testDatetime = null;
            vm.controlType = null;
            vm.qcValue = null;
        }

        function remove(index, e) {
            vm.qcDatas.splice(index, 1);
        }

        function save(e){
            var qualityControlTests = [];

            if (vm.qcDatas.length > 0) {
                _.forEach(vm.qcDatas, function(qcData) {
                    qualityControlTests.push({meter_id: qcData.meter.id, tested_on: qcData.test_datetime, control_level: qcData.control_type, meter_reading: qcData.qc_value, measurement_unit: vm.defaultMeasurementUnit});
                });
            }

            if (vm.meter !== null && vm.testDatetime !== null && vm.controlType !== null && vm.qcValue !== null) {
                qualityControlTests.push({meter_id: vm.meter.id, tested_on: vm.testDatetime, control_level: vm.controlType, meter_reading: vm.qcValue, measurement_unit: vm.defaultMeasurementUnit});
            }

            var response = {
                qcData: qualityControlTests
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function resetForm(form) {
            form.$setUntouched();
            form.$setPristine();
        }

        function closeMeterSelection() {
            $mdSelect.hide();
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function translate() {
            return $translate([
                'MANUAL_QC_DATA_FORM.TITLE'
            ]).then(function(translations) {
                vm.dialogTitle = translations['MANUAL_QC_DATA_FORM.TITLE'];
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.location', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.location', {
                url    : '/location',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/location/location.html',
                        controller : 'LocationController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['hospital_admin']
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/location');
        $translatePartialLoaderProvider.addPart('app/main/location/location-form');

        // Api
        msApiProvider.register('locations', ['/locations']);
        msApiProvider.register('locations.edit', ['/locations/:id', {id: '@id'}, {
            update: { method:'PUT'}
        }]);
        msApiProvider.register('locations.export', ['/locations/export', {}, {
            download: {method: 'GET', responseType: 'arraybuffer', transformResponse: function(data, headersGetter) {
                // Stores the ArrayBuffer object in a property called "data"
                return { data : data };
            }}
        }]);

        msNavigationServiceProvider.saveItem('location', {
            title    : 'Location Register',
            icon     : 'icon-map-marker-radius',
            state    : 'app.location',
            weight   : 7,
            translate: 'LOCATION.NAV'
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.location')
        .controller('LocationFormController', LocationFormController);

    /** @ngInject */
    function LocationFormController($mdDialog, dialogData, $translate)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.hospital = vm.dialogData.hospital;
        vm.isReadOnly = dialogData.isReadOnly;
        vm.canRemove = false;

        // Methods
        vm.save = save;
        vm.remove = remove;
        vm.close = close;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            // Figure out the title
            switch (vm.dialogData.type)
            {
                case 'create' :
                    vm.dialogTitle = vm.dialogTitles.create;
                    break;

                case 'edit' :
                    vm.dialogTitle = vm.dialogTitles.edit;
                    //vm.canRemove = true;
                    break;

                case 'view' :
                    vm.dialogTitle = vm.dialogTitles.view;
                    break;

                default:
                    vm.dialogTitle = vm.dialogTitles.view;
                    break;
            }

            if (vm.dialogData.location) {
                vm.location = vm.dialogData.location;
            } else {
                vm.location = {
                    code: '',
                    description: '',
                    person_in_charge: '',
                    phone: '',
                    hospital_id: vm.hospital.id
                };
            }
        }

        function save(){
            var response = {
                type: vm.dialogData.type,
                location: vm.location
            };

            $mdDialog.hide(response);
        }

        function remove() {
            var response = {
                type: 'remove',
                location: vm.location
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function translate() {
            return $translate([
                'LOCATION_FORM.VIEW',
                'LOCATION_FORM.CREATE',
                'LOCATION_FORM.EDIT'
            ]).then(function(translations) {
                vm.dialogTitles = {
                    view: translations['LOCATION_FORM.VIEW'],
                    create: translations['LOCATION_FORM.CREATE'],
                    edit: translations['LOCATION_FORM.EDIT']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.log.qc-failed', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.qc-failed-log', {
                url    : '/qc-failed-log',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/log/qc-failed/qc-failed.html',
                        controller : 'QCFailedController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['hospital_admin']
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/log/qc-failed');

        // Api
        msApiProvider.register('quality_control_tests', ['/quality_control_tests']);
        msApiProvider.register('quality_control_tests.edit', ['/quality_control_tests/:id', {id: '@id'}, {
            update: { method:'PUT'}
        }]);
        msApiProvider.register('quality_control_tests.export', ['/quality_control_tests/export', {}, {
            download: {method: 'GET', responseType: 'arraybuffer', transformResponse: function(data, headersGetter) {
                // Stores the ArrayBuffer object in a property called "data"
                return { data : data };
            }}
        }]);

        msNavigationServiceProvider.saveItem('qc-failed-log', {
            title    : 'QC Failed Log',
            icon     : 'icon-alert-box',
            state    : 'app.qc-failed-log',
            weight   : 2,
            translate: 'QC_FAILED_LOG.NAV'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.log.qc-failed')
        .controller('QCFailedController', QCFailedController);

    /** @ngInject */
    function QCFailedController(msApi, localStorageService, $timeout, toastService, $mdDialog, $document, $translate, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.pagination = {
            total:0,
            per_page: 5,
            current_page: 1
        };

        vm.sort = "tested_on";

        vm.qualityControlTests = [];
        vm.show = false;
        vm.isReadOnly = false;

        init();

        // Methods
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.getQualityControlTests = getQualityControlTests;
        vm.editNotes = editNotes;
        vm.exportToCSV = exportToCSV;
        vm.exportToExcel = exportToExcel;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.isReadOnly = vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);

        }

        function load() {
            getQualityControlTests().then(function(response) {
                $timeout( function(){
                    vm.show = true;
                }, 300);
            });
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getQualityControlTests();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getQualityControlTests();
            }
        }

        function exportToCSV() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                hospital_id: vm.user.hospitals[0].id,
                within_range: 0,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('quality_control_tests@get',
                params,
                // SUCCESS
                function (response) {
                    var qualityControlTests = response.quality_control_tests;
                    var data =  _.map(qualityControlTests, function (test) {
                        return {
                            testedOn: moment(test.tested_on).format(),
                            meterSerialNo: test.meter.serial_no,
                            locationCode: test.meter.location.code,
                            personInCharge: test.meter.location.person_in_charge ? test.meter.location.person_in_charge : '',
                            phone: test.meter.location.phone ? test.meter.location.phone : '',
                            testStripLotNo: test.test_strip.lot_no,
                            controlLevel: test.control_level,
                            qcTargetRange: parseFloat(test.from).toFixed(1) + ' ' + vm.to + ' ' + parseFloat(test.to).toFixed(1),
                            meterReading: parseFloat(test.meter_reading).toFixed(1),
                            notes: test.notes ? test.notes : '',
                            actionsTaken: test.actions_taken_at ? moment(test.actions_taken_at).format() : vm.pending
                        };
                    });

                    var timestamp = moment();
                    var filename = 'QCFailedLog-' + timestamp.format('YMMDDHm');

                    alasql('SELECT testedOn AS [' + vm.columns.testDateTime + '], ' +
                        'meterSerialNo AS [' + vm.columns.meterSerialNo + '],' +
                        'locationCode AS [' + vm.columns.locationCode + '],' +
                        'personInCharge AS [' + vm.columns.personInCharge + '],' +
                        'phone AS [' + vm.columns.phone + '],' +
                        'testStripLotNo AS [' + vm.columns.stripLot + '], ' +
                        'controlLevel AS [' + vm.columns.controlType + '], ' +
                        'qcTargetRange AS [' + vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')' + '],' +
                        'meterReading AS [' + vm.columns.qcValue  + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')' + '],' +
                        'notes AS [' + vm.columns.notes + '], ' +
                        'actionsTaken AS [' + vm.columns.actionCompleted + '] ' +
                        'INTO CSV(?, {headers:true, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                hospital_id: vm.user.hospitals[0].id,
                within_range: 0,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('quality_control_tests@get',
                params,
                // SUCCESS
                function (response) {
                    var qualityControlTests = response.quality_control_tests;
                    var data =  _.map(qualityControlTests, function (test) {
                        return {
                            testedOn: moment(test.tested_on).format(),
                            meterSerialNo: test.meter.serial_no,
                            locationCode: test.meter.location.code,
                            personInCharge: test.meter.location.person_in_charge ? test.meter.location.person_in_charge : '',
                            phone: test.meter.location.phone ? test.meter.location.phone : '',
                            testStripLotNo: test.test_strip.lot_no,
                            controlLevel: test.control_level,
                            qcTargetRange: parseFloat(test.from).toFixed(1) + ' ' + vm.to + ' ' + parseFloat(test.to).toFixed(1),
                            meterReading: parseFloat(test.meter_reading).toFixed(1),
                            notes: test.notes ? test.notes : '',
                            actionsTaken: test.actions_taken_at ? moment(test.actions_taken_at).format() : vm.pending
                        };
                    });

                    var timestamp = moment();
                    var filename = 'QCFailedLog-' + timestamp.format('YMMDDHm');

                    alasql('SELECT testedOn AS [' + vm.columns.testDateTime + '], ' +
                        'meterSerialNo AS [' + vm.columns.meterSerialNo + '],' +
                        'locationCode AS [' + vm.columns.locationCode + '],' +
                        'personInCharge AS [' + vm.columns.personInCharge + '],' +
                        'phone AS [' + vm.columns.phone + '],' +
                        'testStripLotNo AS [' + vm.columns.stripLot + '],' +
                        'controlLevel AS [' + vm.columns.controlType + '],' +
                        'qcTargetRange AS [' + vm.columns.qcTargetRange + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')' + '],' +
                        'meterReading AS [' + vm.columns.qcValue  + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')' + '],' +
                        'notes AS [' + vm.columns.notes + '],' +
                        'actionsTaken AS [' + vm.columns.actionCompleted + '] ' +
                        'INTO XLSX(?, {headers:true}) FROM ?',[filename, data]);
                });
        }

        function getQualityControlTests() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                hospital_id: vm.user.hospitals[0].id,
                within_range: 0,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            vm.promise =  msApi.request('quality_control_tests@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.qualityControlTests = response.quality_control_tests.data;
                    vm.pagination.total = response.quality_control_tests.total;
                });

            return vm.promise;
        }

        function editNotes(test, e) {
            var testToUpdate = angular.copy(test);

            var dialogData = {
                notes: testToUpdate.notes,
                readonly: true
            };

            $mdDialog.show({
                controller: 'EditNotesDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/edit-notes-dialog/edit-notes-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    dialogData: dialogData
                }
            }).then(function (dialogResponse) {
                testToUpdate.notes = dialogResponse.notes;
                updateQualityControlTest(testToUpdate);
            });
        }

        function updateQualityControlTest(testToUpdate) {
            return msApi.request('quality_control_tests.edit@update',
                testToUpdate,
                // SUCCESS
                function (response) {
                    toastService.show('QC Test updated');
                    var index = _.findIndex(vm.qualityControlTests, ['id', response.quality_control_test.id]);
                    vm.qualityControlTests[index] = response.quality_control_test;
                });
        }

        function translate() {
            return $translate([
                'QC_FAILED_LOG.COLUMNS.TEST_DATE_TIME',
                'QC_FAILED_LOG.COLUMNS.METER_SERIAL_NO',
                'QC_FAILED_LOG.COLUMNS.STRIP_LOT',
                'QC_FAILED_LOG.COLUMNS.CONTROL_TYPE',
                'QC_FAILED_LOG.COLUMNS.QC_TARGET_RANGE',
                'QC_FAILED_LOG.COLUMNS.QC_VALUE',
                'QC_FAILED_LOG.COLUMNS.NOTES',
                'QC_FAILED_LOG.COLUMNS.ACTION_COMPLETED',
                'QC_FAILED_LOG.COLUMNS.LOCATION_CODE',
                'QC_FAILED_LOG.COLUMNS.PERSON_IN_CHARGE',
                'QC_FAILED_LOG.COLUMNS.PHONE',
                'QC_FAILED_LOG.TO',
                'QC_FAILED_LOG.PENDING',
                'QC_FAILED_LOG.PAGINATION.OF',
                'QC_FAILED_LOG.PAGINATION.PAGE',
                'QC_FAILED_LOG.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.columns = {
                    testDateTime: translations['QC_FAILED_LOG.COLUMNS.TEST_DATE_TIME'],
                    meterSerialNo: translations['QC_FAILED_LOG.COLUMNS.METER_SERIAL_NO'],
                    stripLot: translations['QC_FAILED_LOG.COLUMNS.STRIP_LOT'],
                    controlType: translations['QC_FAILED_LOG.COLUMNS.CONTROL_TYPE'],
                    qcTargetRange: translations['QC_FAILED_LOG.COLUMNS.QC_TARGET_RANGE'],
                    qcValue: translations['QC_FAILED_LOG.COLUMNS.QC_VALUE'],
                    notes: translations['QC_FAILED_LOG.COLUMNS.NOTES'],
                    actionCompleted: translations['QC_FAILED_LOG.COLUMNS.ACTION_COMPLETED'],
                    locationCode: translations['QC_FAILED_LOG.COLUMNS.LOCATION_CODE'],
                    personInCharge: translations['QC_FAILED_LOG.COLUMNS.PERSON_IN_CHARGE'],
                    phone: translations['QC_FAILED_LOG.COLUMNS.PHONE']
                };

                vm.to = translations['QC_FAILED_LOG.TO'];
                vm.pending = translations['QC_FAILED_LOG.PENDING'];

                vm.paginationLabel = {
                    of: translations['QC_FAILED_LOG.PAGINATION.OF'],
                    page: translations['QC_FAILED_LOG.PAGINATION.PAGE'],
                    rowsPerPage: translations['QC_FAILED_LOG.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.hospital', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.hospital', {
                url    : '/hospital',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/hospital/hospital.html',
                        controller : 'HospitalController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_country_admin']
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/hospital');
        $translatePartialLoaderProvider.addPart('app/main/hospital/hospital-form');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('hospitals', ['/hospitals/:id']);
        msApiProvider.register('hospitals.edit', ['/hospitals/:id', {id: '@id'}, {
            update: { method:'PUT'}
        }]);

        msApiProvider.register('cloud-links.generate', ['/cloud_links/generate']);
        msApiProvider.register('cloud-links.enable', ['/cloud_links/enable']);
        msApiProvider.register('cloud-links.disable', ['/cloud_links/disable']);

        msNavigationServiceProvider.saveItem('hospital', {
            title    : 'Hospital Register',
            icon     : 'icon-hospital-building',
            state    : 'app.hospital',
            weight   : 5,
            translate: 'HOSPITAL.NAV'
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.hospital')
        .controller('HospitalFormController', HospitalFormController);

    /** @ngInject */
    function HospitalFormController($mdDialog, dialogData, $translate, CONFIG, $log)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.countries = vm.dialogData.countries;
        vm.country = vm.dialogData.country;
        vm.states =  _.sortBy(_.transform(vm.dialogData.states, function(result, value, key) {
            result.push({ code: key, name: value });
        }, []), 'name');

        vm.measurementUnits = [
            {
                name: 'MMOL_PER_L',
                caption: 'mmol/L'
            },
            {
                name: 'MG_PER_DL',
                caption: 'mg/dL'
            }
        ];

        vm.selectedMeasurementUnit = null;
        vm.selectedState = vm.states.length ? vm.states[0] : null;
        vm.selectedModules = [];
        vm.canRemove = false;

        // Methods
        vm.save = save;
        vm.remove = remove;
        vm.close = close;
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            // Figure out the title
            switch (vm.dialogData.type)
            {
                case 'create' :
                    vm.dialogTitle = vm.dialogTitles.create;
                    break;

                case 'edit' :
                    vm.dialogTitle = vm.dialogTitles.edit;
                    //vm.canRemove = true;
                    break;

                default:
                    break;
            }

            vm.selectedSize = vm.sizes[0];
            vm.selectedType = vm.types[0];

            if (vm.dialogData.hospital) {
                vm.hospital = vm.dialogData.hospital;
                vm.selectedMeasurementUnit = _.find(vm.measurementUnits, ['name', vm.hospital.default_measurement_unit]);
                vm.selectedState = _.find(vm.states, ['code', vm.hospital.state]);
                vm.selectedSize = _.find(vm.sizes, ['name', vm.hospital.size]);
                vm.selectedType = _.find(vm.types, ['name', vm.hospital.type]);
                vm.selectedModules = _.map(vm.hospital.default_modules, function(name) {
                    return _.find(vm.modules, ['name', name]);
                });
            } else {
                vm.hospital = {
                    name: '',
                    address: '',
                    city: '',
                    state: vm.selectedState.code,
                    country: vm.country,
                    size: vm.selectedSize.name,
                    type: vm.selectedType.name,
                    default_measurement_unit: null,
                    default_modules: []
                };
            }
        }

        function save(){
            vm.hospital.default_measurement_unit = vm.selectedMeasurementUnit.name;
            vm.hospital.state = vm.selectedState.code;
            vm.hospital.size = vm.selectedSize.name;
            vm.hospital.type = vm.selectedType.name;
            vm.hospital.default_modules = _.map(vm.selectedModules, 'name');

            var response = {
                type: vm.dialogData.type,
                hospital: vm.hospital
            };

            $mdDialog.hide(response);
        }

        function remove() {
            var response = {
                type: 'remove',
                hospital: vm.hospital
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function toggle (module) {
            var index = _.findIndex(vm.selectedModules, module);
            if (index > -1) {
                vm.selectedModules.splice(index, 1);
            }
            else {
                vm.selectedModules.push(module);
            }

            vm.hospitalForm.$setDirty();
        }

        function exists (module) {
            return _.findIndex(vm.selectedModules, module) > -1;
        }

        function isIndeterminate () {
            return (vm.selectedModules.length !== 0 && vm.selectedModules.length !== vm.modules.length);
        }

        function isChecked() {
            return vm.selectedModules.length === vm.modules.length;
        }

        function toggleAll() {
            if (vm.selectedModules.length === vm.modules.length) {
                vm.selectedModules = [];
            } else if (vm.selectedModules.length === 0 || vm.selectedModules.length > 0) {
                vm.selectedModules = vm.modules.slice(0);
            }

            vm.hospitalForm.$setDirty();
        }

        function translate() {
            return $translate([
                'HOSPITAL_FORM.CREATE',
                'HOSPITAL_FORM.EDIT',
                'HOSPITAL_FORM.SIZES.HOSPITAL_SMALL',
                'HOSPITAL_FORM.SIZES.HOSPITAL_MEDIUM',
                'HOSPITAL_FORM.SIZES.HOSPITAL_LARGE',
                'HOSPITAL_FORM.SIZES.HOSPITAL_MEGA',
                'HOSPITAL_FORM.SIZES.CLINIC_SMALL',
                'HOSPITAL_FORM.SIZES.CLINIC_LARGE',
                'HOSPITAL_FORM.TYPES.PRIMARY',
                'HOSPITAL_FORM.TYPES.TERTIARY',
                'HOSPITAL_FORM.MESSAGES.CREATED',
                'HOSPITAL_FORM.MESSAGES.UPDATED',
                'HOSPITAL_FORM.MODULES.DASHBOARD',
                'HOSPITAL_FORM.MODULES.QC_FAILED_LOG',
                'HOSPITAL_FORM.MODULES.LOCATION',
                'HOSPITAL_FORM.MODULES.METER',
                'HOSPITAL_FORM.MODULES.TEST_STRIP',
                'HOSPITAL_FORM.MODULES.CONTROL_SOLUTION',
                'HOSPITAL_FORM.MODULES.CURRENT_LOT',
                'HOSPITAL_FORM.MODULES.OPERATOR',
                'HOSPITAL_FORM.MODULES.QC_REPORT_SINGLE',
                'HOSPITAL_FORM.MODULES.QC_REPORT_MFR_CONTROL_LIMITS',
                'HOSPITAL_FORM.MODULES.QC_REPORT_MULTIPLE',
                'HOSPITAL_FORM.MODULES.HOSPITAL_OVERVIEW',
                'HOSPITAL_FORM.MODULES.TEST_STRIP_CONSUMPTION',
                'HOSPITAL_FORM.MODULES.BLOOD_GLUCOSE_TEST',
                'HOSPITAL_FORM.MODULES.UPLOAD_METER_DATA',
                'HOSPITAL_FORM.MODULES.MANUAL_QC_DATA'
            ]).then(function(translations) {
                vm.dialogTitles = {
                    create: translations['HOSPITAL_FORM.CREATE'],
                    edit: translations['HOSPITAL_FORM.EDIT']
                };

                vm.sizes = [
                    {
                        name: 'clinic_small',
                        caption: translations['HOSPITAL_FORM.SIZES.CLINIC_SMALL']
                    },
                    {
                        name: 'clinic_large',
                        caption: translations['HOSPITAL_FORM.SIZES.CLINIC_LARGE']
                    },
                    {
                        name: 'hospital_small',
                        caption: translations['HOSPITAL_FORM.SIZES.HOSPITAL_SMALL']
                    },
                    {
                        name: 'hospital_medium',
                        caption: translations['HOSPITAL_FORM.SIZES.HOSPITAL_MEDIUM']
                    },
                    {
                        name: 'hospital_large',
                        caption: translations['HOSPITAL_FORM.SIZES.HOSPITAL_LARGE']
                    },
                    {
                        name: 'hospital_mega',
                        caption: translations['HOSPITAL_FORM.SIZES.HOSPITAL_MEGA']
                    }
                ];

                vm.types = [
                    {
                        name: 'primary',
                        caption: translations['HOSPITAL_FORM.TYPES.PRIMARY']
                    },
                    {
                        name: 'tertiary',
                        caption: translations['HOSPITAL_FORM.TYPES.TERTIARY']
                    }
                ];

                vm.modules = [
                    {
                        name: 'dashboard',
                        caption: translations['HOSPITAL_FORM.MODULES.DASHBOARD']
                    },
                    {
                        name: 'log',
                        caption: translations['HOSPITAL_FORM.MODULES.QC_FAILED_LOG']
                    },
                    {
                        name: 'location',
                        caption: translations['HOSPITAL_FORM.MODULES.LOCATION']
                    },
                    {
                        name: 'meter',
                        caption: translations['HOSPITAL_FORM.MODULES.METER']
                    },
                    {
                        name: 'test-strip',
                        caption: translations['HOSPITAL_FORM.MODULES.TEST_STRIP']
                    },
                    {
                        name: 'control-solution',
                        caption: translations['HOSPITAL_FORM.MODULES.CONTROL_SOLUTION']
                    },
                    {
                        name: 'current-lot',
                        caption: translations['HOSPITAL_FORM.MODULES.CURRENT_LOT']
                    },
                    {
                        name: 'hospital-operator',
                        caption: translations['HOSPITAL_FORM.MODULES.OPERATOR']
                    },
                    {
                        name: 'qc-report-single',
                        caption: translations['HOSPITAL_FORM.MODULES.QC_REPORT_SINGLE']
                    },
                    {
                        name: 'qc-report-multiple',
                        caption: translations['HOSPITAL_FORM.MODULES.QC_REPORT_MULTIPLE']
                    },
                    {
                        name: 'qc-report-hospital',
                        caption: translations['HOSPITAL_FORM.MODULES.HOSPITAL_OVERVIEW']
                    },
                    {
                        name: 'test-strip-consumption',
                        caption: translations['HOSPITAL_FORM.MODULES.TEST_STRIP_CONSUMPTION']
                    },
                    {
                        name: 'blood-glucose-test',
                        caption: translations['HOSPITAL_FORM.MODULES.BLOOD_GLUCOSE_TEST']
                    },
                    {
                        name: 'upload-meter-data',
                        caption: translations['HOSPITAL_FORM.MODULES.UPLOAD_METER_DATA']
                    }
                ];

                if (_.indexOf(CONFIG.qc_report_mfr_control_limits_supported_countries, vm.country) > -1) {
                    // Insert at index 9 (qc-report-multiple)
                    vm.modules.splice(9, 0, {
                        name: 'qc-report-mfr-control-limits',
                        caption: translations['HOSPITAL_FORM.MODULES.QC_REPORT_MFR_CONTROL_LIMITS']
                    });
                }

                if (_.indexOf(CONFIG.manual_qc_data_supported_countries, vm.country) > -1) {
                    vm.modules.push({
                        name: 'manual-qc-data',
                        caption: translations['HOSPITAL_FORM.MODULES.MANUAL_QC_DATA']
                    });
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.current-lot', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.current-lot', {
                url    : '/current-lot',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/current-lot/current-lot.html',
                        controller : 'CurrentLotController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['hospital_admin', 'hospital_operator']
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/current-lot');

        // Api
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('test-strips', ['/test_strips']);
        msApiProvider.register('control-solutions', ['/control_solutions']);
        msApiProvider.register('current-lot', ['/meters/current_lot']);
        msApiProvider.register('current-lot-history', ['/meters/current_lot/history']);
        msApiProvider.register('test-strip-history', ['/meters/test_strip_history']);
        msApiProvider.register('control-solution-history', ['/meters/control_solution_history']);
        msApiProvider.register('test-strip-history.edit', ['/meters/test_strip_history/:pivot_id', {pivot_id: '@pivot_id'}, {
            update: { method:'PUT'}
        }]);
        msApiProvider.register('control-solution-history.edit', ['/meters/control_solution_history/:pivot_id', {pivot_id: '@pivot_id'}, {
            update: { method:'PUT'}
        }]);

        msApiProvider.register('meters.export-current-lot-history', ['/meters/export_current_lot_history', {}, {
            download: {method: 'GET', responseType: 'arraybuffer', transformResponse: function(data, headersGetter) {
                // Stores the ArrayBuffer object in a property called "data"
                return { data : data };
            }}
        }]);

        msNavigationServiceProvider.saveItem('current-lot', {
            title    : 'Current Lot Register',
            icon     : 'icon-clipboard-text',
            state    : 'app.current-lot',
            weight   : 11,
            translate: 'CURRENT_LOT.NAV'
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.current-lot')
        .controller('EditTestStripHistoryController', EditTestStripHistoryController);

    /** @ngInject */
    function EditTestStripHistoryController($mdDialog, dialogData, resolveData, $log)
    {
        var vm = this;

        // Data
        vm.testStrips = resolveData.test_strips;
        vm.testStripHistory = dialogData.testStripHistory;
        vm.selectedTestStrip = null;
        vm.changedAt = null;
        vm.changedDate = null;
        vm.changedHour = null;
        vm.changedMinute = null;
        vm.changedMeridiem = null;

        vm.hours = [{value: 1, text: '01'}, {value: 2, text: '02'}, {value: 3, text: '03'}, {value: 4, text: '04'}, {value: 5, text: '05'}, {value: 6, text: '06'}, {value: 7, text: '07'}, {value: 8, text: '08'}, {value: 9, text: '09'}, {value: 10, text: '10'}, {value: 11, text: '11'}, {value: 0, text: '12'}]
        vm.minutes = [
            {value: 0, text: '00'}, {value: 1, text: '01'}, {value: 2, text: '02'}, {value: 3, text: '03'}, {value: 4, text: '04'}, {value: 5, text: '05'}, {value: 6, text: '06'}, {value: 7, text: '07'}, {value: 8, text: '08'}, {value: 9, text: '09'},
            {value: 10, text: '10'}, {value: 11, text: '11'}, {value: 12, text: '12'}, {value: 13, text: '13'}, {value: 14, text: '14'}, {value: 15, text: '15'}, {value: 16, text: '16'}, {value: 17, text: '17'}, {value: 18, text: '18'}, {value: 19, text: '19'},
            {value: 20, text: '20'}, {value: 21, text: '21'}, {value: 22, text: '22'}, {value: 23, text: '23'}, {value: 24, text: '24'}, {value: 25, text: '25'}, {value: 26, text: '26'}, {value: 27, text: '27'}, {value: 28, text: '28'}, {value: 29, text: '29'},
            {value: 30, text: '30'}, {value: 31, text: '31'}, {value: 32, text: '32'}, {value: 33, text: '33'}, {value: 34, text: '34'}, {value: 35, text: '35'}, {value: 36, text: '36'}, {value: 37, text: '37'}, {value: 38, text: '38'}, {value: 39, text: '39'},
            {value: 40, text: '40'}, {value: 41, text: '41'}, {value: 42, text: '42'}, {value: 43, text: '43'}, {value: 44, text: '44'}, {value: 45, text: '45'}, {value: 46, text: '46'}, {value: 47, text: '47'}, {value: 48, text: '48'}, {value: 49, text: '49'},
            {value: 50, text: '50'}, {value: 51, text: '51'}, {value: 52, text: '52'}, {value: 53, text: '53'}, {value: 54, text: '54'}, {value: 55, text: '55'}, {value: 56, text: '56'}, {value: 57, text: '57'}, {value: 58, text: '58'}, {value: 59, text: '59'}]

        // Methods
        vm.save = save;
        vm.close = close;
        vm.now = now;

        init();

        //////////

        function init() {
            vm.selectedTestStrip = _.find(vm.testStrips, ['id', vm.testStripHistory.id]);
            vm.changedAt = moment(vm.testStripHistory.pivot.changed_at);
            vm.changedDate = vm.changedAt.toDate();
            vm.changedHour = vm.changedAt.hour() % 12;
            vm.changedMinute = vm.changedAt.minute();
            vm.changedMeridiem = vm.changedAt.hour() >= 12 ? 'PM' : 'AM';
        }

        function save(){
            var response = {
                testStrip: vm.selectedTestStrip,
                changedAt: moment({
                    year : vm.changedDate.getFullYear(),
                    month : vm.changedDate.getMonth(),
                    day : vm.changedDate.getDate(),
                    hour : (vm.changedMeridiem === 'PM') ? vm.changedHour + 12 : vm.changedHour,
                    minute : vm.changedMinute,
                    second : 0,
                    millisecond : 0
                }).format()
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function now() {
            var now = moment().startOf('minute');
            vm.changedDate = now.toDate();
            vm.changedHour = now.hour() % 12;
            vm.changedMinute = now.minute();
            vm.changedMeridiem = now.hour() >= 12 ? 'PM' : 'AM';
            vm.dirty = true;
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.current-lot')
        .controller('EditControlSolutionHistoryController', EditControlSolutionHistoryController);

    /** @ngInject */
    function EditControlSolutionHistoryController($mdDialog, dialogData, resolveData, $log)
    {
        var vm = this;

        // Data
        vm.controlSolutions = resolveData.control_solutions;
        vm.controlSolutionHistory = dialogData.controlSolutionHistory;
        vm.type = dialogData.type;
        vm.selectedControlSolution = null;
        vm.changedAt = null;
        vm.changedDate = null;
        vm.changedHour = null;
        vm.changedMinute = null;
        vm.changedMeridiem = null;

        vm.hours = [{value: 1, text: '01'}, {value: 2, text: '02'}, {value: 3, text: '03'}, {value: 4, text: '04'}, {value: 5, text: '05'}, {value: 6, text: '06'}, {value: 7, text: '07'}, {value: 8, text: '08'}, {value: 9, text: '09'}, {value: 10, text: '10'}, {value: 11, text: '11'}, {value: 0, text: '12'}]
        vm.minutes = [
            {value: 0, text: '00'}, {value: 1, text: '01'}, {value: 2, text: '02'}, {value: 3, text: '03'}, {value: 4, text: '04'}, {value: 5, text: '05'}, {value: 6, text: '06'}, {value: 7, text: '07'}, {value: 8, text: '08'}, {value: 9, text: '09'},
            {value: 10, text: '10'}, {value: 11, text: '11'}, {value: 12, text: '12'}, {value: 13, text: '13'}, {value: 14, text: '14'}, {value: 15, text: '15'}, {value: 16, text: '16'}, {value: 17, text: '17'}, {value: 18, text: '18'}, {value: 19, text: '19'},
            {value: 20, text: '20'}, {value: 21, text: '21'}, {value: 22, text: '22'}, {value: 23, text: '23'}, {value: 24, text: '24'}, {value: 25, text: '25'}, {value: 26, text: '26'}, {value: 27, text: '27'}, {value: 28, text: '28'}, {value: 29, text: '29'},
            {value: 30, text: '30'}, {value: 31, text: '31'}, {value: 32, text: '32'}, {value: 33, text: '33'}, {value: 34, text: '34'}, {value: 35, text: '35'}, {value: 36, text: '36'}, {value: 37, text: '37'}, {value: 38, text: '38'}, {value: 39, text: '39'},
            {value: 40, text: '40'}, {value: 41, text: '41'}, {value: 42, text: '42'}, {value: 43, text: '43'}, {value: 44, text: '44'}, {value: 45, text: '45'}, {value: 46, text: '46'}, {value: 47, text: '47'}, {value: 48, text: '48'}, {value: 49, text: '49'},
            {value: 50, text: '50'}, {value: 51, text: '51'}, {value: 52, text: '52'}, {value: 53, text: '53'}, {value: 54, text: '54'}, {value: 55, text: '55'}, {value: 56, text: '56'}, {value: 57, text: '57'}, {value: 58, text: '58'}, {value: 59, text: '59'}]

        // Methods
        vm.save = save;
        vm.close = close;
        vm.now = now;

        init();

        //////////

        function init() {

            vm.selectedControlSolution = _.find(vm.controlSolutions, ['id', vm.controlSolutionHistory.id]);
            vm.changedAt = moment(vm.controlSolutionHistory.pivot.changed_at);
            vm.changedDate = vm.changedAt.toDate();
            vm.changedHour = vm.changedAt.hour() % 12;
            vm.changedMinute = vm.changedAt.minute();
            vm.changedMeridiem = vm.changedAt.hour() >= 12 ? 'PM' : 'AM';
        }

        function save(){
            var response = {
                controlSolution: vm.selectedControlSolution,
                changedAt: moment({
                    year : vm.changedDate.getFullYear(),
                    month : vm.changedDate.getMonth(),
                    day : vm.changedDate.getDate(),
                    hour : (vm.changedMeridiem === 'PM') ? vm.changedHour + 12 : vm.changedHour,
                    minute : vm.changedMinute,
                    second : 0,
                    millisecond : 0
                }).format()
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function now() {
            var now = moment().startOf('minute');
            vm.changedDate = now.toDate();
            vm.changedHour = now.hour() % 12;
            vm.changedMinute = now.minute();
            vm.changedMeridiem = now.hour() >= 12 ? 'PM' : 'AM';
            vm.dirty = true;
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.current-lot')
        .controller('ChangeTestStripController', ChangeTestStripController);

    /** @ngInject */
    function ChangeTestStripController($mdDialog, dialogData, resolveData, $log)
    {
        var vm = this;

        // Data
        vm.testStrips = resolveData.test_strips;
        vm.currentTestStrip = dialogData.currentTestStrip;
        vm.selectedTestStrip = null;
        vm.changedAt = null;
        vm.changedDate = null;
        vm.changedHour = null;
        vm.changedMinute = null;
        vm.changedMeridiem = null;

        vm.hours = [{value: 1, text: '01'}, {value: 2, text: '02'}, {value: 3, text: '03'}, {value: 4, text: '04'}, {value: 5, text: '05'}, {value: 6, text: '06'}, {value: 7, text: '07'}, {value: 8, text: '08'}, {value: 9, text: '09'}, {value: 10, text: '10'}, {value: 11, text: '11'}, {value: 0, text: '12'}]
        vm.minutes = [
            {value: 0, text: '00'}, {value: 1, text: '01'}, {value: 2, text: '02'}, {value: 3, text: '03'}, {value: 4, text: '04'}, {value: 5, text: '05'}, {value: 6, text: '06'}, {value: 7, text: '07'}, {value: 8, text: '08'}, {value: 9, text: '09'},
            {value: 10, text: '10'}, {value: 11, text: '11'}, {value: 12, text: '12'}, {value: 13, text: '13'}, {value: 14, text: '14'}, {value: 15, text: '15'}, {value: 16, text: '16'}, {value: 17, text: '17'}, {value: 18, text: '18'}, {value: 19, text: '19'},
            {value: 20, text: '20'}, {value: 21, text: '21'}, {value: 22, text: '22'}, {value: 23, text: '23'}, {value: 24, text: '24'}, {value: 25, text: '25'}, {value: 26, text: '26'}, {value: 27, text: '27'}, {value: 28, text: '28'}, {value: 29, text: '29'},
            {value: 30, text: '30'}, {value: 31, text: '31'}, {value: 32, text: '32'}, {value: 33, text: '33'}, {value: 34, text: '34'}, {value: 35, text: '35'}, {value: 36, text: '36'}, {value: 37, text: '37'}, {value: 38, text: '38'}, {value: 39, text: '39'},
            {value: 40, text: '40'}, {value: 41, text: '41'}, {value: 42, text: '42'}, {value: 43, text: '43'}, {value: 44, text: '44'}, {value: 45, text: '45'}, {value: 46, text: '46'}, {value: 47, text: '47'}, {value: 48, text: '48'}, {value: 49, text: '49'},
            {value: 50, text: '50'}, {value: 51, text: '51'}, {value: 52, text: '52'}, {value: 53, text: '53'}, {value: 54, text: '54'}, {value: 55, text: '55'}, {value: 56, text: '56'}, {value: 57, text: '57'}, {value: 58, text: '58'}, {value: 59, text: '59'}]

        // Methods
        vm.save = save;
        vm.close = close;
        vm.selectedTestStripChanged = selectedTestStripChanged;
        vm.now = now;

        init();

        //////////

        function init() {
            if (vm.currentTestStrip) {
                vm.selectedTestStrip = _.find(vm.testStrips, ['id', vm.currentTestStrip.id]);
                vm.changedAt = moment(vm.currentTestStrip.pivot.changed_at);
                vm.changedDate = vm.changedAt.toDate();
                vm.changedHour = vm.changedAt.hour() % 12;
                vm.changedMinute = vm.changedAt.minute();
                vm.changedMeridiem = vm.changedAt.hour() >= 12 ? 'PM' : 'AM';
            } else {
                now();
            }
        }

        function save(){
            var response = {
                testStrip: vm.selectedTestStrip,
                changedAt: moment({
                    year : vm.changedDate.getFullYear(),
                    month : vm.changedDate.getMonth(),
                    day : vm.changedDate.getDate(),
                    hour : (vm.changedMeridiem === 'PM') ? vm.changedHour + 12 : vm.changedHour,
                    minute : vm.changedMinute,
                    second : 0,
                    millisecond : 0
                }).format()
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function selectedTestStripChanged() {
            if (vm.selectedTestStrip && vm.currentTestStrip && vm.selectedTestStrip.id === vm.currentTestStrip.id) {
                vm.changedDate = vm.changedAt.toDate();
                vm.changedHour = vm.changedAt.hour() % 12;
                vm.changedMinute = vm.changedAt.minute();
                vm.changedMeridiem = vm.changedAt.hour() >= 12 ? 'PM' : 'AM';
            } else {
                now();
            }
        }

        function now() {
            var now = moment().startOf('minute');
            vm.changedDate = now.toDate();
            vm.changedHour = now.hour() % 12;
            vm.changedMinute = now.minute();
            vm.changedMeridiem = now.hour() >= 12 ? 'PM' : 'AM';
            vm.dirty = true;
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.current-lot')
        .controller('ChangeControlSolutionController', ChangeControlSolutionController);

    /** @ngInject */
    function ChangeControlSolutionController($mdDialog, dialogData, resolveData, $log)
    {
        var vm = this;

        // Data
        vm.controlSolutions = resolveData.control_solutions;
        vm.currentControlSolution = dialogData.currentControlSolution;
        vm.type = dialogData.type;
        vm.selectedControlSolution = null;
        vm.changedAt = null;
        vm.changedDate = null;
        vm.changedHour = null;
        vm.changedMinute = null;
        vm.changedMeridiem = null;

        vm.hours = [{value: 1, text: '01'}, {value: 2, text: '02'}, {value: 3, text: '03'}, {value: 4, text: '04'}, {value: 5, text: '05'}, {value: 6, text: '06'}, {value: 7, text: '07'}, {value: 8, text: '08'}, {value: 9, text: '09'}, {value: 10, text: '10'}, {value: 11, text: '11'}, {value: 0, text: '12'}]
        vm.minutes = [
            {value: 0, text: '00'}, {value: 1, text: '01'}, {value: 2, text: '02'}, {value: 3, text: '03'}, {value: 4, text: '04'}, {value: 5, text: '05'}, {value: 6, text: '06'}, {value: 7, text: '07'}, {value: 8, text: '08'}, {value: 9, text: '09'},
            {value: 10, text: '10'}, {value: 11, text: '11'}, {value: 12, text: '12'}, {value: 13, text: '13'}, {value: 14, text: '14'}, {value: 15, text: '15'}, {value: 16, text: '16'}, {value: 17, text: '17'}, {value: 18, text: '18'}, {value: 19, text: '19'},
            {value: 20, text: '20'}, {value: 21, text: '21'}, {value: 22, text: '22'}, {value: 23, text: '23'}, {value: 24, text: '24'}, {value: 25, text: '25'}, {value: 26, text: '26'}, {value: 27, text: '27'}, {value: 28, text: '28'}, {value: 29, text: '29'},
            {value: 30, text: '30'}, {value: 31, text: '31'}, {value: 32, text: '32'}, {value: 33, text: '33'}, {value: 34, text: '34'}, {value: 35, text: '35'}, {value: 36, text: '36'}, {value: 37, text: '37'}, {value: 38, text: '38'}, {value: 39, text: '39'},
            {value: 40, text: '40'}, {value: 41, text: '41'}, {value: 42, text: '42'}, {value: 43, text: '43'}, {value: 44, text: '44'}, {value: 45, text: '45'}, {value: 46, text: '46'}, {value: 47, text: '47'}, {value: 48, text: '48'}, {value: 49, text: '49'},
            {value: 50, text: '50'}, {value: 51, text: '51'}, {value: 52, text: '52'}, {value: 53, text: '53'}, {value: 54, text: '54'}, {value: 55, text: '55'}, {value: 56, text: '56'}, {value: 57, text: '57'}, {value: 58, text: '58'}, {value: 59, text: '59'}]

        // Methods
        vm.save = save;
        vm.close = close;
        vm.selectedControlSolutionChanged = selectedControlSolutionChanged;
        vm.now = now;

        init();

        //////////

        function init() {
            if (vm.currentControlSolution) {
                vm.selectedControlSolution = _.find(vm.controlSolutions, ['id', vm.currentControlSolution.id]);
                vm.changedAt = moment(vm.currentControlSolution.pivot.changed_at);
                vm.changedDate = vm.changedAt.toDate();
                vm.changedHour = vm.changedAt.hour() % 12;
                vm.changedMinute = vm.changedAt.minute();
                vm.changedMeridiem = vm.changedAt.hour() >= 12 ? 'PM' : 'AM';
            } else {
                now();
            }
        }

        function save(){
            var response = {
                controlSolution: vm.selectedControlSolution,
                changedAt: moment({
                    year : vm.changedDate.getFullYear(),
                    month : vm.changedDate.getMonth(),
                    day : vm.changedDate.getDate(),
                    hour : (vm.changedMeridiem === 'PM') ? vm.changedHour + 12 : vm.changedHour,
                    minute : vm.changedMinute,
                    second : 0,
                    millisecond : 0
                }).format()
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function selectedControlSolutionChanged() {
            if (vm.selectedControlSolution && vm.currentControlSolution && vm.selectedControlSolution.id === vm.currentControlSolution.id) {
                vm.changedDate = vm.changedAt.toDate();
                vm.changedHour = vm.changedAt.hour() % 12;
                vm.changedMinute = vm.changedAt.minute();
                vm.changedMeridiem = vm.changedAt.hour() >= 12 ? 'PM' : 'AM';
            } else {
                now();
            }
        }

        function now() {
            var now = moment().startOf('minute');
            vm.changedDate = now.toDate();
            vm.changedHour = now.hour() % 12;
            vm.changedMinute = now.minute();
            vm.changedMeridiem = now.hour() >= 12 ? 'PM' : 'AM';
            vm.dirty = true;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.control-solution', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.control-solution', {
                url    : '/control-solution',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/control-solution/control-solution.html',
                        controller : 'ControlSolutionController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_country_admin', 'hospital_admin']
                },
                resolve: {
                    hospitalsData: function(msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        if (user.role.name === 'roche_country_admin') {
                            return msApi.request('hospitals@get', {
                                country: user.country
                            });
                        }
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/control-solution');
        $translatePartialLoaderProvider.addPart('app/main/control-solution/control-solution-form');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('control-solutions', ['/control_solutions']);
        msApiProvider.register('control-solutions.edit', ['/control_solutions/:id', {id: '@id'}, {
            update: { method:'PUT'}
        }]);
        msApiProvider.register('control-solutions.export', ['/control_solutions/export', {}, {
            download: {method: 'GET', responseType: 'arraybuffer', transformResponse: function(data, headersGetter) {
                // Stores the ArrayBuffer object in a property called "data"
                return { data : data };
            }}
        }]);

        msNavigationServiceProvider.saveItem('control-solution', {
            title    : 'Control Solution Register',
            icon     : 'icon-beaker-outline',
            state    : 'app.control-solution',
            weight   : 10,
            translate: 'CONTROL_SOLUTION.NAV',
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.control-solution')
        .controller('ControlSolutionFormController', ControlSolutionFormController);

    /** @ngInject */
    function ControlSolutionFormController($mdDialog, dialogData, $translate, $log)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.isCountryAdmin = dialogData.isCountryAdmin;
        vm.hospitals = dialogData.hospitals;
        vm.selectedHospital = null;
        vm.types = ['Level 1', 'Level 2'];
        vm.selectedTypes = [];
        vm.expiry = null;

        vm.isReadOnly = dialogData.isReadOnly;
        vm.canRemove = false;

        // Methods
        vm.save = save;
        vm.remove = remove;
        vm.close = close;
        vm.getSelectedTypesText = getSelectedTypesText;
        vm.validateLotNo = validateLotNo;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            // Figure out the title
            switch (vm.dialogData.type)
            {
                case 'create' :
                    vm.dialogTitle = vm.dialogTitles.create;
                    break;

                case 'edit' :
                    vm.dialogTitle = vm.dialogTitles.edit;
                    //vm.canRemove = true;
                    break;

                case 'view' :
                    vm.dialogTitle = vm.dialogTitles.view;
                    break;

                default:
                    vm.dialogTitle = vm.dialogTitles.view;
                    break;
            }

            if (vm.dialogData.controlSolution) {
                vm.controlSolution = vm.dialogData.controlSolution;
                vm.expiry = moment(vm.controlSolution.expiry).toDate();
                vm.selectedHospital = _.find(vm.hospitals, ['id', vm.controlSolution.hospital.id]);
            } else {

                if (!vm.isCountryAdmin) {
                    vm.selectedHospital = vm.hospitals[0];
                }

                vm.controlSolution = {
                    lot_no: '',
                    type: null,
                    expiry: null,
                    hospital_id: null
                };

                vm.selectedTypes = vm.types;
            }
        }

        function save(){
            vm.controlSolution.hospital_id = vm.selectedHospital.id;
            vm.controlSolution.expiry =  moment(vm.expiry).startOf('day').format();

            var response = {
                type: vm.dialogData.type,
                controlSolutions: null,
                controlSolution: null
            };

            if (vm.dialogData.type === 'create') {
                var controlSolutions = [];

                _.forEach(vm.selectedTypes, function(type) {
                    var controlSolution = _.clone(vm.controlSolution);
                    controlSolution.type = type;
                    controlSolutions.push(controlSolution);
                });

                response.controlSolutions = controlSolutions;

            } else {
                response.controlSolution = vm.controlSolution;
            }

            $mdDialog.hide(response);
        }

        function remove() {
            var response = {
                type: 'remove',
                controlSolution: vm.controlSolution
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function getSelectedTypesText() {
            if (vm.selectedTypes && vm.selectedTypes.length) {
                if (vm.selectedTypes.length === vm.types.length) {
                    return vm.selectedTypeTexts.allControlType;
                }
                return _.join(vm.selectedTypes, ',');
            } else {
                return vm.selectedTypeTexts.controlType;
            }
        }

        function validateLotNo() {
            if (vm.dialogData.type === 'edit') {
                vm.controlSolutionForm.lot_no.$setTouched();
            }

            vm.controlSolutionForm.lot_no.$validate();

        }

        function translate() {
            return $translate([
                'CONTROL_SOLUTION_FORM.VIEW',
                'CONTROL_SOLUTION_FORM.CREATE',
                'CONTROL_SOLUTION_FORM.EDIT',
                'CONTROL_SOLUTION_FORM.ALL_CONTROL_TYPE',
                'CONTROL_SOLUTION_FORM.CONTROL_TYPE'
            ]).then(function(translations) {
                vm.dialogTitles = {
                    view: translations['CONTROL_SOLUTION_FORM.VIEW'],
                    create: translations['CONTROL_SOLUTION_FORM.CREATE'],
                    edit: translations['CONTROL_SOLUTION_FORM.EDIT']
                };

                vm.selectedTypeTexts = {
                    allControlType: translations['CONTROL_SOLUTION_FORM.ALL_CONTROL_TYPE'],
                    controlType: translations['CONTROL_SOLUTION_FORM.CONTROL_TYPE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.test-strip')
        .controller('BatchCreateControlSolutionsFormController', BatchCreateControlSolutionsFormController);

    /** @ngInject */
    function BatchCreateControlSolutionsFormController($mdDialog, dialogData, $translate, $log)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.hospitals = dialogData.hospitals;
        vm.selectedHospitals = [];
        vm.expiry = null;
        vm.types = ['Level 1', 'Level 2'];
        vm.selectedTypes = vm.types;

        // Methods
        vm.save = save;
        vm.close = close;
        vm.getSelectedHospitalsText = getSelectedHospitalsText;
        vm.getSelectedHospitalIds = getSelectedHospitalIds;
        vm.getSelectedTypesText = getSelectedTypesText;
        vm.validateLotNo = validateLotNo;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            vm.controlSolution = {
                lot_no: '',
                type: null,
                expiry: null,
                hospital_id: null
            };
        }

        function save(){

            vm.controlSolution.expiry =  moment(vm.expiry).startOf('day').format();

            var controlSolutions = [];

            _.forEach(vm.selectedHospitals, function(hospital) {
                _.forEach(vm.selectedTypes, function(type) {
                    var controlSolution = _.clone(vm.controlSolution);
                    controlSolution.hospital_id = hospital.id;
                    controlSolution.type = type;
                    controlSolutions.push(controlSolution);
                });
            });

            var response = {
                controlSolutions: controlSolutions
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }

        function getSelectedHospitalsText() {
            if (vm.selectedHospitals && vm.selectedHospitals.length) {
                if (vm.selectedHospitals.length === vm.hospitals.length) {
                    return vm.selectedHospitalTexts.allHospitals;
                }
                return _.join(_.map(vm.selectedHospitals, 'name'), ',');
            } else {
                return vm.selectedHospitalTexts.hospitals;
            }
        }

        function getSelectedHospitalIds() {
            return _.map(vm.selectedHospitals, 'id');
        }

        function getSelectedTypesText() {
            if (vm.selectedTypes && vm.selectedTypes.length) {
                if (vm.selectedTypes.length === vm.types.length) {
                    return vm.selectedTypeTexts.allControlType;
                }
                return _.join(vm.selectedTypes, ',');
            } else {
                return vm.selectedTypeTexts.controlType;
            }
        }

        function validateLotNo() {
            if (vm.dialogData.type === 'edit') {
                vm.controlSolutionForm.lot_no.$setTouched();
            }

            vm.controlSolutionForm.lot_no.$validate();

        }

        function translate() {
            return $translate([
                'CONTROL_SOLUTION_FORM.ALL_HOSPITALS',
                'CONTROL_SOLUTION_FORM.HOSPITALS',
                'CONTROL_SOLUTION_FORM.ALL_CONTROL_TYPE',
                'CONTROL_SOLUTION_FORM.CONTROL_TYPE'
            ]).then(function(translations) {
                vm.selectedHospitalTexts = {
                    allHospitals: translations['CONTROL_SOLUTION_FORM.ALL_HOSPITALS'],
                    hospitals: translations['CONTROL_SOLUTION_FORM.HOSPITALS']
                };

                vm.selectedTypeTexts = {
                    allControlType: translations['CONTROL_SOLUTION_FORM.ALL_CONTROL_TYPE'],
                    controlType: translations['CONTROL_SOLUTION_FORM.CONTROL_TYPE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.blood-glucose-test', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.blood-glucose-test', {
                url    : '/blood-glucose-test',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/blood-glucose-test/blood-glucose-test.html',
                        controller : 'BloodGlucoseTestController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin', 'hospital_operator']
                },
                resolve: {
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/blood-glucose-test');

        // Api
        msApiProvider.register('hospitals', ['/hospitals']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('blood-glucose-tests', ['/blood_glucose_tests']);


        msNavigationServiceProvider.saveItem('blood-glucose-test', {
            title    : 'Blood Glucose Test Logbook',
            icon     : 'icon-timetable',
            state    : 'app.blood-glucose-test',
            weight   : 30,
            translate: 'BLOOD_GLUCOSE_TEST.NAV'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.blood-glucose-test')
        .component('bloodGlucoseTestGlobalAdmin', {
            templateUrl: 'app/main/blood-glucose-test/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function GlobalAdminController($scope, msApi, localStorageService, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.countries = [];
        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedCountry = null;
        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.selectedMeter = null;
        vm.searchTerm = '';

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.pagination = {
            total:0,
            per_page: 10,
            current_page: 1
        };
        vm.sort = "tested_on";

        vm.loaded = false;
        vm.message = null;

        // Methods
        vm.$onInit = init;
        vm.selectedCountryChanged = selectedCountryChanged;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMeterChanged = selectedMeterChanged;
        vm.getBloodGlucoseTests = getBloodGlucoseTests;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.evalMeterReading = evalMeterReading;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.countries = _.sortBy(_.transform(vm.allCountries, function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectCountry;
        }

        function selectedCountryChanged() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.selectedCountry.code], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            if (vm.states.length) {
                vm.message = vm.messages.selectState;
            } else {
                $translate('BLOOD_GLUCOSE_TEST.MESSAGES.NO_STATE_IN', { country: vm.selectedCountry.name })
                    .then(function (translation) {
                        vm.message = translation;
                    });
            }

            vm.loaded = false;
            vm.selectedState = null;
            selectedStateChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.selectedCountry.code && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.selectedMeter = null;
            selectedMeterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedMeterChanged() {
            if (vm.selectedMeter && vm.filterForm.$valid) {
                getBloodGlucoseTests();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getBloodGlucoseTests();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getBloodGlucoseTests();
            }
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getBloodGlucoseTests() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.selectedMeter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            vm.promise = msApi.request('blood-glucose-tests@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.pagination.total = response.blood_glucose_tests.total;
                    vm.bloodGlucoseTests = response.blood_glucose_tests.data;
                    vm.loaded = true;
                });
        }

        function exportToCSV() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.selectedMeter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('blood-glucose-tests@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge
                    });

                    data.push({
                        a: vm.selectedMeter.serial_no,
                        b: vm.selectedMeter.model_no,
                        c: vm.selectedMeter.location.hospital.name,
                        d: vm.selectedMeter.location.code,
                        e: vm.selectedMeter.location.person_in_charge
                    });

                    data.push({a: '', b: '', c: '', d: '', e: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.meterReading + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        c: '',
                        d: '',
                        e: ''
                    });

                    var bloodGlucoseTests = response.blood_glucose_tests;

                    _.map(bloodGlucoseTests, function (test) {
                        data.push({
                            a: moment(test.tested_on).format(),
                            b: vm.evalMeterReading(test),
                            c: '',
                            d: '',
                            e: ''
                        });
                    });

                    var timestamp = moment();
                    var filename = 'BloodGlucoseTestLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO CSV(?, {headers:false, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.selectedMeter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('blood-glucose-tests@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge
                    });

                    data.push({
                        a: vm.selectedMeter.serial_no,
                        b: vm.selectedMeter.model_no,
                        c: vm.selectedMeter.location.hospital.name,
                        d: vm.selectedMeter.location.code,
                        e: vm.selectedMeter.location.person_in_charge
                    });

                    data.push({a: '', b: '', c: '', d: '', e: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.meterReading + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        c: '',
                        d: '',
                        e: ''
                    });

                    var bloodGlucoseTests = response.blood_glucose_tests;

                    _.map(bloodGlucoseTests, function (test) {
                        data.push({
                            a: moment(test.tested_on).format(),
                            b: vm.evalMeterReading(test),
                            c: '',
                            d: '',
                            e: ''
                        });
                    });

                    var timestamp = moment();
                    var filename = 'BloodGlucoseTestLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO XLSX(?, {headers:false}) FROM ?',[filename, data]);
                });
        }

        function evalMeterReading(test) {
          if (test.is_high) {
            return "HIGH";
          }
          else if (test.is_high) {
            return "LOW";
          }

          return parseFloat(test.meter_reading).toFixed(1);
        }

        function translate() {
            return $translate([
                'BLOOD_GLUCOSE_TEST.TITLE',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_DATA_AVAILABLE',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_COUNTRY',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_STATE',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_HOSPITAL',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_METER',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_STATE_IN',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER_IN',

                'BLOOD_GLUCOSE_TEST.METER.METER_SERIAL_NO',
                'BLOOD_GLUCOSE_TEST.METER.METER_MODEL',
                'BLOOD_GLUCOSE_TEST.METER.HOSPITAL',
                'BLOOD_GLUCOSE_TEST.METER.LOCATION_CODE',
                'BLOOD_GLUCOSE_TEST.METER.PERSON_IN_CHARGE',

                'BLOOD_GLUCOSE_TEST.COLUMNS.TEST_DATE_TIME',
                'BLOOD_GLUCOSE_TEST.COLUMNS.METER_READING',

                'BLOOD_GLUCOSE_TEST.PAGINATION.OF',
                'BLOOD_GLUCOSE_TEST.PAGINATION.PAGE',
                'BLOOD_GLUCOSE_TEST.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.messages = {
                    noRegisteredMeter: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_METER'],
                    noStateIn: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER_IN']
                };

                vm.meterSection = {
                    serialNo: translations['BLOOD_GLUCOSE_TEST.METER.METER_SERIAL_NO'],
                    model: translations['BLOOD_GLUCOSE_TEST.METER.METER_MODEL'],
                    hospital: translations['BLOOD_GLUCOSE_TEST.METER.HOSPITAL'],
                    locationCode: translations['BLOOD_GLUCOSE_TEST.METER.LOCATION_CODE'],
                    personInCharge: translations['BLOOD_GLUCOSE_TEST.METER.PERSON_IN_CHARGE']
                };

                vm.columns = {
                    testDateTime: translations['BLOOD_GLUCOSE_TEST.COLUMNS.TEST_DATE_TIME'],
                    meterReading: translations['BLOOD_GLUCOSE_TEST.COLUMNS.METER_READING']
                };

                vm.paginationLabel = {
                    of: translations['BLOOD_GLUCOSE_TEST.PAGINATION.OF'],
                    page: translations['BLOOD_GLUCOSE_TEST.PAGINATION.PAGE'],
                    rowsPerPage: translations['BLOOD_GLUCOSE_TEST.PAGINATION.ROWS_PER_PAGE']
                };

            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToCSVEvent = $scope.$on('blood-glucose-test::exportToCSV', function () {
            exportToCSV();
        });

        var exportToExcelEvent = $scope.$on('blood-glucose-test::exportToExcel', function () {
            exportToExcel();
        });

        vm.$onDestroy = function() {
            exportToCSVEvent();
            exportToExcelEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.blood-glucose-test')
        .component('bloodGlucoseTestHospitalOperator', {
            templateUrl: 'app/main/blood-glucose-test/hospital-operator/hospital-operator.html',
            controller: HospitalOperatorController,
            controllerAs: 'vm',
            bindings: {
                hospital: '<',
                locations: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalOperatorController($scope, msApi, localStorageService, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.meterColumns = [];
        vm.meters = [];
        vm.selectedMeter = null;
        vm.searchTerm = '';

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.pagination = {
            total:0,
            per_page: 10,
            current_page: 1
        };
        vm.sort = "tested_on";

        vm.loaded = false;
        vm.message = null;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMeterChanged = selectedMeterChanged;
        vm.getBloodGlucoseTests = getBloodGlucoseTests;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.evalMeterReading = evalMeterReading;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.message = vm.messages.selectMeter;
            getMeters();
        }

        function selectedMeterChanged() {
            if (vm.selectedMeter && vm.filterForm.$valid) {
                getBloodGlucoseTests();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getBloodGlucoseTests();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getBloodGlucoseTests();
            }
        }

        function getMeters() {
            var params = {
                hospital_id: vm.hospital.id,
                'location_ids[]': _.map(vm.locations, 'id')
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getBloodGlucoseTests() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.selectedMeter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            vm.promise = msApi.request('blood-glucose-tests@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.pagination.total = response.blood_glucose_tests.total;
                    vm.bloodGlucoseTests = response.blood_glucose_tests.data;
                    vm.loaded = true;
                });
        }

        function exportToCSV() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.selectedMeter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('blood-glucose-tests@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge
                    });

                    data.push({
                        a: vm.selectedMeter.serial_no,
                        b: vm.selectedMeter.model_no,
                        c: vm.selectedMeter.location.hospital.name,
                        d: vm.selectedMeter.location.code,
                        e: vm.selectedMeter.location.person_in_charge
                    });

                    data.push({a: '', b: '', c: '', d: '', e: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.meterReading + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        c: '',
                        d: '',
                        e: ''
                    });

                    var bloodGlucoseTests = response.blood_glucose_tests;

                    _.map(bloodGlucoseTests, function (test) {
                        data.push({
                            a: moment(test.tested_on).format(),
                            b: vm.evalMeterReading(test),
                            c: '',
                            d: '',
                            e: ''
                        });
                    });

                    var timestamp = moment();
                    var filename = 'BloodGlucoseTestLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO CSV(?, {headers:false, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.selectedMeter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('blood-glucose-tests@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge
                    });

                    data.push({
                        a: vm.selectedMeter.serial_no,
                        b: vm.selectedMeter.model_no,
                        c: vm.selectedMeter.location.hospital.name,
                        d: vm.selectedMeter.location.code,
                        e: vm.selectedMeter.location.person_in_charge
                    });

                    data.push({a: '', b: '', c: '', d: '', e: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.meterReading + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        c: '',
                        d: '',
                        e: ''
                    });

                    var bloodGlucoseTests = response.blood_glucose_tests;

                    _.map(bloodGlucoseTests, function (test) {
                        data.push({
                            a: moment(test.tested_on).format(),
                            b: vm.evalMeterReading(test),
                            c: '',
                            d: '',
                            e: ''
                        });
                    });

                    var timestamp = moment();
                    var filename = 'BloodGlucoseTestLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO XLSX(?, {headers:false}) FROM ?',[filename, data]);
                });
        }

        function evalMeterReading(test) {
          if (test.is_high) {
            return "HIGH";
          }
          else if (test.is_high) {
            return "LOW";
          }

          return parseFloat(test.meter_reading).toFixed(1);
        }

        function translate() {
            return $translate([
                'BLOOD_GLUCOSE_TEST.TITLE',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_DATA_AVAILABLE',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_COUNTRY',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_STATE',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_HOSPITAL',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_METER',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_STATE_IN',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER_IN',

                'BLOOD_GLUCOSE_TEST.METER.METER_SERIAL_NO',
                'BLOOD_GLUCOSE_TEST.METER.METER_MODEL',
                'BLOOD_GLUCOSE_TEST.METER.HOSPITAL',
                'BLOOD_GLUCOSE_TEST.METER.LOCATION_CODE',
                'BLOOD_GLUCOSE_TEST.METER.PERSON_IN_CHARGE',

                'BLOOD_GLUCOSE_TEST.COLUMNS.TEST_DATE_TIME',
                'BLOOD_GLUCOSE_TEST.COLUMNS.METER_READING',

                'BLOOD_GLUCOSE_TEST.PAGINATION.OF',
                'BLOOD_GLUCOSE_TEST.PAGINATION.PAGE',
                'BLOOD_GLUCOSE_TEST.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.messages = {
                    noRegisteredMeter: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_METER'],
                    noStateIn: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER_IN']
                };

                vm.meterSection = {
                    serialNo: translations['BLOOD_GLUCOSE_TEST.METER.METER_SERIAL_NO'],
                    model: translations['BLOOD_GLUCOSE_TEST.METER.METER_MODEL'],
                    hospital: translations['BLOOD_GLUCOSE_TEST.METER.HOSPITAL'],
                    locationCode: translations['BLOOD_GLUCOSE_TEST.METER.LOCATION_CODE'],
                    personInCharge: translations['BLOOD_GLUCOSE_TEST.METER.PERSON_IN_CHARGE']
                };

                vm.columns = {
                    testDateTime: translations['BLOOD_GLUCOSE_TEST.COLUMNS.TEST_DATE_TIME'],
                    meterReading: translations['BLOOD_GLUCOSE_TEST.COLUMNS.METER_READING']
                };

                vm.paginationLabel = {
                    of: translations['BLOOD_GLUCOSE_TEST.PAGINATION.OF'],
                    page: translations['BLOOD_GLUCOSE_TEST.PAGINATION.PAGE'],
                    rowsPerPage: translations['BLOOD_GLUCOSE_TEST.PAGINATION.ROWS_PER_PAGE']
                };

            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToCSVEvent = $scope.$on('blood-glucose-test::exportToCSV', function () {
            exportToCSV();
        });

        var exportToExcelEvent = $scope.$on('blood-glucose-test::exportToExcel', function () {
            exportToExcel();
        });

        vm.$onDestroy = function() {
            exportToCSVEvent();
            exportToExcelEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.blood-glucose-test')
        .component('bloodGlucoseTestHospitalAdmin', {
            templateUrl: 'app/main/blood-glucose-test/hospital-admin/hospital-admin.html',
            controller: HospitalAdminController,
            controllerAs: 'vm',
            bindings: {
                hospital: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function HospitalAdminController($scope, msApi, localStorageService, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.meterColumns = [];
        vm.meters = [];
        vm.selectedMeter = null;
        vm.searchTerm = '';

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.pagination = {
            total:0,
            per_page: 10,
            current_page: 1
        };
        vm.sort = "tested_on";

        vm.loaded = false;
        vm.message = null;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMeterChanged = selectedMeterChanged;
        vm.getBloodGlucoseTests = getBloodGlucoseTests;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.evalMeterReading = evalMeterReading;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.message = vm.messages.selectMeter;
            getMeters();
        }

        function selectedMeterChanged() {
            if (vm.selectedMeter && vm.filterForm.$valid) {
                getBloodGlucoseTests();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getBloodGlucoseTests();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getBloodGlucoseTests();
            }
        }

        function getMeters() {
            var params = {
                hospital_id: vm.hospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getBloodGlucoseTests() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.selectedMeter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            vm.promise = msApi.request('blood-glucose-tests@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.pagination.total = response.blood_glucose_tests.total;
                    vm.bloodGlucoseTests = response.blood_glucose_tests.data;
                    vm.loaded = true;
                });
        }

        function exportToCSV() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.selectedMeter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('blood-glucose-tests@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge
                    });

                    data.push({
                        a: vm.selectedMeter.serial_no,
                        b: vm.selectedMeter.model_no,
                        c: vm.selectedMeter.location.hospital.name,
                        d: vm.selectedMeter.location.code,
                        e: vm.selectedMeter.location.person_in_charge
                    });

                    data.push({a: '', b: '', c: '', d: '', e: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.meterReading + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        c: '',
                        d: '',
                        e: ''
                    });

                    var bloodGlucoseTests = response.blood_glucose_tests;

                    _.map(bloodGlucoseTests, function (test) {
                        data.push({
                            a: moment(test.tested_on).format(),
                            b: vm.evalMeterReading(test),
                            c: '',
                            d: '',
                            e: ''
                        });
                    });

                    var timestamp = moment();
                    var filename = 'BloodGlucoseTestLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO CSV(?, {headers:false, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.selectedMeter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('blood-glucose-tests@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge
                    });

                    data.push({
                        a: vm.selectedMeter.serial_no,
                        b: vm.selectedMeter.model_no,
                        c: vm.selectedMeter.location.hospital.name,
                        d: vm.selectedMeter.location.code,
                        e: vm.selectedMeter.location.person_in_charge
                    });

                    data.push({a: '', b: '', c: '', d: '', e: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.meterReading + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        c: '',
                        d: '',
                        e: ''
                    });

                    var bloodGlucoseTests = response.blood_glucose_tests;

                    _.map(bloodGlucoseTests, function (test) {
                        data.push({
                            a: moment(test.tested_on).format(),
                            b: vm.evalMeterReading(test),
                            c: '',
                            d: '',
                            e: ''
                        });
                    });

                    var timestamp = moment();
                    var filename = 'BloodGlucoseTestLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO XLSX(?, {headers:false}) FROM ?',[filename, data]);
                });
        }

        function evalMeterReading(test) {
          if (test.is_high) {
            return "HIGH";
          }
          else if (test.is_high) {
            return "LOW";
          }

          return parseFloat(test.meter_reading).toFixed(1);
        }

        function translate() {
            return $translate([
                'BLOOD_GLUCOSE_TEST.TITLE',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_DATA_AVAILABLE',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_COUNTRY',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_STATE',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_HOSPITAL',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_METER',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_STATE_IN',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER_IN',

                'BLOOD_GLUCOSE_TEST.METER.METER_SERIAL_NO',
                'BLOOD_GLUCOSE_TEST.METER.METER_MODEL',
                'BLOOD_GLUCOSE_TEST.METER.HOSPITAL',
                'BLOOD_GLUCOSE_TEST.METER.LOCATION_CODE',
                'BLOOD_GLUCOSE_TEST.METER.PERSON_IN_CHARGE',

                'BLOOD_GLUCOSE_TEST.COLUMNS.TEST_DATE_TIME',
                'BLOOD_GLUCOSE_TEST.COLUMNS.METER_READING',

                'BLOOD_GLUCOSE_TEST.PAGINATION.OF',
                'BLOOD_GLUCOSE_TEST.PAGINATION.PAGE',
                'BLOOD_GLUCOSE_TEST.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.messages = {
                    noRegisteredMeter: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_METER'],
                    noStateIn: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER_IN']
                };

                vm.meterSection = {
                    serialNo: translations['BLOOD_GLUCOSE_TEST.METER.METER_SERIAL_NO'],
                    model: translations['BLOOD_GLUCOSE_TEST.METER.METER_MODEL'],
                    hospital: translations['BLOOD_GLUCOSE_TEST.METER.HOSPITAL'],
                    locationCode: translations['BLOOD_GLUCOSE_TEST.METER.LOCATION_CODE'],
                    personInCharge: translations['BLOOD_GLUCOSE_TEST.METER.PERSON_IN_CHARGE']
                };

                vm.columns = {
                    testDateTime: translations['BLOOD_GLUCOSE_TEST.COLUMNS.TEST_DATE_TIME'],
                    meterReading: translations['BLOOD_GLUCOSE_TEST.COLUMNS.METER_READING']
                };

                vm.paginationLabel = {
                    of: translations['BLOOD_GLUCOSE_TEST.PAGINATION.OF'],
                    page: translations['BLOOD_GLUCOSE_TEST.PAGINATION.PAGE'],
                    rowsPerPage: translations['BLOOD_GLUCOSE_TEST.PAGINATION.ROWS_PER_PAGE']
                };

            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToCSVEvent = $scope.$on('blood-glucose-test::exportToCSV', function () {
            exportToCSV();
        });

        var exportToExcelEvent = $scope.$on('blood-glucose-test::exportToExcel', function () {
            exportToExcel();
        });

        vm.$onDestroy = function() {
            exportToCSVEvent();
            exportToExcelEvent();
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('app.blood-glucose-test')
        .component('bloodGlucoseTestCountryAdmin', {
            templateUrl: 'app/main/blood-glucose-test/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                country: '<',
                allStates: '<',
                allHospitals: '<',
                loaded: '=',
                valid: '='
            }
        });

    /** @ngInject */
    function CountryAdminController($scope, msApi, localStorageService, $translate, $log) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.states = [];
        vm.hospitals = [];
        vm.meterColumns = [];
        vm.meters = [];

        vm.selectedState = null;
        vm.selectedHospital = null;
        vm.selectedMeter = null;
        vm.searchTerm = '';

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.pagination = {
            total:0,
            per_page: 10,
            current_page: 1
        };
        vm.sort = "tested_on";

        vm.loaded = false;
        vm.message = null;

        // Methods
        vm.$onInit = init;
        vm.selectedStateChanged = selectedStateChanged;
        vm.selectedHospitalChanged = selectedHospitalChanged;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMeterChanged = selectedMeterChanged;
        vm.getBloodGlucoseTests = getBloodGlucoseTests;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;
        vm.evalMeterReading = evalMeterReading;

        ////////////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            vm.message = vm.messages.selectState;
        }

        function selectedStateChanged() {
            if (vm.selectedState) {
                vm.hospitals =  _.sortBy(_.filter(vm.allHospitals, function (hospital) {
                    return (hospital.country === vm.country && hospital.state === vm.selectedState.code);
                }), 'name');

                if (vm.hospitals.length) {
                    vm.message = vm.messages.selectHospital;
                } else {
                    $translate('BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_HOSPITAL_IN', { state: vm.selectedState.name })
                        .then(function (translation) {
                            vm.message = translation;
                        });
                }
            } else {
                vm.hospitals = [];
            }

            vm.loaded = false;
            vm.selectedHospital = null;
            selectedHospitalChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedHospitalChanged() {
            if (vm.selectedHospital) {
                getMeters();
            } else {
                vm.meters = [];
            }

            vm.loaded = false;
            vm.selectedMeter = null;
            selectedMeterChanged();

            vm.filterForm.$setPristine();
            vm.filterForm.$setUntouched();
        }

        function selectedMeterChanged() {
            if (vm.selectedMeter && vm.filterForm.$valid) {
                getBloodGlucoseTests();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getBloodGlucoseTests();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getBloodGlucoseTests();
            }
        }

        function getMeters() {
            var params = {
                hospital_id: vm.selectedHospital.id
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        $translate('BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER_IN', { hospital: vm.selectedHospital.name })
                            .then(function (translation) {
                                vm.message = translation;
                            });
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getBloodGlucoseTests() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.selectedMeter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            vm.promise = msApi.request('blood-glucose-tests@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.pagination.total = response.blood_glucose_tests.total;
                    vm.bloodGlucoseTests = response.blood_glucose_tests.data;
                    vm.loaded = true;
                });
        }

        function exportToCSV() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.selectedMeter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('blood-glucose-tests@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge
                    });

                    data.push({
                        a: vm.selectedMeter.serial_no,
                        b: vm.selectedMeter.model_no,
                        c: vm.selectedMeter.location.hospital.name,
                        d: vm.selectedMeter.location.code,
                        e: vm.selectedMeter.location.person_in_charge
                    });

                    data.push({a: '', b: '', c: '', d: '', e: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.meterReading + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        c: '',
                        d: '',
                        e: ''
                    });

                    var bloodGlucoseTests = response.blood_glucose_tests;

                    _.map(bloodGlucoseTests, function (test) {
                        data.push({
                            a: moment(test.tested_on).format(),
                            b: vm.evalMeterReading(test),
                            c: '',
                            d: '',
                            e: ''
                        });
                    });

                    var timestamp = moment();
                    var filename = 'BloodGlucoseTestLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO CSV(?, {headers:false, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.selectedMeter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            msApi.request('blood-glucose-tests@get',
                params,
                // SUCCESS
                function (response) {
                    var data = [];

                    data.push({
                        a: vm.meterSection.serialNo,
                        b: vm.meterSection.model,
                        c: vm.meterSection.hospital,
                        d: vm.meterSection.locationCode,
                        e: vm.meterSection.personInCharge
                    });

                    data.push({
                        a: vm.selectedMeter.serial_no,
                        b: vm.selectedMeter.model_no,
                        c: vm.selectedMeter.location.hospital.name,
                        d: vm.selectedMeter.location.code,
                        e: vm.selectedMeter.location.person_in_charge
                    });

                    data.push({a: '', b: '', c: '', d: '', e: ''});

                    data.push({
                        a: vm.columns.testDateTime,
                        b: vm.columns.meterReading + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')',
                        c: '',
                        d: '',
                        e: ''
                    });

                    var bloodGlucoseTests = response.blood_glucose_tests;

                    _.map(bloodGlucoseTests, function (test) {
                        data.push({
                            a: moment(test.tested_on).format(),
                            b: vm.evalMeterReading(test),
                            c: '',
                            d: '',
                            e: ''
                        });
                    });

                    var timestamp = moment();
                    var filename = 'BloodGlucoseTestLogbook-' + timestamp.format('YMMDDHm');

                    alasql('SELECT * INTO XLSX(?, {headers:false}) FROM ?',[filename, data]);
                });
        }

        function evalMeterReading(test) {
          if (test.is_high) {
            return "HIGH";
          }
          else if (test.is_high) {
            return "LOW";
          }

          return parseFloat(test.meter_reading).toFixed(1);
        }

        function translate() {
            return $translate([
                'BLOOD_GLUCOSE_TEST.TITLE',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_DATA_AVAILABLE',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_COUNTRY',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_STATE',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_HOSPITAL',
                'BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_METER',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_STATE_IN',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER_IN',

                'BLOOD_GLUCOSE_TEST.METER.METER_SERIAL_NO',
                'BLOOD_GLUCOSE_TEST.METER.METER_MODEL',
                'BLOOD_GLUCOSE_TEST.METER.HOSPITAL',
                'BLOOD_GLUCOSE_TEST.METER.LOCATION_CODE',
                'BLOOD_GLUCOSE_TEST.METER.PERSON_IN_CHARGE',

                'BLOOD_GLUCOSE_TEST.COLUMNS.TEST_DATE_TIME',
                'BLOOD_GLUCOSE_TEST.COLUMNS.METER_READING',

                'BLOOD_GLUCOSE_TEST.PAGINATION.OF',
                'BLOOD_GLUCOSE_TEST.PAGINATION.PAGE',
                'BLOOD_GLUCOSE_TEST.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.messages = {
                    noRegisteredMeter: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_DATA_AVAILABLE'],
                    selectCountry: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_COUNTRY'],
                    selectState: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_STATE'],
                    selectHospital: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_HOSPITAL'],
                    selectMeter: translations['BLOOD_GLUCOSE_TEST.MESSAGES.SELECT_METER'],
                    noStateIn: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_STATE_IN'],
                    noRegisteredHospitalIn: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_HOSPITAL_IN'],
                    noRegisteredMeterIn: translations['BLOOD_GLUCOSE_TEST.MESSAGES.NO_REGISTERED_METER_IN']
                };

                vm.meterSection = {
                    serialNo: translations['BLOOD_GLUCOSE_TEST.METER.METER_SERIAL_NO'],
                    model: translations['BLOOD_GLUCOSE_TEST.METER.METER_MODEL'],
                    hospital: translations['BLOOD_GLUCOSE_TEST.METER.HOSPITAL'],
                    locationCode: translations['BLOOD_GLUCOSE_TEST.METER.LOCATION_CODE'],
                    personInCharge: translations['BLOOD_GLUCOSE_TEST.METER.PERSON_IN_CHARGE']
                };

                vm.columns = {
                    testDateTime: translations['BLOOD_GLUCOSE_TEST.COLUMNS.TEST_DATE_TIME'],
                    meterReading: translations['BLOOD_GLUCOSE_TEST.COLUMNS.METER_READING']
                };

                vm.paginationLabel = {
                    of: translations['BLOOD_GLUCOSE_TEST.PAGINATION.OF'],
                    page: translations['BLOOD_GLUCOSE_TEST.PAGINATION.PAGE'],
                    rowsPerPage: translations['BLOOD_GLUCOSE_TEST.PAGINATION.ROWS_PER_PAGE']
                };

            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });

        var exportToCSVEvent = $scope.$on('blood-glucose-test::exportToCSV', function () {
            exportToCSV();
        });

        var exportToExcelEvent = $scope.$on('blood-glucose-test::exportToExcel', function () {
            exportToExcel();
        });

        vm.$onDestroy = function() {
            exportToCSVEvent();
            exportToExcelEvent();
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.active-hospitals', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.active-hospitals', {
                url    : '/active-hospitals',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/active-hospitals/active-hospitals.html',
                        controller : 'ActiveHospitalsController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_global_admin', 'roche_country_admin', 'hospital_admin', 'hospital_operator']
                },
                resolve: {
                    statesData: function(msApi) {
                        return msApi.request('states@get');
                    },
                    hospitalsData: function (msApi, localStorageService) {
                        var user = localStorageService.get('user');
                        var role = user.role.name;

                        return msApi.request('hospitals@get', {
                            country: user.country
                        });
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/active-hospitals');

        // Api
        msApiProvider.register('states', ['/states']);
        msApiProvider.register('meters', ['/meters']);
        msApiProvider.register('active-hospitals', ['/hospitals/active']);

        msNavigationServiceProvider.saveItem('active-hospitals', {
            title    : 'Active Hospitals',
            icon     : 'icon-hospital',
            state    : 'app.active-hospitals',
            weight   : 27,
            translate: 'ACTIVE_HOSPITALS.NAV'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.active-hospitals')
        .component('activeHospitalsGlobalAdmin', {
            templateUrl: 'app/main/active-hospitals/global-admin/global-admin.html',
            controller: GlobalAdminController,
            controllerAs: 'vm',
            bindings: {
                allCountries: '<'
            }
        });

    /** @ngInject */
    function GlobalAdminController(msApi, localStorageService, $log) {
        var vm = this;

        // Data
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.activeHospitals = {};
        vm.loaded = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.getActiveHospitalCount = getActiveHospitalCount;

        ////////////////

        function init() {
            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            load();
        }

        function load() {
            getActiveHospitals();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getActiveHospitals();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getActiveHospitals();
            }
        }

        function getActiveHospitals() {
            return msApi.request('active-hospitals@get',
                {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format()
                },
                // SUCCESS
                function (response) {
                    vm.activeHospitals = {'all': 0};
                    angular.forEach(response.hospitals, function(hospital) {
                        if (!vm.activeHospitals[hospital.country]) {
                            vm.activeHospitals[hospital.country] = 0;
                        }
                        vm.activeHospitals[hospital.country]++;
                        vm.activeHospitals['all']++;
                    });

                    vm.loaded = true;
                });
        }

        function getActiveHospitalCount() {
            return Object.keys(vm.activeHospitals || {}).length;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.active-hospitals')
        .component('activeHospitalsCountryAdmin', {
            templateUrl: 'app/main/active-hospitals/country-admin/country-admin.html',
            controller: CountryAdminController,
            controllerAs: 'vm',
            bindings: {
                allStates: '<',
                country: '<'
            }
        });

    /** @ngInject */
    function CountryAdminController(msApi, $filter, $translate, localStorageService, $log) {
        var vm = this;

        // Data
        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.activeHospitals = {};
        vm.loaded = false;

        // Methods
        vm.$onInit = init;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.getActiveHospitalCount = getActiveHospitalCount;

        ////////////////

        function init() {
            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            load();
        }

        function load() {
            vm.states = _.sortBy(_.transform(vm.allStates[vm.country], function(result, value, key) {
                result.push({ code: key, name: value });
            }, []), 'name');

            getActiveHospitals();
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getActiveHospitals();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getActiveHospitals();
            }
        }

        function getActiveHospitals() {
            return msApi.request('active-hospitals@get',
                {
                    start_date: moment(vm.startDate).startOf('day').format(),
                    end_date: moment(vm.endDate).endOf('day').format(),
                    country: vm.country
                },
                // SUCCESS
                function (response) {
                    vm.activeHospitals = {'all': 0};
                    angular.forEach(response.hospitals, function(hospital) {
                        if (!vm.activeHospitals[hospital.state]) {
                            vm.activeHospitals[hospital.state] = 0;
                        }
                        vm.activeHospitals[hospital.state]++;
                        vm.activeHospitals['all']++;
                    });

                    vm.loaded = true;
                });
        }

        function getActiveHospitalCount() {
            return Object.keys(vm.activeHospitals || {}).length;
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.login', {
            url      : '/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-with-toolbar.html',
                    controller : 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                },
                'toolbar@app.login'   : {
                    templateUrl: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                    controller : 'ToolbarController as vm'
                }
            },
            onEnter: function(authManager, localStorageService, msApi, $state, CONFIG, $log) {
                if (authManager.isAuthenticated()) {
                    var user = localStorageService.get('user');

                    if (user.role.name === 'roche_global_admin') {
                        $state.go('app.country-admin', {}, {location: 'replace'});
                    } else if (user.role.name === 'roche_country_admin') {
                        $state.go('app.hospital', {}, {location: 'replace'});
                    } else if(user.role.name === 'hospital_admin'){
                        _.forEach(CONFIG.hospital_modules, function (module) {
                            if (_.indexOf(user.available_modules, module.name) > -1 && _.indexOf(module.forRoles, 'hospital_admin') > -1) {
                                $state.go(module.state, {}, {location: 'replace'});
                                return false;
                            }
                        });
                    } else if(user.role.name === 'hospital_operator'){
                        _.forEach(CONFIG.hospital_modules, function (module) {
                            if (_.indexOf(user.available_modules, module.name) > -1 && _.indexOf(module.forRoles, 'hospital_operator') > -1) {
                                $state.go(module.state);
                                return false;
                            }
                        });
                    }
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/login');

        // Api
        msApiProvider.register('auth.token', ['/auth/token']);
    }

})();

(function() {
  'use strict';

  angular
    .module('app.auth.login')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController(
    msApi,
    localStorageService,
    $state,
    toastService,
    $mdDialog,
    $document,
    CONFIG,
    $translate,
    $log
  ) {
    // Data
    var vm = this;
    vm.year = new Date().getFullYear();
    vm.remember_me = true;

    // Methods
    vm.submit = submit;
    vm.uploadMeterData = uploadMeterData;
    vm.termsOfUse = termsOfUse;

    init();

    //////////

    function init() {
      translate();
    }

    function submit() {
      msApi.request('auth.token@save', vm.form, function(response) {
        var token = response.token;
        var user = response.user;

        if (!vm.remember_me) {
          localStorageService.setStorageType('sessionStorage');
        } else {
          localStorageService.setStorageType('localStorage');
        }

        localStorageService.set('rememberMe', vm.remember_me, 'localStorage');

        localStorageService.set('token', token);
        localStorageService.set('user', user);

        var startDate = moment()
          .subtract(7, 'days')
          .toDate();
        var endDate = moment().toDate();

        localStorageService.set('startDate', startDate);
        localStorageService.set('endDate', endDate);

        toastService.show(vm.messages.greeting + user.name);

        if (user.is_default_password) {
          $state.go('app.update-password');
          return;
        }

        if (user.role.name === 'roche_global_admin') {
          $state.go('app.country-admin');
        } else if (user.role.name === 'roche_country_admin') {
          $state.go('app.hospital');
        } else if (user.role.name === 'hospital_admin') {
          _.forEach(CONFIG.hospital_modules, function(module) {
            if (_.indexOf(user.available_modules, module.name) > -1 && _.indexOf(module.forRoles, 'hospital_admin') > -1) {
              $state.go(module.state);
              return false;
            }
          });
        } else if (user.role.name === 'hospital_operator') {
          _.forEach(CONFIG.hospital_modules, function (module) {
              if (_.indexOf(module.forRoles, 'hospital_operator') > -1) {
                  $state.go(module.state);
                  return false;
              }
          });
        }
      });
    }

    function uploadMeterData() {
      $state.go('app.uploadPublic');
    }

    function termsOfUse(e) {
      showTermsOfUseDialog(e);
    }

    function showTermsOfUseDialog(e) {
      $mdDialog.show({
        controller: 'TermsOfUseDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/dialog/terms-of-use-dialog/terms-of-use-dialog.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true
      });
    }

    function translate() {
      $translate([
        'LOGIN.MESSAGES.GREETING',
        'LOGIN.MESSAGES.INVALID_CREDENTIALS',
        'LOGIN.MESSAGES.COULD_NOT_CREATE_TOKEN'
      ]).then(function(translations) {
        vm.messages = {
          greeting: translations['LOGIN.MESSAGES.GREETING'],
          invalidCredentials:
            translations['LOGIN.MESSAGES.INVALID_CREDENTIALS'],
          couldNotCreateToken:
            translations['LOGIN.MESSAGES.COULD_NOT_CREATE_TOKEN']
        };
      });
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'LocalStorageModule',
                'angular-jwt',
                'ngPassword',
                'ngclipboard',
                'md.data.table',
                'angularMoment',
                'chart.js',
                'angularLoad',
                'ngMaterialDatePicker'
            ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Dashboard',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.dashboard',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'dashboard',
                        '_path'      : 'apps.dashboard',
                        'uisref'     : 'app.dashboard',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '1px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '1px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.page.installer', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider)
    {
        // State
        $stateProvider.state('page.installer', {
            url      : '/installer',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-with-toolbar.html',
                    controller : 'PageController as vm'
                },
                'content@page.installer': {
                    templateUrl: 'app/page/installer/installer.html',
                    controller : 'InstallerController as vm'
                },
                'toolbar@page.installer'   : {
                    templateUrl: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                    controller : 'ToolbarController as vm'
                }
            },
            resolve: {
                installed: function(msApi, $state) {
                    return msApi.request('installer.installed@get',
                        {},
                        function (response) {
                            if (response.installed) {
                                return $state.go('app.login');
                            }
                        });
                }
            },
            bodyClass: 'installer'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/page/installer');

        // Api
        msApiProvider.register('installer', ['/installer']);
        msApiProvider.register('installer.installed', ['/installer/installed']);
        msApiProvider.register('installer.test', ['/installer/test']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.page.installer')
        .controller('InstallerController', InstallerController);

    /** @ngInject */
    function InstallerController($rootScope, msApi, $mdDialog, $document, $state, $timeout, $translate, $log)
    {
        // Data
        var vm = this;
        vm.year = new Date().getFullYear();
        vm.installer = null;

        vm.show = false;
        vm.installing = false;
        vm.testSuccess = false;
        vm.testErrorMessage = null;
        vm.installSuccess = false;
        vm.installErrorMessage = null;

        // Methods
        vm.install = install;
        vm.test = test;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {
            getInstaller().then(function() {
                $timeout( function(){
                    vm.show = true;
                }, 300);
            });
        }

        function test() {
            return msApi.request('installer.test@save',
                vm.form,
                // SUCCESS
                function (response) {
                    vm.testSuccess = response.success;
                    vm.testErrorMessage = null;
                },
                function (error) {
                    vm.testSuccess = false;
                    $timeout(function () {
                        $rootScope.loadingProgress = false;
                    }, 500);

                    if (error.status === 400) {
                        vm.testErrorMessage = {
                            message: error.data.message,
                            detail: error.data.detail
                        };
                    } else{
                        vm.testErrorMessage = {
                            message: $rootScope.messages.internalServerError,
                            detail: null
                        };
                    }

                });
        }

        function install() {
            vm.installing = true;

            return msApi.request('installer@save',
                vm.form,
                // SUCCESS
                function (response) {
                    if (response.installed) {
                        vm.installSuccess = response.installed;
                        vm.installErrorMessage = null;
                        showCompleteInstallDialog();
                    } else {
                        vm.installing = false;
                        vm.installSuccess = false;

                        vm.installErrorMessage = {
                            message: vm.messages.installFailed,
                            detail: null
                        };
                    }
                },
                function (error) {
                    $timeout(function ()
                    {
                        $rootScope.loadingProgress = false;
                    }, 500);

                    vm.installing = false;
                    vm.installSuccess = false;

                    if (error.status === 400) {
                        vm.installErrorMessage = {
                            message: error.data.message,
                            detail: error.data.detail
                        };

                    } else{
                        vm.installErrorMessage = $rootScope.messages.internalServerError;
                        vm.installErrorMessage = {
                            message: $rootScope.messages.internalServerError,
                            detail: null
                        };
                    }
                });
        }

        function showCompleteInstallDialog() {
            var dialogData = {
            };

            $mdDialog.show({
                controller: 'CompleteInstallDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/complete-install-dialog/complete-install-dialog.html',
                parent: angular.element($document.body),
                locals: {
                    dialogData: dialogData
                }
            }).then(function () {
                $state.go('app.login');
            });
        }

        function getInstaller() {
            return msApi.request('installer@get',
                {},
                // SUCCESS
                function (response) {
                    vm.installer = response;
                });
        }

        function translate() {
            return $translate([
                'INSTALLER.MESSAGES.INSTALL_FAILED'
            ]).then(function(translations) {
                vm.messages = {
                    installFailed: translations['INSTALLER.MESSAGES.INSTALL_FAILED']
                };
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.upload-meter-data', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.upload', {
                url    : '/upload',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/upload-meter-data/upload-meter-data.html',
                        controller : 'UploadMeterDataController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['hospital_admin', 'hospital_operator']
                }
            })
            .state('app.uploadPublic', {
                url : '/upload-ext',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-with-toolbar.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.uploadPublic': {
                        templateUrl: 'app/main/upload-meter-data/upload-meter-data-public.html',
                        controller : 'UploadMeterDataController as vm'
                    },
                    'toolbar@app.uploadPublic': {
                        templateUrl: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                        controller : 'ToolbarController as vm'
                    }
                },
                bodyClass: 'upload'
            })
            .state('app.testMeterConnection', {
                url : '/test-meter-connection',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-with-toolbar.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.testMeterConnection': {
                        templateUrl: 'app/main/upload-meter-data/upload-meter-data-test.html',
                        controller : 'UploadMeterDataController as vm'
                    },
                    'toolbar@app.testMeterConnection': {
                        templateUrl: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                        controller : 'ToolbarController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['roche_country_admin', 'hospital_admin']
                },
                bodyClass: 'upload'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/upload-meter-data');

        // Api
        msApiProvider.register('upload', ['/upload']);
        msApiProvider.register('upload.test', ['/upload/test']);

        msNavigationServiceProvider.saveItem('upload', {
            title    : 'Upload Meter Data',
            icon     : 'icon-custom-upload-meter-data',
            state    : 'app.upload',
            weight   : 29,
            translate: 'UPLOAD_METER_DATA.NAV'
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.upload-meter-data')
        .controller('UploadMeterDataController', UploadMeterDataController);

    /** @ngInject */
    function UploadMeterDataController(localStorageService, $state, $window, CONFIG, toastService, msApi, AccuChekUsb, $translate, $mdDialog, $document) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.isReadOnly = false;

        vm.accLib = null;
        vm.isMeterTimeOutOfSync = false;
        vm.meterInfo = null;
        vm.currentStep = 'CONNECT';
        vm.nextButton = {
            label: 'Connect',
            disabled: false
        };

        vm.labels = {
            connect: 'Connect',
            upload: 'Upload',
            close: 'Close'
        };

        vm.messages = {
            errorConnecting: 'Error connecting to meter',
            syncTimeConfirmTitle: '',
            syncTimeConfirm: ''
        };

        init();

        // Methods
        vm.updateNextButton = updateNextButton;
        vm.next = next;
        vm.connect = connect;
        vm.upload = upload;
        vm.reset = reset;
        vm.launchLegacyApp = launchLegacyApp;
        vm.loginPage = loginPage;
        //////////
        
        // Meter diagnostics data and methods
        vm.outputText = "";
        vm.logText = "";
        vm.testConnection = testConnection;
        vm.output = function(msg) {
          vm.outputText += msg + "\n";
        };
        vm.log = function(msg) {
          vm.logText += msg + "\n";
        };

        function init() {
            vm.user = localStorageService.get('user');
            vm.isReadOnly = vm.user && vm.user.hospitals && vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;

            translate().then(function () {
                vm.updateNextButton();
            });
        }

        function translate() {
            return $translate([
                'UPLOAD_METER_DATA.BUTTONS.CONNECT',
                'UPLOAD_METER_DATA.BUTTONS.UPLOAD',
                'UPLOAD_METER_DATA.BUTTONS.CLOSE',
                'UPLOAD_METER_DATA.MESSAGES.ERROR_CONNECTING',
                'UPLOAD_METER_DATA.MESSAGES.SYNC_TIME_CONFIRM_TITLE',
                'UPLOAD_METER_DATA.MESSAGES.SYNC_TIME_CONFIRM'
            ]).then(function (translations) {
                vm.labels.connect = translations['UPLOAD_METER_DATA.BUTTONS.CONNECT'];
                vm.labels.upload = translations['UPLOAD_METER_DATA.BUTTONS.UPLOAD'];
                vm.labels.close = translations['UPLOAD_METER_DATA.BUTTONS.CLOSE'];
                vm.messages.errorConnecting = translations['UPLOAD_METER_DATA.MESSAGES.ERROR_CONNECTING'];
                vm.messages.syncTimeConfirmTitle = translations['UPLOAD_METER_DATA.MESSAGES.SYNC_TIME_CONFIRM_TITLE'];
                vm.messages.syncTimeConfirm = translations['UPLOAD_METER_DATA.MESSAGES.SYNC_TIME_CONFIRM'];
            });
        }

        function updateNextButton() {
            switch (vm.currentStep) {
                case "CONNECT":
                case "ERROR_METER":
                    vm.nextButton.label = vm.labels.connect;
                    vm.nextButton.disabled = false;
                    break;

                case "CONFIRM":
                    vm.nextButton.label = vm.labels.upload;
                    vm.nextButton.disabled = false;
                    break;

                case "SUCCESS":
                    vm.nextButton.label = vm.labels.close;
                    vm.nextButton.disabled = false;
                    break;
            }
        }

        function next() {
            switch (vm.currentStep) {
                case "CONNECT":
                    connect();
                    break;

                case "ERROR_METER":
                    connect();
                    break;

                case "CONFIRM":
                    upload();
                    break;

                case "SUCCESS":
                    reset();
                    break;
            }
        }

        function connect() {
            vm.nextButton.disabled = true;
            vm.accLib = new AccuChekUsb();
            vm.accLib.connect()
                .then(function() {
                    return vm.accLib.getDeviceInfo();
                })
                .then(function (info) {
                    var deviceTime = info && info.deviceTime;
                    vm.isMeterTimeOutOfSync = deviceTime instanceof Date && !isNaN(deviceTime.getTime()) &&
                        Math.abs(new Date().getTime() - deviceTime.getTime()) > 15 * 60 * 1000; // 15 mins

                    return msApi.request('upload@get', {
                        apiKey: CONFIG.upload_meter_data_api_key,
                        meter: info.serialNumber
                    });
                })
                .then(function (response) {
                    vm.meterInfo = response;
                    vm.currentStep = "CONFIRM";
                    vm.updateNextButton();
                })
                .catch(function (err) {
                    if (err && err.status >= 400) {
                        // A toast error message will pop up on HTTP error.
                        vm.currentStep = "CONNECT";
                        vm.updateNextButton();
                    }
                    else {
                        // This is usually device USB connection error, which will not pop up toast message.
                        vm.currentStep = "ERROR_METER";
                        vm.updateNextButton();
                        toastService.error(vm.messages.errorConnecting);
                    }
                });
        }

        function upload() {
            vm.nextButton.disabled = true;

            var uploadPromise = null;
            if (!vm.isMeterTimeOutOfSync) {
                uploadPromise = vm.accLib.retrieveData();
            }
            else {
                uploadPromise = $mdDialog.show({
                    controller: 'ConfirmDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/dialog/confirm-dialog/confirm-dialog.html',
                    parent: angular.element($document.body),
                    locals: {
                        dialogData: {
                            title: vm.messages.syncTimeConfirmTitle,
                            message: vm.messages.syncTimeConfirm
                        }
                    }
                }).then(function () {
                    return vm.accLib.syncDeviceTime();
                }, function () {
                    return;
                }).then(function () {
                    return vm.accLib.retrieveData();
                });
            }

            uploadPromise
                .then(function (data) {
                    var threshold = 156;

                    if (vm.meterInfo.current_test_strip) {
                        threshold = 18 * (vm.meterInfo.current_test_strip.l1_max + vm.meterInfo.current_test_strip.l2_min) / 2;
                    } 
                    else if (vm.meterInfo.meter.model_no === "Accu-Chek Active") {
                        threshold = 104;
                    }

                    var blood_glucose_tests = data.bloodGlucoseData.map(function (item) {
                        return {
                            tested_on: item.dateTime.toISOString(),
                            meter_reading: item.value,
                            measurement_unit: "MG_PER_DL"
                        };
                    });

                    var quality_control_tests = data.controlSolutionData.map(function (item) {
                        return {
                            tested_on: item.dateTime.toISOString(),
                            meter_reading: item.value,
                            measurement_unit: "MG_PER_DL",
                            control_level: (item.value < threshold ? "Level 1" : "Level 2")
                        };
                    });

                    return msApi.request('upload@save', {
                        apiKey: CONFIG.upload_meter_data_api_key,
                        meter: vm.meterInfo.meter.serial_no,
                        blood_glucose_tests: blood_glucose_tests,
                        quality_control_tests: quality_control_tests
                    });
                })
                .then(function () {
                    vm.accLib.disconnect();
                    vm.currentStep = "SUCCESS";
                    vm.updateNextButton();                    
                })
                .catch(function (err) {
                    if (err && err.status >= 400) {
                        // A toast error message will pop up on HTTP error.
                        vm.currentStep = "CONFIRM";
                        vm.updateNextButton();
                    }
                    else {
                        // This is usually device USB connection error, which will not pop up toast message.
                        vm.currentStep = "ERROR_METER";
                        vm.updateNextButton();
                        toastService.error(vm.messages.errorConnecting);
                    }
                });
        }

        function reset() {
            vm.isMeterTimeOutOfSync = false;
            vm.meterInfo = null;
            vm.currentStep = 'CONNECT';
            vm.updateNextButton();
        }

        function launchLegacyApp() {
            $window.open(CONFIG.host + CONFIG.upload_meter_data_url, '_parent');
        }

        function loginPage() {            
            $state.go('app.login');
        }

        function testConnection() {
            var accLib = new AccuChekUsb();

            vm.outputText = "";
            vm.logText = "";

            vm.log("==== Starting Accu‑Chek USB communication ====");
            vm.log("Connecting to device...");
            vm.output("Connecting to device...");
            accLib.connect()
                .then(function() {
                    vm.log("Device connected.");
                    vm.output("Device connected");

                    vm.log("Retrieving device info...");
                    return accLib.getDeviceInfo();
                })
                .then(function(info) {
                    vm.log("Device Info:");
                    vm.log("  Serial Number: " + info.serialNumber);
                    vm.log("  Model: " + info.modelNumber);
                    vm.log("  Device Time: " + info.deviceTime);
                    vm.output("Device Info: " + info.modelNumber + " (S/N: " + info.serialNumber + ")");

                    vm.output("Test sync-ing device time...");
                    var localTime = new Date();
                    if (Math.abs(localTime - new Date(info.deviceTime)) >= 90000) {
                        vm.log("Device time out of sync. Syncing...");
                        return accLib.syncDeviceTime().then(function() {
                            vm.log("Device time synced.");
                            return info;
                        });
                    } else {
                        vm.log("Device time is in sync with local time.");
                        return info;
                    }
                })
                .then(function() {
                    vm.log("Retrieving meter data...");
                    vm.output("Test retrieving meter data...");
                    return accLib.retrieveData();
                })
                .then(function(data) {
                    vm.log(
                      "Retrieved " + data.bloodGlucoseData.length + " BG data entries, " +
                      data.controlSolutionData.length + " control tests"
                    );

                    vm.log("BG Data:");
                    data.bloodGlucoseData.forEach(function(rec) {
                      vm.log("  " + rec.dateTime.toISOString() + " - " + rec.value + " mg/dL");
                    });

                    vm.log("Control Tests:");
                    data.controlSolutionData.forEach(function(rec) {
                      vm.log("  " + rec.dateTime.toISOString() + " - " + rec.value + " mg/dL");
                    });

                    vm.log("Disconnecting device...");
                    vm.output("Test disconnecting device...");
                    return accLib.disconnect();
                })
                .then(function() {
                    vm.log("Device disconnected.");
                    vm.output("Test completed");
                    toastService.show("Test completed successfully. Report was sent to developer");
                })
                .catch(function(err) {
                    vm.log("Error: " + err.message);
                    vm.output("Test interrupted");
                    toastService.error("Test completed with errors. Report was sent to developer");
                })
                .finally(function() {
                    vm.log("==== Finalizing Accu‑Chek USB communication ====");
                    msApi.request('upload.test@save', { data: vm.logText });
                });

        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.test-strip-model')
        .controller('TestStripModelController', TestStripModelController);

    /** @ngInject */
    function TestStripModelController(msApi, $timeout, toastService, $mdDialog, $document, localStorageService, $translate, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.pagination = {
            total:0,
            per_page: 5,
            current_page: 1
        };
        vm.searchTerm = '';
        vm.sort = '-created_at';
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.testStripModels = [];

        vm.show = false;

        init();

        // Methods
        vm.create = create;
        vm.edit = edit;
        vm.getTestStripModels = getTestStripModels;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            translate()
                .then(load);
        }

        function load() {
            getTestStripModels().then(function() {
                $timeout( function(){
                    vm.show = true;
                }, 300);
            });
        }

        function create(e) {
            showTestStripModelFormDialog('create', null, e);
        }

        function edit(testStripModel, e) {
            showTestStripModelFormDialog('edit', angular.copy(testStripModel), e);
        }

        function showTestStripModelFormDialog(type, testStripModel, e) {
            var dialogData = {
                type: type,
                userDefinedMeasurementUnit: vm.user.preferred_measurement_unit,
                measurementUnits: vm.measurementUnits,
                testStripModel: testStripModel
            };

            $mdDialog.show({
                controller: 'TestStripModelFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/test-strip-model/test-strip-model-form/test-strip-model-form.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                }
            }).then(function (dialogResponse) {
                switch (dialogResponse.type) {
                    case 'create':
                        createTestStripModel(dialogResponse.testStripModel);
                        break;
                    case 'edit':
                        editTestStripModel(dialogResponse.testStripModel);
                        break;
                    case 'remove':
                        break;
                }
            });
        }

        function getTestStripModels() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                measurement_unit: vm.user.preferred_measurement_unit,
                search: searchTerm,
                sort: sort + ':' + order
            };

            vm.promise = msApi.request('test-strip-models@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.testStripModels = response.test_strip_models.data;
                    vm.pagination.total = response.test_strip_models.total;
                });

            return vm.promise;
        }

        function createTestStripModel(testStripModel) {
            return msApi.request('test-strip-models@save',
                testStripModel,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.created);
                    getTestStripModels();
                });
        }

        function editTestStripModel(testStripModel) {
            return msApi.request('test-strip-models.edit@update',
                testStripModel,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.updated);
                    getTestStripModels();
                });
        }

        function translate() {
            return $translate([
                'TEST_STRIP_MODEL.MESSAGES.CREATED',
                'TEST_STRIP_MODEL.MESSAGES.UPDATED',
                'TEST_STRIP_MODEL.PAGINATION.OF',
                'TEST_STRIP_MODEL.PAGINATION.PAGE',
                'TEST_STRIP_MODEL.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.messages = {
                    created: translations['TEST_STRIP_MODEL.MESSAGES.CREATED'],
                    updated: translations['TEST_STRIP_MODEL.MESSAGES.UPDATED']
                };

                vm.paginationLabel = {
                    of: translations['TEST_STRIP_MODEL.PAGINATION.OF'],
                    page: translations['TEST_STRIP_MODEL.PAGINATION.PAGE'],
                    rowsPerPage: translations['TEST_STRIP_MODEL.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.test-strip-consumption')
        .controller('TestStripConsumptionController', TestStripConsumptionController);

    /** @ngInject */
    function TestStripConsumptionController(countriesData, statesData, hospitalsData, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;
        vm.locationIds = [];
        vm.locations = [];

        vm.isReadOnly = false;

        init();

        // Methods

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            if (vm.role === 'hospital_operator') {
                vm.locations = vm.user.locations;
                vm.locationIds = _.map(vm.user.locations, 'id');
            }

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.test-strip')
        .controller('TestStripController', TestStripController);

    /** @ngInject */
    function TestStripController(countriesData, hospitalsData, $rootScope, msApi, $timeout, toastService, $mdDialog, $document, localStorageService, $q, $translate, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.countries = countriesData.countries;
        vm.hospitals = hospitalsData ? _.sortBy(hospitalsData.hospitals, 'name') : null;
        vm.selectedHospital = null;
        vm.isCountryAdmin = false;

        vm.pagination = {
            total:0,
            per_page: 5,
            current_page: 1
        };
        vm.searchTerm = '';
        vm.sort = "-expiry";
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.testStrips = [];

        vm.show = false;
        vm.isReadOnly = false;

        init();

        // Methods
        vm.create = create;
        vm.batchCreate = batchCreate;
        vm.edit = edit;
        vm.view = view;
        vm.getTestStrips = getTestStrips;
        vm.isExpired = isExpired;
        vm.exportToCSV = exportToCSV;
        vm.exportToExcel = exportToExcel;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            if (vm.user.role.name === 'roche_country_admin') {
                vm.isCountryAdmin = true;
            } else {
                vm.selectedHospital = vm.user.hospitals[0];
                vm.isReadOnly = vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
            }

            translate()
                .then(load);
        }

        function load() {
            getTestStrips().then(function() {
                $timeout( function(){
                    vm.show = true;
                }, 300);
            });
        }

        function create(e) {
            showTestStripFormDialog('create', false, null, e);
        }

        function batchCreate(e) {
            showBatchCreateTestStripsFormDialog(e);
        }

        function edit(testStrip, e) {
            showTestStripFormDialog('edit', false, angular.copy(testStrip), e);
        }

        function view(testStrip, e) {
            showTestStripFormDialog('view', true, angular.copy(testStrip), e);
        }

        function exportToCSV() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                country: vm.user.country,
                hospital_id: vm.selectedHospital ? vm.selectedHospital.id : null,
                measurement_unit: vm.user.preferred_measurement_unit,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('test-strips@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var data =  _.map(testStrips, function (testStrip) {
                        return {
                            lotNo: testStrip.lot_no,
                            modelName: testStrip.test_strip_model ? testStrip.test_strip_model.model_name : '',
                            l1Min: parseFloat(testStrip.l1_min).toFixed(1),
                            l1Max: parseFloat(testStrip.l1_max).toFixed(1),
                            l2Min: parseFloat(testStrip.l2_min).toFixed(1),
                            l2Max: parseFloat(testStrip.l2_max).toFixed(1),
                            expiry: moment(testStrip.expiry).format('YYYY-MM-DD'),
                            hospital: testStrip.hospital.name,
                            created: moment(testStrip.created_at).format()
                        };
                    });

                    var timestamp = moment();
                    var filename = 'TestStrips-' + timestamp.format('YMMDDHm');

                    alasql('SELECT lotNo AS [' + vm.columns.stripLot + '], ' +
                        'modelName AS [' + vm.columns.stripModel + '],' +
                        'l1Min AS [' + vm.columns.l1Min + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')' + '],' +
                        'l1Max AS [' + vm.columns.l1Max + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')' + '],' +
                        'l2Min AS [' + vm.columns.l2Min + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')' + '],' +
                        'l2Max AS [' + vm.columns.l2Max + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')' + '],' +
                        'expiry AS [' + vm.columns.stripExpiry + '], ' +
                        'hospital AS [' + vm.columns.hospital + '], ' +
                        'created AS [' + vm.columns.created + '] ' +
                        'INTO CSV(?, {headers:true, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                country: vm.user.country,
                hospital_id: vm.selectedHospital ? vm.selectedHospital.id : null,
                measurement_unit: vm.user.preferred_measurement_unit,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('test-strips@get',
                params,
                // SUCCESS
                function (response) {
                    var testStrips = response.test_strips;
                    var data =  _.map(testStrips, function (testStrip) {
                        return {
                            lotNo: testStrip.lot_no,
                            modelName: testStrip.test_strip_model ? testStrip.test_strip_model.model_name : '',
                            l1Min: testStrip.l1_min.toFixed(1),
                            l1Max: testStrip.l1_max.toFixed(1),
                            l2Min: testStrip.l2_min.toFixed(1),
                            l2Max: testStrip.l2_max.toFixed(1),
                            expiry: moment(testStrip.expiry).format('YYYY-MM-DD'),
                            hospital: testStrip.hospital.name,
                            created: moment(testStrip.created_at).format()
                        };
                    });

                    var timestamp = moment();
                    var filename = 'TestStrips-' + timestamp.format('YMMDDHm');

                    alasql('SELECT lotNo AS [' + vm.columns.stripLot + '], ' +
                        'modelName AS [' + vm.columns.stripModel + '],' +
                        'l1Min AS [' + vm.columns.l1Min + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')' + '],' +
                        'l1Max AS [' + vm.columns.l1Max + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')' + '],' +
                        'l2Min AS [' + vm.columns.l2Min + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')' + '],' +
                        'l2Max AS [' + vm.columns.l2Max + ' (' + vm.measurementUnits[vm.user.preferred_measurement_unit] + ')' + '],' +
                        'expiry AS [' + vm.columns.stripExpiry + '], ' +
                        'hospital AS [' + vm.columns.hospital + '], ' +
                        'created AS [' + vm.columns.created + '] ' +
                        'INTO XLSX(?, {headers:true}) FROM ?',[filename, data]);
                });
        }

        function showTestStripFormDialog(type, isReadOnly, testStrip, e) {
            var dialogData = {
                type: type,
                isCountryAdmin: vm.isCountryAdmin,
                hospitals: vm.isCountryAdmin ? _.filter(vm.hospitals, function (hospital) {
                    return !(!isReadOnly && hospital.cloud_link && hospital.cloud_link.is_cloud_link_enabled);
                }) : vm.user.hospitals,
                userDefinedMeasurementUnit: vm.user.preferred_measurement_unit,
                measurementUnits: vm.measurementUnits,
                testStrip: testStrip,
                isReadOnly: isReadOnly
            };

            $mdDialog.show({
                controller: 'TestStripFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/test-strip/test-strip-form/test-strip-form.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        if (testStrip && testStrip.test_strip_model && testStrip.test_strip_model.hospital_id) {
                            return {
                                test_strip_models: [testStrip.test_strip_model]
                            };
                        } else {
                            return msApi.request('test-strip-models@get');
                        }
                    }
                }
            }).then(function (dialogResponse) {
                switch (dialogResponse.type) {
                    case 'create':
                        createTestStrip(dialogResponse.testStrip);
                        break;
                    case 'edit':
                        editTestStrip(dialogResponse.testStrip);
                        break;
                    case 'remove':
                        break;
                }
            });
        }

        function showBatchCreateTestStripsFormDialog(e) {
            var dialogData = {
                hospitals: _.filter(vm.hospitals, function (hospital) {
                    return !(hospital.cloud_link && hospital.cloud_link.is_cloud_link_enabled);
                }),
                userDefinedMeasurementUnit: vm.user.preferred_measurement_unit,
                measurementUnits: vm.measurementUnits
            };

            $mdDialog.show({
                controller: 'BatchCreateTestStripsFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/test-strip/batch-create-test-strips-form/batch-create-test-strips-form.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        return msApi.request('test-strip-models@get');
                    }
                }
            }).then(function (dialogResponse) {
                batchCreateTestStrips(dialogResponse.testStrips)
                    .then(function (response) {
                            toastService.show(vm.messages.batchCreated);
                            getTestStrips();
                        },
                        function(error) {

                            $timeout(function ()
                            {
                                $rootScope.loadingProgress = false;
                            }, 500);

                            toastService.error(vm.messages.batchError);
                            getTestStrips();
                        });
            });
        }

        function getTestStrips() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                country: vm.user.country,
                hospital_id: vm.selectedHospital ? vm.selectedHospital.id : null,
                measurement_unit: vm.user.preferred_measurement_unit,
                search: searchTerm,
                sort: sort + ':' + order
            };

            vm.promise = msApi.request('test-strips@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.testStrips = response.test_strips.data;
                    vm.pagination.total = response.test_strips.total;
                });

            return vm.promise;
        }

        function isExpired(testStrip) {
            return moment().isAfter(testStrip.expiry);
        }

        function createTestStrip(testStrip) {
            return msApi.request('test-strips@save',
                testStrip,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.created);
                    getTestStrips();
                });
        }

        function editTestStrip(testStrip) {
            return msApi.request('test-strips.edit@update',
                testStrip,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.updated);
                    getTestStrips();
                });
        }

        function batchCreateTestStrips(testStrips) {
            var promises = [];

            for (var i = 0; i < testStrips.length; i++) {
                (function(index) {
                    var testStrip = testStrips[index];
                    var curPromise = msApi.request('test-strips@save',
                        testStrip,
                        // SUCCESS
                        function (response) {
                            return response;
                        },
                        // Error
                        function (error) {
                            return error;
                        });
                    promises.push(curPromise);
                })(i);
            }

            return $q.all(promises);
        }

        function translate() {
            return $translate([
                'TEST_STRIP.COLUMNS.STRIP_LOT',
                'TEST_STRIP.COLUMNS.STRIP_MODEL',
                'TEST_STRIP.COLUMNS.L1_MIN',
                'TEST_STRIP.COLUMNS.L1_MAX',
                'TEST_STRIP.COLUMNS.L2_MIN',
                'TEST_STRIP.COLUMNS.L2_MAX',
                'TEST_STRIP.COLUMNS.STRIP_EXPIRY',
                'TEST_STRIP.COLUMNS.HOSPITAL',
                'TEST_STRIP.COLUMNS.CREATED',
                'TEST_STRIP.MESSAGES.CREATED',
                'TEST_STRIP.MESSAGES.UPDATED',
                'TEST_STRIP.MESSAGES.BATCH_CREATED',
                'TEST_STRIP.MESSAGES.BATCH_ERROR',
                'TEST_STRIP.PAGINATION.OF',
                'TEST_STRIP.PAGINATION.PAGE',
                'TEST_STRIP.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.columns = {
                    stripLot: translations['TEST_STRIP.COLUMNS.STRIP_LOT'],
                    stripModel: translations['TEST_STRIP.COLUMNS.STRIP_MODEL'],
                    l1Min: translations['TEST_STRIP.COLUMNS.L1_MIN'],
                    l1Max: translations['TEST_STRIP.COLUMNS.L1_MAX'],
                    l2Min: translations['TEST_STRIP.COLUMNS.L2_MIN'],
                    l2Max: translations['TEST_STRIP.COLUMNS.L2_MAX'],
                    stripExpiry: translations['TEST_STRIP.COLUMNS.STRIP_EXPIRY'],
                    hospital: translations['TEST_STRIP.COLUMNS.HOSPITAL'],
                    created: translations['TEST_STRIP.COLUMNS.CREATED']
                };

                vm.messages = {
                    created: translations['TEST_STRIP.MESSAGES.CREATED'],
                    updated: translations['TEST_STRIP.MESSAGES.UPDATED'],
                    batchCreated: translations['TEST_STRIP.MESSAGES.BATCH_CREATED'],
                    batchError: translations['TEST_STRIP.MESSAGES.BATCH_ERROR']
                };

                vm.paginationLabel = {
                    of: translations['TEST_STRIP.PAGINATION.OF'],
                    page: translations['TEST_STRIP.PAGINATION.PAGE'],
                    rowsPerPage: translations['TEST_STRIP.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.send-data', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.send-data', {
                url    : '/send-data',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/send-data/send-data.html',
                        controller : 'SendDataController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['hospital_admin']
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/send-data');

        // Api
        msApiProvider.register('profile.settings', ['/profile/settings']);
        msApiProvider.register('hospitals.hospital-data', ['/hospitals/hospital_data']);

        msNavigationServiceProvider.saveItem('send-data', {
            title    : 'Send Data to Cloud Server',
            icon     : 'icon-cloud-upload',
            state    : 'app.send-data',
            weight   : 32,
            translate: 'SEND_DATA.NAV'
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.send-data')
        .controller('SendDataController', SendDataController);

    /** @ngInject */
    function SendDataController($timeout, $rootScope, api, msApi, toastService, localStorageService, $mdDialog, $document, $translate, CONFIG, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.cloudLink = null;
        vm.connected = false;
        vm.showSendData = false;
        vm.errorConnect = false;
        vm.sending = false;

        init();

        // Methods
        vm.sendData = sendData;
        vm.enterCloudShareKey = enterCloudShareKey;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            translate()
                .then(getCloudLink);
        }

        function sendData() {
            if(vm.cloudLink) {
                $rootScope.loadingProgress = true;
                vm.sending = true;

                return getHospitalData()
                    .then(function(response) {
                        var hospitalData = response.hospital_data;
                        return sendHospitalData(hospitalData);
                    });
            }
        }

        function sendHospitalData(hospitalData) {
            return api.sendData()
                .save({
                        cloud_link_key: vm.cloudLink.cloud_link_key,
                        hospital_data: hospitalData
                    },
                    success,
                    error
                ).$promise.finally(last);

            function success(response){
                if (!response.cloud_link.is_cloud_link_enabled || response.cloud_link.is_revoked) {
                    toastService.error(vm.messages.invalidKey);
                    vm.showSendData = false;
                } else {
                    vm.cloudLink = response.cloud_link;
                }
            }

            function error(response){
                if (response.status === 422) {
                    toastService.error(vm.messages.invalidKey);
                    vm.showSendData = false;
                } else {
                    toastService.error(vm.messages.errorSending);

                    if(response.status !== 500) {
                        vm.errorConnect = true;
                    }
                }
            }

            function last(){
                $timeout(function ()
                {
                    $rootScope.loadingProgress = false;
                    vm.sending = false;
                }, 500);
            }
        }

        function getHospitalData() {
            var params = {
                hospital_id: vm.user.hospitals[0].id
            };

            return msApi.request('hospitals.hospital-data@get',
                params,
                // SUCCESS
                function (response) {
                    return response;
                });
        }

        function enterCloudShareKey(e) {
            var dialogData = {
            };

            $mdDialog.show({
                controller: 'EnterCloudShareKeyDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/enter-cloud-share-key-dialog/enter-cloud-share-key-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    dialogData: dialogData
                }
            }).then(function (dialogResponse) {
                vm.cloudLink = dialogResponse.cloudLink;
                vm.showSendData = true;
                changeUserCloudShareKey(vm.cloudLink);
            });
        }

        function changeUserCloudShareKey(cloudLink) {
            return msApi.request('profile.settings@save',
                {
                    cloud_link_key: cloudLink.cloud_link_key
                },
                // SUCCESS
                function (response) {
                    var user = response.user;
                    localStorageService.set('user', user);
                });
        }

        function getCloudLink() {
            $rootScope.loadingProgress = true;

            return api.getCloudLink()
                .get({
                        cloud_link_key: vm.user.cloud_link_key
                    },
                    success,
                    error
                ).$promise.finally(last);

            function success(response){
                if (!response.cloud_link.is_cloud_link_enabled || response.cloud_link.is_revoked) {
                    toastService.error(vm.messages.invalidKey);
                } else {
                    vm.cloudLink = response.cloud_link;
                    vm.showSendData = true;
                }
            }

            function error(response){
                if (response.status === 422) {
                    if(vm.user.cloud_link_key) {
                        toastService.error(vm.messages.invalidKey);
                    }
                } else {
                    toastService.error(vm.messages.errorConnecting);
                    vm.errorConnect = true;
                }
            }

            function last(){
                $timeout(function ()
                {
                    $rootScope.loadingProgress = false;
                    vm.connected = true;
                }, 500);
            }
        }

        function translate() {
            return $translate([
                'SEND_DATA.KEY_INVALID_MESSAGE',
                'SEND_DATA.ERROR_CONNECTING_MESSAGE',
                'SEND_DATA.ERROR_SENDING_MESSAGE'
            ]).then(function(translations) {
                vm.messages = {
                    invalidKey: translations['SEND_DATA.KEY_INVALID_MESSAGE'],
                    errorConnecting: translations['SEND_DATA.ERROR_CONNECTING_MESSAGE'],
                    errorSending: translations['SEND_DATA.ERROR_SENDING_MESSAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sample', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.sample', {
                url    : '/sample',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/sample/sample.html',
                        controller : 'SampleController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sample');

        // Api

        // Navigation
        msNavigationServiceProvider.saveItem('fuse', {
            title : 'SAMPLE',
            group : true,
            weight: 1,
            hidden: function() {return true}
        });

        msNavigationServiceProvider.saveItem('fuse.sample', {
            title    : 'Sample',
            icon     : 'icon-tile-four',
            state    : 'app.sample',
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'SAMPLE.SAMPLE_NAV',
            weight   : 1,
            hidden: function() {return true}
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.sample')
        .controller('SampleController', SampleController);

    /** @ngInject */
    function SampleController()
    {
        var vm = this;

        // Data
        vm.helloText = 'Hello';

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.meter')
        .controller('MeterController', MeterController);

    /** @ngInject */
    function MeterController(countriesData, hospitalsData, msApi, $timeout, toastService, $mdDialog, $document, localStorageService, $translate, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.countries = countriesData.countries;
        vm.hospitals = hospitalsData ? _.sortBy(hospitalsData.hospitals, 'name') : null;
        vm.selectedHospital = null;
        vm.isCountryAdmin = false;

        vm.pagination = {
            total:0,
            per_page: 5,
            current_page: 1
        };
        vm.searchTerm = '';
        vm.sort = "-meters.created_at";
        vm.meters = [];
        vm.overview = null;

        vm.show = false;
        vm.isReadOnly = false;

        init();

        // Methods
        vm.create = create;
        vm.edit = edit;
        vm.view = view;
        vm.archive = archive;
        vm.getMeters = getMeters;
        vm.exportToCSV = exportToCSV;
        vm.exportToExcel = exportToExcel;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            if (vm.user.role.name === 'roche_country_admin') {
                vm.isCountryAdmin = true;
            } else {
                vm.selectedHospital = vm.user.hospitals[0];
                vm.isReadOnly = vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
            }

            translate()
                .then(load);

        }

        function load() {
            getMeters().then(function() {
                $timeout( function(){
                    vm.show = true;
                }, 300);
            });
        }

        function create(e) {
            showMeterFormDialog('create', false, null, e);
        }

        function edit(meter, e) {
            showMeterFormDialog('edit', false, angular.copy(meter), e);
        }

        function view(meter, e) {
            showMeterFormDialog('view', true, angular.copy(meter), e);
        }

        function archive(meter, e) {
            $mdDialog.show({
                controller: 'ConfirmDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/confirm-dialog/confirm-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                locals: {
                    dialogData: {
                      title: 'Warning',
                      message: vm.messages.confirm_archive
                    }
                }
            }).then(function (dialogResponse) {
                return msApi.request('meters.archive@delete', {
                        id: meter.id
                    },
                    // OK
                    function () {
                        toastService.show(vm.messages.archived);
                        getMeters();
                    });
            });
        }

        function exportToCSV() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                country: vm.user.country,
                hospital_id: vm.selectedHospital ? vm.selectedHospital.id : null,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    var data =  _.map(meters, function (meter) {
                        return {
                            modelNo: meter.model_no,
                            serialNo: meter.serial_no,
                            locationCode: meter.location.code,
                            hospital: meter.location.hospital.name,
                            created: moment(meter.created_at).format(),
                            status: vm.status[meter.status]
                        };
                    });

                    var timestamp = moment();
                    var filename = 'Meters-' + timestamp.format('YMMDDHm');

                    alasql('SELECT modelNo AS [' + vm.columns.meterModel + '], ' +
                        'serialNo AS [' + vm.columns.serialNo + '],' +
                        'locationCode AS [' + vm.columns.locationCode + '],' +
                        'hospital AS [' + vm.columns.hospital + '],' +
                        'created AS [' + vm.columns.created + '], ' +
                        'status AS [' + vm.columns.status + '] ' +
                        'INTO CSV(?, {headers:true, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                country: vm.user.country,
                hospital_id: vm.selectedHospital ? vm.selectedHospital.id : null,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    var data =  _.map(meters, function (meter) {
                        return {
                            modelNo: meter.model_no,
                            serialNo: meter.serial_no,
                            locationCode: meter.location.code,
                            hospital: meter.location.hospital.name,
                            created: moment(meter.created_at).format(),
                            status: vm.status[meter.status]
                        };
                    });

                    var timestamp = moment();
                    var filename = 'Meters-' + timestamp.format('YMMDDHm');

                    alasql('SELECT modelNo AS [' + vm.columns.meterModel + '], ' +
                        'serialNo AS [' + vm.columns.serialNo + '],' +
                        'locationCode AS [' + vm.columns.locationCode + '],' +
                        'hospital AS [' + vm.columns.hospital + '],' +
                        'created AS [' + vm.columns.created + '], ' +
                        'status AS [' + vm.columns.status + '] ' +
                        'INTO XLSX(?, {headers:true}) FROM ?',[filename, data]);
                });
        }

        function showMeterFormDialog(type, isReadOnly, meter, e) {
            var dialogData = {
                type: type,
                isCountryAdmin: vm.isCountryAdmin,
                hospitals: vm.isCountryAdmin ? _.filter(vm.hospitals, function (hospital) {
                    return !(!isReadOnly && hospital.cloud_link && hospital.cloud_link.is_cloud_link_enabled);
                }) : vm.user.hospitals,
                meter: meter,
                isReadOnly: isReadOnly
            };

            $mdDialog.show({
                controller: 'MeterFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/meter/meter-form/meter-form.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        return msApi.request('locations@get', {
                            country: vm.user.country,
                            hospital_id: !vm.isCountryAdmin ? vm.user.hospitals[0].id: null
                        });
                    }
                }
            }).then(function (dialogResponse) {
                switch (dialogResponse.type) {
                    case 'create':
                        createMeter(dialogResponse.meter);
                        break;

                    case 'edit':
                        editMeter(dialogResponse.meter);
                        break;

                    case 'remove':
                        break;
                }
            });
        }

        function getMeters() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                country: vm.user.country,
                hospital_id: vm.selectedHospital ? vm.selectedHospital.id : null,
                search: searchTerm,
                sort: sort + ':' + order
            };

            vm.promise = msApi.request('meters@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.meters = response.meters.data;
                    vm.pagination.total = response.meters.total;
                    vm.overview = response.overview;
                });

            return vm.promise;
        }

        function createMeter(meter) {
            return msApi.request('meters@save',
                meter,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.created);
                    getMeters();
                });
        }

        function editMeter(meter) {
            return msApi.request('meters.edit@update',
                meter,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.updated);
                    getMeters();
                });
        }

        function translate() {
            return $translate([
                'METER.COLUMNS.METER_MODEL',
                'METER.COLUMNS.SERIAL_NO',
                'METER.COLUMNS.LOCATION_CODE',
                'METER.COLUMNS.HOSPITAL',
                'METER.COLUMNS.STATUS',
                'METER.COLUMNS.CREATED',
                'METER.COLUMNS.ARCHIVED',
                'METER.ACTIVE',
                'METER.INACTIVE',
                'METER.MESSAGES.CREATED',
                'METER.MESSAGES.UPDATED',
                'METER.MESSAGES.ARCHIVED',
                'METER.MESSAGES.CONFIRM_ARCHIVE',
                'METER.PAGINATION.OF',
                'METER.PAGINATION.PAGE',
                'METER.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.columns = {
                    meterModel: translations['METER.COLUMNS.METER_MODEL'],
                    serialNo: translations['METER.COLUMNS.SERIAL_NO'],
                    locationCode: translations['METER.COLUMNS.LOCATION_CODE'],
                    hospital: translations['METER.COLUMNS.HOSPITAL'],
                    status: translations['METER.COLUMNS.STATUS'],
                    created: translations['METER.COLUMNS.CREATED']
                };

                vm.status = {
                    active: translations['METER.ACTIVE'],
                    inactive: translations['METER.INACTIVE']
                };

                vm.messages = {
                    created: translations['METER.MESSAGES.CREATED'],
                    updated: translations['METER.MESSAGES.UPDATED'],
                    archived: translations['METER.MESSAGES.ARCHIVED'],
                    confirm_archive: translations['METER.MESSAGES.CONFIRM_ARCHIVE']
                };

                vm.paginationLabel = {
                    of: translations['METER.PAGINATION.OF'],
                    page: translations['METER.PAGINATION.PAGE'],
                    rowsPerPage: translations['METER.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.manual-qc-data')
        .controller('ManualQcDataController', ManualQcDataController);

    /** @ngInject */
    function ManualQcDataController($scope, msApi, toastService, $mdDialog, $document, localStorageService, $mdSelect, $filter, $translate) {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.meterColumns = [];
        vm.meters = [];
        vm.selectedMeter = null;
        vm.searchTerm = '';

        vm.startDate = moment().subtract(7, 'days').toDate();
        vm.endDate = moment().toDate();
        vm.minEndDate = vm.startDate;

        vm.pagination = {
            total:0,
            per_page: 10,
            current_page: 1
        };
        vm.sort = "tested_on";
        vm.qcDatas = [];

        vm.loaded = false;
        vm.message = null;

        // Methods
        vm.$onInit = init;
        vm.create = create;
        vm.close = close;
        vm.startDateChanged = startDateChanged;
        vm.endDateChanged = endDateChanged;
        vm.selectedMeterChanged = selectedMeterChanged;
        vm.getManualQcData = getManualQcData;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            var startDate = localStorageService.get('startDate');
            var endDate = localStorageService.get('endDate');

            if (startDate && endDate) {
                vm.startDate = new Date(startDate);
                vm.endDate = new Date(endDate);
                vm.minEndDate = vm.startDate;
            }

            translate()
                .then(load);
        }

        function load() {
            vm.message = vm.messages.selectMeter;
            getMeters();
        }

        function create(e) {
            var dialogData = {
                defaultMeasurementUnit: vm.user.preferred_measurement_unit
            };

            $mdDialog.show({
                controller: 'ManualQcDataFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/manual-qc-data/manual-qc-data-form/manual-qc-data-form.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        var locationIds = _.map(vm.user.locations, 'id');
                        var params = {
                            hospital_id: vm.user.hospitals[0].id,
                            'location_ids[]': locationIds
                        };

                        return msApi.request('meters@get',
                            params,
                            // SUCCESS
                            function (response) {
                                var meters = response.meters;
                                vm.meters = meters;
                            });
                    }
                }
            }).then(function (dialogResponse) {
                msApi.request('quality_control_tests.manual_qc_data@save',{
                        data: dialogResponse.qcData
                    },
                    // SUCCESS
                    function (response) {
                        toastService.show(vm.messages.saved);

                        if (_.some(response.quality_control_tests, ['meter_id', vm.selectedMeter.id])) {
                            getManualQcData();
                        }
                    }
                );
            });
        }

        function close() {
            $mdSelect.hide();
        }

        function selectedMeterChanged() {
            if (vm.selectedMeter && vm.filterForm.$valid) {
                getManualQcData();
            }
        }

        function startDateChanged() {
            if (vm.startDate) {
                vm.minEndDate = vm.startDate;
                vm.endDate = moment(vm.endDate).isBefore(vm.minEndDate) ? vm.minEndDate : vm.endDate;

                localStorageService.set('startDate', vm.startDate);
                localStorageService.set('endDate', vm.endDate);
            }

            if(vm.filterForm.$valid) {
                getManualQcData();
            }
        }

        function endDateChanged() {
            localStorageService.set('endDate', vm.endDate);

            if(vm.filterForm.$valid) {
                getManualQcData();
            }
        }

        function getMeters() {
            var locationIds = _.map(vm.user.locations, 'id');
            var params = {
                hospital_id: vm.user.hospitals[0].id,
                'location_ids[]': locationIds
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getManualQcData() {
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                start_date: moment(vm.startDate).startOf('day').format(),
                end_date: moment(vm.endDate).endOf('day').format(),
                meter_id: vm.selectedMeter.id,
                sort: sort + ':' + order,
                measurement_unit: vm.user.preferred_measurement_unit
            };

            vm.promise = msApi.request('quality_control_tests.manual_qc_data@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.pagination.total = response.quality_control_tests.total;
                    vm.qcDatas = response.quality_control_tests.data;
                    vm.loaded = true;
                });
        }

        function translate() {
            return $translate([
                'MANUAL_QC_DATA.TITLE',
                'MANUAL_QC_DATA.MESSAGES.NO_REGISTERED_METER',
                'MANUAL_QC_DATA.MESSAGES.NO_DATA_AVAILABLE',
                'MANUAL_QC_DATA.MESSAGES.SELECT_METER',
                'MANUAL_QC_DATA.MESSAGES.NO_STATE_IN',
                'MANUAL_QC_DATA.MESSAGES.NO_REGISTERED_HOSPITAL_IN',
                'MANUAL_QC_DATA.MESSAGES.NO_REGISTERED_METER_IN',

                'MANUAL_QC_DATA.METER.METER_MODEL',
                'MANUAL_QC_DATA.METER.HOSPITAL',
                'MANUAL_QC_DATA.METER.LOCATION_CODE',
                'MANUAL_QC_DATA.METER.PERSON_IN_CHARGE',

                'MANUAL_QC_DATA.COLUMNS.TEST_DATE_TIME',
                'MANUAL_QC_DATA.COLUMNS.CONTROL_TYPE',
                'MANUAL_QC_DATA.COLUMNS.QC_VALUE',
                'MANUAL_QC_DATA.COLUMNS.STATUS',

                'MANUAL_QC_DATA.PAGINATION.OF',
                'MANUAL_QC_DATA.PAGINATION.PAGE',
                'MANUAL_QC_DATA.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.messages = {
                    saved: translations['MANUAL_QC_DATA.MESSAGES.SAVED'],
                    errorSaving: translations['MANUAL_QC_DATA.MESSAGES.ERROR_SAVING'],
                    noRegisteredMeter: translations['MANUAL_QC_DATA.MESSAGES.NO_REGISTERED_METER'],
                    noDataAvailable: translations['MANUAL_QC_DATA.MESSAGES.NO_DATA_AVAILABLE'],
                    selectMeter: translations['MANUAL_QC_DATA.MESSAGES.SELECT_METER'],
                    noRegisteredMeterIn: translations['MANUAL_QC_DATA.MESSAGES.NO_REGISTERED_METER_IN']
                };

                vm.meterSection = {
                    model: translations['MANUAL_QC_DATA.METER.METER_MODEL'],
                    hospital: translations['MANUAL_QC_DATA.METER.HOSPITAL'],
                    locationCode: translations['MANUAL_QC_DATA.METER.LOCATION_CODE'],
                    personInCharge: translations['MANUAL_QC_DATA.METER.PERSON_IN_CHARGE']
                };

                vm.columns = {
                    testDateTime: translations['MANUAL_QC_DATA.COLUMNS.TEST_DATE_TIME'],
                    controlType: translations['MANUAL_QC_DATA.COLUMNS.CONTROL_TYPE'],
                    qcValue: translations['MANUAL_QC_DATA.COLUMNS.QC_VALUE'],
                    status: translations['MANUAL_QC_DATA.COLUMNS.STATUS']
                };

                vm.paginationLabel = {
                    of: translations['MANUAL_QC_DATA.PAGINATION.OF'],
                    page: translations['MANUAL_QC_DATA.PAGINATION.PAGE'],
                    rowsPerPage: translations['MANUAL_QC_DATA.PAGINATION.ROWS_PER_PAGE']
                };

            });
        }

        $scope.$watch('vm.filterForm.$valid', function(validity) {
            vm.valid = validity;
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.location')
        .controller('LocationController', LocationController);

    /** @ngInject */
    function LocationController(msApi, $timeout, toastService, $mdDialog, $document, localStorageService, $translate, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.pagination = {
            total:0,
            per_page: 5,
            current_page: 1
        };
        vm.searchTerm = '';
        vm.sort = "-created_at";
        vm.locations = [];

        vm.show = false;
        vm.isReadOnly = false;

        init();

        // Methods
        vm.create = create;
        vm.edit = edit;
        vm.getLocations = getLocations;
        vm.exportToCSV = exportToCSV;
        vm.exportToExcel = exportToExcel;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.isReadOnly = vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;

            translate()
                .then(load);

        }

        function load() {
            getLocations().then(function() {
                $timeout( function(){
                    vm.show = true;
                }, 300);
            });
        }

        function create(e) {
            showLocationFormDialog('create', null, e);
        }

        function edit(location, e) {
            showLocationFormDialog(vm.isReadOnly ? 'view' : 'edit', angular.copy(location), e);
        }

        function exportToCSV() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                hospital_id: vm.user.hospitals[0].id,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('locations@get',
                params,
                // SUCCESS
                function (response) {
                    var locations = response.locations;
                    var data =  _.map(locations, function (location) {
                        return {
                            code: location.code,
                            description: location.description,
                            person_in_charge: location.person_in_charge || '',
                            phone: location.phone || '',
                            created: moment(location.created_at).format()
                        };
                    });

                    var timestamp = moment();
                    var filename = 'Locations-' + timestamp.format('YMMDDHm');

                    alasql('SELECT code AS [' + vm.columns.code + '], ' +
                        'description AS [' + vm.columns.location + '],' +
                        'person_in_charge AS [' + vm.columns.personInCharge + '],' +
                        'phone AS [' + vm.columns.phone + '],' +
                        'created AS [' + vm.columns.created + '] ' +
                        'INTO CSV(?, {headers:true, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                hospital_id: vm.user.hospitals[0].id,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('locations@get',
                params,
                // SUCCESS
                function (response) {
                    var locations = response.locations;
                    var data =  _.map(locations, function (location) {
                        return {
                            code: location.code,
                            description: location.description,
                            person_in_charge: location.person_in_charge || '',
                            phone: location.phone || '',
                            created: moment(location.created_at).format()
                        };
                    });

                    var timestamp = moment();
                    var filename = 'Locations-' + timestamp.format('YMMDDHm');

                    alasql('SELECT code AS [' + vm.columns.code + '], ' +
                        'description AS [' + vm.columns.location + '],' +
                        'person_in_charge AS [' + vm.columns.personInCharge + '],' +
                        'phone AS [' + vm.columns.phone + '],' +
                        'created AS [' + vm.columns.created + '] ' +
                        'INTO XLSX(?, {headers:true}) FROM ?',[filename, data]);
                });
        }

        function showLocationFormDialog(type, location, e) {
            var dialogData = {
                type: type,
                hospital: vm.user.hospitals[0],
                location: location,
                isReadOnly: vm.isReadOnly
            };

            $mdDialog.show({
                controller: 'LocationFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/location/location-form/location-form.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                }
            }).then(function (dialogResponse) {
                switch (dialogResponse.type) {
                    case 'create':
                        createLocation(dialogResponse.location);
                        break;

                    case 'edit':
                        editLocation(dialogResponse.location);
                        break;

                    case 'remove':
                        break;
                }
            });
        }

        function getLocations() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                hospital_id: vm.user.hospitals[0].id,
                search: searchTerm,
                sort: sort + ':' + order
            };

            vm.promise = msApi.request('locations@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.locations = response.locations.data;
                    vm.pagination.total = response.locations.total;
                });

            return vm.promise;
        }

        function createLocation(location) {
            return msApi.request('locations@save',
                location,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.created);
                    getLocations();
                });
        }

        function editLocation(location) {
            return msApi.request('locations.edit@update',
                location,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.updated);
                    getLocations();
                });
        }

        function translate() {
            return $translate([
                'LOCATION.COLUMNS.CODE',
                'LOCATION.COLUMNS.LOCATION',
                'LOCATION.COLUMNS.PERSON_IN_CHARGE',
                'LOCATION.COLUMNS.PHONE',
                'LOCATION.COLUMNS.CREATED',
                'LOCATION.MESSAGES.CREATED',
                'LOCATION.MESSAGES.UPDATED',
                'LOCATION.PAGINATION.OF',
                'LOCATION.PAGINATION.PAGE',
                'LOCATION.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.columns = {
                    code: translations['LOCATION.COLUMNS.CODE'],
                    location: translations['LOCATION.COLUMNS.LOCATION'],
                    personInCharge: translations['LOCATION.COLUMNS.PERSON_IN_CHARGE'],
                    phone: translations['LOCATION.COLUMNS.PHONE'],
                    created: translations['LOCATION.COLUMNS.CREATED']
                };

                vm.messages = {
                    created: translations['LOCATION.MESSAGES.CREATED'],
                    updated: translations['LOCATION.MESSAGES.UPDATED']
                };

                vm.paginationLabel = {
                    of: translations['LOCATION.PAGINATION.OF'],
                    page: translations['LOCATION.PAGINATION.PAGE'],
                    rowsPerPage: translations['LOCATION.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.hospital')
        .controller('HospitalController', HospitalController);

    /** @ngInject */
    function HospitalController($rootScope, countriesData, statesData, msApi, $timeout, toastService, $mdDialog, $document, localStorageService, $translate, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.pagination = {
            total:0,
            per_page: 5,
            current_page: 1
        };
        vm.searchTerm = '';
        vm.sort = "-created_at";
        vm.countries = countriesData.countries;

        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };
        vm.hospitals = [];

        vm.show = false;
        vm.showCloudShareButton = false;

        init();

        // Methods
        vm.create = create;
        vm.edit = edit;
        vm.cloudShare = cloudShare;
        vm.getHospitals = getHospitals;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.states = statesData.states[vm.user.country];
            vm.showCloudShareButton = ($rootScope.appType === 'cloud');

            translate()
                .then(load);
        }

        function load() {
            getHospitals()
                .then(function() {
                    $timeout( function(){
                        vm.show = true;
                    }, 300);
                });
        }

        function create(e) {
            showHospitalFormDialog('create', null, e);
        }

        function edit(hospital, e) {
            showHospitalFormDialog('edit', angular.copy(hospital), e);
        }

        function cloudShare(hospital, e) {
            showCloudShareDialog(hospital, e);
        }

        function showHospitalFormDialog(type, hospital, e) {
            var dialogData = {
                type: type,
                defaultMeasurementUnit: vm.user.preferred_measurement_unit,
                country: vm.user.country,
                countries: vm.countries,
                states: vm.states,
                hospital: hospital
            };

            $mdDialog.show({
                controller: 'HospitalFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/hospital/hospital-form/hospital-form.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                }
            }).then(function (dialogResponse) {
                switch (dialogResponse.type) {
                    case 'create':
                        createHospital(dialogResponse.hospital);
                        break;

                    case 'edit':
                        editHospital(dialogResponse.hospital);
                        break;

                    case 'remove':
                        break;
                }
            });
        }

        function showCloudShareDialog(hospital, e) {
            var dialogData = {
                hospital: angular.copy(hospital)
            };

            $mdDialog.show({
                controller: 'CloudShareDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/dialog/cloud-share-dialog/cloud-share-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                }
            }).then(function (dialogResponse) {
                hospital.cloud_link = dialogResponse.cloudLink;
            });
        }

        function getCountries() {
            return msApi.request('countries@get',
                {},
                // SUCCESS
                function (response) {
                    vm.countries = response.countries;
                });
        }

        function getStates() {
            return msApi.request('states@get',
                {
                    country: vm.user.country
                },
                // SUCCESS
                function (response) {
                    vm.states = response.states;
                });
        }

        function getHospitals() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                country: vm.user.country,
                search: searchTerm,
                sort: sort + ':' + order
            };

            vm.promise = msApi.request('hospitals@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.hospitals = response.hospitals.data;
                    vm.pagination.total = response.hospitals.total;
                });

            return vm.promise;
        }

        function createHospital(hospital) {
            return msApi.request('hospitals@save',
                hospital,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.created);
                    getHospitals();
                });
        }

        function editHospital(hospital) {
            return msApi.request('hospitals.edit@update',
                hospital,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.updated);
                    getHospitals();
                });
        }

        function translate() {
            return $translate([
                'HOSPITAL.MESSAGES.CREATED',
                'HOSPITAL.MESSAGES.UPDATED',
                'HOSPITAL.SIZES.HOSPITAL_SMALL',
                'HOSPITAL.SIZES.HOSPITAL_MEDIUM',
                'HOSPITAL.SIZES.HOSPITAL_LARGE',
                'HOSPITAL.SIZES.HOSPITAL_MEGA',
                'HOSPITAL.SIZES.CLINIC_SMALL',
                'HOSPITAL.SIZES.CLINIC_LARGE',
                'HOSPITAL.TYPES.PRIMARY',
                'HOSPITAL.TYPES.TERTIARY',
                'HOSPITAL.PAGINATION.OF',
                'HOSPITAL.PAGINATION.PAGE',
                'HOSPITAL.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.messages = {
                    created: translations['HOSPITAL.MESSAGES.CREATED'],
                    updated: translations['HOSPITAL.MESSAGES.UPDATED']
                };

                vm.sizes = {
                    hospital_small: translations['HOSPITAL.SIZES.HOSPITAL_SMALL'],
                    hospital_medium: translations['HOSPITAL.SIZES.HOSPITAL_MEDIUM'],
                    hospital_large: translations['HOSPITAL.SIZES.HOSPITAL_LARGE'],
                    hospital_mega: translations['HOSPITAL.SIZES.HOSPITAL_MEGA'],
                    clinic_small: translations['HOSPITAL.SIZES.CLINIC_SMALL'],
                    clinic_large: translations['HOSPITAL.SIZES.CLINIC_LARGE']
                };

                vm.types = {
                    primary: translations['HOSPITAL.TYPES.PRIMARY'],
                    tertiary: translations['HOSPITAL.TYPES.TERTIARY']
                };

                vm.paginationLabel = {
                    of: translations['HOSPITAL.PAGINATION.OF'],
                    page: translations['HOSPITAL.PAGINATION.PAGE'],
                    rowsPerPage: translations['HOSPITAL.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard', [
            'app.dashboard.component'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.dashboard', {
                url    : '/dashboard',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/dashboard.html',
                        controller : 'DashboardController as vm'
                    }
                },
                data: {
                    requiresLogin: true,
                    roles: ['hospital_admin']
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dashboard');

        msNavigationServiceProvider.saveItem('dashboard', {
            title    : 'Dashboard',
            icon     : 'icon-tile-four',
            state    : 'app.dashboard',
            translate: 'DASHBOARD.NAV',
            weight   : 1
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController(localStorageService, $log)
    {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.loaded = false;
        vm.isReadOnly = false;

        init();

        // Methods

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.isReadOnly = vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.current-lot')
        .controller('CurrentLotController', CurrentLotController);

    /** @ngInject */
    function CurrentLotController(msApi, toastService, $mdDialog, $document, localStorageService, $mdSelect, $translate, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();

        vm.meterColumns = [];
        vm.meters = [];
        vm.meter = null;
        vm.searchTerm = '';

        vm.paginationTestStrip = {
            total:0,
            per_page: 5,
            current_page: 1
        };
        vm.sortTestStrip = "-pivot_changed_at";
        vm.testStripHistory = [];

        vm.paginationControlSolution1 = {
            total:0,
            per_page: 5,
            current_page: 1
        };
        vm.sortControlSolution1 = "-pivot_changed_at";
        vm.controlSolution1History = [];

        vm.paginationControlSolution2 = {
            total:0,
            per_page: 5,
            current_page: 1
        };
        vm.sortControlSolution2 = "-pivot_changed_at";
        vm.controlSolution2History = [];

        vm.loaded = false;
        vm.isReadOnly = false;

        init();

        // Methods
        vm.changeTestStrip = changeTestStrip;
        vm.changeControlSolution1 = changeControlSolution1;
        vm.changeControlSolution2 = changeControlSolution2;
        vm.editTestStripHistory = editTestStripHistory;
        vm.editControlSolution1History = editControlSolution1History;
        vm.editControlSolution2History = editControlSolution2History;
        vm.meterChanged = meterChanged;
        vm.getTestStripHistory = getTestStripHistory;
        vm.getControlSolution1History = getControlSolution1History;
        vm.getControlSolution2History = getControlSolution2History;
        vm.close = close;
        vm.exportToCSV = exportToCSV;
        vm.exportToExcel = exportToExcel;
        vm.searchMeters = searchMeters;
        vm.meterSelectionOnClose = meterSelectionOnClose;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;
            vm.isReadOnly = vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;

            translate()
                .then(load);

        }

        function load() {
            getMeters();
        }

        function changeTestStrip(e) {
            var dialogData = {
                currentTestStrip : vm.currentTestStrip
            };

            $mdDialog.show({
                controller: 'ChangeTestStripController',
                controllerAs: 'vm',
                templateUrl: 'app/main/current-lot/change-test-strip/change-test-strip.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        return msApi.request('test-strips@get', {
                            hospital_id: vm.user.hospitals[0].id,
                            expiry: moment().format()
                        });
                    }
                }
            }).then(function (dialogResponse) {
                storeCurrentTestStrip(dialogResponse.testStrip, dialogResponse.changedAt);
            });
        }

        function changeControlSolution1(e) {
            var dialogData = {
                type: 'Level 1',
                currentControlSolution : vm.currentControlSolution1
            };

            $mdDialog.show({
                controller: 'ChangeControlSolutionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/current-lot/change-control-solution/change-control-solution.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        return msApi.request('control-solutions@get', {
                            hospital_id: vm.user.hospitals[0].id,
                            type: 'Level 1',
                            expiry: moment().format()
                        });
                    }
                }
            }).then(function (dialogResponse) {
                storeCurrentControlSolution1(dialogResponse.controlSolution, dialogResponse.changedAt);
            });
        }

        function changeControlSolution2(e) {
            var dialogData = {
                type: 'Level 2',
                currentControlSolution : vm.currentControlSolution2
            };

            $mdDialog.show({
                controller: 'ChangeControlSolutionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/current-lot/change-control-solution/change-control-solution.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        return msApi.request('control-solutions@get', {
                            hospital_id: vm.user.hospitals[0].id,
                            type: 'Level 2',
                            expiry: moment().format()
                        });
                    }
                }
            }).then(function (dialogResponse) {
                storeCurrentControlSolution2(dialogResponse.controlSolution, dialogResponse.changedAt);
            });
        }

        function editTestStripHistory(testStripHistory, e) {
            var dialogData = {
                testStripHistory : testStripHistory
            };

            $mdDialog.show({
                controller: 'EditTestStripHistoryController',
                controllerAs: 'vm',
                templateUrl: 'app/main/current-lot/edit-test-strip-history/edit-test-strip-history.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        return msApi.request('test-strips@get', {
                            hospital_id: vm.user.hospitals[0].id
                        });
                    }
                }
            }).then(function (dialogResponse) {
                updateTestStripHistory(testStripHistory.pivot.id, dialogResponse.testStrip, dialogResponse.changedAt);
            });
        }

        function editControlSolution1History(controlSolutionHistory, e) {
            var dialogData = {
                type: 'Level 1',
                controlSolutionHistory : controlSolutionHistory
            };

            $mdDialog.show({
                controller: 'EditControlSolutionHistoryController',
                controllerAs: 'vm',
                templateUrl: 'app/main/current-lot/edit-control-solution-history/edit-control-solution-history.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        return msApi.request('control-solutions@get', {
                            hospital_id: vm.user.hospitals[0].id,
                            type: 'Level 1'
                        });
                    }
                }
            }).then(function (dialogResponse) {
                updateControlSolutionHistory(controlSolutionHistory.pivot.id, 'Level 1', dialogResponse.controlSolution, dialogResponse.changedAt);
            });
        }

        function editControlSolution2History(controlSolutionHistory, e) {
            var dialogData = {
                type: 'Level 2',
                controlSolutionHistory : controlSolutionHistory
            };

            $mdDialog.show({
                controller: 'EditControlSolutionHistoryController',
                controllerAs: 'vm',
                templateUrl: 'app/main/current-lot/edit-control-solution-history/edit-control-solution-history.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                },
                resolve: {
                    resolveData: function() {
                        return msApi.request('control-solutions@get', {
                            hospital_id: vm.user.hospitals[0].id,
                            type: 'Level 2'
                        });
                    }
                }
            }).then(function (dialogResponse) {
                updateControlSolutionHistory(controlSolutionHistory.pivot.id, 'Level 2', dialogResponse.controlSolution, dialogResponse.changedAt);
            });
        }

        function meterChanged() {
            if(vm.meter) {
                getCurrentLot();
                getTestStripHistory();
                getControlSolution1History();
                getControlSolution2History();
            }
        }

        function close() {
            $mdSelect.hide();
        }

        function exportToCSV() {
            var order = _.startsWith(vm.sortTestStrip, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sortTestStrip, '-');

            var params = {
                meter_id: vm.meter.id,
                sort: sort + ':' + order
            };

            msApi.request('current-lot-history@get',
                angular.extend(vm.paginationTestStrip, params),
                // SUCCESS
                function (response) {
                    var testStripHistory = response.test_strip_history;
                    var controlSolutionHistoryLevel1 = response.control_solution_history_level1;
                    var controlSolutionHistoryLevel2 = response.control_solution_history_level2;

                    var data = [];

                    _.map(testStripHistory, function (lot) {
                        data.push({
                            type: vm.history.testStrip,
                            changed: moment(lot.pivot.changed_at).format(),
                            lot: lot.lot_no
                        });
                    });

                    _.map(controlSolutionHistoryLevel1, function (lot) {
                        data.push({
                            type: vm.history.controlSolutionLevel1,
                            changed: moment(lot.pivot.changed_at).format(),
                            lot: lot.lot_no
                        });
                    });

                    _.map(controlSolutionHistoryLevel2, function (lot) {
                        data.push({
                            type: vm.history.controlSolutionLevel2,
                            changed: moment(lot.pivot.changed_at).format(),
                            lot: lot.lot_no
                        });
                    });


                    var timestamp = moment();
                    var filename = 'CurrentLotHistory-' + timestamp.format('YMMDDHm');

                    alasql('SELECT type AS [' + vm.history.testStrip + '/' + vm.history.controlSolutionLevel1 + '/' + vm.history.controlSolutionLevel2 + '], ' +
                        'changed AS [' + vm.history.changed + '],' +
                        'lot AS [' + vm.history.stripLot + '/' + vm.history.controlLot + '] ' +
                        'INTO CSV(?, {headers:true, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var order = _.startsWith(vm.sortTestStrip, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sortTestStrip, '-');

            var params = {
                meter_id: vm.meter.id,
                sort: sort + ':' + order
            };

            msApi.request('current-lot-history@get',
                angular.extend(vm.paginationTestStrip, params),
                // SUCCESS
                function (response) {
                    var testStripHistory = response.test_strip_history;
                    var controlSolutionHistoryLevel1 = response.control_solution_history_level1;
                    var controlSolutionHistoryLevel2 = response.control_solution_history_level2;

                    var data = [];

                    _.map(testStripHistory, function (lot) {
                        data.push({
                            type: vm.history.testStrip,
                            changed: moment(lot.pivot.changed_at).format(),
                            lot: lot.lot_no
                        });
                    });

                    _.map(controlSolutionHistoryLevel1, function (lot) {
                        data.push({
                            type: vm.history.controlSolutionLevel1,
                            changed: moment(lot.pivot.changed_at).format(),
                            lot: lot.lot_no
                        });
                    });

                    _.map(controlSolutionHistoryLevel2, function (lot) {
                        data.push({
                            type: vm.history.controlSolutionLevel2,
                            changed: moment(lot.pivot.changed_at).format(),
                            lot: lot.lot_no
                        });
                    });


                    var timestamp = moment();
                    var filename = 'CurrentLotHistory-' + timestamp.format('YMMDDHm');

                    alasql('SELECT type AS [' + vm.history.testStrip + '/' + vm.history.controlSolutionLevel1 + '/' + vm.history.controlSolutionLevel2 + '], ' +
                        'changed AS [' + vm.history.changed + '],' +
                        'lot AS [' + vm.history.stripLot + '/' + vm.history.controlLot + '] ' +
                        'INTO XLSX(?, {headers:true}) FROM ?',[filename, data]);
                });
        }

        function getMeters() {
            var locationIds = _.map(vm.user.locations, 'id');

            var params = {
                hospital_id: vm.user.hospitals[0].id,
                'location_ids[]': locationIds
            };

            return msApi.request('meters@get',
                params,
                // SUCCESS
                function (response) {
                    var meters = response.meters;
                    vm.meters = meters;

                    if (vm.meters.length) {
                        vm.message = vm.messages.selectMeter;
                    } else {
                        vm.message = vm.messages.noRegisteredMeter;
                    }

                    groupMeters(vm.meters);
                });
        }

        function groupMeters(meters) {
            var groups = _.groupBy(_.sortBy(meters, ['location.code', 'serial_no']), 'location.code');
            var options = [];

            _.map(groups, function (meters, group) {
                options.push({isGroup: true, name: group});
                _.map(meters, function (meter) {
                    options.push(meter);
                });
            });

            vm.meterColumns =  _.chunk(options, 10);
        }

        function searchMeters() {
            var filtered = _.filter(vm.meters, function(meter) {
                return _.startsWith(meter.serial_no.toLowerCase(), vm.searchTerm.toLowerCase());
            });

            groupMeters(filtered);
        }

        function meterSelectionOnClose() {
            vm.searchTerm = '';

            groupMeters(vm.meters);
        }

        function getCurrentLot() {
            var params = {
                meter_id: vm.meter.id
            };

            return msApi.request('current-lot@get',
                params,
                // SUCCESS
                function (response) {
                    vm.currentTestStrip = response.current_test_strip;
                    vm.currentControlSolution1 = response.current_control_solution1;
                    vm.currentControlSolution2 = response.current_control_solution2;
                    vm.loaded = true;
                });
        }

        function getTestStripHistory() {
            var order = _.startsWith(vm.sortTestStrip, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sortTestStrip, '-');

            var params = {
                meter_id: vm.meter.id,
                sort: sort + ':' + order
            };

            vm.promiseTestStrip = msApi.request('test-strip-history@get',
                angular.extend(vm.paginationTestStrip, params),
                // SUCCESS
                function (response) {
                    vm.testStripHistory = response.test_strip_history.data;
                    vm.paginationTestStrip.total = response.test_strip_history.total;
                });
        }

        function getControlSolution1History() {
            var order = _.startsWith(vm.sortControlSolution1, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sortControlSolution1, '-');

            var params = {
                meter_id: vm.meter.id,
                type: 'Level 1',
                sort: sort + ':' + order
            };

            vm.promiseControlSolution1 = msApi.request('control-solution-history@get',
                angular.extend(vm.paginationControlSolution1, params),
                // SUCCESS
                function (response) {
                    vm.controlSolution1History = response.control_solution_history.data;
                    vm.paginationControlSolution1.total = response.control_solution_history.total;
                });
        }

        function getControlSolution2History() {
            var order = _.startsWith(vm.sortControlSolution2, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sortControlSolution2, '-');

            var params = {
                meter_id: vm.meter.id,
                type: 'Level 2',
                sort: sort + ':' + order
            };

            vm.promiseControlSolution2 = msApi.request('control-solution-history@get',
                angular.extend(vm.paginationControlSolution2, params),
                // SUCCESS
                function (response) {
                    vm.controlSolution2History = response.control_solution_history.data;
                    vm.paginationControlSolution2.total = response.control_solution_history.total;
                });
        }

        function storeCurrentTestStrip(testStrip, changedAt) {
            return msApi.request('current-lot@save',
                {
                    meter_id: vm.meter.id,
                    test_strip_id: testStrip.id,
                    test_strip_changed_at: changedAt
                },
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.currentTestStripChanged);
                    vm.currentTestStrip = response.current_test_strip;
                    getTestStripHistory();
                });
        }

        function storeCurrentControlSolution1(controlSolution, changedAt) {
            return msApi.request('current-lot@save',
                {
                    meter_id: vm.meter.id,
                    control_solution1_id: controlSolution.id,
                    control_solution1_changed_at: changedAt
                },
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.currentControlSolutionLevel1Changed);
                    vm.currentControlSolution1 = response.current_control_solution1;
                    getControlSolution1History();
                });
        }

        function storeCurrentControlSolution2(controlSolution, changedAt) {
            return msApi.request('current-lot@save',
                {
                    meter_id: vm.meter.id,
                    control_solution2_id: controlSolution.id,
                    control_solution2_changed_at: changedAt
                },
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.currentControlSolutionLevel2Changed);
                    vm.currentControlSolution2 = response.current_control_solution2;
                    getControlSolution2History();
                });
        }

        function updateTestStripHistory(pivotId, testStrip, changedAt) {
            return msApi.request('test-strip-history.edit@update',
                {
                    pivot_id: pivotId,
                    meter_id: vm.meter.id,
                    test_strip_id: testStrip.id,
                    test_strip_changed_at: changedAt
                },
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.testStripHistoryUpdated);
                    getTestStripHistory();
                    getCurrentLot();
                });
        }

        function updateControlSolutionHistory(pivotId, type, testStrip, changedAt) {
            return msApi.request('control-solution-history.edit@update',
                {
                    pivot_id: pivotId,
                    meter_id: vm.meter.id,
                    control_solution_id: testStrip.id,
                    control_solution_changed_at: changedAt
                },
                // SUCCESS
                function (response) {
                    if (type === 'Level 1') {
                        toastService.show(vm.messages.controlSolutionHistoryLevel1Updated);
                        getControlSolution1History();
                        getCurrentLot();
                    } else if(type === 'Level 2') {
                        toastService.show(vm.messages.controlSolutionHistoryLevel2Updated);
                        getControlSolution2History();
                        getCurrentLot();
                    }
                });
        }

        function translate() {
            return $translate([
                'CURRENT_LOT.CURRENT.TEST_STRIP',
                'CURRENT_LOT.CURRENT.CONTROL_SOLUTION_LEVEL1',
                'CURRENT_LOT.CURRENT.CONTROL_SOLUTION_LEVEL2',
                'CURRENT_LOT.HISTORY.CHANGED',
                'CURRENT_LOT.HISTORY.STRIP_LOT',
                'CURRENT_LOT.HISTORY.CONTROL_LOT',
                'CURRENT_LOT.MESSAGES.SELECT_METER',
                'CURRENT_LOT.MESSAGES.NO_REGISTERED_METER',
                'CURRENT_LOT.MESSAGES.CURRENT_TEST_STRIP_CHANGED',
                'CURRENT_LOT.MESSAGES.CURRENT_CONTROL_SOLUTION_LEVEL1_CHANGED',
                'CURRENT_LOT.MESSAGES.CURRENT_CONTROL_SOLUTION_LEVEL2_CHANGED',
                'CURRENT_LOT.MESSAGES.TEST_STRIP_HISTORY_UPDATED',
                'CURRENT_LOT.MESSAGES.CONTROL_SOLUTION_HISTORY_LEVEL1_UPDATED',
                'CURRENT_LOT.MESSAGES.CONTROL_SOLUTION_HISTORY_LEVEL2_UPDATED',
                'CURRENT_LOT.PAGINATION.OF',
                'CURRENT_LOT.PAGINATION.PAGE',
                'CURRENT_LOT.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.history = {
                    testStrip: translations['CURRENT_LOT.CURRENT.TEST_STRIP'],
                    controlSolutionLevel1: translations['CURRENT_LOT.CURRENT.CONTROL_SOLUTION_LEVEL1'],
                    controlSolutionLevel2: translations['CURRENT_LOT.CURRENT.CONTROL_SOLUTION_LEVEL2'],
                    changed: translations['CURRENT_LOT.HISTORY.CHANGED'],
                    stripLot: translations['CURRENT_LOT.HISTORY.STRIP_LOT'],
                    controlLot: translations['CURRENT_LOT.HISTORY.CONTROL_LOT']
                };

                vm.messages = {
                    noRegisteredMeter: translations['CURRENT_LOT.MESSAGES.NO_REGISTERED_METER'],
                    selectMeter: translations['CURRENT_LOT.MESSAGES.SELECT_METER'],
                    currentTestStripChanged: translations['CURRENT_LOT.MESSAGES.CURRENT_TEST_STRIP_CHANGED'],
                    currentControlSolutionLevel1Changed: translations['CURRENT_LOT.MESSAGES.CURRENT_CONTROL_SOLUTION_LEVEL1_CHANGED'],
                    currentControlSolutionLevel2Changed: translations['CURRENT_LOT.MESSAGES.CURRENT_CONTROL_SOLUTION_LEVEL2_CHANGED'],
                    testStripHistoryUpdated: translations['CURRENT_LOT.MESSAGES.TEST_STRIP_HISTORY_UPDATED'],
                    controlSolutionHistoryLevel1Updated: translations['CURRENT_LOT.MESSAGES.CONTROL_SOLUTION_HISTORY_LEVEL1_UPDATED'],
                    controlSolutionHistoryLevel2Updated: translations['CURRENT_LOT.MESSAGES.CONTROL_SOLUTION_HISTORY_LEVEL2_UPDATED']
                };

                vm.paginationLabel = {
                    of: translations['CURRENT_LOT.PAGINATION.OF'],
                    page: translations['CURRENT_LOT.PAGINATION.PAGE'],
                    rowsPerPage: translations['CURRENT_LOT.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.control-solution')
        .controller('ControlSolutionController', ControlSolutionController);

    /** @ngInject */
    function ControlSolutionController(countriesData, hospitalsData, $rootScope, msApi, $timeout, toastService, $mdDialog, $document, localStorageService, $q, $translate, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.countries = countriesData.countries;
        vm.hospitals = hospitalsData ? _.sortBy(hospitalsData.hospitals, 'name') : null;
        vm.selectedHospital = null;
        vm.isCountryAdmin = false;

        vm.pagination = {
            total:0,
            per_page: 5,
            current_page: 1
        };
        vm.searchTerm = '';
        vm.sort = "-expiry";
        vm.controlSolutions = [];

        vm.show = false;
        vm.isReadOnly = false;

        init();

        // Methods
        vm.create = create;
        vm.batchCreate = batchCreate;
        vm.edit = edit;
        vm.view = view;
        vm.getControlSolutions = getControlSolutions;
        vm.isExpired = isExpired;
        vm.exportToCSV = exportToCSV;
        vm.exportToExcel = exportToExcel;

        //////////

        function init() {
            vm.user = localStorageService.get('user');

            if (vm.user.role.name === 'roche_country_admin') {
                vm.isCountryAdmin = true;
            } else {
                vm.selectedHospital = vm.user.hospitals[0];
                vm.isReadOnly = vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
            }

            translate()
                .then(load);
        }

        function load() {
            getControlSolutions().then(function() {
                $timeout( function(){
                    vm.show = true;
                }, 300);
            });
        }

        function create(e) {
            showControlSolutionFormDialog('create', false, null, e);
        }

        function batchCreate(e) {
            showBatchCreateControlSolutionsFormDialog(e);
        }

        function edit(controlSolution, e) {
            showControlSolutionFormDialog('edit', false, angular.copy(controlSolution), e);
        }

        function view(controlSolution, e) {
            showControlSolutionFormDialog('view', true, angular.copy(controlSolution), e);
        }

        function exportToCSV() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                country: vm.user.country,
                hospital_id: vm.selectedHospital ? vm.selectedHospital.id : null,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('control-solutions@get',
                params,
                // SUCCESS
                function (response) {
                    var controlSolutions = response.control_solutions;
                    var data =  _.map(controlSolutions, function (controlSolution) {
                        return {
                            lotNo: controlSolution.lot_no,
                            type: controlSolution.type,
                            expiry: moment(controlSolution.expiry).format('YYYY-MM-DD'),
                            hospital: controlSolution.hospital.name,
                            created: moment(controlSolution.created_at).format()
                        };
                    });

                    var timestamp = moment();
                    var filename = 'ControlSolutions-' + timestamp.format('YMMDDHm');

                    alasql('SELECT lotNo AS [' + vm.columns.controlLot + '], ' +
                        'type AS [' + vm.columns.controlType + '],' +
                        'expiry AS [' + vm.columns.controlExpiry + '], ' +
                        'hospital AS [' + vm.columns.hospital + '], ' +
                        'created AS [' + vm.columns.created + '] ' +
                        'INTO CSV(?, {headers:true, separator:","}) FROM ?',[filename, data]);
                });
        }

        function exportToExcel() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                country: vm.user.country,
                hospital_id: vm.selectedHospital ? vm.selectedHospital.id : null,
                search: searchTerm,
                sort: sort + ':' + order
            };

            msApi.request('control-solutions@get',
                params,
                // SUCCESS
                function (response) {
                    var controlSolutions = response.control_solutions;
                    var data =  _.map(controlSolutions, function (controlSolution) {
                        return {
                            lotNo: controlSolution.lot_no,
                            type: controlSolution.type,
                            expiry: moment(controlSolution.expiry).format('YYYY-MM-DD'),
                            hospital: controlSolution.hospital.name,
                            created: moment(controlSolution.created_at).format()
                        };
                    });

                    var timestamp = moment();
                    var filename = 'ControlSolutions-' + timestamp.format('YMMDDHm');

                    alasql('SELECT lotNo AS [' + vm.columns.controlLot + '], ' +
                        'type AS [' + vm.columns.controlType + '],' +
                        'expiry AS [' + vm.columns.controlExpiry + '], ' +
                        'hospital AS [' + vm.columns.hospital + '], ' +
                        'created AS [' + vm.columns.created + '] ' +
                        'INTO XLSX(?, {headers:true}) FROM ?',[filename, data]);
                });
        }

        function showControlSolutionFormDialog(type, isReadOnly, controlSolution, e) {
            var dialogData = {
                type: type,
                isCountryAdmin: vm.isCountryAdmin,
                hospitals: vm.isCountryAdmin ? _.filter(vm.hospitals, function (hospital) {
                    return !(!isReadOnly && hospital.cloud_link && hospital.cloud_link.is_cloud_link_enabled);
                }) : vm.user.hospitals,
                controlSolution: controlSolution,
                isReadOnly: isReadOnly
            };

            $mdDialog.show({
                controller: 'ControlSolutionFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/control-solution/control-solution-form/control-solution-form.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                }
            }).then(function (dialogResponse) {
                switch (dialogResponse.type) {
                    case 'create':
                        createControlSolutions(dialogResponse.controlSolutions)
                            .then(function (response) {
                                    toastService.show(vm.messages.created);
                                    getControlSolutions();
                                });
                        break;
                    case 'edit':
                        editControlSolution(dialogResponse.controlSolution);
                        break;

                    case 'remove':
                        break;
                }
            });
        }

        function showBatchCreateControlSolutionsFormDialog(e) {
            var dialogData = {
                hospitals: _.filter(vm.hospitals, function (hospital) {
                    return !(hospital.cloud_link && hospital.cloud_link.is_cloud_link_enabled);
                })
            };

            $mdDialog.show({
                controller: 'BatchCreateControlSolutionsFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/control-solution/batch-create-control-solutions-form/batch-create-control-solutions-form.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: false,
                locals: {
                    dialogData: dialogData
                }
            }).then(function (dialogResponse) {
                batchCreateControlSolutions(dialogResponse.controlSolutions)
                    .then(function (response) {
                            toastService.show(vm.messages.batchCreated);
                            getControlSolutions();
                        },
                        function(error) {

                            $timeout(function ()
                            {
                                $rootScope.loadingProgress = false;
                            }, 500);

                            toastService.error(vm.messages.batchError);
                            getControlSolutions();
                        });
            });
        }

        function getControlSolutions() {
            var searchTerm = vm.searchTerm;
            var order = _.startsWith(vm.sort, '-') ? 'desc' : 'asc';
            var sort = _.trimStart(vm.sort, '-');

            var params = {
                country: vm.user.country,
                hospital_id: vm.selectedHospital ? vm.selectedHospital.id : null,
                search: searchTerm,
                sort: sort + ':' + order
            };

            vm.promise = msApi.request('control-solutions@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.controlSolutions = response.control_solutions.data;
                    vm.pagination.total = response.control_solutions.total;
                });

            return vm.promise;
        }

        function isExpired(controlSolution) {
            return moment().isAfter(controlSolution.expiry);
        }

        // function createControlSolution(controlSolution) {
        //     return msApi.request('control-solutions@save',
        //         controlSolution,
        //         // SUCCESS
        //         function (response) {
        //             return response;
        //         });
        // }

        function createControlSolutions(controlSolutions) {
            var promises = [];

            for (var i = 0; i < controlSolutions.length; i++) {
                (function(index) {
                    var controlSolution = controlSolutions[index];
                    var curPromise = msApi.request('control-solutions@save',
                        controlSolution,
                        // SUCCESS
                        function (response) {
                            return response;
                        },
                        // Error
                        function (error) {
                            return error;
                        });
                    promises.push(curPromise);
                })(i);
            }

            return $q.all(promises);
        }

        function editControlSolution(controlSolution) {
            return msApi.request('control-solutions.edit@update',
                controlSolution,
                // SUCCESS
                function (response) {
                    toastService.show(vm.messages.updated);
                    getControlSolutions();
                });
        }

        function batchCreateControlSolutions(controlSolutions) {
            var promises = [];

            for (var i = 0; i < controlSolutions.length; i++) {
                (function(index) {
                    var controlSolution = controlSolutions[index];
                    var curPromise = msApi.request('control-solutions@save',
                        controlSolution,
                        // SUCCESS
                        function (response) {
                            return response;
                        },
                        // Error
                        function (error) {
                            return error;
                        });
                    promises.push(curPromise);
                })(i);
            }

            return $q.all(promises);
        }

        function translate() {
            return $translate([
                'CONTROL_SOLUTION.COLUMNS.CONTROL_LOT',
                'CONTROL_SOLUTION.COLUMNS.CONTROL_TYPE',
                'CONTROL_SOLUTION.COLUMNS.CONTROL_EXPIRY',
                'CONTROL_SOLUTION.COLUMNS.HOSPITAL',
                'CONTROL_SOLUTION.COLUMNS.CREATED',
                'CONTROL_SOLUTION.MESSAGES.CREATED',
                'CONTROL_SOLUTION.MESSAGES.UPDATED',
                'CONTROL_SOLUTION.MESSAGES.BATCH_CREATED',
                'CONTROL_SOLUTION.MESSAGES.BATCH_ERROR',
                'CONTROL_SOLUTION.PAGINATION.OF',
                'CONTROL_SOLUTION.PAGINATION.PAGE',
                'CONTROL_SOLUTION.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.columns = {
                    controlLot: translations['CONTROL_SOLUTION.COLUMNS.CONTROL_LOT'],
                    controlType: translations['CONTROL_SOLUTION.COLUMNS.CONTROL_TYPE'],
                    controlExpiry: translations['CONTROL_SOLUTION.COLUMNS.CONTROL_EXPIRY'],
                    hospital: translations['CONTROL_SOLUTION.COLUMNS.HOSPITAL'],
                    created: translations['CONTROL_SOLUTION.COLUMNS.CREATED']
                };

                vm.messages = {
                    created: translations['CONTROL_SOLUTION.MESSAGES.CREATED'],
                    updated: translations['CONTROL_SOLUTION.MESSAGES.UPDATED'],
                    batchCreated: translations['CONTROL_SOLUTION.MESSAGES.BATCH_CREATED'],
                    batchError: translations['CONTROL_SOLUTION.MESSAGES.BATCH_ERROR']
                };

                vm.paginationLabel = {
                    of: translations['CONTROL_SOLUTION.PAGINATION.OF'],
                    page: translations['CONTROL_SOLUTION.PAGINATION.PAGE'],
                    rowsPerPage: translations['CONTROL_SOLUTION.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.blood-glucose-test')
        .controller('BloodGlucoseTestController', BloodGlucoseTestController);

    /** @ngInject */
    function BloodGlucoseTestController($scope, countriesData, statesData, hospitalsData, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;
        vm.allHospitals = hospitalsData.hospitals;
        vm.locations = [];

        vm.loaded = false;
        vm.valid = false;

        vm.isReadOnly = false;

        init();

        // Methods
        vm.exportToCSV = exportToCSV;
        vm.exportToExcel = exportToExcel;

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;

            if (vm.role === 'hospital_operator') {
                vm.locations = vm.user.locations;
                vm.locationIds = _.map(vm.user.locations, 'id');
            }

            vm.isReadOnly = vm.user.hospitals.length && vm.user.hospitals[0].cloud_link && vm.user.hospitals[0].cloud_link.is_cloud_link_enabled;
        }

        function exportToCSV() {
            $scope.$broadcast('blood-glucose-test::exportToCSV');
        }

        function exportToExcel() {
            $scope.$broadcast('blood-glucose-test::exportToExcel');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.active-hospitals')
        .controller('ActiveHospitalsController', ActiveHospitalsController);

    /** @ngInject */
    function ActiveHospitalsController(countriesData, statesData, localStorageService, $log) {
        var vm = this;

        // Data
        vm.year = new Date().getFullYear();
        vm.allCountries = countriesData.countries;
        vm.allStates = statesData.states;

        init();

        // Methods

        //////////

        function init() {
            vm.user = localStorageService.get('user');
            vm.role = vm.user.role.name;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialog', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/dialog');
        $translatePartialLoaderProvider.addPart('app/dialog/action-log-dialog');
        $translatePartialLoaderProvider.addPart('app/dialog/edit-qc-data-dialog');
        $translatePartialLoaderProvider.addPart('app/dialog/enter-reason-dialog');
        $translatePartialLoaderProvider.addPart('app/dialog/confirm-dialog');
        $translatePartialLoaderProvider.addPart('app/dialog/change-operator-dialog');
        $translatePartialLoaderProvider.addPart('app/dialog/copy-password-dialog');
        $translatePartialLoaderProvider.addPart('app/dialog/edit-notes-dialog');
        $translatePartialLoaderProvider.addPart('app/dialog/terms-of-use-dialog');
        $translatePartialLoaderProvider.addPart('app/dialog/cloud-share-dialog');
        $translatePartialLoaderProvider.addPart('app/dialog/enter-cloud-share-key-dialog');
        $translatePartialLoaderProvider.addPart('app/dialog/complete-install-dialog');
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dialog')
        .controller('TermsOfUseDialogController', TermsOfUseDialogController);

    /** @ngInject */
    function TermsOfUseDialogController($mdDialog, $log)
    {
        var vm = this;

        // Data

        // Methods
        vm.close = close;

        init();

        //////////

        function init() {
        }

        function close() {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dialog')
        .controller('EnterReasonDialogController', EnterReasonDialogController);

    /** @ngInject */
    function EnterReasonDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.reason = dialogData.reason;

        // Methods
        vm.save = save;
        vm.close = close;

        init();

        //////////

        function init() {
        }

        function save(){

            var response = {
                reason: vm.reason
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dialog')
        .controller('EnterCloudShareKeyDialogController', EnterCloudShareKeyDialogController);

    /** @ngInject */
    function EnterCloudShareKeyDialogController($timeout, $rootScope, api, toastService, $mdDialog, dialogData, $translate, $log)
    {
        var vm = this;

        // Data
        vm.key = null;
        vm.cloudLink = null;
        vm.confirmMessage = null;
        vm.contactAdmin = false;

        // Methods
        vm.save = save;
        vm.close = close;
        vm.notConfirmed = notConfirmed;
        vm.confirmed = confirmed;

        init();

        //////////

        function init() {

            translate();
        }

        function save(){

            getCloudLink();
        }

        function notConfirmed() {
            vm.contactAdmin = true;
        }

        function confirmed() {
            var response = {
                cloudLink: vm.cloudLink
            };

            $mdDialog.hide(response);
        }

        function getCloudLink() {
            $rootScope.loadingProgress = true;

            return api.getCloudLink()
                .get({
                        cloud_link_key: vm.key
                    },
                    success,
                    error
                ).$promise.finally(last);

            function success(response){
                if (!response.cloud_link.is_cloud_link_enabled || response.cloud_link.is_revoked) {
                    toastService.error(vm.messages.invalidKey);
                } else {
                    vm.cloudLink = response.cloud_link;
                }
            }

            function error(response){
                if (response.status === 422) {
                    toastService.error(vm.messages.invalidKey);
                } else {
                    toastService.error(vm.messages.errorOccurred);
                }

            }

            function last(){
                $timeout(function ()
                {
                    $rootScope.loadingProgress = false;
                }, 500);
            }

        }

        function close() {
            $mdDialog.cancel();
        }

        function translate() {
            return $translate([
                'ENTER_CLOUD_SHARE_KEY_DIALOG.KEY_INVALID_MESSAGE',
                'ENTER_CLOUD_SHARE_KEY_DIALOG.ERROR_OCCURRED_MESSAGE'
            ]).then(function(translations) {
                vm.messages = {
                    invalidKey: translations['ENTER_CLOUD_SHARE_KEY_DIALOG.KEY_INVALID_MESSAGE'],
                    errorOccurred: translations['ENTER_CLOUD_SHARE_KEY_DIALOG.ERROR_OCCURRED_MESSAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dialog')
        .controller('EditQcDataDialogController', EditQcDataDialogController);

    /** @ngInject */
    function EditQcDataDialogController($mdDialog, dialogData, isReadOnly, localStorageService)
    {
        var vm = this;

        // Data
        vm.measurementUnits = {
            MMOL_PER_L: 'mmol/L',
            MG_PER_DL: 'mg/dL'
        };

        vm.qcValue = dialogData.qcValue;
        vm.isReadOnly = isReadOnly;
        console.log(vm.isReadOnly);

        // Methods
        vm.remove = remove;
        vm.save = save;
        vm.close = close;

        init();

        //////////

        function init() {
            vm.user = localStorageService.get('user');
        }

        function remove(){

            var response = {
                result: 'delete',
                qcValue: vm.qcValue
            };

            $mdDialog.hide(response);
        }

        function save(){

            var response = {
                result: 'save',
                qcValue: vm.qcValue
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dialog')
        .controller('EditNotesDialogController', EditNotesDialogController);

    /** @ngInject */
    function EditNotesDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.notes = dialogData.notes;
        vm.readonly = dialogData.readonly;

        // Methods
        vm.save = save;
        vm.close = close;

        init();

        //////////

        function init() {
        }

        function save(){

            var response = {
                notes: vm.notes
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dialog')
        .controller('CopyPasswordDialogController', CopyPasswordDialogController);

    /** @ngInject */
    function CopyPasswordDialogController($mdDialog, dialogData, $log)
    {
        var vm = this;

        // Data
        vm.user = dialogData.user;
        vm.password = dialogData.password;
        vm.copied = false;

        // Methods
        vm.close = close;

        init();

        //////////

        function init() {
        }

        function close() {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dialog')
        .controller('ConfirmDialogController', ConfirmDialogController);

    /** @ngInject */
    function ConfirmDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.title = dialogData.title;
        vm.message = dialogData.message;

        // Methods
        vm.ok = ok;
        vm.cancel = cancel;

        init();

        //////////

        function init() {
        }

        function ok(){
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dialog')
        .controller('CompleteInstallDialogController', CompleteInstallDialogController);

    /** @ngInject */
    function CompleteInstallDialogController($mdDialog, dialogData, $log)
    {
        var vm = this;

        // Data
        vm.user = {
            email: 'admin',
            password: 'Passw0rd'
        };
        vm.copied = false;

        // Methods
        vm.close = close;

        init();

        //////////

        function init() {
        }

        function close() {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dialog')
        .controller('CloudShareDialogController', CloudShareDialogController);

    /** @ngInject */
    function CloudShareDialogController(msApi, toastService, $mdDialog, dialogData, $log)
    {
        var vm = this;

        // Data
        vm.hospital = dialogData.hospital;
        vm.cloudLink = vm.hospital.cloud_link;
        vm.copied = false;

        // Methods
        vm.close = close;
        vm.enableChanged = enableChanged;
        vm.regenerate = regenerate;

        init();

        //////////

        function init() {
        }

        function close() {
            var response = {
                cloudLink: vm.cloudLink
            };

            $mdDialog.hide(response);
        }

        function enableChanged() {
            vm.copied = false;
            if (vm.cloudLink.id) {
                if (vm.cloudLink.is_cloud_link_enabled) {
                    enableCloudLink(vm.cloudLink.id);
                } else {
                    disableCloudLink(vm.cloudLink.id);
                }
            } else {
                if (vm.cloudLink.is_cloud_link_enabled) {
                    generateCloudLink(vm.hospital.id);
                }
            }
        }

        function enableCloudLink(id) {
            return msApi.request('cloud-links.enable@save',{
                    id: id
                },
                // SUCCESS
                function (response) {
                    vm.cloudLink = response.cloud_link;
                });
        }

        function disableCloudLink(id) {
            return msApi.request('cloud-links.disable@save',{
                    id: id
                },
                // SUCCESS
                function (response) {
                    vm.cloudLink = response.cloud_link;
                });
        }

        function regenerate() {
            vm.copied = false;
            generateCloudLink(vm.hospital.id);
        }

        function generateCloudLink(hospital_id) {
            return msApi.request('cloud-links.generate@save',{
                    hospital_id: hospital_id
                },
                // SUCCESS
                function (response) {
                    vm.cloudLink = response.cloud_link;
                });
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dialog')
        .controller('ChangeSettingDialogController', ChangeSettingDialogController);

    /** @ngInject */
    function ChangeSettingDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.user = dialogData.user;

        // Methods
        vm.save = save;
        vm.close = close;

        init();

        //////////

        function init() {
            vm.preferred_measurement_unit = vm.user.preferred_measurement_unit;
        }

        function save(){
            vm.user.preferred_measurement_unit = vm.preferred_measurement_unit;

            var response = {
                user: vm.user
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dialog')
        .controller('ChangeOperatorDialogController', ChangeOperatorDialogController);

    /** @ngInject */
    function ChangeOperatorDialogController($mdDialog, dialogData, resolveData)
    {
        var vm = this;

        // Data
        vm.operators = resolveData.users;
        vm.operator = dialogData.operator;
        vm.selectedOperator = vm.operator ?  _.find(vm.operators, ['id', vm.operator.id]) : null;

        // Methods
        vm.save = save;
        vm.close = close;

        init();

        //////////

        function init() {
        }

        function save(){

            var response = {
                operator: vm.selectedOperator
            };

            $mdDialog.hide(response);
        }

        function close() {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.dialog')
        .controller('ActionLogDialogController', ActionLogDialogController);

    /** @ngInject */
    function ActionLogDialogController(msApi, toastService, $mdDialog, dialogData, resolveData, $translate, $log)
    {
        var vm = this;

        // Data
        vm.meter = dialogData.meter;
        vm.isReadOnly = dialogData.isReadOnly;
        vm.logs = resolveData.logs.data;
        vm.pagination = {
            total: resolveData.logs.total,
            per_page: 5,
            current_page: 1
        };

        // Methods
        vm.close = close;
        vm.submit = submit;
        vm.getActionLog = getActionLog;

        init();

        //////////

        function init() {
            translate()
                .then(load);
        }

        function load() {

        }

        function close() {
            $mdDialog.cancel();
        }

        function submit() {
            createActionLog();
        }

        function createActionLog() {
            return msApi.request('logs@save',
                {
                    meter_id: vm.meter.id,
                    message: vm.message
                },
                // SUCCESS
                function (response) {
                    vm.logForm.$setPristine();
                    vm.message = null;
                    toastService.show(vm.messages.created);
                    response.log.new = true;
                    vm.logs.unshift(response.log);
                    vm.pagination.total ++;
                    if (vm.logs.length > vm.pagination.per_page) {
                        vm.logs.pop();
                    }
                });
        }

        function getActionLog() {
            var params = {
                meter_id: vm.meter.id,
                sort: 'created_at:desc'
            };

            vm.promise = msApi.request('logs@get',
                angular.extend(vm.pagination, params),
                // SUCCESS
                function (response) {
                    vm.logs = response.logs.data;
                    vm.pagination.total = response.logs.total;
                });
        }

        function translate() {
            return $translate([
                'ACTION_LOG_DIALOG.MESSAGES.CREATED',
                'ACTION_LOG_DIALOG.PAGINATION.OF',
                'ACTION_LOG_DIALOG.PAGINATION.PAGE',
                'ACTION_LOG_DIALOG.PAGINATION.ROWS_PER_PAGE'
            ]).then(function(translations) {
                vm.messages = {
                    created: translations['ACTION_LOG_DIALOG.MESSAGES.CREATED']
                };

                vm.paginationLabel = {
                    of: translations['ACTION_LOG_DIALOG.PAGINATION.OF'],
                    page: translations['ACTION_LOG_DIALOG.PAGINATION.PAGE'],
                    rowsPerPage: translations['ACTION_LOG_DIALOG.PAGINATION.ROWS_PER_PAGE']
                };
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('toastService', toastService);

    /** @ngInject */
    function toastService($mdToast)
    {
        var delay = 6000;
        var position = 'top right';
        var action = 'OK';

        var service = {
            show: show,
            error: error
        };

        return service;

        //////////

        function show(content) {
            if (!content) {
                return false;
            }

            return $mdToast.show(
                $mdToast.simple()
                    .content(content)
                    .position(position)
                    .action(action)
                    .hideDelay(delay)
            );
        }

        function error(content) {
            if (!content) {
                return false;
            }

            return $mdToast.show(
                $mdToast.simple()
                    .content(content)
                    .position(position)
                    .theme('error-toast')
                    .hideDelay(delay)

        );
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope, $translate)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                var activeLanguage = $translate.use() ||
                    $translate.storage().get($translate.storageKey()) ||
                    $translate.preferredLanguage();

                params = angular.merge(params, {lang: activeLanguage});

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError', response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                var activeLanguage = $translate.use() ||
                    $translate.storage().get($translate.storageKey()) ||
                    $translate.preferredLanguage();

                params = angular.merge(params, {lang: activeLanguage});

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');

                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);

                            } else {
                                // Emit an event
                                $rootScope.$broadcast('msApi::requestError', response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('AccuChekUsb', accuChekUsb);

    /** @ngInject */
    function accuChekUsb($q, $timeout, $log)
    {
      ///////////////////// Helper Functions //////////////////////////
      // Convert a DataView's bytes to a hexadecimal string.
      function commonBytes2hex(dataView, noGaps) {
        var message = "";
        for (var i = 0; i < dataView.byteLength; i++) {
          var hex = dataView.getUint8(i).toString(16).toUpperCase();
          if (hex.length === 1) {
            message += "0";
          }
          message += hex;
          if (!noGaps) {
            message += " ";
          }
        }
        return message;
      }

      // getObject: Scan the response bytes to find the object of the specified type.
      function getObject(bytes, type) {
        var offset = 28;
        var count = bytes.getUint16(24);

        for (var i = 0; i < count; i++) {
          var objClass = bytes.getUint16(offset);

          // If the object class matches the desired type
          if (objClass === type) {
            var obj = {};
            obj.class = objClass;
            obj.handle = bytes.getUint16(offset + 2);
            obj.attributeCount = bytes.getUint16(offset + 4);

            var length = bytes.getUint16(offset + 6);
            offset += length + 8;
            obj.bytes = new DataView(bytes.buffer.slice(offset - length, offset));

            return obj;
          } else {
            var length = bytes.getUint16(offset + 6);
            offset += length + 8;
          }
        }

        return null;
      }

      // getAttributeList: Given a DataView, extract a “list” of attributes.
      function getAttributeList(bytes) {
        var offset = 14;
        var obj = {};
        obj.attributeCount = bytes.getUint16(offset);

        var length = bytes.getUint16(offset + 2);
        offset += 4;
        obj.bytes = new DataView(bytes.buffer.slice(offset, offset + length));

        return obj;
      }

      // getAttribute: Search an attribute list for a given attribute ID.
      function getAttribute(obj, type) {
        var offset = 0;
        for (var i = 0; i < obj.attributeCount; i++) {
          var attributeId = obj.bytes.getUint16(offset);
          var length = obj.bytes.getUint16(offset + 2);
          offset += 4;

          if (attributeId === type) {
            return new DataView(obj.bytes.buffer.slice(offset, offset + length));
          }

          offset += length;
        }

        return null;
      }

      // Production specification entries (used for extracting serial numbers).
      var PROD_SPEC_ENTRY = [
        "unspecified",
        "serial-number",
        "part-number",
        "hw-revision",
        "sw-revision",
        "fw-revision",
        "protocol-revision",
        "prod-spec-gmdn"
      ];

      // getProductionSpecEntry: Scan a production-specification DataView.
      function getProductionSpecEntry(bytes, entry) {
        var offset = 0;
        var count = bytes.getUint16(offset);

        for (var i = 0; i < count; i++) {
          var typeCode = bytes.getUint16(offset + 4);
          var length = bytes.getUint16(offset + 8);

          if (PROD_SPEC_ENTRY[typeCode] === entry) {
            return new DataView(bytes.buffer.slice(offset + 10, offset + 10 + length));
          }

          offset += length + 10;
        }
        return null;
      }

      ///////////////////// Protocol Constants /////////////////////////
      var APDU_TYPE = {
        ASSOCIATION_RESPONSE: 0xE300,
        ASSOCIATION_RELEASE_REQUEST: 0xE400,
        PRESENTATION_APDU: 0xE700
      };

      var ACTION_TYPE = {
        MDC_ACT_SEG_GET_INFO: 0x0C0D,
        MDC_ACT_SEG_TRIG_XFER: 0x0C1C,
        MDC_ACT_SEG_SET_TIME: 0x0C17
      };

      var DATA_ADPU = {
        INVOKE_GET: 0x0103,
        INVOKE_CONFIRMED_ACTION: 0x0107,
        RESPONSE_CONFIRMED_EVENT_REPORT: 0x0201,
        RESPONSE_CONFIRMED_ACTION: 0x0207
      };

      var EVENT_TYPE = {
        MDC_NOTI_CONFIG: 0x0D1C,
        MDC_NOTI_SEGMENT_DATA: 0x0D21
      };

      var MDC_PART_OBJ = {
        // For PM store – used to get device configuration
        MDC_MOC_VMO_PMSTORE: 61,
        MDC_ATTR_ID_MODEL: 2344,
        MDC_ATTR_ID_PROD_SPECN: 2349,
        MDC_ATTR_NUM_SEG: 2385,
        MDC_ATTR_TIME_ABS: 2439
      };

      ///////////////////// “Static” Methods ///////////////////////////

      // getFilters: Return a list of USB device filters for supported Accu‑Chek meters.
      function getFilters() {
        return [
          // { vendorId: 5946, productId: 8652 }, // Accu-chek Active
          { vendorId: 5946, productId: 8655 }, // Accu-Chek Aviva Connect
          { vendorId: 5946, productId: 8661 }, // Accu-Chek Guide
          { vendorId: 5946, productId: 8662 }, // Accu-chek Guide Me
          { vendorId: 5946, productId: 8663 }  // Accu-chek Instant
        ];
      }

      // timeout: Timeout helper (rejects after the specified delay).
      function timeout(delay) {
        delay = delay || 5000;
        var deferred = $q.defer();
        $timeout(function () {
          deferred.reject(new Error("Timeout error"));
        }, delay);
        return deferred.promise;
      }

      // promiseRace: Simple implementation of Promise.race for two promises.
      function promiseRace(promiseA, promiseB) {
        var deferred = $q.defer();
        promiseA.then(function (val) {
          deferred.resolve(val);
        }, function (err) {
          deferred.reject(err);
        });
        promiseB.then(function (val) {
          deferred.resolve(val);
        }, function (err) {
          deferred.reject(err);
        });
        return deferred.promise;
      }

      // buildAssociationResponse: USB Message Builder – constructs an Association Response.
      function buildAssociationResponse() {
        var buf = new ArrayBuffer(48);
        var buffer = new DataView(buf);

        buffer.setUint16(0, APDU_TYPE.ASSOCIATION_RESPONSE);
        buffer.setUint16(2, 44); // Length (excludes initial 4 bytes)
        buffer.setUint16(4, 0x0003); // accepted-unknown-config
        buffer.setUint16(6, 20601);  // data-proto-id
        buffer.setUint16(8, 38);     // data-proto-info length
        buffer.setUint32(10, 0x80000002); // protocolVersion
        buffer.setUint16(14, 0x8000);       // encoding-rules = MDER
        buffer.setUint32(16, 0x80000000);   // nomenclatureVersion
        buffer.setUint32(20, 0);            // functionalUnits = normal association
        buffer.setUint32(24, 0x80000000);   // systemType = sys-type-manager
        buffer.setUint16(28, 8);            // system-id length
        buffer.setUint32(30, 0x12345678);   // system-id high
        buffer.setUint32(34, 0x87654321);   // system-id low
        // rest of bytes should always be 0x00 for manager response

        $log.debug('Association response:', commonBytes2hex(buffer, true));

        return buffer.buffer;
      }

      // buildConfigResponse: Construct a configuration response.
      function buildConfigResponse(invokeId) {
        var buf = new ArrayBuffer(26);
        var buffer = new DataView(buf);

        buffer.setUint16(0, APDU_TYPE.PRESENTATION_APDU);
        buffer.setUint16(2, 22); // length
        buffer.setUint16(4, 20); // octet string length
        buffer.setUint16(6, invokeId); // invoke-id from config
        buffer.setUint16(8, DATA_ADPU.RESPONSE_CONFIRMED_EVENT_REPORT);
        buffer.setUint16(10, 14); // length
        buffer.setUint16(12, 0);  // obj-handle = 0
        buffer.setUint32(14, 0);  // currentTime = 0
        buffer.setUint16(18, EVENT_TYPE.MDC_NOTI_CONFIG); // event-type
        buffer.setUint16(20, 4);  // length
        buffer.setUint16(22, 0x4000); // config-report-id = extended-config-start
        buffer.setUint16(24, 0);      // config-result = accepted-config

        $log.debug('Config response', commonBytes2hex(buffer, true));

        return buffer.buffer;
      }

      // buildMDSAttributeRequest: Construct an MDS attribute request.
      function buildMDSAttributeRequest(invokeId) {
        var buf = new ArrayBuffer(18);
        var buffer = new DataView(buf);

        buffer.setUint16(0, APDU_TYPE.PRESENTATION_APDU);
        buffer.setUint16(2, 14); // length
        buffer.setUint16(4, 12); // octet string length
        buffer.setUint16(6, invokeId + 1); // to differentiate from previous
        buffer.setUint16(8, DATA_ADPU.INVOKE_GET);
        buffer.setUint16(10, 6); // length
        buffer.setUint16(12, 0); // handle 0
        buffer.setUint16(14, 0); // attribute-id-list.count = 0 (get all attributes)
        buffer.setUint16(16, 0); // attribute-id-list.length = 0

        $log.debug('MDS request', commonBytes2hex(buffer, true));

        return buffer.buffer;
      }

      // buildActionRequest: Construct an action request message.
      function buildActionRequest(invokeId, pmStoreHandle) {
        var buf = new ArrayBuffer(24);
        var buffer = new DataView(buf);

        buffer.setUint16(0, APDU_TYPE.PRESENTATION_APDU);
        buffer.setUint16(2, 20); // length
        buffer.setUint16(4, 18); // octet string length
        buffer.setUint16(6, invokeId + 1); // invoke-id
        buffer.setUint16(8, DATA_ADPU.INVOKE_CONFIRMED_ACTION);
        buffer.setUint16(12, pmStoreHandle);
        buffer.setUint16(14, ACTION_TYPE.MDC_ACT_SEG_GET_INFO);
        buffer.setUint16(16, 6); // length
        buffer.setUint16(18, 1); // all-segments
        buffer.setUint16(20, 2); // length
        buffer.setUint16(22, 0);

        $log.debug('Action request', commonBytes2hex(buffer, true));

        return buffer.buffer;
      }

      // buildSetTimeRequest: Construct a request to sync the device time.
      function buildSetTimeRequest(invokeId, pmStoreHandle, timestamp) {
        var buf = new ArrayBuffer(30);
        var buffer = new DataView(buf);

        buffer.setUint16(0, APDU_TYPE.PRESENTATION_APDU);
        buffer.setUint16(2, 26); // length
        buffer.setUint16(4, 24); // octet string length
        buffer.setUint16(6, invokeId + 1); // invoke-id
        buffer.setUint16(8, DATA_ADPU.INVOKE_CONFIRMED_ACTION);
        buffer.setUint16(10, 18); // length
        buffer.setUint16(12, 0);
        buffer.setUint16(14, ACTION_TYPE.MDC_ACT_SEG_SET_TIME);
        buffer.setUint16(16, 12); // length
        // Note: setBigUint64 is not available in ES5. If your environment supports it (or you have a polyfill),
        // you can use it. Otherwise you might need to implement a workaround.
        if (buffer.setBigUint64) {
          buffer.setBigUint64(18, timestamp);
        } else {
          // Simple workaround: convert BigInt to string hex and then write 8 bytes manually.
          var hex = timestamp.toString(16);
          while (hex.length < 16) {
            hex = "0" + hex;
          }
          for (var i = 0; i < 8; i++) {
            buffer.setUint8(18 + i, parseInt(hex.substr(i * 2, 2), 16));
          }
        }
        buffer.setUint32(26, 0); // accuracy (FLOAT-type, set to zero)

        $log.debug('Set time request', commonBytes2hex(buffer, true));

        return buffer.buffer;
      }

      // buildDataTransferRequest: Construct a request to retrieve data.
      function buildDataTransferRequest(invokeId, pmStoreHandle, segment) {
        var buf = new ArrayBuffer(20);
        var buffer = new DataView(buf);

        buffer.setUint16(0, APDU_TYPE.PRESENTATION_APDU);
        buffer.setUint16(2, 16); // length
        buffer.setUint16(4, 14); // octet string length
        buffer.setUint16(6, invokeId + 1); // invoke-id
        buffer.setUint16(8, DATA_ADPU.INVOKE_CONFIRMED_ACTION);
        buffer.setUint16(10, 8); // length
        buffer.setUint16(12, pmStoreHandle);
        buffer.setUint16(14, ACTION_TYPE.MDC_ACT_SEG_TRIG_XFER);
        buffer.setUint16(16, 2); // length
        buffer.setUint16(18, segment); // segment

        $log.debug('Data transfer request', commonBytes2hex(buffer, true));

        return buffer.buffer;
      }

      // buildDataTransferConfirmation: Construct a confirmation message for received segment data.
      function buildDataTransferConfirmation(invokeId, pmStoreHandle, segmentDataResult) {
        var buf = new ArrayBuffer(34);
        var buffer = new DataView(buf);

        buffer.setUint16(0, APDU_TYPE.PRESENTATION_APDU);
        buffer.setUint16(2, 30); // length
        buffer.setUint16(4, 28); // octet string length
        buffer.setUint16(6, invokeId);
        buffer.setUint16(8, DATA_ADPU.RESPONSE_CONFIRMED_EVENT_REPORT);
        buffer.setUint16(10, 22); // length
        buffer.setUint16(12, pmStoreHandle);
        buffer.setUint32(14, 0xFFFFFFFF); // relative time
        buffer.setUint16(18, EVENT_TYPE.MDC_NOTI_SEGMENT_DATA);
        buffer.setUint16(20, 12); // length
        buffer.setUint32(22, segmentDataResult.getUint32(0));
        buffer.setUint32(26, segmentDataResult.getUint32(4));
        buffer.setUint16(30, segmentDataResult.getUint16(8)); // number of entries
        buffer.setUint16(32, 0x0080); // confirmed

        $log.debug('Data transfer confirmation', commonBytes2hex(buffer, true));

        return buffer.buffer;
      }

      // buildAssociationReleaseRequest: Construct a message to release association.
      function buildAssociationReleaseRequest() {
        var buf = new ArrayBuffer(6);
        var buffer = new DataView(buf);

        buffer.setUint16(0, APDU_TYPE.ASSOCIATION_RELEASE_REQUEST);
        buffer.setUint16(2, 2); // length  = 2
        buffer.setUint16(4, 0x0000); // normal

        $log.debug('Association release', commonBytes2hex(buffer, true));

        return buffer.buffer;
      }

      ///////////////////////// Constructor /////////////////////////////

      // The constructor for AccuChekUsb.
      function AccuChekUsb() {
        this.device = null;
        this.interfaceNumber = null;
        this.outEndpointNumber = null;
        this.inEndpointNumber = null;
        this.lastInvokeId = null;
        this.pmStoreHandle = null;
        this.deviceDetails = {}; // Will store serialNumber and deviceTime.
      }

      //////////////////// Instance Methods /////////////////////////////

      // detect: Find an Accu‑Chek USB device.
      AccuChekUsb.prototype.detect = function () {
        var self = this;
        var filters = getFilters();

        return $q.when(navigator.usb.getDevices())
          .then(function (devices) {
            var dev = null;
            devices.forEach(function (d) {
              filters.forEach(function (f) {
                if (d.vendorId === f.vendorId && d.productId === f.productId) {
                  dev = d;
                }
              });
            });
            if (!dev) {
              return navigator.usb.requestDevice({ filters: filters });
            }
            return dev;
          })
          .then(function (dev) {
            if (!dev) {
              throw new Error("No Accu‑Chek device selected.");
            }
            self.device = dev;
            return dev;
          });
      };

      // connect: Open the device, select its configuration and claim its interface.
      AccuChekUsb.prototype.connect = function () {
        var self = this;
        // Chain: if device is not already detected, call detect() first.
        return (self.device ? $q.when() : self.detect())
          .then(function () {
            return self.device.open();
          })
          .then(function () {
            if (!self.device.configuration) {
              return self.device.selectConfiguration(1);
            }
          })
          .then(function () {
            // choose the first interface
            var iface = self.device.configuration.interfaces[0];
            self.interfaceNumber = iface.interfaceNumber;
            return self.device.claimInterface(self.interfaceNumber);
          })
          .then(function () {
            var alternate = self.device.configuration.interfaces[0].alternate;
            var epOut = alternate.endpoints.filter(function (ep) {
              return ep.direction === "out";
            })[0];
            var epIn = alternate.endpoints.filter(function (ep) {
              return ep.direction === "in";
            })[0];
            if (!epOut || !epIn) {
              throw new Error("Could not find required endpoints on device.");
            }
            self.outEndpointNumber = epOut.endpointNumber;
            self.inEndpointNumber = epIn.endpointNumber;
            // Perform a controlTransfer to get device status.
            var getStatus = {
              requestType: 'standard',
              recipient: 'device',
              request: 0x00,
              value: 0x00,
              index: 0x00
            };
            return self.device.controlTransferIn(getStatus, 2);
          })
          .then(function () {
            // Wait for the association request from the device.
            return promiseRace(timeout(5000), self.device.transferIn(self.inEndpointNumber, 1024));
          })
          .then(function (incoming) {
            if (incoming.status === "babble") {
              var error = new Error("Device left plugged in for too long.");
              error.code = "E_UNPLUG_AND_RETRY";
              throw error;
            }
            $log.debug('Received association request', commonBytes2hex(incoming.data, true));

            // Send the association response.
            return self.device.transferOut(self.outEndpointNumber, buildAssociationResponse());
          });
      };

      // getDeviceInfo: Retrieve configuration info from the meter.
      AccuChekUsb.prototype.getDeviceInfo = function () {
        var self = this;
        var invokeId;
        var rawDeviceDetails;
        var pmStoreDetails;

        // Step 1: Retrieve the extended configuration (PM store) from the device.
        return promiseRace(timeout(5000), self.device.transferIn(self.inEndpointNumber, 1024))
          .then(function (incoming) {
            $log.debug('Received extended config', commonBytes2hex(incoming.data, true));

            pmStoreDetails = getObject(incoming.data, MDC_PART_OBJ.MDC_MOC_VMO_PMSTORE);

            if (!pmStoreDetails) {
              // Try resending the association response and try again.
              return self.device.transferOut(self.outEndpointNumber, buildAssociationResponse())
                .then(function () {
                  return promiseRace(timeout(5000), self.device.transferIn(self.inEndpointNumber, 1024));
                })
                .then(function (incomingRetry) {
                  $log.debug('Received extended config', commonBytes2hex(incomingRetry.data, true));
                  pmStoreDetails = getObject(incomingRetry.data, MDC_PART_OBJ.MDC_MOC_VMO_PMSTORE);
                  if (!pmStoreDetails) {
                    throw new Error("Could not parse device config (PM store).");
                  }
                  return incomingRetry;
                });
            }
            invokeId = incoming.data.getUint16(6);
            self.pmStoreHandle = pmStoreDetails.handle;
            return incoming;
          })
          .then(function (incoming) {
            // Step 2: Send a configuration response.
            return self.device.transferOut(self.outEndpointNumber, buildConfigResponse(incoming.data.getUint16(6)))
              .then(function () {
                return incoming;
              });
          })
          .then(function (incoming) {
            // Step 3: Send an MDS attribute request.
            return self.device.transferOut(self.outEndpointNumber, buildMDSAttributeRequest(invokeId))
              .then(function () {
                return self.device.transferIn(self.inEndpointNumber, 1024);
              });
          })
          .then(function (incoming) {
            // Save the raw device details for attribute parsing.
            rawDeviceDetails = incoming.data;
            invokeId = incoming.data.getUint16(6);
            $log.debug('Received MDS attribute response', commonBytes2hex(incoming.data, true));

            // Step 4: Trigger segmented transfer.
            return self.device.transferOut(self.outEndpointNumber, buildActionRequest(invokeId, self.pmStoreHandle));
          })
          .then(function (incoming) {
            return self.device.transferIn(self.inEndpointNumber, 1024);
          })
          .then(function (incoming) {
            self.lastInvokeId = incoming.data.getUint16(6);
            $log.debug('Received action request response', commonBytes2hex(incoming.data, true));

            // Step 5: Parse device attributes using helper functions.
            var decoder = new TextDecoder();
            var deviceAttrList = getAttributeList(rawDeviceDetails);

            // Extract model information.
            var modelData = getAttribute(deviceAttrList, MDC_PART_OBJ.MDC_ATTR_ID_MODEL);
            var modelId = modelData ? decoder.decode(modelData) : "Unknown";
            var re = /(\d+)/g;
            var modelExec = re.exec(modelId);
            var modelNumber = modelExec ? modelExec[1] : "Unknown";

            // Extract production specification to get the serial number.
            var prodSpecData = getAttribute(deviceAttrList, MDC_PART_OBJ.MDC_ATTR_ID_PROD_SPECN);
            var serialStr = "Unknown";
            if (prodSpecData) {
              var serialSpec = getProductionSpecEntry(prodSpecData, 'serial-number');
              if (serialSpec) {
                serialStr = decoder.decode(serialSpec);
              }
            }
            var serialExec = re.exec(serialStr);
            var serialNumber = serialExec ? serialExec[1] : "Unknown";

            // Extract the absolute time attribute from the device.
            var timeData = getAttribute(deviceAttrList, MDC_PART_OBJ.MDC_ATTR_TIME_ABS);
            var deviceTime = null;
            if (timeData) {
              // For example, suppose the device time is encoded as YYYYMMDDHHmm (10 digits)
              var timestampHex = commonBytes2hex(timeData, true).replace(/\s/g, "");
              var year = parseInt(timestampHex.slice(0, 4), 10);
              var month = parseInt(timestampHex.slice(4, 6), 10);
              var day = parseInt(timestampHex.slice(6, 8), 10);
              var hour = parseInt(timestampHex.slice(8, 10), 10);
              var minute = parseInt(timestampHex.slice(10, 12), 10);
              deviceTime = new Date(year, month - 1, day, hour, minute);
            }

            // Save the parsed device details.
            self.deviceDetails = {
              serialNumber: serialNumber,
              modelNumber: modelNumber,
              deviceTime: deviceTime,
              numberOfSegments: (getAttribute(pmStoreDetails, MDC_PART_OBJ.MDC_ATTR_NUM_SEG) ?
                getAttribute(pmStoreDetails, MDC_PART_OBJ.MDC_ATTR_NUM_SEG).getUint16(0) : 0)
            };

            return self.deviceDetails;
          });
      };

      // syncDeviceTime: Sync the meter’s clock with the local system time.
      AccuChekUsb.prototype.syncDeviceTime = function () {
        var self = this;
        var localDate = new Date();
        // pad helper to zero-pad numbers.
        function pad(n, width) {
          width = width || 2;
          n = n.toString();
          return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
        }
        // Format local time as YYYYMMDDHHmmss and append "00" per protocol.
        var timeString =
          '' + localDate.getFullYear() +
          pad(localDate.getMonth() + 1) +
          pad(localDate.getDate()) +
          pad(localDate.getHours()) +
          pad(localDate.getMinutes()) +
          pad(localDate.getSeconds()) + "00";

        // Convert the time string to a BigInt-style value.
        // (Note: BigInt is not available in ES5. Use a workaround if needed.)
        var timestamp;
        try {
          timestamp = BigInt("0x" + timeString);
        } catch (ex) {
          // Fallback: use parseInt on a substring (this may lose precision).
          timestamp = parseInt(timeString, 10);
        }

        return self.device.transferOut(self.outEndpointNumber,
          buildSetTimeRequest(self.lastInvokeId, self.pmStoreHandle, timestamp))
          .then(function () {
            return self.device.transferIn(self.inEndpointNumber, 1024);
          })
          .then(function (incoming) {
            self.lastInvokeId = incoming.data.getUint16(6);
            $log.debug('Received set time response', commonBytes2hex(incoming.data, true));
            if (incoming.data.getUint16(8) !== DATA_ADPU.RESPONSE_CONFIRMED_ACTION) {
              throw new Error("Could not set time on device");
            }

            // Update the stored device time.
            self.deviceDetails.deviceTime = localDate;
          });
      };

      // retrieveData: Retrieve segmented data for BG tests and control solution tests.
      AccuChekUsb.prototype.retrieveData = function () {
        var self = this;

        // Helper function that retrieves and parses data from a given segment.
        function retrieveSegmentData(segment) {
          var pages = [];
          var entries = [];

          return self.device.transferOut(
            self.outEndpointNumber,
            buildDataTransferRequest(self.lastInvokeId, self.pmStoreHandle, segment)
          )
            .then(function () {
              return self.device.transferIn(self.inEndpointNumber, 1024);
            })
            .then(function (incoming) {
              $log.debug("Received data transfer request response for segment " + segment + ":", commonBytes2hex(incoming.data, true));

              // Check for the empty segment response.
              if (incoming.data.byteLength === 22 && incoming.data.getUint16(20)) {
                var dataResponse = incoming.data.getUint16(20);
                if (dataResponse === 3) {
                  return []; // This segment is empty.
                } else {
                  throw new Error("Could not retrieve data: response code " + dataResponse);
                }

              } else if (incoming.data.byteLength < 22 ||
                incoming.data.getUint16(14) !== ACTION_TYPE.MDC_ACT_SEG_TRIG_XFER) {
                throw new Error("Unexpected response during data retrieval for segment " + segment);
              } else {
                var done = false;
                // Chain a loop using a recursive function.
                function handleNextPage() {
                  return self.device.transferIn(self.inEndpointNumber, 1024)
                    .then(function (incomingPage) {
                      pages.push(incomingPage.data);
                      $log.debug("Data from segment " + segment + ":", commonBytes2hex(incomingPage.data, true));

                      var segmentDataResult = new DataView(incomingPage.data.buffer.slice(22, 32));
                      var status = incomingPage.data.getUint8(32);

                      if (status & 0x40) {
                        done = true;
                      }

                      return self.device.transferOut(
                        self.outEndpointNumber,
                        buildDataTransferConfirmation(incomingPage.data.getUint16(6), self.pmStoreHandle, segmentDataResult)
                      )
                        .then(function () {
                          if (!done) {
                            return handleNextPage();
                          }
                        });
                    });
                }
                return handleNextPage();
              }
            })
            .then(function () {
              // Parse each page into data entries.
              pages.forEach(function (page) {
                var offset = 30; // Skip header.
                var entryCount = page.getUint16(offset);
                for (var i = 0; i < entryCount; i++) {
                  // Extract a 6-byte timestamp from the page.
                  var timestampBytes = page.buffer.slice(offset + 6, offset + 12);
                  var timestampHex = Array.prototype.map.call(new Uint8Array(timestampBytes),
                    function (b) {
                      return b.toString(16).padStart(2, '0');
                    }).join('');

                  // Parse date components from the timestamp.
                  var year = parseInt(timestampHex.slice(0, 4), 10);
                  var month = parseInt(timestampHex.slice(4, 6), 10) - 1;
                  var day = parseInt(timestampHex.slice(6, 8), 10);
                  var hour = parseInt(timestampHex.slice(8, 10), 10);
                  var minute = parseInt(timestampHex.slice(10, 12), 10);
                  var dateTime = new Date(year, month, day, hour, minute);

                  // Get the measurement value (located at offset+14).
                  var value = page.getUint16(offset + 14);
                  entries.push({ dateTime: dateTime, value: value });
                  offset += 12; // Move to the next entry.
                }
              });
              return entries;
            });
        } // end retrieveSegmentData

        // Retrieve blood glucose and control solution data (segments 0 and 1).
        return retrieveSegmentData(0)
          .then(function (bloodGlucoseData) {
            return retrieveSegmentData(1)
              .then(function (controlSolutionData) {
                return {
                  bloodGlucoseData: bloodGlucoseData,
                  controlSolutionData: controlSolutionData
                };
              });
          });
      };

      // disconnect: Release the interface and close the device.
      AccuChekUsb.prototype.disconnect = function () {
        var self = this;
        return self.device.transferOut(self.outEndpointNumber, buildAssociationReleaseRequest())
          .then(function () {
            return self.device.transferIn(self.inEndpointNumber, 1024);
          })
          .then(function (incoming) {
            $log.debug('Release response', commonBytes2hex(incoming.data, true));
          })
          .catch(function (err) {
            $log.warn("Error releasing device:", err);
          })
          .then(function () {
            return self.device.releaseInterface(self.interfaceNumber);
          })
          .then(function () {
            return self.device.close();
          });
      };

      /////////////////// Expose the Public API //////////////////////
      // Only public methods are detect, connect, getDeviceInfo, syncDeviceTime, retrieveData, disconnect.
      return AccuChekUsb;
    }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('checkTestStripLotNoAvailability', checkTestStripLotNoAvailability);

    /** @ngInject */
    function checkTestStripLotNoAvailability(msApi, $q) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attr, ngModel) {
                ngModel.$asyncValidators.invalidTestStripLotNo = function(modelValue, viewValue) {
                    var deferred = $q.defer();

                    if (ngModel.$dirty || ngModel.$touched) {
                        var hospitalId = attr.hospitalId;
                        var hospitalIds = attr.hospitalIds ? JSON.parse(attr.hospitalIds) : null;
                        var ignoreId = attr.ignoreId;
                        var lotNo = viewValue;

                        msApi.request('test-strips@get', {
                                hospital_id: hospitalId,
                                'hospital_ids[]': hospitalIds,
                                lot_no: lotNo,
                                ignore_id: ignoreId
                            },
                            // SUCCESS
                            function (response) {
                                if (response.test_strips.length) {
                                    deferred.reject();
                                } else {
                                    deferred.resolve();
                                }
                            },
                            // ERROR
                            function (response) {
                                deferred.reject();
                            }
                        );
                    } else {
                        deferred.resolve();
                    }

                    // return the promise of the asynchronous validator
                    return deferred.promise;
                };
            }
        };
    }
})();
(function() {
  'use strict';

  angular
    .module('app.core')
    .directive('checkInitialsAvailability', checkInitialsAvailabilityDirective);

  /** @ngInject */
  function checkInitialsAvailabilityDirective(msApi, $q) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, element, attr, ngModel) {
        ngModel.$asyncValidators.invalidInitials = function(
          modelValue,
          viewValue
        ) {
          var deferred = $q.defer();
          if (ngModel.$dirty || ngModel.$touched) {
            var hospitalId = attr.hospitalId;
            var ignoreId = attr.ignoreId;
            var initials = viewValue;

            msApi.request(
              'users@get',
              {
                role: 'hospital_operator',
                hospital_id: hospitalId,
                initials: initials,
                ignore_id: ignoreId
              },
              // SUCCESS
              function(response) {
                if (response.users.length) {
                  deferred.reject();
                } else {
                  deferred.resolve();
                }
              },
              // ERROR
              function(response) {
                deferred.reject();
              }
            );
          } else {
            deferred.resolve();
          }

          // return the promise of the asynchronous validator
          return deferred.promise;
        };
      }
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('checkHospitalNameAvailability', checkHospitalNameAvailability);

    /** @ngInject */
    function checkHospitalNameAvailability(msApi, $q) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attr, ngModel) {
                ngModel.$asyncValidators.invalidHospitalName = function(modelValue, viewValue) {
                    var deferred = $q.defer();

                    if (ngModel.$dirty || ngModel.$touched) {
                        var country = attr.country;
                        var ignoreId = attr.ignoreId;
                        var name = viewValue;

                        msApi.request('hospitals@get', {
                                country: country,
                                name: name,
                                ignore_id: ignoreId
                            },
                            // SUCCESS
                            function (response) {
                                if (response.hospitals.length) {
                                    deferred.reject();
                                } else {
                                    deferred.resolve();
                                }
                            },
                            // ERROR
                            function (response) {
                                deferred.reject();
                            }
                        );
                    } else {
                        deferred.resolve();
                    }

                    // return the promise of the asynchronous validator
                    return deferred.promise;
                };
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('checkControlSolutionLotNoAvailability', checkControlSolutionLotNoAvailability);

    /** @ngInject */
    function checkControlSolutionLotNoAvailability(msApi, $q) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attr, ngModel) {
                ngModel.$asyncValidators.invalidControlSolutionLotNo = function(modelValue, viewValue) {
                    var deferred = $q.defer();

                    if (ngModel.$dirty || ngModel.$touched) {
                        var hospitalId = attr.hospitalId;
                        var hospitalIds = attr.hospitalIds ? JSON.parse(attr.hospitalIds) : null;
                        var type = attr.type;
                        var types = attr.types ? JSON.parse(attr.types) : null;
                        var ignoreId = attr.ignoreId;
                        var lotNo = viewValue;

                        msApi.request('control-solutions@get', {
                                hospital_id: hospitalId,
                                'hospital_ids[]': hospitalIds,
                                lot_no: lotNo,
                                type: type,
                                'types[]': types,
                                ignore_id: ignoreId
                            },
                            // SUCCESS
                            function (response) {
                                if (response.control_solutions.length) {
                                    deferred.reject();
                                } else {
                                    deferred.resolve();
                                }
                            },
                            // ERROR
                            function (response) {
                                deferred.reject();
                            }
                        );
                    } else {
                        deferred.resolve();
                    }

                    // return the promise of the asynchronous validator
                    return deferred.promise;

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/toolbar');

        // Api
        msApiProvider.register('profile.settings', ['/profile/settings']);
    }
})();

(function() {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController(
    $rootScope,
    $q,
    $state,
    $timeout,
    $mdSidenav,
    $translate,
    msNavigationService,
    localStorageService,
    $mdDialog,
    $document,
    msApi,
    toastService,
    $window,
    CONFIG,
    $log
  ) {
    var vm = this;

    // Data
    $rootScope.global = {
      search: ''
    };

    vm.bodyEl = angular.element('body');
    vm.userStatusOptions = [
      {
        title: 'Online',
        icon: 'icon-checkbox-marked-circle',
        color: '#4CAF50'
      },
      {
        title: 'Away',
        icon: 'icon-clock',
        color: '#FFC107'
      },
      {
        title: 'Do not Disturb',
        icon: 'icon-minus-circle',
        color: '#F44336'
      },
      {
        title: 'Invisible',
        icon: 'icon-checkbox-blank-circle-outline',
        color: '#BDBDBD'
      },
      {
        title: 'Offline',
        icon: 'icon-checkbox-blank-circle-outline',
        color: '#616161'
      }
    ];

    vm.languages = {
      en: {
        title: 'English',
        translation: 'TOOLBAR.ENGLISH',
        code: 'en',
        iso: 'en'
      },
      es: {
        title: 'Spanish',
        translation: 'TOOLBAR.SPANISH',
        code: 'es',
        iso: 'es'
      },
      ja: {
        title: 'Japanese',
        translation: 'TOOLBAR.JAPANESE',
        code: 'ja',
        iso: 'ja'
      },
      th: {
        title: 'Thai',
        translation: 'TOOLBAR.THAI',
        code: 'th',
        iso: 'th'
      },
      vi: {
        title: 'Vietnamese',
        translation: 'TOOLBAR.VIETNAMESE',
        code: 'vi',
        iso: 'vi'
      },
      'zh-Hant': {
        title: 'Chinese',
        translation: 'TOOLBAR.CHINESE_TRADITIONAL',
        code: 'zh',
        iso: 'zh-Hant'
      }
    };

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    vm.changeLanguage = changeLanguage;
    vm.setUserStatus = setUserStatus;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.search = search;
    vm.searchResultClick = searchResultClick;
    vm.changeSetting = changeSetting;
    vm.help = help;
    vm.openDriverInstaller = openDriverInstaller;
    vm.openDriverExInstaller = openDriverExInstaller;
    vm.openTroubleshootingGuide = openTroubleshootingGuide;
    vm.openConnectivityInstallationGuide = openConnectivityInstallationGuide;
    vm.openImplementationSteps = openImplementationSteps;
    vm.openImplementationWorkbook = openImplementationWorkbook;
    vm.openUserManualHospitalAdmin = openUserManualHospitalAdmin;
    vm.openUserManualOperator = openUserManualOperator;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Select the first status as a default
      vm.userStatus = vm.userStatusOptions[0];

      vm.selectedLanguage = vm.languages[$rootScope.activeLanguage];

      // Get the authenticated user
      vm.user = localStorageService.get('user');

      if (vm.user && vm.user.role.name === 'roche_global_admin') {
        vm.user.icon = 'icon-earth';
      } else if (vm.user && vm.user.role.name === 'roche_country_admin') {
        vm.user.icon = 'icon-account-location';
      } else if (vm.user && vm.user.role.name === 'hospital_admin') {
        vm.user.icon = 'icon-clipboard-account';
      } else if (vm.user && vm.user.role.name === 'hospital_operator') {
        vm.user.icon = 'icon-account-box';
      }

      if ($rootScope.appType === 'intranet') {
        vm.appTypeIcon = 'icon-server-network';
        vm.appTypeTooltip = 'connected to intranet';
      } else if ($rootScope.appType === 'standalone') {
        vm.appTypeIcon = 'icon-close-network';
        vm.appTypeTooltip = 'standalone';
      } else {
        vm.appTypeIcon = 'icon-cloud-check';
        vm.appTypeTooltip = 'connected to cloud server';
      }
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Sets User Status
     * @param status
     */
    function setUserStatus(status) {
      vm.userStatus = status;
    }

    /**
     * Logout Function
     */
    function logout() {
      localStorageService.clearAll();
      $state.go('app.login', {}, { reload: true });
    }

    /**
     * Change Language
     */
    function changeLanguage(lang) {
      vm.selectedLanguage = lang;
      // Change the language
      $translate.use(lang.iso).then(function(data) {
        $window.location.reload();
      });
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }

    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }

    /**
     * Search action
     *
     * @param query
     * @returns {Promise}
     */
    function search(query) {
      var navigation = [],
        flatNavigation = msNavigationService.getFlatNavigation(),
        deferred = $q.defer();

      // Iterate through the navigation array and
      // make sure it doesn't have any groups or
      // none ui-sref items
      for (var x = 0; x < flatNavigation.length; x++) {
        if (flatNavigation[x].uisref) {
          navigation.push(flatNavigation[x]);
        }
      }

      // If there is a query, filter the navigation;
      // otherwise we will return the entire navigation
      // list. Not exactly a good thing to do but it's
      // for demo purposes.
      if (query) {
        navigation = navigation.filter(function(item) {
          if (
            angular.lowercase(item.title).search(angular.lowercase(query)) > -1
          ) {
            return true;
          }
        });
      }

      // Fake service delay
      $timeout(function() {
        deferred.resolve(navigation);
      }, 1000);

      return deferred.promise;
    }

    /**
     * Search result click action
     *
     * @param item
     */
    function searchResultClick(item) {
      // If item has a link
      if (item.uisref) {
        // If there are state params,
        // use them...
        if (item.stateParams) {
          $state.go(item.state, item.stateParams);
        } else {
          $state.go(item.state);
        }
      }
    }

    function changeSetting(e) {
      var dialogData = {
        user: vm.user
      };

      $mdDialog
        .show({
          controller: 'ChangeSettingDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/dialog/change-setting-dialog/change-setting-dialog.html',
          parent: angular.element($document.body),
          targetEvent: e,
          locals: {
            dialogData: dialogData
          }
        })
        .then(function(dialogResponse) {
          updateSetting(dialogResponse.user);
        });
    }

    function updateSetting(user) {
      msApi.request(
        'profile.settings@save',
        user,
        // SUCCESS
        function(response) {
          toastService.show('Settings successfully updated');
          localStorageService.set('user', response.user);
        }
      );
    }

    function help() {
      if (vm.user && vm.user.role.name === 'roche_global_admin') {
        $window.open(CONFIG.host + CONFIG.help_file_global_admin_url, '_blank');
      } else if (vm.user && vm.user.role.name === 'roche_country_admin') {
        $window.open(
          CONFIG.host + CONFIG.help_file_country_admin_url,
          '_blank'
        );
      } else if (vm.user && vm.user.role.name === 'hospital_admin') {
        $window.open(
          CONFIG.host + CONFIG.help_file_hospital_admin_url,
          '_blank'
        );
      } else if (vm.user && vm.user.role.name === 'hospital_operator') {
        $window.open(
          CONFIG.host + CONFIG.help_file_hospital_operator_url,
          '_blank'
        );
      }
    }

    function openDriverInstaller() {
      $window.open(CONFIG.driver_installer_url, '_blank');
    }

    function openDriverExInstaller() {console.log('****');
      $window.open(CONFIG.driver_ex_installer_url, '_blank');
    }

    function openConnectivityInstallationGuide() {
      $window.open(CONFIG.connectivity_installation_guide_url, '_blank');
    }

    function openTroubleshootingGuide() {
      $window.open(CONFIG.troubleshooting_guide_url, '_blank');
    }

    function openImplementationSteps() {
      $window.open(CONFIG.implementation_steps_url, '_blank');
    }

    function openImplementationWorkbook() {
      $window.open(CONFIG.implementation_workbook_url, '_blank');
    }

    function openUserManualHospitalAdmin() {
      $window.open(CONFIG.user_manual_hospital_admin_url, '_blank');
    }

    function openUserManualOperator() {
      $window.open(CONFIG.user_manual_operator_url, '_blank');
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/navigation');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($rootScope, $scope, msNavigationService, localStorageService, CONFIG, $log)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        vm.user = null;

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        init();

        //////////

        function init() {
            msNavigationService.saveItem('dashboard', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('country-admin', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('hospital-admin', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('hospital', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('qc-failed-log', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('location', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('meter', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('test-strip', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('control-solution', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('current-lot', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('hospital-operator', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('qc-report-single', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('qc-report-multiple', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('qc-report-hospital', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('test-strip-model', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('test-strip-consumption', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('blood-glucose-test', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('active-hospitals', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('upload', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('manual-qc-data', {class : '', hidden: function() {return true;}});
            msNavigationService.saveItem('send-data', {class : '', hidden: function() {return true;}});

            vm.user = localStorageService.get('user');

            if (vm.user && vm.user.role.name === 'roche_global_admin') {
                setupGlobalAdminNavigation();
            } else if (vm.user && vm.user.role.name === 'roche_country_admin') {
                setupCountryAdminNavigation();
            } else if(vm.user && vm.user.role.name === 'hospital_admin'){
                setupHospitalAdminNavigation();
            } else if(vm.user && vm.user.role.name === 'hospital_operator'){
                setupHospitalOperatorNavigation();
            }
        }

        function setupGlobalAdminNavigation() {
            msNavigationService.saveItem('country-admin', {hidden: function() {return false;}});
            msNavigationService.saveItem('test-strip-model', {class : 'border-bottom', hidden: function() {return false;}});
            msNavigationService.saveItem('qc-report-single', {hidden: function() {return false;}});
            msNavigationService.saveItem('qc-report-multiple', {hidden: function() {return false;}});
            msNavigationService.saveItem('qc-report-hospital', {class : 'border-bottom', hidden: function() {return false;}});
            msNavigationService.saveItem('test-strip-consumption', {hidden: function() {return false;}});
            msNavigationService.saveItem('blood-glucose-test', {hidden: function() {return false;}});
            msNavigationService.saveItem('active-hospitals', {hidden: function() {return false;}});
        }

        function setupCountryAdminNavigation() {
            msNavigationService.saveItem('hospital', {hidden: function() {return false;}});
            msNavigationService.saveItem('hospital-admin', {class : 'border-bottom', hidden: function() {return false;}});
            msNavigationService.saveItem('meter', {hidden: function() {return false;}});
            msNavigationService.saveItem('test-strip', {hidden: function() {return false;}});
            msNavigationService.saveItem('control-solution', {class : 'border-bottom', hidden: function() {return false;}});
            msNavigationService.saveItem('qc-report-single', {hidden: function() {return false;}});
            msNavigationService.saveItem('qc-report-mfr-control-limits', {hidden: function() {return (_.indexOf(CONFIG.qc_report_mfr_control_limits_supported_countries, vm.user.country) === -1);}});
            msNavigationService.saveItem('qc-report-multiple', {hidden: function() {return false;}});
            msNavigationService.saveItem('qc-report-hospital', {class : 'border-bottom', hidden: function() {return false;}});
            msNavigationService.saveItem('test-strip-consumption', {hidden: function() {return false;}});
            msNavigationService.saveItem('blood-glucose-test', {hidden: function() {return false;}});
            msNavigationService.saveItem('active-hospitals', {hidden: function() {return false;}});
        }

        function setupHospitalAdminNavigation() {
            msNavigationService.saveItem('dashboard', {hidden: function() {return (_.indexOf(vm.user.available_modules, 'dashboard') === -1);}});
            msNavigationService.saveItem('qc-failed-log', {class : 'border-bottom', hidden: function() {return (_.indexOf(vm.user.available_modules, 'log') === -1);}});
            msNavigationService.saveItem('location', {hidden: function() {return (_.indexOf(vm.user.available_modules, 'location') === -1);}});
            msNavigationService.saveItem('meter', {hidden: function() {return (_.indexOf(vm.user.available_modules, 'meter') === -1);}});
            msNavigationService.saveItem('test-strip', {hidden: function() {return (_.indexOf(vm.user.available_modules, 'test-strip') === -1);}});
            msNavigationService.saveItem('control-solution', {class : 'border-bottom', hidden: function() {return (_.indexOf(vm.user.available_modules, 'control-solution') === -1);}});
            msNavigationService.saveItem('current-lot', {hidden: function() {return (_.indexOf(vm.user.available_modules, 'current-lot') === -1);}});
            msNavigationService.saveItem('hospital-operator', {class : 'border-bottom', hidden: function() {return (_.indexOf(vm.user.available_modules, 'hospital-operator') === -1);}});
            msNavigationService.saveItem('qc-report-single', {hidden: function() {return (_.indexOf(vm.user.available_modules, 'qc-report-single') === -1);}});
            msNavigationService.saveItem('qc-report-mfr-control-limits', {hidden: function() {return (_.indexOf(CONFIG.qc_report_mfr_control_limits_supported_countries, vm.user.country) === -1 || _.indexOf(vm.user.available_modules, 'qc-report-mfr-control-limits') === -1);}});
            msNavigationService.saveItem('qc-report-multiple', {hidden: function() {return (_.indexOf(vm.user.available_modules, 'qc-report-multiple') === -1);}});
            msNavigationService.saveItem('qc-report-hospital', {class : 'border-bottom', hidden: function() {return (_.indexOf(vm.user.available_modules, 'qc-report-hospital') === -1);}});
            msNavigationService.saveItem('test-strip-consumption', {hidden: function() {return (_.indexOf(vm.user.available_modules, 'test-strip-consumption') === -1);}});
            msNavigationService.saveItem('blood-glucose-test', {hidden: function() {return (_.indexOf(vm.user.available_modules, 'blood-glucose-test') === -1);}});
            msNavigationService.saveItem('upload', {hidden: function() {return (_.indexOf(vm.user.available_modules, 'upload-meter-data') === -1);}});
            msNavigationService.saveItem('manual-qc-data', {hidden: function() {return (_.indexOf(CONFIG.manual_qc_data_supported_countries, vm.user.country) === -1 || _.indexOf(vm.user.available_modules, 'manual-qc-data') === -1);}});
            msNavigationService.saveItem('send-data', {hidden: function() {return $rootScope.appType === 'cloud';}});
        }

        function setupHospitalOperatorNavigation() {
            msNavigationService.saveItem('current-lot', {hidden: function() {return (_.findIndex(CONFIG.hospital_modules, function(m) { return m.name == 'current-lot' && _.indexOf(m.forRoles, 'hospital_operator') > -1; }) === -1);}});
            msNavigationService.saveItem('qc-report-single', {hidden: function() {return (_.findIndex(CONFIG.hospital_modules, function(m) { return m.name == 'qc-report-single' && _.indexOf(m.forRoles, 'hospital_operator') > -1; }) === -1);}});
            msNavigationService.saveItem('qc-report-mfr-control-limits', {hidden: function() {return (_.indexOf(CONFIG.qc_report_mfr_control_limits_supported_countries, vm.user.country) === -1 || _.indexOf(vm.user.available_modules, 'qc-report-mfr-control-limits') === -1);}});
            msNavigationService.saveItem('test-strip-consumption', {hidden: function() {return (_.findIndex(CONFIG.hospital_modules, function(m) { return m.name == 'test-strip-consumption' && _.indexOf(m.forRoles, 'hospital_operator') > -1; }) === -1);}});
            msNavigationService.saveItem('blood-glucose-test', {hidden: function() {return (_.findIndex(CONFIG.hospital_modules, function(m) { return m.name == 'blood-glucose-test' && _.indexOf(m.forRoles, 'hospital_operator') > -1; }) === -1);}});
            msNavigationService.saveItem('upload', {hidden: function() {return (_.findIndex(CONFIG.hospital_modules, function(m) { return m.name == 'upload' && _.indexOf(m.forRoles, 'hospital_operator') > -1; }) === -1);}});
            msNavigationService.saveItem('manual-qc-data', {hidden: function() {return (_.indexOf(CONFIG.manual_qc_data_supported_countries, vm.user.country) === -1 || _.findIndex(CONFIG.hospital_modules, function(m) { return m.name == 'manual-qc-data' && _.indexOf(m.forRoles, 'hospital_operator') > -1; }) === -1 || _.indexOf(vm.user.hospitals[0].default_modules, 'manual-qc-data') === -1);}});
        }

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.page', [
            'app.page.installer'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State definitions
        $stateProvider
            .state('page', {
                abstract: true
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/page');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.page')
        .controller('PageController', PageController);

    /** @ngInject */
    function PageController($rootScope, $scope, toastService, $timeout, $translate, localStorageService, $state, $log)
    {
        // Data
        var vm = this;

        //////////


        // Get the selected language directly from angular-translate module setting
        $rootScope.activeLanguage = $translate.use() ||
            $translate.storage().get($translate.storageKey()) ||
            $translate.preferredLanguage();

        translate();

        function translate() {
            $translate([
                'PAGE.MESSAGES.INVALID_CREDENTIAL',
                'PAGE.MESSAGES.OLD_PASSWORD_MISMATCH',
                'PAGE.MESSAGES.INTERNAL_SERVER_ERROR'
            ]).then(function(translations) {
                $rootScope.messages = {
                    invalidCredential: translations['PAGE.MESSAGES.INVALID_CREDENTIAL'],
                    oldPasswordMismatch: translations['PAGE.MESSAGES.OLD_PASSWORD_MISMATCH'],
                    internalServerError: translations['PAGE.MESSAGES.INTERNAL_SERVER_ERROR']
                };
            });
        }

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        $scope.$on('msApi::requestStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        $scope.$on('msApi::requestSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            }, 500);
        });

        $scope.$on('msApi::requestError', function (event, response)
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            }, 500);

            if (response.status === 422) {
                var data = _.values(response.data);
                _.forEach(data, function (error) {
                    toastService.error(error[0]);
                });
            }else if (response.status === 401 || response.status === 403 || response.status === 404) {
                localStorageService.clearAll();
                $state.go('app.login');
                return toastService.error($rootScope.messages.invalidCredential);
            } else{
                return toastService.error($rootScope.messages.internalServerError);
            }
        });

        $scope.$on('msApi::resolveStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        $scope.$on('msApi::resolveSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            }, 500);
        });

        $scope.$on('msApi::resolveError', function (event, response)
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            }, 500);

            if (response.status === 422) {
                var data = _.values(response.data);
                _.forEach(data, function (error) {
                    toastService.error(error[0]);
                });
            }else if (response.status === 401 || response.status === 403 || response.status === 404) {
                localStorageService.clearAll();
                $state.go('app.login');
                return toastService.error($rootScope.messages.invalidCredential);
            } else {
                return toastService.error($rootScope.messages.internalServerError);
            }
        });

        $scope.$on('$destroy', function ()
        {
        });

    }
})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            'app.quick-panel',

            // Sample
            //'app.sample',

            'app.dialog',

            'app.page',
            'app.auth',
            'app.profile',
            'app.dashboard',
            'app.user',
            'app.hospital',
            'app.location',
            'app.meter',
            'app.test-strip',
            'app.control-solution',
            'app.current-lot',
            'app.qc-report',
            'app.active-hospitals',
            'app.test-strip-consumption',
            'app.manual-qc-data',
            'app.upload-meter-data',
            'app.log',
            'app.test-strip-model',
            'app.blood-glucose-test',
            'app.send-data'
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController(appTypeData, cloudShareHostData, api, msApi, $scope, $rootScope, toastService, $timeout, $translate, angularLoad, localStorageService, $state, $log)
    {
        // Data
        var vm = this;

        //////////

        $rootScope.appType = appTypeData.app_type;
        $rootScope.cloudShareHost = cloudShareHostData.cloud_share_host;
        api.setBaseUrl($rootScope.cloudShareHost);

        // Get the selected language directly from angular-translate module setting
        $rootScope.activeLanguage = $translate.use() ||
            $translate.storage().get($translate.storageKey()) ||
            $translate.preferredLanguage();

        translate();
        loadPdfFonts();

        function translate() {
            $translate([
                'MAIN.MESSAGES.INVALID_CREDENTIAL',
                'MAIN.MESSAGES.OLD_PASSWORD_MISMATCH',
                'MAIN.MESSAGES.INTERNAL_SERVER_ERROR'
            ]).then(function(translations) {
                $rootScope.messages = {
                    invalidCredential: translations['MAIN.MESSAGES.INVALID_CREDENTIAL'],
                    oldPasswordMismatch: translations['MAIN.MESSAGES.OLD_PASSWORD_MISMATCH'],
                    internalServerError: translations['MAIN.MESSAGES.INTERNAL_SERVER_ERROR']
                };
            });
        }

        function loadPdfFonts() {
            var fontName = 'pdfmake/' + $rootScope.activeLanguage.replace('-', '_') + '_vfs_fonts.js';

            angularLoad.loadScript(fontName).then(function(response) {
                if ($rootScope.activeLanguage === 'en' || $rootScope.activeLanguage === 'vi') {
                    pdfMake.fonts = {
                        pdfFont: {
                            normal: 'Roboto-Regular.ttf',
                            bold: 'Roboto-Medium.ttf',
                            italics: 'Roboto-Regular.ttf',
                            bolditalics: 'Roboto-Medium.ttf'
                        }
                    };
                } else if($rootScope.activeLanguage === 'zh-Hant') {
                    pdfMake.fonts = {
                        pdfFont: {
                            normal: 'SourceHanSerifCN-Regular.ttf',
                            bold: 'SourceHanSerifCN-Regular.ttf',
                            italics: 'SourceHanSerifCN-Regular.ttf',
                            bolditalics: 'SourceHanSerifCN-Regular.ttf'
                        }
                    };
                } else if($rootScope.activeLanguage === 'th') {
                    pdfMake.fonts = {
                        pdfFont: {
                            normal: 'TH-Sarabun-New-Regular.ttf',
                            bold: 'TH-Sarabun-New-Bold.ttf',
                            italics: 'TH-Sarabun-New-Regular.ttf',
                            bolditalics: 'TH-Sarabun-New-Bold.ttf'
                        }
                    };
                } else if($rootScope.activeLanguage === 'ja') {
                    pdfMake.fonts = {
                        pdfFont: {
                            normal: 'ipaexm.ttf',
                            bold: 'ipaexm.ttf',
                            italics: 'ipaexm.ttf',
                            bolditalics: 'ipaexm.ttf'
                        }
                    };
                }

            });
        }

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        $scope.$on('msApi::requestStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        $scope.$on('msApi::requestSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            }, 500);
        });

        $scope.$on('msApi::requestError', function (event, response)
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            }, 500);

            if (response.status === 422) {
                var data = _.values(response.data);
                _.forEach(data, function (error) {
                    toastService.error(error[0]);
                });
            }else if (response.status === 401 || response.status === 403 || response.status === 404) {
                localStorageService.clearAll();
                $state.go('app.login');
                return toastService.error($rootScope.messages.invalidCredential);
            } else{
                return toastService.error($rootScope.messages.internalServerError);
            }
        });

        $scope.$on('msApi::resolveStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        $scope.$on('msApi::resolveSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            }, 500);
        });

        $scope.$on('msApi::resolveError', function (event, response)
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            }, 500);

            if (response.status === 422) {
                var data = _.values(response.data);
                _.forEach(data, function (error) {
                    toastService.error(error[0]);
                });
            }else if (response.status === 401 || response.status === 403 || response.status === 404) {
                localStorageService.clearAll();
                $state.go('app.login');
                return toastService.error($rootScope.messages.invalidCredential);
            } else {
                return toastService.error($rootScope.messages.internalServerError);
            }
        });

        $scope.$on('$destroy', function ()
        {
        });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig,
                      $rootScope, $state, jwtHelper, authManager, localStorageService, CONFIG, $log)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }

        if (!localStorageService.get('rememberMe')) {
            localStorageService.setStorageType('sessionStorage');
        }

        // Validation on state change
        $rootScope.$on('$stateChangeStart', function(e, to) {
            // Allow public upload without authentication
            if (to.name === 'app.uploadPublic') {
                return;
            }

            var user = localStorageService.get('user');
            if (to.data && to.data.roles) {
                if(!user || _.indexOf(to.data.roles, user.role.name) === -1) {
                    e.preventDefault();
                    localStorageService.clearAll();
                    $state.go('app.login');
                }
            }
        });

        // Responding to an Expired Token on Page Refresh
        $rootScope.$on('tokenHasExpired', function(e) {
            e.preventDefault();
            localStorageService.clearAll();
            $state.go('app.login');
        });

        authManager.checkAuthOnRefresh();
        authManager.redirectWhenUnauthenticated();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .constant('CONFIG', {
            'host': '',
            'url': '/api',
            'upload_meter_data_url': '/upload-meter-data',
            'upload_meter_data_api_key': 'y89vau37h6pt4wfu9cu6nsxg2nqmv89b',
            'help_file_global_admin_url': '/help-file-global-admin',
            'help_file_country_admin_url': '/help-file-country-admin',
            'help_file_hospital_admin_url': '/help-file-hospital-admin',
            'help_file_hospital_operator_url': '/help-file-hospital-operator',
            'driver_installer_url': 'https://s3.ap-southeast-1.amazonaws.com/accu-chekqconline.com/connection-manager-1.0.18.0.zip',
            'driver_ex_installer_url': 'https://s3.ap-southeast-1.amazonaws.com/accu-chekqconline.com/additional-ac-drivers.zip',
            'troubleshooting_guide_url': 'https://s3.ap-southeast-1.amazonaws.com/accu-chekqconline.com/troubleshooting-for-problems-in-uploading-meter-data.pdf',
            'connectivity_installation_guide_url': 'https://s3.ap-southeast-1.amazonaws.com/accu-chekqconline.com/connectivity-installation-guide.pdf',
            'implementation_steps_url': 'https://s3.ap-southeast-1.amazonaws.com/accu-chekqconline.com/overview-of-implementation-steps.pdf',
            'implementation_workbook_url': 'https://s3.ap-southeast-1.amazonaws.com/accu-chekqconline.com/hospital-implementation-workbook.pdf',
            'user_manual_hospital_admin_url': 'https://s3.ap-southeast-1.amazonaws.com/accu-chekqconline.com/user-manual-for-hospital-admin.pdf',
            'user_manual_operator_url': 'https://s3.ap-southeast-1.amazonaws.com/accu-chekqconline.com/user-manual-for-operator.pdf',
            'annotation_color': 'rgba(244,67,54, 0.6)',
            'hospital_modules': [
                {
                    name: 'dashboard',
                    state: 'app.dashboard',
                    forRoles: ['hospital_admin']
                },
                {
                    name: 'log',
                    state: 'app.qc-failed-log',
                    forRoles: ['hospital_admin']
                },
                {
                    name: 'location',
                    state: 'app.location',
                    forRoles: ['hospital_admin']
                },
                {
                    name:  'meter',
                    state: 'app.meter',
                    forRoles: ['hospital_admin']
                },
                {
                    name: 'test-strip',
                    state: 'app.test-strip',
                    forRoles: ['hospital_admin']
                },
                {
                    name: 'control-solution',
                    state: 'app.control-solution',
                    forRoles: ['hospital_admin']
                },
                {
                    name:  'current-lot',
                    state: 'app.current-lot',
                    forRoles: ['hospital_admin', 'hospital_operator']
                },
                {
                    name:  'hospital-operator',
                    state: 'app.hospital-operator',
                    forRoles: ['hospital_admin']
                },
                {
                    name:  'qc-report-single',
                    state: 'app.qc-report-single-level1',
                    forRoles: ['hospital_admin', 'hospital_operator']
                },
                {
                    name:  'qc-report.mfr-control-limits',
                    state: 'app.qc-report.mfr-control-limits-level1',
                    forRoles: ['hospital_admin', 'hospital_operator']
                },
                {
                    name:  'qc-report-multiple',
                    state: 'app.qc-report-multiple-level1',
                    forRoles: ['hospital_admin']
                },
                {
                    name:  'qc-report-hospital',
                    state: 'app.qc-report-hospital-sdchart',
                    forRoles: ['hospital_admin']
                },
                {
                    name:  'test-strip-consumption',
                    state: 'app.test-strip-consumption',
                    forRoles: ['hospital_admin', 'hospital_operator']
                },
                {
                    name:  'blood-glucose-test',
                    state: 'app.blood-glucose-test',
                    forRoles: ['hospital_admin', 'hospital_operator']
                },
                {
                    name:  'upload-meter-data',
                    state: 'app.upload',
                    forRoles: ['hospital_admin', 'hospital_operator']
                },
                {
                    name:  'manual-qc-data',
                    state: 'app.manual-qc-data',
                    forRoles: ['hospital_admin', 'hospital_operator']
                }
            ],
            'manual_qc_data_supported_countries': ['TH'],
            'qc_report_mfr_control_limits_supported_countries': ['PK']
        })
        .constant('_', window._);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider,
                    fuseConfigProvider, $mdThemingProvider, msApiProvider,
                    localStorageServiceProvider,  $httpProvider, jwtOptionsProvider,
                    $mdDateLocaleProvider, ChartJsProvider, $translatePartialLoaderProvider,
                    CONFIG)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        // custom theme
        $mdThemingProvider.theme('error-toast');

        // msApiProvider configurations
        msApiProvider.setBaseUrl(CONFIG.host + CONFIG.url);

        // LocalStorageModule configurations
        localStorageServiceProvider.setPrefix('roche-poct-phase3');

        // angular-jwt configurations
        jwtOptionsProvider.config({
            whiteListedDomains: ['roche-poct.dev', 'localhost', '127.0.0.1'],
            unauthenticatedRedirectPath: '/login',
            unauthenticatedRedirector: ['$state', function($state) {
                $state.go('app.login');
            }],
            tokenGetter: ['localStorageService', function(localStorageService) {
                return  localStorageService.get('token');
            }]
        });


        $httpProvider.interceptors.push('jwtInterceptor');

        // Date format
        $mdDateLocaleProvider.formatDate = function(date) {
            if (date) {
                return moment(date).format('YYYY-MM-DD');
            }
            return date;
        };

        $mdDateLocaleProvider.parseDate = function(dateString) {
            var m = moment(dateString, 'YYYY-MM-DD', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        ChartJsProvider.setOptions({ chartColors : [
            '#29b6f6',
            '#ffca28',
            '#66bb6a',
            '#ff7043',

            '#5c6bc0',
            '#ffa726',
            '#26a69a',
            '#ec407a',

            '#8d6e63',
            '#bdbdbd',
            '#78909c',
            '#7e57c2'
        ]});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main');

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $log)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            // $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            // $timeout(function ()
            // {
            //     $rootScope.loadingProgress = false;
            // }, 1000);
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);
        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
            // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                },
                resolve: {
                    countriesData: function(msApi) {
                        return msApi.request('countries@get');
                    },
                    statesData: function(msApi) {
                        return msApi.request('states@get');
                    },
                    appTypeData: function (msApi) {
                        return msApi.request('app-type@get');
                    },
                    cloudShareHostData: function (msApi) {
                        return msApi.request('cloud-share-host@get');
                    },
                    installed: function(msApi, $state, localStorageService) {
                        return msApi.request('installer.installed@get',
                            {},
                            function (response) {
                                if (!response.installed) {
                                    localStorageService.clearAll();
                                    return $state.go('page.installer');
                                }
                            });
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider, msApiProvider)
    {
        // Put your common app configurations here

        // angular-translate configuration

        var langMap = {
            'en_*': 'en',
            'es_*': 'es',
            'zh': 'zh-Hant',
            'zh_*': 'zh-Hant'
        };

        $translateProvider
            .useLoader('$translatePartialLoader', {
                urlTemplate: '{part}/i18n/{lang}.json'
            })
            .useSanitizeValueStrategy()
            .registerAvailableLanguageKeys(['en', 'zh-Hant', 'vi', 'th', 'ja', 'es'], langMap)
            .determinePreferredLanguage()
            .fallbackLanguage('en')
            .useLocalStorage();

        msApiProvider.register('user', ['/user']);
        msApiProvider.register('countries', ['/countries']);
        msApiProvider.register('states', ['/states']);
        msApiProvider.register('app-type', ['/app_type']);
        msApiProvider.register('cloud-share-host', ['/cloud_share_host']);
        msApiProvider.register('installer.installed', ['/installer/installed']);
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, $log)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {
            setBaseUrl: setBaseUrl,
            getBaseUrl: getBaseUrl,
            getCloudLink: getCloudLink,
            sendData: sendData
        };

        // Base Url
        api.baseUrl = '';

        //api.sample = $resource(api.baseUrl + 'sample/sample.json');


        function setBaseUrl(url)
        {
            api.baseUrl = url;
        }

        function getBaseUrl() {
            return api.baseUrl;
        }

        function getCloudLink() {
            return $resource(api.baseUrl + '/api/cloud_links/cloud_link');
        }

        function sendData() {
            return $resource(api.baseUrl + '/api/cloud_links/send_data');
        }

        return api;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital.cvchart', [
            'app.qc-report.hospital.cvchart.level1',
            'app.qc-report.hospital.cvchart.level2'
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.multiple', [
            'app.qc-report.multiple.level1',
            'app.qc-report.multiple.level2',
            'app.qc-report.multiple.combined',
            'app.qc-report.multiple.logbook'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/multiple');

        // Navigation
        msNavigationServiceProvider.saveItem('qc-report-multiple', {
            title : 'QC Reports for Multiple Meters',
            icon  : 'icon-chart-line',
            weight: 18,
            translate: 'QC_REPORT_MULTIPLE.NAV'
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.single', [
            'app.qc-report.single.level1',
            'app.qc-report.single.level2',
            'app.qc-report.single.combined',
            'app.qc-report.single.logbook'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/single');

        // Navigation
        msNavigationServiceProvider.saveItem('qc-report-single', {
            title : 'QC Reports for Single Meter',
            icon  : 'icon-chart-line',
            weight: 13,
            translate: 'QC_REPORT_SINGLE.NAV'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report.mfr-control-limits', [
            'app.qc-report.mfr-control-limits.level1',
            'app.qc-report.mfr-control-limits.level2'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/mfr-control-limits');

        // Navigation
        msNavigationServiceProvider.saveItem('qc-report-mfr-control-limits', {
            title : 'QC Reports vs. Mfr Control Limits',
            icon  : 'icon-chart-line',
            weight: 13,
            translate: 'QC_REPORT_MFR_CONTROL_LIMITS.NAV'
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.qc-report.hospital', [
            'app.qc-report.hospital.cvchart',
            'app.qc-report.hospital.sdchart',
            'app.qc-report.hospital.qcperformance'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/qc-report/hospital');

        // Navigation
        msNavigationServiceProvider.saveItem('qc-report-hospital', {
            title : 'Hospital Overview',
            icon  : 'icon-chart-line',
            weight: 22,
            translate: 'QC_REPORT_HOSPITAL.NAV'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.profile.update-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.update-password', {
            url      : '/update-password',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-with-toolbar.html',
                    controller : 'MainController as vm'
                },
                'content@app.update-password': {
                    templateUrl: 'app/main/profile/update-password/update-password.html',
                    controller : 'UpdatePasswordController as vm'
                },
                'toolbar@app.update-password'   : {
                    templateUrl: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                    controller : 'ToolbarController as vm'
                }
            },
            data: {
                requiresLogin: true
            },
            bodyClass: 'update-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/profile/update-password');

        // Api
        msApiProvider.register('profile.password', ['/profile/password']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.user', [
            'app.user.country-admin',
            'app.user.hospital-admin',
            'app.user.hospital-operator'
        ])
})();
(function ()
{
    'use strict';

    angular
        .module('app.qc-report', [
            'app.qc-report.single',
            'app.qc-report.mfr-control-limits',
            'app.qc-report.multiple',
            'app.qc-report.hospital'
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.log', [
            'app.log.qc-failed'
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth', [
            'app.auth.login'
        ])
})()
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" ms-scroll md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/dialog/change-operator-dialog/change-operator-dialog.html","<md-dialog class=\"change-operator\" aria-label=\"Change Operator\"><form name=\"operatorForm\" novalidate ng-cloak>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\" translate=\"CHANGE_OPERATOR_DIALOG.TITLE\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"{{ \'DIALOG.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><p ng-if=\"vm.operator\" class=\"pb-10\" \ntranslate=\"CHANGE_OPERATOR_DIALOG.SELECT_ONE_TO_CHANGE\" \ntranslate-values=\"{ name: vm.operator.name , initials: vm.operator.initials }\"></p><p ng-if=\"!vm.operator\" \nclass=\"pb-10\" translate=\"CHANGE_OPERATOR_DIALOG.SELECT_ONE\"></p><md-input-container class=\"md-block\" flex><label \ntranslate=\"CHANGE_OPERATOR_DIALOG.OPERATOR\"></label><md-select name=\"operator\" ng-model=\"vm.selectedOperator\" \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-value=\"null\" translate=\"CHANGE_OPERATOR_DIALOG.NONE\">\n</md-option><md-option ng-value=\"operator\" ng-repeat=\"operator in vm.operators\">\n{{ operator.name }} - {{ operator.initials }}</md-option></md-select></md-input-container></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.save()\" class=\"md-accent md-raised\" \nng-disabled=\"operatorForm.$invalid || operatorForm.$pristine\" translate=\"DIALOG.SAVE\" \naria-label=\"{{ \'DIALOG.SAVE\' | translate }}\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/dialog/action-log-dialog/action-log-dialog.html","<md-dialog class=\"action-log\" aria-label=\"Action Log\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ACTION_LOG_DIALOG.TITLE\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" \naria-label=\"{{ \'DIALOG.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><form name=\"vm.logForm\" novalidate><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label translate=\"ACTION_LOG_DIALOG.LOCATION_CODE\"></label><input name=\"location\" \nng-model=\"vm.meter.location.code\" disabled=\"disabled\"></md-input-container><md-input-container flex><label \ntranslate=\"ACTION_LOG_DIALOG.METER_SERIAL_NO\"></label><input name=\"meter\" ng-model=\"vm.meter.serial_no\" \ndisabled=\"disabled\"></md-input-container></div><div ng-if=\"!vm.isReadOnly\" layout=\"row\" \nclass=\"adjust-row-margin-in-form\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"ACTION_LOG_DIALOG.COMMENTS\"></label><textarea ng-model=\"vm.message\" rows=\"1\" md-maxlength=\"255\"></textarea>\n</md-input-container><div class=\"log-submit\" layout=\"row\" layout-align=\"end center\"><md-button \nng-disabled=\"vm.logForm.$invalid || vm.logForm.$pristine || !vm.message\" ng-click=\"vm.submit()\" \ntranslate=\"ACTION_LOG_DIALOG.SUBMIT\" aria-label=\"{{ \'ACTION_LOG_DIALOG.SUBMIT\' | translate }}\"></md-button></div></div>\n</form><md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head><tr md-row><th md-column><span \ntranslate=\"ACTION_LOG_DIALOG.COLUMNS.DATE_TIME\"></span></th><th md-column><span \ntranslate=\"ACTION_LOG_DIALOG.COLUMNS.CREATED_BY\"></span></th><th md-column><span \ntranslate=\"ACTION_LOG_DIALOG.COLUMNS.COMMENTS\"></span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"vm.logs.length === 0\"><td md-cell colspan=\"3\"><div class=\"hint-text font-weight-300 text-center\" \ntranslate=\"ACTION_LOG_DIALOG.NO_ACTION_LOG\"></div></td></tr><tr md-row ng-repeat=\"log in vm.logs\" \nng-class=\"{\'animate-slide-right\': (log.new)}\"><td md-cell nowrap=\"nowrap\">\n{{ log.created_at | date:\'yyyy-MM-dd hh:mma\' }}</td><td md-cell nowrap=\"nowrap\">{{ log.user.name }}</td><td md-cell>\n{{ log.message }}</td></tr></tbody></table></md-table-container><md-table-pagination \nmd-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" \nmd-page=\"vm.pagination.current_page\" md-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getActionLog\" \nmd-page-select></md-table-pagination></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.close()\" \nclass=\"md-accent md-raised\" translate=\"DIALOG.CLOSE\" aria-label=\"{{ \'DIALOG.CLOSE\' | translate }}\"></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/dialog/change-setting-dialog/change-setting-dialog.html","<md-dialog class=\"change-setting-dialog\" aria-label=\"Settings\"><form name=\"userForm\" novalidate ng-cloak><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Settings</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Close dialog\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p class=\"text-bold\">\nPreferred Measurement Unit</p><md-radio-group ng-model=\"vm.preferred_measurement_unit\"><md-radio-button \nvalue=\"MMOL_PER_L\">mmol/L</md-radio-button><md-radio-button value=\"MG_PER_DL\">mg/dL</md-radio-button></md-radio-group>\n</md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.save()\" class=\"md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"userForm.$invalid || userForm.$pristine\">SAVE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/dialog/cloud-share-dialog/cloud-share-dialog.html","<md-dialog class=\"cloud-share-dialog\" aria-label=\"Cloud Share\"><form name=\"userForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\" translate=\"CLOUD_SHARE_DIALOG.TITLE\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"pb-10\"><md-checkbox ng-model=\"vm.cloudLink.is_cloud_link_enabled\" \naria-label=\"Enable\" ng-change=\"vm.enableChanged()\"><span translate=\"CLOUD_SHARE_DIALOG.ENABLE\"></span> <span \nclass=\"text-bold\">{{ vm.hospital.name }}</span></md-checkbox></div><md-input-container class=\"md-block\" flex><label \ntranslate=\"CLOUD_SHARE_DIALOG.NOTES\"></label><input type=\"text\" ng-model=\"vm.cloudLink.cloud_link_key\" \nng-disabled=\"!vm.cloudLink.is_cloud_link_enabled\" readonly=\"readonly\"></md-input-container><div><md-button \nng-disabled=\"!vm.cloudLink.is_cloud_link_enabled\" class=\"md-accent\" type=\"button\" \naria-label=\"{{ \'CLOUD_SHARE_DIALOG.REGENERATE\' | translate }}\" ng-click=\"vm.regenerate()\"><span \ntranslate=\"CLOUD_SHARE_DIALOG.REGENERATE\"></span></md-button><md-button \nng-disabled=\"!vm.cloudLink.is_cloud_link_enabled\" class=\"md-accent md-raised\" type=\"button\" ngclipboard \ndata-clipboard-text=\"{{ vm.cloudLink.cloud_link_key }}\" ngclipboard-success=\"vm.copied = true\" \naria-label=\"{{ \'CLOUD_SHARE_DIALOG.COPY\' | translate }}\"><span translate=\"CLOUD_SHARE_DIALOG.COPY\"></span></md-button>\n<span class=\"text-boxed grey-400-bg white-fg\" ng-if=\"vm.copied\" translate=\"CLOUD_SHARE_DIALOG.COPIED\"></span></div>\n</md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.close()\" class=\"md-accent md-raised\" \ntranslate=\"DIALOG.CLOSE\" aria-label=\"{{ \'DIALOG.CLOSE\' | translate }}\"></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/dialog/complete-install-dialog/complete-install-dialog.html","<md-dialog class=\"complete-install-dialog\" aria-label=\"Complete Install\"><form name=\"userForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"COMPLETE_INSTALL_DIALOG.TITLE\"></span></div>\n</md-toolbar><md-dialog-content ms-scroll><p class=\"text-semibold\">Accu-Chek Quest is successfully installed.</p><p>\nPlease copy the default password and go to login page.</p><p><span class=\"text-bold\" \ntranslate=\"COMPLETE_INSTALL_DIALOG.EMAIL\"></span>{{ vm.user.email }}</p><p><span class=\"text-bold\" \ntranslate=\"COMPLETE_INSTALL_DIALOG.PASSWORD\"></span>{{ vm.user.password }}</p><p \ntranslate=\"COMPLETE_INSTALL_DIALOG.NOTE\"></p><md-button class=\"md-accent md-raised\" type=\"button\" ngclipboard \ndata-clipboard-text=\"{{ vm.user.password }}\" ngclipboard-success=\"vm.copied = true\" \naria-label=\"{{ \'COMPLETE_INSTALL_DIALOG.COPY\' | translate }}\"><span translate=\"COMPLETE_INSTALL_DIALOG.COPY\"></span>\n</md-button><span class=\"text-boxed grey-400-bg white-fg\" ng-if=\"vm.copied\" translate=\"COMPLETE_INSTALL_DIALOG.COPIED\">\n</span></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.close()\" class=\"md-accent md-raised\" \nng-disabled=\"!vm.copied\">Go to Login Page</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/dialog/copy-password-dialog/copy-password-dialog.html","<md-dialog class=\"copy-password-dialog\" aria-label=\"Copy Password\"><form name=\"userForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"COPY_PASSWORD_DIALOG.TITLE\"></span></div>\n</md-toolbar><md-dialog-content><p><span class=\"text-bold\" translate=\"COPY_PASSWORD_DIALOG.EMAIL\"></span>\n{{ vm.user.email }}</p><p><span class=\"text-bold\" translate=\"COPY_PASSWORD_DIALOG.PASSWORD\"></span>{{ vm.password }}\n</p><p translate=\"COPY_PASSWORD_DIALOG.NOTE\"></p><md-button class=\"md-accent md-raised\" type=\"button\" ngclipboard \ndata-clipboard-text=\"{{ vm.password }}\" ngclipboard-success=\"vm.copied = true\" \naria-label=\"{{ \'COPY_PASSWORD_DIALOG.COPY\' | translate }}\"><span translate=\"COPY_PASSWORD_DIALOG.COPY\"></span>\n</md-button><span class=\"text-boxed grey-400-bg white-fg\" ng-if=\"vm.copied\" translate=\"COPY_PASSWORD_DIALOG.COPIED\">\n</span></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.close()\" class=\"md-accent md-raised\" \nng-disabled=\"!vm.copied\" translate=\"DIALOG.CLOSE\" aria-label=\"{{ \'DIALOG.CLOSE\' | translate }}\"></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/dialog/confirm-dialog/confirm-dialog.html","<md-dialog class=\"confirm-dialog\" aria-label=\"Edit Notes\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span ng-if=\"vm.title\" class=\"title\">\n{{ vm.title }}</span> <span ng-if=\"!vm.title\" class=\"title\" translate=\"CONFIRM_DIALOG.TITLE\"></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"{{ \'CONFIRM_DIALOG.CLOSE\' | translate }}\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p class=\"pb-10\">\n{{ vm.message }}</p></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.ok()\" class=\"md-accent md-raised\" \ntranslate=\"CONFIRM_DIALOG.OK\" aria-label=\"{{ \'CONFIRM_DIALOG.OK\' | translate }}\"></md-button><md-button \nng-click=\"vm.cancel()\" class=\"font-size-12 font-weight-300 md-accent\" translate=\"CONFIRM_DIALOG.CANCEL\" \naria-label=\"{{ \'CONFIRM_DIALOG.CANCEL\' | translate }}\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/dialog/edit-qc-data-dialog/edit-qc-data-dialog.html","<md-dialog class=\"edit-qc-data\" aria-label=\"Edit QC Value\"><form name=\"editQcDataForm\" novalidate ng-cloak><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"EDIT_QC_DATA_DIALOG.TITLE\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" \naria-label=\"{{ \'DIALOG.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\" flex><label>\n{{ \'EDIT_QC_DATA_DIALOG.QC_VALUE\' | translate }}&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})\n</label><input name=\"qcValue\" type=\"number\" step=\"any\" min=\"0\" ng-model=\"vm.qcValue\" ng-disabled=\"vm.isReadOnly\" \nrequired><div ng-messages=\"editQcDataForm.qcValue.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\" \ntranslate=\"EDIT_QC_DATA_DIALOG.INPUT_MESSAGES.QC_VALUE_REQUIRED\"></div><div ng-message=\"min\" \ntranslate=\"EDIT_QC_DATA_DIALOG.INPUT_MESSAGES.QC_VALUE_MIN\"></div></div></md-input-container></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.remove()\" class=\"font-size-12 font-weight-300 md-accent\" \ntranslate=\"EDIT_QC_DATA_DIALOG.DELETE\" aria-label=\"{{ \'EDIT_QC_DATA_DIALOG.DELETE\' | translate }}\"></md-button>\n<md-button ng-if=\"!vm.isReadOnly\" ng-click=\"vm.save()\" class=\"md-accent md-raised\" \nng-disabled=\"editQcDataForm.$invalid || editQcDataForm.$pristine\" translate=\"DIALOG.SAVE\" \naria-label=\"{{ \'DIALOG.SAVE\' | translate }}\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/dialog/edit-notes-dialog/edit-notes-dialog.html","<md-dialog class=\"edit-notes\" aria-label=\"Edit Notes\"><form name=\"notesForm\" novalidate ng-cloak><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"EDIT_NOTES_DIALOG.TITLE\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" \naria-label=\"{{ \'DIALOG.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container ng-if=\"vm.notes || !vm.readonly\" class=\"md-block\" flex>\n<label class=\"hidden\" translate=\"EDIT_NOTES_DIALOG.TITLE\"></label><textarea ng-model=\"vm.notes\" rows=\"1\" \nmd-maxlength=\"255\" ng-disabled=\"vm.readonly\"></textarea></md-input-container><div ng-if=\"!vm.notes && vm.readonly\" \nclass=\"text-center\"><p class=\"hint-text font-size-18 font-weight-300\" translate=\"EDIT_NOTES_DIALOG.EMPTY_TEXT\"></p>\n</div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.save()\" class=\"md-accent md-raised\" \nng-disabled=\"notesForm.$invalid || notesForm.$pristine\" translate=\"DIALOG.SAVE\" \naria-label=\"{{ \'DIALOG.SAVE\' | translate }}\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/dialog/enter-cloud-share-key-dialog/enter-cloud-share-key-dialog.html","<md-dialog class=\"enter-cloud-share-key\" aria-label=\"Enter Cloud Share Key\"><form name=\"vm.cloudShareKeyForm\" \nnovalidate ng-cloak><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"ENTER_CLOUD_SHARE_KEY_DIALOG.TITLE\"></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"{{ \'DIALOG.CLOSE\' | translate }}\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nng-if=\"!vm.cloudLink\"><p class=\"pb-10\" translate=\"ENTER_CLOUD_SHARE_KEY_DIALOG.ENTER_KEY_MESSAGE\"></p>\n<md-input-container class=\"md-block\" flex><label translate=\"ENTER_CLOUD_SHARE_KEY_DIALOG.CLOUD_SHARE_KEY\"></label>\n<input name=\"key\" ng-model=\"vm.key\" required><div ng-messages=\"vm.cloudShareKeyForm.key.$error\"><div \nng-message=\"required\" translate=\"ENTER_CLOUD_SHARE_KEY_DIALOG.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container><p class=\"md-warn\" ng-if=\"vm.invalidKey\" \ntranslate=\"ENTER_CLOUD_SHARE_KEY_DIALOG.KEY_INVALID_MESSAGE\"></p></div><div ng-if=\"vm.cloudLink && !vm.contactAdmin\"><p\n class=\"pb-10\"><span translate=\"ENTER_CLOUD_SHARE_KEY_DIALOG.CONFIRM_MESSAGE\" \ntranslate-values=\"{ hospital: vm.cloudLink.hospital.name }\"></span></p></div><div \nng-if=\"vm.cloudLink && vm.contactAdmin\"><p class=\"pb-10\"><span \ntranslate=\"ENTER_CLOUD_SHARE_KEY_DIALOG.CONTACT_ADMIN_MESSAGE\" \ntranslate-values=\"{ hospital: vm.cloudLink.hospital.name }\"></span></p></div></md-dialog-content><md-dialog-actions>\n<md-button ng-if=\"vm.cloudLink && vm.contactAdmin\" ng-click=\"vm.close()\" class=\"md-accent\" translate=\"DIALOG.CLOSE\" \naria-label=\"{{ \'DIALOG.CLOSE\' | translate }}\"></md-button><md-button ng-if=\"vm.cloudLink && !vm.contactAdmin\" \nng-click=\"vm.notConfirmed()\" class=\"md-accent\" translate=\"DIALOG.NO\" aria-label=\"{{ \'DIALOG.NO\' | translate }}\">\n</md-button><md-button ng-if=\"vm.cloudLink && !vm.contactAdmin\" ng-click=\"vm.confirmed()\" class=\"md-accent\" \ntranslate=\"DIALOG.YES\" aria-label=\"{{ \'DIALOG.YES\' | translate }}\"></md-button><md-button ng-if=\"!vm.cloudLink\" \nng-click=\"vm.save()\" class=\"md-accent md-raised\" \nng-disabled=\"vm.cloudShareKeyForm.$invalid || vm.cloudShareKeyForm.$pristine\" translate=\"DIALOG.SAVE\" \naria-label=\"{{ \'DIALOG.SAVE\' | translate }}\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/dialog/enter-reason-dialog/enter-reason-dialog.html","<md-dialog class=\"enter-reason\" aria-label=\"Edit Notes\"><form name=\"reasonForm\" novalidate ng-cloak><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"ENTER_REASON_DIALOG.TITLE\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" \naria-label=\"{{ \'DIALOG.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><p class=\"pb-10\" translate=\"ENTER_REASON_DIALOG.REASON\"></p>\n<md-input-container class=\"md-block\" flex><label class=\"hidden\" translate=\"ENTER_REASON_DIALOG.TITLE\"></label><textarea\n ng-model=\"vm.reason\" name=\"reason\" rows=\"1\" md-maxlength=\"255\" required></textarea><div \nng-messages=\"reasonForm.reason.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"ENTER_REASON_DIALOG.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.close()\" class=\"md-accent md-raised\" translate=\"DIALOG.CANCEL\" \naria-label=\"{{ \'DIALOG.CANCEL\' | translate }}\"></md-button><md-button ng-click=\"vm.save()\" \nclass=\"font-size-12 font-weight-300 md-accent\" ng-disabled=\"reasonForm.$invalid || reasonForm.$pristine\" \ntranslate=\"ENTER_REASON_DIALOG.CONFIRM\" aria-label=\"{{ \'ENTER_REASON_DIALOG.CONFIRM\' | translate }}\"></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/active-hospitals/active-hospitals.html","<div id=\"active-hospitals\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"ACTIVE_HOSPITALS.TITLE\"></div><div ng-if=\"vm.role === \'roche_global_admin\'\" \nclass=\"font-size-14 font-weight-200\">Global</div><div ng-if=\"vm.role === \'roche_country_admin\'\" \nclass=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}</div></div></div><div class=\"content\"><div \nlayout=\"column\"><active-hospitals-global-admin ng-if=\"vm.role === \'roche_global_admin\'\" \nall-countries=\"vm.allCountries\"></active-hospitals-global-admin><active-hospitals-country-admin \nng-if=\"vm.role === \'roche_country_admin\'\" country=\"vm.user.country\" all-states=\"vm.allStates\">\n</active-hospitals-country-admin></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/dialog/terms-of-use-dialog/terms-of-use-dialog.html","<md-dialog class=\"terms-of-use\" aria-label=\"Terms of Use\"><form name=\"termsOfUseForm\" novalidate ng-cloak><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"TERMS_OF_USE_DIALOG.TITLE\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" \naria-label=\"{{ \'DIALOG.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"text-italic mb-16\">Last updated on 19 September 2017</div><div \nlayout=\"row\" layout-align=\"start\" class=\"pv-8\"><div class=\"w-48\">1.</div><div>\nThese Terms of Use apply to the Accu-Chek Quest Online Application (\"Roche Application\").</div></div><div layout=\"row\" \nlayout-align=\"start\" class=\"pv-8\"><div class=\"w-48\">2.</div><div>\nThe Terms of Use, together with the Offer (where available) (collectively, the \"Agreement\"), form the entire agreement for the use of the Roche Application. An \"Offer\" is a written proposal which may be submitted by Roche Diabetes Care Asia Pacific Pte. Ltd. or any of its affiliates (\"Roche\") to the healthcare institution (the \"Licensee\") and accepted by the Licensee containing details in respect of the Roche Application, including but not limited to information regarding the fees and costs, number of users, meters supported and the IT infrastructure for the Roche Application.\n</div></div><div layout=\"row\" layout-align=\"start\" class=\"pv-8\"><div class=\"w-48\">3.</div><div>\nBy accessing or otherwise using the Roche Application, the Licensee and its Users (as defined below) agree to be bound by the terms of the Agreement. The Licensee and its Users further agree that the Agreement is the complete statement of the Agreement between the Licensee, its Users and Roche, and supersedes any proposal or prior agreement, oral or written, any other communications between the Licensee, its Users and Roche relating to the subject matter of this Agreement.\n</div></div><div layout=\"row\" layout-align=\"start\" class=\"pv-8\"><div class=\"w-48\">4.</div><div>\nThe Roche Application is owned and maintained by Roche. All original content, features, and functionality of the Roche Application are owned by Roche and may be protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws. The Licensee will indemnify and hold harmless Roche from any losses, damages, claims and expenses (including, without limitation, reasonable legal expenses) relating to any infringement of the rights of Roche or any third party caused by the Licensee, its officers, employees, consultants, agents or its Users (as defined below).\n</div></div><div layout=\"row\" layout-align=\"start\" class=\"pv-8\"><div class=\"w-48\">5.</div><div><div>\nSubject to the terms of the Agreement, Roche grants the Licensee and its Users (as defined below) a non-exclusive, non-transferable right to use the Roche Application to support quality management for point-of-care glucose testing using the Accu-Chek Blood Glucose Monitoring System. The Licensee agrees that no person shall access and use the Roche Application save for healthcare professionals who have been authorized by the Licensee and have undergone training in using the Roche Application (the \"Users\"). Users are authenticated by the entry of a user ID and a personal password.\n</div><div class=\"pt-8\">The Licensee and Users shall not:</div><div class=\"pt-8\"><div layout=\"row\" \nlayout-align=\"start\"><div class=\"w-32\">(a)</div><div>\ncopy, sell, or otherwise transfer the Roche Application or assign its rights under this Agreement, in whole or in part, to another party without the prior consent of Roche;\n</div></div><div layout=\"row\" layout-align=\"start\" class=\"pt-8\"><div class=\"w-32\">(b)</div><div>\nrent, distribute, license or sublicense the Roche Application;</div></div><div layout=\"row\" layout-align=\"start\" \nclass=\"pt-8\"><div class=\"w-32\">(c)</div><div>create derivative works based on the Roche Application; and</div></div>\n<div layout=\"row\" layout-align=\"start\" class=\"pt-8\"><div class=\"w-32\">(d)</div><div>\nmodify in any form, adapt, reproduce, translate, reverse engineer, decompile or disassemble the Roche Application.\n</div></div></div><div class=\"pt-8\">\nRoche reserves all rights not expressly granted herein, including, but not limited to, the rights to market or provide the use of the Roche Application to other third parties.\n</div></div></div><div layout=\"row\" layout-align=\"start\" class=\"pv-8\"><div class=\"w-48\">6.</div><div>\nNo patient personal data shall be captured in the Roche Application. The Licensee and Users agree that the Roche Application solely processes and stores the data relating to meter, test strip, control solution, operator, quality control and blood glucose results. By submitting information on the Roche Application, the Licensee and Users consent to the collection, processing, use and disclosure of that information by Roche for any purpose, including, but not limited to, to the optimization of Roche\'s service and analysis of meter performance.\n</div></div><div layout=\"row\" layout-align=\"start\" class=\"pv-8\"><div class=\"w-48\">7.</div><div>\nThe Roche Application is provided \"as is\". Roche, to the fullest extent permitted by law, disclaims all warranties, either expressed or implied, statutory or otherwise, including but not limited to implied warranties of merchantability, non-infringement of third parties’ rights, and fitness for a particular purpose. Roche makes no representation or warranty as to the Roche Application or as to the results to be attained by the Licensee, its Users or any third party from the Roche Application. Specifically, Roche makes no representations or warranties that the Roche Application will be available, uninterrupted, error free or free of viruses or other harmful components. The Licensee and its Users acknowledge that they have not relied upon any representations or warranties made by Roche except for those expressly and specifically set forth in this Agreement.\n</div></div><div layout=\"row\" layout-align=\"start\" class=\"pv-8\"><div class=\"w-48\">8.</div><div>\nTo the fullest extent permitted by applicable law, neither Roche, any of its affiliates, assigns, or each of their officers, directors, employees or agents, nor any other party involved in creating, producing or delivering the Roche Application shall be liable for any damages to the Licensee, Users or any third party, including without limitation:\n<div class=\"pt-8\"><div layout=\"row\" layout-align=\"start\"><div class=\"w-32\">(a)</div><div>\nincidental, consequential, special, indirect, or punitive damages;</div></div><div layout=\"row\" layout-align=\"start\" \nclass=\"pt-8\"><div class=\"w-32\">(b)</div><div>personal injury or wrongful death;</div></div><div layout=\"row\" \nlayout-align=\"start\" class=\"pt-8\"><div class=\"w-32\">(c)</div><div>\ndamages resulting from the use or inability to use the Roche Application or the content;</div></div><div layout=\"row\" \nlayout-align=\"start\" class=\"pt-8\"><div class=\"w-32\">(d)</div><div>\ndamages resulting from any failure of performance, error, omission, interruption, delay or defect in operation or transmission of the Roche Application; and\n</div></div><div layout=\"row\" layout-align=\"start\" class=\"pt-8\"><div class=\"w-32\">(e)</div><div>\ndamages arising directly or indirectly from any computer virus, and any loss of use, loss of data, loss of profits or any business interruption directly or indirectly arising out of or in relation to the Roche Application.\n</div></div></div></div></div><div layout=\"row\" layout-align=\"start\" class=\"pv-8\"><div class=\"w-48\">9.</div><div>\nThe Licensee and its Users agree to indemnify, defend and hold harmless Roche, its officers, directors, employees, subcontractors and agents from and against all losses, expenses, claims, damages and costs, including reasonable attorneys\' fees, resulting from any violation of the Agreement.\n</div></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.close()\" class=\"md-accent md-raised\" \ntranslate=\"DIALOG.CLOSE\" aria-label=\"{{ \'DIALOG.CLOSE\' | translate }}\"></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/blood-glucose-test/blood-glucose-test.html","<div id=\"blood-glucose-test\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"BLOOD_GLUCOSE_TEST.TITLE\"></div><div ng-if=\"vm.role === \'roche_global_admin\'\" \nclass=\"font-size-14 font-weight-200\">Global</div><div ng-if=\"vm.role === \'roche_country_admin\'\" \nclass=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}</div><div \nng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\" layout=\"row\" layout-align=\"start center\">\n<md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu md-position-mode=\"right bottom\" \nmd-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" class=\"md-raised\" ng-click=\"$mdMenu.open()\" \naria-label=\"{{ \'BLOOD_GLUCOSE_TEST.EXPORT\' | translate }}\"><div layout=\"row\"><span \ntranslate=\"BLOOD_GLUCOSE_TEST.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon\"></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-delimited\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.exportToCSV()\" translate=\"BLOOD_GLUCOSE_TEST.CSV\" \naria-label=\"{{ \'BLOOD_GLUCOSE_TEST.EXPORT\' | translate }}\"></md-button></md-menu-item><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-file-excel\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToExcel()\" \ntranslate=\"BLOOD_GLUCOSE_TEST.EXCEL\" aria-label=\"{{ \'BLOOD_GLUCOSE_TEST.EXCEL\' | translate }}\"></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div><div class=\"content\"><div layout=\"column\">\n<blood-glucose-test-global-admin loaded=\"vm.loaded\" valid=\"vm.valid\" ng-if=\"vm.role === \'roche_global_admin\'\" \nall-countries=\"vm.allCountries\" all-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\">\n</blood-glucose-test-global-admin><blood-glucose-test-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'roche_country_admin\'\" country=\"vm.user.country\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\"></blood-glucose-test-country-admin><blood-glucose-test-hospital-admin \nloaded=\"vm.loaded\" valid=\"vm.valid\" ng-if=\"vm.role === \'hospital_admin\'\" hospital=\"vm.user.hospitals[0]\">\n</blood-glucose-test-hospital-admin><blood-glucose-test-hospital-operator loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'hospital_operator\'\" hospital=\"vm.user.hospitals[0]\" locations=\"vm.locations\">\n</blood-glucose-test-hospital-operator></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/control-solution/control-solution.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"CONTROL_SOLUTION.TITLE\"></div><div ng-if=\"vm.isCountryAdmin\" class=\"font-size-14 font-weight-200\">\n{{ vm.countries[vm.user.country] }}</div><div ng-if=\"!vm.isCountryAdmin\" layout=\"row\" layout-align=\"start center\">\n<md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu md-position-mode=\"left bottom\" \nmd-offset=\"0 2\"><md-button class=\"md-raised\" ng-click=\"$mdMenu.open()\" \naria-label=\"{{ \'CONTROL_SOLUTION.EXPORT\' | translate }}\"><div layout=\"row\"><span translate=\"CONTROL_SOLUTION.EXPORT\">\n</span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-delimited\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.exportToCSV()\" translate=\"CONTROL_SOLUTION.CSV\" aria-label=\"{{ \'CONTROL_SOLUTION.CSV\' | translate }}\">\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-excel\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.exportToExcel()\" translate=\"CONTROL_SOLUTION.EXCEL\" \naria-label=\"{{ \'CONTROL_SOLUTION.EXCEL\' | translate }}\"></md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><md-button ng-if=\"vm.isCountryAdmin\" class=\"md-raised\" ng-click=\"vm.batchCreate($event)\" \ntranslate=\"CONTROL_SOLUTION.BATCH_CREATE\" aria-label=\"{{ \'CONTROL_SOLUTION.BATCH_CREATE\' | translate }}\"></md-button>\n<md-button ng-if=\"!vm.isReadOnly\" class=\"md-raised\" ng-click=\"vm.create($event)\" translate=\"CONTROL_SOLUTION.CREATE\" \naria-label=\"{{ \'CONTROL_SOLUTION.CREATE\' | translate }}\"></md-button></div></div><div class=\"content\"><div \nlayout=\"column\"><div flex ng-if=\"!vm.show\" class=\"text-center\"><p class=\"hint-text font-size-16 font-weight-300\" \ntranslate=\"CONTROL_SOLUTION.LOADING\"></p></div><div \nclass=\"simple-table-container md-whiteframe-4dp animate-slide-right\" ng-if=\"vm.show\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span translate=\"CONTROL_SOLUTION.PANEL_TITLE\"></span><div layout=\"row\" layout-align=\"start center\"><md-select \nng-if=\"vm.isCountryAdmin\" class=\"simplified font-size-14\" ng-model=\"vm.selectedHospital\" \nng-change=\"vm.getControlSolutions()\" aria-label=\"{{ \'CONTROL_SOLUTION.HOSPITAL\' | translate }}\"><md-option \nng-value=\"null\" translate=\"CONTROL_SOLUTION.ALL_HOSPITALS\"></md-option><md-option ng-repeat=\"hospital in vm.hospitals\" \nng-value=\"hospital\">{{ hospital.name }}</md-option></md-select><input class=\"search-input font-size-14\" \nng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" aria-label=\"Search\"><md-button ng-if=\"vm.searchTerm\" \nng-click=\"vm.searchTerm = \'\'; vm.getControlSolutions()\" class=\"cancel-search-input md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.getControlSolutions()\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div></div></md-toolbar><md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head \nmd-order=\"vm.sort\" md-on-reorder=\"vm.getControlSolutions\"><tr md-row><th md-column><span \ntranslate=\"CONTROL_SOLUTION.COLUMNS.CONTROL_LOT\"></span></th><th md-column><span \ntranslate=\"CONTROL_SOLUTION.COLUMNS.CONTROL_TYPE\"></span></th><th md-column md-order-by=\"expiry\"><span \ntranslate=\"CONTROL_SOLUTION.COLUMNS.CONTROL_EXPIRY\"></span></th><th md-column \nng-if=\"vm.isCountryAdmin && !vm.selectedHospital\"><span translate=\"CONTROL_SOLUTION.COLUMNS.HOSPITAL\"></span></th><th \nmd-column><span translate=\"CONTROL_SOLUTION.COLUMNS.CREATED\"></span></th><th md-column><span \ntranslate=\"CONTROL_SOLUTION.COLUMNS.ACTIONS\"></span></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"controlSolution in vm.controlSolutions\"><td md-cell nowrap=\"nowrap\">{{ controlSolution.lot_no }}</td><td \nmd-cell class=\"text-capitalize\">{{ controlSolution.type }}</td><td md-cell nowrap=\"nowrap\"><span \nng-class=\"{\'red-fg\': vm.isExpired(controlSolution)}\">{{ controlSolution.expiry | date:\'yyyy-MM-dd\' }}</span></td><td \nmd-cell class=\"text-capitalize\" ng-if=\"vm.isCountryAdmin && !vm.selectedHospital\">{{ controlSolution.hospital.name }}\n</td><td md-cell><span am-time-ago=\"controlSolution.created_at\"></span></td><td md-cell><md-button \nng-if=\"!(controlSolution.hospital.cloud_link && controlSolution.hospital.cloud_link.is_cloud_link_enabled)\" \nclass=\"edit-button md-icon-button\" ng-click=\"vm.edit(controlSolution, $event)\" \naria-label=\"{{ \'CONTROL_SOLUTION.EDIT\' | translate }}\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button><md-button \nng-if=\"controlSolution.hospital.cloud_link && controlSolution.hospital.cloud_link.is_cloud_link_enabled\" \nclass=\"edit-button md-icon-button\" ng-click=\"vm.view(controlSolution, $event)\" \naria-label=\"{{ \'CONTROL_SOLUTION.EDIT\' | translate }}\"><md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" \nmd-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" \nmd-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getControlSolutions\" md-page-select></md-table-pagination>\n</div></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img \nclass=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">\n©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/current-lot/current-lot.html","<div class=\"page-layout simple tabbed doc-page\" layout=\"column\" ng-cloak><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" translate=\"CURRENT_LOT.TITLE\"></div><div \nlayout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" \nclass=\"s16 white-fg line-height-20\"></md-icon><div flex class=\"ml-8 font-size-14 font-weight-200 line-height-20\">\n{{ vm.user.hospitals[0].name }}</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\">\n<md-menu md-position-mode=\"right bottom\" md-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded\" class=\"md-raised\" \nng-click=\"$mdMenu.open()\" aria-label=\"{{ \'CURRENT_LOT.EXPORT\' | translate }}\"><div layout=\"row\"><span \ntranslate=\"CURRENT_LOT.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon\"></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-delimited\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.exportToCSV()\" translate=\"CURRENT_LOT.CSV\" \naria-label=\"{{ \'CURRENT_LOT.CSV\' | translate }}\"></md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToExcel()\" \ntranslate=\"CURRENT_LOT.EXCEL\" aria-label=\"{{ \'CURRENT_LOT.EXCEL\' | translate }}\"></md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab \nlabel=\"{{ \'CURRENT_LOT.CURRENT.TAB_TITLE\' | translate }}\"><div layout=\"column\"><form name=\"vm.filterForm\" \nclass=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><md-input-container class=\"md-block\" \nflex=\"40\"><label translate=\"CURRENT_LOT.METER_SERIAL_NO\"></label><md-select md-on-close=\"vm.meterSelectionOnClose()\" \nmd-container-class=\"multi-column-select\" name=\"meter\" ng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.meterChanged()\" required><md-select-header><input flex \nng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" ng-change=\"vm.searchMeters()\" \nng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button ng-if=\"vm.searchTerm\" \nng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"CURRENT_LOT.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-if=\"vm.loaded\" class=\"widget-group animate-slide-right mt-10\" layout=\"row\"><ms-widget\n layout=\"column\" class=\"no-padding\" flex><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" translate=\"CURRENT_LOT.CURRENT.TEST_STRIP\"></div><div \nclass=\"pv-8\"><md-button class=\"edit-button md-icon-button\" ng-disabled=\"vm.isReadOnly\" \nng-click=\"vm.changeTestStrip($event)\" aria-label=\"{{ \'CURRENT_LOT.EDIT\' | translate }}\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></div></div><div class=\"p-16\" layout=\"column\"><div \nclass=\"h4 secondary-text text-bold\" translate=\"CURRENT_LOT.CURRENT.STRIP_LOT\"></div><div \nclass=\"pt-8 h3 font-weight-300\"><span ng-if=\"vm.currentTestStrip\">{{ vm.currentTestStrip.lot_no }}</span> <span \nng-if=\"!vm.currentTestStrip\" class=\"text-italic\" translate=\"CURRENT_LOT.CURRENT.NOT_SPECIFIED\"></span></div></div><div \nclass=\"p-16\" layout=\"column\"><div class=\"h4 secondary-text text-bold\" translate=\"CURRENT_LOT.CURRENT.EXPIRE_ON\"></div>\n<div class=\"pt-8 h3 font-weight-300\"><span ng-if=\"vm.currentTestStrip\">\n{{ vm.currentTestStrip.expiry | date:\'yyyy-MM-dd\' }}</span> <span ng-if=\"!vm.currentTestStrip\" class=\"text-italic\" \ntranslate=\"CURRENT_LOT.CURRENT.NOT_SPECIFIED\"></span></div></div><div class=\"p-16\" layout=\"column\"><div \nclass=\"h4 secondary-text text-bold\" translate=\"CURRENT_LOT.CURRENT.CHANGED_DATE\"></div><div \nclass=\"pt-8 h3 font-weight-300\"><span ng-if=\"vm.currentTestStrip\">\n{{ vm.currentTestStrip.pivot.changed_at | date:\'yyyy-MM-dd hh:mma\' }}</span> <span ng-if=\"!vm.currentTestStrip\" \nclass=\"text-italic\" translate=\"CURRENT_LOT.CURRENT.NOT_SPECIFIED\"></span></div></div></ms-widget-front></ms-widget>\n<ms-widget layout=\"column\" class=\"no-padding margin-horizontal-20\" flex><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" \ntranslate=\"CURRENT_LOT.CURRENT.CONTROL_SOLUTION_LEVEL1\"></div><div class=\"pv-8\"><md-button \nclass=\"edit-button md-icon-button\" ng-disabled=\"vm.isReadOnly\" ng-click=\"vm.changeControlSolution1($event)\" \naria-label=\"{{ \'CURRENT_LOT.EDIT\' | translate }}\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></div></div><div class=\"p-16\" layout=\"column\"><div class=\"h4 secondary-text text-bold\" \ntranslate=\"CURRENT_LOT.CURRENT.CONTROL_LOT\"></div><div class=\"pt-8 h3 font-weight-300\"><span \nng-if=\"vm.currentControlSolution1\">{{ vm.currentControlSolution1.lot_no }}</span> <span \nng-if=\"!vm.currentControlSolution1\" class=\"text-italic\" translate=\"CURRENT_LOT.CURRENT.NOT_SPECIFIED\"></span></div>\n</div><div class=\"p-16\" layout=\"column\"><div class=\"h4 secondary-text text-bold\" \ntranslate=\"CURRENT_LOT.CURRENT.EXPIRE_ON\"></div><div class=\"pt-8 h3 font-weight-300\"><span \nng-if=\"vm.currentControlSolution1\">{{ vm.currentControlSolution1.expiry | date:\'yyyy-MM-dd\' }}</span> <span \nng-if=\"!vm.currentControlSolution1\" class=\"text-italic\" translate=\"CURRENT_LOT.CURRENT.NOT_SPECIFIED\"></span></div>\n</div><div class=\"p-16\" layout=\"column\"><div class=\"h4 secondary-text text-bold\" \ntranslate=\"CURRENT_LOT.CURRENT.CHANGED_DATE\"></div><div class=\"pt-8 h3 font-weight-300\"><span \nng-if=\"vm.currentControlSolution1\">{{ vm.currentControlSolution1.pivot.changed_at | date:\'yyyy-MM-dd hh:mma\' }}</span> \n<span ng-if=\"!vm.currentControlSolution1\" class=\"text-italic\" translate=\"CURRENT_LOT.CURRENT.NOT_SPECIFIED\"></span>\n</div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" class=\"no-padding\" flex><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" \ntranslate=\"CURRENT_LOT.CURRENT.CONTROL_SOLUTION_LEVEL2\"></div><div class=\"pv-8\"><md-button \nclass=\"edit-button md-icon-button\" ng-disabled=\"vm.isReadOnly\" ng-click=\"vm.changeControlSolution2($event)\" \naria-label=\"{{ \'CURRENT_LOT.EDIT\' | translate }}\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></div></div><div class=\"p-16\" layout=\"column\"><div class=\"h4 secondary-text text-bold\" \ntranslate=\"CURRENT_LOT.CURRENT.CONTROL_LOT\"></div><div class=\"pt-8 h3 font-weight-300\"><span \nng-if=\"vm.currentControlSolution2\">{{ vm.currentControlSolution2.lot_no }}</span> <span \nng-if=\"!vm.currentControlSolution2\" class=\"text-italic\" translate=\"CURRENT_LOT.CURRENT.NOT_SPECIFIED\"></span></div>\n</div><div class=\"p-16\" layout=\"column\"><div class=\"h4 secondary-text text-bold\" \ntranslate=\"CURRENT_LOT.CURRENT.EXPIRE_ON\"></div><div class=\"pt-8 h3 font-weight-300\"><span \nng-if=\"vm.currentControlSolution2\">{{ vm.currentControlSolution2.expiry | date:\'yyyy-MM-dd\' }}</span> <span \nng-if=\"!vm.currentControlSolution2\" class=\"text-italic\" translate=\"CURRENT_LOT.CURRENT.NOT_SPECIFIED\"></span></div>\n</div><div class=\"p-16\" layout=\"column\"><div class=\"h4 secondary-text text-bold\" \ntranslate=\"CURRENT_LOT.CURRENT.CHANGED_DATE\"></div><div class=\"pt-8 h3 font-weight-300\"><span \nng-if=\"vm.currentControlSolution2\">{{ vm.currentControlSolution2.pivot.changed_at | date:\'yyyy-MM-dd hh:mma\' }}</span> \n<span ng-if=\"!vm.currentControlSolution2\" class=\"text-italic\" translate=\"CURRENT_LOT.CURRENT.NOT_SPECIFIED\"></span>\n</div></div></ms-widget-front></ms-widget></div></div></md-tab><md-tab \nlabel=\"{{ \'CURRENT_LOT.HISTORY.TAB_TITLE\' | translate }}\"><div layout=\"column\"><form name=\"vm.filterForm\" \nclass=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><md-input-container class=\"md-block\" \nflex=\"40\"><label translate=\"CURRENT_LOT.METER_SERIAL_NO\"></label><md-select md-on-close=\"vm.meterSelectionOnClose()\" \nmd-container-class=\"multi-column-select\" name=\"meter\" ng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.meterChanged()\" required><md-select-header><input flex \nng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" ng-change=\"vm.searchMeters()\" \nng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button ng-if=\"vm.searchTerm\" \nng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"CURRENT_LOT.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-if=\"vm.loaded\" class=\"animate-slide-right\" layout=\"row\"><div \nclass=\"mv-10 simple-table-container md-whiteframe-1dp\" flex=\"70\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\"><span translate=\"CURRENT_LOT.HISTORY.TEST_STRIPS\"></span></div></md-toolbar>\n<md-table-container><table md-table md-progress=\"vm.promiseTestStrip\"><thead md-head md-order=\"vm.sortTestStrip\" \nmd-on-reorder=\"vm.getTestStripHistory\"><tr md-row><th md-column md-order-by=\"pivot_changed_at\"><span \ntranslate=\"CURRENT_LOT.HISTORY.CHANGED\"></span></th><th md-column><span translate=\"CURRENT_LOT.HISTORY.STRIP_LOT\">\n</span></th><th md-column ng-if=\"!vm.isReadOnly\"><span translate=\"CURRENT_LOT.HISTORY.ACTIONS\"></span></th></tr>\n</thead><tbody md-body><tr md-row ng-repeat=\"item in vm.testStripHistory\"><td md-cell>\n{{ item.pivot.changed_at | date:\'yyyy-MM-dd hh:mma\' }}</td><td md-cell nowrap=\"nowrap\">{{ item.lot_no }}</td><td \nmd-cell ng-if=\"!vm.isReadOnly\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.editTestStripHistory(item, $event)\" aria-label=\"{{ \'CURRENT_LOT.EDIT\' | translate }}\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.paginationTestStrip.per_page\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"vm.paginationTestStrip.current_page\" \nmd-total=\"{{ vm.paginationTestStrip.total }}\" md-on-paginate=\"vm.getTestStripHistory\" md-page-select>\n</md-table-pagination></div></div><div ng-if=\"vm.loaded\" class=\"animate-slide-right\" layout=\"row\"><div \nclass=\"mv-15 simple-table-container md-whiteframe-1dp\" flex=\"70\"><md-toolbar class=\"md-table-toolbar md-default\"><div \nclass=\"md-toolbar-tools\"><span translate=\"CURRENT_LOT.HISTORY.CONTROL_SOLUTIONS_LEVEL1\"></span></div></md-toolbar>\n<md-table-container><table md-table md-progress=\"vm.promiseControlSolution1\"><thead md-head \nmd-order=\"vm.sortControlSolution1\" md-on-reorder=\"vm.getControlSolution1History\"><tr md-row><th md-column \nmd-order-by=\"pivot_changed_at\"><span translate=\"CURRENT_LOT.HISTORY.CHANGED\"></span></th><th md-column><span \ntranslate=\"CURRENT_LOT.HISTORY.CONTROL_LOT\"></span></th><th md-column ng-if=\"!vm.isReadOnly\"><span \ntranslate=\"CURRENT_LOT.HISTORY.ACTIONS\"></span></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"item in vm.controlSolution1History\"><td md-cell>{{ item.pivot.changed_at | date:\'yyyy-MM-dd hh:mma\' }}</td>\n<td md-cell nowrap=\"nowrap\">{{ item.lot_no }}</td><td md-cell ng-if=\"!vm.isReadOnly\"><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.editControlSolution1History(item, $event)\" \naria-label=\"{{ \'CURRENT_LOT.EDIT\' | translate }}\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" \nmd-limit=\"vm.paginationControlSolution1.per_page\" md-limit-options=\"[5, 10, 15]\" \nmd-page=\"vm.paginationControlSolution1.current_page\" md-total=\"{{ vm.paginationControlSolution1.total }}\" \nmd-on-paginate=\"vm.getControlSolution1History\" md-page-select></md-table-pagination></div></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right\" layout=\"row\"><div class=\"mv-10 simple-table-container md-whiteframe-1dp\" flex=\"70\">\n<md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span \ntranslate=\"CURRENT_LOT.HISTORY.CONTROL_SOLUTIONS_LEVEL2\"></span></div></md-toolbar><md-table-container><table md-table \nmd-progress=\"vm.promiseControlSolution2\"><thead md-head md-order=\"vm.sortControlSolution2\" \nmd-on-reorder=\"vm.getControlSolution2History\"><tr md-row><th md-column md-order-by=\"pivot_changed_at\"><span \ntranslate=\"CURRENT_LOT.HISTORY.CHANGED\"></span></th><th md-column><span translate=\"CURRENT_LOT.HISTORY.CONTROL_LOT\">\n</span></th><th md-column ng-if=\"!vm.isReadOnly\"><span translate=\"CURRENT_LOT.HISTORY.ACTIONS\"></span></th></tr>\n</thead><tbody md-body><tr md-row ng-repeat=\"item in vm.controlSolution2History\"><td md-cell>\n{{ item.pivot.changed_at | date:\'yyyy-MM-dd hh:mma\' }}</td><td md-cell nowrap=\"nowrap\">{{ item.lot_no }}</td><td \nmd-cell ng-if=\"!vm.isReadOnly\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.editControlSolution2History(item, $event)\" aria-label=\"{{ \'CURRENT_LOT.EDIT\' | translate }}\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.paginationControlSolution2.per_page\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"vm.paginationControlSolution2.current_page\" \nmd-total=\"{{ vm.paginationControlSolution2.total }}\" md-on-paginate=\"vm.getControlSolution2History\" md-page-select>\n</md-table-pagination></div></div></div></md-tab></md-tabs></div></div><div class=\"workspace-footer-copy-right\" \nlayout=\"column\" layout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"dashboard\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"DASHBOARD.TITLE\"></div><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" \nmd-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div></div><div \nclass=\"content\"><div layout=\"column\"><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p \nclass=\"hint-text font-size-16 font-weight-300\" translate=\"DASHBOARD.LOADING\"></p></div><div layout=\"column\"><qc-history\n hospital=\"vm.user.hospitals[0]\" loaded=\"vm.loaded\"></qc-history><qc-failed hospital=\"vm.user.hospitals[0]\" \nmeasurement-unit=\"vm.user.preferred_measurement_unit\" loaded=\"vm.loaded\"></qc-failed></div></div></div></div><div \nclass=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img class=\"logo-image\" \nng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> \n<span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/hospital/hospital.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" translate=\"HOSPITAL.TITLE\">\n</div><div class=\"font-size-14 font-weight-200\">{{ vm.countries[vm.user.country] }}</div></div><md-button \nclass=\"md-raised\" ng-click=\"vm.create($event)\" translate=\"HOSPITAL.CREATE\" \naria-label=\"{{ \'HOSPITAL.CREATE\' | translate }}\"></md-button></div><div class=\"content\"><div layout=\"column\"><div flex \nng-if=\"!vm.show\" class=\"text-center\"><p class=\"hint-text font-size-16 font-weight-300\" translate=\"HOSPITAL.LOADING\">\n</p></div><div class=\"simple-table-container md-whiteframe-4dp animate-slide-right\" ng-if=\"vm.show\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span translate=\"HOSPITAL.PANEL_TITLE\"></span><div layout=\"row\" layout-align=\"start center\"><input \nclass=\"search-input font-size-14\" ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" aria-label=\"Search\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.getHospitals()\" \nclass=\"cancel-search-input md-icon-button\" aria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" \nclass=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.getHospitals()\" \naria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div></div></md-toolbar>\n<md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" \nmd-on-reorder=\"vm.getHospitals\"><tr md-row><th md-column><span translate=\"HOSPITAL.COLUMNS.HOSPITAL\"></span></th><th \nmd-column><span translate=\"HOSPITAL.COLUMNS.STATE\"></span></th><th md-column><span translate=\"HOSPITAL.COLUMNS.SIZE\">\n</span></th><th md-column><span translate=\"HOSPITAL.COLUMNS.TYPE\"></span></th><th md-column><span \ntranslate=\"HOSPITAL.COLUMNS.MEASUREMENT_UNIT\"></span></th><th md-column md-order-by=\"created_at\"><span \ntranslate=\"HOSPITAL.COLUMNS.CREATED\"></span></th><th md-column><span translate=\"HOSPITAL.COLUMNS.ACTIONS\"></span></th>\n</tr></thead><tbody md-body><tr md-row ng-repeat=\"hospital in vm.hospitals\"><td md-cell class=\"text-capitalize\">\n{{ hospital.name }}</td><td md-cell class=\"text-capitalize\">{{ vm.states[hospital.state] }}</td><td md-cell \nclass=\"text-capitalize\">{{ vm.sizes[hospital.size] }}</td><td md-cell>{{ vm.types[hospital.type] }}</td><td md-cell>\n{{ vm.measurementUnits[hospital.default_measurement_unit]}}</td><td md-cell><span am-time-ago=\"hospital.created_at\">\n</span></td><td md-cell><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.edit(hospital, $event)\" \naria-label=\"{{ \'HOSPITAL.EDIT\' | translate}}\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button>\n<md-button ng-if=\"vm.showCloudShareButton\" class=\"edit-button md-icon-button\" \nng-click=\"vm.cloudShare(hospital, $event)\" aria-label=\"{{ \'HOSPITAL.EDIT\' | translate}}\"><md-icon \nng-if=\"!hospital.cloud_link.is_cloud_link_enabled\" md-font-icon=\"icon-link-off\" class=\"s16\"></md-icon><md-icon \nng-if=\"hospital.cloud_link.is_cloud_link_enabled\" md-font-icon=\"icon-link\" class=\"s16\"></md-icon></md-button></td></tr>\n</tbody></table></md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" \nmd-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" \nmd-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getHospitals\" md-page-select></md-table-pagination></div></div>\n</div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img class=\"logo-image\" \nng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> \n<span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/location/location.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" translate=\"LOCATION.TITLE\">\n</div><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" \nclass=\"s16 white-fg line-height-20\"></md-icon><div flex class=\"ml-8 font-size-14 font-weight-200 line-height-20\">\n{{ vm.user.hospitals[0].name }}</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\">\n<md-menu md-position-mode=\"left bottom\" md-offset=\"0 2\"><md-button class=\"md-raised\" ng-click=\"$mdMenu.open()\" \naria-label=\"{{ \'LOCATION.EXPORT\' | translate }}\"><div layout=\"row\"><span translate=\"LOCATION.EXPORT\"></span><md-icon \nmd-font-icon=\"icon-menu-down\" class=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-file-delimited\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.exportToCSV()\" translate=\"LOCATION.CSV\" aria-label=\"{{ \'LOCATION.CSV\' | translate }}\"></md-button>\n</md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-excel\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.exportToExcel()\" translate=\"LOCATION.EXCEL\" aria-label=\"{{ \'LOCATION.EXCEL\' | translate }}\">\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-button ng-if=\"!vm.isReadOnly\" \nclass=\"md-raised\" ng-click=\"vm.create($event)\" translate=\"LOCATION.CREATE\" \naria-label=\"{{ \'LOCATION.CREATE\' | translate }}\"></md-button></div></div><div class=\"content\"><div layout=\"column\"><div\n flex ng-if=\"!vm.show\" class=\"text-center\"><p class=\"hint-text font-size-16 font-weight-300\" \ntranslate=\"LOCATION.LOADING\"></p></div><div class=\"simple-table-container md-whiteframe-4dp animate-slide-right\" \nng-if=\"vm.show\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span translate=\"LOCATION.PANEL_TITLE\"></span><div layout=\"row\" \nlayout-align=\"start center\"><input class=\"search-input font-size-14\" ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" aria-label=\"Search\"><md-button ng-if=\"vm.searchTerm\" \nng-click=\"vm.searchTerm = \'\'; vm.getLocations()\" class=\"cancel-search-input md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.getLocations()\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div>\n</div></md-toolbar><md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" \nmd-on-reorder=\"vm.getLocations\"><tr md-row><th md-column><span translate=\"LOCATION.COLUMNS.CODE\"></span></th><th \nmd-column><span translate=\"LOCATION.COLUMNS.LOCATION\"></span></th><th md-column><span \ntranslate=\"LOCATION.COLUMNS.PERSON_IN_CHARGE\"></span></th><th md-column><span translate=\"LOCATION.COLUMNS.PHONE\">\n</span></th><th md-column md-order-by=\"created_at\"><span translate=\"LOCATION.COLUMNS.CREATED\"></span></th><th \nmd-column><span translate=\"LOCATION.COLUMNS.ACTIONS\"></span></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"location in vm.locations\"><td md-cell nowrap=\"nowrap\">{{ location.code }}</td><td md-cell \nclass=\"text-capitalize\">{{ location.description }}</td><td md-cell class=\"text-capitalize\">\n{{ location.person_in_charge }}</td><td md-cell>{{ location.phone }}</td><td md-cell><span \nam-time-ago=\"location.created_at\"></span></td><td md-cell><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.edit(location, $event)\" aria-label=\"{{ \'LOCATION.EDIT\' | translate }}\"><md-icon ng-if=\"!vm.isReadOnly\" \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-eye\" class=\"s16\">\n</md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" \nmd-page=\"vm.pagination.current_page\" md-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getLocations\" \nmd-page-select></md-table-pagination></div></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/manual-qc-data/manual-qc-data.html","<div id=\"manual-qc-data\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"MANUAL_QC_DATA.TITLE\"></div><div layout=\"row\" layout-align=\"start center\"><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"column\" layout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"vm.create($event)\" \ntranslate=\"MANUAL_QC_DATA.CREATE\" aria-label=\"{{ \'MANUAL_QC_DATA.CREATE\' | translate }}\"></md-button></div></div><div \nclass=\"content\" layout=\"column\"><form name=\"vm.filterForm\" class=\"md-inline-form filter-form\" layout-align=\"start\"><div\n layout=\"row\"><div layout=\"row\" flex=\"50\"><md-input-container flex><label \ntranslate=\"MANUAL_QC_DATA.FILTERS.START_DATE\"></label><md-datepicker name=\"startDate\" ng-model=\"vm.startDate\" \nng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"MANUAL_QC_DATA.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"MANUAL_QC_DATA.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"MANUAL_QC_DATA.FILTERS.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"MANUAL_QC_DATA.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"MANUAL_QC_DATA.FILTERS.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"MANUAL_QC_DATA.FILTERS.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"MANUAL_QC_DATA.FILTERS.METER_SERIAL_NO\"></label>\n<md-select md-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.selectedMeter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.selectedMeterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"MANUAL_QC_DATA.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"MANUAL_QC_DATA.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-if=\"vm.loaded\" class=\"animate-slide-right simple-table-container md-whiteframe-1dp\">\n<md-table-container><table md-table><thead md-head><tr md-row><th md-column><span \ntranslate=\"MANUAL_QC_DATA.METER.METER_MODEL\"></span></th><th md-column><span translate=\"MANUAL_QC_DATA.METER.HOSPITAL\">\n</span></th><th md-column><span translate=\"MANUAL_QC_DATA.METER.LOCATION_CODE\"></span></th><th md-column><span \ntranslate=\"MANUAL_QC_DATA.METER.PERSON_IN_CHARGE\"></span></th></tr></thead><tbody md-body><tr md-row \ndisabled=\"disabled\"><td md-cell>{{ vm.selectedMeter.model_no }}</td><td md-cell>\n{{ vm.selectedMeter.location.hospital.name }}</td><td md-cell>{{ vm.selectedMeter.location.code }}</td><td md-cell>\n{{ vm.selectedMeter.location.person_in_charge }}</td></tr></tbody><tfoot><tr><td></td></tr></tfoot></table>\n</md-table-container></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span translate=\"MANUAL_QC_DATA.PANEL_TITLE\"></span>\n<div flex></div></div></md-toolbar><md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head \nmd-order=\"vm.sort\" md-on-reorder=\"vm.getManualQcData\"><tr md-row><th md-column md-order-by=\"tested_on\"><span \ntranslate=\"MANUAL_QC_DATA.COLUMNS.TEST_DATE_TIME\"></span></th><th md-column><span \ntranslate=\"MANUAL_QC_DATA.COLUMNS.CONTROL_TYPE\"></span></th><th md-column><span \ntranslate=\"MANUAL_QC_DATA.COLUMNS.QC_VALUE\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column><span \ntranslate=\"MANUAL_QC_DATA.COLUMNS.STATUS\"></span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nng-repeat=\"qcData in vm.qcDatas\"><td md-cell>{{ qcData.tested_on | date:\'yyyy-MM-dd hh:mma\' }}</td><td md-cell>\n{{ qcData.control_level }}</td><td md-cell>{{ qcData.meter_reading | number:1 }}</td><td md-cell \nng-if=\"qcData.deleted_at != null\"><span translate=\"MANUAL_QC_DATA.COLUMNS.VALUES.DELETED\"></span><md-button \nclass=\"md-icon-button\" ng-if=\"qcData.delete_reason != null\" \naria-label=\"{{ \'MANUAL_QC_DATA_FORM.REASON\' | translate }}\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s16\"></md-icon><md-tooltip>{{ qcData.delete_reason }}</md-tooltip></md-button></td><td md-cell \nng-if=\"qcData.deleted_at == null && qcData.is_override\"><span translate=\"MANUAL_QC_DATA.COLUMNS.VALUES.ARCHIVED\">\n</span></td><td md-cell ng-if=\"qcData.deleted_at == null && !qcData.is_override\"><span \ntranslate=\"MANUAL_QC_DATA.COLUMNS.VALUES.ACTIVE\"></span></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.pagination.per_page\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" md-total=\"{{ vm.pagination.total }}\" \nmd-on-paginate=\"vm.getBloodGlucoseTests\" md-page-select></md-table-pagination></div></div></div>");
$templateCache.put("app/main/meter/meter.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" translate=\"METER.TITLE\"></div>\n<div ng-if=\"vm.isCountryAdmin\" class=\"font-size-14 font-weight-200\">{{ vm.countries[vm.user.country] }}</div><div \nng-if=\"!vm.isCountryAdmin\" layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" \nmd-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu md-position-mode=\"left bottom\" \nmd-offset=\"0 2\"><md-button class=\"md-raised\" ng-click=\"$mdMenu.open()\" aria-label=\"{{ \'METER.EXPORT\' | translate }}\">\n<div layout=\"row\"><span translate=\"METER.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon\"></md-icon>\n</div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-delimited\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToCSV()\" translate=\"METER.CSV\" \naria-label=\"{{ \'METER.EXPORT\' | translate }}\"></md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToExcel()\" translate=\"METER.EXCEL\" \naria-label=\"{{ \'METER.EXCEL\' | translate }}\"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<md-button ng-if=\"!vm.isReadOnly\" class=\"md-raised\" ng-click=\"vm.create($event)\" translate=\"METER.CREATE\" \naria-label=\"{{ \'METER.CREATE\' | translate }}\"></md-button></div></div><div class=\"content\"><div layout=\"column\"><div \nflex ng-if=\"!vm.show\" class=\"text-center\"><p class=\"hint-text font-size-16 font-weight-300\" translate=\"METER.LOADING\">\n</p></div><div class=\"simple-table-container md-whiteframe-4dp animate-slide-right\" ng-if=\"vm.show\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<div><span translate=\"METER.PANEL_TITLE\">Meters</span> <span ng-if=\"vm.overview\" class=\"font-size-14 font-weight-400\">\n({{ \'METER.ACTIVE\' | translate }}: {{ vm.overview.active }} | {{ \'METER.INACTIVE\' | translate }} : {{ vm.overview.inactive }})\n</span></div><div layout=\"row\" layout-align=\"start center\"><md-select ng-if=\"vm.isCountryAdmin\" \nclass=\"simplified font-size-14\" ng-model=\"vm.selectedHospital\" ng-change=\"vm.getMeters()\" \naria-label=\"{{ \'METER.HOSPITAL\' | translate }}\"><md-option ng-value=\"null\" translate=\"METER.ALL_HOSPITALS\"></md-option>\n<md-option ng-repeat=\"hospital in vm.hospitals\" ng-value=\"hospital\">{{ hospital.name }}</md-option></md-select><input \nclass=\"search-input font-size-14\" ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" aria-label=\"Search\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.getMeters()\" \nclass=\"cancel-search-input md-icon-button\" aria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" \nclass=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.getMeters()\" \naria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div></div></md-toolbar>\n<md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" \nmd-on-reorder=\"vm.getMeters\"><tr md-row><th md-column md-order-by=\"model_no\"><span \ntranslate=\"METER.COLUMNS.METER_MODEL\"></span></th><th md-column md-order-by=\"serial_no\"><span \ntranslate=\"METER.COLUMNS.SERIAL_NO\"></span></th><th md-column md-order-by=\"locations.code\"><span \ntranslate=\"METER.COLUMNS.LOCATION_CODE\"></span></th><th md-column ng-if=\"vm.isCountryAdmin && !vm.selectedHospital\">\n<span translate=\"METER.COLUMNS.HOSPITAL\"></span></th><th md-column md-order-by=\"meters.created_at\"><span \ntranslate=\"METER.COLUMNS.CREATED\"></span></th><th md-column><span translate=\"METER.COLUMNS.STATUS\"></span></th><th \nmd-column><span translate=\"METER.COLUMNS.ACTIONS\"></span></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"meter in vm.meters\"><td md-cell nowrap=\"nowrap\">{{ meter.model_no }}</td><td md-cell nowrap=\"nowrap\">\n{{ meter.serial_no }}</td><td md-cell nowrap=\"nowrap\">{{ meter.location.code }}</td><td md-cell \nclass=\"text-capitalize\" ng-if=\"vm.isCountryAdmin && !vm.selectedHospital\">{{ meter.location.hospital.name }}</td><td \nmd-cell nowrap=\"nowrap\">{{ meter.created_at | date:\'yyyy-MM-dd hh:mma\' }}</td><td md-cell><div class=\"text-center\"><div\n ng-if=\"meter.status === \'active\'\" class=\"status-indicator md-green-500-bg\"></div><div \nng-if=\"meter.status === \'inactive\'\" class=\"status-indicator md-grey-500-bg\"></div></div></td><td md-cell><md-button \nng-if=\"!(meter.location.hospital.cloud_link && meter.location.hospital.cloud_link.is_cloud_link_enabled)\" \nclass=\"edit-button md-icon-button\" ng-click=\"vm.edit(meter, $event)\" aria-label=\"{{ \'METER.EDIT\' | translate }}\">\n<md-icon ng-if=\"!(meter.location.hospital.cloud_link && meter.location.hospital.cloud_link.is_cloud_link_enabled)\" \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button><md-button \nng-if=\"meter.location.hospital.cloud_link && meter.location.hospital.cloud_link.is_cloud_link_enabled\" \nclass=\"edit-button md-icon-button\" ng-click=\"vm.view(meter, $event)\" aria-label=\"{{ \'METER.EDIT\' | translate }}\">\n<md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon></md-button><md-button \nng-if=\"!(meter.location.hospital.cloud_link && meter.location.hospital.cloud_link.is_cloud_link_enabled)\" \nclass=\"edit-button md-icon-button\" ng-click=\"vm.archive(meter, $event)\" aria-label=\"{{ \'METER.ARCHIVE\' | translate }}\">\n<md-icon ng-if=\"!(meter.location.hospital.cloud_link && meter.location.hospital.cloud_link.is_cloud_link_enabled)\" \nmd-font-icon=\"icon-archive\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.pagination.per_page\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" md-total=\"{{ vm.pagination.total }}\" \nmd-on-paginate=\"vm.getMeters\" md-page-select></md-table-pagination></div></div></div></div><div \nclass=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img class=\"logo-image\" \nng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> \n<span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/sample/sample.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/main/send-data/send-data.html","<div id=\"send-data\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"SEND_DATA.TITLE\"></div><div class=\"font-size-14 font-weight-200\">{{ vm.user.hospitals[0].name }}</div></div>\n</div><div class=\"content\"><div layout=\"column\"><div flex ng-if=\"!vm.connected\" class=\"text-center\"><p \nclass=\"hint-text font-size-16 font-weight-300\" translate=\"SEND_DATA.CONNECTING\"></p></div><div ng-if=\"vm.connected\">\n<div ng-if=\"vm.errorConnect\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"SEND_DATA.NOT_CONNECTED\"></p></div><div ng-if=\"!vm.errorConnect\"><div ng-if=\"vm.showSendData\" flex \nclass=\"mt-32 text-center\"><p ng-if=\"vm.cloudLink.last_sent_on\"><span class=\"font-size-16 font-weight-300\" \ntranslate=\"SEND_DATA.LAST_SENT_ON\"></span> <span class=\"font-size-16 font-weight-500\">\n{{ vm.cloudLink.last_sent_on | date:\'yyyy-MM-dd hh:mma\'}}</span></p><p class=\"hint-text font-size-16 font-weight-300\" \nng-if=\"!vm.cloudLink.last_sent_on\" translate=\"SEND_DATA.NO_DATA_SENT\"></p><md-button ng-disabled=\"vm.sending\" \ntype=\"button\" class=\"md-raised md-accent\" ng-click=\"vm.sendData()\" translate=\"SEND_DATA.SEND_DATA\" \naria-label=\"{{ \'SEND_DATA.SEND_DATA\' | translate }}\"></md-button><md-progress-linear class=\"mt-32\" \nmd-mode=\"indeterminate\" ng-disabled=\"!vm.sending\"></md-progress-linear></div><div ng-if=\"!vm.showSendData\" flex \nclass=\"mt-32 text-center\"><md-button type=\"button\" class=\"md-raised md-accent\" \nng-click=\"vm.enterCloudShareKey($event)\" translate=\"SEND_DATA.ENTER_CLOUD_SHARE_KEY\" \naria-label=\"{{ \'SEND_DATA.ENTER_CLOUD_SHARE_KEY\' | translate }}\"></md-button></div></div></div></div></div></div><div \nclass=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img class=\"logo-image\" \nng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> \n<span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/test-strip/test-strip.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" translate=\"TEST_STRIP.TITLE\">\n</div><div ng-if=\"vm.isCountryAdmin\" class=\"font-size-14 font-weight-200\">{{ vm.countries[vm.user.country] }}</div><div\n ng-if=\"!vm.isCountryAdmin\" layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" \nmd-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu md-position-mode=\"left bottom\" \nmd-offset=\"0 2\"><md-button class=\"md-raised\" ng-click=\"$mdMenu.open()\" \naria-label=\"{{ \'TEST_STRIP.EXPORT\' | translate }}\"><div layout=\"row\"><span translate=\"TEST_STRIP.EXPORT\"></span>\n<md-icon md-font-icon=\"icon-menu-down\" class=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-delimited\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.exportToCSV()\" translate=\"TEST_STRIP.CSV\" aria-label=\"{{ \'TEST_STRIP.CSV\' | translate }}\"></md-button>\n</md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-excel\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.exportToExcel()\" translate=\"TEST_STRIP.EXCEL\" \naria-label=\"{{ \'TEST_STRIP.EXCEL\' | translate }}\"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<md-button ng-if=\"vm.isCountryAdmin\" class=\"md-raised\" ng-click=\"vm.batchCreate($event)\" \ntranslate=\"TEST_STRIP.BATCH_CREATE\" aria-label=\"{{ \'TEST_STRIP.BATCN_CREATE\' | translate }}\"></md-button><md-button \nng-if=\"!vm.isReadOnly\" class=\"md-raised\" ng-click=\"vm.create($event)\" translate=\"TEST_STRIP.CREATE\" \naria-label=\"{{ \'TEST_STRIP.CREATE\' | translate }}\"></md-button></div></div><div class=\"content\"><div layout=\"column\">\n<div flex ng-if=\"!vm.show\" class=\"text-center\"><p class=\"hint-text font-size-16 font-weight-300\" \ntranslate=\"TEST_STRIP.LOADING\"></p></div><div class=\"simple-table-container md-whiteframe-4dp animate-slide-right\" \nng-if=\"vm.show\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span translate=\"TEST_STRIP.PANEL_TITLE\"></span><div layout=\"row\" \nlayout-align=\"start center\"><md-select ng-if=\"vm.isCountryAdmin\" class=\"simplified font-size-14\" \nng-model=\"vm.selectedHospital\" ng-change=\"vm.getTestStrips()\" aria-label=\"{{ \'TEST_STRIP.HOSPITAL\' | translate }}\">\n<md-option ng-value=\"null\" translate=\"TEST_STRIP.ALL_HOSPITALS\"></md-option><md-option \nng-repeat=\"hospital in vm.hospitals\" ng-value=\"hospital\">{{ hospital.name }}</md-option></md-select><input \nclass=\"search-input font-size-14\" ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" aria-label=\"Search\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.getTestStrips()\" \nclass=\"cancel-search-input md-icon-button\" aria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" \nclass=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.getTestStrips()\" \naria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div></div></md-toolbar>\n<md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" \nmd-on-reorder=\"vm.getTestStrips\"><tr md-row><th md-column><span translate=\"TEST_STRIP.COLUMNS.STRIP_LOT\"></span></th>\n<th md-column><span translate=\"TEST_STRIP.COLUMNS.STRIP_MODEL\"></span></th><th md-column md-numeric><div \nclass=\"control-level-indicator md-light-blue-500-bg\"></div><span translate=\"TEST_STRIP.COLUMNS.L1_MIN\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-numeric><div \nclass=\"control-level-indicator md-light-blue-500-bg\"></div><span translate=\"TEST_STRIP.COLUMNS.L1_MAX\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-numeric><div \nclass=\"control-level-indicator md-green-500-bg\"></div><span translate=\"TEST_STRIP.COLUMNS.L2_MIN\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-numeric><div \nclass=\"control-level-indicator md-green-500-bg\"></div><span translate=\"TEST_STRIP.COLUMNS.L2_MAX\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-order-by=\"expiry\"><span \ntranslate=\"TEST_STRIP.COLUMNS.STRIP_EXPIRY\"></span></th><th md-column \nng-if=\"vm.isCountryAdmin && !vm.selectedHospital\"><span translate=\"TEST_STRIP.COLUMNS.HOSPITAL\"></span></th><th \nmd-column><span translate=\"TEST_STRIP.COLUMNS.CREATED\"></span></th><th md-column><span \ntranslate=\"TEST_STRIP.COLUMNS.ACTIONS\"></span></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"testStrip in vm.testStrips\"><td md-cell nowrap=\"nowrap\">{{ testStrip.lot_no }}</td><td md-cell>\n{{ testStrip.test_strip_model.model_name }}</td><td md-cell>{{ testStrip.l1_min | number:1 }}</td><td md-cell>\n{{ testStrip.l1_max | number:1 }}</td><td md-cell>{{ testStrip.l2_min | number:1 }}</td><td md-cell>\n{{ testStrip.l2_max | number:1 }}</td><td md-cell nowrap=\"nowrap\"><span ng-class=\"{\'red-fg\': vm.isExpired(testStrip)}\">\n{{ testStrip.expiry | date:\'yyyy-MM-dd\' }}</span></td><td md-cell class=\"text-capitalize\" \nng-if=\"vm.isCountryAdmin && !vm.selectedHospital\">{{ testStrip.hospital.name }}</td><td md-cell><span \nam-time-ago=\"testStrip.created_at\"></span></td><td md-cell><md-button \nng-if=\"!(testStrip.hospital.cloud_link && testStrip.hospital.cloud_link.is_cloud_link_enabled)\" \nclass=\"edit-button md-icon-button\" ng-click=\"vm.edit(testStrip, $event)\" \naria-label=\"{{ \'TEST_STRIP.EDIT\' | translate }}\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button>\n<md-button ng-if=\"testStrip.hospital.cloud_link && testStrip.hospital.cloud_link.is_cloud_link_enabled\" \nclass=\"edit-button md-icon-button\" ng-click=\"vm.view(testStrip, $event)\" \naria-label=\"{{ \'TEST_STRIP.EDIT\' | translate }}\"><md-icon md-font-icon=\"icon-eye\" class=\"s16\"></md-icon></md-button>\n</td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" \nmd-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" \nmd-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getTestStrips\" md-page-select></md-table-pagination></div>\n</div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img \nclass=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">\n©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/test-strip-consumption/test-strip-consumption.html","<div id=\"test-strip-consumption\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"TEST_STRIP_CONSUMPTION.TITLE\"></div><div ng-if=\"vm.role === \'roche_global_admin\'\" \nclass=\"font-size-14 font-weight-200\">Global</div><div ng-if=\"vm.role === \'roche_country_admin\'\" \nclass=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}</div><div \nng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\" layout=\"row\" layout-align=\"start center\">\n<md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div></div><div \nclass=\"content\"><div layout=\"column\"><test-strip-consumption-global-admin ng-if=\"vm.role === \'roche_global_admin\'\" \nall-countries=\"vm.allCountries\" all-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\">\n</test-strip-consumption-global-admin><test-strip-consumption-country-admin ng-if=\"vm.role === \'roche_country_admin\'\" \ncountry=\"vm.user.country\" all-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\">\n</test-strip-consumption-country-admin><test-strip-consumption-hospital-admin ng-if=\"vm.role === \'hospital_admin\'\" \nhospital=\"vm.user.hospitals[0]\"></test-strip-consumption-hospital-admin><test-strip-consumption-hospital-operator \nng-if=\"vm.role === \'hospital_operator\'\" hospital=\"vm.user.hospitals[0]\" locations=\"vm.locations\">\n</test-strip-consumption-hospital-operator></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/test-strip-model/test-strip-model.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"TEST_STRIP_MODEL.TITLE\"></div><div class=\"font-size-14 font-weight-200\">Global</div></div><md-button \nclass=\"md-raised\" ng-click=\"vm.create($event)\" translate=\"TEST_STRIP_MODEL.CREATE\" \naria-label=\"{{ \'TEST_STRIP_MODEL.CREATE\' | translate }}\"></md-button></div><div class=\"content\"><div layout=\"column\">\n<div flex ng-if=\"!vm.show\" class=\"text-center\"><p class=\"hint-text font-size-16 font-weight-300\" \ntranslate=\"TEST_STRIP_MODEL.LOADING\"></p></div><div \nclass=\"simple-table-container md-whiteframe-4dp animate-slide-right\" ng-if=\"vm.show\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span translate=\"TEST_STRIP_MODEL.PANEL_TITLE\"></span><div layout=\"row\" layout-align=\"start center\"><input \nclass=\"search-input font-size-14\" ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" aria-label=\"Search\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.getTestStripModels()\" \nclass=\"cancel-search-input md-icon-button\" aria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" \nclass=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.getTestStripModels()\" \naria-label=\"\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div></div></md-toolbar><md-table-container>\n<table md-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" md-on-reorder=\"vm.getTestStripModels\"><tr \nmd-row><th md-column><span translate=\"TEST_STRIP_MODEL.COLUMNS.STRIP_MODEL\"></span></th><th md-column md-numeric><div \nclass=\"control-level-indicator md-light-blue-500-bg\"></div><span translate=\"TEST_STRIP_MODEL.COLUMNS.L1_MFR_MEAN\">\n</span>&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-numeric><div \nclass=\"control-level-indicator md-light-blue-500-bg\"></div><span translate=\"TEST_STRIP_MODEL.COLUMNS.L1_MFR_SD\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-numeric><div \nclass=\"control-level-indicator md-green-500-bg\"></div><span translate=\"TEST_STRIP_MODEL.COLUMNS.L2_MFR_MEAN\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-numeric><div \nclass=\"control-level-indicator md-green-500-bg\"></div><span translate=\"TEST_STRIP_MODEL.COLUMNS.L2_MFR_SD\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-order-by=\"created_at\"><span \ntranslate=\"TEST_STRIP_MODEL.COLUMNS.CREATED\"></span></th><th md-column><span \ntranslate=\"TEST_STRIP_MODEL.COLUMNS.ACTIONS\"></span></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"testStripModel in vm.testStripModels\"><td md-cell nowrap=\"nowrap\">{{ testStripModel.model_name }}</td><td \nmd-cell>{{ testStripModel.l1_mfr_mean | number:2 }}</td><td md-cell>{{ testStripModel.l1_mfr_sd | number:2 }}</td><td \nmd-cell>{{ testStripModel.l2_mfr_mean | number:2 }}</td><td md-cell>{{ testStripModel.l2_mfr_sd | number:2 }}</td><td \nmd-cell><span am-time-ago=\"testStripModel.created_at\"></span></td><td md-cell><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.edit(testStripModel, $event)\" \naria-label=\"{{ \'TEST_STRIP_MODEL.EDIT\' | translate }}\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" \nmd-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" \nmd-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getTestStripModels\" md-page-select></md-table-pagination></div>\n</div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img \nclass=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">\n©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/upload-meter-data/upload-meter-data-public.html","<div id=\"upload-meter-data-public\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nid=\"upload-meter-data-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"upload-meter-data-form\" \nclass=\"md-whiteframe-4dp p-32\"><div ng-if=\"vm.currentStep === \'CONNECT\'\"><div class=\"caption mb-16 text-center\" \ntranslate=\"UPLOAD_METER_DATA.CONNECT.TITLE\"></div><div class=\"mb-16\" translate=\"UPLOAD_METER_DATA.CONNECT.BODY\"></div>\n<div class=\"mb-16\" translate=\"UPLOAD_METER_DATA.CONNECT.ACTION\"></div><div class=\"mb-16\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"space-around center\"><img ng-src=\"assets/images/etc/guide-connect.png\"> <img \nng-src=\"assets/images/etc/instant-connect.png\"></div></div><div ng-if=\"vm.currentStep === \'ERROR_METER\'\"><div \nclass=\"caption mb-16 text-center\" translate=\"UPLOAD_METER_DATA.ERROR.TITLE\"></div><div class=\"mb-16\" \ntranslate=\"UPLOAD_METER_DATA.ERROR.IDLE\"></div><div class=\"mb-16\" translate=\"UPLOAD_METER_DATA.ERROR.DRIVER\"></div><div\n class=\"mb-16 text-center\"><img ng-src=\"assets/images/etc/connection_manager-exit.png\"></div><div class=\"mb-16\"><span \ntranslate=\"UPLOAD_METER_DATA.ERROR.PERSIST\"></span> <a href=\"\" ng-click=\"vm.launchLegacyApp()\" \ntranslate=\"UPLOAD_METER_DATA.ERROR.LEGACY_APP\"></a></div></div><div \nng-if=\"vm.currentStep === \'CONFIRM\' && vm.meterInfo.meter\"><div class=\"caption mb-16 text-center\" \ntranslate=\"UPLOAD_METER_DATA.CONFIRM.TITLE\"></div><div class=\"mb-16\" translate=\"UPLOAD_METER_DATA.CONFIRM.BODY\"></div>\n<table class=\"simple mb-16\"><tr><td translate=\"UPLOAD_METER_DATA.CONFIRM.TABLE.METER_MODEL\"></td><td \nclass=\"text-semibold\">{{ vm.meterInfo.meter.model_no }}</td></tr><tr><td \ntranslate=\"UPLOAD_METER_DATA.CONFIRM.TABLE.SERIAL_NUMBER\"></td><td class=\"text-semibold\">\n{{ vm.meterInfo.meter.serial_no }}</td></tr><tr><td translate=\"UPLOAD_METER_DATA.CONFIRM.TABLE.HOSPITAL\"></td><td \nclass=\"text-semibold\">{{ vm.meterInfo.meter.location.hospital.name }}</td></tr><tr><td \ntranslate=\"UPLOAD_METER_DATA.CONFIRM.TABLE.LOCATION\"></td><td class=\"text-semibold\">\n{{ vm.meterInfo.meter.location.code }} ({{ vm.meterInfo.location.description }})</td></tr><tr><td \ntranslate=\"UPLOAD_METER_DATA.CONFIRM.TABLE.PERSON_IN_CHARGE\"></td><td class=\"text-semibold\">\n{{ vm.meterInfo.meter.location.person_in_charge }}</td></tr><tr><td translate=\"UPLOAD_METER_DATA.CONFIRM.TABLE.PHONE\">\n</td><td class=\"text-semibold\">{{ vm.meterInfo.meter.location.phone }}</td></tr></table><div class=\"mb-16\" \ntranslate=\"UPLOAD_METER_DATA.CONFIRM.UPLOAD\"></div></div><div ng-if=\"vm.currentStep === \'SUCCESS\'\"><div class=\"pv-20\">\n<div class=\"mb-16 text-center\"><img ng-src=\"assets/images/etc/green_tick.png\"></div><div class=\"h-20\"></div><div \nclass=\"caption mb-16 text-center\" translate=\"UPLOAD_METER_DATA.SUCCESS.TITLE\"></div><div class=\"mb-16 text-center\" \ntranslate=\"UPLOAD_METER_DATA.SUCCESS.BODY\"></div></div></div><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-accent back-button\" \ntranslate=\"UPLOAD_METER_DATA.BUTTONS.BACK_TO_LOGIN\" ng-click=\"vm.loginPage($event)\"></md-button><md-button \nclass=\"md-raised md-accent next-button\" ng-click=\"vm.next($event)\" ng-disabled=\"vm.nextButton.disabled\">\n{{ vm.nextButton.label }}</md-button></div></div></div></div><div class=\"footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><span class=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/upload-meter-data/upload-meter-data-test.html","<div id=\"upload-meter-data-public\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nid=\"upload-meter-data-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"upload-meter-data-form\" \nclass=\"md-whiteframe-4dp p-32 w-500\"><div class=\"text-center\"><md-button class=\"md-raised md-accent\" \nng-click=\"vm.testConnection()\">Test Meter Connection</md-button></div><div flex class=\"mt-10\"><textarea \nclass=\"md-input border font-mono p-10\" fill-width style=\"font-family: monospace; line-height:1.5em\" rows=\"30\" \nng-model=\"vm.outputText\" placeholder=\"Diagnostic message will appear here...\" readonly=\"readonly\"></textarea></div>\n</div></div></div><div class=\"footer-copy-right\" layout=\"column\" layout-align=\"end end\"><span class=\"logo-text\">\n©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/upload-meter-data/upload-meter-data.html","<div id=\"upload-meter-data\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"UPLOAD_METER_DATA.TITLE\"></div><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" \nmd-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button ng-if=\"!vm.isReadOnly\" class=\"md-raised\" ng-click=\"vm.next($event)\" \nng-disabled=\"vm.nextButton.disabled\">{{ vm.nextButton.label }}</md-button></div></div><div class=\"content\"><div \nlayout=\"column\" layout-align=\"center center\"><div id=\"upload-meter-data-form\" class=\"md-whiteframe-4dp p-32\"><div \nng-if=\"vm.currentStep === \'CONNECT\'\"><div class=\"caption mb-16 text-center\" \ntranslate=\"UPLOAD_METER_DATA.CONNECT.TITLE\"></div><div class=\"mb-16\" translate=\"UPLOAD_METER_DATA.CONNECT.BODY\"></div>\n<div class=\"mb-16\" translate=\"UPLOAD_METER_DATA.CONNECT.ACTION\"></div><div class=\"mb-16\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"space-around center\"><img ng-src=\"assets/images/etc/guide-connect.png\"> <img \nng-src=\"assets/images/etc/instant-connect.png\"></div></div><div ng-if=\"vm.currentStep === \'ERROR_METER\'\"><div \nclass=\"caption mb-16 text-center\" translate=\"UPLOAD_METER_DATA.ERROR.TITLE\"></div><div class=\"mb-16\" \ntranslate=\"UPLOAD_METER_DATA.ERROR.IDLE\"></div><div class=\"mb-16\" translate=\"UPLOAD_METER_DATA.ERROR.DRIVER\"></div><div\n class=\"mb-16 text-center\"><img ng-src=\"assets/images/etc/connection_manager-exit.png\"></div><div class=\"mb-16\"><span \ntranslate=\"UPLOAD_METER_DATA.ERROR.PERSIST\"></span> <a href=\"\" ng-click=\"vm.launchLegacyApp()\" \ntranslate=\"UPLOAD_METER_DATA.ERROR.LEGACY_APP\"></a></div></div><div \nng-if=\"vm.currentStep === \'CONFIRM\' && vm.meterInfo.meter\"><div class=\"caption mb-16 text-center\" \ntranslate=\"UPLOAD_METER_DATA.CONFIRM.TITLE\"></div><div class=\"mb-16\" translate=\"UPLOAD_METER_DATA.CONFIRM.BODY\"></div>\n<table class=\"simple mb-16\"><tr><td translate=\"UPLOAD_METER_DATA.CONFIRM.TABLE.METER_MODEL\"></td><td \nclass=\"text-semibold\">{{ vm.meterInfo.meter.model_no }}</td></tr><tr><td \ntranslate=\"UPLOAD_METER_DATA.CONFIRM.TABLE.SERIAL_NUMBER\"></td><td class=\"text-semibold\">\n{{ vm.meterInfo.meter.serial_no }}</td></tr><tr><td translate=\"UPLOAD_METER_DATA.CONFIRM.TABLE.HOSPITAL\"></td><td \nclass=\"text-semibold\">{{ vm.meterInfo.meter.location.hospital.name }}</td></tr><tr><td \ntranslate=\"UPLOAD_METER_DATA.CONFIRM.TABLE.LOCATION\"></td><td class=\"text-semibold\">\n{{ vm.meterInfo.meter.location.code }} ({{ vm.meterInfo.location.description }})</td></tr><tr><td \ntranslate=\"UPLOAD_METER_DATA.CONFIRM.TABLE.PERSON_IN_CHARGE\"></td><td class=\"text-semibold\">\n{{ vm.meterInfo.meter.location.person_in_charge }}</td></tr><tr><td translate=\"UPLOAD_METER_DATA.CONFIRM.TABLE.PHONE\">\n</td><td class=\"text-semibold\">{{ vm.meterInfo.meter.location.phone }}</td></tr></table><div class=\"mb-16\" \ntranslate=\"UPLOAD_METER_DATA.CONFIRM.UPLOAD\"></div></div><div ng-if=\"vm.currentStep === \'SUCCESS\'\"><div class=\"pv-20\">\n<div class=\"mb-16\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-around center\"><img \nng-src=\"assets/images/etc/green_tick.png\"></div><div class=\"h-20\"></div><div class=\"caption mb-16 text-center\" \ntranslate=\"UPLOAD_METER_DATA.SUCCESS.TITLE\"></div><div class=\"mb-16 text-center\" \ntranslate=\"UPLOAD_METER_DATA.SUCCESS.BODY\"></div></div></div></div></div></div></div><div \nclass=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img class=\"logo-image\" \nng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> \n<span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/page/installer/installer.html","<div id=\"installer\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"installer-form-wrapper\" layout=\"column\" \nlayout-align=\"start center\"><div flex ng-if=\"!vm.show\" class=\"text-center\"><p \nclass=\"font-size-16 font-weight-300 white-text\" translate=\"INSTALLER.LOADING\"></p></div><div id=\"installer-form\" \nclass=\"md-whiteframe-8dp\" ng-if=\"vm.show\"><h1 class=\"text-center\">Accu-Chek<span class=\"text-super font-size-10\">®\n</span> Quest Setup</h1><div><h4 class=\"text-semibold text-uppercase\">PHP Version Check</h4><div \nclass=\"check-item check-item-success\" ng-if=\"vm.installer.php_version.passed\" layout=\"row\"><div class=\"status\">Success:\n</div><div flex>The application requires <span class=\"text-semibold\">PHP >= 7.0</span> and yours is <span \nclass=\"text-semibold\">{{ vm.installer.php_version.version }}</span></div></div><div \nclass=\"check-item check-item-failed\" ng-if=\"!vm.installer.php_version.passed\" layout=\"row\"><div class=\"status\">Failed:\n</div><div flex>The application requires <span class=\"text-semibold\">PHP >= 7.0</span> and yours is <span \nclass=\"text-semibold\">{{ vm.installer.php_version.version }}</span></div></div></div><div><h4 \nclass=\"text-semibold text-uppercase\">Files & Folders Check</h4><div ng-repeat=\"item in vm.installer.files_folders\"><div\n class=\"check-item check-item-success\" ng-if=\"item.passed\" layout=\"row\"><div class=\"status\">Success:</div><div flex>\n<span class=\"text-semibold\">{{ item.path }}</span> is writable</div></div><div class=\"check-item check-item-failed\" \nng-if=\"!item.passed\" layout=\"row\"><div class=\"status\">Failed:</div><div flex><span class=\"text-semibold\">\n{{ item.path }}</span> is not writable</div></div></div></div><div><h4 class=\"text-semibold text-uppercase\">\nPHP Requirements Check</h4><div ng-repeat=\"item in vm.installer.requirements\"><div \nclass=\"check-item check-item-success\" ng-if=\"item.passed\" layout=\"row\"><div class=\"status\">Success:</div><div flex>\n<span class=\"text-semibold\">{{ item.name }}</span> extension is loaded</div></div><div \nclass=\"check-item check-item-failed\" ng-if=\"!item.passed\" layout=\"row\"><div class=\"status\">Failed:</div><div flex><span\n class=\"text-semibold\">{{ item.name }}</span> extension is not loaded</div></div></div></div><div><h4 \nclass=\"text-semibold text-uppercase\">PHP Optional Requirements Check</h4><div \nng-repeat=\"item in vm.installer.optional_requirements\"><div class=\"check-item check-item-success\" ng-if=\"item.passed\" \nlayout=\"row\"><div class=\"status\">Success:</div><div flex><span class=\"text-semibold\">{{ item.name }}</span>\n extension is loaded</div></div><div class=\"check-item check-item-warning\" ng-if=\"!item.passed\" layout=\"row\"><div \nclass=\"status\">Warning:</div><div flex><span class=\"text-semibold\">{{ item.name }}</span> extension is not loaded</div>\n</div></div></div><form name=\"appSettingForm\" novalidate><h4 class=\"text-semibold text-uppercase pb-16\">\nApplication Settings</h4><div class=\"height-60\"><md-input-container class=\"md-block\" md-no-float><label>Application URL\n</label><input type=\"text\" name=\"appUrl\" ng-model=\"vm.form.app_url\" placeholder=\"http://ac-quest\" required><div \nng-messages=\"appSettingForm.appUrl.$error\" role=\"alert\"><div ng-message=\"required\">Required</div></div>\n</md-input-container></div><div><md-checkbox flex ng-model=\"vm.form.force_use_ssl\" aria-label=\"Force use SSL?\">\nForce use SSL?</md-checkbox></div></form><form name=\"databaseSettingForm\" novalidate><h4 \nclass=\"text-semibold text-uppercase pb-16\">Database Settings</h4><div class=\"height-60\"><md-input-container \nclass=\"md-block\" md-no-float><label>Database Type</label><md-select name=\"databaseConnection\" \nng-model=\"vm.form.database_connection\" required><md-option ng-value=\"\'mysql\'\">MySQL</md-option><md-option \nng-value=\"\'pgsql\'\">Postgres</md-option><md-option ng-value=\"\'sqlsrv\'\">SQL Server</md-option></md-select><div \nng-messages=\"databaseSettingForm.databaseConnection.$error\" role=\"alert\"><div ng-message=\"required\">Required</div>\n</div></md-input-container></div><div class=\"height-60\"><md-input-container class=\"md-block\" md-no-float><label>\nDatabase Host</label><input type=\"text\" name=\"databaseHost\" ng-model=\"vm.form.database_host\" required><div \nng-messages=\"databaseSettingForm.databaseHost.$error\" role=\"alert\"><div ng-message=\"required\">Required</div></div>\n</md-input-container></div><div class=\"height-60\"><md-input-container class=\"md-block\" md-no-float><label>Database Name\n</label><input type=\"text\" name=\"databaseName\" ng-model=\"vm.form.database_name\" required><div \nng-messages=\"databaseSettingForm.databaseName.$error\" role=\"alert\"><div ng-message=\"required\">Required</div></div>\n</md-input-container></div><div class=\"height-60\"><md-input-container class=\"md-block\" md-no-float><label>\nDatabase Username</label><input type=\"text\" name=\"databaseUsername\" ng-model=\"vm.form.database_username\" required><div \nng-messages=\"databaseSettingForm.databaseUsername.$error\" role=\"alert\"><div ng-message=\"required\">Required</div></div>\n</md-input-container></div><div class=\"height-60\"><md-input-container class=\"md-block\" md-no-float><label>\nDatabase Password</label><input type=\"text\" name=\"databasePassword\" ng-model=\"vm.form.database_password\">\n</md-input-container></div></form><div class=\"check-item check-item-success\" ng-if=\"vm.testSuccess\"><div \nclass=\"status\">Success:</div>Connected to <span class=\"text-semibold\">{{ vm.form.database_name }}</span></div><div \nclass=\"check-item check-item-failed\" ng-if=\"vm.testErrorMessage\" layout=\"row\"><div class=\"status\">Failed:</div><div \nlayout=\"column\"><div ng-if=\"vm.testErrorMessage.message\">{{ vm.testErrorMessage.message }}</div><div \nng-if=\"vm.testErrorMessage.detail\">{{ vm.testErrorMessage.detail }}</div></div></div><md-button ng-click=\"vm.test()\" \nclass=\"md-accent\" ng-disabled=\"databaseSettingForm.$invalid || vm.installing\">Test Database Connection</md-button><div \nclass=\"check-item check-item-success\" ng-if=\"vm.installSuccess\"><div class=\"status\">Success:</div>\nSystem Successfully Installed</div><div class=\"check-item check-item-failed\" ng-if=\"vm.installErrorMessage\" \nlayout=\"row\"><div class=\"status\">Failed:</div><div layout=\"column\"><div ng-if=\"vm.installErrorMessage.message\">\n{{ vm.installErrorMessage.message }}</div><div ng-if=\"vm.installErrorMessage.detail\">\n{{ vm.installErrorMessage.detail }}</div></div></div><md-button ng-click=\"vm.install()\" class=\"md-accent md-raised\" \nng-disabled=\"appSettingForm.$invalid || databaseSettingForm.$invalid || vm.installing\">Install Accu-Chek Quest\n</md-button></div></div></div><div class=\"footer-copy-right\" layout=\"column\" layout-align=\"end end\"><span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdMenu.open($event)\"><ms-color-picker-button><md-button\n aria-label=\"Row Color\" md-menu-origin ng-click=\"$mdMenu.open($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/active-hospitals/country-admin/country-admin.html","<form name=\"vm.filterForm\" class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\" flex=\"100\">\n<md-input-container flex><label translate=\"ACTIVE_HOSPITALS.FILTERS.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"ACTIVE_HOSPITALS.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"ACTIVE_HOSPITALS.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"ACTIVE_HOSPITALS.FILTERS.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"ACTIVE_HOSPITALS.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"ACTIVE_HOSPITALS.FILTERS.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"ACTIVE_HOSPITALS.FILTERS.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div></form><div \nng-if=\"vm.loaded\" class=\"animate-slide-right widget-group\" layout=\"row\" layout-wrap><div class=\"p-8\" flex=\"50\" \nflex-gt-sm=\"25\"><ms-widget class=\"h-120 no-padding\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg md-display-1 pb-8\">\n{{ vm.activeHospitals[\'all\'] | number }}</div><div class=\"font-weight-500 secondary-text text-center\" \ntranslate=\"ACTIVE_HOSPITALS.ALL\"></div></ms-widget-front></ms-widget></div><div \nng-repeat=\"(state, count) in vm.activeHospitals\" ng-if=\"state != \'all\'\" class=\"p-8\" flex=\"50\" flex-gt-sm=\"25\">\n<ms-widget class=\"h-120 no-padding\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg md-display-1 pb-8\">{{ count | number }}</div><div \nclass=\"font-weight-500 secondary-text text-center\">{{ vm.allStates[vm.country][state] }}</div></ms-widget-front>\n</ms-widget></div></div><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p \nclass=\"hint-text font-size-16 font-weight-300\" translate=\"ACTIVE_HOSPITALS.LOADING\"></p></div>");
$templateCache.put("app/main/active-hospitals/global-admin/global-admin.html","<form name=\"vm.filterForm\" class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\" flex=\"100\">\n<md-input-container flex><label translate=\"ACTIVE_HOSPITALS.FILTERS.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"ACTIVE_HOSPITALS.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"ACTIVE_HOSPITALS.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"ACTIVE_HOSPITALS.FILTERS.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"ACTIVE_HOSPITALS.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"ACTIVE_HOSPITALS.FILTERS.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"ACTIVE_HOSPITALS.FILTERS.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div></form><div \nng-if=\"vm.loaded\" class=\"animate-slide-right widget-group\" layout=\"row\" layout-wrap><div class=\"p-8\" flex=\"50\" \nflex-gt-sm=\"25\"><ms-widget class=\"h-120 no-padding\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg md-display-1 pb-8\">\n{{ vm.activeHospitals[\'all\'] | number }}</div><div class=\"font-weight-500 secondary-text text-center\" \ntranslate=\"ACTIVE_HOSPITALS.ALL\"></div></ms-widget-front></ms-widget></div><div \nng-repeat=\"(country, count) in vm.activeHospitals\" ng-if=\"country != \'all\'\" class=\"p-8\" flex=\"50\" flex-gt-sm=\"25\">\n<ms-widget class=\"h-120 no-padding\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg md-display-1 pb-8\">{{ count | number }}</div><div \nclass=\"font-weight-500 secondary-text text-center\">{{ vm.allCountries[country] }}</div></ms-widget-front></ms-widget>\n</div></div><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-16 font-weight-300\" \ntranslate=\"ACTIVE_HOSPITALS.LOADING\"></p></div>");
$templateCache.put("app/main/blood-glucose-test/country-admin/country-admin.html","<form name=\"vm.filterForm\" class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div layout=\"row\" \nflex=\"50\"><md-input-container class=\"md-block\" flex><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.STATE\"></label>\n<md-select name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.HOSPITAL\"></label>\n<md-select ng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div \nlayout=\"row\"><div layout=\"row\" flex=\"50\"><md-input-container flex><label \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.START_DATE\"></label><md-datepicker name=\"startDate\" ng-model=\"vm.startDate\" \nng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nflex class=\"ml-20\"><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.METER_SERIAL_NO\"></label>\n<md-select md-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.selectedMeter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.selectedMeterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"BLOOD_GLUCOSE_TEST.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-if=\"vm.loaded\" class=\"animate-slide-right simple-table-container md-whiteframe-1dp\">\n<md-table-container><table md-table><thead md-head><tr md-row><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.METER_MODEL\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.HOSPITAL\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.LOCATION_CODE\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.PERSON_IN_CHARGE\"></span></th></tr></thead><tbody md-body><tr md-row \ndisabled=\"disabled\"><td md-cell>{{ vm.selectedMeter.model_no }}</td><td md-cell>\n{{ vm.selectedMeter.location.hospital.name }}</td><td md-cell>{{ vm.selectedMeter.location.code }}</td><td md-cell>\n{{ vm.selectedMeter.location.person_in_charge }}</td></tr></tbody><tfoot><tr><td></td></tr></tfoot></table>\n</md-table-container></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span translate=\"BLOOD_GLUCOSE_TEST.PANEL_TITLE\">\n</span><div flex></div></div></md-toolbar><md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head \nmd-order=\"vm.sort\" md-on-reorder=\"vm.getBloodGlucoseTests\"><tr md-row><th md-column md-order-by=\"tested_on\"><span \ntranslate=\"BLOOD_GLUCOSE_TEST.COLUMNS.TEST_DATE_TIME\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.COLUMNS.METER_READING\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th></tr></thead><tbody md-body><tr md-row \nmd-auto-select ng-repeat=\"test in vm.bloodGlucoseTests\"><td md-cell>{{ test.tested_on | date:\'yyyy-MM-dd hh:mma\' }}\n</td><td md-cell><span ng-if=\"test.is_high\" class=\"red-fg\">HIGH</span><span ng-if=\"test.is_low\" class=\"red-fg\">LOW\n</span><span ng-if=\"!test.is_high && !test.is_low\">{{ test.meter_reading | number:1 }}</span></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.pagination.per_page\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" md-total=\"{{ vm.pagination.total }}\" \nmd-on-paginate=\"vm.getBloodGlucoseTests\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/blood-glucose-test/global-admin/global-admin.html","<form name=\"vm.filterForm\" class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div layout=\"row\" \nflex=\"50\"><md-input-container class=\"md-block\" flex><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.HOSPITAL\"></label>\n<md-select ng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div \nlayout=\"row\"><div layout=\"row\" flex=\"50\"><md-input-container flex><label \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.START_DATE\"></label><md-datepicker name=\"startDate\" ng-model=\"vm.startDate\" \nng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nflex class=\"ml-20\"><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.METER_SERIAL_NO\"></label>\n<md-select md-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.selectedMeter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.selectedMeterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"BLOOD_GLUCOSE_TEST.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-if=\"vm.loaded\" class=\"animate-slide-right simple-table-container md-whiteframe-1dp\">\n<md-table-container><table md-table><thead md-head><tr md-row><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.METER_MODEL\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.HOSPITAL\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.LOCATION_CODE\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.PERSON_IN_CHARGE\"></span></th></tr></thead><tbody md-body><tr md-row \ndisabled=\"disabled\"><td md-cell>{{ vm.selectedMeter.model_no }}</td><td md-cell>\n{{ vm.selectedMeter.location.hospital.name }}</td><td md-cell>{{ vm.selectedMeter.location.code }}</td><td md-cell>\n{{ vm.selectedMeter.location.person_in_charge }}</td></tr></tbody><tfoot><tr><td></td></tr></tfoot></table>\n</md-table-container></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span translate=\"BLOOD_GLUCOSE_TEST.PANEL_TITLE\">\n</span><div flex></div></div></md-toolbar><md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head \nmd-order=\"vm.sort\" md-on-reorder=\"vm.getBloodGlucoseTests\"><tr md-row><th md-column md-order-by=\"tested_on\"><span \ntranslate=\"BLOOD_GLUCOSE_TEST.COLUMNS.TEST_DATE_TIME\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.COLUMNS.METER_READING\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th></tr></thead><tbody md-body><tr md-row \nmd-auto-select ng-repeat=\"test in vm.bloodGlucoseTests\"><td md-cell>{{ test.tested_on | date:\'yyyy-MM-dd hh:mma\' }}\n</td><td md-cell><span ng-if=\"test.is_high\" class=\"red-fg\">HIGH</span><span ng-if=\"test.is_low\" class=\"red-fg\">LOW\n</span><span ng-if=\"!test.is_high && !test.is_low\">{{ test.meter_reading | number:1 }}</span></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.pagination.per_page\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" md-total=\"{{ vm.pagination.total }}\" \nmd-on-paginate=\"vm.getBloodGlucoseTests\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/blood-glucose-test/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div layout=\"row\" \nflex=\"50\"><md-input-container flex><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nflex class=\"ml-20\"><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.METER_SERIAL_NO\"></label>\n<md-select md-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.selectedMeter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.selectedMeterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"BLOOD_GLUCOSE_TEST.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-if=\"vm.loaded\" class=\"animate-slide-right simple-table-container md-whiteframe-1dp\">\n<md-table-container><table md-table><thead md-head><tr md-row><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.METER_MODEL\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.HOSPITAL\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.LOCATION_CODE\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.PERSON_IN_CHARGE\"></span></th></tr></thead><tbody md-body><tr md-row \ndisabled=\"disabled\"><td md-cell>{{ vm.selectedMeter.model_no }}</td><td md-cell>\n{{ vm.selectedMeter.location.hospital.name }}</td><td md-cell>{{ vm.selectedMeter.location.code }}</td><td md-cell>\n{{ vm.selectedMeter.location.person_in_charge }}</td></tr></tbody><tfoot><tr><td></td></tr></tfoot></table>\n</md-table-container></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span translate=\"BLOOD_GLUCOSE_TEST.PANEL_TITLE\">\n</span><div flex></div></div></md-toolbar><md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head \nmd-order=\"vm.sort\" md-on-reorder=\"vm.getBloodGlucoseTests\"><tr md-row><th md-column md-order-by=\"tested_on\"><span \ntranslate=\"BLOOD_GLUCOSE_TEST.COLUMNS.TEST_DATE_TIME\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.COLUMNS.METER_READING\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th></tr></thead><tbody md-body><tr md-row \nmd-auto-select ng-repeat=\"test in vm.bloodGlucoseTests\"><td md-cell>{{ test.tested_on | date:\'yyyy-MM-dd hh:mma\' }}\n</td><td md-cell><span ng-if=\"test.is_high\" class=\"red-fg\">HIGH</span><span ng-if=\"test.is_low\" class=\"red-fg\">LOW\n</span><span ng-if=\"!test.is_high && !test.is_low\">{{ test.meter_reading | number:1 }}</span></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.pagination.per_page\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" md-total=\"{{ vm.pagination.total }}\" \nmd-on-paginate=\"vm.getBloodGlucoseTests\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/blood-glucose-test/hospital-operator/hospital-operator.html","<form name=\"vm.filterForm\" class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div layout=\"row\" \nflex=\"50\"><md-input-container flex><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nflex class=\"ml-20\"><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"BLOOD_GLUCOSE_TEST.FILTERS.METER_SERIAL_NO\"></label>\n<md-select md-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.selectedMeter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.selectedMeterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"BLOOD_GLUCOSE_TEST.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"BLOOD_GLUCOSE_TEST.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-if=\"vm.loaded\" class=\"animate-slide-right simple-table-container md-whiteframe-1dp\">\n<md-table-container><table md-table><thead md-head><tr md-row><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.METER_MODEL\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.HOSPITAL\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.LOCATION_CODE\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.METER.PERSON_IN_CHARGE\"></span></th></tr></thead><tbody md-body><tr md-row \ndisabled=\"disabled\"><td md-cell>{{ vm.selectedMeter.model_no }}</td><td md-cell>\n{{ vm.selectedMeter.location.hospital.name }}</td><td md-cell>{{ vm.selectedMeter.location.code }}</td><td md-cell>\n{{ vm.selectedMeter.location.person_in_charge }}</td></tr></tbody><tfoot><tr><td></td></tr></tfoot></table>\n</md-table-container></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span translate=\"BLOOD_GLUCOSE_TEST.PANEL_TITLE\">\n</span><div flex></div></div></md-toolbar><md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head \nmd-order=\"vm.sort\" md-on-reorder=\"vm.getBloodGlucoseTests\"><tr md-row><th md-column md-order-by=\"tested_on\"><span \ntranslate=\"BLOOD_GLUCOSE_TEST.COLUMNS.TEST_DATE_TIME\"></span></th><th md-column><span \ntranslate=\"BLOOD_GLUCOSE_TEST.COLUMNS.METER_READING\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th></tr></thead><tbody md-body><tr md-row \nmd-auto-select ng-repeat=\"test in vm.bloodGlucoseTests\"><td md-cell>{{ test.tested_on | date:\'yyyy-MM-dd hh:mma\' }}\n</td><td md-cell><span ng-if=\"test.is_high\" class=\"red-fg\">HIGH</span><span ng-if=\"test.is_low\" class=\"red-fg\">LOW\n</span><span ng-if=\"!test.is_high && !test.is_low\">{{ test.meter_reading | number:1 }}</span></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.pagination.per_page\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" md-total=\"{{ vm.pagination.total }}\" \nmd-on-paginate=\"vm.getBloodGlucoseTests\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><h1 class=\"margin-bottom-32\">Accu-Chek<span\n class=\"text-super font-size-10\">®</span> Quest Online</h1><div class=\"title\" translate=\"LOGIN.TITLE\"></div><div \nclass=\"mb-16\"><span translate=\"LOGIN.TERMS_OF_USE_MESSAGE\"></span>&nbsp;<a href=\"#\" \nclass=\"md-accent-color md-default-theme\" ng-click=\"vm.termsOfUse($event)\" translate=\"LOGIN.TERMS_OF_USE\"></a></div>\n<form name=\"loginForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"email\" \nng-model=\"vm.form.email\" required translate-attr=\"{ placeholder: \'LOGIN.EMAIL\'}\" \naria-label=\"{{ \'LOGIN.EMAIL\' | translate }}\"><div ng-messages=\"loginForm.email.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN.INPUT_MESSAGES.EMAIL_REQUIRED\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nrequired translate-attr=\"{ placeholder: \'LOGIN.PASSWORD\'}\" aria-label=\"{{ \'LOGIN.PASSWORD\' | translate }}\"><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.INPUT_MESSAGES.PASSWORD_REQUIRED\"></span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"start\"><md-checkbox class=\"remember-me\" \nng-model=\"vm.remember_me\" aria-label=\"{{ \'LOGIN.REMEMBER_ME\' | translate }}\"><span translate=\"LOGIN.REMEMBER_ME\">\n</span></md-checkbox></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" ng-click=\"vm.submit()\" translate=\"LOGIN.LOG_IN\" \naria-label=\"{{ \'LOGIN.LOG_IN\' | translate }}\"></md-button></form><div class=\"separator\"><span class=\"text\" \ntranslate=\"LOGIN.OR\"></span></div><md-button type=\"button\" class=\"md-accent upload\" ng-click=\"vm.uploadMeterData()\" \ntranslate=\"LOGIN.UPLOAD_METER_DATA\" aria-label=\"{{ \'LOGIN.UPLOAD_METER_DATA\' | translate }}\"></md-button></div></div>\n</div><div class=\"footer-copy-right\" layout=\"column\" layout-align=\"end end\"><span class=\"logo-text\">\n©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/control-solution/batch-create-control-solutions-form/batch-create-control-solutions-form.html","<md-dialog class=\"batch-create-control-solutions-form\" \naria-label=\"{{ \'CONTROL_SOLUTION_FORM.BATCH_CREATE\' | translate }}\"><form name=\"vm.controlSolutionForm\" \nclass=\"md-inline-form\" novalidate ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"{{ \'CONTROL_SOLUTION_FORM.BATCH_CREATE\' | translate }}\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"{{ \'CONTROL_SOLUTION_FORM.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTROL_SOLUTION_FORM.HOSPITALS\"></label><md-select multiple=\"multiple\" name=\"selectedHospitals\" \nng-model=\"vm.selectedHospitals\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nmd-on-close=\"vm.controlSolutionForm.lot_no.$validate()\" md-selected-text=\"vm.getSelectedHospitalsText()\" required>\n<md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.selectedHospitals.length === vm.hospitals.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.selectedHospitals = []\" \naria-label=\"{{\n                \'CONTROL_SOLUTION_FORM.UN_SELECT_ALL\' | translate\n              }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.selectedHospitals.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.selectedHospitals = vm.hospitals\" \naria-label=\"{{ \'CONTROL_SOLUTION_FORM.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\">\n</md-icon></md-button><md-button \nng-if=\"vm.selectedHospitals.length && vm.selectedHospitals.length !== vm.hospitals.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.selectedHospitals = vm.hospitals\" \naria-label=\"{{ \'CONTROL_SOLUTION_FORM.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\"></md-icon>\n</md-button></md-select-header><md-option ng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}\n</md-option></md-select><div ng-messages=\"vm.controlSolutionForm.selectedHospitals.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CONTROL_SOLUTION_FORM.INPUT_MESSAGES.HOSPITALS_REQUIRED\"></span></div></div>\n</md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTROL_SOLUTION_FORM.CONTROL_TYPE\"></label><md-select multiple=\"multiple\" name=\"type\" \nng-model=\"vm.selectedTypes\" md-selected-text=\"vm.getSelectedTypesText()\" required md-on-close=\"vm.validateLotNo()\">\n<md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.selectedTypes.length === vm.types.length\" class=\"md-icon-button md-primary\" ng-click=\"vm.selectedTypes = []\" \naria-label=\"{{\n                  \'CONTROL_SOLUTION_FORM.UN_SELECT_ALL\' | translate\n                }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.selectedTypes.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.selectedTypes = vm.types\" \naria-label=\"{{\n                  \'CONTROL_SOLUTION_FORM.SELECT_ALL\' | translate\n                }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.selectedTypes.length && vm.selectedTypes.length !== vm.types.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.selectedTypes = vm.types\" \naria-label=\"{{\n                  \'CONTROL_SOLUTION_FORM.SELECT_ALL\' | translate\n                }}\"><md-icon \nmd-font-icon=\"icon-minus-box\"></md-icon></md-button></md-select-header><md-option ng-value=\"type\" \nng-repeat=\"type in vm.types\">{{ type }}</md-option></md-select><div ng-messages=\"vm.controlSolutionForm.type.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"CONTROL_SOLUTION_FORM.INPUT_MESSAGES.CONTROL_TYPE_REQUIRED\">\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTROL_SOLUTION_FORM.CONTROL_LOT_NO\"></label><input name=\"lot_no\" ng-model=\"vm.controlSolution.lot_no\" \nrequired check-control-solution-lot-no-availability types=\"{{ vm.selectedTypes }}\" \nhospital-ids=\"{{ vm.getSelectedHospitalIds() }}\"><div ng-messages=\"vm.controlSolutionForm.lot_no.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"CONTROL_SOLUTION_FORM.INPUT_MESSAGES.CONTROL_LOT_NO_REQUIRED\"></span></div>\n<div ng-message=\"invalidControlSolutionLotNo\"><span \ntranslate=\"CONTROL_SOLUTION_FORM.INPUT_MESSAGES.CONTROL_LOT_NO_IN_SOME_HOSPITAL_INVALID\"></span></div></div><span \nclass=\"hint-text font-size-12\" ng-show=\"vm.controlSolutionForm.lot_no.$pending\">checking availability...</span>\n</md-input-container></div><div layout=\"row\" class=\"adjust-row-margin-in-form\"><md-input-container class=\"md-block\" \nflex><label translate=\"CONTROL_SOLUTION_FORM.CONTROL_EXPIRY\"></label><md-datepicker name=\"expiry\" ng-model=\"vm.expiry\" \nrequired md-hide-icons=\"calendar\"></md-datepicker><div ng-messages=\"vm.controlSolutionForm.expiry.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"CONTROL_SOLUTION_FORM.INPUT_MESSAGES.CONTROL_EXPIRY_REQUIRED\"></span></div><div ng-message=\"valid\"><span \ntranslate=\"CONTROL_SOLUTION_FORM.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div></div><md-button \nng-click=\"vm.save()\" class=\"save-button md-accent md-raised\" \nng-disabled=\"vm.controlSolutionForm.$pending || vm.controlSolutionForm.$invalid || vm.controlSolutionForm.$pristine\" \ntranslate=\"CONTROL_SOLUTION_FORM.SAVE\" aria-label=\"{{ \'CONTROL_SOLUTION_FORM.SAVE\' | translate }}\"></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/control-solution/control-solution-form/control-solution-form.html","<md-dialog class=\"control-solution-form\" aria-label=\"{{ vm.dialogTitle }}\"><form name=\"vm.controlSolutionForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{ vm.dialogTitle }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"{{ \'CONTROL_SOLUTION_FORM.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p class=\"pb-10\" ng-if=\"vm.isReadOnly\" \ntranslate=\"MAIN.DATA_SENT_FROM_CLOUD_LINK\"></p><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTROL_SOLUTION_FORM.HOSPITAL\"></label><md-select \nng-disabled=\"vm.isReadOnly || vm.dialogData.type === \'edit\' || !vm.isCountryAdmin\" name=\"hospital\" \nng-model=\"vm.selectedHospital\" ng-model-options=\"{trackBy: \'$value.id\'}\" required md-on-close=\"vm.validateLotNo()\">\n<md-option ng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.controlSolutionForm.hospital.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CONTROL_SOLUTION_FORM.INPUT_MESSAGES.HOSPITAL_REQUIRED\"></span></div></div></md-input-container><div \nlayout=\"row\" ng-if=\"vm.dialogData.type === \'create\'\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTROL_SOLUTION_FORM.CONTROL_TYPE\"></label><md-select ng-disabled=\"vm.isReadOnly\" multiple=\"multiple\" \nname=\"type\" ng-model=\"vm.selectedTypes\" md-selected-text=\"vm.getSelectedTypesText()\" required \nmd-on-close=\"vm.validateLotNo()\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.selectedTypes.length === vm.types.length\" class=\"md-icon-button md-primary\" ng-click=\"vm.selectedTypes = []\" \naria-label=\"{{\n                  \'CONTROL_SOLUTION_FORM.UN_SELECT_ALL\' | translate\n                }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.selectedTypes.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.selectedTypes = vm.types\" \naria-label=\"{{\n                  \'CONTROL_SOLUTION_FORM.SELECT_ALL\' | translate\n                }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.selectedTypes.length && vm.selectedTypes.length !== vm.types.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.selectedTypes = vm.types\" \naria-label=\"{{\n                  \'CONTROL_SOLUTION_FORM.SELECT_ALL\' | translate\n                }}\"><md-icon \nmd-font-icon=\"icon-minus-box\"></md-icon></md-button></md-select-header><md-option ng-value=\"type\" \nng-repeat=\"type in vm.types\">{{ type }}</md-option></md-select><div ng-messages=\"vm.controlSolutionForm.type.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"CONTROL_SOLUTION_FORM.INPUT_MESSAGES.CONTROL_TYPE_REQUIRED\">\n</span></div></div></md-input-container></div><div layout=\"row\" ng-if=\"vm.dialogData.type !== \'create\'\">\n<md-input-container class=\"md-block\" flex><label translate=\"CONTROL_SOLUTION_FORM.CONTROL_TYPE\"></label><md-select \nng-disabled=\"vm.isReadOnly\" name=\"type\" ng-disabled=\"vm.dialogData.type === \'edit\'\" ng-model=\"vm.controlSolution.type\" \nrequired md-on-close=\"vm.validateLotNo()\"><md-option ng-value=\"type\" ng-repeat=\"type in vm.types\">{{ type }}\n</md-option></md-select><div ng-messages=\"vm.controlSolutionForm.type.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"CONTROL_SOLUTION_FORM.INPUT_MESSAGES.CONTROL_TYPE_REQUIRED\"></span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"CONTROL_SOLUTION_FORM.CONTROL_LOT_NO\"></label><input ng-disabled=\"vm.isReadOnly\" name=\"lot_no\" \nng-model=\"vm.controlSolution.lot_no\" required check-control-solution-lot-no-availability \nhospital-id=\"{{ vm.selectedHospital.id }}\" type=\"{{ vm.controlSolution.type }}\" types=\"{{ vm.selectedTypes }}\" \nignore-id=\"{{ vm.controlSolution.id }}\"><div ng-messages=\"vm.controlSolutionForm.lot_no.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CONTROL_SOLUTION_FORM.INPUT_MESSAGES.CONTROL_LOT_NO_REQUIRED\"></span></div><div \nng-message=\"invalidControlSolutionLotNo\"><span translate=\"CONTROL_SOLUTION_FORM.INPUT_MESSAGES.CONTROL_LOT_NO_INVALID\">\n</span></div></div><span class=\"hint-text font-size-12\" ng-show=\"vm.controlSolutionForm.lot_no.$pending\">\nchecking availability...</span></md-input-container></div><div layout=\"row\" class=\"adjust-row-margin-in-form\">\n<md-input-container class=\"md-block\" flex><label translate=\"CONTROL_SOLUTION_FORM.CONTROL_EXPIRY\"></label>\n<md-datepicker ng-disabled=\"vm.isReadOnly\" name=\"expiry\" ng-model=\"vm.expiry\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.controlSolutionForm.expiry.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"CONTROL_SOLUTION_FORM.INPUT_MESSAGES.CONTROL_EXPIRY_REQUIRED\"></span></div><div \nng-message=\"valid\"><span translate=\"CONTROL_SOLUTION_FORM.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<div></div><md-button ng-click=\"vm.save()\" class=\"save-button md-accent md-raised\" \nng-disabled=\"vm.isReadOnly || vm.controlSolutionForm.$pending || vm.controlSolutionForm.$invalid || vm.controlSolutionForm.$pristine\" \ntranslate=\"CONTROL_SOLUTION_FORM.SAVE\" aria-label=\"{{ \'CONTROL_SOLUTION_FORM.SAVE\' | translate }}\"></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/current-lot/change-control-solution/change-control-solution.html","<md-dialog class=\"change-control-solution\" \naria-label=\"{{\n    \'CURRENT_LOT.CHANGE_LOT_FORM.CHANGE_CONTROL_SOLUTION\'\n      | translate: \'{ type: vm.type }\'\n  }}\">\n<form name=\"controlSolutionForm\" novalidate ng-cloak><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.CHANGE_CONTROL_SOLUTION\" translate-values=\"{ type: vm.type }\"></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"{{ \'CURRENT_LOT.CHANGE_LOT_FORM.CLOSE\' | translate }}\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nng-if=\"vm.currentControlSolution\" class=\"pb-10\"><span translate=\"CURRENT_LOT.CHANGE_LOT_FORM.CURRENT_CONTROL_LOT_IS\" \ntranslate-values=\"{ type: vm.type, lot_no: vm.currentControlSolution.lot_no }\"></span></div><div \nng-if=\"!vm.currentControlSolution\" class=\"pb-10\"><span \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.CURRENT_CONTROL_LOT_IS_NOT_SPECIFIED\" translate-values=\"{ type: vm.type }\">\n</span></div><md-input-container class=\"md-block\" flex><label translate=\"CURRENT_LOT.CHANGE_LOT_FORM.CONTROL_LOT\">\n</label><md-select name=\"controlSolution\" ng-change=\"vm.selectedControlSolutionChanged()\" \nng-model=\"vm.selectedControlSolution\" ng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option \nng-value=\"controlSolution\" ng-repeat=\"controlSolution in vm.controlSolutions\">{{ controlSolution.lot_no }}</md-option>\n</md-select><div ng-messages=\"controlSolutionForm.controlSolution.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"CURRENT_LOT.CHANGE_LOT_FORM.INPUT_MESSAGES.CONTROL_LOT_REQUIRED\"></span></div></div></md-input-container>\n<div layout=\"row\"><md-input-container flex><label translate=\"CURRENT_LOT.CHANGE_LOT_FORM.CHANGED_DATE\"></label>\n<md-datepicker name=\"changedDate\" ng-model=\"vm.changedDate\" required md-hide-icons=\"calendar\" \nng-disabled=\"vm.currentControlSolution && vm.selectedControlSolution && vm.currentControlSolution.id === vm.selectedControlSolution.id\">\n</md-datepicker><div ng-messages=\"controlSolutionForm.changedDate.$error\"><div ng-message=\"valid\"><span \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></span></div><div ng-message=\"required\">\n<span translate=\"CURRENT_LOT.CHANGE_LOT_FORM.INPUT_MESSAGES.REQUIRED\"></span></div></div></md-input-container><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label class=\"changed-hour\" \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.CHANGED_TIME\"></label><md-select name=\"changedHour\" ng-model=\"vm.changedHour\" \nrequired \nng-disabled=\"vm.currentControlSolution && vm.selectedControlSolution && vm.currentControlSolution.id === vm.selectedControlSolution.id\">\n<md-option ng-repeat=\"hour in vm.hours\" ng-value=\"hour.value\">{{ hour.text }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label class=\"changed-minute\">Changed Minute</label>\n<md-select name=\"changedMinute\" ng-model=\"vm.changedMinute\" \nng-disabled=\"vm.currentControlSolution && vm.selectedControlSolution && vm.currentControlSolution.id === vm.selectedControlSolution.id\">\n<md-option ng-repeat=\"minute in vm.minutes\" ng-value=\"minute.value\">{{ minute.text }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label class=\"changed-meridiem\">Changed Meridiem</label>\n<md-select name=\"changedMeridiem\" ng-model=\"vm.changedMeridiem\" \nng-disabled=\"vm.currentControlSolution && vm.selectedControlSolution && vm.currentControlSolution.id === vm.selectedControlSolution.id\">\n<md-option value=\"AM\">AM</md-option><md-option value=\"PM\">PM</md-option></md-select></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-accent\" \naria-label=\"NOW\" ng-click=\"vm.now()\" \nng-disabled=\"vm.currentControlSolution && vm.selectedControlSolution && vm.currentControlSolution.id === vm.selectedControlSolution.id\" \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.NOW\" aria-label=\"{{ \'CURRENT_LOT.CHANGE_LOT_FORM.NOW\' | translate }}\">\n</md-button><md-button ng-click=\"vm.save()\" class=\"md-accent md-raised\" \nng-disabled=\"controlSolutionForm.$invalid || controlSolutionForm.$pristine || (vm.currentControlSolution && vm.selectedControlSolution && vm.currentControlSolution.id === vm.selectedControlSolution.id)\" \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.SAVE\" aria-label=\"{{ \'CURRENT_LOT.CHANGE_LOT_FORM.SAVE\' | translate }}\">\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/current-lot/change-test-strip/change-test-strip.html","<md-dialog class=\"change-test-strip\" aria-label=\"{{ \'CURRENT_LOT.CHANGE_LOT_FORM.CHANGE_TEST_STRIP\' | translate }}\">\n<form name=\"testStripForm\" novalidate ng-cloak><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.CHANGE_TEST_STRIP\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"{{ \'CURRENT_LOT.CHANGE_LOT_FORM.CLOSE\' | translate }}\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nng-if=\"vm.currentTestStrip\" class=\"pb-10\"><span translate=\"CURRENT_LOT.CHANGE_LOT_FORM.CURRENT_STRIP_LOT_IS\" \ntranslate-values=\"{ lot_no: vm.currentTestStrip.lot_no }\"></span></div><div ng-if=\"!vm.currentTestStrip\" class=\"pb-10\">\n<span translate=\"CURRENT_LOT.CHANGE_LOT_FORM.CURRENT_STRIP_LOT_IS_NOT_SPECIFIED\"></span></div><md-input-container \nclass=\"md-block\" flex><label translate=\"CURRENT_LOT.CHANGE_LOT_FORM.STRIP_LOT\"></label><md-select name=\"testStrip\" \nng-change=\"vm.selectedTestStripChanged()\" ng-model=\"vm.selectedTestStrip\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nrequired><md-option ng-value=\"testStrip\" ng-repeat=\"testStrip in vm.testStrips\">{{ testStrip.lot_no }}</md-option>\n</md-select><div ng-messages=\"testStripForm.testStrip.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.INPUT_MESSAGES.STRIP_LOT_REQUIRED\"></span></div></div></md-input-container><div \nlayout=\"row\"><md-input-container flex><label translate=\"CURRENT_LOT.CHANGE_LOT_FORM.CHANGED_DATE\"></label>\n<md-datepicker name=\"changedDate\" ng-model=\"vm.changedDate\" required md-hide-icons=\"calendar\" \nng-disabled=\"vm.currentTestStrip && vm.selectedTestStrip && vm.currentTestStrip.id === vm.selectedTestStrip.id\">\n</md-datepicker><div ng-messages=\"testStripForm.changedDate.$error\"><div ng-message=\"valid\" \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><div layout=\"row\" \nflex><md-input-container class=\"md-block\" flex><label class=\"changed-hour\" \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.CHANGED_TIME\"></label><md-select name=\"changedHour\" ng-model=\"vm.changedHour\" \nrequired \nng-disabled=\"vm.currentTestStrip && vm.selectedTestStrip && vm.currentTestStrip.id === vm.selectedTestStrip.id\">\n<md-option ng-repeat=\"hour in vm.hours\" ng-value=\"hour.value\">{{ hour.text }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label class=\"changed-minute\">Changed Minute</label>\n<md-select name=\"changedMinute\" ng-model=\"vm.changedMinute\" \nng-disabled=\"vm.currentTestStrip && vm.selectedTestStrip && vm.currentTestStrip.id === vm.selectedTestStrip.id\">\n<md-option ng-repeat=\"minute in vm.minutes\" ng-value=\"minute.value\">{{ minute.text }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label class=\"changed-meridiem\">Changed Meridiem</label>\n<md-select name=\"changedMeridiem\" ng-model=\"vm.changedMeridiem\" \nng-disabled=\"vm.currentTestStrip && vm.selectedTestStrip && vm.currentTestStrip.id === vm.selectedTestStrip.id\">\n<md-option value=\"AM\">AM</md-option><md-option value=\"PM\">PM</md-option></md-select></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-accent\" \nng-click=\"vm.now()\" \nng-disabled=\"vm.currentTestStrip && vm.selectedTestStrip && vm.currentTestStrip.id === vm.selectedTestStrip.id\" \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.NOW\" aria-label=\"{{ \'CURRENT_LOT.CHANGE_LOT_FORM.NOW\' | translate }}\">\n</md-button><md-button ng-click=\"vm.save()\" class=\"md-accent md-raised\" \nng-disabled=\"testStripForm.$invalid || testStripForm.$pristine || (vm.currentTestStrip && vm.selectedTestStrip && vm.currentTestStrip.id === vm.selectedTestStrip.id)\" \ntranslate=\"CURRENT_LOT.CHANGE_LOT_FORM.SAVE\" aria-label=\"{{ \'CURRENT_LOT.CHANGE_LOT_FORM.SAVE\' | translate }}\">\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/current-lot/edit-control-solution-history/edit-control-solution-history.html","<md-dialog class=\"edit-control-solution-history\" \naria-label=\"{{ \'CURRENT_LOT.EDIT_HISTORY_FORM.EDIT_CONTROL_SOLUTION\' | translate: \'{ type: vm.type }\' }}\"><form \nname=\"controlSolutionForm\" novalidate ng-cloak><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.EDIT_CONTROL_SOLUTION\" translate-values=\"{ type: vm.type }\"></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"{{ \'CURRENT_LOT.EDIT_HISTORY_FORM\' | translate }}\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p class=\"pb-10\"><span \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.EDIT_CONTROL_SOLUTION_WITH\" \ntranslate-values=\"{ type: vm.type, lot_no: vm.controlSolutionHistory.lot_no }\"></span></p><md-input-container \nclass=\"md-block\" flex><label translate=\"CURRENT_LOT.EDIT_HISTORY_FORM.CONTROL_LOT\"></label><md-select \nname=\"controlSolution\" ng-model=\"vm.selectedControlSolution\" ng-model-options=\"{trackBy: \'$value.id\'}\" required>\n<md-option ng-value=\"controlSolution\" ng-repeat=\"controlSolution in vm.controlSolutions\">{{ controlSolution.lot_no }}\n</md-option></md-select><div ng-messages=\"controlSolutionForm.controlSolution.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CURRENT_LOT.EDIT_HISTORY_FORM.INPUT_MESSAGES.CONTROL_LOT_REQUIRED\"></span></div>\n</div></md-input-container><div layout=\"row\"><md-input-container flex><label \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.CHANGED_DATE\"></label><md-datepicker name=\"changedDate\" \nng-model=\"vm.changedDate\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"controlSolutionForm.changedDate.$error\"><div ng-message=\"valid\"><span \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></span></div><div ng-message=\"required\">\n<span translate=\"CURRENT_LOT.EDIT_HISTORY_FORM.INPUT_MESSAGES.REQUIRED\"></span></div></div></md-input-container><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label class=\"changed-hour\" \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.CHANGED_TIME\"></label><md-select name=\"changedHour\" ng-model=\"vm.changedHour\" \nrequired><md-option ng-repeat=\"hour in vm.hours\" ng-value=\"hour.value\">{{ hour.text }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label class=\"changed-minute\">Changed Minute</label>\n<md-select name=\"changedMinute\" ng-model=\"vm.changedMinute\"><md-option ng-repeat=\"minute in vm.minutes\" \nng-value=\"minute.value\">{{ minute.text }}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex><label class=\"changed-meridiem\">Changed Meridiem</label><md-select name=\"changedMeridiem\" \nng-model=\"vm.changedMeridiem\"><md-option value=\"AM\">AM</md-option><md-option value=\"PM\">PM</md-option></md-select>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-accent\" aria-label=\"NOW\" ng-click=\"vm.now()\" \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.NOW\" aria-label=\"{{ \'CURRENT_LOT.EDIT_HISTORY_FORM.NOW\' | translate }}\">\n</md-button><md-button ng-click=\"vm.save()\" class=\"md-accent md-raised\" \nng-disabled=\"!vm.dirty && (controlSolutionForm.$invalid || controlSolutionForm.$pristine)\" \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.SAVE\" aria-label=\"{{ \'CURRENT_LOT.EDIT_HISTORY_FORM.SAVE\' | translate }}\">\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/current-lot/edit-test-strip-history/edit-test-strip-history.html","<md-dialog class=\"edit-test-strip-history\" \naria-label=\"{{ \'CURRENT_LOT.EDIT_HISTORY_FORM.EDIT_TEST_STRIP\' | translate }}\"><form name=\"testStripForm\" novalidate \nng-cloak><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CURRENT_LOT.EDIT_HISTORY_FORM.EDIT_TEST_STRIP\">\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" \naria-label=\"{{ \'CURRENT_LOT.EDIT_HISTORY_FORM.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><p class=\"pb-10\"><span \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.EDIT_TEST_STRIP_WITH\" \ntranslate-values=\"{ lot_no: vm.testStripHistory.lot_no }\"></span></p><md-input-container class=\"md-block\" flex><label \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.STRIP_LOT\"></label><md-select name=\"testStrip\" \nng-model=\"vm.selectedTestStrip\" ng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option ng-value=\"testStrip\" \nng-repeat=\"testStrip in vm.testStrips\">{{ testStrip.lot_no }}</md-option></md-select><div \nng-messages=\"testStripForm.testStrip.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.INPUT_MESSAGES.STRIP_LOT_REQUIRED\"></span></div></div></md-input-container>\n<div layout=\"row\"><md-input-container flex><label translate=\"CURRENT_LOT.EDIT_HISTORY_FORM.CHANGED_DATE\"></label>\n<md-datepicker name=\"changedDate\" ng-model=\"vm.changedDate\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"testStripForm.changedDate.$error\"><div ng-message=\"valid\" \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><div layout=\"row\" \nflex><md-input-container class=\"md-block\" flex><label class=\"changed-hour\" \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.CHANGED_TIME\"></label><md-select name=\"changedHour\" ng-model=\"vm.changedHour\" \nrequired><md-option ng-repeat=\"hour in vm.hours\" ng-value=\"hour.value\">{{ hour.text }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label class=\"changed-minute\">Changed Minute</label>\n<md-select name=\"changedMinute\" ng-model=\"vm.changedMinute\"><md-option ng-repeat=\"minute in vm.minutes\" \nng-value=\"minute.value\">{{ minute.text }}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex><label class=\"changed-meridiem\">Changed Meridiem</label><md-select name=\"changedMeridiem\" \nng-model=\"vm.changedMeridiem\"><md-option value=\"AM\">AM</md-option><md-option value=\"PM\">PM</md-option></md-select>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-accent\" ng-click=\"vm.now()\" \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.NOW\" aria-label=\"{{ \'CURRENT_LOT.EDIT_HISTORY_FORM.NOW\' | translate }}\">\n</md-button><md-button ng-click=\"vm.save()\" class=\"md-accent md-raised\" \nng-disabled=\"!vm.dirty && (testStripForm.$invalid || testStripForm.$pristine)\" \ntranslate=\"CURRENT_LOT.EDIT_HISTORY_FORM.SAVE\" aria-label=\"{{ \'CURRENT_LOT.EDIT_HISTORY_FORM.SAVE\' | translate }}\">\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/hospital/hospital-form/hospital-form.html","<md-dialog class=\"hospital-form\" aria-label=\"{{ vm.dialogTitle }}\"><form name=\"vm.hospitalForm\" novalidate><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{ vm.dialogTitle }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" \naria-label=\"{{ \'HOSPITAL_FORM.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><p class=\"pb-10\"><span translate=\"HOSPITAL_FORM.SUB_TITLE\" \ntranslate-values=\"{title: vm.dialogTitle, country: vm.countries[vm.country]}\"></span></p><md-input-container \nclass=\"md-block\"><label translate=\"HOSPITAL_FORM.HOSPITAL\"></label><input name=\"name\" ng-model=\"vm.hospital.name\" \nrequired check-hospital-name-availability country=\"{{ vm.country }}\" ignore-id=\"{{ vm.hospital.id }}\"><div \nng-messages=\"vm.hospitalForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"HOSPITAL_FORM.INPUT_MESSAGES.HOSPITAL_REQUIRED\"></span></div><div ng-message=\"invalidHospitalName\"><span \ntranslate=\"HOSPITAL_FORM.INPUT_MESSAGES.HOSPITAL_NAME_INVALID\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"HOSPITAL_FORM.ADDRESS\"></label><input name=\"address\" \nng-model=\"vm.hospital.address\"></md-input-container><div layout=\"row\"><md-input-container flex><label \ntranslate=\"HOSPITAL_FORM.CITY\"></label><input name=\"city\" ng-model=\"vm.hospital.city\" required><div \nng-messages=\"vm.hospitalForm.city.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"HOSPITAL_FORM.INPUT_MESSAGES.CITY_REQUIRED\"></span></div></div></md-input-container><md-input-container \nflex><label translate=\"HOSPITAL_FORM.STATE\"></label><md-select name=\"state\" ng-model=\"vm.selectedState\" \nng-model-options=\"{trackBy: \'$value.code\'}\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.hospitalForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"HOSPITAL_FORM.INPUT_MESSAGES.STATE_REQUIRED\"></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"HOSPITAL_FORM.SIZE\"></label><md-select name=\"size\" \nng-model=\"vm.selectedSize\" ng-model-options=\"{trackBy: \'$value.name\'}\" required><md-option ng-value=\"size\" \nng-repeat=\"size in vm.sizes\">{{ size.caption }}</md-option></md-select><div ng-messages=\"vm.hospitalForm.size.$error\">\n<div ng-message=\"required\" translate=\"HOSPITAL_FORM.INPUT_MESSAGES.SIZE_REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"HOSPITAL_FORM.TYPE\"></label><md-select name=\"type\" \nng-model=\"vm.selectedType\" ng-model-options=\"{trackBy: \'$value.name\'}\" required><md-option ng-value=\"type\" \nng-repeat=\"type in vm.types\">{{ type.caption }}</md-option></md-select><div ng-messages=\"vm.hospitalForm.type.$error\">\n<div ng-message=\"required\" translate=\"HOSPITAL_FORM.INPUT_MESSAGES.TYPE_REQUIRED\"></div></div></md-input-container>\n</div><md-input-container class=\"md-block md-input-has-value\"><label>\n{{ \'HOSPITAL_FORM.DEFAULT_MEASUREMENT_UNIT\' | translate }}&nbsp;<sup>*</sup></label><md-radio-group \nname=\"defaultMeasurementUnit\" ng-model=\"vm.selectedMeasurementUnit\" required><div class=\"measurement-unit-container\" \nng-repeat=\"measurementUnit in vm.measurementUnits\"><md-radio-button ng-value=\"measurementUnit\">\n{{ measurementUnit.caption }}</md-radio-button></div></md-radio-group><div \nng-messages=\"vm.hospitalForm.defaultMeasurementUnit.$error\"><div ng-message=\"required\" \ntranslate=\"HOSPITAL_FORM.INPUT_MESSAGES.DEFAULT_MEASUREMENT_UNIT_REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block md-input-has-value\"><label>{{ \'HOSPITAL_FORM.DEFAULT_MODULES\' | translate }}&nbsp;\n<sup>*</sup></label><div><md-checkbox aria-label=\"{{ \'HOSPITAL_FORM.DEFAULT_MODULES\' | translate }}\" \nng-checked=\"vm.isChecked()\" md-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"><span \nng-if=\"vm.isChecked()\" translate=\"HOSPITAL_FORM.UN_SELECT_ALL\"></span> <span ng-if=\"!vm.isChecked()\" \ntranslate=\"HOSPITAL_FORM.SELECT_ALL\"></span></md-checkbox></div><div class=\"module-checkbox-container\" \nng-repeat=\"module in vm.modules\"><md-checkbox ng-checked=\"vm.exists(module)\" ng-click=\"vm.toggle(module)\">\n{{ module.caption }}</md-checkbox></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div></div><md-button ng-click=\"vm.save()\" class=\"save-button md-accent md-raised\" \nng-disabled=\"vm.hospitalForm.$invalid || vm.hospitalForm.$pristine || !vm.selectedModules.length\" \ntranslate=\"HOSPITAL_FORM.SAVE\" aria-label=\"{{ \'HOSPITAL_FORM.SAVE\' | translate }}\"></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/log/qc-failed/qc-failed.html","<div id=\"test-strip-consumption\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"QC_FAILED_LOG.TITLE\"></div><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" \nmd-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu md-position-mode=\"right bottom\" \nmd-offset=\"0 2\"><md-button class=\"md-raised\" ng-click=\"$mdMenu.open()\" \naria-label=\"{{ \'QC_FAILED_LOG.EXPORT\' | translate }}\"><div layout=\"row\"><span translate=\"QC_FAILED_LOG.EXPORT\"></span>\n<md-icon md-font-icon=\"icon-menu-down\" class=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-delimited\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.exportToCSV()\" translate=\"QC_FAILED_LOG.CSV\" aria-label=\"{{ \'QC_FAILED_LOG.CSV\' | translate }}\">\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-excel\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.exportToExcel()\" translate=\"QC_FAILED_LOG.EXCEL\" \naria-label=\"{{ \'QC_FAILED_LOG.EXCEL\' | translate }}\"></md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></div></div><div class=\"content\"><div layout=\"column\"><form name=\"vm.filterForm\" \nclass=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><md-input-container flex=\"25\"><label \ntranslate=\"QC_FAILED_LOG.START_DATE\"></label><md-datepicker name=\"startDate\" ng-model=\"vm.startDate\" \nng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_FAILED_LOG.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_FAILED_LOG.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex=\"25\" \nclass=\"ml-20\"><label translate=\"QC_FAILED_LOG.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_FAILED_LOG.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_FAILED_LOG.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_FAILED_LOG.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div></form><div \nclass=\"animate-slide-right simple-table-container md-whiteframe-1dp\" ng-if=\"vm.show\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span translate=\"QC_FAILED_LOG.PANEL_TITLE\"></span>\n</div></md-toolbar><md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" \nmd-on-reorder=\"vm.getQualityControlTests\"><tr md-row><th md-column md-order-by=\"tested_on\"><span \ntranslate=\"QC_FAILED_LOG.COLUMNS.TEST_DATE_TIME\"></span></th><th md-column><span \ntranslate=\"QC_FAILED_LOG.COLUMNS.METER_SERIAL_NO\"></span></th><th md-column><span \ntranslate=\"QC_FAILED_LOG.COLUMNS.STRIP_LOT\"></span></th><th md-column><span \ntranslate=\"QC_FAILED_LOG.COLUMNS.CONTROL_TYPE\"></span></th><th md-column md-numeric>\n{{ \'QC_FAILED_LOG.COLUMNS.QC_TARGET_RANGE\' | translate }}&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})\n</th><th md-column md-numeric>\n{{ \'QC_FAILED_LOG.COLUMNS.QC_VALUE\' | translate }}&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})\n</th><th md-column><span translate=\"QC_FAILED_LOG.COLUMNS.NOTES\"></span></th><th md-column><span \ntranslate=\"QC_FAILED_LOG.COLUMNS.ACTION_COMPLETED\"></span></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"test in vm.qualityControlTests\"><td md-cell nowrap=\"nowrap\">{{ test.tested_on | date:\'yyyy-MM-dd hh:mma\' }}\n</td><td md-cell nowrap=\"nowrap\"><div>{{ test.meter.serial_no }}<md-tooltip md-direction=\"right\" \nclass=\"tooltip-multiline\"><div>{{ test.meter.location.code }}</div><div>{{ test.meter.location.person_in_charge }}\n</div><div>{{ test.meter.location.phone }}</div></md-tooltip></div></td><td md-cell nowrap=\"nowrap\">\n{{ test.test_strip.lot_no }}</td><td md-cell nowrap=\"nowrap\">{{ test.control_level }}</td><td md-cell>\n{{ test.from | number:1 }}&nbsp;{{ \'QC_FAILED_LOG.TO\' | translate }}&nbsp;{{ test.to | number:1 }}</td><td md-cell>\n{{ test.meter_reading | number:1 }}</td><td md-cell><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.editNotes(test, $event)\" aria-label=\"{{ \'QC_FAILED_LOG.NOTES\' | translate }}\"><md-icon \nng-if=\"!test.notes\" md-font-icon=\"icon-calendar-blank\" class=\"s16\"></md-icon><md-icon ng-if=\"test.notes\" \nmd-font-icon=\"icon-calendar-text\" class=\"s16\"></md-icon></md-button></td><td md-cell nowrap=\"nowrap\"><span \nng-if=\"test.actions_taken\">{{ test.actions_taken_at | date:\'yyyy-MM-dd hh:mma\' }}</span> <span \nng-if=\"!test.actions_taken\" translate=\"QC_FAILED_LOG.PENDING\"></span></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.pagination.per_page\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" md-total=\"{{ vm.pagination.total }}\" \nmd-on-paginate=\"vm.getQualityControlTests\" md-page-select></md-table-pagination></div></div></div></div><div \nclass=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img class=\"logo-image\" \nng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> \n<span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/location/location-form/location-form.html","<md-dialog class=\"location-form\" aria-label=\"{{ vm.dialogTitle }}\"><form name=\"locationForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{ vm.dialogTitle }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"{{ \'LOCATION_FORM.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p class=\"pb-10\" ng-if=\"!vm.isReadOnly\"><span \ntranslate=\"LOCATION_FORM.SUB_TITLE\" translate-values=\"{title: vm.dialogTitle, hospital: vm.hospital.name}\"></span></p>\n<p class=\"pb-10\" ng-if=\"vm.isReadOnly\" translate=\"MAIN.DATA_SENT_FROM_CLOUD_LINK\"></p><md-input-container \nclass=\"md-block\"><label translate=\"LOCATION_FORM.CODE\"></label><input ng-disabled=\"vm.isReadOnly\" name=\"code\" \nng-model=\"vm.location.code\" required><div ng-messages=\"locationForm.code.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOCATION_FORM.INPUT_MESSAGES.CODE_REQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"LOCATION_FORM.LOCATION\"></label><input \nng-disabled=\"vm.isReadOnly\" name=\"description\" ng-model=\"vm.location.description\" required><div \nng-messages=\"locationForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOCATION_FORM.INPUT_MESSAGES.LOCATION_REQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"LOCATION_FORM.PERSON_IN_CHARGE\"></label><input ng-disabled=\"vm.isReadOnly\" \nname=\"personInCharge\" ng-model=\"vm.location.person_in_charge\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"LOCATION_FORM.PHONE\"></label><input ng-disabled=\"vm.isReadOnly\" name=\"phone\" \nng-model=\"vm.location.phone\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div></div><md-button ng-click=\"vm.save()\" class=\"save-button md-accent md-raised\" \nng-disabled=\"vm.isReadOnly || locationForm.$invalid || locationForm.$pristine\" translate=\"LOCATION_FORM.SAVE\" \naria-label=\"{{ \'LOCATION_FORM.SAVE\' | translate }}\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/manual-qc-data/manual-qc-data-form/manual-qc-data-form.html","<md-dialog class=\"manual-qc-data-form\" aria-label=\"{{ vm.dialogTitle }}\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{ vm.dialogTitle }}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" \naria-label=\"{{ \'MANUAL_QC_DATA_FORM.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><form name=\"createNewQcDataForm\" class=\"md-inline-form\" novalidate><div\n layout=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"MANUAL_QC_DATA_FORM.COLUMNS.METER_SERIAL_NO\">\n</label><md-select md-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" required>\n<md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" \nng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button \nng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.closeMeterSelection()\" \nng-value=\"option\" ng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"createNewQcDataForm.meter.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MANUAL_QC_DATA_FORM.COLUMNS.INPUT_MESSAGES.METER_SERIAL_NO_REQUIRED\"></div></div></md-input-container>\n<md-input-container flex><label translate=\"MANUAL_QC_DATA_FORM.COLUMNS.TEST_DATE_TIME\"></label><input \nmdc-datetime-picker name=\"testDatetime\" date=\"true\" time=\"true\" short-time=\"true\" minute-steps=\"1\" edit-input=\"true\" \nshow-icon=\"true\" auto-ok=\"true\" ng-model=\"vm.testDatetime\" ng-change=\"createNewQcDataForm.testDatetime.$setDirty()\" \nrequired><div ng-messages=\"createNewQcDataForm.testDatetime.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\" translate=\"MANUAL_QC_DATA_FORM.COLUMNS.INPUT_MESSAGES.TEST_DATE_TIME_REQUIRED\"></div><div \nng-message=\"valid\" translate=\"MANUAL_QC_DATA_FORM.COLUMNS.INPUT_MESSAGES.TEST_DATE_TIME_INVALID\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"MANUAL_QC_DATA_FORM.COLUMNS.CONTROL_TYPE\"></label><md-select name=\"controlType\" ng-model=\"vm.controlType\" \nrequired><md-option ng-value=\"type\" ng-repeat=\"type in vm.types\">{{ type }}</md-option></md-select><div \nng-messages=\"createNewQcDataForm.controlType.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MANUAL_QC_DATA_FORM.COLUMNS.INPUT_MESSAGES.CONTROL_TYPE_REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>\n{{ \'MANUAL_QC_DATA_FORM.COLUMNS.QC_VALUE\' | translate }}&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})\n</label><input name=\"qcValue\" type=\"number\" step=\"any\" min=\"0\" ng-model=\"vm.qcValue\" required><div \nng-messages=\"createNewQcDataForm.qcValue.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\" \ntranslate=\"MANUAL_QC_DATA_FORM.COLUMNS.INPUT_MESSAGES.QC_VALUE_REQUIRED\"></div><div ng-message=\"min\" \ntranslate=\"MANUAL_QC_DATA_FORM.COLUMNS.INPUT_MESSAGES.QC_VALUE_MIN\"></div></div></md-input-container><div \nlayout=\"column\" layout-align=\"center center\"><md-button class=\"edit-button md-icon-button\" aria-label=\"Add\" \nng-disabled=\"createNewQcDataForm.$invalid\" ng-click=\"vm.add($event); vm.resetForm(createNewQcDataForm)\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\" class=\"s24\"></md-icon></md-button></div></div></form><form \nname=\"createQcDataForm\" class=\"md-inline-form\" novalidate><div layout=\"row\" ng-repeat=\"qcData in vm.qcDatas\">\n<md-input-container class=\"md-block\" flex><label translate=\"MANUAL_QC_DATA_FORM.COLUMNS.METER_SERIAL_NO\"></label>\n<md-select md-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" \nname=\"meter_{{ qcData.$$hashKey }}\" ng-disabled=\"!vm.meters.length\" ng-model=\"qcData.meter\" \nng-model-options=\"{trackBy: \'$value.id\'}\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.closeMeterSelection()\" \nng-value=\"option\" ng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"createQcDataForm[\'meter_\' + qcData.$$hashKey].$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MANUAL_QC_DATA_FORM.COLUMNS.INPUT_MESSAGES.METER_SERIAL_NO_REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"MANUAL_QC_DATA_FORM.COLUMNS.TEST_DATE_TIME\"></label><input \nmdc-datetime-picker name=\"testDatetime_{{ qcData.$$hashKey }}\" date=\"true\" time=\"true\" short-time=\"true\" \nminute-steps=\"1\" edit-input=\"true\" show-icon=\"true\" auto-ok=\"true\" ng-model=\"qcData.test_datetime\" \nng-change=\"createQcDataForm[\'testDatetime_\' + qcData.$$hashKey].setDirty()\" required><div \nng-messages=\"createQcDataForm[\'testDatetime_\' + qcData.$$hashKey].$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\" translate=\"MANUAL_QC_DATA_FORM.COLUMNS.INPUT_MESSAGES.TEST_DATE_TIME_REQUIRED\"></div><div \nng-message=\"valid\" translate=\"MANUAL_QC_DATA_FORM.COLUMNS.INPUT_MESSAGES.TEST_DATE_TIME_INVALID\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"MANUAL_QC_DATA_FORM.COLUMNS.CONTROL_TYPE\"></label><md-select name=\"controlType_{{ qcData.$$hashKey }}\" \nng-model=\"qcData.control_type\" required><md-option ng-value=\"type\" ng-repeat=\"type in vm.types\">{{ type }}</md-option>\n</md-select><div ng-messages=\"createQcDataForm[\'controlType_\' + qcData.$$hashKey].$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"MANUAL_QC_DATA_FORM.COLUMNS.INPUT_MESSAGES.CONTROL_TYPE_REQUIRED\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label>\n{{ \'MANUAL_QC_DATA_FORM.COLUMNS.QC_VALUE\' | translate }}&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})\n</label><input name=\"qcValue_{{ qcData.$$hashKey }}\" type=\"number\" step=\"any\" min=\"0\" ng-model=\"qcData.qc_value\" \nrequired><div ng-messages=\"createQcDataForm[\'qcValue_\' + qcData.$$hashKey].$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\" translate=\"MANUAL_QC_DATA_FORM.COLUMNS.INPUT_MESSAGES.QC_VALUE_REQUIRED\"></div><div \nng-message=\"min\" translate=\"MANUAL_QC_DATA_FORM.COLUMNS.INPUT_MESSAGES.QC_VALUE_MIN\"></div></div></md-input-container>\n<div layout=\"column\" layout-align=\"center center\"><md-button class=\"edit-button md-icon-button\" aria-label=\"Remove\" \nng-click=\"vm.remove($index, $event)\"><md-icon md-font-icon=\"icon-minus-circle-outline\" class=\"s24\"></md-icon>\n</md-button></div></div></form></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<div></div><md-button ng-click=\"vm.save()\" class=\"save-button md-accent md-raised\" \nng-disabled=\"createNewQcDataForm.$pristine && vm.qcDatas.length == 0 || createNewQcDataForm.$dirty && createNewQcDataForm.$invalid || createQcDataForm.$invalid\" \ntranslate=\"MANUAL_QC_DATA_FORM.SAVE_ALL\" aria-label=\"{{ \'MANUAL_QC_DATA_FORM.SAVE_ALL\' | translate }}\"></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/meter/meter-form/meter-form.html","<md-dialog class=\"meter-form\" aria-label=\"{{ vm.dialogTitle }}\"><form name=\"meterForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{ vm.dialogTitle }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"{{ \'METER_FORM.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><p class=\"pb-10\" ng-if=\"vm.isReadOnly\" \ntranslate=\"MAIN.DATA_SENT_FROM_CLOUD_LINK\"></p><md-input-container class=\"md-block\"><label \ntranslate=\"METER_FORM.HOSPITAL\"></label><md-select \nng-disabled=\"vm.isReadOnly || vm.dialogData.type === \'edit\' || !vm.isCountryAdmin\" name=\"hospital\" \nng-model=\"vm.selectedHospital\" ng-change=\"vm.selectedLocation = null\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nrequired><md-option ng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option>\n</md-select><div ng-messages=\"meterForm.hospital.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"METER_FORM.INPUT_MESSAGES.HOSPITAL_REQUIRED\"></span></div></div></md-input-container><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"METER_FORM.LOCATION_CODE\"></label><md-select \nng-disabled=\"vm.isReadOnly\" name=\"location\" ng-model=\"vm.selectedLocation\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nrequired><md-option ng-value=\"location\" \nng-repeat=\"location in vm.locations | filter: { hospital_id: vm.selectedHospital ? vm.selectedHospital.id : null }: true\">\n{{ location.code }}</md-option></md-select><div ng-messages=\"meterForm.location.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"METER_FORM.INPUT_MESSAGES.LOCATION_CODE_REQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"METER_FORM.SERIAL_NO\"></label><input \nng-disabled=\"vm.isReadOnly\" name=\"serialNo\" ng-model=\"vm.meter.serial_no\" required><div \nng-messages=\"meterForm.serialNo.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"METER_FORM.INPUT_MESSAGES.SERIAL_NO_REQUIRED\"></span></div></div></md-input-container></div><div \nlayout=\"row\" class=\"adjust-row-margin-in-form\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"METER_FORM.METER_MODEL\"></label><md-select ng-disabled=\"vm.isReadOnly\" ng-model=\"vm.meter.model_no\" \nrequired><md-option ng-repeat=\"model in vm.models\" value=\"{{ model }}\">{{ model }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"METER_FORM.STATUS\"></label><md-select \nng-disabled=\"vm.isReadOnly\" ng-model=\"vm.meter.status\" required><md-option ng-value=\"\'active\'\" \ntranslate=\"METER_FORM.ACTIVE\"></md-option><md-option ng-value=\"\'inactive\'\" translate=\"METER_FORM.INACTIVE\"></md-option>\n</md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div></div><md-button ng-click=\"vm.save()\" class=\"save-button md-accent md-raised\" \nng-disabled=\"vm.isReadOnly || meterForm.$invalid || meterForm.$pristine\" translate=\"METER_FORM.SAVE\" \naria-label=\"{{ \'METER_FORM.SAVE\' | translate }}\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/profile/update-password/update-password.html","<div id=\"update-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"update-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"update-password-form\" class=\"md-whiteframe-8dp\"><h1 \nclass=\"margin-bottom-32\">Accu-Chek<span class=\"text-super font-size-10\">®</span> Quest Online</h1><div class=\"title\" \ntranslate=\"UPDATE_PASSWORD.TITLE\"></div><div class=\"subtitle\" translate=\"UPDATE_PASSWORD.SUB_TITLE\"></div><form \nname=\"updatePasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"currentPassword\" ng-model=\"vm.form.old_password\" ng-minlength=\"6\" required \ntranslate-attr=\"{ placeholder: \'UPDATE_PASSWORD.CURRENT_PASSWORD\' }\" \naria-label=\"{{ \'UPDATE_PASSWORD.CURRENT_PASSWORD\' | translate }}\"><div \nng-messages=\"updatePasswordForm.currentPassword.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"UPDATE_PASSWORD.INPUT_MESSAGES.CURRENT_PASSWORD_REQUIRED\"></span></div><div ng-message=\"minlength\"><span \ntranslate=\"UPDATE_PASSWORD.INPUT_MESSAGES.MINIMUM_CHARACTERS\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"newPassword\" \nng-model=\"vm.form.new_password\" ng-minlength=\"6\" required \ntranslate-attr=\"{ placeholder: \'UPDATE_PASSWORD.NEW_PASSWORD\'}\" \naria-label=\"{{ \'UPDATE_PASSWORD.NEW_PASSWORD\' | translate }}\"><div ng-messages=\"updatePasswordForm.newPassword.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"UPDATE_PASSWORD.INPUT_MESSAGES.NEW_PASSWORD_REQUIRED\"></span>\n</div><div ng-message=\"minlength\"><span translate=\"UPDATE_PASSWORD.INPUT_MESSAGES.MINIMUM_CHARACTERS\"></span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"confirmPassword\" ng-model=\"vm.form.confirm_password\" match-password=\"newPassword\" required \ntranslate-attr=\"{ placeholder: \'UPDATE_PASSWORD.CONFIRM_PASSWORD\'}\" \naria-label=\"{{ \'UPDATE_PASSWORD.CONFIRM_PASSWORD\' | translate }}\"><div \nng-messages=\"updatePasswordForm.confirmPassword.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span translate=\"UPDATE_PASSWORD.INPUT_MESSAGES.CONFIRM_PASSWORD_REQUIRED\"></span></div><div \nng-message=\"passwordMatch\"><span translate=\"UPDATE_PASSWORD.INPUT_MESSAGES.CONFIRM_PASSWORD_DID_NOT_MATCH\"></span>\n</div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \nng-disabled=\"updatePasswordForm.$invalid || updatePasswordForm.$pristine\" ng-click=\"vm.update()\" \ntranslate=\"UPDATE_PASSWORD.UPDATE\" aria-label=\"{{ \'UPDATE_PASSWORD.UPDATE\' | translate }}\"></md-button></form></div>\n</div></div><div class=\"footer-copy-right\" layout=\"column\" layout-align=\"end end\"><span class=\"logo-text\">\n©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/test-strip/batch-create-test-strips-form/batch-create-test-strips-form.html","<md-dialog class=\"batch-create-test-strips-form\" aria-label=\"{{ \'TEST_STRIP_FORM.BATCH_CREATE\' | translate }}\"><form \nname=\"vm.testStripForm\" class=\"md-inline-form\" novalidate ng-cloak><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"TEST_STRIP_FORM.BATCH_CREATE\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" \naria-label=\"{{ \'TEST_STRIP_FORM.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"TEST_STRIP_FORM.HOSPITALS\"></label><md-select multiple=\"multiple\" name=\"selectedHospitals\" \nng-model=\"vm.selectedHospitals\" ng-model-options=\"{trackBy: \'$value.id\'}\" md-on-close=\"vm.validateLotNo()\" \nmd-selected-text=\"vm.getSelectedHospitalsText()\" required><md-select-header layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-if=\"vm.selectedHospitals.length === vm.hospitals.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.selectedHospitals = []\" \naria-label=\"{{ \'TEST_STRIP_FORM.UN_SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"icon-checkbox-marked\"></md-icon>\n</md-button><md-button ng-if=\"!vm.selectedHospitals.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.selectedHospitals = vm.hospitals\" aria-label=\"{{ \'TEST_STRIP_FORM.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.selectedHospitals.length && vm.selectedHospitals.length !== vm.hospitals.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.selectedHospitals = vm.hospitals\" \naria-label=\"{{ \'TEST_STRIP_FORM.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\"></md-icon>\n</md-button></md-select-header><md-option ng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}\n</md-option></md-select><div ng-messages=\"vm.testStripForm.selectedHospitals.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"TEST_STRIP_FORM.INPUT_MESSAGES.HOSPITALS_REQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"TEST_STRIP_FORM.STRIP_MODEL\">\nStrip Model</label><md-select name=\"test_strip_model\" ng-model=\"vm.selectedTestStripModel\" \nng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option ng-value=\"testStripModel\" \nng-repeat=\"testStripModel in vm.testStripModels\">{{ testStripModel.model_name }}</md-option></md-select><div \nng-messages=\"vm.testStripForm.test_strip_model.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.STRIP_MODEL_REQUIRED\"></span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"TEST_STRIP_FORM.STRIP_LOT_NO\"></label><input \nname=\"lot_no\" ng-model=\"vm.testStrip.lot_no\" required check-test-strip-lot-no-availability \nhospital-ids=\"{{ vm.getSelectedHospitalIds() }}\"><div ng-messages=\"vm.testStripForm.lot_no.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"TEST_STRIP_FORM.INPUT_MESSAGES.STRIP_LOT_NO_REQUIRED\"></span></div><div \nng-message=\"invalidTestStripLotNo\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.STRIP_LOT_NO_IN_SOME_HOSPITAL_INVALID\"></span></div></div><span \nclass=\"hint-text font-size-12\" ng-show=\"vm.testStripForm.lot_no.$pending\">checking availability...</span>\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"TEST_STRIP_FORM.STRIP_EXPIRY\"></label>\n<md-datepicker name=\"expiry\" ng-model=\"vm.expiry\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.testStripForm.expiry.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.STRIP_EXPIRY_REQUIRED\"></span></div><div ng-message=\"valid\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></span></div></div></md-input-container></div><div \nlayout=\"row\" class=\"adjust-row-margin-in-form\"><md-input-container class=\"md-block\" flex><label>\n{{ \'TEST_STRIP_FORM.L1_MIN\' | translate }}&nbsp;({{ vm.measurementUnits[vm.userDefinedMeasurementUnit] }})</label>\n<input name=\"l1_min\" ng-model=\"vm.testStrip.l1_min\" required type=\"number\" step=\"any\" min=\"0\"><div \nng-messages=\"vm.testStripForm.l1_min.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L1_MIN_REQUIRED\"></span></div><div ng-message=\"min\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L1_MIN_MIN\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>\n{{ \'TEST_STRIP_FORM.L1_MAX\' | translate }}&nbsp;({{ vm.measurementUnits[vm.userDefinedMeasurementUnit] }})</label>\n<input name=\"l1_max\" ng-model=\"vm.testStrip.l1_max\" required type=\"number\" step=\"any\" min=\"0\"><div \nng-messages=\"vm.testStripForm.l1_max.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L1_MAX_REQUIRED\"></span></div><div ng-message=\"min\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L1_MAX_MIN\"></span></div></div></md-input-container></div><div layout=\"row\" \nclass=\"adjust-row-margin-in-form\"><md-input-container class=\"md-block\" flex><label>\n{{ \'TEST_STRIP_FORM.L2_MIN\' | translate }}&nbsp;({{ vm.measurementUnits[vm.userDefinedMeasurementUnit] }})</label>\n<input name=\"l2_min\" ng-model=\"vm.testStrip.l2_min\" required type=\"number\" step=\"any\" min=\"0\"><div \nng-messages=\"vm.testStripForm.l2_min.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L2_MIN_REQUIRED\"></span></div><div ng-message=\"min\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L2_MIN_MIN\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>\n{{ \'TEST_STRIP_FORM.L2_MAX\' | translate }}&nbsp;({{ vm.measurementUnits[vm.userDefinedMeasurementUnit] }})</label>\n<input name=\"l2_max\" ng-model=\"vm.testStrip.l2_max\" required type=\"number\" step=\"any\" min=\"0\"><div \nng-messages=\"vm.testStripForm.l2_max.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L2_MAX_REQUIRED\"></span></div><div ng-message=\"min\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L2_MAX_MIN\"></span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div></div><md-button \nng-click=\"vm.save()\" class=\"save-button md-accent md-raised\" \nng-disabled=\"vm.testStripForm.$pending || vm.testStripForm.$invalid || vm.testStripForm.$pristine\" \ntranslate=\"TEST_STRIP_FORM.SAVE\" aria-label=\"{{ \'TEST_STRIP_FORM.SAVE\' | translate }}\"></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/test-strip/test-strip-form/test-strip-form.html","<md-dialog class=\"test-strip-form\" aria-label=\"{{ vm.dialogTitle }}\"><form name=\"vm.testStripForm\" \nclass=\"md-inline-form\" novalidate ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{ vm.dialogTitle }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"{{ \'TEST_STRIP_FORM.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p class=\"pb-10\" ng-if=\"vm.isReadOnly\" \ntranslate=\"MAIN.DATA_SENT_FROM_CLOUD_LINK\"></p><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"TEST_STRIP_FORM.HOSPITAL\"></label><md-select \nng-disabled=\"vm.isReadOnly || vm.dialogData.type === \'edit\' || !vm.isCountryAdmin\" name=\"hospital\" \nng-model=\"vm.selectedHospital\" ng-model-options=\"{trackBy: \'$value.id\'}\" md-on-close=\"vm.validateLotNo()\" required>\n<md-option ng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.testStripForm.hospital.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.HOSPITAL_REQUIRED\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"TEST_STRIP_FORM.STRIP_MODEL\">Strip Model</label><md-select \nng-disabled=\"vm.isReadOnly\" name=\"test_strip_model\" ng-model=\"vm.selectedTestStripModel\" \nng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option ng-value=\"testStripModel\" \nng-repeat=\"testStripModel in vm.testStripModels\">{{ testStripModel.model_name }}</md-option></md-select><div \nng-messages=\"vm.testStripForm.test_strip_model.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.STRIP_MODEL_REQUIRED\"></span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"TEST_STRIP_FORM.STRIP_LOT_NO\"></label><input \nng-disabled=\"vm.isReadOnly\" name=\"lot_no\" ng-model=\"vm.testStrip.lot_no\" required check-test-strip-lot-no-availability \nhospital-id=\"{{ vm.selectedHospital.id }}\" ignore-id=\"{{ vm.testStrip.id }}\"><div \nng-messages=\"vm.testStripForm.lot_no.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.STRIP_LOT_NO_REQUIRED\"></span></div><div ng-message=\"invalidTestStripLotNo\">\n<span translate=\"TEST_STRIP_FORM.INPUT_MESSAGES.STRIP_LOT_NO_INVALID\"></span></div></div><span \nclass=\"hint-text font-size-12\" ng-show=\"vm.testStripForm.lot_no.$pending\">checking availability...</span>\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"TEST_STRIP_FORM.STRIP_EXPIRY\"></label>\n<md-datepicker ng-disabled=\"vm.isReadOnly\" name=\"expiry\" ng-model=\"vm.expiry\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.testStripForm.expiry.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"TEST_STRIP_FORM.INPUT_MESSAGES.STRIP_EXPIRY_REQUIRED\"></span></div><div \nng-message=\"valid\"><span translate=\"TEST_STRIP_FORM.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></span></div></div>\n</md-input-container></div><div layout=\"row\" class=\"adjust-row-margin-in-form\"><md-input-container class=\"md-block\" \nflex><label>{{ \'TEST_STRIP_FORM.L1_MIN\' | translate }}&nbsp;({{ vm.measurementUnits[vm.userDefinedMeasurementUnit] }})\n</label><input ng-disabled=\"vm.isReadOnly\" name=\"l1_min\" ng-model=\"vm.testStrip.l1_min\" required type=\"number\" \nstep=\"any\" min=\"0\"><div ng-messages=\"vm.testStripForm.l1_min.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L1_MIN_REQUIRED\"></span></div><div \nng-message=\"min\"><span translate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L1_MIN_MIN\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>\n{{ \'TEST_STRIP_FORM.L1_MAX\' | translate }}&nbsp;({{ vm.measurementUnits[vm.userDefinedMeasurementUnit] }})</label>\n<input ng-disabled=\"vm.isReadOnly\" name=\"l1_max\" ng-model=\"vm.testStrip.l1_max\" required type=\"number\" step=\"any\" \nmin=\"0\"><div ng-messages=\"vm.testStripForm.l1_max.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span translate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L1_MAX_REQUIRED\"></span></div><div ng-message=\"min\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L1_MAX_MIN\"></span></div></div></md-input-container></div><div layout=\"row\" \nclass=\"adjust-row-margin-in-form\"><md-input-container class=\"md-block\" flex><label>\n{{ \'TEST_STRIP_FORM.L2_MIN\' | translate }}&nbsp;({{ vm.measurementUnits[vm.userDefinedMeasurementUnit] }})</label>\n<input ng-disabled=\"vm.isReadOnly\" name=\"l2_min\" ng-model=\"vm.testStrip.l2_min\" required type=\"number\" step=\"any\" \nmin=\"0\"><div ng-messages=\"vm.testStripForm.l2_min.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span translate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L2_MIN_REQUIRED\"></span></div><div ng-message=\"min\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L2_MIN_MIN\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>\n{{ \'TEST_STRIP_FORM.L2_MAX\' | translate }}&nbsp;({{ vm.measurementUnits[vm.userDefinedMeasurementUnit] }})</label>\n<input ng-disabled=\"vm.isReadOnly\" name=\"l2_max\" ng-model=\"vm.testStrip.l2_max\" required type=\"number\" step=\"any\" \nmin=\"0\"><div ng-messages=\"vm.testStripForm.l2_max.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span translate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L2_MAX_REQUIRED\"></span></div><div ng-message=\"min\"><span \ntranslate=\"TEST_STRIP_FORM.INPUT_MESSAGES.L2_MAX_MIN\"></span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div></div><md-button \nng-click=\"vm.save()\" class=\"save-button md-accent md-raised\" \nng-disabled=\"vm.isReadOnly || vm.testStripForm.$pending || vm.testStripForm.$invalid || vm.testStripForm.$pristine\" \ntranslate=\"TEST_STRIP_FORM.SAVE\" aria-label=\"{{ \'TEST_STRIP_FORM.SAVE\' | translate }}\"></md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/test-strip-consumption/country-admin/country-admin.html","<form name=\"vm.filterForm\" class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div layout=\"row\" \nflex=\"50\"><md-input-container class=\"md-block\" flex><label translate=\"TEST_STRIP_CONSUMPTION.FILTERS.STATE\"></label>\n<md-select name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\"><md-option ng-value=\"null\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.ALL_STATES\">\n</md-option><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select>\n</md-input-container></div><md-input-container class=\"md-block ml-20\" flex><label \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.HOSPITAL\"></label><md-select name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\"><md-option ng-value=\"null\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.ALL_HOSPITALS\"></md-option><md-option ng-value=\"hospital\" \nng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select></md-input-container></div><div \nlayout=\"row\"><div layout=\"row\" flex=\"50\"><md-input-container flex><label \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.START_DATE\"></label><md-datepicker name=\"startDate\" ng-model=\"vm.startDate\" \nng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container\n flex class=\"ml-20\"><label translate=\"TEST_STRIP_CONSUMPTION.FILTERS.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div>\n<md-input-container ng-if=\"!vm.meters.length\" class=\"md-block ml-20\" flex><label \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.METERS\"></label><md-select name=\"meter\" ng-model=\"vm.selectedMeters\">\n<md-option ng-value=\"null\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.ALL_METERS\"></md-option></md-select>\n</md-input-container><md-input-container ng-if=\"vm.meters.length\" class=\"md-block ml-20\" flex><label \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.METERS\"></label><md-select md-on-close=\"vm.meterSelectionOnClose()\" \nmd-container-class=\"multi-column-select\" multiple=\"multiple\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText()\" ng-required=\"vm.meters.length\"><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'TEST_STRIP_CONSUMPTION.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.OK\" \naria-label=\"{{ \'TEST_STRIP_CONSUMPTION.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><div ng-if=\"vm.loaded\" class=\"animate-slide-right widget-group\" layout=\"row\"><div \nlayout=\"row\" flex=\"50\"><ms-widget class=\"h-120 no-padding\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" \nlayout=\"row\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"orange-fg md-display-1 pb-8\">{{ vm.quality_control_tests | number }}</div><div \nclass=\"font-weight-500 secondary-text text-center\" translate=\"TEST_STRIP_CONSUMPTION.QC_TESTED\"></div></div>\n</ms-widget-front></ms-widget><div class=\"h-120 sign\" layout=\"column\" layout-align=\"center center\">+</div><ms-widget \nclass=\"h-120 no-padding ml-20\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" layout=\"row\"><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\"><div class=\"green-fg md-display-1 pb-8\">\n{{ vm.blood_glucose_tests | number }}</div><div class=\"font-weight-500 secondary-text text-center\" \ntranslate=\"TEST_STRIP_CONSUMPTION.BLOOD_GLUCOSE_TESTED\"></div></div></ms-widget-front></ms-widget></div><div \nclass=\"h-120 sign\" layout=\"column\" layout-align=\"center center\">=</div><ms-widget class=\"h-120 no-padding ml-20\" \nlayout=\"column\" flex=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\"><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg md-display-1 pb-8\">{{ vm.all | number }}</div><div \nclass=\"font-weight-500 secondary-text text-center\" translate=\"TEST_STRIP_CONSUMPTION.TOTAL_TEST_STRIP_USED\"></div>\n</div></ms-widget-front></ms-widget></div><div \nng-if=\"vm.loaded && !vm.selectedHospital && vm.hospital_tests.length > 0\" \nclass=\"simple-table-container animate-slide-right md-whiteframe-4dp mt-20\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span translate=\"TEST_STRIP_CONSUMPTION.TOP_HOSPITALS\"></span></div></md-toolbar><md-table-container><table md-table>\n<thead md-head md-order=\"vm.sort\"><tr md-row><th md-column><span translate=\"TEST_STRIP_CONSUMPTION.HOSPITAL\"></span>\n</th><th md-column md-order-by=\"quality_control_tests\"><span translate=\"TEST_STRIP_CONSUMPTION.QC_TESTED\"></span></th>\n<th md-column md-order-by=\"blood_glucose_tests\"><span translate=\"TEST_STRIP_CONSUMPTION.BLOOD_GLUCOSE_TESTED\"></span>\n</th><th md-column md-order-by=\"total\"><span translate=\"TEST_STRIP_CONSUMPTION.TOTAL_TEST_STRIP_USED\"></span></th></tr>\n</thead><tbody md-body><tr md-row ng-repeat=\"hospital_test in vm.hospital_tests | orderBy: vm.sort | limitTo: 10\"><td \nmd-cell>{{ hospital_test.name }} ({{ vm.allStates[vm.country][hospital_test.state] }})</td><td md-cell>\n{{ hospital_test.quality_control_tests | number }}</td><td md-cell>{{ hospital_test.blood_glucose_tests | number }}\n</td><td md-cell>{{ hospital_test.total | number }}</td></tr></tbody></table></md-table-container></div><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-16 font-weight-300\" \ntranslate=\"TEST_STRIP_CONSUMPTION.LOADING\"></p></div>");
$templateCache.put("app/main/test-strip-consumption/global-admin/global-admin.html","<form name=\"vm.filterForm\" class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div layout=\"row\" \nflex=\"50\"><md-input-container class=\"md-block\" flex><label translate=\"TEST_STRIP_CONSUMPTION.FILTERS.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\"><md-option ng-value=\"null\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.ALL_COUNTRIES\"></md-option><md-option ng-value=\"country\" \nng-repeat=\"country in vm.countries\">{{ country.name }}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"TEST_STRIP_CONSUMPTION.FILTERS.STATE\"></label><md-select name=\"state\" \nng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\">\n<md-option ng-value=\"null\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.ALL_STATES\"></md-option><md-option \nng-value=\"state\" ng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"TEST_STRIP_CONSUMPTION.FILTERS.HOSPITAL\"></label>\n<md-select name=\"hospital\" ng-model=\"vm.selectedHospital\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.selectedHospitalChanged()\"><md-option ng-value=\"null\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.ALL_HOSPITALS\"></md-option><md-option ng-value=\"hospital\" \nng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select></md-input-container></div><div \nlayout=\"row\"><div layout=\"row\" flex=\"50\"><md-input-container flex><label \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.START_DATE\"></label><md-datepicker name=\"startDate\" ng-model=\"vm.startDate\" \nng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container\n flex class=\"ml-20\"><label translate=\"TEST_STRIP_CONSUMPTION.FILTERS.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div>\n<md-input-container ng-if=\"!vm.meters.length\" class=\"md-block ml-20\" flex><label \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.METERS\"></label><md-select name=\"meter\" ng-model=\"vm.selectedMeters\">\n<md-option ng-value=\"null\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.ALL_METERS\"></md-option></md-select>\n</md-input-container><md-input-container ng-if=\"vm.meters.length\" class=\"md-block ml-20\" flex><label \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.METERS\"></label><md-select md-on-close=\"vm.meterSelectionOnClose()\" \nmd-container-class=\"multi-column-select\" multiple=\"multiple\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText()\" ng-required=\"vm.meters.length\"><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'TEST_STRIP_CONSUMPTION.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.OK\" \naria-label=\"{{ \'TEST_STRIP_CONSUMPTION.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><div ng-if=\"vm.loaded\" class=\"animate-slide-right widget-group\" layout=\"row\"><div \nlayout=\"row\" flex=\"50\"><ms-widget class=\"h-120 no-padding\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" \nlayout=\"row\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"orange-fg md-display-1 pb-8\">{{ vm.quality_control_tests | number }}</div><div \nclass=\"font-weight-500 secondary-text text-center\" translate=\"TEST_STRIP_CONSUMPTION.QC_TESTED\"></div></div>\n</ms-widget-front></ms-widget><div class=\"h-120 sign\" layout=\"column\" layout-align=\"center center\">+</div><ms-widget \nclass=\"h-120 no-padding ml-20\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" layout=\"row\"><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\"><div class=\"green-fg md-display-1 pb-8\">\n{{ vm.blood_glucose_tests | number }}</div><div class=\"font-weight-500 secondary-text text-center\" \ntranslate=\"TEST_STRIP_CONSUMPTION.BLOOD_GLUCOSE_TESTED\"></div></div></ms-widget-front></ms-widget></div><div \nclass=\"h-120 sign\" layout=\"column\" layout-align=\"center center\">=</div><ms-widget class=\"h-120 no-padding ml-20\" \nlayout=\"column\" flex=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\"><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg md-display-1 pb-8\">{{ vm.all | number }}</div><div \nclass=\"font-weight-500 secondary-text text-center\" translate=\"TEST_STRIP_CONSUMPTION.TOTAL_TEST_STRIP_USED\"></div>\n</div></ms-widget-front></ms-widget></div><div \nng-if=\"vm.loaded && !vm.selectedHospital && vm.hospital_tests.length > 0\" \nclass=\"simple-table-container animate-slide-right md-whiteframe-4dp mt-20\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span translate=\"TEST_STRIP_CONSUMPTION.TOP_HOSPITALS\"></span></div></md-toolbar><md-table-container><table md-table>\n<thead md-head md-order=\"vm.sort\"><tr md-row><th md-column><span translate=\"TEST_STRIP_CONSUMPTION.HOSPITAL\"></span>\n</th><th md-column md-order-by=\"quality_control_tests\"><span translate=\"TEST_STRIP_CONSUMPTION.QC_TESTED\"></span></th>\n<th md-column md-order-by=\"blood_glucose_tests\"><span translate=\"TEST_STRIP_CONSUMPTION.BLOOD_GLUCOSE_TESTED\"></span>\n</th><th md-column md-order-by=\"total\"><span translate=\"TEST_STRIP_CONSUMPTION.TOTAL_TEST_STRIP_USED\"></span></th></tr>\n</thead><tbody md-body><tr md-row ng-repeat=\"hospital_test in vm.hospital_tests | orderBy: vm.sort | limitTo: 10\"><td \nmd-cell ng-if=\"!vm.selectedCountry\">{{ hospital_test.name }} ({{ vm.allCountries[hospital_test.country] }})</td><td \nmd-cell ng-if=\"vm.selectedCountry\">\n{{ hospital_test.name }} ({{ vm.allStates[vm.selectedCountry.code][hospital_test.state] }})</td><td md-cell>\n{{ hospital_test.quality_control_tests | number }}</td><td md-cell>{{ hospital_test.blood_glucose_tests | number }}\n</td><td md-cell>{{ hospital_test.total | number }}</td></tr></tbody></table></md-table-container></div><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-16 font-weight-300\" \ntranslate=\"TEST_STRIP_CONSUMPTION.LOADING\"></p></div>");
$templateCache.put("app/main/test-strip-consumption/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div layout=\"row\" \nflex=\"50\"><md-input-container flex><label translate=\"TEST_STRIP_CONSUMPTION.FILTERS.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container\n flex class=\"ml-20\"><label translate=\"TEST_STRIP_CONSUMPTION.FILTERS.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div>\n<md-input-container ng-if=\"!vm.meters.length\" class=\"md-block ml-20\" flex><label \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.METERS\"></label><md-select name=\"meter\" ng-model=\"vm.selectedMeters\">\n<md-option ng-value=\"null\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.ALL_METERS\"></md-option></md-select>\n</md-input-container><md-input-container ng-if=\"vm.meters.length\" class=\"md-block ml-20\" flex><label \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.METERS\"></label><md-select md-on-close=\"vm.meterSelectionOnClose()\" \nmd-container-class=\"multi-column-select\" multiple=\"multiple\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText()\" ng-required=\"vm.meters.length\"><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'TEST_STRIP_CONSUMPTION.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.OK\" \naria-label=\"{{ \'TEST_STRIP_CONSUMPTION.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><div ng-if=\"vm.loaded\" class=\"animate-slide-right widget-group\" layout=\"row\"><div \nlayout=\"row\" flex=\"50\"><ms-widget class=\"h-120 no-padding\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" \nlayout=\"row\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"orange-fg md-display-1 pb-8\">{{ vm.quality_control_tests }}</div><div \nclass=\"font-weight-500 secondary-text text-center\" translate=\"TEST_STRIP_CONSUMPTION.QC_TESTED\"></div></div>\n</ms-widget-front></ms-widget><div class=\"h-120 sign\" layout=\"column\" layout-align=\"center center\">+</div><ms-widget \nclass=\"h-120 no-padding ml-20\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" layout=\"row\"><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\"><div class=\"green-fg md-display-1 pb-8\">\n{{ vm.blood_glucose_tests }}</div><div class=\"font-weight-500 secondary-text text-center\" \ntranslate=\"TEST_STRIP_CONSUMPTION.BLOOD_GLUCOSE_TESTED\"></div></div></ms-widget-front></ms-widget></div><div \nclass=\"h-120 sign\" layout=\"column\" layout-align=\"center center\">=</div><ms-widget class=\"h-120 no-padding ml-20\" \nlayout=\"column\" flex=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\"><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg md-display-1 pb-8\">{{ vm.all }}</div><div \nclass=\"font-weight-500 secondary-text text-center\" translate=\"TEST_STRIP_CONSUMPTION.TOTAL_TEST_STRIP_USED\"></div>\n</div></ms-widget-front></ms-widget></div><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p \nclass=\"hint-text font-size-16 font-weight-300\" translate=\"TEST_STRIP_CONSUMPTION.LOADING\"></p></div>");
$templateCache.put("app/main/test-strip-consumption/hospital-operator/hospital-operator.html","<form name=\"vm.filterForm\" class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div layout=\"row\" \nflex=\"50\"><md-input-container flex><label translate=\"TEST_STRIP_CONSUMPTION.FILTERS.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container\n flex class=\"ml-20\"><label translate=\"TEST_STRIP_CONSUMPTION.FILTERS.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div>\n<md-input-container ng-if=\"!vm.meters.length\" class=\"md-block ml-20\" flex><label \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.METERS\"></label><md-select name=\"meter\" ng-model=\"vm.selectedMeters\">\n<md-option ng-value=\"null\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.ALL_METERS\"></md-option></md-select>\n</md-input-container><md-input-container ng-if=\"vm.meters.length\" class=\"md-block ml-20\" flex><label \ntranslate=\"TEST_STRIP_CONSUMPTION.FILTERS.METERS\"></label><md-select md-on-close=\"vm.meterSelectionOnClose()\" \nmd-container-class=\"multi-column-select\" multiple=\"multiple\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText()\" ng-required=\"vm.meters.length\"><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'TEST_STRIP_CONSUMPTION.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.OK\" \naria-label=\"{{ \'TEST_STRIP_CONSUMPTION.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"TEST_STRIP_CONSUMPTION.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><div ng-if=\"vm.loaded\" class=\"animate-slide-right widget-group\" layout=\"row\"><div \nlayout=\"row\" flex=\"50\"><ms-widget class=\"h-120 no-padding\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" \nlayout=\"row\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"orange-fg md-display-1 pb-8\">{{ vm.quality_control_tests }}</div><div \nclass=\"font-weight-500 secondary-text text-center\" translate=\"TEST_STRIP_CONSUMPTION.QC_TESTED\"></div></div>\n</ms-widget-front></ms-widget><div class=\"h-120 sign\" layout=\"column\" layout-align=\"center center\">+</div><ms-widget \nclass=\"h-120 no-padding ml-20\" layout=\"column\" flex><ms-widget-front class=\"p-16 white-bg\" layout=\"row\"><div \nclass=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\"><div class=\"green-fg md-display-1 pb-8\">\n{{ vm.blood_glucose_tests }}</div><div class=\"font-weight-500 secondary-text text-center\" \ntranslate=\"TEST_STRIP_CONSUMPTION.BLOOD_GLUCOSE_TESTED\"></div></div></ms-widget-front></ms-widget></div><div \nclass=\"h-120 sign\" layout=\"column\" layout-align=\"center center\">=</div><ms-widget class=\"h-120 no-padding ml-20\" \nlayout=\"column\" flex=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\"><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg md-display-1 pb-8\">{{ vm.all }}</div><div \nclass=\"font-weight-500 secondary-text text-center\" translate=\"TEST_STRIP_CONSUMPTION.TOTAL_TEST_STRIP_USED\"></div>\n</div></ms-widget-front></ms-widget></div><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p \nclass=\"hint-text font-size-16 font-weight-300\" translate=\"TEST_STRIP_CONSUMPTION.LOADING\"></p></div>");
$templateCache.put("app/main/test-strip-model/test-strip-model-form/test-strip-model-form.html","<md-dialog class=\"test-strip-model-form\" aria-label=\"{{ vm.dialogTitle }}\"><form name=\"testStripModelForm\" \nclass=\"md-inline-form\" novalidate ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{ vm.dialogTitle }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"{{ \'TEST_STRIP_MODEL_FORM.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label \ntranslate=\"TEST_STRIP_MODEL_FORM.STRIP_MODEL\"></label><input name=\"model_name\" ng-model=\"vm.testStripModel.model_name\" \nrequired><div ng-messages=\"testStripModelForm.model_name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TEST_STRIP_MODEL_FORM.INPUT_MESSAGES.STRIP_MODEL_REQUIRED\"></span></div></div></md-input-container><div \nlayout=\"row\" class=\"adjust-row-margin-in-form\"><md-input-container class=\"md-block\" flex><label>\n{{ \'TEST_STRIP_MODEL_FORM.L1_MFR_MEAN\' | translate }}&nbsp;({{ vm.measurementUnits[vm.userDefinedMeasurementUnit] }})\n</label><input name=\"l1_mfr_mean\" ng-model=\"vm.testStripModel.l1_mfr_mean\" required type=\"number\" step=\"any\" min=\"0\">\n<div ng-messages=\"testStripModelForm.l1_mfr_mean.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span translate=\"TEST_STRIP_MODEL_FORM.INPUT_MESSAGES.L1_MFR_MEAN_REQUIRED\"></span></div><div ng-message=\"min\"><span \ntranslate=\"TEST_STRIP_MODEL_FORM.INPUT_MESSAGES.L1_MFR_MEAN_MIN\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>\n{{ \'TEST_STRIP_MODEL_FORM.L1_MFR_SD\' | translate }}&nbsp;({{ vm.measurementUnits[vm.userDefinedMeasurementUnit] }})\n</label><input name=\"l1_mfr_sd\" ng-model=\"vm.testStripModel.l1_mfr_sd\" required type=\"number\" step=\"any\" min=\"0\"><div \nng-messages=\"testStripModelForm.l1_mfr_sd.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"TEST_STRIP_MODEL_FORM.INPUT_MESSAGES.L1_MFR_SD_REQUIRED\"></span></div><div ng-message=\"min\"><span \ntranslate=\"TEST_STRIP_MODEL_FORM.INPUT_MESSAGES.L1_MFR_SD_MIN\"></span></div></div></md-input-container></div><div \nlayout=\"row\" class=\"adjust-row-margin-in-form\"><md-input-container class=\"md-block\" flex><label>\n{{ \'TEST_STRIP_MODEL_FORM.L2_MFR_MEAN\' | translate }}&nbsp;({{ vm.measurementUnits[vm.userDefinedMeasurementUnit] }})\n</label><input name=\"l2_mfr_mean\" ng-model=\"vm.testStripModel.l2_mfr_mean\" required type=\"number\" step=\"any\" min=\"0\">\n<div ng-messages=\"testStripModelForm.l2_mfr_mean.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span translate=\"TEST_STRIP_MODEL_FORM.INPUT_MESSAGES.L2_MFR_MEAN_REQUIRED\"></span></div><div ng-message=\"min\"><span \ntranslate=\"TEST_STRIP_MODEL_FORM.INPUT_MESSAGES.L2_MFR_MEAN_MIN\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>\n{{ \'TEST_STRIP_MODEL_FORM.L2_MFR_SD\' | translate }}&nbsp;({{ vm.measurementUnits[vm.userDefinedMeasurementUnit] }})\n</label><input name=\"l2_mfr_sd\" ng-model=\"vm.testStripModel.l2_mfr_sd\" required type=\"number\" step=\"any\" min=\"0\"><div \nng-messages=\"testStripModelForm.l2_mfr_sd.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"TEST_STRIP_MODEL_FORM.INPUT_MESSAGES.L2_MFR_SD_REQUIRED\"></span></div><div ng-message=\"min\"><span \ntranslate=\"TEST_STRIP_MODEL_FORM.INPUT_MESSAGES.L2_MFR_SD_MIN\"></span></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div></div><md-button \nng-click=\"vm.save()\" class=\"save-button md-accent md-raised\" \nng-disabled=\"testStripModelForm.$invalid || testStripModelForm.$pristine\" translate=\"TEST_STRIP_MODEL_FORM.SAVE\" \naria-label=\"{{ \'TEST_STRIP_MODEL_FORM.SAVE\' | translate }}\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/user/country-admin/country-admin.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"COUNTRY_ADMIN.TITLE\"></div><div class=\"font-size-14 font-weight-200\">Global</div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu md-position-mode=\"left bottom\" md-offset=\"0 2\"><md-button \nclass=\"md-raised\" ng-click=\"$mdMenu.open()\" aria-label=\"{{ \'COUNTRY_ADMIN.EXPORT\' | translate }}\"><div layout=\"row\">\n<span translate=\"COUNTRY_ADMIN.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon\"></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-delimited\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.exportToCSV()\" translate=\"COUNTRY_ADMIN.CSV\" \naria-label=\"{{ \'COUNTRY_ADMIN.CSV\' | translate }}\"></md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-excel\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToExcel()\" \ntranslate=\"COUNTRY_ADMIN.EXCEL\" aria-label=\"{{ \'COUNTRY_ADMIN.EXCEL\' | translate }}\"></md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-button class=\"md-raised\" ng-click=\"vm.create($event)\" \ntranslate=\"COUNTRY_ADMIN.CREATE\" aria-label=\"{{ \'COUNTRY_ADMIN.CREATE\' | translate }}\"></md-button></div></div><div \nclass=\"content\"><div layout=\"column\"><div flex ng-if=\"!vm.show\" class=\"text-center\"><p \nclass=\"hint-text font-size-16 font-weight-300\" translate=\"COUNTRY_ADMIN.LOADING\"></p></div><div \nclass=\"simple-table-container md-whiteframe-4dp animate-slide-right\" ng-if=\"vm.show\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span translate=\"COUNTRY_ADMIN.PANEL_TITLE\"></span><div layout=\"row\" layout-align=\"start center\"><md-select \nclass=\"simplified font-size-14\" ng-model=\"vm.selectedCountry\" ng-change=\"vm.getUsers()\" \naria-label=\"{{ \'COUNTRY_ADMIN.COUNTRY\' | translate }}\"><md-option ng-value=\"null\" \ntranslate=\"COUNTRY_ADMIN.ALL_COUNTRIES\"></md-option><md-option ng-repeat=\"country in vm.countryList | orderBy:\'name\'\" \nng-value=\"country\">{{ country.name }}</md-option></md-select><input class=\"search-input font-size-14\" \nng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" aria-label=\"Search\"><md-button ng-if=\"vm.searchTerm\" \nng-click=\"vm.searchTerm = \'\'; vm.getUsers()\" class=\"cancel-search-input md-icon-button\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.getUsers()\" aria-label=\"\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div></div>\n</md-toolbar><md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" \nmd-on-reorder=\"vm.getUsers\"><tr md-row><th md-column md-order-by=\"name\"><span translate=\"COUNTRY_ADMIN.COLUMNS.NAME\">\n</span></th><th md-column md-order-by=\"email\"><span translate=\"COUNTRY_ADMIN.COLUMNS.EMAIL\"></span></th><th md-column>\n<span translate=\"COUNTRY_ADMIN.COLUMNS.COUNTRY\"></span></th><th md-column md-order-by=\"last_login_at\"><span \ntranslate=\"COUNTRY_ADMIN.COLUMNS.LAST_LOGIN\"></span></th><th md-column md-order-by=\"created_at\"><span \ntranslate=\"COUNTRY_ADMIN.COLUMNS.CREATED\"></span></th><th md-column><span translate=\"COUNTRY_ADMIN.COLUMNS.STATUS\">\n</span></th><th md-column><span translate=\"COUNTRY_ADMIN.COLUMNS.ACTIONS\"></span></th></tr></thead><tbody md-body><tr \nmd-row ng-repeat=\"user in vm.users\"><td md-cell class=\"text-capitalize\">{{ user.name }}</td><td md-cell \nnowrap=\"nowrap\">{{ user.email }}</td><td md-cell class=\"text-capitalize\">{{ vm.countries[user.country] }}</td><td \nmd-cell><span ng-if=\"user.last_login_at\" am-time-ago=\"user.last_login_at\"></span> <span ng-if=\"!user.last_login_at\" \ntranslate=\"COUNTRY_ADMIN.NEVER\"></span></td><td md-cell><span am-time-ago=\"user.created_at\"></span></td><td md-cell>\n<div class=\"text-center\"><div ng-if=\"user.status === \'active\'\" class=\"status-indicator md-green-500-bg\"></div><div \nng-if=\"user.status === \'inactive\'\" class=\"status-indicator md-grey-500-bg\"></div></div></td><td md-cell><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.edit(user, $event)\" \naria-label=\"{{ \'COUNTRY_ADMIN.EDIT\' | translate }}\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" \nmd-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" \nmd-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getUsers\" md-page-select></md-table-pagination></div></div>\n</div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img class=\"logo-image\" \nng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> \n<span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/user/hospital-admin/hospital-admin.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"HOSPITAL_ADMIN.TITLE\"></div><div class=\"font-size-14 font-weight-200\">{{ vm.countries[vm.user.country] }}\n</div></div><div layout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu \nmd-position-mode=\"left bottom\" md-offset=\"0 2\"><md-button class=\"md-raised\" ng-click=\"$mdMenu.open()\" \naria-label=\"{{ \'HOSPITAL_ADMIN.EXPORT\' | translate }}\"><div layout=\"row\"><span translate=\"HOSPITAL_ADMIN.EXPORT\">\n</span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-delimited\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.exportToCSV()\" translate=\"HOSPITAL_ADMIN.CSV\" aria-label=\"{{ \'HOSPITAL_ADMIN.CSV\' | translate }}\">\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-excel\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.exportToExcel()\" translate=\"HOSPITAL_ADMIN.EXCEL\" \naria-label=\"{{ \'HOSPITAL_ADMIN.EXCEL\' | translate }}\"></md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><md-button class=\"md-raised\" ng-click=\"vm.create($event)\" translate=\"HOSPITAL_ADMIN.CREATE\" \naria-label=\"{{ \'HOSPITAL_ADMIN.CREATE\' | translate }}\"></md-button></div></div><div class=\"content\"><div \nlayout=\"column\"><div flex ng-if=\"!vm.show\" class=\"text-center\"><p class=\"hint-text font-size-16 font-weight-300\" \ntranslate=\"HOSPITAL_ADMIN.LOADING\"></p></div><div class=\"simple-table-container md-whiteframe-4dp animate-slide-right\" \nng-if=\"vm.show\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span translate=\"HOSPITAL_ADMIN.PANEL_TITLE\"></span><div layout=\"row\" \nlayout-align=\"start center\"><md-select class=\"simplified font-size-14\" ng-model=\"vm.selectedHospital\" \nng-change=\"vm.getUsers()\" aria-label=\"{{ \'HOSPITAL_ADMIN.HOSPITAL\' | translate }}\"><md-option ng-value=\"null\" \ntranslate=\"HOSPITAL_ADMIN.ALL_HOSPITALS\"></md-option><md-option ng-repeat=\"hospital in vm.hospitals\" \nng-value=\"hospital\">{{ hospital.name }}</md-option></md-select><input class=\"search-input font-size-14\" \nng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" aria-label=\"Search\"><md-button ng-if=\"vm.searchTerm\" \nng-click=\"vm.searchTerm = \'\'; vm.getUsers()\" class=\"cancel-search-input md-icon-button\" aria-label=\"Cancel\"><md-icon \nmd-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.getUsers()\" aria-label=\"\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div></div>\n</md-toolbar><md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" \nmd-on-reorder=\"vm.getUsers\"><tr md-row><th md-column md-order-by=\"name\"><span translate=\"HOSPITAL_ADMIN.COLUMNS.NAME\">\n</span></th><th md-column md-order-by=\"email\"><span translate=\"HOSPITAL_ADMIN.COLUMNS.EMAIL\"></span></th><th md-column>\n<span translate=\"HOSPITAL_ADMIN.COLUMNS.HOSPITAL\"></span></th><th md-column><span \ntranslate=\"HOSPITAL_ADMIN.COLUMNS.DEPARTMENT\"></span></th><th md-column><span translate=\"HOSPITAL_ADMIN.COLUMNS.PHONE\">\n</span></th><th md-column md-order-by=\"created_at\"><span translate=\"HOSPITAL_ADMIN.COLUMNS.CREATED\"></span></th><th \nmd-column><span translate=\"HOSPITAL_ADMIN.COLUMNS.STATUS\"></span></th><th md-column><span \ntranslate=\"HOSPITAL_ADMIN.COLUMNS.ACTIONS\"></span></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"user in vm.users\"><td md-cell class=\"text-capitalize\">{{ user.name }}</td><td md-cell nowrap=\"nowrap\">\n{{ user.email }}</td><td md-cell class=\"text-capitalize\">{{ user.hospitals[0].name }}</td><td md-cell \nclass=\"text-capitalize\">{{ user.department }}</td><td md-cell>{{ user.phone }}</td><td md-cell><span \nam-time-ago=\"user.created_at\"></span></td><td md-cell><div class=\"text-center\"><div ng-if=\"user.status === \'active\'\" \nclass=\"status-indicator md-green-500-bg\"></div><div ng-if=\"user.status === \'inactive\'\" \nclass=\"status-indicator md-grey-500-bg\"></div></div></td><td md-cell><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.edit(user, $event)\" aria-label=\"{{ \'HOSPITAL_ADMIN.EDIT\' | translate }}\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.pagination.per_page\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" md-total=\"{{ vm.pagination.total }}\" \nmd-on-paginate=\"vm.getUsers\" md-page-select></md-table-pagination></div></div></div></div><div \nclass=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img class=\"logo-image\" \nng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> \n<span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/user/hospital-operator/hospital-operator.html","<div id=\"hospital-operator\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"HOSPITAL_OPERATOR.TITLE\"></div><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" \nmd-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu md-position-mode=\"left bottom\" \nmd-offset=\"0 2\"><md-button class=\"md-raised\" ng-click=\"$mdMenu.open()\" \naria-label=\"{{ \'HOSPITAL_OPERATOR.EXPORT\' | translate }}\"><div layout=\"row\"><span translate=\"HOSPITAL_OPERATOR.EXPORT\">\n</span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-delimited\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.exportToCSV()\" translate=\"HOSPITAL_OPERATOR.CSV\" aria-label=\"{{ \'HOSPITAL_OPERATOR.CSV\' | translate }}\">\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-excel\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.exportToExcel()\" translate=\"HOSPITAL_OPERATOR.EXCEL\" \naria-label=\"{{ \'HOSPITAL_OPERATOR.EXCEL\' | translate }}\"></md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><md-button ng-if=\"!vm.isReadOnly\" class=\"md-raised\" ng-click=\"vm.create($event)\" \ntranslate=\"HOSPITAL_OPERATOR.CREATE\" aria-label=\"{{ \'HOSPITAL_OPERATOR.CREATE\' | translate }}\"></md-button></div></div>\n<div class=\"content\"><div layout=\"column\"><div flex ng-if=\"!vm.show\" class=\"text-center\"><p \nclass=\"hint-text font-size-16 font-weight-300\" translate=\"HOSPITAL_OPERATOR.LOADING\"></p></div><div \nclass=\"simple-table-container md-whiteframe-4dp animate-slide-right\" ng-if=\"vm.show\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span translate=\"HOSPITAL_OPERATOR.PANEL_TITLE\"></span><div layout=\"row\" layout-align=\"start center\"><input \nclass=\"search-input font-size-14\" ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" aria-label=\"Search\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.getUsers()\" \nclass=\"cancel-search-input md-icon-button\" aria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" \nclass=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.getUsers()\" \naria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div></div></md-toolbar>\n<md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" \nmd-on-reorder=\"vm.getUsers\"><tr md-row><th md-column><span translate=\"HOSPITAL_OPERATOR.COLUMNS.OPERATOR\"></span></th>\n<th md-column><span translate=\"HOSPITAL_OPERATOR.COLUMNS.OP_ID\"></span></th><th md-column><span \ntranslate=\"HOSPITAL_OPERATOR.COLUMNS.OP_INITIALS\"></span></th><th md-column><span \ntranslate=\"HOSPITAL_OPERATOR.COLUMNS.LOCATION_CODE\"></span></th><th md-column><span \ntranslate=\"HOSPITAL_OPERATOR.COLUMNS.TRAINING_COMPLETION\"></span></th><th md-column><span \ntranslate=\"HOSPITAL_OPERATOR.COLUMNS.TRAINING_CERT_EXPIRY\"></span></th><th md-column md-order-by=\"created_at\"><span \ntranslate=\"HOSPITAL_ADMIN.COLUMNS.CREATED\"></span></th><th md-column><span \ntranslate=\"HOSPITAL_OPERATOR.COLUMNS.STATUS\"></span></th><th md-column ng-if=\"!vm.isReadOnly\"><span \ntranslate=\"HOSPITAL_OPERATOR.COLUMNS.ACTIONS\"></span></th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"user in vm.users\"><td md-cell class=\"text-capitalize\">{{ user.name }}</td><td md-cell nowrap=\"nowrap\">\n{{ user.operator_id }}</td><td md-cell nowrap=\"nowrap\" class=\"text-uppercase\">{{ user.initials }}</td><td md-cell>\n{{ user.locations[0][\'code\'] }}</td><td md-cell nowrap=\"nowrap\">{{ user.training_completion | date:\'yyyy-MM-dd\' }}</td>\n<td md-cell nowrap=\"nowrap\">{{ user.cert_expiry | date:\'yyyy-MM-dd\' }}</td><td md-cell><span \nam-time-ago=\"user.created_at\"></span></td><td md-cell><div class=\"text-center\"><div ng-if=\"user.status === \'active\'\" \nclass=\"status-indicator md-green-500-bg\"></div><div ng-if=\"user.status === \'inactive\'\" \nclass=\"status-indicator md-grey-500-bg\"></div></div></td><td md-cell ng-if=\"!vm.isReadOnly\"><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.edit(user, $event)\" \naria-label=\"{{ \'HOSPITAL_OPERATOR.EDIT\' | translate }}\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" \nmd-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" \nmd-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getUsers\" md-page-select></md-table-pagination></div></div>\n</div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img class=\"logo-image\" \nng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> \n<span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><img class=\"logo-image\" \nng-src=\"assets/images/logos/quest-logo-white.png\"> <span class=\"logo-text\" translate=\"NAVIGATION.MENU\"></span></div>\n<md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"center\"><div layout=\"row\" layout-align=\"start center\" flex></div><div layout=\"row\" \nlayout-align=\"center center\" flex><div class=\"accu-chek-logo\" layout=\"row\" layout-align=\"start center\"><img \nclass=\"logo-image\" ng-src=\"assets/images/logos/accuchek-logo.png\"> <span class=\"logo-text\"></span></div></div><div \nlayout=\"row\" layout-align=\"end center\" flex><md-progress-circular id=\"toolbar-progress\" class=\"md-accent mr-8\" \nng-if=\"$root.loadingProgress\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"roche-logo\" \nlayout=\"row\" layout-align=\"start center\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo.png\"> <span \nclass=\"logo-text\"></span></div><div class=\"ml-8 toolbar-separator\"></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"center center\" flex hide show-gt-md><div class=\"quest-title\" layout=\"row\" \nlayout-align=\"start center\"><img class=\"logo-image\" ng-src=\"assets/images/logos/quest-title-edited.png\"> <span \nclass=\"logo-text\"></span></div></div><div layout=\"row\" layout-align=\"end center\" flex><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.user.icon\" \nclass=\"icon status s16 light-blue-fg\"></md-icon></div><div class=\"line-height-20\" hide show-gt-sm><div \nclass=\"username\">{{ vm.user.name }}</div><div class=\"username font-size-10 font-weight-400\">\n{{ vm.user.role.display_name }}</div></div><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-download\" class=\"icon\"></md-icon><md-button ng-click=\"vm.openDriverExInstaller()\">Drivers\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-help-circle\" class=\"icon\">\n</md-icon><md-menu><md-button ng-click=\"$mdOpenMenu()\">Resources</md-button><md-menu-content width=\"2\"><md-menu-item>\n<md-button ng-click=\"vm.openTroubleshootingGuide()\">Troubleshooting Guide</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.openConnectivityInstallationGuide()\">Connectivity Installation Guide</md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.user.role.name === \'roche_global_admin\' || vm.user.role.name === \'roche_country_admin\'\">\n<md-button ng-click=\"vm.openImplementationSteps()\">Simplified Implementation Steps</md-button></md-menu-item>\n<md-menu-item \nng-if=\"vm.user.role.name === \'roche_global_admin\' || vm.user.role.name === \'roche_country_admin\' || vm.user.role.name === \'hospital_admin\'\">\n<md-button ng-click=\"vm.openImplementationWorkbook()\">Hospital Implementation Workbook</md-button></md-menu-item>\n<md-menu-item ng-if=\"vm.user.role.name === \'hospital_admin\'\"><md-button ng-click=\"vm.openUserManualHospitalAdmin()\">\nUser Manual</md-button></md-menu-item><md-menu-item ng-if=\"vm.user.role.name === \'hospital_operator\'\"><md-button \nng-click=\"vm.openUserManualOperator()\">User Manual</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\" translate=\"TOOLBAR.LOGOUT\" \naria-label=\"{{ \'TOOLBAR.LOGOUT\' | translate }}\"></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"lang in vm.languages\">\n<md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate \ntranslate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><span \nclass=\"w-32 text-uppercase font-size-12 text-semibold\">{{lang.code}}</span> <span translate=\"{{lang.translation}}\">\n{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/dashboard/component/qc-failed/qc-failed.html","<ms-widget layout=\"row\" ng-if=\"vm.show\" class=\"animate-slide-right\"><ms-widget-front class=\"white-bg\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span translate=\"QC_FAILED.TITLE\"></span><md-select class=\"simplified font-size-14\" ng-model=\"vm.range\" \nng-change=\"vm.getQualityControlTests()\" aria-label=\"{{ \'QC_FAILED.RANGES\' | translate }}\"><md-option \nng-repeat=\"range in vm.ranges\" ng-value=\"range\">{{ range.text }}</md-option></md-select></div></md-toolbar>\n<md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head><tr md-row><th md-column><span \ntranslate=\"QC_FAILED.COLUMNS.TEST_DATE_TIME\"></span></th><th md-column><span \ntranslate=\"QC_FAILED.COLUMNS.METER_SERIAL_NO\"></span></th><th md-column><span translate=\"QC_FAILED.COLUMNS.STRIP_LOT\">\n</span></th><th md-column><span translate=\"QC_FAILED.COLUMNS.CONTROL_TYPE\"></span></th><th md-column md-numeric>\n{{ \'QC_FAILED.COLUMNS.QC_TARGET_RANGE\' | translate }}&nbsp;({{ vm.measurementUnits[vm.measurementUnit] }})</th><th \nmd-column md-numeric>\n{{ \'QC_FAILED.COLUMNS.QC_VALUE\' | translate }}&nbsp;({{ vm.measurementUnits[vm.measurementUnit] }})</th><th md-column>\n<span translate=\"QC_FAILED.COLUMNS.NOTES\"></span></th><th md-column ng-if=\"!vm.isReadOnly\"><span \ntranslate=\"QC_FAILED.COLUMNS.ACTION_COMPLETED\"></span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"vm.pagination.total === 0\"><td md-cell colspan=\"8\"><div class=\"hint-text font-weight-300 text-center\">\n{{ vm.emptyMessage }}</div></td></tr><tr md-row ng-repeat=\"test in vm.qualityControlTests\"><td md-cell nowrap=\"nowrap\" \nng-class=\"{\'disabled-text\':test.disabled}\">{{ test.tested_on | date:\'yyyy-MM-dd hh:mma\' }}</td><td md-cell \nnowrap=\"nowrap\" ng-class=\"{\'disabled-text\':test.disabled}\"><div>{{ test.meter.serial_no }}<md-tooltip \nmd-direction=\"right\" class=\"tooltip-multiline\"><div>{{ test.meter.location.code }}</div><div>\n{{ test.meter.location.person_in_charge }}</div><div>{{ test.meter.location.phone }}</div></md-tooltip></div></td><td \nmd-cell nowrap=\"nowrap\" ng-class=\"{\'disabled-text\':test.disabled}\">{{ test.test_strip.lot_no }}</td><td md-cell \nnowrap=\"nowrap\" ng-class=\"{\'disabled-text\':test.disabled}\">{{ test.control_level }}</td><td md-cell \nng-class=\"{\'disabled-text\':test.disabled}\">\n{{ test.from | number:1 }}&nbsp;{{ \'QC_FAILED.TO\' | translate }}&nbsp;{{ test.to | number:1 }}</td><td md-cell \nng-class=\"{\'disabled-text\':test.disabled}\">{{ test.meter_reading | number:1 }}</td><td md-cell \nng-class=\"{\'disabled-text\':test.disabled}\"><md-button ng-disabled=\"test.disabled\" class=\"edit-button md-icon-button\" \nng-click=\"vm.editNotes(test, $event)\" aria-label=\"{{ \'QC_FAILED.NOTES\' | translate }}\"><md-icon ng-if=\"!test.notes\" \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-icon ng-if=\"test.notes\" md-font-icon=\"icon-calendar-text\" \nclass=\"s16\"></md-icon></md-button></td><td md-cell ng-if=\"!vm.isReadOnly\" ng-class=\"{\'disabled-text\' : text.disabled}\">\n<div class=\"text-center\"><md-checkbox ng-disabled=\"test.disabled\" ng-model=\"test.actions_taken\" \nng-change=\"vm.actionCompleted(test)\" aria-label=\"{{ \'QC_FAILED.ACTION_COMPLETED\' | translate }}\"></md-checkbox></div>\n</td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" \nmd-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" \nmd-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getQualityControlTests\" md-page-select></md-table-pagination>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/dashboard/component/qc-history/qc-history.html","<ms-widget layout=\"row\" ng-if=\"vm.show\" class=\"animate-slide-right\"><ms-widget-front class=\"white-bg\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span translate=\"QC_HISTORY.TITLE\"></span><md-select class=\"simplified font-size-14\" ng-model=\"vm.range\" \nng-change=\"vm.getLastQCDate()\" aria-label=\"{{ \'QC_HISTORY.RANGES\' | translate }}\"><md-option \nng-repeat=\"range in vm.ranges\" ng-value=\"range\">{{ range.text }}</md-option></md-select></div></md-toolbar>\n<md-table-container><table md-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" \nmd-on-reorder=\"vm.getLastQCDate\"><tr md-row><th md-column><span translate=\"QC_HISTORY.COLUMNS.LOCATION_CODE\"></span>\n</th><th md-column><span translate=\"QC_HISTORY.COLUMNS.METER_SERIAL_NO\"></span></th><th md-column><span \ntranslate=\"QC_HISTORY.COLUMNS.PERSON_IN_CHARGE\"></span></th><th md-column><span translate=\"QC_HISTORY.COLUMNS.PHONE\">\n</span></th><th md-column md-order-by=\"last_qcdate\"><span translate=\"QC_HISTORY.COLUMNS.LAST_QC_DONE\"></span></th><th \nmd-column ng-if=\"!vm.isReadOnly\"><span translate=\"QC_HISTORY.COLUMNS.ACTION_LOG\"></span></th></tr></thead><tbody \nmd-body><tr md-row ng-if=\"vm.pagination.total === 0\"><td md-cell colspan=\"8\"><div \nclass=\"hint-text font-weight-300 text-center\">{{ vm.emptyMessage }}</div></td></tr><tr md-row \nng-repeat=\"meter in vm.meters\"><td md-cell nowrap=\"nowrap\">{{ meter.location.code }}</td><td md-cell nowrap=\"nowrap\">\n{{ meter.serial_no }}</td><td md-cell class=\"text-capitalize\" nowrap=\"nowrap\">{{ meter.location.person_in_charge }}\n</td><td md-cell>{{ meter.location.phone }}</td><td md-cell ng-if=\"meter.last_qcdate\"><span \nam-time-ago=\"meter.last_qcdate\"></span></td><td md-cell ng-if=\"!meter.last_qcdate\"><span class=\"hint-text\" \ntranslate=\"QC_HISTORY.MESSAGES.NO_QC_DATA\"></span></td><td md-cell ng-if=\"!vm.isReadOnly\"><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.showActionLog(meter, $event)\" \naria-label=\"{{ \'QC_HISTORY.EDIT\' | translate }}\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button>\n</td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" \nmd-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" \nmd-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getLastQCDate\" md-page-select></md-table-pagination>\n</ms-widget-front></ms-widget>");
$templateCache.put("app/main/qc-report/hospital/qcperformance/qcperformance.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_HOSPITAL.TITLE\"></span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\"><div class=\"title\" translate=\"QC_REPORT_HOSPITAL_QCPERFORMANCE.TITLE\"></div><div \nng-if=\"vm.role === \'roche_country_admin\'\" class=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}\n</div><div ng-if=\"vm.role === \'hospital_admin\'\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu md-position-mode=\"right bottom\" \nmd-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid || !vm.hasData\" class=\"md-raised\" \nng-click=\"$mdMenu.open()\" aria-label=\"{{ \'QC_REPORT_HOSPITAL_QCPERFORMANCE.EXPORT\' | translate }}\"><div layout=\"row\">\n<span translate=\"QC_REPORT_HOSPITAL_QCPERFORMANCE.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon\">\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToPDF()\" \ntranslate=\"QC_REPORT_HOSPITAL_QCPERFORMANCE.PDF\" aria-label=\"{{ \'QC_REPORT_HOSPITAL_QCPERFORMANCE.PDF\' | translate }}\">\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div></div><div class=\"content\"><div \nlayout=\"column\"><hospital-qc-performance-global-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nall-countries=\"vm.allCountries\" all-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\" has-data=\"vm.hasData\" \nng-if=\"vm.role === \'roche_global_admin\'\"></hospital-qc-performance-global-admin><hospital-qc-performance-country-admin \nloaded=\"vm.loaded\" valid=\"vm.valid\" has-data=\"vm.hasData\" ng-if=\"vm.role === \'roche_country_admin\'\" \ncountry=\"vm.user.country\" all-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\">\n</hospital-qc-performance-country-admin><hospital-qc-performance-hospital-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nhas-data=\"vm.hasData\" ng-if=\"vm.role === \'hospital_admin\'\"></hospital-qc-performance-hospital-admin></div></div></div>\n<div class=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img class=\"logo-image\" \nng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> \n<span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/qc-report/hospital/sdchart/sdchart.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_HOSPITAL.TITLE\"></span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\"><div class=\"title\" translate=\"QC_REPORT_HOSPITAL_SDCHART.TITLE\"></div><div \nng-if=\"vm.role === \'roche_country_admin\'\" class=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}\n</div><div ng-if=\"vm.role === \'hospital_admin\'\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu md-position-mode=\"right bottom\" \nmd-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" class=\"md-raised\" ng-click=\"$mdMenu.open()\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL_SDCHART.EXPORT\' | translate }}\"><div layout=\"row\"><span \ntranslate=\"QC_REPORT_HOSPITAL_SDCHART.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon\"></md-icon>\n</div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-pdf\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.exportToPDF()\" translate=\"QC_REPORT_HOSPITAL_SDCHART.PDF\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL_SDCHART.PDF\' | translate }}\"></md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></div></div></div><div class=\"content\"><div layout=\"column\"><hospital-sd-chart-global-admin \nloaded=\"vm.loaded\" valid=\"vm.valid\" all-countries=\"vm.allCountries\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\" ng-if=\"vm.role === \'roche_global_admin\'\"></hospital-sd-chart-global-admin>\n<hospital-sd-chart-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" ng-if=\"vm.role === \'roche_country_admin\'\" \ncountry=\"vm.user.country\" all-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\"></hospital-sd-chart-country-admin>\n<hospital-sd-chart-hospital-admin loaded=\"vm.loaded\" valid=\"vm.valid\" ng-if=\"vm.role === \'hospital_admin\'\">\n</hospital-sd-chart-hospital-admin></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/qc-report/multiple/combined/combined.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_MULTIPLE.TITLE\"></span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\"><div class=\"title\" translate=\"QC_REPORT_MULTIPLE_COMBINED.TITLE\"></div><div \nng-if=\"vm.role === \'roche_global_admin\'\" class=\"font-size-14 font-weight-200\">Global</div><div \nng-if=\"vm.role === \'roche_country_admin\'\" class=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}\n</div><div ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\" layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" \nclass=\"s16 white-fg line-height-20\"></md-icon><div flex class=\"ml-8 font-size-14 font-weight-200 line-height-20\">\n{{ vm.user.hospitals[0].name }}</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\">\n<md-menu md-position-mode=\"right bottom\" md-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" \nclass=\"md-raised\" ng-click=\"$mdMenu.open()\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.EXPORT\' | translate }}\"><div \nlayout=\"row\"><span translate=\"QC_REPORT_MULTIPLE_COMBINED.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" \nclass=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToPDF()\" \ntranslate=\"QC_REPORT_MULTIPLE_COMBINED.PDF\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.PDF\' | translate }}\">\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div></div><div class=\"content\"><div \nlayout=\"column\"><multiple-combined-global-admin loaded=\"vm.loaded\" valid=\"vm.valid\" all-countries=\"vm.allCountries\" \nall-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\" ng-if=\"vm.role === \'roche_global_admin\'\">\n</multiple-combined-global-admin><multiple-combined-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'roche_country_admin\'\" country=\"vm.user.country\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\"></multiple-combined-country-admin><multiple-combined-hospital-admin loaded=\"vm.loaded\" \nvalid=\"vm.valid\" ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\">\n</multiple-combined-hospital-admin></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/qc-report/multiple/level1/level1.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_MULTIPLE.TITLE\"></span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\"><div class=\"title\" translate=\"QC_REPORT_MULTIPLE_LEVEL1.TITLE\"></div><div \nng-if=\"vm.role === \'roche_global_admin\'\" class=\"font-size-14 font-weight-200\">Global</div><div \nng-if=\"vm.role === \'roche_country_admin\'\" class=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}\n</div><div ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\" layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" \nclass=\"s16 white-fg line-height-20\"></md-icon><div flex class=\"ml-8 font-size-14 font-weight-200 line-height-20\">\n{{ vm.user.hospitals[0].name }}</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\">\n<md-menu md-position-mode=\"right bottom\" md-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" \nclass=\"md-raised\" ng-click=\"$mdMenu.open()\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.EXPORT\' | translate }}\"><div \nlayout=\"row\"><span translate=\"QC_REPORT_MULTIPLE_LEVEL1.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" \nclass=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToPDF()\" \ntranslate=\"QC_REPORT_MULTIPLE_LEVEL1.PDF\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.PDF\' | translate }}\"></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div></div><div class=\"content\"><div layout=\"column\">\n<multiple-level1-global-admin loaded=\"vm.loaded\" valid=\"vm.valid\" all-countries=\"vm.allCountries\" \nall-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\" ng-if=\"vm.role === \'roche_global_admin\'\">\n</multiple-level1-global-admin><multiple-level1-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'roche_country_admin\'\" country=\"vm.user.country\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\"></multiple-level1-country-admin><multiple-level1-hospital-admin loaded=\"vm.loaded\" \nvalid=\"vm.valid\" ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\">\n</multiple-level1-hospital-admin></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/qc-report/multiple/logbook/logbook.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_MULTIPLE.TITLE\"></span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\"><div class=\"title\" translate=\"QC_REPORT_MULTIPLE_LOGBOOK.TITLE\"></div><div \nng-if=\"vm.role === \'roche_global_admin\'\" class=\"font-size-14 font-weight-200\">Global</div><div \nng-if=\"vm.role === \'roche_country_admin\'\" class=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}\n</div><div ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\" layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" \nclass=\"s16 white-fg line-height-20\"></md-icon><div flex class=\"ml-8 font-size-14 font-weight-200 line-height-20\">\n{{ vm.user.hospitals[0].name }}</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\">\n<md-menu md-position-mode=\"right bottom\" md-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" \nclass=\"md-raised\" ng-click=\"$mdMenu.open()\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.EXPORT\' | translate }}\"><div \nlayout=\"row\"><span translate=\"QC_REPORT_MULTIPLE_LOGBOOK.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" \nclass=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-delimited\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToCSV()\" \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.CSV\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.EXPORT\' | translate }}\">\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-excel\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.exportToExcel()\" translate=\"QC_REPORT_MULTIPLE_LOGBOOK.EXCEL\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.EXCEL\' | translate }}\"></md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar></div></div></div><div class=\"content\"><div layout=\"column\"><multiple-logbook-global-admin \nloaded=\"vm.loaded\" valid=\"vm.valid\" all-countries=\"vm.allCountries\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\" ng-if=\"vm.role === \'roche_global_admin\'\"></multiple-logbook-global-admin>\n<multiple-logbook-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" ng-if=\"vm.role === \'roche_country_admin\'\" \ncountry=\"vm.user.country\" all-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\"></multiple-logbook-country-admin>\n<multiple-logbook-hospital-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\"></multiple-logbook-hospital-admin></div></div>\n</div><div class=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img class=\"logo-image\" \nng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> \n<span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/qc-report/multiple/level2/level2.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_MULTIPLE.TITLE\"></span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\"><div class=\"title\" translate=\"QC_REPORT_MULTIPLE_LEVEL2.TITLE\"></div><div \nng-if=\"vm.role === \'roche_global_admin\'\" class=\"font-size-14 font-weight-200\">Global</div><div \nng-if=\"vm.role === \'roche_country_admin\'\" class=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}\n</div><div ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\" layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" \nclass=\"s16 white-fg line-height-20\"></md-icon><div flex class=\"ml-8 font-size-14 font-weight-200 line-height-20\">\n{{ vm.user.hospitals[0].name }}</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\">\n<md-menu md-position-mode=\"right bottom\" md-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" \nclass=\"md-raised\" ng-click=\"$mdMenu.open()\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.EXPORT\' | translate }}\"><div \nlayout=\"row\"><span translate=\"QC_REPORT_MULTIPLE_LEVEL2.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" \nclass=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToPDF()\" \ntranslate=\"QC_REPORT_MULTIPLE_LEVEL2.PDF\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.PDF\' | translate }}\"></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div></div><div class=\"content\"><div layout=\"column\">\n<multiple-level2-global-admin loaded=\"vm.loaded\" valid=\"vm.valid\" all-countries=\"vm.allCountries\" \nall-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\" ng-if=\"vm.role === \'roche_global_admin\'\">\n</multiple-level2-global-admin><multiple-level2-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'roche_country_admin\'\" country=\"vm.user.country\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\"></multiple-level2-country-admin><multiple-level2-hospital-admin loaded=\"vm.loaded\" \nvalid=\"vm.valid\" ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\">\n</multiple-level2-hospital-admin></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/qc-report/mfr-control-limits/level1/level1.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_MFR_CONTROL_LIMITS.TITLE\"></span></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.TITLE\"></div><div ng-if=\"vm.role === \'roche_global_admin\'\" \nclass=\"font-size-14 font-weight-200\">Global</div><div ng-if=\"vm.role === \'roche_country_admin\'\" \nclass=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}</div><div \nng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\" layout=\"row\" layout-align=\"start center\">\n<md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu md-position-mode=\"right bottom\" \nmd-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" class=\"md-raised\" ng-click=\"$mdMenu.open()\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.EXPORT\' | translate }}\"><div layout=\"row\"><span \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon\">\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToPDF()\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.PDF\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.PDF\' | translate }}\"></md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar></div></div></div><div class=\"content\"><div class=\"\" layout=\"column\">\n<mfr-control-limits-level1-global-admin loaded=\"vm.loaded\" valid=\"vm.valid\" all-countries=\"vm.allCountries\" \nall-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\" ng-if=\"vm.role === \'roche_global_admin\'\">\n</mfr-control-limits-level1-global-admin><mfr-control-limits-level1-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'roche_country_admin\'\" country=\"vm.user.country\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\"></mfr-control-limits-level1-country-admin><mfr-control-limits-level1-hospital-admin \nloaded=\"vm.loaded\" valid=\"vm.valid\" ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\">\n</mfr-control-limits-level1-hospital-admin></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/qc-report/mfr-control-limits/level2/level2.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_MFR_CONTROL_LIMITS.TITLE\"></span></div><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\"><div class=\"title\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.TITLE\"></div><div ng-if=\"vm.role === \'roche_global_admin\'\" \nclass=\"font-size-14 font-weight-200\">Global</div><div ng-if=\"vm.role === \'roche_country_admin\'\" \nclass=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}</div><div \nng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\" layout=\"row\" layout-align=\"start center\">\n<md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu md-position-mode=\"right bottom\" \nmd-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" class=\"md-raised\" ng-click=\"$mdMenu.open()\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.EXPORT\' | translate }}\"><div layout=\"row\"><span \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon\">\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToPDF()\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.PDF\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.PDF\' | translate }}\"></md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar></div></div></div><div class=\"content\"><div class=\"\" layout=\"column\">\n<mfr-control-limits-level2-global-admin loaded=\"vm.loaded\" valid=\"vm.valid\" all-countries=\"vm.allCountries\" \nall-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\" ng-if=\"vm.role === \'roche_global_admin\'\">\n</mfr-control-limits-level2-global-admin><mfr-control-limits-level2-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'roche_country_admin\'\" country=\"vm.user.country\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\"></mfr-control-limits-level2-country-admin><mfr-control-limits-level2-hospital-admin \nloaded=\"vm.loaded\" valid=\"vm.valid\" ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\">\n</mfr-control-limits-level2-hospital-admin></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/qc-report/single/combined/combined.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_SINGLE.TITLE\"></span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\"><div class=\"title\" translate=\"QC_REPORT_SINGLE_COMBINED.TITLE\"></div><div \nng-if=\"vm.role === \'roche_global_admin\'\" class=\"font-size-14 font-weight-200\">Global</div><div \nng-if=\"vm.role === \'roche_country_admin\'\" class=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}\n</div><div ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\" layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" \nclass=\"s16 white-fg line-height-20\"></md-icon><div flex class=\"ml-8 font-size-14 font-weight-200 line-height-20\">\n{{ vm.user.hospitals[0].name }}</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\">\n<md-menu md-position-mode=\"right bottom\" md-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" \nclass=\"md-raised\" ng-click=\"$mdMenu.open()\" aria-label=\"{{ \'QC_REPORT_SINGLE_COMBINED.EXPORT\' | translate }}\"><div \nlayout=\"row\"><span translate=\"QC_REPORT_SINGLE_COMBINED.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" \nclass=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToPDF()\" \ntranslate=\"QC_REPORT_SINGLE_COMBINED.PDF\" aria-label=\"{{ \'QC_REPORT_SINGLE_COMBINED.PDF\' | translate }}\"></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div></div><div class=\"content\"><div layout=\"column\">\n<single-combined-global-admin loaded=\"vm.loaded\" valid=\"vm.valid\" all-countries=\"vm.allCountries\" \nall-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\" ng-if=\"vm.role === \'roche_global_admin\'\">\n</single-combined-global-admin><single-combined-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'roche_country_admin\'\" country=\"vm.user.country\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\"></single-combined-country-admin><single-combined-hospital-admin loaded=\"vm.loaded\" \nvalid=\"vm.valid\" ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\">\n</single-combined-hospital-admin></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/qc-report/single/level1/level1.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_SINGLE.TITLE\"></span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\"><div class=\"title\" translate=\"QC_REPORT_SINGLE_LEVEL1.TITLE\"></div><div \nng-if=\"vm.role === \'roche_global_admin\'\" class=\"font-size-14 font-weight-200\">Global</div><div \nng-if=\"vm.role === \'roche_country_admin\'\" class=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}\n</div><div ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\" layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" \nclass=\"s16 white-fg line-height-20\"></md-icon><div flex class=\"ml-8 font-size-14 font-weight-200 line-height-20\">\n{{ vm.user.hospitals[0].name }}</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\">\n<md-menu md-position-mode=\"right bottom\" md-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" \nclass=\"md-raised\" ng-click=\"$mdMenu.open()\" aria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL1.EXPORT\' | translate }}\"><div \nlayout=\"row\"><span translate=\"QC_REPORT_SINGLE_LEVEL1.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" \nclass=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToPDF()\" \ntranslate=\"QC_REPORT_SINGLE_LEVEL1.PDF\" aria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL1.PDF\' | translate }}\"></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div></div><div class=\"content\"><div class=\"\" \nlayout=\"column\"><single-level1-global-admin loaded=\"vm.loaded\" valid=\"vm.valid\" all-countries=\"vm.allCountries\" \nall-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\" ng-if=\"vm.role === \'roche_global_admin\'\">\n</single-level1-global-admin><single-level1-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'roche_country_admin\'\" country=\"vm.user.country\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\"></single-level1-country-admin><single-level1-hospital-admin loaded=\"vm.loaded\" \nvalid=\"vm.valid\" ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\">\n</single-level1-hospital-admin></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/qc-report/single/level2/level2.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_SINGLE.TITLE\"></span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\"><div class=\"title\" translate=\"QC_REPORT_SINGLE_LEVEL2.TITLE\"></div><div \nng-if=\"vm.role === \'roche_global_admin\'\" class=\"font-size-14 font-weight-200\">Global</div><div \nng-if=\"vm.role === \'roche_country_admin\'\" class=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}\n</div><div ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\" layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" \nclass=\"s16 white-fg line-height-20\"></md-icon><div flex class=\"ml-8 font-size-14 font-weight-200 line-height-20\">\n{{ vm.user.hospitals[0].name }}</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\">\n<md-menu md-position-mode=\"right bottom\" md-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" \nclass=\"md-raised\" ng-click=\"$mdMenu.open()\" aria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL2.EXPORT\' | translate }}\"><div \nlayout=\"row\"><span translate=\"QC_REPORT_SINGLE_LEVEL2.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" \nclass=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToPDF()\" \ntranslate=\"QC_REPORT_SINGLE_LEVEL2.PDF\" aria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL2.PDF\' | translate }}\"></md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div></div><div class=\"content\"><div class=\"\" \nlayout=\"column\"><single-level2-global-admin loaded=\"vm.loaded\" valid=\"vm.valid\" all-countries=\"vm.allCountries\" \nall-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\" ng-if=\"vm.role === \'roche_global_admin\'\">\n</single-level2-global-admin><single-level2-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'roche_country_admin\'\" country=\"vm.user.country\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\"></single-level2-country-admin><single-level2-hospital-admin loaded=\"vm.loaded\" \nvalid=\"vm.valid\" ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\">\n</single-level2-hospital-admin></div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" \nlayout-align=\"end end\"><img class=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span \nclass=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">\nNot available for sale in the US</span></div>");
$templateCache.put("app/main/qc-report/single/logbook/logbook.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_SINGLE.TITLE\"></span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\"><div class=\"title\" translate=\"QC_REPORT_SINGLE_LOGBOOK.TITLE\"></div><div \nng-if=\"vm.role === \'roche_global_admin\'\" class=\"font-size-14 font-weight-200\">Global</div><div \nng-if=\"vm.role === \'roche_country_admin\'\" class=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}\n</div><div ng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\" layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" \nclass=\"s16 white-fg line-height-20\"></md-icon><div flex class=\"ml-8 font-size-14 font-weight-200 line-height-20\">\n{{ vm.user.hospitals[0].name }}</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\">\n<md-menu md-position-mode=\"right bottom\" md-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" \nclass=\"md-raised\" ng-click=\"$mdMenu.open()\" aria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.EXPORT\' | translate }}\"><div \nlayout=\"row\"><span translate=\"QC_REPORT_SINGLE_LOGBOOK.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" \nclass=\"icon\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-delimited\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToCSV()\" \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.CSV\" aria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.EXPORT\' | translate }}\"></md-button>\n</md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-excel\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.exportToExcel()\" translate=\"QC_REPORT_SINGLE_LOGBOOK.EXCEL\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.EXCEL\' | translate }}\"></md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></div></div></div><div class=\"content\"><div layout=\"column\"><single-logbook-global-admin \nloaded=\"vm.loaded\" valid=\"vm.valid\" all-countries=\"vm.allCountries\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\" ng-if=\"vm.role === \'roche_global_admin\'\"></single-logbook-global-admin>\n<single-logbook-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" ng-if=\"vm.role === \'roche_country_admin\'\" \ncountry=\"vm.user.country\" all-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\"></single-logbook-country-admin>\n<single-logbook-hospital-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'hospital_admin\' || vm.role === \'hospital_operator\'\"></single-logbook-hospital-admin></div></div>\n</div><div class=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img class=\"logo-image\" \nng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">©{{ vm.year }} Roche Diabetes Care</span> \n<span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/user/country-admin/country-admin-form/country-admin-form.html","<md-dialog class=\"country-admin-form\" aria-label=\"{{ vm.dialogTitle }}\"><form name=\"vm.userForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{ vm.dialogTitle }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"{{ \'COUNTRY_ADMIN_FORM.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label \ntranslate=\"COUNTRY_ADMIN_FORM.EMAIL\"></label><input name=\"email\" ng-model=\"vm.user.email\" type=\"email\" required \nng-disabled=\"vm.dialogData.type == \'edit\'\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"vm.userForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"COUNTRY_ADMIN_FORM.INPUT_MESSAGES.EMAIL_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"COUNTRY_ADMIN_FORM.INPUT_MESSAGES.EMAIL_FORMAT_INVALID\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"COUNTRY_ADMIN_FORM.NAME\"></label><input name=\"name\" \nng-model=\"vm.user.name\" required><div ng-messages=\"vm.userForm.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"COUNTRY_ADMIN_FORM.INPUT_MESSAGES.NAME_REQUIRED\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"COUNTRY_ADMIN_FORM.COUNTRY\"></label><md-select name=\"country\" \nng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" required><md-option ng-value=\"country\" \nng-repeat=\"country in vm.countries\">{{ country.name }}</md-option></md-select><div \nng-messages=\"vm.userForm.country.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"COUNTRY_ADMIN_FORM.INPUT_MESSAGES.COUNTRY_REQUIRED\"></span></div></div></md-input-container><div \nclass=\"h-8\"></div><md-input-container class=\"md-block\"><label translate=\"COUNTRY_ADMIN_FORM.STATUS\"></label><md-select \nname=\"status\" ng-model=\"vm.user.status\" required><md-option ng-value=\"\'active\'\" translate=\"COUNTRY_ADMIN_FORM.ACTIVE\">\n</md-option><md-option ng-value=\"\'inactive\'\" translate=\"COUNTRY_ADMIN_FORM.INACTIVE\"></md-option></md-select><div \nng-messages=\"vm.userForm.status.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"COUNTRY_ADMIN_FORM.INPUT_MESSAGES.STATUS_REQUIRED\"></span></div></div></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div></div><div><md-button \ntype=\"button\" ng-click=\"vm.resetPassword()\" class=\"md-warn\" ng-disabled=\"!vm.canResetPassword\" \ntranslate=\"COUNTRY_ADMIN_FORM.RESET_PASSWORD\" aria-label=\"{{ \'COUNTRY_ADMIN_FORM.RESET_PASSWORD\' | translate }}\">\n</md-button><md-button ng-click=\"vm.save()\" class=\"save-button md-accent md-raised\" \nng-disabled=\"vm.userForm.$invalid || vm.userForm.$pristine\" translate=\"COUNTRY_ADMIN_FORM.SAVE\" \naria-label=\"{{ \'COUNTRY_ADMIN_FORM.SAVE\' | translate }}\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/user/hospital-admin/hospital-admin-form/hospital-admin-form.html","<md-dialog class=\"hospital-admin-form\" aria-label=\"{{ vm.dialogTitle }}\"><form name=\"vm.userForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{ vm.dialogTitle }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"{{ \'HOSPITAL_ADMIN_FORM\' | translate }}\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p class=\"pb-10\">{{ vm.dialogTitle }}&nbsp;<span \ntranslate=\"HOSPITAL_ADMIN_FORM.SUB_TITLE\"></span>&nbsp;<span class=\"text-bold\">{{ vm.countries[vm.country] }}</span>.\n</p><md-input-container class=\"md-block\"><label translate=\"HOSPITAL_ADMIN_FORM.EMAIL\"></label><input name=\"email\" \nng-model=\"vm.user.email\" type=\"email\" required ng-disabled=\"vm.dialogData.type == \'edit\'\" ng-pattern=\"/^.+@.+\\..+$/\">\n<div ng-messages=\"vm.userForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"HOSPITAL_ADMIN_FORM.INPUT_MESSAGES.EMAIL_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"HOSPITAL_ADMIN_FORM.INPUT_MESSAGES.EMAIL_FORMAT_INVALID\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"HOSPITAL_ADMIN_FORM.NAME\"></label><input name=\"name\" \nng-model=\"vm.user.name\" required><div ng-messages=\"vm.userForm.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"HOSPITAL_ADMIN_FORM.INPUT_MESSAGES.NAME_REQUIRED\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"HOSPITAL_ADMIN_FORM.HOSPITAL\"></label><md-select \nname=\"hospital\" ng-model=\"vm.selectedHospital\" ng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.userForm.hospital.$error\"><div ng-message=\"required\"><span \ntranslate=\"HOSPITAL_ADMIN_FORM.INPUT_MESSAGES.HOSPITAL_REQUIRED\"></span></div></div></md-input-container><div \nlayout=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"HOSPITAL_ADMIN_FORM.DEPARTMENT\"></label><input\n name=\"department\" ng-model=\"vm.user.department\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"HOSPITAL_ADMIN_FORM.PHONE\"></label><input name=\"phone\" ng-model=\"vm.user.phone\"></md-input-container></div>\n<md-input-container class=\"md-block mt-0\"><label translate=\"HOSPITAL_ADMIN_FORM.STATUS\"></label><md-select \nng-model=\"vm.user.status\" required><md-option ng-value=\"\'active\'\" translate=\"HOSPITAL_ADMIN_FORM.ACTIVE\"></md-option>\n<md-option ng-value=\"\'inactive\'\" translate=\"HOSPITAL_ADMIN_FORM.INACTIVE\"></md-option></md-select></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div></div><div><md-button \ntype=\"button\" ng-click=\"vm.resetPassword()\" class=\"md-warn\" ng-disabled=\"!vm.canResetPassword\" \ntranslate=\"HOSPITAL_ADMIN_FORM.RESET_PASSWORD\" aria-label=\"{{ \'HOSPITAL_ADMIN_FORM.RESET_PASSWORD\' | translate }}\">\nRESET PASSWORD</md-button><md-button ng-click=\"vm.save()\" class=\"save-button md-accent md-raised\" \nng-disabled=\"vm.userForm.$invalid || vm.userForm.$pristine\" translate=\"HOSPITAL_ADMIN_FORM.SAVE\" \naria-label=\"{{ \'HOSPITAL_ADMIN_FORM.SAVE\' | translate }}\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/user/hospital-operator/hospital-operator-form/hospital-operator-form.html","<md-dialog class=\"hospital-operator-form\" aria-label=\"{{ vm.dialogTitle }}\"><form name=\"vm.userForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{ vm.dialogTitle }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"{{ \'HOSPITAL_OPERATOR_FORM.CLOSE\' | translate }}\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><p class=\"pb-10\">{{ vm.dialogTitle }}&nbsp;<span \ntranslate=\"HOSPITAL_OPERATOR_FORM.SUB_TITLE\" translate-values=\"{title: vm.dialogTitle, hospital: vm.hospital.name}\">\n</span></p><md-input-container class=\"md-block\"><label translate=\"HOSPITAL_OPERATOR_FORM.EMAIL\"></label><input \nname=\"email\" ng-model=\"vm.user.email\" type=\"email\" required ng-disabled=\"vm.dialogData.type == \'edit\'\" \nng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"vm.userForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"HOSPITAL_OPERATOR_FORM.INPUT_MESSAGES.EMAIL_REQUIRED\"></span></div><div \nng-message=\"pattern\"><span translate=\"HOSPITAL_OPERATOR_FORM.INPUT_MESSAGES.EMAIL_FORMAT_INVALID\"></span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"HOSPITAL_OPERATOR_FORM.NAME\"></label><input\n name=\"name\" ng-model=\"vm.user.name\" required ng-blur=\"vm.nameOnBlur()\"><div ng-messages=\"vm.userForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"HOSPITAL_OPERATOR_FORM.INPUT_MESSAGES.NAME_REQUIRED\"></span>\n</div></div></md-input-container><div layout=\"row\" class=\"adjust-row-margin-in-form\"><md-input-container \nclass=\"md-block\" flex><label translate=\"HOSPITAL_OPERATOR_FORM.OP_INITIALS\"></label><input name=\"initials\" \nng-model=\"vm.user.initials\" required check-initials-availability hospital-id=\"{{ vm.hospital.id }}\" \nignore-id=\"{{ vm.user.id }}\"><div ng-messages=\"vm.userForm.initials.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"HOSPITAL_OPERATOR_FORM.INPUT_MESSAGES.OP_INITIALS_REQUIRED\"></span></div><div \nng-message=\"invalidInitials\"><span translate=\"HOSPITAL_OPERATOR_FORM.INPUT_MESSAGES.OP_INITIALS_INVALID\"></span></div>\n</div><span class=\"hint-text font-size-12\" ng-show=\"vm.userForm.initials.$pending\">checking availability...</span>\n</md-input-container><md-input-container class=\"md-block\" flex><label translate=\"HOSPITAL_OPERATOR_FORM.OP_ID\"></label>\n<input name=\"operatorID\" ng-model=\"vm.user.operator_id\" required><div ng-messages=\"vm.userForm.operatorID.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"HOSPITAL_OPERATOR_FORM.INPUT_MESSAGES.OP_ID_REQUIRED\"></span>\n</div></div></md-input-container></div><md-input-container class=\"md-block adjust-select-margin-in-form\"><label \ntranslate=\"HOSPITAL_OPERATOR_FORM.LOCATION_CODE\"></label><md-select name=\"location\" ng-model=\"vm.selectedLocation\" \nng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option ng-value=\"location\" ng-repeat=\"location in vm.locations\">\n{{ location.code }}</md-option></md-select><div ng-messages=\"vm.userForm.location.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"HOSPITAL_OPERATOR_FORM.INPUT_MESSAGES.LOCATION_CODE_REQUIRED\"></div></div>\n</md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"HOSPITAL_OPERATOR_FORM.TRAINING_COMPLETION\"></label><md-datepicker name=\"trainingCompletion\" \nng-model=\"vm.trainingCompletion\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.userForm.trainingCompletion.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"HOSPITAL_OPERATOR_FORM.INPUT_MESSAGES.TRAINING_COMPLETION_REQUIRED\"></span></div><div ng-message=\"valid\">\n<span translate=\"HOSPITAL_OPERATOR_FORM.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"HOSPITAL_OPERATOR_FORM.TRAINING_CERT_EXPIRY\"></label>\n<md-datepicker name=\"certExpiry\" ng-model=\"vm.certExpiry\" required md-min-date=\"vm.trainingCompletion\" \nmd-hide-icons=\"calendar\"></md-datepicker><div ng-messages=\"vm.userForm.certExpiry.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"HOSPITAL_OPERATOR_FORM.INPUT_MESSAGES.TRAINING_CERT_EXPIRY_REQUIRED\"></span></div><div ng-message=\"valid\">\n<span translate=\"HOSPITAL_OPERATOR_FORM.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></span></div><div ng-message=\"mindate\">\n<span translate=\"HOSPITAL_OPERATOR_FORM.INPUT_MESSAGES.TRAINING_CERT_EXPIRY_MIN\"></span></div></div>\n</md-input-container></div><md-input-container class=\"md-block mt-0\"><label translate=\"HOSPITAL_OPERATOR_FORM.STATUS\">\n</label><md-select ng-model=\"vm.user.status\" required><md-option ng-value=\"\'active\'\" \ntranslate=\"HOSPITAL_OPERATOR_FORM.ACTIVE\"></md-option><md-option ng-value=\"\'inactive\'\" \ntranslate=\"HOSPITAL_OPERATOR_FORM.INACTIVE\"></md-option></md-select></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div></div><div><md-button type=\"button\" \nng-click=\"vm.resetPassword()\" class=\"md-warn\" ng-disabled=\"!vm.canResetPassword\" \ntranslate=\"HOSPITAL_OPERATOR_FORM.RESET_PASSWORD\" \naria-label=\"{{ \'HOSPITAL_OPERATOR_FORM.RESET_PASSWORD\' | translate }}\"></md-button><md-button ng-click=\"vm.save()\" \nclass=\"save-button md-accent md-raised\" \nng-disabled=\"vm.userForm.$pending || vm.userForm.$invalid || vm.userForm.$pristine\" \ntranslate=\"HOSPITAL_OPERATOR_FORM.SAVE\" aria-label=\"{{ \'HOSPITAL_OPERATOR_FORM.SAVE\' | translate }}\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/qc-report/hospital/cvchart/level1/level1.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_HOSPITAL.TITLE\"></span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\"><div class=\"title\" translate=\"QC_REPORT_HOSPITAL_CVCHART_LEVEL1.TITLE\"></div><div \nng-if=\"vm.role === \'roche_country_admin\'\" class=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}\n</div><div ng-if=\"vm.role === \'hospital_admin\'\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu md-position-mode=\"right bottom\" \nmd-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" class=\"md-raised\" ng-click=\"$mdMenu.open()\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.EXPORT\' | translate }}\"><div layout=\"row\"><span \ntranslate=\"QC_REPORT_HOSPITAL_CVCHART_LEVEL1.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon\">\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToPDF()\" \ntranslate=\"QC_REPORT_HOSPITAL_CVCHART_LEVEL1.PDF\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL_CVCHART_LEVEL1.PDF\' | translate }}\"></md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar></div></div></div><div class=\"content\"><div layout=\"column\">\n<hospital-cv-chart-level1-global-admin loaded=\"vm.loaded\" valid=\"vm.valid\" all-countries=\"vm.allCountries\" \nall-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\" ng-if=\"vm.role === \'roche_global_admin\'\">\n</hospital-cv-chart-level1-global-admin><hospital-cv-chart-level1-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'roche_country_admin\'\" country=\"vm.user.country\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\"></hospital-cv-chart-level1-country-admin><hospital-cv-chart-level1-hospital-admin \nloaded=\"vm.loaded\" valid=\"vm.valid\" ng-if=\"vm.role === \'hospital_admin\'\"></hospital-cv-chart-level1-hospital-admin>\n</div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img \nclass=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">\n©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/qc-report/hospital/cvchart/level2/level2.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"column\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"parent\" translate=\"QC_REPORT_HOSPITAL.TITLE\"></span></div><div layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"column\"><div class=\"title\" translate=\"QC_REPORT_HOSPITAL_CVCHART_LEVEL2.TITLE\"></div><div \nng-if=\"vm.role === \'roche_country_admin\'\" class=\"font-size-14 font-weight-200\">{{ vm.allCountries[vm.user.country] }}\n</div><div ng-if=\"vm.role === \'hospital_admin\'\" layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isReadOnly\" md-font-icon=\"icon-link\" class=\"s16 white-fg line-height-20\"></md-icon><div flex \nclass=\"ml-8 font-size-14 font-weight-200 line-height-20\">{{ vm.user.hospitals[0].name }}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-menu-bar class=\"p-0\"><md-menu md-position-mode=\"right bottom\" \nmd-offset=\"0 2\"><md-button ng-disabled=\"!vm.loaded || !vm.valid\" class=\"md-raised\" ng-click=\"$mdMenu.open()\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.EXPORT\' | translate }}\"><div layout=\"row\"><span \ntranslate=\"QC_REPORT_HOSPITAL_CVCHART_LEVEL2.EXPORT\"></span><md-icon md-font-icon=\"icon-menu-down\" class=\"icon\">\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon><md-button ng-click=\"vm.exportToPDF()\" \ntranslate=\"QC_REPORT_HOSPITAL_CVCHART_LEVEL2.PDF\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL_CVCHART_LEVEL2.PDF\' | translate }}\"></md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar></div></div></div><div class=\"content\"><div layout=\"column\">\n<hospital-cv-chart-level2-global-admin loaded=\"vm.loaded\" valid=\"vm.valid\" all-countries=\"vm.allCountries\" \nall-states=\"vm.allStates\" all-hospitals=\"vm.allHospitals\" ng-if=\"vm.role === \'roche_global_admin\'\">\n</hospital-cv-chart-level2-global-admin><hospital-cv-chart-level2-country-admin loaded=\"vm.loaded\" valid=\"vm.valid\" \nng-if=\"vm.role === \'roche_country_admin\'\" country=\"vm.user.country\" all-states=\"vm.allStates\" \nall-hospitals=\"vm.allHospitals\"></hospital-cv-chart-level2-country-admin><hospital-cv-chart-level2-hospital-admin \nloaded=\"vm.loaded\" valid=\"vm.valid\" ng-if=\"vm.role === \'hospital_admin\'\"></hospital-cv-chart-level2-hospital-admin>\n</div></div></div><div class=\"workspace-footer-copy-right\" layout=\"column\" layout-align=\"end end\"><img \nclass=\"logo-image\" ng-src=\"assets/images/logos/roche-logo-gray.png\"> <span class=\"logo-text\">\n©{{ vm.year }} Roche Diabetes Care</span> <span class=\"sub-logo-text\">Not available for sale in the US</span></div>");
$templateCache.put("app/main/qc-report/hospital/qcperformance/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_HOSPITAL.STATE\"></label><md-select name=\"state\" \nng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required>\n<md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_HOSPITAL.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_HOSPITAL.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"{{ vm.getSelectMetersIcon() }}\">\n</md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" \nng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button \nng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-accent\" \ntype=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_HOSPITAL.OK\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div class=\"widget-group\" layout=\"row\"><ms-widget ng-if=\"vm.loaded\" \nclass=\"animate-slide-right no-padding\" layout=\"column\" flex=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"h3 p-16\" translate=\"QC_REPORT_HOSPITAL_QCPERFORMANCE.PANEL_TITLE\"></div><md-divider></md-divider><div \nclass=\"p-16 text-center\"><p ng-if=\"vm.pieChart.data.length === 0\" class=\"hint-text font-weight-300\" \ntranslate=\"QC_REPORT_HOSPITAL_QCPERFORMANCE.NOT_ENOUGH_DATA\"></p><canvas ng-if=\"vm.pieChart.data.length > 0\" id=\"pie\" \nclass=\"chart chart-pie\" chart-data=\"vm.pieChart.data\" chart-labels=\"vm.pieChart.labels\" \nchart-options=\"vm.pieChart.options\" chart-dataset-override=\"vm.pieChart.datasetOverride\"></canvas></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/qc-report/hospital/sdchart/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_HOSPITAL.STATE\"></label><md-select name=\"state\" \nng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required>\n<md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_HOSPITAL.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_HOSPITAL.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"{{ vm.getSelectMetersIcon() }}\">\n</md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" \nng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button \nng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-accent\" \ntype=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_HOSPITAL.OK\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp no-margin\"><div \nlayout=\"row\" layout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_HOSPITAL.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" \nchart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/hospital/qcperformance/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_HOSPITAL.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_HOSPITAL.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"{{ vm.getSelectMetersIcon() }}\">\n</md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" \nng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button \nng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-accent\" \ntype=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_HOSPITAL.OK\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div class=\"widget-group\" layout=\"row\"><ms-widget ng-if=\"vm.loaded\" \nclass=\"animate-slide-right no-padding\" layout=\"column\" flex=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"h3 p-16\" translate=\"QC_REPORT_HOSPITAL_QCPERFORMANCE.PANEL_TITLE\"></div><md-divider></md-divider><div \nclass=\"p-16 text-center\"><p ng-if=\"vm.pieChart.data.length === 0\" class=\"hint-text font-weight-300\" \ntranslate=\"QC_REPORT_HOSPITAL_QCPERFORMANCE.NOT_ENOUGH_DATA\"></p><canvas ng-if=\"vm.pieChart.data.length > 0\" id=\"pie\" \nclass=\"chart chart-pie\" chart-data=\"vm.pieChart.data\" chart-labels=\"vm.pieChart.labels\" \nchart-options=\"vm.pieChart.options\" chart-dataset-override=\"vm.pieChart.datasetOverride\"></canvas></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/qc-report/hospital/qcperformance/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_HOSPITAL.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_HOSPITAL.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"{{ vm.getSelectMetersIcon() }}\">\n</md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" \nng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button \nng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-accent\" \ntype=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_HOSPITAL.OK\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div></form><div flex ng-if=\"vm.metersLoaded && vm.meters.length == 0\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div class=\"widget-group\" layout=\"row\">\n<ms-widget ng-if=\"vm.loaded\" class=\"animate-slide-right no-padding\" layout=\"column\" flex=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"h3 p-16\" translate=\"QC_REPORT_HOSPITAL_QCPERFORMANCE.PANEL_TITLE\"></div><md-divider>\n</md-divider><div class=\"p-16 text-center\"><p ng-if=\"vm.pieChart.data.length === 0\" class=\"hint-text font-weight-300\" \ntranslate=\"QC_REPORT_HOSPITAL_QCPERFORMANCE.NOT_ENOUGH_DATA\"></p><canvas ng-if=\"vm.pieChart.data.length > 0\" id=\"pie\" \nclass=\"chart chart-pie\" chart-data=\"vm.pieChart.data\" chart-labels=\"vm.pieChart.labels\" \nchart-options=\"vm.pieChart.options\" chart-dataset-override=\"vm.pieChart.datasetOverride\"></canvas></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/qc-report/hospital/sdchart/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_HOSPITAL.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_HOSPITAL.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"{{ vm.getSelectMetersIcon() }}\">\n</md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" \nng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button \nng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-accent\" \ntype=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_HOSPITAL.OK\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp no-margin\"><div \nlayout=\"row\" layout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_HOSPITAL.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" \nchart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/hospital/sdchart/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_HOSPITAL.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_HOSPITAL.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"{{ vm.getSelectMetersIcon() }}\">\n</md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" \nng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button \nng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-accent\" \ntype=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_HOSPITAL.OK\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div></form><div flex ng-if=\"vm.metersLoaded && vm.meters.length == 0\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp no-margin\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" aria-label=\"{{ \'QC_REPORT_HOSPITAL.ZOOM_TO_FIT\' | translate }}\" \nng-change=\"vm.changeZoom()\"><span translate=\"QC_REPORT_HOSPITAL.ZOOM_TO_FIT\"></span></md-switch></div><canvas \nid=\"chart\" class=\"chart chart-line\" chart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" \nchart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/multiple/combined/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE.STATE\"></label>\n<md-select ng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" \nng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" \nng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div><md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE.HOSPITAL\"></label><md-select\n ng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_MULTIPLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_MULTIPLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" \ntranslate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" aria-label=\"{{ \'QC_REPORT_MULTIPLE.ZOOM_TO_FIT\' | translate }}\" \nng-change=\"vm.changeZoom()\"><span translate=\"QC_REPORT_MULTIPLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas \nid=\"chart\" class=\"chart chart-line\" chart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" \nchart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/multiple/combined/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_MULTIPLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_MULTIPLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" \ntranslate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" aria-label=\"{{ \'QC_REPORT_MULTIPLE.ZOOM_TO_FIT\' | translate }}\" \nng-change=\"vm.changeZoom()\"><span translate=\"QC_REPORT_MULTIPLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas \nid=\"chart\" class=\"chart chart-line\" chart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" \nchart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/multiple/combined/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container flex><label translate=\"QC_REPORT_MULTIPLE.START_DATE\"></label><md-datepicker name=\"startDate\" \nng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"margin-horizontal-20\"><label translate=\"QC_REPORT_MULTIPLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" \ntranslate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><form name=\"vm.subFilterForm\" novalidate class=\"md-inline-form sub-filter-form\" \nlayout-align=\"start\"><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.STRIP_LOT\"></label><md-select multiple=\"multiple\" \nng-disabled=\"!vm.testStrips.length\" name=\"stripLot\" ng-model=\"vm.stripLot\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nmd-selected-text=\"vm.getStripLotText()\" ng-required=\"vm.testStrips.length\"><md-select-header layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-if=\"vm.stripLot.length === vm.testStrips.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = []\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.stripLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = vm.testStrips\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.stripLot.length && vm.stripLot.length !== vm.testStrips.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.stripLot = vm.testStrips\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-minus-box\"></md-icon></md-button><md-button class=\"md-accent\" type=\"button\" \nng-click=\"vm.stripLotChanged()\" translate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.OK\' | translate }}\"></md-button></md-select-header><md-option \nng-value=\"testStrip\" ng-repeat=\"testStrip in vm.testStrips\">{{ testStrip.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.stripLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block margin-horizontal-20\" flex><label \ntranslate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1\"></label><md-select multiple=\"multiple\" \nng-disabled=\"!vm.controlSolutions1.length\" name=\"controlLot1\" ng-model=\"vm.controlLot1\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLot1Text()\" \nng-required=\"vm.controlSolutions1.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button\n ng-if=\"vm.controlLot1.length === vm.controlSolutions1.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot1 = []\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.UN_SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot1.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot1 = vm.controlSolutions1\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot1.length && vm.controlLot1.length !== vm.controlSolutions1.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot1 = vm.controlSolutions1\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\">\n</md-icon></md-button><md-button class=\"md-accent\" type=\"button\" ng-click=\"vm.controlLot1Changed()\" \ntranslate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.OK\' | translate }}\"></md-button></md-select-header><md-option \nng-value=\"controlSolution\" ng-repeat=\"controlSolution in vm.controlSolutions1\">{{ controlSolution.lot_no }}</md-option>\n</md-select><div ng-messages=\"vm.subFilterForm.controlLot1.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2\">\n</label><md-select multiple=\"multiple\" ng-disabled=\"!vm.controlSolutions2.length\" name=\"controlLot2\" \nng-model=\"vm.controlLot2\" ng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLot2Text()\" \nng-required=\"vm.controlSolutions2.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button\n ng-if=\"vm.controlLot2.length === vm.controlSolutions2.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot2 = []\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.UN_SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot2.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot2 = vm.controlSolutions2\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot2.length && vm.controlLot2.length !== vm.controlSolutions2.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot2 = vm.controlSolutions2\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\">\n</md-icon></md-button><md-button class=\"md-accent\" type=\"button\" ng-click=\"vm.controlLot2Changed()\" \ntranslate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_COMBINED.FILTERS.OK\' | translate }}\"></md-button></md-select-header><md-option \nng-value=\"controlSolution\" ng-repeat=\"controlSolution in vm.controlSolutions2\">{{ controlSolution.lot_no }}</md-option>\n</md-select><div ng-messages=\"vm.subFilterForm.controlLot2.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE_COMBINED.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form>\n<div flex ng-if=\"vm.metersLoaded && vm.meters.length == 0\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" aria-label=\"{{ \'QC_REPORT_MULTIPLE.ZOOM_TO_FIT\' | translate }}\" \nng-change=\"vm.changeZoom()\"><span translate=\"QC_REPORT_MULTIPLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas \nid=\"chart\" class=\"chart chart-line\" chart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" \nchart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/multiple/level1/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE.STATE\"></label>\n<md-select ng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" \nng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" \nng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div><md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE.HOSPITAL\"></label><md-select\n ng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_MULTIPLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_MULTIPLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" aria-label=\"{{ \'QC_REPORT_MULTIPLE.ZOOM_TO_FIT\' | translate }}\" \nng-change=\"vm.changeZoom()\"><span translate=\"QC_REPORT_MULTIPLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas \nid=\"chart\" class=\"chart chart-line\" chart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" \nchart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/multiple/level1/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_MULTIPLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_MULTIPLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" aria-label=\"{{ \'QC_REPORT_MULTIPLE.ZOOM_TO_FIT\' | translate }}\" \nng-change=\"vm.changeZoom()\"><span translate=\"QC_REPORT_MULTIPLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas \nid=\"chart\" class=\"chart chart-line\" chart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" \nchart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/multiple/level1/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_MULTIPLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_MULTIPLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><form name=\"vm.subFilterForm\" novalidate class=\"md-inline-form sub-filter-form\" \nlayout-align=\"start\"><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.STRIP_LOT\"></label><md-select multiple=\"multiple\" \nng-disabled=\"!vm.testStrips.length\" name=\"stripLot\" ng-model=\"vm.stripLot\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nmd-selected-text=\"vm.getStripLotText()\" ng-required=\"vm.testStrips.length\"><md-select-header layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-if=\"vm.stripLot.length === vm.testStrips.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = []\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.stripLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = vm.testStrips\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.stripLot.length && vm.stripLot.length !== vm.testStrips.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.stripLot = vm.testStrips\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-minus-box\"></md-icon></md-button><md-button class=\"md-accent\" type=\"button\" \nng-click=\"vm.stripLotChanged()\" translate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.OK\' | translate }}\"></md-button></md-select-header><md-option \nng-value=\"testStrip\" ng-repeat=\"testStrip in vm.testStrips\">{{ testStrip.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.stripLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.CONTROL_LOT\">\n</label><md-select multiple=\"multiple\" ng-disabled=\"!vm.controlSolutions.length\" name=\"controlLot\" \nng-model=\"vm.controlLot\" ng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLotText()\" \nng-required=\"vm.controlSolutions.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.controlLot.length === vm.controlSolutions.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot = []\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon\n md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot = vm.controlSolutions\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot.length && vm.controlLot.length !== vm.controlSolutions.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot = vm.controlSolutions\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\">\n</md-icon></md-button><md-button class=\"md-accent\" type=\"button\" ng-click=\"vm.controlLotChanged()\" \ntranslate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.OK\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL1.FILTERS.OK\' | translate }}\">\n</md-button></md-select-header><md-option ng-value=\"controlSolution\" \nng-repeat=\"controlSolution in vm.controlSolutions\">{{ controlSolution.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.controlLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE_LEVEL1.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form>\n<div flex ng-if=\"vm.metersLoaded && vm.meters.length == 0\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" aria-label=\"{{ \'QC_REPORT_MULTIPLE.ZOOM_TO_FIT\' | translate }}\" \nng-change=\"vm.changeZoom()\"><span translate=\"QC_REPORT_MULTIPLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas \nid=\"chart\" class=\"chart chart-line\" chart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" \nchart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/multiple/logbook/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE.STATE\"></label>\n<md-select ng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" \nng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" \nng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div><md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE.HOSPITAL\"></label><md-select\n ng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_MULTIPLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_MULTIPLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.PANEL_TITLE\"></span><div flex></div></div></md-toolbar><md-table-container><table\n md-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" md-on-reorder=\"vm.getQCLogbook\"><tr md-row><th \nmd-column md-order-by=\"tested_on\"><span translate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.TEST_DATE_TIME\"></span></th><th \nmd-column><span translate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.METER_SERIAL\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.LOCATION\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STRIP_LOT\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.CONTROL_TYPE\"></span></th><th md-column md-numeric><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-numeric><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_VALUE\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STATUS\"></span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select ng-repeat=\"log in vm.qclogbook\"><td md-cell>{{ log.tested_on | date:\'yyyy-MM-dd hh:mma\' }}</td><td \nmd-cell>{{ log.meter.serial_no }}</td><td md-cell>{{ log.meter.location.code }}</td><td md-cell>\n{{ log.test_strip.lot_no }}</td><td md-cell>{{ log.control_level }}</td><td md-cell>\n{{ log.from | number:1 }}&nbsp;{{ \'QC_REPORT_MULTIPLE_LOGBOOK.TO\' | translate }}&nbsp;{{ log.to | number:1 }}</td><td \nmd-cell><span ng-if=\"log.source == \'upload\'\"><span ng-if=\"log.is_high\" class=\"red-fg\">HIGH</span><span \nng-if=\"log.is_low\" class=\"red-fg\">LOW</span><span ng-if=\"!log.is_high && !log.is_low\">\n{{ log.meter_reading | number:1 }}</span></span> <span ng-if=\"log.source == \'manual\'\"><sup>**</sup><span \nng-if=\"log.is_high\" class=\"red-fg\">HIGH</span><span ng-if=\"log.is_low\" class=\"red-fg\">LOW</span><span \nng-if=\"!log.is_high && !log.is_low\">{{ log.meter_reading | number:1 }}</span></span></td><td md-cell><span \nng-if=\"log.within_range\" class=\"text-boxed m-0 green-bg white-fg\" translate=\"QC_REPORT_MULTIPLE_LOGBOOK.WITHIN_RANGE\">\n</span> <span ng-if=\"!log.within_range\" class=\"text-boxed m-0 red-bg white-fg\" \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.OUTSIDE_RANGE\"></span></td></tr><tr md-row ng-if=\"vm.hasManualQcData\"><td \nmd-cell colspan=\"7\"><div class=\"text-semibold text-italic\">**<span translate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.PS\">\n</span></div></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" \nmd-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" \nmd-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getQCLogbook\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/qc-report/multiple/logbook/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_MULTIPLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_MULTIPLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.PANEL_TITLE\"></span><div flex></div></div></md-toolbar><md-table-container><table\n md-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" md-on-reorder=\"vm.getQCLogbook\"><tr md-row><th \nmd-column md-order-by=\"tested_on\"><span translate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.TEST_DATE_TIME\"></span></th><th \nmd-column><span translate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.METER_SERIAL\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.LOCATION\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STRIP_LOT\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.CONTROL_TYPE\"></span></th><th md-column md-numeric><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-numeric><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_VALUE\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STATUS\"></span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select ng-repeat=\"log in vm.qclogbook\"><td md-cell>{{ log.tested_on | date:\'yyyy-MM-dd hh:mma\' }}</td><td \nmd-cell>{{ log.meter.serial_no }}</td><td md-cell>{{ log.meter.location.code }}</td><td md-cell>\n{{ log.test_strip.lot_no }}</td><td md-cell>{{ log.control_level }}</td><td md-cell>\n{{ log.from | number:1 }}&nbsp;{{ \'QC_REPORT_MULTIPLE_LOGBOOK.TO\' | translate }}&nbsp;{{ log.to | number:1 }}</td><td \nmd-cell><span ng-if=\"log.source == \'upload\'\"><span ng-if=\"log.is_high\" class=\"red-fg\">HIGH</span><span \nng-if=\"log.is_low\" class=\"red-fg\">LOW</span><span ng-if=\"!log.is_high && !log.is_low\">\n{{ log.meter_reading | number:1 }}</span></span> <span ng-if=\"log.source == \'manual\'\"><sup>**</sup><span \nng-if=\"log.is_high\" class=\"red-fg\">HIGH</span><span ng-if=\"log.is_low\" class=\"red-fg\">LOW</span><span \nng-if=\"!log.is_high && !log.is_low\">{{ log.meter_reading | number:1 }}</span></span></td><td md-cell><span \nng-if=\"log.within_range\" class=\"text-boxed m-0 green-bg white-fg\" translate=\"QC_REPORT_MULTIPLE_LOGBOOK.WITHIN_RANGE\">\n</span> <span ng-if=\"!log.within_range\" class=\"text-boxed m-0 red-bg white-fg\" \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.OUTSIDE_RANGE\"></span></td></tr><tr md-row ng-if=\"vm.hasManualQcData\"><td \nmd-cell colspan=\"7\"><div class=\"text-semibold text-italic\">**<span translate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.PS\">\n</span></div></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" \nmd-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" \nmd-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getQCLogbook\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/qc-report/multiple/logbook/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container flex><label translate=\"QC_REPORT_MULTIPLE.START_DATE\"></label><md-datepicker name=\"startDate\" \nng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"margin-horizontal-20\"><label translate=\"QC_REPORT_MULTIPLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><form name=\"vm.subFilterForm\" novalidate class=\"md-inline-form sub-filter-form\" \nlayout-align=\"start\"><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.STRIP_LOT\"></label><md-select multiple=\"multiple\" \nng-disabled=\"!vm.testStrips.length\" name=\"stripLot\" ng-model=\"vm.stripLot\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nmd-selected-text=\"vm.getStripLotText()\" ng-required=\"vm.testStrips.length\"><md-select-header layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-if=\"vm.stripLot.length === vm.testStrips.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = []\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.stripLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = vm.testStrips\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.stripLot.length && vm.stripLot.length !== vm.testStrips.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.stripLot = vm.testStrips\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-minus-box\"></md-icon></md-button><md-button class=\"md-accent\" type=\"button\" \nng-click=\"vm.stripLotChanged()\" translate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.OK\' | translate }}\"></md-button></md-select-header><md-option \nng-value=\"testStrip\" ng-repeat=\"testStrip in vm.testStrips\">{{ testStrip.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.stripLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block margin-horizontal-20\" flex><label \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1\"></label><md-select multiple=\"multiple\" \nng-disabled=\"!vm.controlSolutions1.length\" name=\"controlLot1\" ng-model=\"vm.controlLot1\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLot1Text()\" \nng-required=\"vm.controlSolutions1.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button\n ng-if=\"vm.controlLot1.length === vm.controlSolutions1.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot1 = []\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.UN_SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot1.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot1 = vm.controlSolutions1\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot1.length && vm.controlLot1.length !== vm.controlSolutions1.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot1 = vm.controlSolutions1\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\">\n</md-icon></md-button><md-button class=\"md-accent\" type=\"button\" ng-click=\"vm.controlLot1Changed()\" \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.OK\' | translate }}\"></md-button></md-select-header><md-option \nng-value=\"controlSolution\" ng-repeat=\"controlSolution in vm.controlSolutions1\">{{ controlSolution.lot_no }}</md-option>\n</md-select><div ng-messages=\"vm.subFilterForm.controlLot1.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2\">\n</label><md-select multiple=\"multiple\" ng-disabled=\"!vm.controlSolutions2.length\" name=\"controlLot2\" \nng-model=\"vm.controlLot2\" ng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLot2Text()\" \nng-required=\"vm.controlSolutions2.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button\n ng-if=\"vm.controlLot2.length === vm.controlSolutions2.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot2 = []\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.UN_SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot2.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot2 = vm.controlSolutions2\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot2.length && vm.controlLot2.length !== vm.controlSolutions2.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot2 = vm.controlSolutions2\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.OK\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\">\n</md-icon></md-button><md-button class=\"md-accent\" type=\"button\" ng-click=\"vm.controlLot2Changed()\" \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.OK\' | translate }}\"></md-button></md-select-header><md-option \nng-value=\"controlSolution\" ng-repeat=\"controlSolution in vm.controlSolutions2\">{{ controlSolution.lot_no }}</md-option>\n</md-select><div ng-messages=\"vm.subFilterForm.controlLot2.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form>\n<div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.PANEL_TITLE\"></span><div flex></div></div></md-toolbar><md-table-container><table\n md-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" md-on-reorder=\"vm.getQCLogbook\"><tr md-row><th \nmd-column md-order-by=\"tested_on\"><span translate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.TEST_DATE_TIME\"></span></th><th \nmd-column><span translate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.METER_SERIAL\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.LOCATION\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STRIP_LOT\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.CONTROL_TYPE\"></span></th><th md-column md-numeric><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-numeric><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.QC_VALUE\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.STATUS\"></span></th><th md-column ng-if=\"!vm.isReadOnly\"><span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS\"></span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select ng-repeat=\"log in vm.qclogbook\" ng-class=\"{ grayout: log.is_deleted }\"><td md-cell>\n{{ log.tested_on | date:\'yyyy-MM-dd hh:mma\' }}</td><td md-cell>{{ log.meter.serial_no }}</td><td md-cell>\n{{ log.meter.location.code }}</td><td md-cell>{{ log.test_strip.lot_no }}</td><td md-cell>{{ log.control_level }}</td>\n<td md-cell>\n{{ log.from | number:1 }}&nbsp;{{ \'QC_REPORT_MULTIPLE_LOGBOOK.TO\' | translate }}&nbsp;{{ log.to | number:1 }}</td><td \nmd-cell><span ng-if=\"log.source == \'upload\'\"><span class=\"qc-data\" \nng-click=\"!log.is_deleted && vm.editQcData(log, $event)\"><span ng-if=\"log.is_high\" class=\"red-fg\">HIGH</span><span \nng-if=\"log.is_low\" class=\"red-fg\">LOW</span><span ng-if=\"!log.is_high && !log.is_low\">\n{{ log.meter_reading | number:1 }}</span></span></span> <span ng-if=\"log.source == \'manual\'\"><sup>**</sup><span \nclass=\"qc-data\" ng-click=\"!log.is_deleted && vm.editQcData(log, $event)\"><span ng-if=\"log.is_high\" class=\"red-fg\">HIGH\n</span><span ng-if=\"log.is_low\" class=\"red-fg\">LOW</span><span ng-if=\"!log.is_high && !log.is_low\">\n{{ log.meter_reading | number:1 }}</span></span></span></td><td md-cell><span ng-if=\"log.within_range\" \nclass=\"text-boxed m-0 green-bg white-fg\" translate=\"QC_REPORT_MULTIPLE_LOGBOOK.WITHIN_RANGE\"></span> <span \nng-if=\"!log.within_range\" class=\"text-boxed m-0 red-bg white-fg\" translate=\"QC_REPORT_MULTIPLE_LOGBOOK.OUTSIDE_RANGE\">\n</span></td><td md-cell ng-if=\"!vm.isReadOnly\"><md-button class=\"font-size-12 font-weight-300 text-lowercase\" \nng-if=\"log.hospital_operator\" ng-click=\"vm.changeOperator(log, $event)\" ng-disabled=\"log.is_deleted\"><span \nclass=\"text-uppercase\">{{ log.hospital_operator.initials}}</span></md-button><md-button \nclass=\"font-size-12 font-weight-300 text-lowercase md-accent\" ng-if=\"!log.hospital_operator\" \nng-click=\"vm.changeOperator(log, $event)\" ng-disabled=\"log.is_deleted\" \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.TAG_OPERATOR\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LOGBOOK.TAG_OPERATOR\' | translate }}\"></md-button></td></tr><tr md-row \nng-if=\"vm.hasManualQcData\"><td md-cell colspan=\"7\"><div class=\"text-semibold text-italic\">**<span \ntranslate=\"QC_REPORT_MULTIPLE_LOGBOOK.COLUMNS.PS\"></span></div></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.pagination.per_page\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" md-total=\"{{ vm.pagination.total }}\" \nmd-on-paginate=\"vm.getQCLogbook\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/qc-report/multiple/level2/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_MULTIPLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_MULTIPLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" aria-label=\"{{ \'QC_REPORT_MULTIPLE.ZOOM_TO_FIT\' | translate }}\" \nng-change=\"vm.changeZoom()\"><span translate=\"QC_REPORT_MULTIPLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas \nid=\"chart\" class=\"chart chart-line\" chart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" \nchart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/multiple/level2/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE.STATE\"></label>\n<md-select ng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" \nng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" \nng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div><md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE.HOSPITAL\"></label><md-select\n ng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_MULTIPLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_MULTIPLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" aria-label=\"{{ \'QC_REPORT_MULTIPLE.ZOOM_TO_FIT\' | translate }}\" \nng-change=\"vm.changeZoom()\"><span translate=\"QC_REPORT_MULTIPLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas \nid=\"chart\" class=\"chart chart-line\" chart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" \nchart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/multiple/level2/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_MULTIPLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_MULTIPLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"{{ vm.getSelectMetersIcon() }}\"></md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button \nclass=\"md-accent\" type=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div>\n</md-input-container></div></form><form name=\"vm.subFilterForm\" novalidate class=\"md-inline-form sub-filter-form\" \nlayout-align=\"start\"><div layout=\"row\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.STRIP_LOT\"></label><md-select multiple=\"multiple\" \nng-disabled=\"!vm.testStrips.length\" name=\"stripLot\" ng-model=\"vm.stripLot\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nmd-selected-text=\"vm.getStripLotText()\" ng-required=\"vm.testStrips.length\"><md-select-header layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-if=\"vm.stripLot.length === vm.testStrips.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = []\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.stripLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = vm.testStrips\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.stripLot.length && vm.stripLot.length !== vm.testStrips.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.stripLot = vm.testStrips\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-minus-box\"></md-icon></md-button><md-button class=\"md-accent\" type=\"button\" \nng-click=\"vm.stripLotChanged()\" translate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.OK\' | translate }}\"></md-button></md-select-header><md-option \nng-value=\"testStrip\" ng-repeat=\"testStrip in vm.testStrips\">{{ testStrip.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.stripLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.CONTROL_LOT\">\n</label><md-select multiple=\"multiple\" ng-disabled=\"!vm.controlSolutions.length\" name=\"controlLot\" \nng-model=\"vm.controlLot\" ng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLotText()\" \nng-required=\"vm.controlSolutions.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.controlLot.length === vm.controlSolutions.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot = []\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon\n md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot = vm.controlSolutions\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot.length && vm.controlLot.length !== vm.controlSolutions.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot = vm.controlSolutions\" \naria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\">\n</md-icon></md-button><md-button class=\"md-accent\" type=\"button\" ng-click=\"vm.controlLotChanged()\" \ntranslate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.OK\" aria-label=\"{{ \'QC_REPORT_MULTIPLE_LEVEL2.FILTERS.OK\' | translate }}\">\n</md-button></md-select-header><md-option ng-value=\"controlSolution\" \nng-repeat=\"controlSolution in vm.controlSolutions\">{{ controlSolution.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.controlLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE_LEVEL2.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form>\n<div flex ng-if=\"vm.metersLoaded && vm.meters.length == 0\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_MULTIPLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" aria-label=\"{{ \'QC_REPORT_MULTIPLE.ZOOM_TO_FIT\' | translate }}\" \nng-change=\"vm.changeZoom()\"><span translate=\"QC_REPORT_MULTIPLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas \nid=\"chart\" class=\"chart chart-line\" chart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" \nchart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/mfr-control-limits/level1/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.STATE\"></label>\n<md-select ng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" \nng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" \nng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_SINGLE.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_SINGLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\">\n</canvas></div>");
$templateCache.put("app/main/qc-report/mfr-control-limits/level1/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_SINGLE.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_SINGLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\">\n</canvas></div>");
$templateCache.put("app/main/qc-report/mfr-control-limits/level1/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_MFR_CONTROL_LIMITS.START_DATE\"></label>\n<md-datepicker name=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required \nmd-hide-icons=\"calendar\"></md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nflex class=\"ml-20\"><label translate=\"QC_REPORT_MFR_CONTROL_LIMITS.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO\">\n</label><md-select md-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><form \nname=\"vm.subFilterForm\" novalidate class=\"md-inline-form sub-filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.STRIP_LOT\">\n</label><md-select multiple=\"multiple\" ng-disabled=\"!vm.testStrips.length\" name=\"stripLot\" ng-model=\"vm.stripLot\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getStripLotText()\" ng-required=\"vm.testStrips.length\">\n<md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.stripLot.length === vm.testStrips.length\" class=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = []\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.stripLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = vm.testStrips\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.stripLot.length && vm.stripLot.length !== vm.testStrips.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.stripLot = vm.testStrips\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-minus-box\"></md-icon></md-button><md-button class=\"md-accent\" type=\"button\" \nng-click=\"vm.stripLotChanged()\" translate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.OK\' | translate }}\"></md-button></md-select-header>\n<md-option ng-value=\"testStrip\" ng-repeat=\"testStrip in vm.testStrips\">{{ testStrip.lot_no }}</md-option></md-select>\n<div ng-messages=\"vm.subFilterForm.stripLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block ml-20\" flex><label \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.CONTROL_LOT\"></label><md-select multiple=\"multiple\" \nng-disabled=\"!vm.controlSolutions.length\" name=\"controlLot\" ng-model=\"vm.controlLot\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLotText()\" \nng-required=\"vm.controlSolutions.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.controlLot.length === vm.controlSolutions.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot = []\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot = vm.controlSolutions\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot.length && vm.controlLot.length !== vm.controlSolutions.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot = vm.controlSolutions\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-minus-box\"></md-icon></md-button><md-button class=\"md-accent\" type=\"button\" \nng-click=\"vm.controlLotChanged()\" translate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.OK\' | translate }}\"></md-button></md-select-header>\n<md-option ng-value=\"controlSolution\" ng-repeat=\"controlSolution in vm.controlSolutions\">{{ controlSolution.lot_no }}\n</md-option></md-select><div ng-messages=\"vm.subFilterForm.controlLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL1.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div>\n</form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" \nclass=\"chart chart-line\" chart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" \nchart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/mfr-control-limits/level2/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.STATE\"></label>\n<md-select ng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" \nng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" \nng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_SINGLE.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_SINGLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\">\n</canvas></div>");
$templateCache.put("app/main/qc-report/mfr-control-limits/level2/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_SINGLE.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_SINGLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\">\n</canvas></div>");
$templateCache.put("app/main/qc-report/mfr-control-limits/level2/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_MFR_CONTROL_LIMITS.START_DATE\"></label>\n<md-datepicker name=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required \nmd-hide-icons=\"calendar\"></md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nflex class=\"ml-20\"><label translate=\"QC_REPORT_MFR_CONTROL_LIMITS.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_MFR_CONTROL_LIMITS.METER_SERIAL_NO\">\n</label><md-select md-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><form \nname=\"vm.subFilterForm\" novalidate class=\"md-inline-form sub-filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.STRIP_LOT\">\n</label><md-select multiple=\"multiple\" ng-disabled=\"!vm.testStrips.length\" name=\"stripLot\" ng-model=\"vm.stripLot\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getStripLotText()\" ng-required=\"vm.testStrips.length\">\n<md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.stripLot.length === vm.testStrips.length\" class=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = []\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.stripLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = vm.testStrips\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.stripLot.length && vm.stripLot.length !== vm.testStrips.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.stripLot = vm.testStrips\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-minus-box\"></md-icon></md-button><md-button class=\"md-accent\" type=\"button\" \nng-click=\"vm.stripLotChanged()\" translate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.OK\' | translate }}\"></md-button></md-select-header>\n<md-option ng-value=\"testStrip\" ng-repeat=\"testStrip in vm.testStrips\">{{ testStrip.lot_no }}</md-option></md-select>\n<div ng-messages=\"vm.subFilterForm.stripLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block ml-20\" flex><label \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.CONTROL_LOT\"></label><md-select multiple=\"multiple\" \nng-disabled=\"!vm.controlSolutions.length\" name=\"controlLot\" ng-model=\"vm.controlLot\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLotText()\" \nng-required=\"vm.controlSolutions.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.controlLot.length === vm.controlSolutions.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot = []\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot = vm.controlSolutions\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot.length && vm.controlLot.length !== vm.controlSolutions.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot = vm.controlSolutions\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-minus-box\"></md-icon></md-button><md-button class=\"md-accent\" type=\"button\" \nng-click=\"vm.controlLotChanged()\" translate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.OK\' | translate }}\"></md-button></md-select-header>\n<md-option ng-value=\"controlSolution\" ng-repeat=\"controlSolution in vm.controlSolutions\">{{ controlSolution.lot_no }}\n</md-option></md-select><div ng-messages=\"vm.subFilterForm.controlLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS_LEVEL2.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div>\n</form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_MFR_CONTROL_LIMITS.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_MFR_CONTROL_LIMITS.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" \nclass=\"chart chart-line\" chart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" \nchart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/single/combined/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.STATE\"></label>\n<md-select ng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" \nng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" \nng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_SINGLE.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_SINGLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\">\n</canvas></div>");
$templateCache.put("app/main/qc-report/single/combined/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_SINGLE.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_SINGLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\">\n</canvas></div>");
$templateCache.put("app/main/qc-report/single/combined/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker name=\"startDate\" \nng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"margin-horizontal-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><form \nname=\"vm.subFilterForm\" novalidate class=\"md-inline-form sub-filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE_COMBINED.FILTERS.STRIP_LOT\"></label>\n<md-select multiple=\"multiple\" ng-disabled=\"!vm.testStrips.length\" name=\"stripLot\" ng-model=\"vm.stripLot\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getStripLotText()\" ng-required=\"vm.testStrips.length\">\n<md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.stripLot.length === vm.testStrips.length\" class=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = []\" \naria-label=\"{{ \'QC_REPORT_SINGLE_COMBINED.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.stripLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = vm.testStrips\" \naria-label=\"{{ \'QC_REPORT_SINGLE_COMBINED.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.stripLot.length && vm.stripLot.length !== vm.testStrips.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.stripLot = vm.testStrips\" aria-label=\"{{ \'QC_REPORT_SINGLE_COMBINED.FILTERS.SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-minus-box\"></md-icon></md-button><md-button class=\"md-accent\" type=\"button\" \nng-click=\"vm.stripLotChanged()\" translate=\"QC_REPORT_SINGLE_COMBINED.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_SINGLE_COMBINED.FILTERS.OK\' | translate }}\"></md-button></md-select-header><md-option \nng-value=\"testStrip\" ng-repeat=\"testStrip in vm.testStrips\">{{ testStrip.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.stripLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE_COMBINED.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block margin-horizontal-20\" flex><label \ntranslate=\"QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL1\"></label><md-select multiple=\"multiple\" \nng-disabled=\"!vm.controlSolutions1.length\" name=\"controlLot1\" ng-model=\"vm.controlLot1\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLot1Text()\" \nng-required=\"vm.controlSolutions1.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button\n ng-if=\"vm.controlLot1.length === vm.controlSolutions1.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot1 = []\" aria-label=\"{{ \'QC_REPORT_SINGLE_COMBINED.FILTERS.UN_SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot1.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot1 = vm.controlSolutions1\" \naria-label=\"{{ \'QC_REPORT_SINGLE_COMBINED.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot1.length && vm.controlLot1.length !== vm.controlSolutions1.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot1 = vm.controlSolutions1\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\">\n</md-icon></md-button><md-button class=\"md-accent\" type=\"button\" ng-click=\"vm.controlLot1Changed()\" \ntranslate=\"QC_REPORT_SINGLE_COMBINED.FILTERS.OK\" aria-label=\"{{ \'QC_REPORT_SINGLE_COMBINED.FILTERS.OK\' | translate }}\">\n</md-button></md-select-header><md-option ng-value=\"controlSolution\" \nng-repeat=\"controlSolution in vm.controlSolutions1\">{{ controlSolution.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.controlLot1.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE_COMBINED.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE_COMBINED.FILTERS.CONTROL_LOT_LEVEL2\">\n</label><md-select multiple=\"multiple\" ng-disabled=\"!vm.controlSolutions2.length\" name=\"controlLot2\" \nng-model=\"vm.controlLot2\" ng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLot2Text()\" \nng-required=\"vm.controlSolutions2.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button\n ng-if=\"vm.controlLot2.length === vm.controlSolutions2.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot2 = []\" aria-label=\"{{ \'QC_REPORT_SINGLE_COMBINED.FILTERS.UN_SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot2.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot2 = vm.controlSolutions2\" \naria-label=\"{{ \'QC_REPORT_SINGLE_COMBINED.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot2.length && vm.controlLot2.length !== vm.controlSolutions2.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot2 = vm.controlSolutions2\" \naria-label=\"{{ \'QC_REPORT_SINGLE_COMBINED.FILTERS.OK\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\"></md-icon>\n</md-button><md-button class=\"md-accent\" type=\"button\" ng-click=\"vm.controlLot2Changed()\" \ntranslate=\"QC_REPORT_SINGLE_COMBINED.FILTERS.OK\" aria-label=\"{{ \'QC_REPORT_SINGLE_COMBINED.FILTERS.OK\' | translate }}\">\n</md-button></md-select-header><md-option ng-value=\"controlSolution\" \nng-repeat=\"controlSolution in vm.controlSolutions2\">{{ controlSolution.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.controlLot2.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE_COMBINED.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form>\n<div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_SINGLE.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_SINGLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\">\n</canvas></div>");
$templateCache.put("app/main/qc-report/single/level1/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.STATE\"></label>\n<md-select ng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" \nng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" \nng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_SINGLE.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_SINGLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\">\n</canvas></div>");
$templateCache.put("app/main/qc-report/single/level1/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_SINGLE.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_SINGLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\">\n</canvas></div>");
$templateCache.put("app/main/qc-report/single/level1/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><form \nname=\"vm.subFilterForm\" novalidate class=\"md-inline-form sub-filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE_LEVEL1.FILTERS.STRIP_LOT\"></label>\n<md-select multiple=\"multiple\" ng-disabled=\"!vm.testStrips.length\" name=\"stripLot\" ng-model=\"vm.stripLot\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getStripLotText()\" ng-required=\"vm.testStrips.length\">\n<md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.stripLot.length === vm.testStrips.length\" class=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = []\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL1.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.stripLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = vm.testStrips\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.stripLot.length && vm.stripLot.length !== vm.testStrips.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.stripLot = vm.testStrips\" aria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-minus-box\"></md-icon></md-button><md-button class=\"md-accent\" type=\"button\" \nng-click=\"vm.stripLotChanged()\" translate=\"QC_REPORT_SINGLE_LEVEL1.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL1.FILTERS.OK\' | translate }}\"></md-button></md-select-header><md-option \nng-value=\"testStrip\" ng-repeat=\"testStrip in vm.testStrips\">{{ testStrip.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.stripLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE_LEVEL1.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE_LEVEL1.FILTERS.CONTROL_LOT\"></label>\n<md-select multiple=\"multiple\" ng-disabled=\"!vm.controlSolutions.length\" name=\"controlLot\" ng-model=\"vm.controlLot\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLotText()\" \nng-required=\"vm.controlSolutions.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.controlLot.length === vm.controlSolutions.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot = []\" aria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL1.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot = vm.controlSolutions\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot.length && vm.controlLot.length !== vm.controlSolutions.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot = vm.controlSolutions\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL1.FILTERS.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\">\n</md-icon></md-button><md-button class=\"md-accent\" type=\"button\" ng-click=\"vm.controlLotChanged()\" \ntranslate=\"QC_REPORT_SINGLE_LEVEL1.FILTERS.OK\" aria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL1.FILTERS.OK\' | translate }}\">\n</md-button></md-select-header><md-option ng-value=\"controlSolution\" \nng-repeat=\"controlSolution in vm.controlSolutions\">{{ controlSolution.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.controlLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE_LEVEL1.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div \nflex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_SINGLE.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_SINGLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\">\n</canvas></div>");
$templateCache.put("app/main/qc-report/single/level2/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.STATE\"></label>\n<md-select ng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" \nng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" \nng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_SINGLE.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_SINGLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\">\n</canvas></div>");
$templateCache.put("app/main/qc-report/single/level2/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_SINGLE.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_SINGLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\">\n</canvas></div>");
$templateCache.put("app/main/qc-report/single/level2/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><form \nname=\"vm.subFilterForm\" novalidate class=\"md-inline-form sub-filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE_LEVEL2.FILTERS.STRIP_LOT\"></label>\n<md-select multiple=\"multiple\" ng-disabled=\"!vm.testStrips.length\" name=\"stripLot\" ng-model=\"vm.stripLot\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getStripLotText()\" ng-required=\"vm.testStrips.length\">\n<md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.stripLot.length === vm.testStrips.length\" class=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = []\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL2.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.stripLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = vm.testStrips\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.stripLot.length && vm.stripLot.length !== vm.testStrips.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.stripLot = vm.testStrips\" aria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-minus-box\"></md-icon></md-button><md-button class=\"md-accent\" type=\"button\" \nng-click=\"vm.stripLotChanged()\" translate=\"QC_REPORT_SINGLE_LEVEL2.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL2.FILTERS.OK\' | translate }}\"></md-button></md-select-header><md-option \nng-value=\"testStrip\" ng-repeat=\"testStrip in vm.testStrips\">{{ testStrip.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.stripLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE_LEVEL2.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE_LEVEL2.FILTERS.CONTROL_LOT\"></label>\n<md-select multiple=\"multiple\" ng-disabled=\"!vm.controlSolutions.length\" name=\"controlLot\" ng-model=\"vm.controlLot\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLotText()\" \nng-required=\"vm.controlSolutions.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.controlLot.length === vm.controlSolutions.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot = []\" aria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL2.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot = vm.controlSolutions\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot.length && vm.controlLot.length !== vm.controlSolutions.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot = vm.controlSolutions\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL2.FILTERS.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\">\n</md-icon></md-button><md-button class=\"md-accent\" type=\"button\" ng-click=\"vm.controlLotChanged()\" \ntranslate=\"QC_REPORT_SINGLE_LEVEL2.FILTERS.OK\" aria-label=\"{{ \'QC_REPORT_SINGLE_LEVEL2.FILTERS.OK\' | translate }}\">\n</md-button></md-select-header><md-option ng-value=\"controlSolution\" \nng-repeat=\"controlSolution in vm.controlSolutions\">{{ controlSolution.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.controlLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE_LEVEL2.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div \nflex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp\"><div layout=\"row\" \nlayout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_SINGLE.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_SINGLE.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\">\n</canvas></div>");
$templateCache.put("app/main/qc-report/single/logbook/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.STATE\"></label>\n<md-select ng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" \nng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" \nng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div>\n<md-input-container class=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-10 simple-table-container md-whiteframe-1dp\"><md-table-container><table md-table><thead \nmd-head><tr md-row><th md-column><span translate=\"QC_REPORT_SINGLE_LOGBOOK.METER.METER_MODEL\"></span></th><th \nmd-column><span translate=\"QC_REPORT_SINGLE_LOGBOOK.METER.HOSPITAL\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.METER.LOCATION_CODE\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.METER.PERSON_IN_CHARGE\"></span></th></tr></thead><tbody md-body><tr md-row \ndisabled=\"disabled\"><td md-cell>{{ vm.meter.model_no }}</td><td md-cell>{{ vm.meter.location.hospital.name }}</td><td \nmd-cell>{{ vm.meter.location.code }}</td><td md-cell>{{ vm.meter.location.person_in_charge }}</td></tr></tbody><tfoot>\n<tr><td></td></tr></tfoot></table></md-table-container></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-table-container><table md-table><thead \nmd-head><tr md-row><th md-column><span translate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.TITLE\"></span></th><th md-column \nmd-numeric>Level 1</th><th md-column md-numeric>Level 2</th></tr></thead><tbody md-body><tr md-row disabled=\"disabled\">\n<td md-cell><span translate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.NO_OF_TESTS\"></span></td><td md-cell>\n{{ vm.overall[\'Level 1\'] ? vm.overall[\'Level 1\'].number_of_tests : 0 }}</td><td md-cell>\n{{ vm.overall[\'Level 2\'] ? vm.overall[\'Level 2\'].number_of_tests : 0 }}</td></tr><tr md-row disabled=\"disabled\"><td \nmd-cell><span translate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.MEAN\"></span>\n ({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</td><td md-cell><span ng-if=\"vm.overall[\'Level 1\']\">\n{{ vm.overall[\'Level 1\'].mean | number:2 }}</span></td><td md-cell><span ng-if=\"vm.overall[\'Level 2\']\">\n{{ vm.overall[\'Level 2\'].mean | number:2 }}</span></td></tr><tr md-row disabled=\"disabled\"><td md-cell><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.SD\"></span> ({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})\n</td><td md-cell><span ng-if=\"vm.overall[\'Level 1\'] && vm.overall[\'Level 1\'].stdev != null\">\n{{ vm.overall[\'Level 1\'].stdev | number:2 }}</span></td><td md-cell><span \nng-if=\"vm.overall[\'Level 2\'] && vm.overall[\'Level 2\'].stdev != null\">{{ vm.overall[\'Level 2\'].stdev | number:2 }}\n</span></td></tr><tr md-row disabled=\"disabled\"><td md-cell><span translate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.CV\">\n</span></td><td md-cell><span ng-if=\"vm.overall[\'Level 1\'] && vm.overall[\'Level 1\'].cv != null\">\n{{ vm.overall[\'Level 1\'].cv | number:2 }}*</span></td><td md-cell><span \nng-if=\"vm.overall[\'Level 2\'] && vm.overall[\'Level 2\'].cv != null\">{{ vm.overall[\'Level 2\'].cv | number:2 }}</span></td>\n</tr><tr md-row disabled=\"disabled\"><td md-cell colspan=\"3\"><div class=\"text-semibold text-italic\" \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.PS\"></div></td></tr></tbody><tfoot><tr><td></td></tr></tfoot></table>\n</md-table-container></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.PANEL_TITLE\"></span><div flex></div></div></md-toolbar><md-table-container><table \nmd-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" md-on-reorder=\"vm.getQCLogbook\"><tr md-row><th \nmd-column md-order-by=\"tested_on\"><span translate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.TEST_DATE_TIME\"></span></th><th \nmd-column><span translate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STRIP_LOT\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.CONTROL_TYPE\"></span></th><th md-column md-numeric><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-numeric><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_VALUE\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STATUS\"></span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nng-repeat=\"log in vm.qclogbook\"><td md-cell>{{ log.tested_on | date:\'yyyy-MM-dd hh:mma\' }}</td><td md-cell>\n{{ log.test_strip.lot_no }}</td><td md-cell>{{ log.control_level }}</td><td md-cell>\n{{ log.from | number:1 }}&nbsp;{{ \'QC_REPORT_SINGLE_LOGBOOK.TO\' | translate }}&nbsp;{{ log.to | number:1 }}</td><td \nmd-cell><span ng-if=\"log.source == \'upload\'\"><span ng-if=\"log.is_high\" class=\"red-fg\">HIGH</span><span \nng-if=\"log.is_low\" class=\"red-fg\">LOW</span><span ng-if=\"!log.is_high && !log.is_low\">\n{{ log.meter_reading | number:1 }}</span></span> <span ng-if=\"log.source == \'manual\'\"><sup>**</sup><span \nng-if=\"log.is_high\" class=\"red-fg\">HIGH</span><span ng-if=\"log.is_low\" class=\"red-fg\">LOW</span><span \nng-if=\"!log.is_high && !log.is_low\">{{ log.meter_reading | number:1 }}</span></span></td><td md-cell><span \nng-if=\"log.within_range\" class=\"text-boxed m-0 green-bg white-fg\" translate=\"QC_REPORT_SINGLE_LOGBOOK.WITHIN_RANGE\">\n</span> <span ng-if=\"!log.within_range\" class=\"text-boxed m-0 red-bg white-fg\" \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.OUTSIDE_RANGE\"></span></td></tr><tr md-row ng-if=\"vm.hasManualQcData\"><td md-cell \ncolspan=\"7\"><div class=\"text-semibold text-italic\">**<span translate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.PS\"></span>\n</div></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" \nmd-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" \nmd-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getQCLogbook\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/qc-report/single/logbook/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" ng-model=\"vm.endDate\" \nmd-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div flex \nng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-10 simple-table-container md-whiteframe-1dp\"><md-table-container><table md-table><thead \nmd-head><tr md-row><th md-column><span translate=\"QC_REPORT_SINGLE_LOGBOOK.METER.METER_MODEL\"></span></th><th \nmd-column><span translate=\"QC_REPORT_SINGLE_LOGBOOK.METER.HOSPITAL\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.METER.LOCATION_CODE\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.METER.PERSON_IN_CHARGE\"></span></th></tr></thead><tbody md-body><tr md-row \ndisabled=\"disabled\"><td md-cell>{{ vm.meter.model_no }}</td><td md-cell>{{ vm.meter.location.hospital.name }}</td><td \nmd-cell>{{ vm.meter.location.code }}</td><td md-cell>{{ vm.meter.location.person_in_charge }}</td></tr></tbody><tfoot>\n<tr><td></td></tr></tfoot></table></md-table-container></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-table-container><table md-table><thead \nmd-head><tr md-row><th md-column><span translate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.TITLE\"></span></th><th md-column \nmd-numeric>Level 1</th><th md-column md-numeric>Level 2</th></tr></thead><tbody md-body><tr md-row disabled=\"disabled\">\n<td md-cell><span translate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.NO_OF_TESTS\"></span></td><td md-cell>\n{{ vm.overall[\'Level 1\'] ? vm.overall[\'Level 1\'].number_of_tests : 0 }}</td><td md-cell>\n{{ vm.overall[\'Level 2\'] ? vm.overall[\'Level 2\'].number_of_tests : 0 }}</td></tr><tr md-row disabled=\"disabled\"><td \nmd-cell><span translate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.MEAN\"></span>\n ({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</td><td md-cell><span ng-if=\"vm.overall[\'Level 1\']\">\n{{ vm.overall[\'Level 1\'].mean | number:2 }}</span></td><td md-cell><span ng-if=\"vm.overall[\'Level 2\']\">\n{{ vm.overall[\'Level 2\'].mean | number:2 }}</span></td></tr><tr md-row disabled=\"disabled\"><td md-cell><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.SD\"></span> ({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})\n</td><td md-cell><span ng-if=\"vm.overall[\'Level 1\'] && vm.overall[\'Level 1\'].stdev != null\">\n{{ vm.overall[\'Level 1\'].stdev | number:2 }}</span></td><td md-cell><span \nng-if=\"vm.overall[\'Level 2\'] && vm.overall[\'Level 2\'].stdev != null\">{{ vm.overall[\'Level 2\'].stdev | number:2 }}\n</span></td></tr><tr md-row disabled=\"disabled\"><td md-cell><span translate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.CV\">\n</span></td><td md-cell><span ng-if=\"vm.overall[\'Level 1\'] && vm.overall[\'Level 1\'].cv != null\">\n{{ vm.overall[\'Level 1\'].cv | number:2 }}*</span></td><td md-cell><span \nng-if=\"vm.overall[\'Level 2\'] && vm.overall[\'Level 2\'].cv != null\">{{ vm.overall[\'Level 2\'].cv | number:2 }}</span></td>\n</tr><tr md-row disabled=\"disabled\"><td md-cell colspan=\"3\"><div class=\"text-semibold text-italic\" \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.PS\"></div></td></tr></tbody><tfoot><tr><td></td></tr></tfoot></table>\n</md-table-container></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.PANEL_TITLE\"></span><div flex></div></div></md-toolbar><md-table-container><table \nmd-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" md-on-reorder=\"vm.getQCLogbook\"><tr md-row><th \nmd-column md-order-by=\"tested_on\"><span translate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.TEST_DATE_TIME\"></span></th><th \nmd-column><span translate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STRIP_LOT\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.CONTROL_TYPE\"></span></th><th md-column md-numeric><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-numeric><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_VALUE\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STATUS\"></span></th></tr></thead><tbody md-body><tr md-row md-auto-select \nng-repeat=\"log in vm.qclogbook\"><td md-cell>{{ log.tested_on | date:\'yyyy-MM-dd hh:mma\' }}</td><td md-cell>\n{{ log.test_strip.lot_no }}</td><td md-cell>{{ log.control_level }}</td><td md-cell>\n{{ log.from | number:1 }}&nbsp;{{ \'QC_REPORT_SINGLE_LOGBOOK.TO\' | translate }}&nbsp;{{ log.to | number:1 }}</td><td \nmd-cell><span ng-if=\"log.source == \'upload\'\"><span ng-if=\"log.is_high\" class=\"red-fg\">HIGH</span><span \nng-if=\"log.is_low\" class=\"red-fg\">LOW</span><span ng-if=\"!log.is_high && !log.is_low\">\n{{ log.meter_reading | number:1 }}</span></span> <span ng-if=\"log.source == \'manual\'\"><sup>**</sup><span \nng-if=\"log.is_high\" class=\"red-fg\">HIGH</span><span ng-if=\"log.is_low\" class=\"red-fg\">LOW</span><span \nng-if=\"!log.is_high && !log.is_low\">{{ log.meter_reading | number:1 }}</span></span></td><td md-cell><span \nng-if=\"log.within_range\" class=\"text-boxed m-0 green-bg white-fg\" translate=\"QC_REPORT_SINGLE_LOGBOOK.WITHIN_RANGE\">\n</span> <span ng-if=\"!log.within_range\" class=\"text-boxed m-0 red-bg white-fg\" \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.OUTSIDE_RANGE\"></span></td></tr><tr md-row ng-if=\"vm.hasManualQcData\"><td md-cell \ncolspan=\"7\"><div class=\"text-semibold text-italic\">**<span translate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.PS\"></span>\n</div></td></tr></tbody></table></md-table-container><md-table-pagination md-label=\"{{ vm.paginationLabel }}\" \nmd-limit=\"vm.pagination.per_page\" md-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" \nmd-total=\"{{ vm.pagination.total }}\" md-on-paginate=\"vm.getQCLogbook\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/main/qc-report/single/logbook/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container flex><label translate=\"QC_REPORT_SINGLE.START_DATE\"></label><md-datepicker name=\"startDate\" \nng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\"></md-datepicker><div \nng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"margin-horizontal-20\"><label translate=\"QC_REPORT_SINGLE.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE.METER_SERIAL_NO\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" name=\"meter\" \nng-disabled=\"!vm.meters.length\" ng-model=\"vm.meter\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"vm.meterChanged()\" required><md-select-header><input flex ng-model=\"vm.searchTerm\" type=\"text\" \nplaceholder=\"Search...\" ng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\">\n<md-button ng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" \naria-label=\"Cancel\"><md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button>\n</md-select-header><div ng-if=\"vm.searchTerm && !vm.meterColumns.length\" \nclass=\"hint-text font-size-14 p-16 text-italic\" translate=\"MAIN.NO_METERS_FOUND\"></div><div \nclass=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-click=\"vm.close()\" ng-value=\"option\" \nng-if=\"!option.isGroup\">{{ option.serial_no }}</md-option></div></div></div></md-select><div \nng-messages=\"vm.filterForm.meter.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><form \nname=\"vm.subFilterForm\" novalidate class=\"md-inline-form sub-filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE_LOGBOOK.FILTERS.STRIP_LOT\"></label>\n<md-select multiple=\"multiple\" ng-disabled=\"!vm.testStrips.length\" name=\"stripLot\" ng-model=\"vm.stripLot\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getStripLotText()\" ng-required=\"vm.testStrips.length\">\n<md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button \nng-if=\"vm.stripLot.length === vm.testStrips.length\" class=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = []\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.stripLot.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.stripLot = vm.testStrips\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.stripLot.length && vm.stripLot.length !== vm.testStrips.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.stripLot = vm.testStrips\" aria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\">\n<md-icon md-font-icon=\"icon-minus-box\"></md-icon></md-button><md-button class=\"md-accent\" type=\"button\" \nng-click=\"vm.stripLotChanged()\" translate=\"QC_REPORT_SINGLE_LOGBOOK.FILTERS.OK\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.FILTERS.OK\' | translate }}\"></md-button></md-select-header><md-option \nng-value=\"testStrip\" ng-repeat=\"testStrip in vm.testStrips\">{{ testStrip.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.stripLot.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block margin-horizontal-20\" flex><label \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL1\"></label><md-select multiple=\"multiple\" \nng-disabled=\"!vm.controlSolutions1.length\" name=\"controlLot1\" ng-model=\"vm.controlLot1\" \nng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLot1Text()\" \nng-required=\"vm.controlSolutions1.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button\n ng-if=\"vm.controlLot1.length === vm.controlSolutions1.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot1 = []\" aria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon\n md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot1.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot1 = vm.controlSolutions1\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot1.length && vm.controlLot1.length !== vm.controlSolutions1.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot1 = vm.controlSolutions1\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\">\n</md-icon></md-button><md-button class=\"md-accent\" type=\"button\" ng-click=\"vm.controlLot1Changed()\" \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.FILTERS.OK\" aria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.FILTERS.OK\' | translate }}\">\n</md-button></md-select-header><md-option ng-value=\"controlSolution\" \nng-repeat=\"controlSolution in vm.controlSolutions1\">{{ controlSolution.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.controlLot1.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_SINGLE_LOGBOOK.FILTERS.CONTROL_LOT_LEVEL2\">\n</label><md-select multiple=\"multiple\" ng-disabled=\"!vm.controlSolutions2.length\" name=\"controlLot2\" \nng-model=\"vm.controlLot2\" ng-model-options=\"{trackBy: \'$value.id\'}\" md-selected-text=\"vm.getControlLot2Text()\" \nng-required=\"vm.controlSolutions2.length\"><md-select-header layout=\"row\" layout-align=\"space-between center\"><md-button\n ng-if=\"vm.controlLot2.length === vm.controlSolutions2.length\" class=\"md-icon-button md-primary\" \nng-click=\"vm.controlLot2 = []\" aria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.FILTERS.UN_SELECT_ALL\' | translate }}\"><md-icon\n md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-button ng-if=\"!vm.controlLot2.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot2 = vm.controlSolutions2\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.FILTERS.SELECT_ALL\' | translate }}\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon></md-button><md-button \nng-if=\"vm.controlLot2.length && vm.controlLot2.length !== vm.controlSolutions2.length\" \nclass=\"md-icon-button md-primary\" ng-click=\"vm.controlLot2 = vm.controlSolutions2\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.FILTERS.OK\' | translate }}\"><md-icon md-font-icon=\"icon-minus-box\"></md-icon>\n</md-button><md-button class=\"md-accent\" type=\"button\" ng-click=\"vm.controlLot2Changed()\" \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.FILTERS.OK\" aria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.FILTERS.OK\' | translate }}\">\n</md-button></md-select-header><md-option ng-value=\"controlSolution\" \nng-repeat=\"controlSolution in vm.controlSolutions2\">{{ controlSolution.lot_no }}</md-option></md-select><div \nng-messages=\"vm.subFilterForm.controlLot2.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.FILTERS.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div></form><div\n flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_SINGLE.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-10 simple-table-container md-whiteframe-1dp\"><md-table-container><table md-table><thead \nmd-head><tr md-row><th md-column><span translate=\"QC_REPORT_SINGLE_LOGBOOK.METER.METER_MODEL\"></span></th><th \nmd-column><span translate=\"QC_REPORT_SINGLE_LOGBOOK.METER.HOSPITAL\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.METER.LOCATION_CODE\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.METER.PERSON_IN_CHARGE\"></span></th></tr></thead><tbody md-body><tr md-row \ndisabled=\"disabled\"><td md-cell>{{ vm.meter.model_no }}</td><td md-cell>{{ vm.meter.location.hospital.name }}</td><td \nmd-cell>{{ vm.meter.location.code }}</td><td md-cell>{{ vm.meter.location.person_in_charge }}</td></tr></tbody><tfoot>\n<tr><td></td></tr></tfoot></table></md-table-container></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-table-container><table md-table><thead \nmd-head><tr md-row><th md-column><span translate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.TITLE\"></span></th><th md-column \nmd-numeric>Level 1</th><th md-column md-numeric>Level 2</th></tr></thead><tbody md-body><tr md-row disabled=\"disabled\">\n<td md-cell><span translate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.NO_OF_TESTS\"></span></td><td md-cell>\n{{ vm.overall[\'Level 1\'] ? vm.overall[\'Level 1\'].number_of_tests : 0 }}</td><td md-cell>\n{{ vm.overall[\'Level 2\'] ? vm.overall[\'Level 2\'].number_of_tests : 0 }}</td></tr><tr md-row disabled=\"disabled\"><td \nmd-cell><span translate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.MEAN\"></span>\n ({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</td><td md-cell><span ng-if=\"vm.overall[\'Level 1\']\">\n{{ vm.overall[\'Level 1\'].mean | number:2 }}</span></td><td md-cell><span ng-if=\"vm.overall[\'Level 2\']\">\n{{ vm.overall[\'Level 2\'].mean | number:2 }}</span></td></tr><tr md-row disabled=\"disabled\"><td md-cell><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.SD\"></span> ({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})\n</td><td md-cell><span ng-if=\"vm.overall[\'Level 1\'] && vm.overall[\'Level 1\'].stdev != null\">\n{{ vm.overall[\'Level 1\'].stdev | number:2 }}</span></td><td md-cell><span \nng-if=\"vm.overall[\'Level 2\'] && vm.overall[\'Level 2\'].stdev != null\">{{ vm.overall[\'Level 2\'].stdev | number:2 }}\n</span></td></tr><tr md-row disabled=\"disabled\"><td md-cell><span translate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.CV\">\n</span></td><td md-cell><span ng-if=\"vm.overall[\'Level 1\'] && vm.overall[\'Level 1\'].cv != null\">\n{{ vm.overall[\'Level 1\'].cv | number:2 }}*</span></td><td md-cell><span \nng-if=\"vm.overall[\'Level 2\'] && vm.overall[\'Level 2\'].cv != null\">{{ vm.overall[\'Level 2\'].cv | number:2 }}</span></td>\n</tr><tr md-row disabled=\"disabled\"><td md-cell colspan=\"3\"><div class=\"text-semibold text-italic\" \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.OVERALL.PS\"></div></td></tr></tbody><tfoot><tr><td></td></tr></tfoot></table>\n</md-table-container></div><div ng-if=\"vm.loaded\" \nclass=\"animate-slide-right mt-20 simple-table-container md-whiteframe-1dp\"><md-toolbar \nclass=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.PANEL_TITLE\"></span><div flex></div></div></md-toolbar><md-table-container><table \nmd-table md-progress=\"vm.promise\"><thead md-head md-order=\"vm.sort\" md-on-reorder=\"vm.getQCLogbook\"><tr md-row><th \nmd-column md-order-by=\"tested_on\"><span translate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.TEST_DATE_TIME\"></span></th><th \nmd-column><span translate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STRIP_LOT\"></span></th><th md-column><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.CONTROL_TYPE\"></span></th><th md-column md-numeric><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_TARGET_RANGE\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column md-numeric><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.QC_VALUE\"></span>\n&nbsp;({{ vm.measurementUnits[vm.user.preferred_measurement_unit] }})</th><th md-column><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.STATUS\"></span></th><th md-column ng-if=\"!vm.isReadOnly\"><span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.OPERATOR_INITIALS\"></span></th></tr></thead><tbody md-body><tr md-row \nmd-auto-select ng-repeat=\"log in vm.qclogbook\" ng-class=\"{ grayout: log.is_deleted }\"><td md-cell>\n{{ log.tested_on | date:\'yyyy-MM-dd hh:mma\' }}</td><td md-cell>{{ log.test_strip.lot_no }}</td><td md-cell>\n{{ log.control_level }}</td><td md-cell>\n{{ log.from | number:1 }}&nbsp;{{ \'QC_REPORT_SINGLE_LOGBOOK.TO\' | translate }}&nbsp;{{ log.to | number:1 }}</td><td \nmd-cell><span ng-if=\"log.source == \'upload\'\"><span class=\"qc-data\" \nng-click=\"!log.is_deleted && vm.editQcData(log, $event)\"><span ng-if=\"log.is_high\" class=\"red-fg\">HIGH</span><span \nng-if=\"log.is_low\" class=\"red-fg\">LOW</span><span ng-if=\"!log.is_high && !log.is_low\">\n{{ log.meter_reading | number:1 }}</span></span></span> <span ng-if=\"log.source == \'manual\'\"><sup>**</sup><span \nclass=\"qc-data\" ng-click=\"!log.is_deleted && vm.editQcData(log, $event)\"><span ng-if=\"log.is_high\" class=\"red-fg\">HIGH\n</span><span ng-if=\"log.is_low\" class=\"red-fg\">LOW</span><span ng-if=\"!log.is_high && !log.is_low\">\n{{ log.meter_reading | number:1 }}</span></span></span></td><td md-cell><span ng-if=\"log.within_range\" \nclass=\"text-boxed m-0 green-bg white-fg\" translate=\"QC_REPORT_SINGLE_LOGBOOK.WITHIN_RANGE\"></span> <span \nng-if=\"!log.within_range\" class=\"text-boxed m-0 red-bg white-fg\" translate=\"QC_REPORT_SINGLE_LOGBOOK.OUTSIDE_RANGE\">\n</span></td><td md-cell ng-if=\"!vm.isReadOnly\"><md-button class=\"font-size-12 font-weight-300 text-lowercase\" \nng-if=\"log.hospital_operator\" ng-click=\"vm.changeOperator(log, $event)\" ng-disabled=\"log.is_deleted\"><span \nclass=\"text-uppercase\">{{ log.hospital_operator.initials}}</span></md-button><md-button \nclass=\"font-size-12 font-weight-300 text-lowercase md-accent\" ng-if=\"!log.hospital_operator\" \nng-click=\"vm.changeOperator(log, $event)\" ng-disabled=\"log.is_deleted\" \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.TAG_OPERATOR\" \naria-label=\"{{ \'QC_REPORT_SINGLE_LOGBOOK.TAG_OPERATOR\' | translate }}\"></md-button></td></tr><tr md-row \nng-if=\"vm.hasManualQcData\"><td md-cell colspan=\"7\"><div class=\"text-semibold text-italic\">**<span \ntranslate=\"QC_REPORT_SINGLE_LOGBOOK.COLUMNS.PS\"></span></div></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-label=\"{{ vm.paginationLabel }}\" md-limit=\"vm.pagination.per_page\" \nmd-limit-options=\"[5, 10, 15]\" md-page=\"vm.pagination.current_page\" md-total=\"{{ vm.pagination.total }}\" \nmd-on-paginate=\"vm.getQCLogbook\" md-page-select></md-table-pagination></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/qc-report/hospital/cvchart/level1/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_HOSPITAL.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_HOSPITAL.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"{{ vm.getSelectMetersIcon() }}\">\n</md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" \nng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button \nng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-accent\" \ntype=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_HOSPITAL.OK\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div></form><div flex ng-if=\"vm.metersLoaded && vm.meters.length == 0\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp no-margin\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" aria-label=\"{{ \'QC_REPORT_HOSPITAL.ZOOM_TO_FIT\' | translate }}\" \nng-change=\"vm.changeZoom()\"><span translate=\"QC_REPORT_HOSPITAL.ZOOM_TO_FIT\"></span></md-switch></div><canvas \nid=\"chart\" class=\"chart chart-line\" chart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" \nchart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas><div \nclass=\"text-semibold text-italic mt-20\" translate=\"QC_REPORT_HOSPITAL_CVCHART_LEVEL1.PS\"></div></div>");
$templateCache.put("app/main/qc-report/hospital/cvchart/level1/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_HOSPITAL.STATE\"></label><md-select name=\"state\" \nng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required>\n<md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_HOSPITAL.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_HOSPITAL.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"{{ vm.getSelectMetersIcon() }}\">\n</md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" \nng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button \nng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-accent\" \ntype=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_HOSPITAL.OK\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp no-margin\"><div \nlayout=\"row\" layout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_HOSPITAL.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" \nchart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas><div class=\"text-semibold text-italic mt-20\" \ntranslate=\"QC_REPORT_HOSPITAL_CVCHART_LEVEL1.PS\"></div></div>");
$templateCache.put("app/main/qc-report/hospital/cvchart/level1/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_HOSPITAL.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_HOSPITAL.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"{{ vm.getSelectMetersIcon() }}\">\n</md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" \nng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button \nng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-accent\" \ntype=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_HOSPITAL.OK\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp no-margin\"><div \nlayout=\"row\" layout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_HOSPITAL.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" \nchart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas><div class=\"text-semibold text-italic mt-20\" \ntranslate=\"QC_REPORT_HOSPITAL_CVCHART_LEVEL1.PS\"></div></div>");
$templateCache.put("app/main/qc-report/hospital/cvchart/level2/country-admin/country-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_HOSPITAL.STATE\"></label><md-select name=\"state\" \nng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" ng-change=\"vm.selectedStateChanged()\" required>\n<md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">{{ state.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_HOSPITAL.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_HOSPITAL.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"{{ vm.getSelectMetersIcon() }}\">\n</md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" \nng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button \nng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-accent\" \ntype=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_HOSPITAL.OK\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp no-margin\"><div \nlayout=\"row\" layout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_HOSPITAL.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" \nchart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/hospital/cvchart/level2/global-admin/global-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label translate=\"QC_REPORT_MULTIPLE.COUNTRY\"></label>\n<md-select name=\"country\" ng-model=\"vm.selectedCountry\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedCountryChanged()\" required><md-option ng-value=\"country\" ng-repeat=\"country in vm.countries\">\n{{ country.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.country.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_MULTIPLE.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.STATE\"></label><md-select \nng-disabled=\"!vm.states.length\" name=\"state\" ng-model=\"vm.selectedState\" ng-model-options=\"{trackBy: \'$value.code\'}\" \nng-change=\"vm.selectedStateChanged()\" required><md-option ng-value=\"state\" ng-repeat=\"state in vm.states\">\n{{ state.name }}</md-option></md-select><div ng-messages=\"vm.filterForm.state.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.HOSPITAL\"></label><md-select \nng-disabled=\"!vm.hospitals.length\" name=\"hospital\" ng-model=\"vm.selectedHospital\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"vm.selectedHospitalChanged()\" required><md-option \nng-value=\"hospital\" ng-repeat=\"hospital in vm.hospitals\">{{ hospital.name }}</md-option></md-select><div \nng-messages=\"vm.filterForm.hospital.$error\"><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container></div><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_HOSPITAL.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_HOSPITAL.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"{{ vm.getSelectMetersIcon() }}\">\n</md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" \nng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button \nng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-accent\" \ntype=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_HOSPITAL.OK\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div></form><div flex ng-if=\"!vm.loaded\" class=\"text-center\"><p class=\"hint-text font-size-24 font-weight-300\" \ntranslate=\"QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE\"></p><p class=\"hint-text font-size-18 font-weight-300\">\n{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" class=\"animate-slide-left card md-whiteframe-4dp no-margin\"><div \nlayout=\"row\" layout-align=\"end center\"><md-switch class=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.ZOOM_TO_FIT\' | translate }}\" ng-change=\"vm.changeZoom()\"><span \ntranslate=\"QC_REPORT_HOSPITAL.ZOOM_TO_FIT\"></span></md-switch></div><canvas id=\"chart\" class=\"chart chart-line\" \nchart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" chart-options=\"vm.chartjs.options\" \nchart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");
$templateCache.put("app/main/qc-report/hospital/cvchart/level2/hospital-admin/hospital-admin.html","<form name=\"vm.filterForm\" novalidate class=\"md-inline-form filter-form\" layout-align=\"start\"><div layout=\"row\"><div \nlayout=\"row\" flex><md-input-container flex><label translate=\"QC_REPORT_HOSPITAL.START_DATE\"></label><md-datepicker \nname=\"startDate\" ng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container><md-input-container flex \nclass=\"ml-20\"><label translate=\"QC_REPORT_HOSPITAL.END_DATE\"></label><md-datepicker name=\"endDate\" \nng-model=\"vm.endDate\" md-min-date=\"vm.minEndDate\" ng-change=\"vm.endDateChanged()\" required md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"vm.filterForm.endDate.$error\"><div ng-message=\"valid\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.DATE_FORMAT_INVALID\"></div><div ng-message=\"required\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div><div ng-message=\"mindate\" \ntranslate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.END_DATE_MIN\"></div></div></md-input-container></div><md-input-container \nclass=\"md-block ml-20\" flex><label translate=\"QC_REPORT_HOSPITAL.METERS\"></label><md-select \nmd-on-close=\"vm.meterSelectionOnClose()\" md-container-class=\"multi-column-select\" multiple=\"multiple\" \nng-disabled=\"!vm.meters.length\" name=\"selectedMeters\" ng-model=\"vm.selectedMeters\" \nmd-selected-text=\"vm.getSelectedMetersText\" required><md-select-header layout=\"row\"><md-button \nng-disabled=\"vm.searchTerm && !vm.meterColumns.length\" ng-click=\"vm.selectMeters()\" class=\"md-icon-button md-primary\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.SELECT_ALL\' | translate }}\"><md-icon md-font-icon=\"{{ vm.getSelectMetersIcon() }}\">\n</md-icon></md-button><input flex ng-model=\"vm.searchTerm\" type=\"text\" placeholder=\"Search...\" \nng-change=\"vm.searchMeters()\" ng-keydown=\"$event.stopPropagation()\" class=\"search-input\"><md-button \nng-if=\"vm.searchTerm\" ng-click=\"vm.searchTerm = \'\'; vm.searchMeters()\" class=\"md-icon-button\" aria-label=\"Cancel\">\n<md-icon md-font-icon=\"icon-cancel\" class=\"clear-search-icon\"></md-icon></md-button><md-button class=\"md-accent\" \ntype=\"button\" ng-click=\"vm.selectedMetersChanged()\" translate=\"QC_REPORT_HOSPITAL.OK\" \naria-label=\"{{ \'QC_REPORT_HOSPITAL.OK\' | translate }}\"></md-button></md-select-header><div \nng-if=\"vm.searchTerm && !vm.meterColumns.length\" class=\"hint-text font-size-14 p-16 text-italic\" \ntranslate=\"MAIN.NO_METERS_FOUND\"></div><div class=\"multi-column-wrapper\"><div ng-repeat=\"column in vm.meterColumns\" \nng-class=\"{\'multi-column\': vm.meterColumns.length > 1}\"><div ng-repeat=\"option in column\"><md-optgroup \nng-if=\"option.isGroup\" label=\"{{ option.name }}\"></md-optgroup><md-option ng-value=\"option\" ng-if=\"!option.isGroup\">\n{{ option.serial_no }}</md-option></div></div></div></md-select><div ng-messages=\"vm.filterForm.selectedMeters.$error\">\n<div ng-message=\"required\" translate=\"QC_REPORT_HOSPITAL.INPUT_MESSAGES.REQUIRED\"></div></div></md-input-container>\n</div></form><div flex ng-if=\"vm.metersLoaded && vm.meters.length == 0\" class=\"text-center\"><p \nclass=\"hint-text font-size-24 font-weight-300\" translate=\"QC_REPORT_HOSPITAL.MESSAGES.NO_DATA_AVAILABLE\"></p><p \nclass=\"hint-text font-size-18 font-weight-300\">{{ vm.message }}</p></div><div ng-show=\"vm.loaded\" \nclass=\"animate-slide-left card md-whiteframe-4dp no-margin\"><div layout=\"row\" layout-align=\"end center\"><md-switch \nclass=\"m-0 md-primary\" ng-model=\"vm.zoomToFit\" aria-label=\"{{ \'QC_REPORT_HOSPITAL.ZOOM_TO_FIT\' | translate }}\" \nng-change=\"vm.changeZoom()\"><span translate=\"QC_REPORT_HOSPITAL.ZOOM_TO_FIT\"></span></md-switch></div><canvas \nid=\"chart\" class=\"chart chart-line\" chart-labels=\"vm.chartjs.labels\" chart-data=\"vm.chartjs.data\" \nchart-options=\"vm.chartjs.options\" chart-dataset-override=\"vm.chartjs.datasetOverride\"></canvas></div>");}]);